
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    if (window.Sentry) Sentry.init({
    dsn: "https://88d7623b3cce44eba015174692293607@o239071.ingest.sentry.io/5355496"
});



var $907ec11c35d1e2b6$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $907ec11c35d1e2b6$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $907ec11c35d1e2b6$exports));
try {
    regeneratorRuntime = $907ec11c35d1e2b6$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $907ec11c35d1e2b6$var$runtime;
    else Function("r", "regeneratorRuntime = r")($907ec11c35d1e2b6$var$runtime);
}


const $ca0cdf5e422ff079$var$isChinese = Boolean(location.hostname.match("polaxiong"));
const $ca0cdf5e422ff079$var$isDevelopment = true;
const $ca0cdf5e422ff079$var$apiHost = $ca0cdf5e422ff079$var$isDevelopment ? "api-test" : "api";
const $ca0cdf5e422ff079$var$styleHost = $ca0cdf5e422ff079$var$isDevelopment ? "styletest" : "s";
const $ca0cdf5e422ff079$var$tldPlus1 = $ca0cdf5e422ff079$var$isChinese ? "polaxiong.com" : "polarr.co";
const $ca0cdf5e422ff079$var$apiEndpoint = `https://${$ca0cdf5e422ff079$var$apiHost}.${$ca0cdf5e422ff079$var$tldPlus1}/v1`;
const $ca0cdf5e422ff079$var$styleEndpoint = `https://${$ca0cdf5e422ff079$var$styleHost}.${$ca0cdf5e422ff079$var$tldPlus1}`;
const $ca0cdf5e422ff079$var$cdnEndpoint = `https://ppe-assets.${$ca0cdf5e422ff079$var$tldPlus1}`;
var $ca0cdf5e422ff079$export$2e2bcd8739ae039 = {
    apiEndpoint: $ca0cdf5e422ff079$var$apiEndpoint,
    cdnEndpoint: $ca0cdf5e422ff079$var$cdnEndpoint,
    staticRoot: `${"https://style-preview.production.polarr.co/assets/8d07a62f0165b30a430ae70bc36700346066a4f7/"}static`,
    styleEndpoint: $ca0cdf5e422ff079$var$styleEndpoint,
    supportedStyleVersion: 3
};


const $8ae837b596d9b32e$var$en = {
    dismiss: "Dismiss",
    download_app: "Download App",
    download_polarr: "Download Polarr",
    error_loading_photo: "Sorry, that photo could not be loaded.",
    error_loading_style: "Sorry, this Style could not be loaded.",
    error_rendering_style: "Sorry, this Style could not be previewed.",
    error_saving_photo: "Sorry, that photo could not be saved.",
    error_webgl_not_supported: "Sorry, but your browser doesn't support rendering Styles. Please download Polarr to try out this Style.",
    import: "import",
    imports: "imports",
    link: "Link",
    no_link_set: "no link set",
    open_photo: "Open Photo",
    page_description: "Preview Polarr styles",
    page_title: "Polarr Style Preview",
    polarr_support: "Polarr Support",
    save_photo: "Save Photo",
    scan_in_polarr: "Scan in Polarr to get this style",
    style_made_by: "Style made by",
    use_on_photo: "Use on photo",
    use_on_video: "Use on video"
};
const $8ae837b596d9b32e$var$zh = {
    dismiss: "\u53D6\u6D88",
    download_app: "\u4E0B\u8F7D App",
    download_polarr: "\u4E0B\u8F7D Polarr",
    error_loading_photo: "\u62B1\u6B49\uFF0C\u8BE5\u7167\u7247\u65E0\u6CD5\u52A0\u8F7D\u3002",
    error_loading_style: "\u62B1\u6B49\uFF0C\u8BE5\u6EE4\u955C\u65E0\u6CD5\u52A0\u8F7D\u3002",
    error_rendering_style: "\u62B1\u6B49\uFF0C\u8BE5\u6EE4\u955C\u65E0\u6CD5\u9884\u89C8\u3002",
    error_saving_photo: "\u62B1\u6B49\uFF0C\u8BE5\u7167\u7247\u65E0\u6CD5\u4FDD\u5B58\u3002",
    error_webgl_not_supported: "\u62B1\u6B49\uFF0C\u60A8\u7684\u6D4F\u89C8\u5668\u65E0\u6CD5\u6E32\u67D3\u6B64\u6EE4\u955C\u3002\u8BF7\u4E0B\u8F7D Polarr \u4EE5\u5C1D\u8BD5\u8BE5\u6EE4\u955C\u3002",
    import: "\u5BFC\u5165",
    imports: "\u5BFC\u5165",
    link: "\u94FE\u63A5",
    no_link_set: "\u672A\u8BBE\u7F6E\u94FE\u63A5",
    open_photo: "\u6253\u5F00\u7167\u7247",
    page_description: "\u9884\u89C8\u6CFC\u8FA3\u6EE4\u955C",
    page_title: "\u6CFC\u8FA3\u6EE4\u955C\u9884\u89C8",
    polarr_support: "Polarr \u7528\u6237\u652F\u6301",
    save_photo: "\u4FDD\u5B58\u7167\u7247",
    scan_in_polarr: "\u4F7F\u7528 Polarr \u626B\u7801\u5373\u53EF\u83B7\u5F97\u6B64\u6EE4\u955C",
    style_made_by: "\u6EE4\u955C\u7531",
    use_on_photo: "\u5728\u56FE\u7247\u4E0A\u4F7F\u7528",
    use_on_video: "\u5728\u89C6\u9891\u4E0A\u4F7F\u7528"
};
// const isChinese = new RegExp(/zh/, "gi").test(navigator.language);
// Switch language based on hostname instead.
const $8ae837b596d9b32e$export$4c53bdad641744eb = Boolean(location.hostname.match("polaxiong"));
const $8ae837b596d9b32e$var$i18n = $8ae837b596d9b32e$export$4c53bdad641744eb ? $8ae837b596d9b32e$var$zh : $8ae837b596d9b32e$var$en;
document.documentElement.lang = $8ae837b596d9b32e$export$4c53bdad641744eb ? "zh" : "en";
document.querySelector('meta[name="description"]').setAttribute("content", $8ae837b596d9b32e$var$i18n.page_description);
var $8ae837b596d9b32e$export$2e2bcd8739ae039 = $8ae837b596d9b32e$var$i18n;



var $01ade0a89313d083$exports = {};

$parcel$export($01ade0a89313d083$exports, "set", () => $01ade0a89313d083$export$adaa4cf7ef1b65be);
$parcel$export($01ade0a89313d083$exports, "get", () => $01ade0a89313d083$export$3988ae62b71be9a3);
$parcel$export($01ade0a89313d083$exports, "getUrl", () => $01ade0a89313d083$export$94df0e59ebebf4a7);
const $01ade0a89313d083$var$cache = {};
async function $01ade0a89313d083$export$adaa4cf7ef1b65be(key, value) {
    $01ade0a89313d083$var$cache[key] = value;
}
async function $01ade0a89313d083$export$3988ae62b71be9a3(key) {
    return $01ade0a89313d083$var$cache[key];
}
const $01ade0a89313d083$export$94df0e59ebebf4a7 = $01ade0a89313d083$export$3988ae62b71be9a3;


function $cc8fedf75257ac26$export$7d15b64cf5a3a4c4(n) {
    return n < 0 ? 0 : n > 1 ? 1 : n;
}
function $cc8fedf75257ac26$export$3988ae62b71be9a3(url, responseType = "json") {
    return new Promise((resolve, reject)=>{
        const req = new XMLHttpRequest();
        req.onload = function() {
            if (req.status > 299) reject(req.response);
            else resolve(req.response);
        };
        req.onerror = reject;
        req.onabort = reject;
        req.open("GET", url);
        req.responseType = responseType;
        req.send();
    });
}
function $cc8fedf75257ac26$export$84a362bd8de8f093() {
    const params = {};
    const urlSearchParams = location.search ? location.search.split("?")[1].split("&") : [];
    urlSearchParams.forEach(function(param) {
        const pair = decodeURIComponent(param).split("=");
        params[pair[0]] = pair[1];
    });
    return params;
}
function $cc8fedf75257ac26$export$3ac756b6844bf082(string, key) {
    const stringBytes = typeof string === "string" ? $cc8fedf75257ac26$export$3df70a15530b5e81(string) : string;
    const keyBytes = typeof key === "string" ? $cc8fedf75257ac26$export$3df70a15530b5e81(key) : key;
    for(let i = 0; i < stringBytes.length; i++)stringBytes[i] = stringBytes[i] ^ keyBytes[i % keyBytes.length];
    return stringBytes;
}
function $cc8fedf75257ac26$export$3df70a15530b5e81(string) {
    const encoder = new TextEncoder();
    return encoder.encode(string);
}
function $cc8fedf75257ac26$export$5f46301b4a1d43db(bytes) {
    const decoder = new TextDecoder();
    return decoder.decode(bytes);
}
function $cc8fedf75257ac26$export$f5dd818bff069720(number) {
    if (typeof Intl !== "undefined" && typeof Intl.NumberFormat !== "undefined") return new Intl.NumberFormat().format(number);
    else return number;
}
const $cc8fedf75257ac26$export$3d8c2f653ac9d0b9 = (selector)=>document.querySelector(selector);
class $cc8fedf75257ac26$export$85f6557964517f1a {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
function $cc8fedf75257ac26$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.src = src;
        image.onload = ()=>resolve(image);
        image.onerror = reject;
    });
}
const $cc8fedf75257ac26$export$18ae0829741a5008 = (e)=>e.target && e.target.href || e.currentTarget && e.currentTarget.href;
function $cc8fedf75257ac26$export$79337f56fa1c77aa(link, prefix) {
    switch(prefix){
        case "ppe":
            return `https://ppe.polarr.co/?link=${link}&apn=photo.editor.polarr&isi=988173374&ibi=co.polarr.ppe`;
        case "pve":
            return `https://view.24fps.polarr.co/?link=${link}&isi=1341136787&ibi=co.polarr.pve`;
    }
}


function $2bb369240502852a$export$fb278f46a98b8805() {
    const params = (0, $cc8fedf75257ac26$export$84a362bd8de8f093)();
    const { id: id, v6id: v6id, filterId: filterId, legacyFilterId: legacyFilterId } = params;
    if (id || v6id || filterId || legacyFilterId) return id || v6id || filterId || legacyFilterId;
    const urlPath = window.location.pathname.split("/");
    if (urlPath.length && urlPath[1]) return urlPath[1];
    return null;
}
function $2bb369240502852a$export$6671c68d89d2abfe() {
    const styleId = $2bb369240502852a$export$fb278f46a98b8805();
    return `${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).styleEndpoint}/${styleId}`;
}
async function $2bb369240502852a$export$9e2aed230c1376b4(styleId) {
    const url = `${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).apiEndpoint}/ppe/filters/${styleId}/preview`;
    return (0, $cc8fedf75257ac26$export$3988ae62b71be9a3)(url);
}
async function $2bb369240502852a$export$61fbb928fb77e86a(style) {
    if (style.version >= 3) {
        const rawContent = await (0, $cc8fedf75257ac26$export$3988ae62b71be9a3)(style.contentUrl, "arraybuffer");
        return $2bb369240502852a$export$20cb7f118daddf70(new Uint8Array(rawContent));
    } else return await (0, $cc8fedf75257ac26$export$3988ae62b71be9a3)(style.contentUrl, "json");
}
async function $2bb369240502852a$export$f033596bac06e4f8(styleId) {
    const url = `${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).apiEndpoint}/ppe/filters/${styleId}/seoMetadata`;
    return (0, $cc8fedf75257ac26$export$3988ae62b71be9a3)(url);
}
async function $2bb369240502852a$var$downloadOverlay(overlay) {
    const { src: src, remoteSrc: remoteSrc } = overlay;
    if (!src) return;
    const baseUrl = (0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).cdnEndpoint;
    const url = remoteSrc ? remoteSrc : `${baseUrl}${src}`;
    const blob = await (0, $cc8fedf75257ac26$export$3988ae62b71be9a3)(url, "blob");
    const blobUrl = URL.createObjectURL(blob);
    (0, $01ade0a89313d083$export$adaa4cf7ef1b65be)(src, blobUrl);
}
async function $2bb369240502852a$export$958998e5e61e85c0(state) {
    let layers = [];
    const pushLayers = (localState)=>{
        if (localState.layers) layers = layers.concat(localState.layers.filter((layer)=>layer.type === "file"));
    };
    // Global layers
    pushLayers(state);
    // Selection layers
    if (state.local_adjustments) state.local_adjustments.forEach(pushLayers);
    for (const layer of layers)await $2bb369240502852a$var$downloadOverlay(layer);
}
function $2bb369240502852a$export$20cb7f118daddf70(encryptedContent) {
    // extract key
    const key = encryptedContent.subarray(0, 32);
    // extract content
    const content = encryptedContent.subarray(32);
    // decrypt content
    const decryptedContent = (0, $cc8fedf75257ac26$export$3ac756b6844bf082)(content, key);
    // convert to string
    const json = (0, $cc8fedf75257ac26$export$5f46301b4a1d43db)(decryptedContent);
    return JSON.parse(json);
}
function $2bb369240502852a$export$ab8272679afc2108(style) {
    try {
        return decodeURIComponent(style.name);
    } catch  {
        return style.name;
    }
}


const $01249a745811b263$export$ca000e230c0caa3e = {
    afterState: {},
    beforeState: {},
    photoName: "sample.jpg",
    style: {}
};



const $e26c28a5a06afede$var$config = {
    page: {
        variants: {
            control: {
                payload: "v1",
                weight: 0.5
            },
            variation: {
                payload: "v2",
                weight: 0.5
            }
        }
    }
};
const $e26c28a5a06afede$var$activatedExperiments = $e26c28a5a06afede$var$getItem("experiments") || {};
function $e26c28a5a06afede$export$ff55ca4f0cacdf35(experimentKey) {
    const urlParams = (0, $cc8fedf75257ac26$export$84a362bd8de8f093)();
    if (urlParams[experimentKey] != null) return urlParams[experimentKey];
    if (!$e26c28a5a06afede$var$activatedExperiments[experimentKey]) {
        $e26c28a5a06afede$var$activatedExperiments[experimentKey] = $e26c28a5a06afede$export$5b3aa5a89af4ce4e(experimentKey);
        $e26c28a5a06afede$var$setItem("experiments", $e26c28a5a06afede$var$activatedExperiments);
    }
    return $e26c28a5a06afede$var$activatedExperiments[experimentKey].payload;
}
const $e26c28a5a06afede$export$bd92c7794ffcb89b = ()=>$e26c28a5a06afede$var$activatedExperiments;
const $e26c28a5a06afede$export$2f86411d819a755e = (experiment)=>$e26c28a5a06afede$var$config[experiment];
const $e26c28a5a06afede$export$7cdb4fbddb61cc4e = ()=>Object.keys($e26c28a5a06afede$var$config);
const $e26c28a5a06afede$export$4863e5a4701360ac = (experiment)=>Object.keys($e26c28a5a06afede$var$config[experiment].variants);
const $e26c28a5a06afede$export$539a1675c8ea976f = (experimentKey, variantKey)=>{
    const experiment = $e26c28a5a06afede$export$2f86411d819a755e(experimentKey);
    // @ts-ignore
    const variant = experiment.variants[variantKey];
    return variant;
};
/**
 * Get the weight of an individual experiment variant, or fall back to an even distribution
 */ const $e26c28a5a06afede$var$getExperimentVariantWeight = (experimentKey, variantKey)=>{
    const variantConfig = $e26c28a5a06afede$export$539a1675c8ea976f(experimentKey, variantKey);
    return typeof variantConfig.weight === "number" ? variantConfig.weight : 1 / $e26c28a5a06afede$export$4863e5a4701360ac(experimentKey).length;
};
const $e26c28a5a06afede$export$5b3aa5a89af4ce4e = (experimentKey)=>{
    const determinant = Math.random();
    let accWeights = 0;
    for (const variantKey of $e26c28a5a06afede$export$4863e5a4701360ac(experimentKey)){
        accWeights += $e26c28a5a06afede$var$getExperimentVariantWeight(experimentKey, variantKey);
        if (determinant <= accWeights) return {
            key: variantKey,
            payload: $e26c28a5a06afede$export$539a1675c8ea976f(experimentKey, variantKey).payload,
            source: "client"
        };
    }
    throw new Error("Could not make variant assignment");
};
function $e26c28a5a06afede$var$getItem(key) {
    try {
        return JSON.parse(localStorage.getItem(key));
    } catch  {
        return null;
    }
}
function $e26c28a5a06afede$var$setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}




const $fbbd0ebd61aeb144$var$DEVELOPMENT = true;
const $fbbd0ebd61aeb144$var$COLLECTOR_ENDPOINT = $fbbd0ebd61aeb144$var$DEVELOPMENT ? "ec2-18-144-18-51.us-west-1.compute.amazonaws.com" : "collector.polarr.co";
window.snowplow("newTracker", "sp", $fbbd0ebd61aeb144$var$COLLECTOR_ENDPOINT, {
    appId: "style_preview_web",
    eventMethod: "POST",
    forceSecureTracker: !$fbbd0ebd61aeb144$var$DEVELOPMENT
});
function $fbbd0ebd61aeb144$var$trackEvent(schema, data = {}, contexts = []) {
    // default contexts
    contexts = contexts.concat([
        $fbbd0ebd61aeb144$var$createExperimentsContext(),
        $fbbd0ebd61aeb144$var$createStyleContext()
    ]);
    window.snowplow("trackSelfDescribingEvent", {
        data: data,
        schema: schema
    }, contexts);
    if ($fbbd0ebd61aeb144$var$DEVELOPMENT) console.log("Track Event:", schema, data, contexts);
}
function $fbbd0ebd61aeb144$var$createExperimentsContext() {
    const activatedExperiments = (0, $e26c28a5a06afede$export$bd92c7794ffcb89b)();
    const experimentKeys = Object.keys(activatedExperiments);
    const activeExperiments = experimentKeys.map((key)=>{
        const experiment = activatedExperiments[key];
        return {
            experiment_key: key,
            source: experiment.source,
            variant_name: experiment.key,
            variant_payload: experiment.payload
        };
    });
    return {
        data: {
            active_experiments: activeExperiments
        },
        schema: "iglu:com.polarr.style_preview.context/experiments/jsonschema/1-0-0"
    };
}
function $fbbd0ebd61aeb144$var$createStyleContext() {
    return {
        data: {
            id: (0, $2bb369240502852a$export$fb278f46a98b8805)(),
            name: (0, $01249a745811b263$export$ca000e230c0caa3e).style && (0, $01249a745811b263$export$ca000e230c0caa3e).style.name || ""
        },
        schema: "iglu:com.polarr.style_preview.context/style/jsonschema/1-0-0"
    };
}
function $fbbd0ebd61aeb144$export$92ab14d0aa42e41e() {
    const { cid: cid } = (0, $cc8fedf75257ac26$export$84a362bd8de8f093)();
    $fbbd0ebd61aeb144$var$trackEvent("iglu:com.polarr.style_preview.event/view_page/jsonschema/1-0-0", {
        campaign_id: cid || null,
        referrer: document.referrer
    });
}
function $fbbd0ebd61aeb144$export$363414f65951ac79({ target_url: target_url }) {
    $fbbd0ebd61aeb144$var$trackEvent("iglu:com.polarr.style_preview.event/tap_open_ppe/jsonschema/1-0-0", {
        target_url: target_url
    });
}
function $fbbd0ebd61aeb144$export$a9d3477d73f7f5cb({ target_url: target_url }) {
    $fbbd0ebd61aeb144$var$trackEvent("iglu:com.polarr.style_preview.event/tap_open_pve/jsonschema/1-0-0", {
        target_url: target_url
    });
}
function $fbbd0ebd61aeb144$export$5f1073fec066c090({ target_type: target_type, target_url: target_url }) {
    $fbbd0ebd61aeb144$var$trackEvent("iglu:com.polarr.style_preview.event/tap_download_app/jsonschema/1-0-0", {
        target_type: target_type,
        target_url: target_url
    });
}
function $fbbd0ebd61aeb144$export$70578a22e13c2fde() {
    $fbbd0ebd61aeb144$var$trackEvent("iglu:com.polarr.style_preview.event/tap_author_name/jsonschema/1-0-0", {});
}
function $fbbd0ebd61aeb144$export$f69ffa4b7935a2f0({ handle_type: handle_type, handle_url: handle_url }) {
    $fbbd0ebd61aeb144$var$trackEvent("iglu:com.polarr.style_preview.event/tap_author_link/jsonschema/1-0-0", {
        handle_type: handle_type,
        handle_url: handle_url
    });
}
function $fbbd0ebd61aeb144$export$dcf473332b4e71be() {
    $fbbd0ebd61aeb144$var$trackEvent("iglu:com.polarr.style_preview.event/open_photo/jsonschema/1-0-0", {});
}
function $fbbd0ebd61aeb144$export$9a74c95d6f3ea641() {
    $fbbd0ebd61aeb144$var$trackEvent("iglu:com.polarr.style_preview.event/export_photo/jsonschema/1-0-0", {});
}




var $edd7624ed4b79326$exports = {};

$parcel$export($edd7624ed4b79326$exports, "openPhoto", () => $edd7624ed4b79326$export$f120b603e65ef974);
$parcel$export($edd7624ed4b79326$exports, "importPhoto", () => $edd7624ed4b79326$export$fc1584d70e8a9f5c);
$parcel$export($edd7624ed4b79326$exports, "savePhoto", () => $edd7624ed4b79326$export$33e85711129c0564);
$parcel$export($edd7624ed4b79326$exports, "renderOutput", () => $edd7624ed4b79326$export$da8e8db2a2454039);
$parcel$export($edd7624ed4b79326$exports, "encodeJPEG", () => $edd7624ed4b79326$export$e326c965e996cde5);
$parcel$export($edd7624ed4b79326$exports, "loadWatermark", () => $edd7624ed4b79326$export$9416765e0d9c038a);
$parcel$export($edd7624ed4b79326$exports, "renderBeforeAfter", () => $edd7624ed4b79326$export$7ceb98555b214486);
$parcel$export($edd7624ed4b79326$exports, "renderImage", () => $edd7624ed4b79326$export$cebdc09f4d9da75c);
var $577521a7d2a2a15c$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($577521a7d2a2a15c$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $577521a7d2a2a15c$exports = g;
});



var $422cec71ced0541f$exports = {};

/*! For license information please see filtr.js.LICENSE.txt */ !function(t, e) {
    $422cec71ced0541f$exports = e();
}(undefined, function() {
    return function(t) {
        var e = {};
        function r(n) {
            if (e[n]) return e[n].exports;
            var o = e[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }
        return r.m = t, r.c = e, r.d = function(t, e, n) {
            r.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, r.t = function(t, e) {
            if (1 & e && (t = r(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var o in t)r.d(n, o, (function(e) {
                return t[e];
            }).bind(null, o));
            return n;
        }, r.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return r.d(e, "a", e), e;
        }, r.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "/", r(r.s = 206);
    }([
        function(t, e, r) {
            var n = r(2), o = r(8), i = r(15), a = r(12), c = r(18), u = function(t, e, r) {
                var s, l, f, h, d = t & u.F, p = t & u.G, v = t & u.S, m = t & u.P, g = t & u.B, b = p ? n : v ? n[e] || (n[e] = {}) : (n[e] || {}).prototype, x = p ? o : o[e] || (o[e] = {}), y = x.prototype || (x.prototype = {});
                for(s in p && (r = e), r)f = ((l = !d && b && void 0 !== b[s]) ? b : r)[s], h = g && l ? c(f, n) : m && "function" == typeof f ? c(Function.call, f) : f, b && a(b, s, f, t & u.U), x[s] != f && i(x, s, h), m && y[s] != f && (y[s] = f);
            };
            n.core = o, u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, t.exports = u;
        },
        function(t, e, r) {
            t.exports = function() {
                "use strict";
                var t = Array.prototype.slice;
                function e(t, e) {
                    e && (t.prototype = Object.create(e.prototype)), t.prototype.constructor = t;
                }
                function r(t) {
                    return a(t) ? t : G(t);
                }
                function n(t) {
                    return c(t) ? t : V(t);
                }
                function o(t) {
                    return u(t) ? t : q(t);
                }
                function i(t) {
                    return a(t) && !s(t) ? t : Y(t);
                }
                function a(t) {
                    return !(!t || !t[f]);
                }
                function c(t) {
                    return !(!t || !t[h]);
                }
                function u(t) {
                    return !(!t || !t[d]);
                }
                function s(t) {
                    return c(t) || u(t);
                }
                function l(t) {
                    return !(!t || !t[p]);
                }
                e(n, r), e(o, r), e(i, r), r.isIterable = a, r.isKeyed = c, r.isIndexed = u, r.isAssociative = s, r.isOrdered = l, r.Keyed = n, r.Indexed = o, r.Set = i;
                var f = "@@__IMMUTABLE_ITERABLE__@@", h = "@@__IMMUTABLE_KEYED__@@", d = "@@__IMMUTABLE_INDEXED__@@", p = "@@__IMMUTABLE_ORDERED__@@", v = {}, m = {
                    value: !1
                }, g = {
                    value: !1
                };
                function b(t) {
                    return t.value = !1, t;
                }
                function x(t) {
                    t && (t.value = !0);
                }
                function y() {}
                function _(t, e) {
                    e = e || 0;
                    for(var r = Math.max(0, t.length - e), n = new Array(r), o = 0; o < r; o++)n[o] = t[o + e];
                    return n;
                }
                function w(t) {
                    return void 0 === t.size && (t.size = t.__iterate(M)), t.size;
                }
                function S(t, e) {
                    if ("number" != typeof e) {
                        var r = e >>> 0;
                        if ("" + r !== e || 4294967295 === r) return NaN;
                        e = r;
                    }
                    return e < 0 ? w(t) + e : e;
                }
                function M() {
                    return !0;
                }
                function T(t, e, r) {
                    return (0 === t || void 0 !== r && t <= -r) && (void 0 === e || void 0 !== r && e >= r);
                }
                function I(t, e) {
                    return E(t, e, 0);
                }
                function D(t, e) {
                    return E(t, e, e);
                }
                function E(t, e, r) {
                    return void 0 === t ? r : t < 0 ? Math.max(0, e + t) : void 0 === e ? t : Math.min(e, t);
                }
                var A, C, z, O = "function" == typeof Symbol && Symbol.iterator, F = O || "@@iterator";
                function R(t) {
                    this.next = t;
                }
                function P(t, e, r, n) {
                    var o = 0 === t ? e : 1 === t ? r : [
                        e,
                        r
                    ];
                    return n ? n.value = o : n = {
                        value: o,
                        done: !1
                    }, n;
                }
                function L() {
                    return {
                        value: void 0,
                        done: !0
                    };
                }
                function k(t) {
                    return !!B(t);
                }
                function j(t) {
                    return t && "function" == typeof t.next;
                }
                function U(t) {
                    var e = B(t);
                    return e && e.call(t);
                }
                function B(t) {
                    var e = t && (O && t[O] || t["@@iterator"]);
                    if ("function" == typeof e) return e;
                }
                function N(t) {
                    return t && "number" == typeof t.length;
                }
                function G(t) {
                    return null == t ? J() : a(t) ? t.toSeq() : function(t) {
                        var e = tt(t) || "object" == typeof t && new W(t);
                        if (!e) throw new TypeError("Expected Array or iterable object of values, or keyed object: " + t);
                        return e;
                    }(t);
                }
                function V(t) {
                    return null == t ? J().toKeyedSeq() : a(t) ? c(t) ? t.toSeq() : t.fromEntrySeq() : $(t);
                }
                function q(t) {
                    return null == t ? J() : a(t) ? c(t) ? t.entrySeq() : t.toIndexedSeq() : Q(t);
                }
                function Y(t) {
                    return (null == t ? J() : a(t) ? c(t) ? t.entrySeq() : t : Q(t)).toSetSeq();
                }
                function H(t) {
                    this._array = t, this.size = t.length;
                }
                function W(t) {
                    var e = Object.keys(t);
                    this._object = t, this._keys = e, this.size = e.length;
                }
                function X(t) {
                    this._iterable = t, this.size = t.length || t.size;
                }
                function K(t) {
                    this._iterator = t, this._iteratorCache = [];
                }
                function Z(t) {
                    return !(!t || !t["@@__IMMUTABLE_SEQ__@@"]);
                }
                function J() {
                    return A || (A = new H([]));
                }
                function $(t) {
                    var e = Array.isArray(t) ? new H(t).fromEntrySeq() : j(t) ? new K(t).fromEntrySeq() : k(t) ? new X(t).fromEntrySeq() : "object" == typeof t ? new W(t) : void 0;
                    if (!e) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + t);
                    return e;
                }
                function Q(t) {
                    var e = tt(t);
                    if (!e) throw new TypeError("Expected Array or iterable object of values: " + t);
                    return e;
                }
                function tt(t) {
                    return N(t) ? new H(t) : j(t) ? new K(t) : k(t) ? new X(t) : void 0;
                }
                function et(t, e, r, n) {
                    var o = t._cache;
                    if (o) {
                        for(var i = o.length - 1, a = 0; a <= i; a++){
                            var c = o[r ? i - a : a];
                            if (!1 === e(c[1], n ? c[0] : a, t)) return a + 1;
                        }
                        return a;
                    }
                    return t.__iterateUncached(e, r);
                }
                function rt(t, e, r, n) {
                    var o = t._cache;
                    if (o) {
                        var i = o.length - 1, a = 0;
                        return new R(function() {
                            var t = o[r ? i - a : a];
                            return a++ > i ? {
                                value: void 0,
                                done: !0
                            } : P(e, n ? t[0] : a - 1, t[1]);
                        });
                    }
                    return t.__iteratorUncached(e, r);
                }
                function nt(t, e) {
                    return e ? function t(e, r, n, o) {
                        return Array.isArray(r) ? e.call(o, n, q(r).map(function(n, o) {
                            return t(e, n, o, r);
                        })) : it(r) ? e.call(o, n, V(r).map(function(n, o) {
                            return t(e, n, o, r);
                        })) : r;
                    }(e, t, "", {
                        "": t
                    }) : ot(t);
                }
                function ot(t) {
                    return Array.isArray(t) ? q(t).map(ot).toList() : it(t) ? V(t).map(ot).toMap() : t;
                }
                function it(t) {
                    return t && (t.constructor === Object || void 0 === t.constructor);
                }
                function at(t, e) {
                    if (t === e || t != t && e != e) return !0;
                    if (!t || !e) return !1;
                    if ("function" == typeof t.valueOf && "function" == typeof e.valueOf) {
                        if ((t = t.valueOf()) === (e = e.valueOf()) || t != t && e != e) return !0;
                        if (!t || !e) return !1;
                    }
                    return !("function" != typeof t.equals || "function" != typeof e.equals || !t.equals(e));
                }
                function ct(t, e) {
                    if (t === e) return !0;
                    if (!a(e) || void 0 !== t.size && void 0 !== e.size && t.size !== e.size || void 0 !== t.__hash && void 0 !== e.__hash && t.__hash !== e.__hash || c(t) !== c(e) || u(t) !== u(e) || l(t) !== l(e)) return !1;
                    if (0 === t.size && 0 === e.size) return !0;
                    var r = !s(t);
                    if (l(t)) {
                        var n = t.entries();
                        return e.every(function(t, e) {
                            var o = n.next().value;
                            return o && at(o[1], t) && (r || at(o[0], e));
                        }) && n.next().done;
                    }
                    var o = !1;
                    if (void 0 === t.size) {
                        if (void 0 === e.size) "function" == typeof t.cacheResult && t.cacheResult();
                        else {
                            o = !0;
                            var i = t;
                            t = e, e = i;
                        }
                    }
                    var f = !0, h = e.__iterate(function(e, n) {
                        if (r ? !t.has(e) : o ? !at(e, t.get(n, v)) : !at(t.get(n, v), e)) return f = !1, !1;
                    });
                    return f && t.size === h;
                }
                function ut(t, e) {
                    if (!(this instanceof ut)) return new ut(t, e);
                    if (this._value = t, this.size = void 0 === e ? 1 / 0 : Math.max(0, e), 0 === this.size) {
                        if (C) return C;
                        C = this;
                    }
                }
                function st(t, e) {
                    if (!t) throw new Error(e);
                }
                function lt(t, e, r) {
                    if (!(this instanceof lt)) return new lt(t, e, r);
                    if (st(0 !== r, "Cannot step a Range by 0"), t = t || 0, void 0 === e && (e = 1 / 0), r = void 0 === r ? 1 : Math.abs(r), e < t && (r = -r), this._start = t, this._end = e, this._step = r, this.size = Math.max(0, Math.ceil((e - t) / r - 1) + 1), 0 === this.size) {
                        if (z) return z;
                        z = this;
                    }
                }
                function ft() {
                    throw TypeError("Abstract");
                }
                function ht() {}
                function dt() {}
                function pt() {}
                R.prototype.toString = function() {
                    return "[Iterator]";
                }, R.KEYS = 0, R.VALUES = 1, R.ENTRIES = 2, R.prototype.inspect = R.prototype.toSource = function() {
                    return this.toString();
                }, R.prototype[F] = function() {
                    return this;
                }, e(G, r), G.of = function() {
                    return G(arguments);
                }, G.prototype.toSeq = function() {
                    return this;
                }, G.prototype.toString = function() {
                    return this.__toString("Seq {", "}");
                }, G.prototype.cacheResult = function() {
                    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
                }, G.prototype.__iterate = function(t, e) {
                    return et(this, t, e, !0);
                }, G.prototype.__iterator = function(t, e) {
                    return rt(this, t, e, !0);
                }, e(V, G), V.prototype.toKeyedSeq = function() {
                    return this;
                }, e(q, G), q.of = function() {
                    return q(arguments);
                }, q.prototype.toIndexedSeq = function() {
                    return this;
                }, q.prototype.toString = function() {
                    return this.__toString("Seq [", "]");
                }, q.prototype.__iterate = function(t, e) {
                    return et(this, t, e, !1);
                }, q.prototype.__iterator = function(t, e) {
                    return rt(this, t, e, !1);
                }, e(Y, G), Y.of = function() {
                    return Y(arguments);
                }, Y.prototype.toSetSeq = function() {
                    return this;
                }, G.isSeq = Z, G.Keyed = V, G.Set = Y, G.Indexed = q, G.prototype["@@__IMMUTABLE_SEQ__@@"] = !0, e(H, q), H.prototype.get = function(t, e) {
                    return this.has(t) ? this._array[S(this, t)] : e;
                }, H.prototype.__iterate = function(t, e) {
                    for(var r = this._array, n = r.length - 1, o = 0; o <= n; o++)if (!1 === t(r[e ? n - o : o], o, this)) return o + 1;
                    return o;
                }, H.prototype.__iterator = function(t, e) {
                    var r = this._array, n = r.length - 1, o = 0;
                    return new R(function() {
                        return o > n ? {
                            value: void 0,
                            done: !0
                        } : P(t, o, r[e ? n - o++ : o++]);
                    });
                }, e(W, V), W.prototype.get = function(t, e) {
                    return void 0 === e || this.has(t) ? this._object[t] : e;
                }, W.prototype.has = function(t) {
                    return this._object.hasOwnProperty(t);
                }, W.prototype.__iterate = function(t, e) {
                    for(var r = this._object, n = this._keys, o = n.length - 1, i = 0; i <= o; i++){
                        var a = n[e ? o - i : i];
                        if (!1 === t(r[a], a, this)) return i + 1;
                    }
                    return i;
                }, W.prototype.__iterator = function(t, e) {
                    var r = this._object, n = this._keys, o = n.length - 1, i = 0;
                    return new R(function() {
                        var a = n[e ? o - i : i];
                        return i++ > o ? {
                            value: void 0,
                            done: !0
                        } : P(t, a, r[a]);
                    });
                }, W.prototype[p] = !0, e(X, q), X.prototype.__iterateUncached = function(t, e) {
                    if (e) return this.cacheResult().__iterate(t, e);
                    var r = U(this._iterable), n = 0;
                    if (j(r)) for(var o; !(o = r.next()).done && !1 !== t(o.value, n++, this););
                    return n;
                }, X.prototype.__iteratorUncached = function(t, e) {
                    if (e) return this.cacheResult().__iterator(t, e);
                    var r = U(this._iterable);
                    if (!j(r)) return new R(L);
                    var n = 0;
                    return new R(function() {
                        var e = r.next();
                        return e.done ? e : P(t, n++, e.value);
                    });
                }, e(K, q), K.prototype.__iterateUncached = function(t, e) {
                    if (e) return this.cacheResult().__iterate(t, e);
                    for(var r, n = this._iterator, o = this._iteratorCache, i = 0; i < o.length;)if (!1 === t(o[i], i++, this)) return i;
                    for(; !(r = n.next()).done;){
                        var a = r.value;
                        if (o[i] = a, !1 === t(a, i++, this)) break;
                    }
                    return i;
                }, K.prototype.__iteratorUncached = function(t, e) {
                    if (e) return this.cacheResult().__iterator(t, e);
                    var r = this._iterator, n = this._iteratorCache, o = 0;
                    return new R(function() {
                        if (o >= n.length) {
                            var e = r.next();
                            if (e.done) return e;
                            n[o] = e.value;
                        }
                        return P(t, o, n[o++]);
                    });
                }, e(ut, q), ut.prototype.toString = function() {
                    return 0 === this.size ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
                }, ut.prototype.get = function(t, e) {
                    return this.has(t) ? this._value : e;
                }, ut.prototype.includes = function(t) {
                    return at(this._value, t);
                }, ut.prototype.slice = function(t, e) {
                    var r = this.size;
                    return T(t, e, r) ? this : new ut(this._value, D(e, r) - I(t, r));
                }, ut.prototype.reverse = function() {
                    return this;
                }, ut.prototype.indexOf = function(t) {
                    return at(this._value, t) ? 0 : -1;
                }, ut.prototype.lastIndexOf = function(t) {
                    return at(this._value, t) ? this.size : -1;
                }, ut.prototype.__iterate = function(t, e) {
                    for(var r = 0; r < this.size; r++)if (!1 === t(this._value, r, this)) return r + 1;
                    return r;
                }, ut.prototype.__iterator = function(t, e) {
                    var r = this, n = 0;
                    return new R(function() {
                        return n < r.size ? P(t, n++, r._value) : {
                            value: void 0,
                            done: !0
                        };
                    });
                }, ut.prototype.equals = function(t) {
                    return t instanceof ut ? at(this._value, t._value) : ct(t);
                }, e(lt, q), lt.prototype.toString = function() {
                    return 0 === this.size ? "Range []" : "Range [ " + this._start + "..." + this._end + (1 !== this._step ? " by " + this._step : "") + " ]";
                }, lt.prototype.get = function(t, e) {
                    return this.has(t) ? this._start + S(this, t) * this._step : e;
                }, lt.prototype.includes = function(t) {
                    var e = (t - this._start) / this._step;
                    return e >= 0 && e < this.size && e === Math.floor(e);
                }, lt.prototype.slice = function(t, e) {
                    return T(t, e, this.size) ? this : (t = I(t, this.size), (e = D(e, this.size)) <= t ? new lt(0, 0) : new lt(this.get(t, this._end), this.get(e, this._end), this._step));
                }, lt.prototype.indexOf = function(t) {
                    var e = t - this._start;
                    if (e % this._step == 0) {
                        var r = e / this._step;
                        if (r >= 0 && r < this.size) return r;
                    }
                    return -1;
                }, lt.prototype.lastIndexOf = function(t) {
                    return this.indexOf(t);
                }, lt.prototype.__iterate = function(t, e) {
                    for(var r = this.size - 1, n = this._step, o = e ? this._start + r * n : this._start, i = 0; i <= r; i++){
                        if (!1 === t(o, i, this)) return i + 1;
                        o += e ? -n : n;
                    }
                    return i;
                }, lt.prototype.__iterator = function(t, e) {
                    var r = this.size - 1, n = this._step, o = e ? this._start + r * n : this._start, i = 0;
                    return new R(function() {
                        var a = o;
                        return o += e ? -n : n, i > r ? {
                            value: void 0,
                            done: !0
                        } : P(t, i++, a);
                    });
                }, lt.prototype.equals = function(t) {
                    return t instanceof lt ? this._start === t._start && this._end === t._end && this._step === t._step : ct(this, t);
                }, e(ft, r), e(ht, ft), e(dt, ft), e(pt, ft), ft.Keyed = ht, ft.Indexed = dt, ft.Set = pt;
                var vt = "function" == typeof Math.imul && -2 === Math.imul(4294967295, 2) ? Math.imul : function(t, e) {
                    var r = 65535 & (t |= 0), n = 65535 & (e |= 0);
                    return r * n + ((t >>> 16) * n + r * (e >>> 16) << 16 >>> 0) | 0;
                };
                function mt(t) {
                    return t >>> 1 & 1073741824 | 3221225471 & t;
                }
                function gt(t) {
                    if (!1 === t || null == t) return 0;
                    if ("function" == typeof t.valueOf && (!1 === (t = t.valueOf()) || null == t)) return 0;
                    if (!0 === t) return 1;
                    var e = typeof t;
                    if ("number" === e) {
                        if (t != t || t === 1 / 0) return 0;
                        var r = 0 | t;
                        for(r !== t && (r ^= 4294967295 * t); t > 4294967295;)r ^= t /= 4294967295;
                        return mt(r);
                    }
                    if ("string" === e) return t.length > Tt ? function(t) {
                        var e = Et[t];
                        return void 0 === e && (e = bt(t), Dt === It && (Dt = 0, Et = {}), Dt++, Et[t] = e), e;
                    }(t) : bt(t);
                    if ("function" == typeof t.hashCode) return t.hashCode();
                    if ("object" === e) return function(t) {
                        var e;
                        if (wt && void 0 !== (e = xt.get(t))) return e;
                        if (void 0 !== (e = t[Mt])) return e;
                        if (!_t) {
                            if (void 0 !== (e = t.propertyIsEnumerable && t.propertyIsEnumerable[Mt])) return e;
                            if (void 0 !== (e = function(t) {
                                if (t && t.nodeType > 0) switch(t.nodeType){
                                    case 1:
                                        return t.uniqueID;
                                    case 9:
                                        return t.documentElement && t.documentElement.uniqueID;
                                }
                            }(t))) return e;
                        }
                        if (e = ++St, 1073741824 & St && (St = 0), wt) xt.set(t, e);
                        else {
                            if (void 0 !== yt && !1 === yt(t)) throw new Error("Non-extensible objects are not allowed as keys.");
                            if (_t) Object.defineProperty(t, Mt, {
                                enumerable: !1,
                                configurable: !1,
                                writable: !1,
                                value: e
                            });
                            else if (void 0 !== t.propertyIsEnumerable && t.propertyIsEnumerable === t.constructor.prototype.propertyIsEnumerable) t.propertyIsEnumerable = function() {
                                return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
                            }, t.propertyIsEnumerable[Mt] = e;
                            else {
                                if (void 0 === t.nodeType) throw new Error("Unable to set a non-enumerable property on object.");
                                t[Mt] = e;
                            }
                        }
                        return e;
                    }(t);
                    if ("function" == typeof t.toString) return bt(t.toString());
                    throw new Error("Value type " + e + " cannot be hashed.");
                }
                function bt(t) {
                    for(var e = 0, r = 0; r < t.length; r++)e = 31 * e + t.charCodeAt(r) | 0;
                    return mt(e);
                }
                var xt, yt = Object.isExtensible, _t = function() {
                    try {
                        return Object.defineProperty({}, "@", {}), !0;
                    } catch (t) {
                        return !1;
                    }
                }(), wt = "function" == typeof WeakMap;
                wt && (xt = new WeakMap);
                var St = 0, Mt = "__immutablehash__";
                "function" == typeof Symbol && (Mt = Symbol(Mt));
                var Tt = 16, It = 255, Dt = 0, Et = {};
                function At(t) {
                    st(t !== 1 / 0, "Cannot perform this action with an infinite size.");
                }
                function Ct(t) {
                    return null == t ? qt() : zt(t) && !l(t) ? t : qt().withMutations(function(e) {
                        var r = n(t);
                        At(r.size), r.forEach(function(t, r) {
                            return e.set(r, t);
                        });
                    });
                }
                function zt(t) {
                    return !(!t || !t[Ft]);
                }
                e(Ct, ht), Ct.of = function() {
                    var e = t.call(arguments, 0);
                    return qt().withMutations(function(t) {
                        for(var r = 0; r < e.length; r += 2){
                            if (r + 1 >= e.length) throw new Error("Missing value for key: " + e[r]);
                            t.set(e[r], e[r + 1]);
                        }
                    });
                }, Ct.prototype.toString = function() {
                    return this.__toString("Map {", "}");
                }, Ct.prototype.get = function(t, e) {
                    return this._root ? this._root.get(0, void 0, t, e) : e;
                }, Ct.prototype.set = function(t, e) {
                    return Yt(this, t, e);
                }, Ct.prototype.setIn = function(t, e) {
                    return this.updateIn(t, v, function() {
                        return e;
                    });
                }, Ct.prototype.remove = function(t) {
                    return Yt(this, t, v);
                }, Ct.prototype.deleteIn = function(t) {
                    return this.updateIn(t, function() {
                        return v;
                    });
                }, Ct.prototype.update = function(t, e, r) {
                    return 1 === arguments.length ? t(this) : this.updateIn([
                        t
                    ], e, r);
                }, Ct.prototype.updateIn = function(t, e, r) {
                    r || (r = e, e = void 0);
                    var n = function t(e, r, n, o) {
                        var i = e === v, a = r.next();
                        if (a.done) {
                            var c = i ? n : e, u = o(c);
                            return u === c ? e : u;
                        }
                        st(i || e && e.set, "invalid keyPath");
                        var s = a.value, l = i ? v : e.get(s, v), f = t(l, r, n, o);
                        return f === l ? e : f === v ? e.remove(s) : (i ? qt() : e).set(s, f);
                    }(this, Ke(t), e, r);
                    return n === v ? void 0 : n;
                }, Ct.prototype.clear = function() {
                    return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : qt();
                }, Ct.prototype.merge = function() {
                    return Kt(this, void 0, arguments);
                }, Ct.prototype.mergeWith = function(e) {
                    var r = t.call(arguments, 1);
                    return Kt(this, e, r);
                }, Ct.prototype.mergeIn = function(e) {
                    var r = t.call(arguments, 1);
                    return this.updateIn(e, qt(), function(t) {
                        return "function" == typeof t.merge ? t.merge.apply(t, r) : r[r.length - 1];
                    });
                }, Ct.prototype.mergeDeep = function() {
                    return Kt(this, Zt, arguments);
                }, Ct.prototype.mergeDeepWith = function(e) {
                    var r = t.call(arguments, 1);
                    return Kt(this, Jt(e), r);
                }, Ct.prototype.mergeDeepIn = function(e) {
                    var r = t.call(arguments, 1);
                    return this.updateIn(e, qt(), function(t) {
                        return "function" == typeof t.mergeDeep ? t.mergeDeep.apply(t, r) : r[r.length - 1];
                    });
                }, Ct.prototype.sort = function(t) {
                    return _e(je(this, t));
                }, Ct.prototype.sortBy = function(t, e) {
                    return _e(je(this, e, t));
                }, Ct.prototype.withMutations = function(t) {
                    var e = this.asMutable();
                    return t(e), e.wasAltered() ? e.__ensureOwner(this.__ownerID) : this;
                }, Ct.prototype.asMutable = function() {
                    return this.__ownerID ? this : this.__ensureOwner(new y);
                }, Ct.prototype.asImmutable = function() {
                    return this.__ensureOwner();
                }, Ct.prototype.wasAltered = function() {
                    return this.__altered;
                }, Ct.prototype.__iterator = function(t, e) {
                    return new Bt(this, t, e);
                }, Ct.prototype.__iterate = function(t, e) {
                    var r = this, n = 0;
                    return this._root && this._root.iterate(function(e) {
                        return n++, t(e[1], e[0], r);
                    }, e), n;
                }, Ct.prototype.__ensureOwner = function(t) {
                    return t === this.__ownerID ? this : t ? Vt(this.size, this._root, t, this.__hash) : (this.__ownerID = t, this.__altered = !1, this);
                }, Ct.isMap = zt;
                var Ot, Ft = "@@__IMMUTABLE_MAP__@@", Rt = Ct.prototype;
                function Pt(t, e) {
                    this.ownerID = t, this.entries = e;
                }
                function Lt(t, e, r) {
                    this.ownerID = t, this.bitmap = e, this.nodes = r;
                }
                function kt(t, e, r) {
                    this.ownerID = t, this.count = e, this.nodes = r;
                }
                function jt(t, e, r) {
                    this.ownerID = t, this.keyHash = e, this.entries = r;
                }
                function Ut(t, e, r) {
                    this.ownerID = t, this.keyHash = e, this.entry = r;
                }
                function Bt(t, e, r) {
                    this._type = e, this._reverse = r, this._stack = t._root && Gt(t._root);
                }
                function Nt(t, e) {
                    return P(t, e[0], e[1]);
                }
                function Gt(t, e) {
                    return {
                        node: t,
                        index: 0,
                        __prev: e
                    };
                }
                function Vt(t, e, r, n) {
                    var o = Object.create(Rt);
                    return o.size = t, o._root = e, o.__ownerID = r, o.__hash = n, o.__altered = !1, o;
                }
                function qt() {
                    return Ot || (Ot = Vt(0));
                }
                function Yt(t, e, r) {
                    var n, o;
                    if (t._root) {
                        var i = b(m), a = b(g);
                        if (n = Ht(t._root, t.__ownerID, 0, void 0, e, r, i, a), !a.value) return t;
                        o = t.size + (i.value ? r === v ? -1 : 1 : 0);
                    } else {
                        if (r === v) return t;
                        o = 1, n = new Pt(t.__ownerID, [
                            [
                                e,
                                r
                            ]
                        ]);
                    }
                    return t.__ownerID ? (t.size = o, t._root = n, t.__hash = void 0, t.__altered = !0, t) : n ? Vt(o, n) : qt();
                }
                function Ht(t, e, r, n, o, i, a, c) {
                    return t ? t.update(e, r, n, o, i, a, c) : i === v ? t : (x(c), x(a), new Ut(e, n, [
                        o,
                        i
                    ]));
                }
                function Wt(t) {
                    return t.constructor === Ut || t.constructor === jt;
                }
                function Xt(t, e, r, n, o) {
                    if (t.keyHash === n) return new jt(e, n, [
                        t.entry,
                        o
                    ]);
                    var i, a = 31 & (0 === r ? t.keyHash : t.keyHash >>> r), c = 31 & (0 === r ? n : n >>> r);
                    return new Lt(e, 1 << a | 1 << c, a === c ? [
                        Xt(t, e, r + 5, n, o)
                    ] : (i = new Ut(e, n, o), a < c ? [
                        t,
                        i
                    ] : [
                        i,
                        t
                    ]));
                }
                function Kt(t, e, r) {
                    for(var o = [], i = 0; i < r.length; i++){
                        var c = r[i], u = n(c);
                        a(c) || (u = u.map(function(t) {
                            return nt(t);
                        })), o.push(u);
                    }
                    return $t(t, e, o);
                }
                function Zt(t, e, r) {
                    return t && t.mergeDeep && a(e) ? t.mergeDeep(e) : at(t, e) ? t : e;
                }
                function Jt(t) {
                    return function(e, r, n) {
                        if (e && e.mergeDeepWith && a(r)) return e.mergeDeepWith(t, r);
                        var o = t(e, r, n);
                        return at(e, o) ? e : o;
                    };
                }
                function $t(t, e, r) {
                    return 0 === (r = r.filter(function(t) {
                        return 0 !== t.size;
                    })).length ? t : 0 !== t.size || t.__ownerID || 1 !== r.length ? t.withMutations(function(t) {
                        for(var n = e ? function(r, n) {
                            t.update(n, v, function(t) {
                                return t === v ? r : e(t, r, n);
                            });
                        } : function(e, r) {
                            t.set(r, e);
                        }, o = 0; o < r.length; o++)r[o].forEach(n);
                    }) : t.constructor(r[0]);
                }
                function Qt(t) {
                    return t = (t = (858993459 & (t -= t >> 1 & 1431655765)) + (t >> 2 & 858993459)) + (t >> 4) & 252645135, t += t >> 8, 127 & (t += t >> 16);
                }
                function te(t, e, r, n) {
                    var o = n ? t : _(t);
                    return o[e] = r, o;
                }
                Rt[Ft] = !0, Rt.delete = Rt.remove, Rt.removeIn = Rt.deleteIn, Pt.prototype.get = function(t, e, r, n) {
                    for(var o = this.entries, i = 0, a = o.length; i < a; i++)if (at(r, o[i][0])) return o[i][1];
                    return n;
                }, Pt.prototype.update = function(t, e, r, n, o, i, a) {
                    for(var c = o === v, u = this.entries, s = 0, l = u.length; s < l && !at(n, u[s][0]); s++);
                    var f = s < l;
                    if (f ? u[s][1] === o : c) return this;
                    if (x(a), (c || !f) && x(i), !c || 1 !== u.length) {
                        if (!f && !c && u.length >= ee) return function(t, e, r, n) {
                            t || (t = new y);
                            for(var o = new Ut(t, gt(r), [
                                r,
                                n
                            ]), i = 0; i < e.length; i++){
                                var a = e[i];
                                o = o.update(t, 0, void 0, a[0], a[1]);
                            }
                            return o;
                        }(t, u, n, o);
                        var h = t && t === this.ownerID, d = h ? u : _(u);
                        return f ? c ? s === l - 1 ? d.pop() : d[s] = d.pop() : d[s] = [
                            n,
                            o
                        ] : d.push([
                            n,
                            o
                        ]), h ? (this.entries = d, this) : new Pt(t, d);
                    }
                }, Lt.prototype.get = function(t, e, r, n) {
                    void 0 === e && (e = gt(r));
                    var o = 1 << (31 & (0 === t ? e : e >>> t)), i = this.bitmap;
                    return 0 == (i & o) ? n : this.nodes[Qt(i & o - 1)].get(t + 5, e, r, n);
                }, Lt.prototype.update = function(t, e, r, n, o, i, a) {
                    void 0 === r && (r = gt(n));
                    var c = 31 & (0 === e ? r : r >>> e), u = 1 << c, s = this.bitmap, l = 0 != (s & u);
                    if (!l && o === v) return this;
                    var f = Qt(s & u - 1), h = this.nodes, d = l ? h[f] : void 0, p = Ht(d, t, e + 5, r, n, o, i, a);
                    if (p === d) return this;
                    if (!l && p && h.length >= re) return function(t, e, r, n, o) {
                        for(var i = 0, a = new Array(32), c = 0; 0 !== r; c++, r >>>= 1)a[c] = 1 & r ? e[i++] : void 0;
                        return a[n] = o, new kt(t, i + 1, a);
                    }(t, h, s, c, p);
                    if (l && !p && 2 === h.length && Wt(h[1 ^ f])) return h[1 ^ f];
                    if (l && p && 1 === h.length && Wt(p)) return p;
                    var m = t && t === this.ownerID, g = l ? p ? s : s ^ u : s | u, b = l ? p ? te(h, f, p, m) : function(t, e, r) {
                        var n = t.length - 1;
                        if (r && e === n) return t.pop(), t;
                        for(var o = new Array(n), i = 0, a = 0; a < n; a++)a === e && (i = 1), o[a] = t[a + i];
                        return o;
                    }(h, f, m) : function(t, e, r, n) {
                        var o = t.length + 1;
                        if (n && e + 1 === o) return t[e] = r, t;
                        for(var i = new Array(o), a = 0, c = 0; c < o; c++)c === e ? (i[c] = r, a = -1) : i[c] = t[c + a];
                        return i;
                    }(h, f, p, m);
                    return m ? (this.bitmap = g, this.nodes = b, this) : new Lt(t, g, b);
                }, kt.prototype.get = function(t, e, r, n) {
                    void 0 === e && (e = gt(r));
                    var o = 31 & (0 === t ? e : e >>> t), i = this.nodes[o];
                    return i ? i.get(t + 5, e, r, n) : n;
                }, kt.prototype.update = function(t, e, r, n, o, i, a) {
                    void 0 === r && (r = gt(n));
                    var c = 31 & (0 === e ? r : r >>> e), u = o === v, s = this.nodes, l = s[c];
                    if (u && !l) return this;
                    var f = Ht(l, t, e + 5, r, n, o, i, a);
                    if (f === l) return this;
                    var h = this.count;
                    if (l) {
                        if (!f && --h < ne) return function(t, e, r, n) {
                            for(var o = 0, i = 0, a = new Array(r), c = 0, u = 1, s = e.length; c < s; c++, u <<= 1){
                                var l = e[c];
                                void 0 !== l && c !== n && (o |= u, a[i++] = l);
                            }
                            return new Lt(t, o, a);
                        }(t, s, h, c);
                    } else h++;
                    var d = t && t === this.ownerID, p = te(s, c, f, d);
                    return d ? (this.count = h, this.nodes = p, this) : new kt(t, h, p);
                }, jt.prototype.get = function(t, e, r, n) {
                    for(var o = this.entries, i = 0, a = o.length; i < a; i++)if (at(r, o[i][0])) return o[i][1];
                    return n;
                }, jt.prototype.update = function(t, e, r, n, o, i, a) {
                    void 0 === r && (r = gt(n));
                    var c = o === v;
                    if (r !== this.keyHash) return c ? this : (x(a), x(i), Xt(this, t, e, r, [
                        n,
                        o
                    ]));
                    for(var u = this.entries, s = 0, l = u.length; s < l && !at(n, u[s][0]); s++);
                    var f = s < l;
                    if (f ? u[s][1] === o : c) return this;
                    if (x(a), (c || !f) && x(i), c && 2 === l) return new Ut(t, this.keyHash, u[1 ^ s]);
                    var h = t && t === this.ownerID, d = h ? u : _(u);
                    return f ? c ? s === l - 1 ? d.pop() : d[s] = d.pop() : d[s] = [
                        n,
                        o
                    ] : d.push([
                        n,
                        o
                    ]), h ? (this.entries = d, this) : new jt(t, this.keyHash, d);
                }, Ut.prototype.get = function(t, e, r, n) {
                    return at(r, this.entry[0]) ? this.entry[1] : n;
                }, Ut.prototype.update = function(t, e, r, n, o, i, a) {
                    var c = o === v, u = at(n, this.entry[0]);
                    return (u ? o === this.entry[1] : c) ? this : (x(a), c ? void x(i) : u ? t && t === this.ownerID ? (this.entry[1] = o, this) : new Ut(t, this.keyHash, [
                        n,
                        o
                    ]) : (x(i), Xt(this, t, e, gt(n), [
                        n,
                        o
                    ])));
                }, Pt.prototype.iterate = jt.prototype.iterate = function(t, e) {
                    for(var r = this.entries, n = 0, o = r.length - 1; n <= o; n++)if (!1 === t(r[e ? o - n : n])) return !1;
                }, Lt.prototype.iterate = kt.prototype.iterate = function(t, e) {
                    for(var r = this.nodes, n = 0, o = r.length - 1; n <= o; n++){
                        var i = r[e ? o - n : n];
                        if (i && !1 === i.iterate(t, e)) return !1;
                    }
                }, Ut.prototype.iterate = function(t, e) {
                    return t(this.entry);
                }, e(Bt, R), Bt.prototype.next = function() {
                    for(var t = this._type, e = this._stack; e;){
                        var r, n = e.node, o = e.index++;
                        if (n.entry) {
                            if (0 === o) return Nt(t, n.entry);
                        } else if (n.entries) {
                            if (o <= (r = n.entries.length - 1)) return Nt(t, n.entries[this._reverse ? r - o : o]);
                        } else if (o <= (r = n.nodes.length - 1)) {
                            var i = n.nodes[this._reverse ? r - o : o];
                            if (i) {
                                if (i.entry) return Nt(t, i.entry);
                                e = this._stack = Gt(i, e);
                            }
                            continue;
                        }
                        e = this._stack = this._stack.__prev;
                    }
                    return {
                        value: void 0,
                        done: !0
                    };
                };
                var ee = 8, re = 16, ne = 8;
                function oe(t) {
                    var e = pe();
                    if (null == t) return e;
                    if (ie(t)) return t;
                    var r = o(t), n = r.size;
                    return 0 === n ? e : (At(n), n > 0 && n < 32 ? de(0, n, 5, null, new ue(r.toArray())) : e.withMutations(function(t) {
                        t.setSize(n), r.forEach(function(e, r) {
                            return t.set(r, e);
                        });
                    }));
                }
                function ie(t) {
                    return !(!t || !t[ae]);
                }
                e(oe, dt), oe.of = function() {
                    return this(arguments);
                }, oe.prototype.toString = function() {
                    return this.__toString("List [", "]");
                }, oe.prototype.get = function(t, e) {
                    if ((t = S(this, t)) >= 0 && t < this.size) {
                        var r = ge(this, t += this._origin);
                        return r && r.array[31 & t];
                    }
                    return e;
                }, oe.prototype.set = function(t, e) {
                    return function(t, e, r) {
                        if ((e = S(t, e)) != e) return t;
                        if (e >= t.size || e < 0) return t.withMutations(function(t) {
                            e < 0 ? be(t, e).set(0, r) : be(t, 0, e + 1).set(e, r);
                        });
                        e += t._origin;
                        var n = t._tail, o = t._root, i = b(g);
                        return e >= ye(t._capacity) ? n = ve(n, t.__ownerID, 0, e, r, i) : o = ve(o, t.__ownerID, t._level, e, r, i), i.value ? t.__ownerID ? (t._root = o, t._tail = n, t.__hash = void 0, t.__altered = !0, t) : de(t._origin, t._capacity, t._level, o, n) : t;
                    }(this, t, e);
                }, oe.prototype.remove = function(t) {
                    return this.has(t) ? 0 === t ? this.shift() : t === this.size - 1 ? this.pop() : this.splice(t, 1) : this;
                }, oe.prototype.insert = function(t, e) {
                    return this.splice(t, 0, e);
                }, oe.prototype.clear = function() {
                    return 0 === this.size ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = 5, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : pe();
                }, oe.prototype.push = function() {
                    var t = arguments, e = this.size;
                    return this.withMutations(function(r) {
                        be(r, 0, e + t.length);
                        for(var n = 0; n < t.length; n++)r.set(e + n, t[n]);
                    });
                }, oe.prototype.pop = function() {
                    return be(this, 0, -1);
                }, oe.prototype.unshift = function() {
                    var t = arguments;
                    return this.withMutations(function(e) {
                        be(e, -t.length);
                        for(var r = 0; r < t.length; r++)e.set(r, t[r]);
                    });
                }, oe.prototype.shift = function() {
                    return be(this, 1);
                }, oe.prototype.merge = function() {
                    return xe(this, void 0, arguments);
                }, oe.prototype.mergeWith = function(e) {
                    var r = t.call(arguments, 1);
                    return xe(this, e, r);
                }, oe.prototype.mergeDeep = function() {
                    return xe(this, Zt, arguments);
                }, oe.prototype.mergeDeepWith = function(e) {
                    var r = t.call(arguments, 1);
                    return xe(this, Jt(e), r);
                }, oe.prototype.setSize = function(t) {
                    return be(this, 0, t);
                }, oe.prototype.slice = function(t, e) {
                    var r = this.size;
                    return T(t, e, r) ? this : be(this, I(t, r), D(e, r));
                }, oe.prototype.__iterator = function(t, e) {
                    var r = 0, n = he(this, e);
                    return new R(function() {
                        var e = n();
                        return e === fe ? {
                            value: void 0,
                            done: !0
                        } : P(t, r++, e);
                    });
                }, oe.prototype.__iterate = function(t, e) {
                    for(var r, n = 0, o = he(this, e); (r = o()) !== fe && !1 !== t(r, n++, this););
                    return n;
                }, oe.prototype.__ensureOwner = function(t) {
                    return t === this.__ownerID ? this : t ? de(this._origin, this._capacity, this._level, this._root, this._tail, t, this.__hash) : (this.__ownerID = t, this);
                }, oe.isList = ie;
                var ae = "@@__IMMUTABLE_LIST__@@", ce = oe.prototype;
                function ue(t, e) {
                    this.array = t, this.ownerID = e;
                }
                ce[ae] = !0, ce.delete = ce.remove, ce.setIn = Rt.setIn, ce.deleteIn = ce.removeIn = Rt.removeIn, ce.update = Rt.update, ce.updateIn = Rt.updateIn, ce.mergeIn = Rt.mergeIn, ce.mergeDeepIn = Rt.mergeDeepIn, ce.withMutations = Rt.withMutations, ce.asMutable = Rt.asMutable, ce.asImmutable = Rt.asImmutable, ce.wasAltered = Rt.wasAltered, ue.prototype.removeBefore = function(t, e, r) {
                    if (r === e ? 1 << e : 0 === this.array.length) return this;
                    var n = r >>> e & 31;
                    if (n >= this.array.length) return new ue([], t);
                    var o, i = 0 === n;
                    if (e > 0) {
                        var a = this.array[n];
                        if ((o = a && a.removeBefore(t, e - 5, r)) === a && i) return this;
                    }
                    if (i && !o) return this;
                    var c = me(this, t);
                    if (!i) for(var u = 0; u < n; u++)c.array[u] = void 0;
                    return o && (c.array[n] = o), c;
                }, ue.prototype.removeAfter = function(t, e, r) {
                    if (r === (e ? 1 << e : 0) || 0 === this.array.length) return this;
                    var n, o = r - 1 >>> e & 31;
                    if (o >= this.array.length) return this;
                    if (e > 0) {
                        var i = this.array[o];
                        if ((n = i && i.removeAfter(t, e - 5, r)) === i && o === this.array.length - 1) return this;
                    }
                    var a = me(this, t);
                    return a.array.splice(o + 1), n && (a.array[o] = n), a;
                };
                var se, le, fe = {};
                function he(t, e) {
                    var r = t._origin, n = t._capacity, o = ye(n), i = t._tail;
                    return a(t._root, t._level, 0);
                    function a(t, c, u) {
                        return 0 === c ? function(t, a) {
                            var c = a === o ? i && i.array : t && t.array, u = a > r ? 0 : r - a, s = n - a;
                            return s > 32 && (s = 32), function() {
                                if (u === s) return fe;
                                var t = e ? --s : u++;
                                return c && c[t];
                            };
                        }(t, u) : function(t, o, i) {
                            var c, u = t && t.array, s = i > r ? 0 : r - i >> o, l = 1 + (n - i >> o);
                            return l > 32 && (l = 32), function() {
                                for(;;){
                                    if (c) {
                                        var t = c();
                                        if (t !== fe) return t;
                                        c = null;
                                    }
                                    if (s === l) return fe;
                                    var r = e ? --l : s++;
                                    c = a(u && u[r], o - 5, i + (r << o));
                                }
                            };
                        }(t, c, u);
                    }
                }
                function de(t, e, r, n, o, i, a) {
                    var c = Object.create(ce);
                    return c.size = e - t, c._origin = t, c._capacity = e, c._level = r, c._root = n, c._tail = o, c.__ownerID = i, c.__hash = a, c.__altered = !1, c;
                }
                function pe() {
                    return se || (se = de(0, 0, 5));
                }
                function ve(t, e, r, n, o, i) {
                    var a, c = n >>> r & 31, u = t && c < t.array.length;
                    if (!u && void 0 === o) return t;
                    if (r > 0) {
                        var s = t && t.array[c], l = ve(s, e, r - 5, n, o, i);
                        return l === s ? t : ((a = me(t, e)).array[c] = l, a);
                    }
                    return u && t.array[c] === o ? t : (x(i), a = me(t, e), void 0 === o && c === a.array.length - 1 ? a.array.pop() : a.array[c] = o, a);
                }
                function me(t, e) {
                    return e && t && e === t.ownerID ? t : new ue(t ? t.array.slice() : [], e);
                }
                function ge(t, e) {
                    if (e >= ye(t._capacity)) return t._tail;
                    if (e < 1 << t._level + 5) {
                        for(var r = t._root, n = t._level; r && n > 0;)r = r.array[e >>> n & 31], n -= 5;
                        return r;
                    }
                }
                function be(t, e, r) {
                    void 0 !== e && (e |= 0), void 0 !== r && (r |= 0);
                    var n = t.__ownerID || new y, o = t._origin, i = t._capacity, a = o + e, c = void 0 === r ? i : r < 0 ? i + r : o + r;
                    if (a === o && c === i) return t;
                    if (a >= c) return t.clear();
                    for(var u = t._level, s = t._root, l = 0; a + l < 0;)s = new ue(s && s.array.length ? [
                        void 0,
                        s
                    ] : [], n), l += 1 << (u += 5);
                    l && (a += l, o += l, c += l, i += l);
                    for(var f = ye(i), h = ye(c); h >= 1 << u + 5;)s = new ue(s && s.array.length ? [
                        s
                    ] : [], n), u += 5;
                    var d = t._tail, p = h < f ? ge(t, c - 1) : h > f ? new ue([], n) : d;
                    if (d && h > f && a < i && d.array.length) {
                        for(var v = s = me(s, n), m = u; m > 5; m -= 5){
                            var g = f >>> m & 31;
                            v = v.array[g] = me(v.array[g], n);
                        }
                        v.array[f >>> 5 & 31] = d;
                    }
                    if (c < i && (p = p && p.removeAfter(n, 0, c)), a >= h) a -= h, c -= h, u = 5, s = null, p = p && p.removeBefore(n, 0, a);
                    else if (a > o || h < f) {
                        for(l = 0; s;){
                            var b = a >>> u & 31;
                            if (b !== h >>> u & 31) break;
                            b && (l += (1 << u) * b), u -= 5, s = s.array[b];
                        }
                        s && a > o && (s = s.removeBefore(n, u, a - l)), s && h < f && (s = s.removeAfter(n, u, h - l)), l && (a -= l, c -= l);
                    }
                    return t.__ownerID ? (t.size = c - a, t._origin = a, t._capacity = c, t._level = u, t._root = s, t._tail = p, t.__hash = void 0, t.__altered = !0, t) : de(a, c, u, s, p);
                }
                function xe(t, e, r) {
                    for(var n = [], i = 0, c = 0; c < r.length; c++){
                        var u = r[c], s = o(u);
                        s.size > i && (i = s.size), a(u) || (s = s.map(function(t) {
                            return nt(t);
                        })), n.push(s);
                    }
                    return i > t.size && (t = t.setSize(i)), $t(t, e, n);
                }
                function ye(t) {
                    return t < 32 ? 0 : t - 1 >>> 5 << 5;
                }
                function _e(t) {
                    return null == t ? Me() : we(t) ? t : Me().withMutations(function(e) {
                        var r = n(t);
                        At(r.size), r.forEach(function(t, r) {
                            return e.set(r, t);
                        });
                    });
                }
                function we(t) {
                    return zt(t) && l(t);
                }
                function Se(t, e, r, n) {
                    var o = Object.create(_e.prototype);
                    return o.size = t ? t.size : 0, o._map = t, o._list = e, o.__ownerID = r, o.__hash = n, o;
                }
                function Me() {
                    return le || (le = Se(qt(), pe()));
                }
                function Te(t, e, r) {
                    var n, o, i = t._map, a = t._list, c = i.get(e), u = void 0 !== c;
                    if (r === v) {
                        if (!u) return t;
                        a.size >= 32 && a.size >= 2 * i.size ? (n = (o = a.filter(function(t, e) {
                            return void 0 !== t && c !== e;
                        })).toKeyedSeq().map(function(t) {
                            return t[0];
                        }).flip().toMap(), t.__ownerID && (n.__ownerID = o.__ownerID = t.__ownerID)) : (n = i.remove(e), o = c === a.size - 1 ? a.pop() : a.set(c, void 0));
                    } else if (u) {
                        if (r === a.get(c)[1]) return t;
                        n = i, o = a.set(c, [
                            e,
                            r
                        ]);
                    } else n = i.set(e, a.size), o = a.set(a.size, [
                        e,
                        r
                    ]);
                    return t.__ownerID ? (t.size = n.size, t._map = n, t._list = o, t.__hash = void 0, t) : Se(n, o);
                }
                function Ie(t, e) {
                    this._iter = t, this._useKeys = e, this.size = t.size;
                }
                function De(t) {
                    this._iter = t, this.size = t.size;
                }
                function Ee(t) {
                    this._iter = t, this.size = t.size;
                }
                function Ae(t) {
                    this._iter = t, this.size = t.size;
                }
                function Ce(t) {
                    var e = He(t);
                    return e._iter = t, e.size = t.size, e.flip = function() {
                        return t;
                    }, e.reverse = function() {
                        var e = t.reverse.apply(this);
                        return e.flip = function() {
                            return t.reverse();
                        }, e;
                    }, e.has = function(e) {
                        return t.includes(e);
                    }, e.includes = function(e) {
                        return t.has(e);
                    }, e.cacheResult = We, e.__iterateUncached = function(e, r) {
                        var n = this;
                        return t.__iterate(function(t, r) {
                            return !1 !== e(r, t, n);
                        }, r);
                    }, e.__iteratorUncached = function(e, r) {
                        if (2 === e) {
                            var n = t.__iterator(e, r);
                            return new R(function() {
                                var t = n.next();
                                if (!t.done) {
                                    var e = t.value[0];
                                    t.value[0] = t.value[1], t.value[1] = e;
                                }
                                return t;
                            });
                        }
                        return t.__iterator(1 === e ? 0 : 1, r);
                    }, e;
                }
                function ze(t, e, r) {
                    var n = He(t);
                    return n.size = t.size, n.has = function(e) {
                        return t.has(e);
                    }, n.get = function(n, o) {
                        var i = t.get(n, v);
                        return i === v ? o : e.call(r, i, n, t);
                    }, n.__iterateUncached = function(n, o) {
                        var i = this;
                        return t.__iterate(function(t, o, a) {
                            return !1 !== n(e.call(r, t, o, a), o, i);
                        }, o);
                    }, n.__iteratorUncached = function(n, o) {
                        var i = t.__iterator(2, o);
                        return new R(function() {
                            var o = i.next();
                            if (o.done) return o;
                            var a = o.value, c = a[0];
                            return P(n, c, e.call(r, a[1], c, t), o);
                        });
                    }, n;
                }
                function Oe(t, e) {
                    var r = He(t);
                    return r._iter = t, r.size = t.size, r.reverse = function() {
                        return t;
                    }, t.flip && (r.flip = function() {
                        var e = Ce(t);
                        return e.reverse = function() {
                            return t.flip();
                        }, e;
                    }), r.get = function(r, n) {
                        return t.get(e ? r : -1 - r, n);
                    }, r.has = function(r) {
                        return t.has(e ? r : -1 - r);
                    }, r.includes = function(e) {
                        return t.includes(e);
                    }, r.cacheResult = We, r.__iterate = function(e, r) {
                        var n = this;
                        return t.__iterate(function(t, r) {
                            return e(t, r, n);
                        }, !r);
                    }, r.__iterator = function(e, r) {
                        return t.__iterator(e, !r);
                    }, r;
                }
                function Fe(t, e, r, n) {
                    var o = He(t);
                    return n && (o.has = function(n) {
                        var o = t.get(n, v);
                        return o !== v && !!e.call(r, o, n, t);
                    }, o.get = function(n, o) {
                        var i = t.get(n, v);
                        return i !== v && e.call(r, i, n, t) ? i : o;
                    }), o.__iterateUncached = function(o, i) {
                        var a = this, c = 0;
                        return t.__iterate(function(t, i, u) {
                            if (e.call(r, t, i, u)) return c++, o(t, n ? i : c - 1, a);
                        }, i), c;
                    }, o.__iteratorUncached = function(o, i) {
                        var a = t.__iterator(2, i), c = 0;
                        return new R(function() {
                            for(;;){
                                var i = a.next();
                                if (i.done) return i;
                                var u = i.value, s = u[0], l = u[1];
                                if (e.call(r, l, s, t)) return P(o, n ? s : c++, l, i);
                            }
                        });
                    }, o;
                }
                function Re(t, e, r, n) {
                    var o = t.size;
                    if (void 0 !== e && (e |= 0), void 0 !== r && (r === 1 / 0 ? r = o : r |= 0), T(e, r, o)) return t;
                    var i = I(e, o), a = D(r, o);
                    if (i != i || a != a) return Re(t.toSeq().cacheResult(), e, r, n);
                    var c, u = a - i;
                    u == u && (c = u < 0 ? 0 : u);
                    var s = He(t);
                    return s.size = 0 === c ? c : t.size && c || void 0, !n && Z(t) && c >= 0 && (s.get = function(e, r) {
                        return (e = S(this, e)) >= 0 && e < c ? t.get(e + i, r) : r;
                    }), s.__iterateUncached = function(e, r) {
                        var o = this;
                        if (0 === c) return 0;
                        if (r) return this.cacheResult().__iterate(e, r);
                        var a = 0, u = !0, s = 0;
                        return t.__iterate(function(t, r) {
                            if (!u || !(u = a++ < i)) return s++, !1 !== e(t, n ? r : s - 1, o) && s !== c;
                        }), s;
                    }, s.__iteratorUncached = function(e, r) {
                        if (0 !== c && r) return this.cacheResult().__iterator(e, r);
                        var o = 0 !== c && t.__iterator(e, r), a = 0, u = 0;
                        return new R(function() {
                            for(; a++ < i;)o.next();
                            if (++u > c) return {
                                value: void 0,
                                done: !0
                            };
                            var t = o.next();
                            return n || 1 === e ? t : P(e, u - 1, 0 === e ? void 0 : t.value[1], t);
                        });
                    }, s;
                }
                function Pe(t, e, r, n) {
                    var o = He(t);
                    return o.__iterateUncached = function(o, i) {
                        var a = this;
                        if (i) return this.cacheResult().__iterate(o, i);
                        var c = !0, u = 0;
                        return t.__iterate(function(t, i, s) {
                            if (!c || !(c = e.call(r, t, i, s))) return u++, o(t, n ? i : u - 1, a);
                        }), u;
                    }, o.__iteratorUncached = function(o, i) {
                        var a = this;
                        if (i) return this.cacheResult().__iterator(o, i);
                        var c = t.__iterator(2, i), u = !0, s = 0;
                        return new R(function() {
                            var t, i, l;
                            do {
                                if ((t = c.next()).done) return n || 1 === o ? t : P(o, s++, 0 === o ? void 0 : t.value[1], t);
                                var f = t.value;
                                i = f[0], l = f[1], u && (u = e.call(r, l, i, a));
                            }while (u);
                            return 2 === o ? t : P(o, i, l, t);
                        });
                    }, o;
                }
                function Le(t, e) {
                    var r = c(t), o = [
                        t
                    ].concat(e).map(function(t) {
                        return a(t) ? r && (t = n(t)) : t = r ? $(t) : Q(Array.isArray(t) ? t : [
                            t
                        ]), t;
                    }).filter(function(t) {
                        return 0 !== t.size;
                    });
                    if (0 === o.length) return t;
                    if (1 === o.length) {
                        var i = o[0];
                        if (i === t || r && c(i) || u(t) && u(i)) return i;
                    }
                    var s = new H(o);
                    return r ? s = s.toKeyedSeq() : u(t) || (s = s.toSetSeq()), (s = s.flatten(!0)).size = o.reduce(function(t, e) {
                        if (void 0 !== t) {
                            var r = e.size;
                            if (void 0 !== r) return t + r;
                        }
                    }, 0), s;
                }
                function ke(t, e, r) {
                    var n = He(t);
                    return n.__iterateUncached = function(n, o) {
                        var i = 0, c = !1;
                        return function t(u, s) {
                            var l = this;
                            u.__iterate(function(o, u) {
                                return (!e || s < e) && a(o) ? t(o, s + 1) : !1 === n(o, r ? u : i++, l) && (c = !0), !c;
                            }, o);
                        }(t, 0), i;
                    }, n.__iteratorUncached = function(n, o) {
                        var i = t.__iterator(n, o), c = [], u = 0;
                        return new R(function() {
                            for(; i;){
                                var t = i.next();
                                if (!1 === t.done) {
                                    var s = t.value;
                                    if (2 === n && (s = s[1]), e && !(c.length < e) || !a(s)) return r ? t : P(n, u++, s, t);
                                    c.push(i), i = s.__iterator(n, o);
                                } else i = c.pop();
                            }
                            return {
                                value: void 0,
                                done: !0
                            };
                        });
                    }, n;
                }
                function je(t, e, r) {
                    e || (e = Xe);
                    var n = c(t), o = 0, i = t.toSeq().map(function(e, n) {
                        return [
                            n,
                            e,
                            o++,
                            r ? r(e, n, t) : e
                        ];
                    }).toArray();
                    return i.sort(function(t, r) {
                        return e(t[3], r[3]) || t[2] - r[2];
                    }).forEach(n ? function(t, e) {
                        i[e].length = 2;
                    } : function(t, e) {
                        i[e] = t[1];
                    }), n ? V(i) : u(t) ? q(i) : Y(i);
                }
                function Ue(t, e, r) {
                    if (e || (e = Xe), r) {
                        var n = t.toSeq().map(function(e, n) {
                            return [
                                e,
                                r(e, n, t)
                            ];
                        }).reduce(function(t, r) {
                            return Be(e, t[1], r[1]) ? r : t;
                        });
                        return n && n[0];
                    }
                    return t.reduce(function(t, r) {
                        return Be(e, t, r) ? r : t;
                    });
                }
                function Be(t, e, r) {
                    var n = t(r, e);
                    return 0 === n && r !== e && (null == r || r != r) || n > 0;
                }
                function Ne(t, e, n) {
                    var o = He(t);
                    return o.size = new H(n).map(function(t) {
                        return t.size;
                    }).min(), o.__iterate = function(t, e) {
                        for(var r, n = this.__iterator(1, e), o = 0; !(r = n.next()).done && !1 !== t(r.value, o++, this););
                        return o;
                    }, o.__iteratorUncached = function(t, o) {
                        var i = n.map(function(t) {
                            return t = r(t), U(o ? t.reverse() : t);
                        }), a = 0, c = !1;
                        return new R(function() {
                            var r;
                            return c || (r = i.map(function(t) {
                                return t.next();
                            }), c = r.some(function(t) {
                                return t.done;
                            })), c ? {
                                value: void 0,
                                done: !0
                            } : P(t, a++, e.apply(null, r.map(function(t) {
                                return t.value;
                            })));
                        });
                    }, o;
                }
                function Ge(t, e) {
                    return Z(t) ? e : t.constructor(e);
                }
                function Ve(t) {
                    if (t !== Object(t)) throw new TypeError("Expected [K, V] tuple: " + t);
                }
                function qe(t) {
                    return At(t.size), w(t);
                }
                function Ye(t) {
                    return c(t) ? n : u(t) ? o : i;
                }
                function He(t) {
                    return Object.create((c(t) ? V : u(t) ? q : Y).prototype);
                }
                function We() {
                    return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : G.prototype.cacheResult.call(this);
                }
                function Xe(t, e) {
                    return t > e ? 1 : t < e ? -1 : 0;
                }
                function Ke(t) {
                    var e = U(t);
                    if (!e) {
                        if (!N(t)) throw new TypeError("Expected iterable or array-like: " + t);
                        e = U(r(t));
                    }
                    return e;
                }
                function Ze(t, e) {
                    var r, n = function(i) {
                        if (i instanceof n) return i;
                        if (!(this instanceof n)) return new n(i);
                        if (!r) {
                            r = !0;
                            var a = Object.keys(t);
                            !function(t, e) {
                                try {
                                    e.forEach(tr.bind(void 0, t));
                                } catch (t) {}
                            }(o, a), o.size = a.length, o._name = e, o._keys = a, o._defaultValues = t;
                        }
                        this._map = Ct(i);
                    }, o = n.prototype = Object.create(Je);
                    return o.constructor = n, n;
                }
                e(_e, Ct), _e.of = function() {
                    return this(arguments);
                }, _e.prototype.toString = function() {
                    return this.__toString("OrderedMap {", "}");
                }, _e.prototype.get = function(t, e) {
                    var r = this._map.get(t);
                    return void 0 !== r ? this._list.get(r)[1] : e;
                }, _e.prototype.clear = function() {
                    return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : Me();
                }, _e.prototype.set = function(t, e) {
                    return Te(this, t, e);
                }, _e.prototype.remove = function(t) {
                    return Te(this, t, v);
                }, _e.prototype.wasAltered = function() {
                    return this._map.wasAltered() || this._list.wasAltered();
                }, _e.prototype.__iterate = function(t, e) {
                    var r = this;
                    return this._list.__iterate(function(e) {
                        return e && t(e[1], e[0], r);
                    }, e);
                }, _e.prototype.__iterator = function(t, e) {
                    return this._list.fromEntrySeq().__iterator(t, e);
                }, _e.prototype.__ensureOwner = function(t) {
                    if (t === this.__ownerID) return this;
                    var e = this._map.__ensureOwner(t), r = this._list.__ensureOwner(t);
                    return t ? Se(e, r, t, this.__hash) : (this.__ownerID = t, this._map = e, this._list = r, this);
                }, _e.isOrderedMap = we, _e.prototype[p] = !0, _e.prototype.delete = _e.prototype.remove, e(Ie, V), Ie.prototype.get = function(t, e) {
                    return this._iter.get(t, e);
                }, Ie.prototype.has = function(t) {
                    return this._iter.has(t);
                }, Ie.prototype.valueSeq = function() {
                    return this._iter.valueSeq();
                }, Ie.prototype.reverse = function() {
                    var t = this, e = Oe(this, !0);
                    return this._useKeys || (e.valueSeq = function() {
                        return t._iter.toSeq().reverse();
                    }), e;
                }, Ie.prototype.map = function(t, e) {
                    var r = this, n = ze(this, t, e);
                    return this._useKeys || (n.valueSeq = function() {
                        return r._iter.toSeq().map(t, e);
                    }), n;
                }, Ie.prototype.__iterate = function(t, e) {
                    var r, n = this;
                    return this._iter.__iterate(this._useKeys ? function(e, r) {
                        return t(e, r, n);
                    } : (r = e ? qe(this) : 0, function(o) {
                        return t(o, e ? --r : r++, n);
                    }), e);
                }, Ie.prototype.__iterator = function(t, e) {
                    if (this._useKeys) return this._iter.__iterator(t, e);
                    var r = this._iter.__iterator(1, e), n = e ? qe(this) : 0;
                    return new R(function() {
                        var o = r.next();
                        return o.done ? o : P(t, e ? --n : n++, o.value, o);
                    });
                }, Ie.prototype[p] = !0, e(De, q), De.prototype.includes = function(t) {
                    return this._iter.includes(t);
                }, De.prototype.__iterate = function(t, e) {
                    var r = this, n = 0;
                    return this._iter.__iterate(function(e) {
                        return t(e, n++, r);
                    }, e);
                }, De.prototype.__iterator = function(t, e) {
                    var r = this._iter.__iterator(1, e), n = 0;
                    return new R(function() {
                        var e = r.next();
                        return e.done ? e : P(t, n++, e.value, e);
                    });
                }, e(Ee, Y), Ee.prototype.has = function(t) {
                    return this._iter.includes(t);
                }, Ee.prototype.__iterate = function(t, e) {
                    var r = this;
                    return this._iter.__iterate(function(e) {
                        return t(e, e, r);
                    }, e);
                }, Ee.prototype.__iterator = function(t, e) {
                    var r = this._iter.__iterator(1, e);
                    return new R(function() {
                        var e = r.next();
                        return e.done ? e : P(t, e.value, e.value, e);
                    });
                }, e(Ae, V), Ae.prototype.entrySeq = function() {
                    return this._iter.toSeq();
                }, Ae.prototype.__iterate = function(t, e) {
                    var r = this;
                    return this._iter.__iterate(function(e) {
                        if (e) {
                            Ve(e);
                            var n = a(e);
                            return t(n ? e.get(1) : e[1], n ? e.get(0) : e[0], r);
                        }
                    }, e);
                }, Ae.prototype.__iterator = function(t, e) {
                    var r = this._iter.__iterator(1, e);
                    return new R(function() {
                        for(;;){
                            var e = r.next();
                            if (e.done) return e;
                            var n = e.value;
                            if (n) {
                                Ve(n);
                                var o = a(n);
                                return P(t, o ? n.get(0) : n[0], o ? n.get(1) : n[1], e);
                            }
                        }
                    });
                }, De.prototype.cacheResult = Ie.prototype.cacheResult = Ee.prototype.cacheResult = Ae.prototype.cacheResult = We, e(Ze, ht), Ze.prototype.toString = function() {
                    return this.__toString(Qe(this) + " {", "}");
                }, Ze.prototype.has = function(t) {
                    return this._defaultValues.hasOwnProperty(t);
                }, Ze.prototype.get = function(t, e) {
                    if (!this.has(t)) return e;
                    var r = this._defaultValues[t];
                    return this._map ? this._map.get(t, r) : r;
                }, Ze.prototype.clear = function() {
                    if (this.__ownerID) return this._map && this._map.clear(), this;
                    var t = this.constructor;
                    return t._empty || (t._empty = $e(this, qt()));
                }, Ze.prototype.set = function(t, e) {
                    if (!this.has(t)) throw new Error('Cannot set unknown key "' + t + '" on ' + Qe(this));
                    if (this._map && !this._map.has(t) && e === this._defaultValues[t]) return this;
                    var r = this._map && this._map.set(t, e);
                    return this.__ownerID || r === this._map ? this : $e(this, r);
                }, Ze.prototype.remove = function(t) {
                    if (!this.has(t)) return this;
                    var e = this._map && this._map.remove(t);
                    return this.__ownerID || e === this._map ? this : $e(this, e);
                }, Ze.prototype.wasAltered = function() {
                    return this._map.wasAltered();
                }, Ze.prototype.__iterator = function(t, e) {
                    var r = this;
                    return n(this._defaultValues).map(function(t, e) {
                        return r.get(e);
                    }).__iterator(t, e);
                }, Ze.prototype.__iterate = function(t, e) {
                    var r = this;
                    return n(this._defaultValues).map(function(t, e) {
                        return r.get(e);
                    }).__iterate(t, e);
                }, Ze.prototype.__ensureOwner = function(t) {
                    if (t === this.__ownerID) return this;
                    var e = this._map && this._map.__ensureOwner(t);
                    return t ? $e(this, e, t) : (this.__ownerID = t, this._map = e, this);
                };
                var Je = Ze.prototype;
                function $e(t, e, r) {
                    var n = Object.create(Object.getPrototypeOf(t));
                    return n._map = e, n.__ownerID = r, n;
                }
                function Qe(t) {
                    return t._name || t.constructor.name || "Record";
                }
                function tr(t, e) {
                    Object.defineProperty(t, e, {
                        get: function() {
                            return this.get(e);
                        },
                        set: function(t) {
                            st(this.__ownerID, "Cannot set on an immutable record."), this.set(e, t);
                        }
                    });
                }
                function er(t) {
                    return null == t ? ur() : rr(t) && !l(t) ? t : ur().withMutations(function(e) {
                        var r = i(t);
                        At(r.size), r.forEach(function(t) {
                            return e.add(t);
                        });
                    });
                }
                function rr(t) {
                    return !(!t || !t[or]);
                }
                Je.delete = Je.remove, Je.deleteIn = Je.removeIn = Rt.removeIn, Je.merge = Rt.merge, Je.mergeWith = Rt.mergeWith, Je.mergeIn = Rt.mergeIn, Je.mergeDeep = Rt.mergeDeep, Je.mergeDeepWith = Rt.mergeDeepWith, Je.mergeDeepIn = Rt.mergeDeepIn, Je.setIn = Rt.setIn, Je.update = Rt.update, Je.updateIn = Rt.updateIn, Je.withMutations = Rt.withMutations, Je.asMutable = Rt.asMutable, Je.asImmutable = Rt.asImmutable, e(er, pt), er.of = function() {
                    return this(arguments);
                }, er.fromKeys = function(t) {
                    return this(n(t).keySeq());
                }, er.prototype.toString = function() {
                    return this.__toString("Set {", "}");
                }, er.prototype.has = function(t) {
                    return this._map.has(t);
                }, er.prototype.add = function(t) {
                    return ar(this, this._map.set(t, !0));
                }, er.prototype.remove = function(t) {
                    return ar(this, this._map.remove(t));
                }, er.prototype.clear = function() {
                    return ar(this, this._map.clear());
                }, er.prototype.union = function() {
                    var e = t.call(arguments, 0);
                    return 0 === (e = e.filter(function(t) {
                        return 0 !== t.size;
                    })).length ? this : 0 !== this.size || this.__ownerID || 1 !== e.length ? this.withMutations(function(t) {
                        for(var r = 0; r < e.length; r++)i(e[r]).forEach(function(e) {
                            return t.add(e);
                        });
                    }) : this.constructor(e[0]);
                }, er.prototype.intersect = function() {
                    var e = t.call(arguments, 0);
                    if (0 === e.length) return this;
                    e = e.map(function(t) {
                        return i(t);
                    });
                    var r = this;
                    return this.withMutations(function(t) {
                        r.forEach(function(r) {
                            e.every(function(t) {
                                return t.includes(r);
                            }) || t.remove(r);
                        });
                    });
                }, er.prototype.subtract = function() {
                    var e = t.call(arguments, 0);
                    if (0 === e.length) return this;
                    e = e.map(function(t) {
                        return i(t);
                    });
                    var r = this;
                    return this.withMutations(function(t) {
                        r.forEach(function(r) {
                            e.some(function(t) {
                                return t.includes(r);
                            }) && t.remove(r);
                        });
                    });
                }, er.prototype.merge = function() {
                    return this.union.apply(this, arguments);
                }, er.prototype.mergeWith = function(e) {
                    var r = t.call(arguments, 1);
                    return this.union.apply(this, r);
                }, er.prototype.sort = function(t) {
                    return sr(je(this, t));
                }, er.prototype.sortBy = function(t, e) {
                    return sr(je(this, e, t));
                }, er.prototype.wasAltered = function() {
                    return this._map.wasAltered();
                }, er.prototype.__iterate = function(t, e) {
                    var r = this;
                    return this._map.__iterate(function(e, n) {
                        return t(n, n, r);
                    }, e);
                }, er.prototype.__iterator = function(t, e) {
                    return this._map.map(function(t, e) {
                        return e;
                    }).__iterator(t, e);
                }, er.prototype.__ensureOwner = function(t) {
                    if (t === this.__ownerID) return this;
                    var e = this._map.__ensureOwner(t);
                    return t ? this.__make(e, t) : (this.__ownerID = t, this._map = e, this);
                }, er.isSet = rr;
                var nr, or = "@@__IMMUTABLE_SET__@@", ir = er.prototype;
                function ar(t, e) {
                    return t.__ownerID ? (t.size = e.size, t._map = e, t) : e === t._map ? t : 0 === e.size ? t.__empty() : t.__make(e);
                }
                function cr(t, e) {
                    var r = Object.create(ir);
                    return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
                }
                function ur() {
                    return nr || (nr = cr(qt()));
                }
                function sr(t) {
                    return null == t ? pr() : lr(t) ? t : pr().withMutations(function(e) {
                        var r = i(t);
                        At(r.size), r.forEach(function(t) {
                            return e.add(t);
                        });
                    });
                }
                function lr(t) {
                    return rr(t) && l(t);
                }
                ir[or] = !0, ir.delete = ir.remove, ir.mergeDeep = ir.merge, ir.mergeDeepWith = ir.mergeWith, ir.withMutations = Rt.withMutations, ir.asMutable = Rt.asMutable, ir.asImmutable = Rt.asImmutable, ir.__empty = ur, ir.__make = cr, e(sr, er), sr.of = function() {
                    return this(arguments);
                }, sr.fromKeys = function(t) {
                    return this(n(t).keySeq());
                }, sr.prototype.toString = function() {
                    return this.__toString("OrderedSet {", "}");
                }, sr.isOrderedSet = lr;
                var fr, hr = sr.prototype;
                function dr(t, e) {
                    var r = Object.create(hr);
                    return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
                }
                function pr() {
                    return fr || (fr = dr(Me()));
                }
                function vr(t) {
                    return null == t ? _r() : mr(t) ? t : _r().unshiftAll(t);
                }
                function mr(t) {
                    return !(!t || !t[br]);
                }
                hr[p] = !0, hr.__empty = pr, hr.__make = dr, e(vr, dt), vr.of = function() {
                    return this(arguments);
                }, vr.prototype.toString = function() {
                    return this.__toString("Stack [", "]");
                }, vr.prototype.get = function(t, e) {
                    var r = this._head;
                    for(t = S(this, t); r && t--;)r = r.next;
                    return r ? r.value : e;
                }, vr.prototype.peek = function() {
                    return this._head && this._head.value;
                }, vr.prototype.push = function() {
                    if (0 === arguments.length) return this;
                    for(var t = this.size + arguments.length, e = this._head, r = arguments.length - 1; r >= 0; r--)e = {
                        value: arguments[r],
                        next: e
                    };
                    return this.__ownerID ? (this.size = t, this._head = e, this.__hash = void 0, this.__altered = !0, this) : yr(t, e);
                }, vr.prototype.pushAll = function(t) {
                    if (0 === (t = o(t)).size) return this;
                    At(t.size);
                    var e = this.size, r = this._head;
                    return t.reverse().forEach(function(t) {
                        e++, r = {
                            value: t,
                            next: r
                        };
                    }), this.__ownerID ? (this.size = e, this._head = r, this.__hash = void 0, this.__altered = !0, this) : yr(e, r);
                }, vr.prototype.pop = function() {
                    return this.slice(1);
                }, vr.prototype.unshift = function() {
                    return this.push.apply(this, arguments);
                }, vr.prototype.unshiftAll = function(t) {
                    return this.pushAll(t);
                }, vr.prototype.shift = function() {
                    return this.pop.apply(this, arguments);
                }, vr.prototype.clear = function() {
                    return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : _r();
                }, vr.prototype.slice = function(t, e) {
                    if (T(t, e, this.size)) return this;
                    var r = I(t, this.size);
                    if (D(e, this.size) !== this.size) return dt.prototype.slice.call(this, t, e);
                    for(var n = this.size - r, o = this._head; r--;)o = o.next;
                    return this.__ownerID ? (this.size = n, this._head = o, this.__hash = void 0, this.__altered = !0, this) : yr(n, o);
                }, vr.prototype.__ensureOwner = function(t) {
                    return t === this.__ownerID ? this : t ? yr(this.size, this._head, t, this.__hash) : (this.__ownerID = t, this.__altered = !1, this);
                }, vr.prototype.__iterate = function(t, e) {
                    if (e) return this.reverse().__iterate(t);
                    for(var r = 0, n = this._head; n && !1 !== t(n.value, r++, this);)n = n.next;
                    return r;
                }, vr.prototype.__iterator = function(t, e) {
                    if (e) return this.reverse().__iterator(t);
                    var r = 0, n = this._head;
                    return new R(function() {
                        if (n) {
                            var e = n.value;
                            return n = n.next, P(t, r++, e);
                        }
                        return {
                            value: void 0,
                            done: !0
                        };
                    });
                }, vr.isStack = mr;
                var gr, br = "@@__IMMUTABLE_STACK__@@", xr = vr.prototype;
                function yr(t, e, r, n) {
                    var o = Object.create(xr);
                    return o.size = t, o._head = e, o.__ownerID = r, o.__hash = n, o.__altered = !1, o;
                }
                function _r() {
                    return gr || (gr = yr(0));
                }
                function wr(t, e) {
                    var r = function(r) {
                        t.prototype[r] = e[r];
                    };
                    return Object.keys(e).forEach(r), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach(r), t;
                }
                xr[br] = !0, xr.withMutations = Rt.withMutations, xr.asMutable = Rt.asMutable, xr.asImmutable = Rt.asImmutable, xr.wasAltered = Rt.wasAltered, r.Iterator = R, wr(r, {
                    toArray: function() {
                        At(this.size);
                        var t = new Array(this.size || 0);
                        return this.valueSeq().__iterate(function(e, r) {
                            t[r] = e;
                        }), t;
                    },
                    toIndexedSeq: function() {
                        return new De(this);
                    },
                    toJS: function() {
                        return this.toSeq().map(function(t) {
                            return t && "function" == typeof t.toJS ? t.toJS() : t;
                        }).__toJS();
                    },
                    toJSON: function() {
                        return this.toSeq().map(function(t) {
                            return t && "function" == typeof t.toJSON ? t.toJSON() : t;
                        }).__toJS();
                    },
                    toKeyedSeq: function() {
                        return new Ie(this, !0);
                    },
                    toMap: function() {
                        return Ct(this.toKeyedSeq());
                    },
                    toObject: function() {
                        At(this.size);
                        var t = {};
                        return this.__iterate(function(e, r) {
                            t[r] = e;
                        }), t;
                    },
                    toOrderedMap: function() {
                        return _e(this.toKeyedSeq());
                    },
                    toOrderedSet: function() {
                        return sr(c(this) ? this.valueSeq() : this);
                    },
                    toSet: function() {
                        return er(c(this) ? this.valueSeq() : this);
                    },
                    toSetSeq: function() {
                        return new Ee(this);
                    },
                    toSeq: function() {
                        return u(this) ? this.toIndexedSeq() : c(this) ? this.toKeyedSeq() : this.toSetSeq();
                    },
                    toStack: function() {
                        return vr(c(this) ? this.valueSeq() : this);
                    },
                    toList: function() {
                        return oe(c(this) ? this.valueSeq() : this);
                    },
                    toString: function() {
                        return "[Iterable]";
                    },
                    __toString: function(t, e) {
                        return 0 === this.size ? t + e : t + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + e;
                    },
                    concat: function() {
                        var e = t.call(arguments, 0);
                        return Ge(this, Le(this, e));
                    },
                    includes: function(t) {
                        return this.some(function(e) {
                            return at(e, t);
                        });
                    },
                    entries: function() {
                        return this.__iterator(2);
                    },
                    every: function(t, e) {
                        At(this.size);
                        var r = !0;
                        return this.__iterate(function(n, o, i) {
                            if (!t.call(e, n, o, i)) return r = !1, !1;
                        }), r;
                    },
                    filter: function(t, e) {
                        return Ge(this, Fe(this, t, e, !0));
                    },
                    find: function(t, e, r) {
                        var n = this.findEntry(t, e);
                        return n ? n[1] : r;
                    },
                    forEach: function(t, e) {
                        return At(this.size), this.__iterate(e ? t.bind(e) : t);
                    },
                    join: function(t) {
                        At(this.size), t = void 0 !== t ? "" + t : ",";
                        var e = "", r = !0;
                        return this.__iterate(function(n) {
                            r ? r = !1 : e += t, e += null != n ? n.toString() : "";
                        }), e;
                    },
                    keys: function() {
                        return this.__iterator(0);
                    },
                    map: function(t, e) {
                        return Ge(this, ze(this, t, e));
                    },
                    reduce: function(t, e, r) {
                        var n, o;
                        return At(this.size), arguments.length < 2 ? o = !0 : n = e, this.__iterate(function(e, i, a) {
                            o ? (o = !1, n = e) : n = t.call(r, n, e, i, a);
                        }), n;
                    },
                    reduceRight: function(t, e, r) {
                        var n = this.toKeyedSeq().reverse();
                        return n.reduce.apply(n, arguments);
                    },
                    reverse: function() {
                        return Ge(this, Oe(this, !0));
                    },
                    slice: function(t, e) {
                        return Ge(this, Re(this, t, e, !0));
                    },
                    some: function(t, e) {
                        return !this.every(Dr(t), e);
                    },
                    sort: function(t) {
                        return Ge(this, je(this, t));
                    },
                    values: function() {
                        return this.__iterator(1);
                    },
                    butLast: function() {
                        return this.slice(0, -1);
                    },
                    isEmpty: function() {
                        return void 0 !== this.size ? 0 === this.size : !this.some(function() {
                            return !0;
                        });
                    },
                    count: function(t, e) {
                        return w(t ? this.toSeq().filter(t, e) : this);
                    },
                    countBy: function(t, e) {
                        return function(t, e, r) {
                            var n = Ct().asMutable();
                            return t.__iterate(function(o, i) {
                                n.update(e.call(r, o, i, t), 0, function(t) {
                                    return t + 1;
                                });
                            }), n.asImmutable();
                        }(this, t, e);
                    },
                    equals: function(t) {
                        return ct(this, t);
                    },
                    entrySeq: function() {
                        var t = this;
                        if (t._cache) return new H(t._cache);
                        var e = t.toSeq().map(Ir).toIndexedSeq();
                        return e.fromEntrySeq = function() {
                            return t.toSeq();
                        }, e;
                    },
                    filterNot: function(t, e) {
                        return this.filter(Dr(t), e);
                    },
                    findEntry: function(t, e, r) {
                        var n = r;
                        return this.__iterate(function(r, o, i) {
                            if (t.call(e, r, o, i)) return n = [
                                o,
                                r
                            ], !1;
                        }), n;
                    },
                    findKey: function(t, e) {
                        var r = this.findEntry(t, e);
                        return r && r[0];
                    },
                    findLast: function(t, e, r) {
                        return this.toKeyedSeq().reverse().find(t, e, r);
                    },
                    findLastEntry: function(t, e, r) {
                        return this.toKeyedSeq().reverse().findEntry(t, e, r);
                    },
                    findLastKey: function(t, e) {
                        return this.toKeyedSeq().reverse().findKey(t, e);
                    },
                    first: function() {
                        return this.find(M);
                    },
                    flatMap: function(t, e) {
                        return Ge(this, function(t, e, r) {
                            var n = Ye(t);
                            return t.toSeq().map(function(o, i) {
                                return n(e.call(r, o, i, t));
                            }).flatten(!0);
                        }(this, t, e));
                    },
                    flatten: function(t) {
                        return Ge(this, ke(this, t, !0));
                    },
                    fromEntrySeq: function() {
                        return new Ae(this);
                    },
                    get: function(t, e) {
                        return this.find(function(e, r) {
                            return at(r, t);
                        }, void 0, e);
                    },
                    getIn: function(t, e) {
                        for(var r, n = this, o = Ke(t); !(r = o.next()).done;){
                            var i = r.value;
                            if ((n = n && n.get ? n.get(i, v) : v) === v) return e;
                        }
                        return n;
                    },
                    groupBy: function(t, e) {
                        return function(t, e, r) {
                            var n = c(t), o = (l(t) ? _e() : Ct()).asMutable();
                            t.__iterate(function(i, a) {
                                o.update(e.call(r, i, a, t), function(t) {
                                    return (t = t || []).push(n ? [
                                        a,
                                        i
                                    ] : i), t;
                                });
                            });
                            var i = Ye(t);
                            return o.map(function(e) {
                                return Ge(t, i(e));
                            });
                        }(this, t, e);
                    },
                    has: function(t) {
                        return this.get(t, v) !== v;
                    },
                    hasIn: function(t) {
                        return this.getIn(t, v) !== v;
                    },
                    isSubset: function(t) {
                        return t = "function" == typeof t.includes ? t : r(t), this.every(function(e) {
                            return t.includes(e);
                        });
                    },
                    isSuperset: function(t) {
                        return (t = "function" == typeof t.isSubset ? t : r(t)).isSubset(this);
                    },
                    keyOf: function(t) {
                        return this.findKey(function(e) {
                            return at(e, t);
                        });
                    },
                    keySeq: function() {
                        return this.toSeq().map(Tr).toIndexedSeq();
                    },
                    last: function() {
                        return this.toSeq().reverse().first();
                    },
                    lastKeyOf: function(t) {
                        return this.toKeyedSeq().reverse().keyOf(t);
                    },
                    max: function(t) {
                        return Ue(this, t);
                    },
                    maxBy: function(t, e) {
                        return Ue(this, e, t);
                    },
                    min: function(t) {
                        return Ue(this, t ? Er(t) : zr);
                    },
                    minBy: function(t, e) {
                        return Ue(this, e ? Er(e) : zr, t);
                    },
                    rest: function() {
                        return this.slice(1);
                    },
                    skip: function(t) {
                        return this.slice(Math.max(0, t));
                    },
                    skipLast: function(t) {
                        return Ge(this, this.toSeq().reverse().skip(t).reverse());
                    },
                    skipWhile: function(t, e) {
                        return Ge(this, Pe(this, t, e, !0));
                    },
                    skipUntil: function(t, e) {
                        return this.skipWhile(Dr(t), e);
                    },
                    sortBy: function(t, e) {
                        return Ge(this, je(this, e, t));
                    },
                    take: function(t) {
                        return this.slice(0, Math.max(0, t));
                    },
                    takeLast: function(t) {
                        return Ge(this, this.toSeq().reverse().take(t).reverse());
                    },
                    takeWhile: function(t, e) {
                        return Ge(this, function(t, e, r) {
                            var n = He(t);
                            return n.__iterateUncached = function(n, o) {
                                var i = this;
                                if (o) return this.cacheResult().__iterate(n, o);
                                var a = 0;
                                return t.__iterate(function(t, o, c) {
                                    return e.call(r, t, o, c) && ++a && n(t, o, i);
                                }), a;
                            }, n.__iteratorUncached = function(n, o) {
                                var i = this;
                                if (o) return this.cacheResult().__iterator(n, o);
                                var a = t.__iterator(2, o), c = !0;
                                return new R(function() {
                                    if (!c) return {
                                        value: void 0,
                                        done: !0
                                    };
                                    var t = a.next();
                                    if (t.done) return t;
                                    var o = t.value, u = o[0], s = o[1];
                                    return e.call(r, s, u, i) ? 2 === n ? t : P(n, u, s, t) : (c = !1, {
                                        value: void 0,
                                        done: !0
                                    });
                                });
                            }, n;
                        }(this, t, e));
                    },
                    takeUntil: function(t, e) {
                        return this.takeWhile(Dr(t), e);
                    },
                    valueSeq: function() {
                        return this.toIndexedSeq();
                    },
                    hashCode: function() {
                        return this.__hash || (this.__hash = function(t) {
                            if (t.size === 1 / 0) return 0;
                            var e = l(t), r = c(t), n = e ? 1 : 0;
                            return function(t, e) {
                                return e = vt(e, 3432918353), e = vt(e << 15 | e >>> -15, 461845907), e = vt(e << 13 | e >>> -13, 5), e = vt((e = (e + 3864292196 | 0) ^ t) ^ e >>> 16, 2246822507), e = mt((e = vt(e ^ e >>> 13, 3266489909)) ^ e >>> 16);
                            }(t.__iterate(r ? e ? function(t, e) {
                                n = 31 * n + Or(gt(t), gt(e)) | 0;
                            } : function(t, e) {
                                n = n + Or(gt(t), gt(e)) | 0;
                            } : e ? function(t) {
                                n = 31 * n + gt(t) | 0;
                            } : function(t) {
                                n = n + gt(t) | 0;
                            }), n);
                        }(this));
                    }
                });
                var Sr = r.prototype;
                Sr[f] = !0, Sr[F] = Sr.values, Sr.__toJS = Sr.toArray, Sr.__toStringMapper = Ar, Sr.inspect = Sr.toSource = function() {
                    return this.toString();
                }, Sr.chain = Sr.flatMap, Sr.contains = Sr.includes, wr(n, {
                    flip: function() {
                        return Ge(this, Ce(this));
                    },
                    mapEntries: function(t, e) {
                        var r = this, n = 0;
                        return Ge(this, this.toSeq().map(function(o, i) {
                            return t.call(e, [
                                i,
                                o
                            ], n++, r);
                        }).fromEntrySeq());
                    },
                    mapKeys: function(t, e) {
                        var r = this;
                        return Ge(this, this.toSeq().flip().map(function(n, o) {
                            return t.call(e, n, o, r);
                        }).flip());
                    }
                });
                var Mr = n.prototype;
                function Tr(t, e) {
                    return e;
                }
                function Ir(t, e) {
                    return [
                        e,
                        t
                    ];
                }
                function Dr(t) {
                    return function() {
                        return !t.apply(this, arguments);
                    };
                }
                function Er(t) {
                    return function() {
                        return -t.apply(this, arguments);
                    };
                }
                function Ar(t) {
                    return "string" == typeof t ? JSON.stringify(t) : String(t);
                }
                function Cr() {
                    return _(arguments);
                }
                function zr(t, e) {
                    return t < e ? 1 : t > e ? -1 : 0;
                }
                function Or(t, e) {
                    return t ^ e + 2654435769 + (t << 6) + (t >> 2) | 0;
                }
                return Mr[h] = !0, Mr[F] = Sr.entries, Mr.__toJS = Sr.toObject, Mr.__toStringMapper = function(t, e) {
                    return JSON.stringify(e) + ": " + Ar(t);
                }, wr(o, {
                    toKeyedSeq: function() {
                        return new Ie(this, !1);
                    },
                    filter: function(t, e) {
                        return Ge(this, Fe(this, t, e, !1));
                    },
                    findIndex: function(t, e) {
                        var r = this.findEntry(t, e);
                        return r ? r[0] : -1;
                    },
                    indexOf: function(t) {
                        var e = this.keyOf(t);
                        return void 0 === e ? -1 : e;
                    },
                    lastIndexOf: function(t) {
                        var e = this.lastKeyOf(t);
                        return void 0 === e ? -1 : e;
                    },
                    reverse: function() {
                        return Ge(this, Oe(this, !1));
                    },
                    slice: function(t, e) {
                        return Ge(this, Re(this, t, e, !1));
                    },
                    splice: function(t, e) {
                        var r = arguments.length;
                        if (e = Math.max(0 | e, 0), 0 === r || 2 === r && !e) return this;
                        t = I(t, t < 0 ? this.count() : this.size);
                        var n = this.slice(0, t);
                        return Ge(this, 1 === r ? n : n.concat(_(arguments, 2), this.slice(t + e)));
                    },
                    findLastIndex: function(t, e) {
                        var r = this.findLastEntry(t, e);
                        return r ? r[0] : -1;
                    },
                    first: function() {
                        return this.get(0);
                    },
                    flatten: function(t) {
                        return Ge(this, ke(this, t, !1));
                    },
                    get: function(t, e) {
                        return (t = S(this, t)) < 0 || this.size === 1 / 0 || void 0 !== this.size && t > this.size ? e : this.find(function(e, r) {
                            return r === t;
                        }, void 0, e);
                    },
                    has: function(t) {
                        return (t = S(this, t)) >= 0 && (void 0 !== this.size ? this.size === 1 / 0 || t < this.size : -1 !== this.indexOf(t));
                    },
                    interpose: function(t) {
                        return Ge(this, function(t, e) {
                            var r = He(t);
                            return r.size = t.size && 2 * t.size - 1, r.__iterateUncached = function(r, n) {
                                var o = this, i = 0;
                                return t.__iterate(function(t, n) {
                                    return (!i || !1 !== r(e, i++, o)) && !1 !== r(t, i++, o);
                                }, n), i;
                            }, r.__iteratorUncached = function(r, n) {
                                var o, i = t.__iterator(1, n), a = 0;
                                return new R(function() {
                                    return (!o || a % 2) && (o = i.next()).done ? o : a % 2 ? P(r, a++, e) : P(r, a++, o.value, o);
                                });
                            }, r;
                        }(this, t));
                    },
                    interleave: function() {
                        var t = [
                            this
                        ].concat(_(arguments)), e = Ne(this.toSeq(), q.of, t), r = e.flatten(!0);
                        return e.size && (r.size = e.size * t.length), Ge(this, r);
                    },
                    keySeq: function() {
                        return lt(0, this.size);
                    },
                    last: function() {
                        return this.get(-1);
                    },
                    skipWhile: function(t, e) {
                        return Ge(this, Pe(this, t, e, !1));
                    },
                    zip: function() {
                        var t = [
                            this
                        ].concat(_(arguments));
                        return Ge(this, Ne(this, Cr, t));
                    },
                    zipWith: function(t) {
                        var e = _(arguments);
                        return e[0] = this, Ge(this, Ne(this, t, e));
                    }
                }), o.prototype[d] = !0, o.prototype[p] = !0, wr(i, {
                    get: function(t, e) {
                        return this.has(t) ? t : e;
                    },
                    includes: function(t) {
                        return this.has(t);
                    },
                    keySeq: function() {
                        return this.valueSeq();
                    }
                }), i.prototype.has = Sr.includes, i.prototype.contains = i.prototype.includes, wr(V, n.prototype), wr(q, o.prototype), wr(Y, i.prototype), wr(ht, n.prototype), wr(dt, o.prototype), wr(pt, i.prototype), {
                    Iterable: r,
                    Seq: G,
                    Collection: ft,
                    Map: Ct,
                    OrderedMap: _e,
                    List: oe,
                    Stack: vr,
                    Set: er,
                    OrderedSet: sr,
                    Record: Ze,
                    Range: lt,
                    Repeat: ut,
                    is: at,
                    fromJS: nt
                };
            }();
        },
        function(t, e) {
            var r = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
            "number" == typeof __g && (__g = r);
        },
        function(t, e) {
            t.exports = function(t) {
                try {
                    return !!t();
                } catch (t) {
                    return !0;
                }
            };
        },
        function(t, e, r) {
            var n = r(5);
            t.exports = function(t) {
                if (!n(t)) throw TypeError(t + " is not an object!");
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return "object" == typeof t ? null !== t : "function" == typeof t;
            };
        },
        function(t, e, r) {
            var n = r(58)("wks"), o = r(32), i = r(2).Symbol, a = "function" == typeof i;
            (t.exports = function(t) {
                return n[t] || (n[t] = a && i[t] || (a ? i : o)("Symbol." + t));
            }).store = n;
        },
        function(t, e, r) {
            var n = r(20), o = Math.min;
            t.exports = function(t) {
                return t > 0 ? o(n(t), 9007199254740991) : 0;
            };
        },
        function(t, e) {
            var r = t.exports = {
                version: "2.6.11"
            };
            "number" == typeof __e && (__e = r);
        },
        function(t, e, r) {
            t.exports = !r(3)(function() {
                return 7 != Object.defineProperty({}, "a", {
                    get: function() {
                        return 7;
                    }
                }).a;
            });
        },
        function(t, e, r) {
            var n = r(4), o = r(129), i = r(29), a = Object.defineProperty;
            e.f = r(9) ? Object.defineProperty : function(t, e, r) {
                if (n(t), e = i(e, !0), n(r), o) try {
                    return a(t, e, r);
                } catch (t) {}
                if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
                return "value" in r && (t[e] = r.value), t;
            };
        },
        function(t, e, r) {
            var n = r(27);
            t.exports = function(t) {
                return Object(n(t));
            };
        },
        function(t, e, r) {
            var n = r(2), o = r(15), i = r(14), a = r(32)("src"), c = r(212), u = ("" + c).split("toString");
            r(8).inspectSource = function(t) {
                return c.call(t);
            }, (t.exports = function(t, e, r, c) {
                var s = "function" == typeof r;
                s && (i(r, "name") || o(r, "name", e)), t[e] !== r && (s && (i(r, a) || o(r, a, t[e] ? "" + t[e] : u.join(String(e)))), t === n ? t[e] = r : c ? t[e] ? t[e] = r : o(t, e, r) : (delete t[e], o(t, e, r)));
            })(Function.prototype, "toString", function() {
                return "function" == typeof this && this[a] || c.call(this);
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(3), i = r(27), a = /"/g, c = function(t, e, r, n) {
                var o = String(i(t)), c = "<" + e;
                return "" !== r && (c += " " + r + '="' + String(n).replace(a, "&quot;") + '"'), c + ">" + o + "</" + e + ">";
            };
            t.exports = function(t, e) {
                var r = {};
                r[t] = e(c), n(n.P + n.F * o(function() {
                    var e = ""[t]('"');
                    return e !== e.toLowerCase() || e.split('"').length > 3;
                }), "String", r);
            };
        },
        function(t, e) {
            var r = {}.hasOwnProperty;
            t.exports = function(t, e) {
                return r.call(t, e);
            };
        },
        function(t, e, r) {
            var n = r(10), o = r(31);
            t.exports = r(9) ? function(t, e, r) {
                return n.f(t, e, o(1, r));
            } : function(t, e, r) {
                return t[e] = r, t;
            };
        },
        function(t, e, r) {
            var n = r(50), o = r(27);
            t.exports = function(t) {
                return n(o(t));
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(3);
            t.exports = function(t, e) {
                return !!t && n(function() {
                    e ? t.call(null, function() {}, 1) : t.call(null);
                });
            };
        },
        function(t, e, r) {
            var n = r(19);
            t.exports = function(t, e, r) {
                if (n(t), void 0 === e) return t;
                switch(r){
                    case 1:
                        return function(r) {
                            return t.call(e, r);
                        };
                    case 2:
                        return function(r, n) {
                            return t.call(e, r, n);
                        };
                    case 3:
                        return function(r, n, o) {
                            return t.call(e, r, n, o);
                        };
                }
                return function() {
                    return t.apply(e, arguments);
                };
            };
        },
        function(t, e) {
            t.exports = function(t) {
                if ("function" != typeof t) throw TypeError(t + " is not a function!");
                return t;
            };
        },
        function(t, e) {
            var r = Math.ceil, n = Math.floor;
            t.exports = function(t) {
                return isNaN(t = +t) ? 0 : (t > 0 ? n : r)(t);
            };
        },
        function(t, e, r) {
            var n = r(51), o = r(31), i = r(16), a = r(29), c = r(14), u = r(129), s = Object.getOwnPropertyDescriptor;
            e.f = r(9) ? s : function(t, e) {
                if (t = i(t), e = a(e, !0), u) try {
                    return s(t, e);
                } catch (t) {}
                if (c(t, e)) return o(!n.f.call(t, e), t[e]);
            };
        },
        function(t, e, r) {
            var n = r(0), o = r(8), i = r(3);
            t.exports = function(t, e) {
                var r = (o.Object || {})[t] || Object[t], a = {};
                a[t] = e(r), n(n.S + n.F * i(function() {
                    r(1);
                }), "Object", a);
            };
        },
        function(t, e, r) {
            var n = r(18), o = r(50), i = r(11), a = r(7), c = r(145);
            t.exports = function(t, e) {
                var r = 1 == t, u = 2 == t, s = 3 == t, l = 4 == t, f = 6 == t, h = 5 == t || f, d = e || c;
                return function(e, c, p) {
                    for(var v, m, g = i(e), b = o(g), x = n(c, p, 3), y = a(b.length), _ = 0, w = r ? d(e, y) : u ? d(e, 0) : void 0; y > _; _++)if ((h || _ in b) && (m = x(v = b[_], _, g), t)) {
                        if (r) w[_] = m;
                        else if (m) switch(t){
                            case 3:
                                return !0;
                            case 5:
                                return v;
                            case 6:
                                return _;
                            case 2:
                                w.push(v);
                        }
                        else if (l) return !1;
                    }
                    return f ? -1 : s || l ? l : w;
                };
            };
        },
        function(t, e, r) {
            var n = r(172), o = "object" == typeof self && self && self.Object === Object && self, i = n || o || Function("return this")();
            t.exports = i;
        },
        function(t, e) {
            var r = Array.isArray;
            t.exports = r;
        },
        function(t, e) {
            var r = {}.toString;
            t.exports = function(t) {
                return r.call(t).slice(8, -1);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                if (null == t) throw TypeError("Can't call method on  " + t);
                return t;
            };
        },
        function(t, e, r) {
            "use strict";
            if (r(9)) {
                var n = r(33), o = r(2), i = r(3), a = r(0), c = r(69), u = r(106), s = r(18), l = r(48), f = r(31), h = r(15), d = r(49), p = r(20), v = r(7), m = r(156), g = r(35), b = r(29), x = r(14), y = r(52), _ = r(5), w = r(11), S = r(98), M = r(36), T = r(38), I = r(37).f, D = r(100), E = r(32), A = r(6), C = r(23), z = r(59), O = r(53), F = r(102), R = r(46), P = r(62), L = r(47), k = r(101), j = r(147), U = r(10), B = r(21), N = U.f, G = B.f, V = o.RangeError, q = o.TypeError, Y = o.Uint8Array, H = Array.prototype, W = u.ArrayBuffer, X = u.DataView, K = C(0), Z = C(2), J = C(3), $ = C(4), Q = C(5), tt = C(6), et = z(!0), rt = z(!1), nt = F.values, ot = F.keys, it = F.entries, at = H.lastIndexOf, ct = H.reduce, ut = H.reduceRight, st = H.join, lt = H.sort, ft = H.slice, ht = H.toString, dt = H.toLocaleString, pt = A("iterator"), vt = A("toStringTag"), mt = E("typed_constructor"), gt = E("def_constructor"), bt = c.CONSTR, xt = c.TYPED, yt = c.VIEW, _t = C(1, function(t, e) {
                    return It(O(t, t[gt]), e);
                }), wt = i(function() {
                    return 1 === new Y(new Uint16Array([
                        1
                    ]).buffer)[0];
                }), St = !!Y && !!Y.prototype.set && i(function() {
                    new Y(1).set({});
                }), Mt = function(t, e) {
                    var r = p(t);
                    if (r < 0 || r % e) throw V("Wrong offset!");
                    return r;
                }, Tt = function(t) {
                    if (_(t) && xt in t) return t;
                    throw q(t + " is not a typed array!");
                }, It = function(t, e) {
                    if (!_(t) || !(mt in t)) throw q("It is not a typed array constructor!");
                    return new t(e);
                }, Dt = function(t, e) {
                    return Et(O(t, t[gt]), e);
                }, Et = function(t, e) {
                    for(var r = 0, n = e.length, o = It(t, n); n > r;)o[r] = e[r++];
                    return o;
                }, At = function(t, e, r) {
                    N(t, e, {
                        get: function() {
                            return this._d[r];
                        }
                    });
                }, Ct = function(t) {
                    var e, r, n, o, i, a, c = w(t), u = arguments.length, l = u > 1 ? arguments[1] : void 0, f = void 0 !== l, h = D(c);
                    if (null != h && !S(h)) {
                        for(a = h.call(c), n = [], e = 0; !(i = a.next()).done; e++)n.push(i.value);
                        c = n;
                    }
                    for(f && u > 2 && (l = s(l, arguments[2], 2)), e = 0, r = v(c.length), o = It(this, r); r > e; e++)o[e] = f ? l(c[e], e) : c[e];
                    return o;
                }, zt = function() {
                    for(var t = 0, e = arguments.length, r = It(this, e); e > t;)r[t] = arguments[t++];
                    return r;
                }, Ot = !!Y && i(function() {
                    dt.call(new Y(1));
                }), Ft = function() {
                    return dt.apply(Ot ? ft.call(Tt(this)) : Tt(this), arguments);
                }, Rt = {
                    copyWithin: function(t, e) {
                        return j.call(Tt(this), t, e, arguments.length > 2 ? arguments[2] : void 0);
                    },
                    every: function(t) {
                        return $(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
                    },
                    fill: function(t) {
                        return k.apply(Tt(this), arguments);
                    },
                    filter: function(t) {
                        return Dt(this, Z(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0));
                    },
                    find: function(t) {
                        return Q(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
                    },
                    findIndex: function(t) {
                        return tt(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
                    },
                    forEach: function(t) {
                        K(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
                    },
                    indexOf: function(t) {
                        return rt(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
                    },
                    includes: function(t) {
                        return et(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
                    },
                    join: function(t) {
                        return st.apply(Tt(this), arguments);
                    },
                    lastIndexOf: function(t) {
                        return at.apply(Tt(this), arguments);
                    },
                    map: function(t) {
                        return _t(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
                    },
                    reduce: function(t) {
                        return ct.apply(Tt(this), arguments);
                    },
                    reduceRight: function(t) {
                        return ut.apply(Tt(this), arguments);
                    },
                    reverse: function() {
                        for(var t, e = Tt(this).length, r = Math.floor(e / 2), n = 0; n < r;)t = this[n], this[n++] = this[--e], this[e] = t;
                        return this;
                    },
                    some: function(t) {
                        return J(Tt(this), t, arguments.length > 1 ? arguments[1] : void 0);
                    },
                    sort: function(t) {
                        return lt.call(Tt(this), t);
                    },
                    subarray: function(t, e) {
                        var r = Tt(this), n = r.length, o = g(t, n);
                        return new (O(r, r[gt]))(r.buffer, r.byteOffset + o * r.BYTES_PER_ELEMENT, v((void 0 === e ? n : g(e, n)) - o));
                    }
                }, Pt = function(t, e) {
                    return Dt(this, ft.call(Tt(this), t, e));
                }, Lt = function(t) {
                    Tt(this);
                    var e = Mt(arguments[1], 1), r = this.length, n = w(t), o = v(n.length), i = 0;
                    if (o + e > r) throw V("Wrong length!");
                    for(; i < o;)this[e + i] = n[i++];
                }, kt = {
                    entries: function() {
                        return it.call(Tt(this));
                    },
                    keys: function() {
                        return ot.call(Tt(this));
                    },
                    values: function() {
                        return nt.call(Tt(this));
                    }
                }, jt = function(t, e) {
                    return _(t) && t[xt] && "symbol" != typeof e && e in t && String(+e) == String(e);
                }, Ut = function(t, e) {
                    return jt(t, e = b(e, !0)) ? f(2, t[e]) : G(t, e);
                }, Bt = function(t, e, r) {
                    return !(jt(t, e = b(e, !0)) && _(r) && x(r, "value")) || x(r, "get") || x(r, "set") || r.configurable || x(r, "writable") && !r.writable || x(r, "enumerable") && !r.enumerable ? N(t, e, r) : (t[e] = r.value, t);
                };
                bt || (B.f = Ut, U.f = Bt), a(a.S + a.F * !bt, "Object", {
                    getOwnPropertyDescriptor: Ut,
                    defineProperty: Bt
                }), i(function() {
                    ht.call({});
                }) && (ht = dt = function() {
                    return st.call(this);
                });
                var Nt = d({}, Rt);
                d(Nt, kt), h(Nt, pt, kt.values), d(Nt, {
                    slice: Pt,
                    set: Lt,
                    constructor: function() {},
                    toString: ht,
                    toLocaleString: Ft
                }), At(Nt, "buffer", "b"), At(Nt, "byteOffset", "o"), At(Nt, "byteLength", "l"), At(Nt, "length", "e"), N(Nt, vt, {
                    get: function() {
                        return this[xt];
                    }
                }), t.exports = function(t, e, r, u) {
                    var s = t + ((u = !!u) ? "Clamped" : "") + "Array", f = "get" + t, d = "set" + t, p = o[s], g = p || {}, b = p && T(p), x = !p || !c.ABV, w = {}, S = p && p.prototype, D = function(t, r) {
                        N(t, r, {
                            get: function() {
                                return function(t, r) {
                                    var n = t._d;
                                    return n.v[f](r * e + n.o, wt);
                                }(this, r);
                            },
                            set: function(t) {
                                return function(t, r, n) {
                                    var o = t._d;
                                    u && (n = (n = Math.round(n)) < 0 ? 0 : n > 255 ? 255 : 255 & n), o.v[d](r * e + o.o, n, wt);
                                }(this, r, t);
                            },
                            enumerable: !0
                        });
                    };
                    x ? (p = r(function(t, r, n, o) {
                        l(t, p, s, "_d");
                        var i, a, c, u, f = 0, d = 0;
                        if (_(r)) {
                            if (!(r instanceof W || "ArrayBuffer" == (u = y(r)) || "SharedArrayBuffer" == u)) return xt in r ? Et(p, r) : Ct.call(p, r);
                            i = r, d = Mt(n, e);
                            var g = r.byteLength;
                            if (void 0 === o) {
                                if (g % e) throw V("Wrong length!");
                                if ((a = g - d) < 0) throw V("Wrong length!");
                            } else if ((a = v(o) * e) + d > g) throw V("Wrong length!");
                            c = a / e;
                        } else c = m(r), i = new W(a = c * e);
                        for(h(t, "_d", {
                            b: i,
                            o: d,
                            l: a,
                            e: c,
                            v: new X(i)
                        }); f < c;)D(t, f++);
                    }), S = p.prototype = M(Nt), h(S, "constructor", p)) : i(function() {
                        p(1);
                    }) && i(function() {
                        new p(-1);
                    }) && P(function(t) {
                        new p, new p(null), new p(1.5), new p(t);
                    }, !0) || (p = r(function(t, r, n, o) {
                        var i;
                        return l(t, p, s), _(r) ? r instanceof W || "ArrayBuffer" == (i = y(r)) || "SharedArrayBuffer" == i ? void 0 !== o ? new g(r, Mt(n, e), o) : void 0 !== n ? new g(r, Mt(n, e)) : new g(r) : xt in r ? Et(p, r) : Ct.call(p, r) : new g(m(r));
                    }), K(b !== Function.prototype ? I(g).concat(I(b)) : I(g), function(t) {
                        t in p || h(p, t, g[t]);
                    }), p.prototype = S, n || (S.constructor = p));
                    var E = S[pt], A = !!E && ("values" == E.name || null == E.name), C = kt.values;
                    h(p, mt, !0), h(S, xt, s), h(S, yt, !0), h(S, gt, p), (u ? new p(1)[vt] == s : vt in S) || N(S, vt, {
                        get: function() {
                            return s;
                        }
                    }), w[s] = p, a(a.G + a.W + a.F * (p != g), w), a(a.S, s, {
                        BYTES_PER_ELEMENT: e
                    }), a(a.S + a.F * i(function() {
                        g.of.call(p, 1);
                    }), s, {
                        from: Ct,
                        of: zt
                    }), "BYTES_PER_ELEMENT" in S || h(S, "BYTES_PER_ELEMENT", e), a(a.P, s, Rt), L(s), a(a.P + a.F * St, s, {
                        set: Lt
                    }), a(a.P + a.F * !A, s, kt), n || S.toString == ht || (S.toString = ht), a(a.P + a.F * i(function() {
                        new p(1).slice();
                    }), s, {
                        slice: Pt
                    }), a(a.P + a.F * (i(function() {
                        return [
                            1,
                            2
                        ].toLocaleString() != new p([
                            1,
                            2
                        ]).toLocaleString();
                    }) || !i(function() {
                        S.toLocaleString.call([
                            1,
                            2
                        ]);
                    })), s, {
                        toLocaleString: Ft
                    }), R[s] = A ? E : C, n || A || h(S, pt, C);
                };
            } else t.exports = function() {};
        },
        function(t, e, r) {
            var n = r(5);
            t.exports = function(t, e) {
                if (!n(t)) return t;
                var r, o;
                if (e && "function" == typeof (r = t.toString) && !n(o = r.call(t))) return o;
                if ("function" == typeof (r = t.valueOf) && !n(o = r.call(t))) return o;
                if (!e && "function" == typeof (r = t.toString) && !n(o = r.call(t))) return o;
                throw TypeError("Can't convert object to primitive value");
            };
        },
        function(t, e, r) {
            var n = r(32)("meta"), o = r(5), i = r(14), a = r(10).f, c = 0, u = Object.isExtensible || function() {
                return !0;
            }, s = !r(3)(function() {
                return u(Object.preventExtensions({}));
            }), l = function(t) {
                a(t, n, {
                    value: {
                        i: "O" + ++c,
                        w: {}
                    }
                });
            }, f = t.exports = {
                KEY: n,
                NEED: !1,
                fastKey: function(t, e) {
                    if (!o(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
                    if (!i(t, n)) {
                        if (!u(t)) return "F";
                        if (!e) return "E";
                        l(t);
                    }
                    return t[n].i;
                },
                getWeak: function(t, e) {
                    if (!i(t, n)) {
                        if (!u(t)) return !0;
                        if (!e) return !1;
                        l(t);
                    }
                    return t[n].w;
                },
                onFreeze: function(t) {
                    return s && f.NEED && u(t) && !i(t, n) && l(t), t;
                }
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return {
                    enumerable: !(1 & t),
                    configurable: !(2 & t),
                    writable: !(4 & t),
                    value: e
                };
            };
        },
        function(t, e) {
            var r = 0, n = Math.random();
            t.exports = function(t) {
                return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++r + n).toString(36));
            };
        },
        function(t, e) {
            t.exports = !1;
        },
        function(t, e, r) {
            var n = r(131), o = r(85);
            t.exports = Object.keys || function(t) {
                return n(t, o);
            };
        },
        function(t, e, r) {
            var n = r(20), o = Math.max, i = Math.min;
            t.exports = function(t, e) {
                return (t = n(t)) < 0 ? o(t + e, 0) : i(t, e);
            };
        },
        function(t, e, r) {
            var n = r(4), o = r(132), i = r(85), a = r(84)("IE_PROTO"), c = function() {}, u = function() {
                var t, e = r(82)("iframe"), n = i.length;
                for(e.style.display = "none", r(86).appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), u = t.F; n--;)delete u.prototype[i[n]];
                return u();
            };
            t.exports = Object.create || function(t, e) {
                var r;
                return null !== t ? (c.prototype = n(t), r = new c, c.prototype = null, r[a] = t) : r = u(), void 0 === e ? r : o(r, e);
            };
        },
        function(t, e, r) {
            var n = r(131), o = r(85).concat("length", "prototype");
            e.f = Object.getOwnPropertyNames || function(t) {
                return n(t, o);
            };
        },
        function(t, e, r) {
            var n = r(14), o = r(11), i = r(84)("IE_PROTO"), a = Object.prototype;
            t.exports = Object.getPrototypeOf || function(t) {
                return t = o(t), n(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null;
            };
        },
        function(t, e, r) {
            var n = r(6)("unscopables"), o = Array.prototype;
            null == o[n] && r(15)(o, n, {}), t.exports = function(t) {
                o[n][t] = !0;
            };
        },
        function(t, e, r) {
            var n = r(5);
            t.exports = function(t, e) {
                if (!n(t) || t._t !== e) throw TypeError("Incompatible receiver, " + e + " required!");
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return null != t && "object" == typeof t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = typeof t;
                return null != t && ("object" == e || "function" == e);
            };
        },
        function(t, e, r) {
            var n = r(508), o = r(511);
            t.exports = function(t, e) {
                var r = o(t, e);
                return n(r) ? r : void 0;
            };
        },
        function(t, e, r) {
            var n = r(10).f, o = r(14), i = r(6)("toStringTag");
            t.exports = function(t, e, r) {
                t && !o(t = r ? t : t.prototype, i) && n(t, i, {
                    configurable: !0,
                    value: e
                });
            };
        },
        function(t, e, r) {
            var n = r(0), o = r(27), i = r(3), a = r(88), c = "[" + a + "]", u = RegExp("^" + c + c + "*"), s = RegExp(c + c + "*$"), l = function(t, e, r) {
                var o = {}, c = i(function() {
                    return !!a[t]() || "\u200B\x85" != "\u200B\x85"[t]();
                }), u = o[t] = c ? e(f) : a[t];
                r && (o[r] = u), n(n.P + n.F * c, "String", o);
            }, f = l.trim = function(t, e) {
                return t = String(o(t)), 1 & e && (t = t.replace(u, "")), 2 & e && (t = t.replace(s, "")), t;
            };
            t.exports = l;
        },
        function(t, e) {
            t.exports = {};
        },
        function(t, e, r) {
            "use strict";
            var n = r(2), o = r(10), i = r(9), a = r(6)("species");
            t.exports = function(t) {
                var e = n[t];
                i && e && !e[a] && o.f(e, a, {
                    configurable: !0,
                    get: function() {
                        return this;
                    }
                });
            };
        },
        function(t, e) {
            t.exports = function(t, e, r, n) {
                if (!(t instanceof e) || void 0 !== n && n in t) throw TypeError(r + ": incorrect invocation!");
                return t;
            };
        },
        function(t, e, r) {
            var n = r(12);
            t.exports = function(t, e, r) {
                for(var o in e)n(t, o, e[o], r);
                return t;
            };
        },
        function(t, e, r) {
            var n = r(26);
            t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t) {
                return "String" == n(t) ? t.split("") : Object(t);
            };
        },
        function(t, e) {
            e.f = ({}).propertyIsEnumerable;
        },
        function(t, e, r) {
            var n = r(26), o = r(6)("toStringTag"), i = "Arguments" == n(function() {
                return arguments;
            }());
            t.exports = function(t) {
                var e, r, a;
                return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function(t, e) {
                    try {
                        return t[e];
                    } catch (t) {}
                }(e = Object(t), o)) ? r : i ? n(e) : "Object" == (a = n(e)) && "function" == typeof e.callee ? "Arguments" : a;
            };
        },
        function(t, e, r) {
            var n = r(4), o = r(19), i = r(6)("species");
            t.exports = function(t, e) {
                var r, a = n(t).constructor;
                return void 0 === a || null == (r = n(a)[i]) ? e : o(r);
            };
        },
        function(t, e, r) {
            var n = r(170), o = r(492), i = r(72);
            t.exports = function(t) {
                return i(t) ? n(t) : o(t);
            };
        },
        function(t, e, r) {
            var n = r(56), o = r(488), i = r(489), a = n ? n.toStringTag : void 0;
            t.exports = function(t) {
                return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : a && a in Object(t) ? o(t) : i(t);
            };
        },
        function(t, e, r) {
            var n = r(24).Symbol;
            t.exports = n;
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t === e || t != t && e != e;
            };
        },
        function(t, e, r) {
            var n = r(8), o = r(2), i = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
            (t.exports = function(t, e) {
                return i[t] || (i[t] = void 0 !== e ? e : {});
            })("versions", []).push({
                version: n.version,
                mode: r(33) ? "pure" : "global",
                copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
            });
        },
        function(t, e, r) {
            var n = r(16), o = r(7), i = r(35);
            t.exports = function(t) {
                return function(e, r, a) {
                    var c, u = n(e), s = o(u.length), l = i(a, s);
                    if (t && r != r) {
                        for(; s > l;)if ((c = u[l++]) != c) return !0;
                    } else for(; s > l; l++)if ((t || l in u) && u[l] === r) return t || l || 0;
                    return !t && -1;
                };
            };
        },
        function(t, e) {
            e.f = Object.getOwnPropertySymbols;
        },
        function(t, e, r) {
            var n = r(26);
            t.exports = Array.isArray || function(t) {
                return "Array" == n(t);
            };
        },
        function(t, e, r) {
            var n = r(6)("iterator"), o = !1;
            try {
                var i = [
                    7
                ][n]();
                i.return = function() {
                    o = !0;
                }, Array.from(i, function() {
                    throw 2;
                });
            } catch (t) {}
            t.exports = function(t, e) {
                if (!e && !o) return !1;
                var r = !1;
                try {
                    var i = [
                        7
                    ], a = i[n]();
                    a.next = function() {
                        return {
                            done: r = !0
                        };
                    }, i[n] = function() {
                        return a;
                    }, t(i);
                } catch (t) {}
                return r;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(4);
            t.exports = function() {
                var t = n(this), e = "";
                return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(52), o = RegExp.prototype.exec;
            t.exports = function(t, e) {
                var r = t.exec;
                if ("function" == typeof r) {
                    var i = r.call(t, e);
                    if ("object" != typeof i) throw new TypeError("RegExp exec method returned something other than an Object or null");
                    return i;
                }
                if ("RegExp" !== n(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
                return o.call(t, e);
            };
        },
        function(t, e, r) {
            "use strict";
            r(149);
            var n = r(12), o = r(15), i = r(3), a = r(27), c = r(6), u = r(103), s = c("species"), l = !i(function() {
                var t = /./;
                return t.exec = function() {
                    var t = [];
                    return t.groups = {
                        a: "7"
                    }, t;
                }, "7" !== "".replace(t, "$<a>");
            }), f = function() {
                var t = /(?:)/, e = t.exec;
                t.exec = function() {
                    return e.apply(this, arguments);
                };
                var r = "ab".split(t);
                return 2 === r.length && "a" === r[0] && "b" === r[1];
            }();
            t.exports = function(t, e, r) {
                var h = c(t), d = !i(function() {
                    var e = {};
                    return e[h] = function() {
                        return 7;
                    }, 7 != ""[t](e);
                }), p = d ? !i(function() {
                    var e = !1, r = /a/;
                    return r.exec = function() {
                        return e = !0, null;
                    }, "split" === t && (r.constructor = {}, r.constructor[s] = function() {
                        return r;
                    }), r[h](""), !e;
                }) : void 0;
                if (!d || !p || "replace" === t && !l || "split" === t && !f) {
                    var v = /./[h], m = r(a, h, ""[t], function(t, e, r, n, o) {
                        return e.exec === u ? d && !o ? {
                            done: !0,
                            value: v.call(e, r, n)
                        } : {
                            done: !0,
                            value: t.call(r, e, n)
                        } : {
                            done: !1
                        };
                    }), g = m[0], b = m[1];
                    n(String.prototype, t, g), o(RegExp.prototype, h, 2 == e ? function(t, e) {
                        return b.call(t, this, e);
                    } : function(t) {
                        return b.call(t, this);
                    });
                }
            };
        },
        function(t, e, r) {
            var n = r(18), o = r(144), i = r(98), a = r(4), c = r(7), u = r(100), s = {}, l = {};
            (e = t.exports = function(t, e, r, f, h) {
                var d, p, v, m, g = h ? function() {
                    return t;
                } : u(t), b = n(r, f, e ? 2 : 1), x = 0;
                if ("function" != typeof g) throw TypeError(t + " is not iterable!");
                if (i(g)) {
                    for(d = c(t.length); d > x; x++)if ((m = e ? b(a(p = t[x])[0], p[1]) : b(t[x])) === s || m === l) return m;
                } else for(v = g.call(t); !(p = v.next()).done;)if ((m = o(v, b, p.value, e)) === s || m === l) return m;
            }).BREAK = s, e.RETURN = l;
        },
        function(t, e, r) {
            var n = r(2).navigator;
            t.exports = n && n.userAgent || "";
        },
        function(t, e, r) {
            "use strict";
            var n = r(2), o = r(0), i = r(12), a = r(49), c = r(30), u = r(66), s = r(48), l = r(5), f = r(3), h = r(62), d = r(44), p = r(89);
            t.exports = function(t, e, r, v, m, g) {
                var b = n[t], x = b, y = m ? "set" : "add", _ = x && x.prototype, w = {}, S = function(t) {
                    var e = _[t];
                    i(_, t, "delete" == t || "has" == t ? function(t) {
                        return !(g && !l(t)) && e.call(this, 0 === t ? 0 : t);
                    } : "get" == t ? function(t) {
                        return g && !l(t) ? void 0 : e.call(this, 0 === t ? 0 : t);
                    } : "add" == t ? function(t) {
                        return e.call(this, 0 === t ? 0 : t), this;
                    } : function(t, r) {
                        return e.call(this, 0 === t ? 0 : t, r), this;
                    });
                };
                if ("function" == typeof x && (g || _.forEach && !f(function() {
                    (new x).entries().next();
                }))) {
                    var M = new x, T = M[y](g ? {} : -0, 1) != M, I = f(function() {
                        M.has(1);
                    }), D = h(function(t) {
                        new x(t);
                    }), E = !g && f(function() {
                        for(var t = new x, e = 5; e--;)t[y](e, e);
                        return !t.has(-0);
                    });
                    D || ((x = e(function(e, r) {
                        s(e, x, t);
                        var n = p(new b, e, x);
                        return null != r && u(r, m, n[y], n), n;
                    })).prototype = _, _.constructor = x), (I || E) && (S("delete"), S("has"), m && S("get")), (E || T) && S(y), g && _.clear && delete _.clear;
                } else x = v.getConstructor(e, t, m, y), a(x.prototype, r), c.NEED = !0;
                return d(x, t), w[t] = x, o(o.G + o.W + o.F * (x != b), w), g || v.setStrong(x, t, m), x;
            };
        },
        function(t, e, r) {
            for(var n, o = r(2), i = r(15), a = r(32), c = a("typed_array"), u = a("view"), s = !(!o.ArrayBuffer || !o.DataView), l = s, f = 0, h = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); f < 9;)(n = o[h[f++]]) ? (i(n.prototype, c, !0), i(n.prototype, u, !0)) : l = !1;
            t.exports = {
                ABV: s,
                CONSTR: l,
                TYPED: c,
                VIEW: u
            };
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
                return null === e ? null : [
                    e[1],
                    e[2],
                    e[3]
                ].map(function(t) {
                    return parseInt(t, 16);
                });
            }
            function o(t, e, r) {
                return e /= 255, r /= 255, t = (t /= 255) > .04045 ? Math.pow((t + .005) / 1.055, 2.4) : t / 12.92, e = e > .04045 ? Math.pow((e + .005) / 1.055, 2.4) : e / 12.92, r = r > .04045 ? Math.pow((r + .005) / 1.055, 2.4) : r / 12.92, [
                    .4124 * (t *= 100) + .3576 * (e *= 100) + .1805 * (r *= 100),
                    .2126 * t + .7152 * e + .0722 * r,
                    .0193 * t + .1192 * e + .9505 * r
                ];
            }
            function i(t, e, r) {
                return e /= 100, r /= 108.883, t = (t /= 95.047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, [
                    116 * (e = e > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116) - 16,
                    500 * (t - e),
                    200 * (e - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))
                ];
            }
            function a(t, e, r) {
                var n = o(t, e, r);
                return i(n[0], n[1], n[2]);
            }
            function c(t, e) {
                var r = t[0], n = t[1], o = t[2], i = e[0], a = e[1], c = e[2], u = r - i, s = n - a, l = o - c, f = Math.sqrt(n * n + o * o), h = i - r, d = Math.sqrt(a * a + c * c) - f, p = Math.sqrt(u * u + s * s + l * l), v = Math.sqrt(p) > Math.sqrt(Math.abs(h)) + Math.sqrt(Math.abs(d)) ? Math.sqrt(p * p - h * h - d * d) : 0;
                return h /= 1, d /= 1 * (1 + .045 * f), v /= 1 * (1 + .015 * f), Math.sqrt(h * h + d * d + v * v);
            }
            function u(t, e) {
                return c(a.apply(void 0, t), a.apply(void 0, e));
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.DELTAE94_DIFF_STATUS = {
                NA: 0,
                PERFECT: 1,
                CLOSE: 2,
                GOOD: 10,
                SIMILAR: 50
            }, e.SIGBITS = 5, e.RSHIFT = 8 - e.SIGBITS, e.defer = function() {
                var t, e, r = new Promise(function(r, n) {
                    t = r, e = n;
                });
                return {
                    resolve: t,
                    reject: e,
                    promise: r
                };
            }, e.hexToRgb = n, e.rgbToHex = function(t, e, r) {
                return "#" + (16777216 + (t << 16) + (e << 8) + r).toString(16).slice(1, 7);
            }, e.rgbToHsl = function(t, e, r) {
                t /= 255, e /= 255, r /= 255;
                var n, o, i = Math.max(t, e, r), a = Math.min(t, e, r), c = (i + a) / 2;
                if (i === a) n = o = 0;
                else {
                    var u = i - a;
                    switch(o = c > .5 ? u / (2 - i - a) : u / (i + a), i){
                        case t:
                            n = (e - r) / u + (e < r ? 6 : 0);
                            break;
                        case e:
                            n = (r - t) / u + 2;
                            break;
                        case r:
                            n = (t - e) / u + 4;
                    }
                    n /= 6;
                }
                return [
                    n,
                    o,
                    c
                ];
            }, e.hslToRgb = function(t, e, r) {
                var n, o, i;
                function a(t, e, r) {
                    return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
                }
                if (0 === e) n = o = i = r;
                else {
                    var c = r < .5 ? r * (1 + e) : r + e - r * e, u = 2 * r - c;
                    n = a(u, c, t + 1 / 3), o = a(u, c, t), i = a(u, c, t - 1 / 3);
                }
                return [
                    255 * n,
                    255 * o,
                    255 * i
                ];
            }, e.rgbToXyz = o, e.xyzToCIELab = i, e.rgbToCIELab = a, e.deltaE94 = c, e.rgbDiff = u, e.hexDiff = function(t, e) {
                return u(n(t), n(e));
            }, e.getColorDiffStatus = function(t) {
                return t < e.DELTAE94_DIFF_STATUS.NA ? "N/A" : t <= e.DELTAE94_DIFF_STATUS.PERFECT ? "Perfect" : t <= e.DELTAE94_DIFF_STATUS.CLOSE ? "Close" : t <= e.DELTAE94_DIFF_STATUS.GOOD ? "Good" : t < e.DELTAE94_DIFF_STATUS.SIMILAR ? "Similar" : "Wrong";
            }, e.getColorIndex = function(t, r, n) {
                return (t << 2 * e.SIGBITS) + (r << e.SIGBITS) + n;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.webpackPolyfill || (t.deprecate = function() {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
                    enumerable: !0,
                    get: function() {
                        return t.l;
                    }
                }), Object.defineProperty(t, "id", {
                    enumerable: !0,
                    get: function() {
                        return t.i;
                    }
                }), t.webpackPolyfill = 1), t;
            };
        },
        function(t, e, r) {
            var n = r(175), o = r(115);
            t.exports = function(t) {
                return null != t && o(t.length) && !n(t);
            };
        },
        function(t, e, r) {
            var n = r(498), o = r(499), i = r(500), a = r(501), c = r(502);
            function u(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            u.prototype.clear = n, u.prototype.delete = o, u.prototype.get = i, u.prototype.has = a, u.prototype.set = c, t.exports = u;
        },
        function(t, e, r) {
            var n = r(57);
            t.exports = function(t, e) {
                for(var r = t.length; r--;)if (n(t[r][0], e)) return r;
                return -1;
            };
        },
        function(t, e, r) {
            var n = r(43)(Object, "create");
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(520);
            t.exports = function(t, e) {
                var r = t.__data__;
                return n(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
            };
        },
        function(t, e, r) {
            var n = r(534), o = r(120), i = r(535), a = r(536), c = r(537), u = r(55), s = r(176), l = s(n), f = s(o), h = s(i), d = s(a), p = s(c), v = u;
            (n && "[object DataView]" != v(new n(new ArrayBuffer(1))) || o && "[object Map]" != v(new o) || i && "[object Promise]" != v(i.resolve()) || a && "[object Set]" != v(new a) || c && "[object WeakMap]" != v(new c)) && (v = function(t) {
                var e = u(t), r = "[object Object]" == e ? t.constructor : void 0, n = r ? s(r) : "";
                if (n) switch(n){
                    case l:
                        return "[object DataView]";
                    case f:
                        return "[object Map]";
                    case h:
                        return "[object Promise]";
                    case d:
                        return "[object Set]";
                    case p:
                        return "[object WeakMap]";
                }
                return e;
            }), t.exports = v;
        },
        function(t, e, r) {
            var n = r(124);
            t.exports = function(t) {
                if ("string" == typeof t || n(t)) return t;
                var e = t + "";
                return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
            };
        },
        function(t, e, r) {
            var n = r(188), o = r(189);
            t.exports = function(t, e, r, i) {
                var a = !r;
                r || (r = {});
                for(var c = -1, u = e.length; ++c < u;){
                    var s = e[c], l = i ? i(r[s], t[s], s, r, t) : void 0;
                    void 0 === l && (l = t[s]), a ? o(r, s, l) : n(r, s, l);
                }
                return r;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
            function o(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
            }
            e.assign = function(t) {
                for(var e = Array.prototype.slice.call(arguments, 1); e.length;){
                    var r = e.shift();
                    if (r) {
                        if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                        for(var n in r)o(r, n) && (t[n] = r[n]);
                    }
                }
                return t;
            }, e.shrinkBuf = function(t, e) {
                return t.length === e ? t : t.subarray ? t.subarray(0, e) : (t.length = e, t);
            };
            var i = {
                arraySet: function(t, e, r, n, o) {
                    if (e.subarray && t.subarray) t.set(e.subarray(r, r + n), o);
                    else for(var i = 0; i < n; i++)t[o + i] = e[r + i];
                },
                flattenChunks: function(t) {
                    var e, r, n, o, i, a;
                    for(n = 0, e = 0, r = t.length; e < r; e++)n += t[e].length;
                    for(a = new Uint8Array(n), o = 0, e = 0, r = t.length; e < r; e++)i = t[e], a.set(i, o), o += i.length;
                    return a;
                }
            }, a = {
                arraySet: function(t, e, r, n, o) {
                    for(var i = 0; i < n; i++)t[o + i] = e[r + i];
                },
                flattenChunks: function(t) {
                    return [].concat.apply([], t);
                }
            };
            e.setTyped = function(t) {
                t ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, i)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, a));
            }, e.setTyped(n);
        },
        function(t, e) {
            var r;
            r = function() {
                return this;
            }();
            try {
                r = r || new Function("return this")();
            } catch (t) {
                "object" == typeof window && (r = window);
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(5), o = r(2).document, i = n(o) && n(o.createElement);
            t.exports = function(t) {
                return i ? o.createElement(t) : {};
            };
        },
        function(t, e, r) {
            e.f = r(6);
        },
        function(t, e, r) {
            var n = r(58)("keys"), o = r(32);
            t.exports = function(t) {
                return n[t] || (n[t] = o(t));
            };
        },
        function(t, e) {
            t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
        },
        function(t, e, r) {
            var n = r(2).document;
            t.exports = n && n.documentElement;
        },
        function(t, e, r) {
            var n = r(5), o = r(4), i = function(t, e) {
                if (o(t), !n(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
            };
            t.exports = {
                set: Object.setPrototypeOf || ("__proto__" in {} ? function(t, e, n) {
                    try {
                        (n = r(18)(Function.call, r(21).f(Object.prototype, "__proto__").set, 2))(t, []), e = !(t instanceof Array);
                    } catch (t) {
                        e = !0;
                    }
                    return function(t, r) {
                        return i(t, r), e ? t.__proto__ = r : n(t, r), t;
                    };
                }({}, !1) : void 0),
                check: i
            };
        },
        function(t, e) {
            t.exports = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
        },
        function(t, e, r) {
            var n = r(5), o = r(87).set;
            t.exports = function(t, e, r) {
                var i, a = e.constructor;
                return a !== r && "function" == typeof a && (i = a.prototype) !== r.prototype && n(i) && o && o(t, i), t;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(20), o = r(27);
            t.exports = function(t) {
                var e = String(o(this)), r = "", i = n(t);
                if (i < 0 || i == 1 / 0) throw RangeError("Count can't be negative");
                for(; i > 0; (i >>>= 1) && (e += e))1 & i && (r += e);
                return r;
            };
        },
        function(t, e) {
            t.exports = Math.sign || function(t) {
                return 0 == (t = +t) || t != t ? t : t < 0 ? -1 : 1;
            };
        },
        function(t, e) {
            var r = Math.expm1;
            t.exports = !r || r(10) > 22025.465794806718 || r(10) < 22025.465794806718 || -0.00000000000000002 != r(-0.00000000000000002) ? function(t) {
                return 0 == (t = +t) ? t : t > -0.000001 && t < 1e-6 ? t + t * t / 2 : Math.exp(t) - 1;
            } : r;
        },
        function(t, e, r) {
            var n = r(20), o = r(27);
            t.exports = function(t) {
                return function(e, r) {
                    var i, a, c = String(o(e)), u = n(r), s = c.length;
                    return u < 0 || u >= s ? t ? "" : void 0 : (i = c.charCodeAt(u)) < 55296 || i > 56319 || u + 1 === s || (a = c.charCodeAt(u + 1)) < 56320 || a > 57343 ? t ? c.charAt(u) : i : t ? c.slice(u, u + 2) : a - 56320 + (i - 55296 << 10) + 65536;
                };
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(33), o = r(0), i = r(12), a = r(15), c = r(46), u = r(143), s = r(44), l = r(38), f = r(6)("iterator"), h = !([].keys && "next" in [].keys()), d = function() {
                return this;
            };
            t.exports = function(t, e, r, p, v, m, g) {
                u(r, e, p);
                var b, x, y, _ = function(t) {
                    if (!h && t in T) return T[t];
                    switch(t){
                        case "keys":
                        case "values":
                            return function() {
                                return new r(this, t);
                            };
                    }
                    return function() {
                        return new r(this, t);
                    };
                }, w = e + " Iterator", S = "values" == v, M = !1, T = t.prototype, I = T[f] || T["@@iterator"] || v && T[v], D = I || _(v), E = v ? S ? _("entries") : D : void 0, A = "Array" == e && T.entries || I;
                if (A && (y = l(A.call(new t))) !== Object.prototype && y.next && (s(y, w, !0), n || "function" == typeof y[f] || a(y, f, d)), S && I && "values" !== I.name && (M = !0, D = function() {
                    return I.call(this);
                }), n && !g || !h && !M && T[f] || a(T, f, D), c[e] = D, c[w] = d, v) {
                    if (b = {
                        values: S ? D : _("values"),
                        keys: m ? D : _("keys"),
                        entries: E
                    }, g) for(x in b)x in T || i(T, x, b[x]);
                    else o(o.P + o.F * (h || M), e, b);
                }
                return b;
            };
        },
        function(t, e, r) {
            var n = r(96), o = r(27);
            t.exports = function(t, e, r) {
                if (n(e)) throw TypeError("String#" + r + " doesn't accept regex!");
                return String(o(t));
            };
        },
        function(t, e, r) {
            var n = r(5), o = r(26), i = r(6)("match");
            t.exports = function(t) {
                var e;
                return n(t) && (void 0 !== (e = t[i]) ? !!e : "RegExp" == o(t));
            };
        },
        function(t, e, r) {
            var n = r(6)("match");
            t.exports = function(t) {
                var e = /./;
                try {
                    "/./"[t](e);
                } catch (r) {
                    try {
                        return e[n] = !1, !"/./"[t](e);
                    } catch (t) {}
                }
                return !0;
            };
        },
        function(t, e, r) {
            var n = r(46), o = r(6)("iterator"), i = Array.prototype;
            t.exports = function(t) {
                return void 0 !== t && (n.Array === t || i[o] === t);
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(10), o = r(31);
            t.exports = function(t, e, r) {
                e in t ? n.f(t, e, o(0, r)) : t[e] = r;
            };
        },
        function(t, e, r) {
            var n = r(52), o = r(6)("iterator"), i = r(46);
            t.exports = r(8).getIteratorMethod = function(t) {
                if (null != t) return t[o] || t["@@iterator"] || i[n(t)];
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(11), o = r(35), i = r(7);
            t.exports = function(t) {
                for(var e = n(this), r = i(e.length), a = arguments.length, c = o(a > 1 ? arguments[1] : void 0, r), u = a > 2 ? arguments[2] : void 0, s = void 0 === u ? r : o(u, r); s > c;)e[c++] = t;
                return e;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(39), o = r(148), i = r(46), a = r(16);
            t.exports = r(94)(Array, "Array", function(t, e) {
                this._t = a(t), this._i = 0, this._k = e;
            }, function() {
                var t = this._t, e = this._k, r = this._i++;
                return !t || r >= t.length ? (this._t = void 0, o(1)) : o(0, "keys" == e ? r : "values" == e ? t[r] : [
                    r,
                    t[r]
                ]);
            }, "values"), i.Arguments = i.Array, n("keys"), n("values"), n("entries");
        },
        function(t, e, r) {
            "use strict";
            var n, o, i = r(63), a = RegExp.prototype.exec, c = String.prototype.replace, u = a, s = (n = /a/, o = /b*/g, a.call(n, "a"), a.call(o, "a"), 0 !== n.lastIndex || 0 !== o.lastIndex), l = void 0 !== /()??/.exec("")[1];
            (s || l) && (u = function(t) {
                var e, r, n, o, u = this;
                return l && (r = new RegExp("^" + u.source + "$(?!\\s)", i.call(u))), s && (e = u.lastIndex), n = a.call(u, t), s && n && (u.lastIndex = u.global ? n.index + n[0].length : e), l && n && n.length > 1 && c.call(n[0], r, function() {
                    for(o = 1; o < arguments.length - 2; o++)void 0 === arguments[o] && (n[o] = void 0);
                }), n;
            }), t.exports = u;
        },
        function(t, e, r) {
            "use strict";
            var n = r(93)(!0);
            t.exports = function(t, e, r) {
                return e + (r ? n(t, e).length : 1);
            };
        },
        function(t, e, r) {
            var n, o, i, a = r(18), c = r(137), u = r(86), s = r(82), l = r(2), f = l.process, h = l.setImmediate, d = l.clearImmediate, p = l.MessageChannel, v = l.Dispatch, m = 0, g = {}, b = function() {
                var t = +this;
                if (g.hasOwnProperty(t)) {
                    var e = g[t];
                    delete g[t], e();
                }
            }, x = function(t) {
                b.call(t.data);
            };
            h && d || (h = function(t) {
                for(var e = [], r = 1; arguments.length > r;)e.push(arguments[r++]);
                return g[++m] = function() {
                    c("function" == typeof t ? t : Function(t), e);
                }, n(m), m;
            }, d = function(t) {
                delete g[t];
            }, "process" == r(26)(f) ? n = function(t) {
                f.nextTick(a(b, t, 1));
            } : v && v.now ? n = function(t) {
                v.now(a(b, t, 1));
            } : p ? (i = (o = new p).port2, o.port1.onmessage = x, n = a(i.postMessage, i, 1)) : l.addEventListener && "function" == typeof postMessage && !l.importScripts ? (n = function(t) {
                l.postMessage(t + "", "*");
            }, l.addEventListener("message", x, !1)) : n = "onreadystatechange" in s("script") ? function(t) {
                u.appendChild(s("script")).onreadystatechange = function() {
                    u.removeChild(this), b.call(t);
                };
            } : function(t) {
                setTimeout(a(b, t, 1), 0);
            }), t.exports = {
                set: h,
                clear: d
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(2), o = r(9), i = r(33), a = r(69), c = r(15), u = r(49), s = r(3), l = r(48), f = r(20), h = r(7), d = r(156), p = r(37).f, v = r(10).f, m = r(101), g = r(44), b = n.ArrayBuffer, x = n.DataView, y = n.Math, _ = n.RangeError, w = n.Infinity, S = b, M = y.abs, T = y.pow, I = y.floor, D = y.log, E = y.LN2, A = o ? "_b" : "buffer", C = o ? "_l" : "byteLength", z = o ? "_o" : "byteOffset";
            function O(t, e, r) {
                var n, o, i, a = new Array(r), c = 8 * r - e - 1, u = (1 << c) - 1, s = u >> 1, l = 23 === e ? T(2, -24) - T(2, -77) : 0, f = 0, h = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                for((t = M(t)) != t || t === w ? (o = t != t ? 1 : 0, n = u) : (n = I(D(t) / E), t * (i = T(2, -n)) < 1 && (n--, i *= 2), (t += n + s >= 1 ? l / i : l * T(2, 1 - s)) * i >= 2 && (n++, i /= 2), n + s >= u ? (o = 0, n = u) : n + s >= 1 ? (o = (t * i - 1) * T(2, e), n += s) : (o = t * T(2, s - 1) * T(2, e), n = 0)); e >= 8; a[f++] = 255 & o, o /= 256, e -= 8);
                for(n = n << e | o, c += e; c > 0; a[f++] = 255 & n, n /= 256, c -= 8);
                return a[--f] |= 128 * h, a;
            }
            function F(t, e, r) {
                var n, o = 8 * r - e - 1, i = (1 << o) - 1, a = i >> 1, c = o - 7, u = r - 1, s = t[u--], l = 127 & s;
                for(s >>= 7; c > 0; l = 256 * l + t[u], u--, c -= 8);
                for(n = l & (1 << -c) - 1, l >>= -c, c += e; c > 0; n = 256 * n + t[u], u--, c -= 8);
                if (0 === l) l = 1 - a;
                else {
                    if (l === i) return n ? NaN : s ? -w : w;
                    n += T(2, e), l -= a;
                }
                return (s ? -1 : 1) * n * T(2, l - e);
            }
            function R(t) {
                return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0];
            }
            function P(t) {
                return [
                    255 & t
                ];
            }
            function L(t) {
                return [
                    255 & t,
                    t >> 8 & 255
                ];
            }
            function k(t) {
                return [
                    255 & t,
                    t >> 8 & 255,
                    t >> 16 & 255,
                    t >> 24 & 255
                ];
            }
            function j(t) {
                return O(t, 52, 8);
            }
            function U(t) {
                return O(t, 23, 4);
            }
            function B(t, e, r) {
                v(t.prototype, e, {
                    get: function() {
                        return this[r];
                    }
                });
            }
            function N(t, e, r, n) {
                var o = d(+r);
                if (o + e > t[C]) throw _("Wrong index!");
                var i = t[A]._b, a = o + t[z], c = i.slice(a, a + e);
                return n ? c : c.reverse();
            }
            function G(t, e, r, n, o, i) {
                var a = d(+r);
                if (a + e > t[C]) throw _("Wrong index!");
                for(var c = t[A]._b, u = a + t[z], s = n(+o), l = 0; l < e; l++)c[u + l] = s[i ? l : e - l - 1];
            }
            if (a.ABV) {
                if (!s(function() {
                    b(1);
                }) || !s(function() {
                    new b(-1);
                }) || s(function() {
                    return new b, new b(1.5), new b(NaN), "ArrayBuffer" != b.name;
                })) {
                    for(var V, q = (b = function(t) {
                        return l(this, b), new S(d(t));
                    }).prototype = S.prototype, Y = p(S), H = 0; Y.length > H;)(V = Y[H++]) in b || c(b, V, S[V]);
                    i || (q.constructor = b);
                }
                var W = new x(new b(2)), X = x.prototype.setInt8;
                W.setInt8(0, 2147483648), W.setInt8(1, 2147483649), !W.getInt8(0) && W.getInt8(1) || u(x.prototype, {
                    setInt8: function(t, e) {
                        X.call(this, t, e << 24 >> 24);
                    },
                    setUint8: function(t, e) {
                        X.call(this, t, e << 24 >> 24);
                    }
                }, !0);
            } else b = function(t) {
                l(this, b, "ArrayBuffer");
                var e = d(t);
                this._b = m.call(new Array(e), 0), this[C] = e;
            }, x = function(t, e, r) {
                l(this, x, "DataView"), l(t, b, "DataView");
                var n = t[C], o = f(e);
                if (o < 0 || o > n) throw _("Wrong offset!");
                if (o + (r = void 0 === r ? n - o : h(r)) > n) throw _("Wrong length!");
                this[A] = t, this[z] = o, this[C] = r;
            }, o && (B(b, "byteLength", "_l"), B(x, "buffer", "_b"), B(x, "byteLength", "_l"), B(x, "byteOffset", "_o")), u(x.prototype, {
                getInt8: function(t) {
                    return N(this, 1, t)[0] << 24 >> 24;
                },
                getUint8: function(t) {
                    return N(this, 1, t)[0];
                },
                getInt16: function(t) {
                    var e = N(this, 2, t, arguments[1]);
                    return (e[1] << 8 | e[0]) << 16 >> 16;
                },
                getUint16: function(t) {
                    var e = N(this, 2, t, arguments[1]);
                    return e[1] << 8 | e[0];
                },
                getInt32: function(t) {
                    return R(N(this, 4, t, arguments[1]));
                },
                getUint32: function(t) {
                    return R(N(this, 4, t, arguments[1])) >>> 0;
                },
                getFloat32: function(t) {
                    return F(N(this, 4, t, arguments[1]), 23, 4);
                },
                getFloat64: function(t) {
                    return F(N(this, 8, t, arguments[1]), 52, 8);
                },
                setInt8: function(t, e) {
                    G(this, 1, t, P, e);
                },
                setUint8: function(t, e) {
                    G(this, 1, t, P, e);
                },
                setInt16: function(t, e) {
                    G(this, 2, t, L, e, arguments[2]);
                },
                setUint16: function(t, e) {
                    G(this, 2, t, L, e, arguments[2]);
                },
                setInt32: function(t, e) {
                    G(this, 4, t, k, e, arguments[2]);
                },
                setUint32: function(t, e) {
                    G(this, 4, t, k, e, arguments[2]);
                },
                setFloat32: function(t, e) {
                    G(this, 4, t, U, e, arguments[2]);
                },
                setFloat64: function(t, e) {
                    G(this, 8, t, j, e, arguments[2]);
                }
            });
            g(b, "ArrayBuffer"), g(x, "DataView"), c(x.prototype, a.VIEW, !0), e.ArrayBuffer = b, e.DataView = x;
        },
        function(t, e) {
            var r = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
            "number" == typeof __g && (__g = r);
        },
        function(t, e) {
            t.exports = function(t) {
                return "object" == typeof t ? null !== t : "function" == typeof t;
            };
        },
        function(t, e, r) {
            t.exports = !r(161)(function() {
                return 7 != Object.defineProperty({}, "a", {
                    get: function() {
                        return 7;
                    }
                }).a;
            });
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nuniform mat4 u_ModelViewProjectionMatrix;attribute vec4 a_Vertex;attribute vec4 a_TexCoord;varying vec4 coord;void main(){coord=a_TexCoord;gl_Position=u_ModelViewProjectionMatrix*a_Vertex;}";
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nuniform mat3 distortionMatrix;attribute vec4 a_TexCoord;attribute vec4 a_Distortion;attribute vec4 a_Delta;varying vec4 coord;varying vec4 compositeCoord;varying vec2 distortionCoord;uniform mat4 viewMatrix;uniform float distortion_amount;uniform float distortion_horizontal;uniform float distortion_vertical;uniform vec2 textureSize;const vec2 j=vec2(.5);const vec2 e=vec2(0.,.5);void main(){vec4 f=a_Distortion+vec4(a_Delta.xy,0.,0.);vec3 k=distortionMatrix*vec3(f.xy,1.);f.xy=k.xy/k.z;coord=viewMatrix*f*.5+.5;compositeCoord=a_TexCoord;float l=length(textureSize);vec2 m=.4/l*textureSize;vec2 o=vec2(distortion_horizontal,distortion_vertical);vec2 n=1.-step(0.,o);vec2 g,a;float c,d;float h=1.;float i=1.;vec2 b=abs(n-compositeCoord.xy);if(distortion_horizontal!=0.){a=b-e.xy;g=1.-abs(distortion_horizontal)*m;a=mix(a,a*g,vec2(1.,a.x));b=a+e.xy;}if(distortion_vertical!=0.){a=b-e.yx;g=1.-abs(distortion_vertical)*m;a=mix(a,a*g,vec2(a.y,1.));b=a+e.yx;}b=abs(n-b)-j;if(distortion_amount<0.){d=l/(distortion_amount*-4.);c=max(length(b*textureSize)/d,1e-4);h=atan(c)/c;c=max(-.5*textureSize.x,-.5*textureSize.y)/d;i=atan(c)/c;}if(distortion_amount>0.){c=dot(b,b)*.5625;d=distortion_amount*2.;h=1.+c*d;i=1.+.5*.5625*d;}distortionCoord=h*b/i+j;gl_Position=viewMatrix*f;}";
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = r(70), o = r(480), i = function() {
                function t(t, e) {
                    this._rgb = t, this._population = e;
                }
                return t.applyFilter = function(t, e) {
                    return "function" == typeof e ? o(t, function(t) {
                        var r = t.r, n = t.g, o = t.b;
                        return e(r, n, o, 255);
                    }) : t;
                }, Object.defineProperty(t.prototype, "r", {
                    get: function() {
                        return this._rgb[0];
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t.prototype, "g", {
                    get: function() {
                        return this._rgb[1];
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t.prototype, "b", {
                    get: function() {
                        return this._rgb[2];
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t.prototype, "rgb", {
                    get: function() {
                        return this._rgb;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t.prototype, "hsl", {
                    get: function() {
                        if (!this._hsl) {
                            var t = this._rgb, e = t[0], r = t[1], o = t[2];
                            this._hsl = n.rgbToHsl(e, r, o);
                        }
                        return this._hsl;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t.prototype, "hex", {
                    get: function() {
                        if (!this._hex) {
                            var t = this._rgb, e = t[0], r = t[1], o = t[2];
                            this._hex = n.rgbToHex(e, r, o);
                        }
                        return this._hex;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t.prototype, "population", {
                    get: function() {
                        return this._population;
                    },
                    enumerable: !0,
                    configurable: !0
                }), t.prototype.toJSON = function() {
                    return {
                        rgb: this.rgb,
                        population: this.population
                    };
                }, t.prototype.getRgb = function() {
                    return this._rgb;
                }, t.prototype.getHsl = function() {
                    return this.hsl;
                }, t.prototype.getPopulation = function() {
                    return this._population;
                }, t.prototype.getHex = function() {
                    return this.hex;
                }, t.prototype.getYiq = function() {
                    if (!this._yiq) {
                        var t = this._rgb;
                        this._yiq = (299 * t[0] + 587 * t[1] + 114 * t[2]) / 1e3;
                    }
                    return this._yiq;
                }, Object.defineProperty(t.prototype, "titleTextColor", {
                    get: function() {
                        return this._titleTextColor || (this._titleTextColor = this.getYiq() < 200 ? "#fff" : "#000"), this._titleTextColor;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t.prototype, "bodyTextColor", {
                    get: function() {
                        return this._bodyTextColor || (this._bodyTextColor = this.getYiq() < 150 ? "#fff" : "#000"), this._bodyTextColor;
                    },
                    enumerable: !0,
                    configurable: !0
                }), t.prototype.getTitleTextColor = function() {
                    return this.titleTextColor;
                }, t.prototype.getBodyTextColor = function() {
                    return this.bodyTextColor;
                }, t;
            }();
            e.Swatch = i;
        },
        function(t, e, r) {
            (function(t) {
                var n = r(24), o = r(490), i = e && !e.nodeType && e, a = i && "object" == typeof t && t && !t.nodeType && t, c = a && a.exports === i ? n.Buffer : void 0, u = (c ? c.isBuffer : void 0) || o;
                t.exports = u;
            }).call(this, r(71)(t));
        },
        function(t, e) {
            var r = /^(?:0|[1-9]\d*)$/;
            t.exports = function(t, e) {
                var n = typeof t;
                return !!(e = null == e ? 9007199254740991 : e) && ("number" == n || "symbol" != n && r.test(t)) && t > -1 && t % 1 == 0 && t < e;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return function(e) {
                    return t(e);
                };
            };
        },
        function(t, e, r) {
            (function(t) {
                var n = r(172), o = e && !e.nodeType && e, i = o && "object" == typeof t && t && !t.nodeType && t, a = i && i.exports === o && n.process, c = function() {
                    try {
                        var t = i && i.require && i.require("util").types;
                        return t || a && a.binding && a.binding("util");
                    } catch (t) {}
                }();
                t.exports = c;
            }).call(this, r(71)(t));
        },
        function(t, e) {
            var r = Object.prototype;
            t.exports = function(t) {
                var e = t && t.constructor;
                return t === ("function" == typeof e && e.prototype || r);
            };
        },
        function(t, e, r) {
            var n = r(73), o = r(503), i = r(504), a = r(505), c = r(506), u = r(507);
            function s(t) {
                var e = this.__data__ = new n(t);
                this.size = e.size;
            }
            s.prototype.clear = o, s.prototype.delete = i, s.prototype.get = a, s.prototype.has = c, s.prototype.set = u, t.exports = s;
        },
        function(t, e, r) {
            var n = r(43)(r(24), "Map");
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(512), o = r(519), i = r(521), a = r(522), c = r(523);
            function u(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            u.prototype.clear = n, u.prototype.delete = o, u.prototype.get = i, u.prototype.has = a, u.prototype.set = c, t.exports = u;
        },
        function(t, e, r) {
            var n = r(169), o = r(183), i = Object.prototype.propertyIsEnumerable, a = Object.getOwnPropertySymbols, c = a ? function(t) {
                return null == t ? [] : (t = Object(t), n(a(t), function(e) {
                    return i.call(t, e);
                }));
            } : o;
            t.exports = c;
        },
        function(t, e, r) {
            var n = r(25), o = r(124), i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, a = /^\w*$/;
            t.exports = function(t, e) {
                if (n(t)) return !1;
                var r = typeof t;
                return !("number" != r && "symbol" != r && "boolean" != r && null != t && !o(t)) || a.test(t) || !i.test(t) || null != e && t in Object(e);
            };
        },
        function(t, e, r) {
            var n = r(55), o = r(41);
            t.exports = function(t) {
                return "symbol" == typeof t || o(t) && "[object Symbol]" == n(t);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t;
            };
        },
        function(t, e, r) {
            var n = r(170), o = r(559), i = r(72);
            t.exports = function(t) {
                return i(t) ? n(t, !0) : o(t);
            };
        },
        function(t, e, r) {
            var n = r(179);
            t.exports = function(t) {
                var e = new t.constructor(t.byteLength);
                return new n(e).set(new n(t)), e;
            };
        },
        function(t, e, r) {
            var n;
            !function(r) {
                "use strict";
                var o = {
                    s: 1,
                    n: 0,
                    d: 1
                };
                function i(t) {
                    function e() {
                        var e = Error.apply(this, arguments);
                        e.name = this.name = t, this.stack = e.stack, this.message = e.message;
                    }
                    function r() {}
                    return r.prototype = Error.prototype, e.prototype = new r, e;
                }
                var a = h.DivisionByZero = i("DivisionByZero"), c = h.InvalidParameter = i("InvalidParameter");
                function u(t, e) {
                    return isNaN(t = parseInt(t, 10)) && s(), t * e;
                }
                function s() {
                    throw new c;
                }
                var l = function(t, e) {
                    var r, n = 0, i = 1, c = 1, l = 0, f = 0, h = 0, d = 1, p = 1, v = 0, m = 1, g = 1, b = 1, x = 1e7;
                    if (null == t) ;
                    else if (void 0 !== e) c = (n = t) * (i = e);
                    else switch(typeof t){
                        case "object":
                            "d" in t && "n" in t ? (n = t.n, i = t.d, "s" in t && (n *= t.s)) : 0 in t ? (n = t[0], 1 in t && (i = t[1])) : s(), c = n * i;
                            break;
                        case "number":
                            if (t < 0 && (c = t, t = -t), t % 1 == 0) n = t;
                            else if (t > 0) {
                                for(t >= 1 && (t /= p = Math.pow(10, Math.floor(1 + Math.log(t) / Math.LN10))); m <= x && b <= x;){
                                    if (t === (r = (v + g) / (m + b))) {
                                        m + b <= x ? (n = v + g, i = m + b) : b > m ? (n = g, i = b) : (n = v, i = m);
                                        break;
                                    }
                                    t > r ? (v += g, m += b) : (g += v, b += m), m > x ? (n = g, i = b) : (n = v, i = m);
                                }
                                n *= p;
                            } else (isNaN(t) || isNaN(e)) && (i = n = NaN);
                            break;
                        case "string":
                            if (null === (m = t.match(/\d+|./g)) && s(), "-" === m[v] ? (c = -1, v++) : "+" === m[v] && v++, m.length === v + 1 ? f = u(m[v++], c) : "." === m[v + 1] || "." === m[v] ? ("." !== m[v] && (l = u(m[v++], c)), (++v + 1 === m.length || "(" === m[v + 1] && ")" === m[v + 3] || "'" === m[v + 1] && "'" === m[v + 3]) && (f = u(m[v], c), d = Math.pow(10, m[v].length), v++), ("(" === m[v] && ")" === m[v + 2] || "'" === m[v] && "'" === m[v + 2]) && (h = u(m[v + 1], c), p = Math.pow(10, m[v + 1].length) - 1, v += 3)) : "/" === m[v + 1] || ":" === m[v + 1] ? (f = u(m[v], c), d = u(m[v + 2], 1), v += 3) : "/" === m[v + 3] && " " === m[v + 1] && (l = u(m[v], c), f = u(m[v + 2], c), d = u(m[v + 4], 1), v += 5), m.length <= v) {
                                c = n = h + (i = d * p) * l + p * f;
                                break;
                            }
                        default:
                            s();
                    }
                    if (0 === i) throw new a;
                    o.s = c < 0 ? -1 : 1, o.n = Math.abs(n), o.d = Math.abs(i);
                };
                function f(t, e) {
                    if (!t) return e;
                    if (!e) return t;
                    for(;;){
                        if (!(t %= e)) return e;
                        if (!(e %= t)) return t;
                    }
                }
                function h(t, e) {
                    if (!(this instanceof h)) return new h(t, e);
                    l(t, e), t = h.REDUCE ? f(o.d, o.n) : 1, this.s = o.s, this.n = o.n / t, this.d = o.d / t;
                }
                h.REDUCE = 1, h.prototype = {
                    s: 1,
                    n: 0,
                    d: 1,
                    abs: function() {
                        return new h(this.n, this.d);
                    },
                    neg: function() {
                        return new h(-this.s * this.n, this.d);
                    },
                    add: function(t, e) {
                        return l(t, e), new h(this.s * this.n * o.d + o.s * this.d * o.n, this.d * o.d);
                    },
                    sub: function(t, e) {
                        return l(t, e), new h(this.s * this.n * o.d - o.s * this.d * o.n, this.d * o.d);
                    },
                    mul: function(t, e) {
                        return l(t, e), new h(this.s * o.s * this.n * o.n, this.d * o.d);
                    },
                    div: function(t, e) {
                        return l(t, e), new h(this.s * o.s * this.n * o.d, this.d * o.n);
                    },
                    clone: function() {
                        return new h(this);
                    },
                    mod: function(t, e) {
                        return isNaN(this.n) || isNaN(this.d) ? new h(NaN) : void 0 === t ? new h(this.s * this.n % this.d, 1) : (l(t, e), 0 === o.n && 0 === this.d && h(0, 0), new h(this.s * (o.d * this.n) % (o.n * this.d), o.d * this.d));
                    },
                    gcd: function(t, e) {
                        return l(t, e), new h(f(o.n, this.n) * f(o.d, this.d), o.d * this.d);
                    },
                    lcm: function(t, e) {
                        return l(t, e), 0 === o.n && 0 === this.n ? new h : new h(o.n * this.n, f(o.n, this.n) * f(o.d, this.d));
                    },
                    ceil: function(t) {
                        return t = Math.pow(10, t || 0), isNaN(this.n) || isNaN(this.d) ? new h(NaN) : new h(Math.ceil(t * this.s * this.n / this.d), t);
                    },
                    floor: function(t) {
                        return t = Math.pow(10, t || 0), isNaN(this.n) || isNaN(this.d) ? new h(NaN) : new h(Math.floor(t * this.s * this.n / this.d), t);
                    },
                    round: function(t) {
                        return t = Math.pow(10, t || 0), isNaN(this.n) || isNaN(this.d) ? new h(NaN) : new h(Math.round(t * this.s * this.n / this.d), t);
                    },
                    inverse: function() {
                        return new h(this.s * this.d, this.n);
                    },
                    pow: function(t) {
                        return t < 0 ? new h(Math.pow(this.s * this.d, -t), Math.pow(this.n, -t)) : new h(Math.pow(this.s * this.n, t), Math.pow(this.d, t));
                    },
                    equals: function(t, e) {
                        return l(t, e), this.s * this.n * o.d == o.s * o.n * this.d;
                    },
                    compare: function(t, e) {
                        l(t, e);
                        var r = this.s * this.n * o.d - o.s * o.n * this.d;
                        return (0 < r) - (r < 0);
                    },
                    simplify: function(t) {
                        if (isNaN(this.n) || isNaN(this.d)) return this;
                        var e = this.abs().toContinued();
                        function r(t) {
                            return 1 === t.length ? new h(t[0]) : r(t.slice(1)).inverse().add(t[0]);
                        }
                        t = t || .001;
                        for(var n = 0; n < e.length; n++){
                            var o = r(e.slice(0, n + 1));
                            if (o.sub(this.abs()).abs().valueOf() < t) return o.mul(this.s);
                        }
                        return this;
                    },
                    divisible: function(t, e) {
                        return l(t, e), !(!(o.n * this.d) || this.n * o.d % (o.n * this.d));
                    },
                    valueOf: function() {
                        return this.s * this.n / this.d;
                    },
                    toFraction: function(t) {
                        var e, r = "", n = this.n, o = this.d;
                        return this.s < 0 && (r += "-"), 1 === o ? r += n : (t && (e = Math.floor(n / o)) > 0 && (r += e, r += " ", n %= o), r += n, r += "/", r += o), r;
                    },
                    toLatex: function(t) {
                        var e, r = "", n = this.n, o = this.d;
                        return this.s < 0 && (r += "-"), 1 === o ? r += n : (t && (e = Math.floor(n / o)) > 0 && (r += e, n %= o), r += "\\frac{", r += n, r += "}{", r += o, r += "}"), r;
                    },
                    toContinued: function() {
                        var t, e = this.n, r = this.d, n = [];
                        if (isNaN(this.n) || isNaN(this.d)) return n;
                        do n.push(Math.floor(e / r)), t = e % r, e = r, r = t;
                        while (1 !== e);
                        return n;
                    },
                    toString: function(t) {
                        var e, r = this.n, n = this.d;
                        if (isNaN(r) || isNaN(n)) return "NaN";
                        h.REDUCE || (r /= e = f(r, n), n /= e), t = t || 15;
                        var o = function(t, e) {
                            for(; e % 2 == 0; e /= 2);
                            for(; e % 5 == 0; e /= 5);
                            if (1 === e) return 0;
                            for(var r = 10 % e, n = 1; 1 !== r; n++)if (r = 10 * r % e, n > 2e3) return 0;
                            return n;
                        }(0, n), i = function(t, e, r) {
                            for(var n = 1, o = function(t, e, r) {
                                for(var n = 1; e > 0; t = t * t % r, e >>= 1)1 & e && (n = n * t % r);
                                return n;
                            }(10, r, e), i = 0; i < 300; i++){
                                if (n === o) return i;
                                n = 10 * n % e, o = 10 * o % e;
                            }
                            return 0;
                        }(0, n, o), a = -1 === this.s ? "-" : "";
                        if (a += r / n | 0, r %= n, (r *= 10) && (a += "."), o) {
                            for(var c = i; c--;)a += r / n | 0, r %= n, r *= 10;
                            a += "(";
                            for(c = o; c--;)a += r / n | 0, r %= n, r *= 10;
                            a += ")";
                        } else for(c = t; r && c--;)a += r / n | 0, r %= n, r *= 10;
                        return a;
                    }
                }, void 0 === (n = (function() {
                    return h;
                }).apply(e, [])) || (t.exports = n);
            }();
        },
        function(t, e, r) {
            t.exports = !r(9) && !r(3)(function() {
                return 7 != Object.defineProperty(r(82)("div"), "a", {
                    get: function() {
                        return 7;
                    }
                }).a;
            });
        },
        function(t, e, r) {
            var n = r(2), o = r(8), i = r(33), a = r(83), c = r(10).f;
            t.exports = function(t) {
                var e = o.Symbol || (o.Symbol = i ? {} : n.Symbol || {});
                "_" == t.charAt(0) || t in e || c(e, t, {
                    value: a.f(t)
                });
            };
        },
        function(t, e, r) {
            var n = r(14), o = r(16), i = r(59)(!1), a = r(84)("IE_PROTO");
            t.exports = function(t, e) {
                var r, c = o(t), u = 0, s = [];
                for(r in c)r != a && n(c, r) && s.push(r);
                for(; e.length > u;)n(c, r = e[u++]) && (~i(s, r) || s.push(r));
                return s;
            };
        },
        function(t, e, r) {
            var n = r(10), o = r(4), i = r(34);
            t.exports = r(9) ? Object.defineProperties : function(t, e) {
                o(t);
                for(var r, a = i(e), c = a.length, u = 0; c > u;)n.f(t, r = a[u++], e[r]);
                return t;
            };
        },
        function(t, e, r) {
            var n = r(16), o = r(37).f, i = {}.toString, a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
            t.exports.f = function(t) {
                return a && "[object Window]" == i.call(t) ? function(t) {
                    try {
                        return o(t);
                    } catch (t) {
                        return a.slice();
                    }
                }(t) : o(n(t));
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(9), o = r(34), i = r(60), a = r(51), c = r(11), u = r(50), s = Object.assign;
            t.exports = !s || r(3)(function() {
                var t = {}, e = {}, r = Symbol(), n = "abcdefghijklmnopqrst";
                return t[r] = 7, n.split("").forEach(function(t) {
                    e[t] = t;
                }), 7 != s({}, t)[r] || Object.keys(s({}, e)).join("") != n;
            }) ? function(t, e) {
                for(var r = c(t), s = arguments.length, l = 1, f = i.f, h = a.f; s > l;)for(var d, p = u(arguments[l++]), v = f ? o(p).concat(f(p)) : o(p), m = v.length, g = 0; m > g;)d = v[g++], n && !h.call(p, d) || (r[d] = p[d]);
                return r;
            } : s;
        },
        function(t, e) {
            t.exports = Object.is || function(t, e) {
                return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(19), o = r(5), i = r(137), a = [].slice, c = {}, u = function(t, e, r) {
                if (!(e in c)) {
                    for(var n = [], o = 0; o < e; o++)n[o] = "a[" + o + "]";
                    c[e] = Function("F,a", "return new F(" + n.join(",") + ")");
                }
                return c[e](t, r);
            };
            t.exports = Function.bind || function(t) {
                var e = n(this), r = a.call(arguments, 1), c = function() {
                    var n = r.concat(a.call(arguments));
                    return this instanceof c ? u(e, n.length, n) : i(e, n, t);
                };
                return o(e.prototype) && (c.prototype = e.prototype), c;
            };
        },
        function(t, e) {
            t.exports = function(t, e, r) {
                var n = void 0 === r;
                switch(e.length){
                    case 0:
                        return n ? t() : t.call(r);
                    case 1:
                        return n ? t(e[0]) : t.call(r, e[0]);
                    case 2:
                        return n ? t(e[0], e[1]) : t.call(r, e[0], e[1]);
                    case 3:
                        return n ? t(e[0], e[1], e[2]) : t.call(r, e[0], e[1], e[2]);
                    case 4:
                        return n ? t(e[0], e[1], e[2], e[3]) : t.call(r, e[0], e[1], e[2], e[3]);
                }
                return t.apply(r, e);
            };
        },
        function(t, e, r) {
            var n = r(2).parseInt, o = r(45).trim, i = r(88), a = /^[-+]?0[xX]/;
            t.exports = 8 !== n(i + "08") || 22 !== n(i + "0x16") ? function(t, e) {
                var r = o(String(t), 3);
                return n(r, e >>> 0 || (a.test(r) ? 16 : 10));
            } : n;
        },
        function(t, e, r) {
            var n = r(2).parseFloat, o = r(45).trim;
            t.exports = 1 / n(r(88) + "-0") != -1 / 0 ? function(t) {
                var e = o(String(t), 3), r = n(e);
                return 0 === r && "-" == e.charAt(0) ? -0 : r;
            } : n;
        },
        function(t, e, r) {
            var n = r(26);
            t.exports = function(t, e) {
                if ("number" != typeof t && "Number" != n(t)) throw TypeError(e);
                return +t;
            };
        },
        function(t, e, r) {
            var n = r(5), o = Math.floor;
            t.exports = function(t) {
                return !n(t) && isFinite(t) && o(t) === t;
            };
        },
        function(t, e) {
            t.exports = Math.log1p || function(t) {
                return (t = +t) > -0.00000001 && t < 1e-8 ? t - t * t / 2 : Math.log(1 + t);
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(36), o = r(31), i = r(44), a = {};
            r(15)(a, r(6)("iterator"), function() {
                return this;
            }), t.exports = function(t, e, r) {
                t.prototype = n(a, {
                    next: o(1, r)
                }), i(t, e + " Iterator");
            };
        },
        function(t, e, r) {
            var n = r(4);
            t.exports = function(t, e, r, o) {
                try {
                    return o ? e(n(r)[0], r[1]) : e(r);
                } catch (e) {
                    var i = t.return;
                    throw void 0 !== i && n(i.call(t)), e;
                }
            };
        },
        function(t, e, r) {
            var n = r(302);
            t.exports = function(t, e) {
                return new (n(t))(e);
            };
        },
        function(t, e, r) {
            var n = r(19), o = r(11), i = r(50), a = r(7);
            t.exports = function(t, e, r, c, u) {
                n(e);
                var s = o(t), l = i(s), f = a(s.length), h = u ? f - 1 : 0, d = u ? -1 : 1;
                if (r < 2) for(;;){
                    if (h in l) {
                        c = l[h], h += d;
                        break;
                    }
                    if (h += d, u ? h < 0 : f <= h) throw TypeError("Reduce of empty array with no initial value");
                }
                for(; u ? h >= 0 : f > h; h += d)h in l && (c = e(c, l[h], h, s));
                return c;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(11), o = r(35), i = r(7);
            t.exports = [].copyWithin || function(t, e) {
                var r = n(this), a = i(r.length), c = o(t, a), u = o(e, a), s = arguments.length > 2 ? arguments[2] : void 0, l = Math.min((void 0 === s ? a : o(s, a)) - u, a - c), f = 1;
                for(u < c && c < u + l && (f = -1, u += l - 1, c += l - 1); l-- > 0;)u in r ? r[c] = r[u] : delete r[c], c += f, u += f;
                return r;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return {
                    value: e,
                    done: !!t
                };
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(103);
            r(0)({
                target: "RegExp",
                proto: !0,
                forced: n !== /./.exec
            }, {
                exec: n
            });
        },
        function(t, e, r) {
            r(9) && "g" != /./g.flags && r(10).f(RegExp.prototype, "flags", {
                configurable: !0,
                get: r(63)
            });
        },
        function(t, e, r) {
            "use strict";
            var n, o, i, a, c = r(33), u = r(2), s = r(18), l = r(52), f = r(0), h = r(5), d = r(19), p = r(48), v = r(66), m = r(53), g = r(105).set, b = r(322)(), x = r(152), y = r(323), _ = r(67), w = r(153), S = u.TypeError, M = u.process, T = M && M.versions, I = T && T.v8 || "", D = u.Promise, E = "process" == l(M), A = function() {}, C = o = x.f, z = !!function() {
                try {
                    var t = D.resolve(1), e = (t.constructor = {})[r(6)("species")] = function(t) {
                        t(A, A);
                    };
                    return (E || "function" == typeof PromiseRejectionEvent) && t.then(A) instanceof e && 0 !== I.indexOf("6.6") && -1 === _.indexOf("Chrome/66");
                } catch (t) {}
            }(), O = function(t) {
                var e;
                return !(!h(t) || "function" != typeof (e = t.then)) && e;
            }, F = function(t, e) {
                if (!t._n) {
                    t._n = !0;
                    var r = t._c;
                    b(function() {
                        for(var n = t._v, o = 1 == t._s, i = 0, a = function(e) {
                            var r, i, a, c = o ? e.ok : e.fail, u = e.resolve, s = e.reject, l = e.domain;
                            try {
                                c ? (o || (2 == t._h && L(t), t._h = 1), !0 === c ? r = n : (l && l.enter(), r = c(n), l && (l.exit(), a = !0)), r === e.promise ? s(S("Promise-chain cycle")) : (i = O(r)) ? i.call(r, u, s) : u(r)) : s(n);
                            } catch (t) {
                                l && !a && l.exit(), s(t);
                            }
                        }; r.length > i;)a(r[i++]);
                        t._c = [], t._n = !1, e && !t._h && R(t);
                    });
                }
            }, R = function(t) {
                g.call(u, function() {
                    var e, r, n, o = t._v, i = P(t);
                    if (i && (e = y(function() {
                        E ? M.emit("unhandledRejection", o, t) : (r = u.onunhandledrejection) ? r({
                            promise: t,
                            reason: o
                        }) : (n = u.console) && n.error && n.error("Unhandled promise rejection", o);
                    }), t._h = E || P(t) ? 2 : 1), t._a = void 0, i && e.e) throw e.v;
                });
            }, P = function(t) {
                return 1 !== t._h && 0 === (t._a || t._c).length;
            }, L = function(t) {
                g.call(u, function() {
                    var e;
                    E ? M.emit("rejectionHandled", t) : (e = u.onrejectionhandled) && e({
                        promise: t,
                        reason: t._v
                    });
                });
            }, k = function(t) {
                var e = this;
                e._d || (e._d = !0, (e = e._w || e)._v = t, e._s = 2, e._a || (e._a = e._c.slice()), F(e, !0));
            }, j = function(t) {
                var e, r = this;
                if (!r._d) {
                    r._d = !0, r = r._w || r;
                    try {
                        if (r === t) throw S("Promise can't be resolved itself");
                        (e = O(t)) ? b(function() {
                            var n = {
                                _w: r,
                                _d: !1
                            };
                            try {
                                e.call(t, s(j, n, 1), s(k, n, 1));
                            } catch (t) {
                                k.call(n, t);
                            }
                        }) : (r._v = t, r._s = 1, F(r, !1));
                    } catch (t) {
                        k.call({
                            _w: r,
                            _d: !1
                        }, t);
                    }
                }
            };
            z || (D = function(t) {
                p(this, D, "Promise", "_h"), d(t), n.call(this);
                try {
                    t(s(j, this, 1), s(k, this, 1));
                } catch (t) {
                    k.call(this, t);
                }
            }, (n = function(t) {
                this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
            }).prototype = r(49)(D.prototype, {
                then: function(t, e) {
                    var r = C(m(this, D));
                    return r.ok = "function" != typeof t || t, r.fail = "function" == typeof e && e, r.domain = E ? M.domain : void 0, this._c.push(r), this._a && this._a.push(r), this._s && F(this, !1), r.promise;
                },
                catch: function(t) {
                    return this.then(void 0, t);
                }
            }), i = function() {
                var t = new n;
                this.promise = t, this.resolve = s(j, t, 1), this.reject = s(k, t, 1);
            }, x.f = C = function(t) {
                return t === D || t === a ? new i(t) : o(t);
            }), f(f.G + f.W + f.F * !z, {
                Promise: D
            }), r(44)(D, "Promise"), r(47)("Promise"), a = r(8).Promise, f(f.S + f.F * !z, "Promise", {
                reject: function(t) {
                    var e = C(this);
                    return (0, e.reject)(t), e.promise;
                }
            }), f(f.S + f.F * (c || !z), "Promise", {
                resolve: function(t) {
                    return w(c && this === a ? D : this, t);
                }
            }), f(f.S + f.F * !(z && r(62)(function(t) {
                D.all(t).catch(A);
            })), "Promise", {
                all: function(t) {
                    var e = this, r = C(e), n = r.resolve, o = r.reject, i = y(function() {
                        var r = [], i = 0, a = 1;
                        v(t, !1, function(t) {
                            var c = i++, u = !1;
                            r.push(void 0), a++, e.resolve(t).then(function(t) {
                                u || (u = !0, r[c] = t, --a || n(r));
                            }, o);
                        }), --a || n(r);
                    });
                    return i.e && o(i.v), r.promise;
                },
                race: function(t) {
                    var e = this, r = C(e), n = r.reject, o = y(function() {
                        v(t, !1, function(t) {
                            e.resolve(t).then(r.resolve, n);
                        });
                    });
                    return o.e && n(o.v), r.promise;
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(19);
            function o(t) {
                var e, r;
                this.promise = new t(function(t, n) {
                    if (void 0 !== e || void 0 !== r) throw TypeError("Bad Promise constructor");
                    e = t, r = n;
                }), this.resolve = n(e), this.reject = n(r);
            }
            t.exports.f = function(t) {
                return new o(t);
            };
        },
        function(t, e, r) {
            var n = r(4), o = r(5), i = r(152);
            t.exports = function(t, e) {
                if (n(t), o(e) && e.constructor === t) return e;
                var r = i.f(t);
                return (0, r.resolve)(e), r.promise;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(10).f, o = r(36), i = r(49), a = r(18), c = r(48), u = r(66), s = r(94), l = r(148), f = r(47), h = r(9), d = r(30).fastKey, p = r(40), v = h ? "_s" : "size", m = function(t, e) {
                var r, n = d(e);
                if ("F" !== n) return t._i[n];
                for(r = t._f; r; r = r.n)if (r.k == e) return r;
            };
            t.exports = {
                getConstructor: function(t, e, r, s) {
                    var l = t(function(t, n) {
                        c(t, l, e, "_i"), t._t = e, t._i = o(null), t._f = void 0, t._l = void 0, t[v] = 0, null != n && u(n, r, t[s], t);
                    });
                    return i(l.prototype, {
                        clear: function() {
                            for(var t = p(this, e), r = t._i, n = t._f; n; n = n.n)n.r = !0, n.p && (n.p = n.p.n = void 0), delete r[n.i];
                            t._f = t._l = void 0, t[v] = 0;
                        },
                        delete: function(t) {
                            var r = p(this, e), n = m(r, t);
                            if (n) {
                                var o = n.n, i = n.p;
                                delete r._i[n.i], n.r = !0, i && (i.n = o), o && (o.p = i), r._f == n && (r._f = o), r._l == n && (r._l = i), r[v]--;
                            }
                            return !!n;
                        },
                        forEach: function(t) {
                            p(this, e);
                            for(var r, n = a(t, arguments.length > 1 ? arguments[1] : void 0, 3); r = r ? r.n : this._f;)for(n(r.v, r.k, this); r && r.r;)r = r.p;
                        },
                        has: function(t) {
                            return !!m(p(this, e), t);
                        }
                    }), h && n(l.prototype, "size", {
                        get: function() {
                            return p(this, e)[v];
                        }
                    }), l;
                },
                def: function(t, e, r) {
                    var n, o, i = m(t, e);
                    return i ? i.v = r : (t._l = i = {
                        i: o = d(e, !0),
                        k: e,
                        v: r,
                        p: n = t._l,
                        n: void 0,
                        r: !1
                    }, t._f || (t._f = i), n && (n.n = i), t[v]++, "F" !== o && (t._i[o] = i)), t;
                },
                getEntry: m,
                setStrong: function(t, e, r) {
                    s(t, e, function(t, r) {
                        this._t = p(t, e), this._k = r, this._l = void 0;
                    }, function() {
                        for(var t = this._k, e = this._l; e && e.r;)e = e.p;
                        return this._t && (this._l = e = e ? e.n : this._t._f) ? l(0, "keys" == t ? e.k : "values" == t ? e.v : [
                            e.k,
                            e.v
                        ]) : (this._t = void 0, l(1));
                    }, r ? "entries" : "values", !r, !0), f(e);
                }
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(49), o = r(30).getWeak, i = r(4), a = r(5), c = r(48), u = r(66), s = r(23), l = r(14), f = r(40), h = s(5), d = s(6), p = 0, v = function(t) {
                return t._l || (t._l = new m);
            }, m = function() {
                this.a = [];
            }, g = function(t, e) {
                return h(t.a, function(t) {
                    return t[0] === e;
                });
            };
            m.prototype = {
                get: function(t) {
                    var e = g(this, t);
                    if (e) return e[1];
                },
                has: function(t) {
                    return !!g(this, t);
                },
                set: function(t, e) {
                    var r = g(this, t);
                    r ? r[1] = e : this.a.push([
                        t,
                        e
                    ]);
                },
                delete: function(t) {
                    var e = d(this.a, function(e) {
                        return e[0] === t;
                    });
                    return ~e && this.a.splice(e, 1), !!~e;
                }
            }, t.exports = {
                getConstructor: function(t, e, r, i) {
                    var s = t(function(t, n) {
                        c(t, s, e, "_i"), t._t = e, t._i = p++, t._l = void 0, null != n && u(n, r, t[i], t);
                    });
                    return n(s.prototype, {
                        delete: function(t) {
                            if (!a(t)) return !1;
                            var r = o(t);
                            return !0 === r ? v(f(this, e)).delete(t) : r && l(r, this._i) && delete r[this._i];
                        },
                        has: function(t) {
                            if (!a(t)) return !1;
                            var r = o(t);
                            return !0 === r ? v(f(this, e)).has(t) : r && l(r, this._i);
                        }
                    }), s;
                },
                def: function(t, e, r) {
                    var n = o(i(e), !0);
                    return !0 === n ? v(t).set(e, r) : n[t._i] = r, t;
                },
                ufstore: v
            };
        },
        function(t, e, r) {
            var n = r(20), o = r(7);
            t.exports = function(t) {
                if (void 0 === t) return 0;
                var e = n(t), r = o(e);
                if (e !== r) throw RangeError("Wrong length!");
                return r;
            };
        },
        function(t, e, r) {
            var n = r(37), o = r(60), i = r(4), a = r(2).Reflect;
            t.exports = a && a.ownKeys || function(t) {
                var e = n.f(i(t)), r = o.f;
                return r ? e.concat(r(t)) : e;
            };
        },
        function(t, e, r) {
            var n = r(7), o = r(90), i = r(27);
            t.exports = function(t, e, r, a) {
                var c = String(i(t)), u = c.length, s = void 0 === r ? " " : String(r), l = n(e);
                if (l <= u || "" == s) return c;
                var f = l - u, h = o.call(s, Math.ceil(f / s.length));
                return h.length > f && (h = h.slice(0, f)), a ? h + c : c + h;
            };
        },
        function(t, e, r) {
            var n = r(9), o = r(34), i = r(16), a = r(51).f;
            t.exports = function(t) {
                return function(e) {
                    for(var r, c = i(e), u = o(c), s = u.length, l = 0, f = []; s > l;)r = u[l++], n && !a.call(c, r) || f.push(t ? [
                        r,
                        c[r]
                    ] : c[r]);
                    return f;
                };
            };
        },
        function(t, e) {
            var r = t.exports = {
                version: "2.6.11"
            };
            "number" == typeof __e && (__e = r);
        },
        function(t, e) {
            t.exports = function(t) {
                try {
                    return !!t();
                } catch (t) {
                    return !0;
                }
            };
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nuniform mat4 u_ModelViewProjectionMatrix;attribute vec4 a_Vertex;void main(){gl_Position=u_ModelViewProjectionMatrix*a_Vertex;}";
        },
        function(t, e, r) {
            var n = {
                "./adjustments.frag": 164,
                "./adjustments_v2.frag": 165,
                "./basic.frag": 403,
                "./blur.frag": 404,
                "./blur_composite.frag": 405,
                "./blur_mask.frag": 406,
                "./border.frag": 407,
                "./box_blur.frag": 408,
                "./color_cursor.frag": 166,
                "./combine.frag": 409,
                "./compute_a.frag": 410,
                "./compute_b.frag": 411,
                "./darkchannel_1.frag": 412,
                "./darkchannel_2.frag": 413,
                "./denoise.frag": 414,
                "./denoise_nlm1.frag": 415,
                "./denoise_nlm2.frag": 416,
                "./display.frag": 417,
                "./display_multitexture.frag": 418,
                "./distortion.frag": 419,
                "./distortion_map.frag": 420,
                "./distortion_multitexture.frag": 421,
                "./face.frag": 422,
                "./fill.frag": 423,
                "./helpers/blend_modes.frag": 424,
                "./layer.frag": 425,
                "./legacy/blur_nlm1.frag": 426,
                "./legacy/blur_nlm2.frag": 427,
                "./legacy/clarity.frag": 428,
                "./legacy/contrast.frag": 429,
                "./legacy/curves.frag": 430,
                "./legacy/dehaze.frag": 431,
                "./legacy/dehaze_map_2.frag": 432,
                "./legacy/dehaze_map_min1.frag": 433,
                "./legacy/dehaze_map_min2.frag": 434,
                "./legacy/denoise.frag": 435,
                "./legacy/denoise_nlm.frag": 436,
                "./legacy/diffuse.frag": 437,
                "./legacy/exposure.frag": 438,
                "./legacy/grain.frag": 439,
                "./legacy/hsl.frag": 440,
                "./legacy/invert.frag": 441,
                "./legacy/lens_blur.frag": 442,
                "./legacy/mosaic.frag": 443,
                "./legacy/out_multitexture.frag": 444,
                "./legacy/paint.frag": 445,
                "./legacy/saturation_vibrance.frag": 446,
                "./legacy/shadows_highlights.frag": 447,
                "./legacy/sharpen.frag": 448,
                "./legacy/split_tone.frag": 449,
                "./legacy/temperature.frag": 450,
                "./legacy/vignette.frag": 451,
                "./legacy/white_balance.frag": 452,
                "./legacy/whites_blacks.frag": 453,
                "./line.frag": 167,
                "./lookup_export_filter.frag": 454,
                "./lookup_table.frag": 455,
                "./mask_brush.frag": 456,
                "./mask_color.frag": 457,
                "./mask_depth.frag": 458,
                "./mask_gradient.frag": 459,
                "./mask_luminance.frag": 460,
                "./mask_object.frag": 461,
                "./mask_radial.frag": 462,
                "./mul.frag": 463,
                "./out.frag": 464,
                "./overlay.frag": 465,
                "./render_channel.frag": 466,
                "./resample.frag": 467,
                "./rotation_blur.frag": 468,
                "./screen.frag": 469,
                "./spot_heal.frag": 470,
                "./spot_heal_mask.frag": 471,
                "./spot_heal_multitexture.frag": 472,
                "./strip_alpha.frag": 473,
                "./text_layer.frag": 474,
                "./watermark.frag": 475,
                "./zoom_blur.frag": 476
            };
            function o(t) {
                var e = i(t);
                return r(e);
            }
            function i(t) {
                if (!r.o(n, t)) {
                    var e = new Error("Cannot find module '" + t + "'");
                    throw e.code = "MODULE_NOT_FOUND", e;
                }
                return n[t];
            }
            o.keys = function() {
                return Object.keys(n);
            }, o.resolve = i, t.exports = o, o.id = 163;
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;precision lowp sampler2D;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;varying vec4 compositeCoord;uniform sampler2D texture;uniform sampler2D dehazeTexture;uniform sampler2D curvesTexture;uniform sampler2D hslTexture;uniform sampler2D lookupTexture;uniform sampler2D grainTexture;uniform vec4 crop;uniform vec2 grainTextureSize;uniform vec2 textureSize;uniform float textureScale;uniform float lutSize;uniform mat4 rotationMatrix;uniform mat3 distortionMatrix;uniform float sharpen;uniform float diffuse;uniform float clarity;uniform float dehaze;uniform float whites;uniform float blacks;uniform float shadows;uniform float highlights;uniform float exposure;uniform float gamma;uniform float temperature;uniform float tint;uniform float contrast;uniform float saturation;uniform float vibrance;uniform float highlights_hue;uniform float highlights_saturation;uniform float shadows_hue;uniform float shadows_saturation;uniform float balance;uniform float vignette_feather;uniform float vignette_amount;uniform float vignette_highlights;uniform float vignette_roundness;uniform float vignette_size;uniform vec2 vignette_center;uniform float invert;uniform float lookup_intensity;uniform float grain_highlights;uniform float grain_amount;uniform float grain_size;uniform float grain_roughness;uniform bool render_curves;uniform bool render_hsl;uniform bool render_lut;const vec3 B=vec3(.95047,1.,1.08883);const vec3 v=vec3(.96422,1.,.82521);const mat3 m=mat3(.8951,-.7502,.0389,.2664,1.7135,-.0685,-.1614,.0367,1.0296);const mat3 C=mat3(.986993,.432305,-.008529,-.147054,.51836,.040043,.159963,.049291,.968487);const mat3 K=mat3(.412456,.212673,.019334,.357576,.715152,.119192,.180437,.072175,.950304);const mat3 L=mat3(3.240454,-.969266,.055643,-1.537139,1.876011,-.204026,-.498531,.041556,1.057225);const mat3 t=mat3(.529346,.330073,.140581,.098374,.873461,.028165,.016883,.117672,.865444);const mat3 z=mat3(2.034076,-.727334,-.306742,-.228813,1.23173,-.002917,-.00857,-.153287,1.161856);const float w=216./24389.;const float u=24389./27.;const float M=1.-1e-6;vec3 T(in vec3 a){return vec3(a.r<=.04045?a.r/12.92:pow((a.r+.055)/1.055,2.4),a.g<=.04045?a.g/12.92:pow((a.g+.055)/1.055,2.4),a.b<=.04045?a.b/12.92:pow((a.b+.055)/1.055,2.4));}vec3 U(in vec3 a){return vec3(a.r<=.003131?a.r*12.92:1.055*pow(a.r,1./2.4)-.055,a.g<=.003131?a.g*12.92:1.055*pow(a.g,1./2.4)-.055,a.b<=.003131?a.b*12.92:1.055*pow(a.b,1./2.4)-.055);}vec3 N(in vec3 b){const vec4 d=vec4(0.,-1./3.,2./3.,-1.);vec4 c=b.g<b.b?vec4(b.bg,d.wz):vec4(b.gb,d.xy);vec4 a=b.r<c.x?vec4(c.xyw,b.r):vec4(b.r,c.yzx);float e=a.x-min(a.w,a.y);return vec3(abs(a.z+(a.w-a.y)/(6.*e+1e-10)),e/(a.x+1e-10),a.x);}vec3 D(in vec3 b){const vec4 a=vec4(1.,2./3.,1./3.,3.);vec3 c=abs(fract(b.xxx+a.xyz)*6.-a.www);return b.z*mix(a.xxx,clamp(c-a.xxx,0.,1.),b.y);}float V(in float a){a*=2.;if(a>=1.){a-=1.;a=log(.5)/log(.5*(1.-a)+.9332*a);}return clamp(a,1e-3,10.);}float O(in vec3 a){return dot(a,vec3(.242655,.755158,.002187));}float o(in vec3 a){const vec3 b=vec3(.298839,.586811,.11435);return dot(a,b);}vec3 E(in vec3 b,in vec3 c){vec3 a=N(b);vec3 d=N(c);a.x=d.x;return clamp(D(a),0.,1.);}vec2 P(in vec2 a){float b=sin(dot(a,vec2(12.9898,78.233)))*43758.5453;return fract(vec2(1.3453,1.3647)*b)*2.-1.;}float W(){const vec3 a=vec3(12.9898,78.233,151.7182);return fract(sin(dot(gl_FragCoord.xyz,a))*43758.5453);}vec3 X(in vec3 a,in vec3 d){vec3 b=2.*a*d;vec3 c=1.-2.*(1.-a)*(1.-d);return vec3(a.r<.5?b.r:c.r,a.g<.5?b.g:c.g,a.b<.5?b.b:c.b);}vec3 Q(vec3 b,vec3 a){vec3 c=2.*b*a+b*b*(1.-2.*a);vec3 d=sqrt(b)*(2.*a-1.)+2.*b*(1.-a);return vec3(a.r<.5?c.r:d.r,a.g<.5?c.g:d.g,a.b<.5?c.b:d.b);}vec3 Y(in vec3 a){float b=o(a);float c=min(min(a.r,a.g),a.b);float d=max(max(a.r,a.g),a.b);if(c<0.)a=(a-b)*b/(b-c)+b;if(d>1.)a=(a-b)*(1.-b)/(d-b)+b;return a;}vec3 R(in vec3 a,in float b){float c=b-o(a);return Y(a+c);}vec3 Z(vec3 b){vec3 a;float e=min(min(b.r,b.g),b.b);float c=max(max(b.r,b.g),b.b);float d=c-e;a.z=(c+e)/2.;if(d==0.){a.x=0.;a.y=0.;}else{if(a.z<.5)a.y=d/(c+e);else a.y=d/(2.-c-e);float f=((c-b.r)/6.+d/2.)/d;float g=((c-b.g)/6.+d/2.)/d;float h=((c-b.b)/6.+d/2.)/d;if(b.r==c)a.x=h-g;else if(b.g==c)a.x=1./3.+f-h;else if(b.b==c)a.x=2./3.+g-f;if(a.x<0.)a.x+=1.;else if(a.x>1.)a.x-=1.;}return clamp(a,0.,1.);}float F(float b,float d,float a){if(a<0.)a+=1.;else if(a>1.)a-=1.;float c;if(6.*a<1.)c=b+(d-b)*6.*a;else if(2.*a<1.)c=d;else if(3.*a<2.)c=b+(d-b)*(2./3.-a)*6.;else c=b;return c;}vec3 _(vec3 a){vec3 c;if(a.y==0.)c=vec3(a.z);else{float b;if(a.z<.5)b=a.z*(1.+a.y);else b=a.z+a.y-a.y*a.z;float d=2.*a.z-b;c.r=F(d,b,a.x+1./3.);c.g=F(d,b,a.x);c.b=F(d,b,a.x-1./3.);}return c;}vec3 S(in vec3 c,in vec3 d){vec3 a=c/d;vec3 b=vec3(a.x>w?pow(a.x,1./3.):(u*a.x+16.)/116.,a.y>w?pow(a.y,1./3.):(u*a.y+16.)/116.,a.z>w?pow(a.z,1./3.):(u*a.z+16.)/116.);return vec3(116.*b.y-16.,500.*(b.x-b.y),200.*(b.y-b.z));}vec3 aa(in vec3 a,in vec3 g){float d=(a.x+16.)/116.;float b=2e-3*a.y+d;float c=d-5e-3*a.z;float e=b*b*b;float f=c*c*c;vec3 h=vec3(e>w?e:(116.*b-16.)/u,a.x>8.?pow((a.x+16.)/116.,3.):a.x/u,f>w?f:(116.*c-16.)/u);return h*g;}vec3 A(in vec3 b,in vec3 c,in vec3 d){vec3 a;a=K*b;a=C*(m*a*(c/d));return a;}vec3 ba(in vec3 a,in vec3 c,in vec3 d){vec3 b;a=C*(m*a*(d/c));b=L*a;return b;}void ca(inout vec3 c,in float i,in float e){vec2 f=1./textureSize*textureScale;vec2 g=f*e*2.-i*f;vec2 h=P(distortionCoord)*f*e;vec2 d=(0.+h)*g;vec2 a=(1.+h)*g;vec2 b=(2.+h)*g;vec3 j=c;c=.013514*texture2D(texture,coord.xy+vec2(-b.x,-b.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(-b.x,-a.y)).rgb+.040541*texture2D(texture,coord.xy+vec2(-b.x,-d.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(-b.x,+a.y)).rgb+.013514*texture2D(texture,coord.xy+vec2(-b.x,+b.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(-a.x,-b.y)).rgb+.054054*texture2D(texture,coord.xy+vec2(-a.x,-a.y)).rgb+.067568*texture2D(texture,coord.xy+vec2(-a.x,-d.y)).rgb+.054054*texture2D(texture,coord.xy+vec2(-a.x,+a.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(-a.x,+b.y)).rgb+.040541*texture2D(texture,coord.xy+vec2(+d.x,-b.y)).rgb+.067568*texture2D(texture,coord.xy+vec2(+d.x,-a.y)).rgb+.081081*c+.067568*texture2D(texture,coord.xy+vec2(+d.x,+a.y)).rgb+.040541*texture2D(texture,coord.xy+vec2(+d.x,+b.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(+a.x,-b.y)).rgb+.054054*texture2D(texture,coord.xy+vec2(+a.x,-a.y)).rgb+.067568*texture2D(texture,coord.xy+vec2(+a.x,-d.y)).rgb+.054054*texture2D(texture,coord.xy+vec2(+a.x,+a.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(+a.x,+b.y)).rgb+.013514*texture2D(texture,coord.xy+vec2(+b.x,-b.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(+b.x,-a.y)).rgb+.040541*texture2D(texture,coord.xy+vec2(+b.x,-d.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(+b.x,+a.y)).rgb+.013514*texture2D(texture,coord.xy+vec2(+b.x,+b.y)).rgb;c=mix(c,j,(1.+i)*2.*(1.-e));c=clamp(c,0.,1.);c=E(c,j);}void da(inout vec3 a,in float e,in float f,in float i){const vec3 j=vec3(1.009802,1.,.644496);const vec3 k=vec3(.995451,1.,1.886109);vec3 l=a;float n=o(a);float b=abs(e)*(1.-pow(n,2.72));vec3 c=vec3(.968774,1.,1.121774);vec3 g=e<0.?k:j;vec3 p=c;vec3 q=vec3(mix(c.x,g.x,b),mix(1.,.9,f),mix(c.z,g.z,b));vec3 r=m*q;vec3 s=m*p;vec3 d=K*a;vec3 h=m*d;h*=r/s;d=C*h;a=L*d;a=a*(1.+(b+f)/10.);a=mix(l,a,i);a=clamp(a,0.,1.);}void ea(inout vec3 b,in float h,in float c){vec3 a=b;float f=a.r*.299+a.g*.587+a.b*.114;float g=min(min(a.r,a.g),a.b);float d=max(max(a.r,a.g),a.b);float i=(1.-(d-g))*(1.-d)*f*5.;vec3 e=vec3((g+d)/2.);a=mix(a,mix(a,e,-c),i);a=mix(a,e,(1.-e)*(1.-c)/2.*abs(c));b=mix(a,vec3(f),-h);b=clamp(b,0.,1.);}void fa(inout vec3 a,in float b,in vec4 c){float d=1.-c.a;float e=mix(1.,max(.01,d),b);a=(a-.95)/e+.95;a=clamp(a,0.,1.);}void ga(inout vec3 a,in float c,in vec3 d){vec3 e=d/2.+.5;float f=1.-pow(o(a),2.72);vec3 b=mix(vec3(.5),e,c*2.*f);a=sqrt(a)*(2.*b-1.)+2.*a*(1.-b);}void ha(inout vec3 a,in float b,in vec3 d){float e=b>0.?b*3.:b*2.;float f=(o(a)+(1.-o(d)))*.5;vec3 c=a*t;vec3 g=vec3(clamp(mix(.5,f,e),0.,1.));a=X(c,g);a=E(a,c);a=a*z;a=clamp(a,0.,1.);}void ia(inout vec3 k,in float i,in float j){vec3 d=k;const float l=-6.994413;const float n=-.188103;const float p=-14.950968;const float q=-34.330249;const float r=-3.418496;const float s=-12.099387;const float x=-2.919341;const float y=-9.767371;const float G=-121.21509;const float H=-108.566087;float I=max(d.r,max(d.g,d.b));float J=min(d.r,min(d.g,d.b));float b=(I+J)/2.;float h=b;float a=h*h;float c=a*h;float f,g;vec3 e;f=.005337*h+.666424*a+3.023761*c+l*a*a+3.293987*a*c;f=min(f,1.-b);g=n*h+2.812945*a+p*c+33.494165*a*a+q*a*c+13.143082*c*c;g=max(g,-b);e=i>=0.?d*(f*i+b)/b:d*(b-g*i)/b;e=clamp(e,0.,1.);f=.837673*h+r*a+8.078055*c+s*a*a+9.520316*a*c+x*c*c;f=min(f,1.-b);g=b<=.23?-b:.508865+y*h+49.107057*a+G*c+160.620531*a*a+H*a*c+29.315822*c*c;g=max(g,-b);e=j>=0.?e*(f*j+b)/b:e*(b-g*j)/b;e=clamp(e,0.,1.);k=R(d,o(e));}void ja(inout vec3 b,in float h,in float i,in vec3 j,in float k){vec3 c=b*t;float n=o(b);float l=O(j*t);float e=mix(i,h,1.-l);float f=abs(e)*k+1e-6;float d=pow(2.,f+1.)-2.;float g=M-exp(-d);vec3 a=e>0.?(1.-exp(-d*c))/g:log(1.-c*g)/-d;a=mix(c,a,min(f*100.,1.));a=clamp(a,0.,1.);b=a*z;}void ka(inout vec3 d,in float e,in float i,in float f){vec3 b=d*t;float g=abs(e)*f+1e-6;float c=pow(2.,g*2.+1.)-2.;float h=M-exp(-c);vec3 a=e>0.?(1.-exp(-c*b))/h:log(1.-b*h)/-c;a=mix(b,a,min(g*100.,1.));a=E(a,b);a=pow(a,vec3(V(1.-(i*f+1.)/2.)));d=a*z;}void la(inout vec3 a,in float b){float d=b<0.?b*.5:b;a=a*t;vec3 c=mix(vec3(.5),a,d);a=mix(2.*a*c,1.-2.*(1.-a)*(1.-c),step(.5,a));a=a*z;a=clamp(a,0.,1.);}void ma(inout vec3 f,in float k,in float l,in float n,in float p){vec3 a=f;float g=O(a*t);a=T(a);vec3 q=D(vec3(l,k*2.,1.));vec3 r=D(vec3(p,n*2.,1.));vec3 b=v;vec3 e=B;vec3 c=m*b;vec3 d=m*e;vec3 s=S(A(a,c,d),b);vec3 h=mix(r,q,clamp(g+balance,0.,1.));vec3 x=A(h,c,d);float i=1.-(1.-g);b=v;e=v;c=m*b;d=m*e;vec3 y=A(h,c,d);b=mix(x,v,i);e=B;c=m*b;d=m*e;a=A(a,c,d);b=v;e=mix(y,B,i);c=m*b;d=m*e;vec3 j=S(a,b);j.x=s.x;a=aa(j,b);a=ba(a,c,d);a=clamp(a,0.,1.);f=U(a);}void na(inout vec3 a,in sampler2D b){a.r=texture2D(b,vec2(texture2D(b,vec2(a.r)).r)).a;a.g=texture2D(b,vec2(texture2D(b,vec2(a.g)).g)).a;a.b=texture2D(b,vec2(texture2D(b,vec2(a.b)).b)).a;}void oa(inout vec3 d,in sampler2D f){vec3 e=d;vec3 a=Z(e);vec3 b=texture2D(f,vec2(a.x)).xyz;b=(b-.5)*2.+.5;vec3 g=_(vec3(a.x-(1.-b.x*2.)*60./360.,a.y*(b.y*2.),a.z));float c=o(e);d=R(g,c+(b.z-.5)*(a.y*(1.-c)*4.)*c*c);}void pa(inout vec3 a,in float b){a=mix(a,1.-a,b);}void qa(inout vec3 a,in float d,in float e,in float h,in vec2 f,in sampler2D i){float j=o(a);float k=d*grain_highlights;float l=mix(d,k,j);vec2 b=compositeCoord.xy*textureSize/f;b=b+P(b).xy/f/textureScale/3.;vec4 c=texture2D(i,b);vec2 g=vec2(mix(c.r,c.b,e),mix(c.g,c.a,e));float n=mix(g.x,g.y,h);vec3 p=a*n*2.;a=mix(a,p,l);}void ra(inout vec3 j,in float r,in float g,in float s,in float x,in float a,in vec2 y){vec3 G=vec3(compositeCoord.xy*2.-1.,1.);vec3 k=distortionMatrix*G;vec4 H=vec4(k.xy/k.z,1.,1.);vec4 I=H*.5*rotationMatrix+.5;vec2 J=(I.xy-vec2(crop.x,1.-crop.w-crop.y))/crop.zw;const vec2 sa=vec2(1.,1.);vec2 ta=y;float ua=min(1.-g,.99);float l=-r;float n=-0.*.5;vec3 h=j;float va=mix(10.,2.,x);float i=1./mix(.5,.05,max(0.,-a));vec2 b=textureSize*crop.zw;float wa=mix(1.,max(1.,b.x/b.y),a);float xa=mix(1.,max(1.,b.y/b.x),a);vec2 ya=vec2(wa,xa);vec3 p=vec3(1.-pow(o(h),2.72)*s);vec2 c=(J-ta)/sa*(1.-g/2.);c+=c*(ya-1.)*float(a>=0.);float za=pow(pow(abs(c.x),i)+pow(abs(c.y),i),1./i);float Aa=1.+W()/100.*g;float d=smoothstep(1.,ua,za*va*Aa);vec3 e=vec3(d);vec3 Ba=Q(h,mix(vec3(.5),e/2.,l));e=Ba*mix(vec3(1.),e,l*p);float q=1.-d;vec3 f=vec3(q);vec3 Ca=Q(h,mix(vec3(.5),f/2.,n));f=Ca*mix(vec3(1.),f,n*p);float Da=float(d/(d+q));j=mix(e,f,Da);}void Ea(inout vec3 b,in float i,in float a,in sampler2D f){vec3 c=b;float d=a-1.;float g=(c.r*d+.5)/a;float h=(c.b*d+.5)/a;float e=c.g*d;float j=(floor(e)+g)/a;float k=(ceil(e)+g)/a;vec3 l=texture2D(f,vec2(j,h)).xyz;vec3 n=texture2D(f,vec2(k,h)).xyz;b=mix(l,n,fract(e));b=mix(c,b,i);}void main(){vec4 c=texture2D(texture,coord.xy);vec4 e=texture2D(dehazeTexture,distortionCoord);vec3 a=c.rgb;vec3 d=e.rgb;float f=max(0.,(grain_size-.25)/.75)*pow(grain_amount,.25);float b=c.a;if(sharpen!=0.||f!=0.)ca(a,sharpen,f);if(diffuse!=0.)ga(a,diffuse,d);if(clarity!=0.)ha(a,clarity*b,d);if(dehaze!=0.)fa(a,dehaze,e);if(whites!=0.||blacks!=0.)ia(a,whites,blacks);if(shadows!=0.||highlights!=0.)ja(a,shadows,highlights,d,b);if(exposure!=0.||gamma!=0.)ka(a,exposure,gamma,b);if(temperature!=0.||tint!=0.)da(a,temperature,tint,b);if(contrast!=0.)la(a,contrast*b);if(render_curves)na(a,curvesTexture);if(render_lut)Ea(a,lookup_intensity,lutSize,lookupTexture);if(render_hsl)oa(a,hslTexture);if(saturation!=0.||vibrance!=0.)ea(a,saturation*b,vibrance*b);if(highlights_saturation!=0.||shadows_saturation!=0.)ma(a,highlights_saturation*b,highlights_hue,shadows_saturation*b,shadows_hue);if(vignette_amount!=0.)ra(a,vignette_amount,vignette_feather,vignette_highlights,vignette_size,vignette_roundness,vignette_center);if(grain_amount!=0.)qa(a,grain_amount,grain_size,grain_roughness,grainTextureSize,grainTexture);if(invert!=0.)pa(a,invert);a=mix(c.rgb,a,c.a);gl_FragColor=vec4(a,c.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;precision lowp sampler2D;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;varying vec4 compositeCoord;uniform sampler2D texture;uniform sampler2D originalTexture;uniform sampler2D dehazeTexture;uniform sampler2D curvesTexture;uniform sampler2D hslTexture;uniform sampler2D lookupTexture;uniform sampler2D grainTexture;uniform vec4 crop;uniform vec2 grainTextureSize;uniform vec2 textureSize;uniform float textureScale;uniform float lutSize;uniform mat4 rotationMatrix;uniform mat3 distortionMatrix;uniform vec3 precomputed_highlights_rgb;uniform vec3 precomputed_shadows_rgb;uniform float sharpen;uniform float diffuse;uniform float clarity;uniform float dehaze;uniform float whites;uniform float blacks;uniform float shadows;uniform float highlights;uniform float exposure;uniform float gamma;uniform float offset;uniform float temperature;uniform float tint;uniform float contrast;uniform float saturation;uniform float vibrance;uniform float balance;uniform float vignette_feather;uniform float vignette_amount;uniform float vignette_highlights;uniform float vignette_roundness;uniform float vignette_size;uniform vec2 vignette_center;uniform float invert;uniform float lookup_intensity;uniform float grain_highlights;uniform float grain_amount;uniform float grain_size;uniform float grain_roughness;uniform bool render_curves;uniform bool render_hsl;uniform bool render_lut;uniform bool render_split_tone;const vec3 r=vec3(.95047,1.,1.08883);const vec3 ta=vec3(.952646,1.,1.008825);const vec3 ua=vec3(.96422,1.,.82521);const vec3 N=vec3(1.009802,1.,.644496);const vec3 O=vec3(1.001197,1.,1.96363);const mat3 u=mat3(.8951,-.7502,.0389,.2664,1.7135,-.0685,-.1614,.0367,1.0296);const mat3 P=mat3(.986993,.432305,-.008529,-.147054,.51836,.040043,.159963,.049291,.968487);const mat3 Q=mat3(.412456,.212673,.019334,.357576,.715152,.119192,.180437,.072175,.950304);const mat3 va=mat3(3.240454,-.969266,.055643,-1.537139,1.876011,-.204026,-.498531,.041556,1.057225);const mat3 wa=mat3(.987224,-.007598,.003073,-.006113,1.00186,-.005096,.015953,.00533,1.08168);const mat3 xa=mat3(1.013035,.007698,-.002841,.006105,.998165,.004685,-.014971,-.005032,.924507);const mat3 ya=mat3(.662454,.272229,-.005575,.134004,.674082,.004061,.156188,.05369,1.010339);const mat3 za=mat3(1.641023,-.663663,.011722,-.324803,1.615332,-.008284,-.236425,.016756,.988395);const mat3 H=mat3(.652238,.267672,-.005382,.128236,.674339,.001369,.169982,.057988,1.09307);const mat3 I=mat3(1.660585,-.659926,.009003,-.315296,1.608394,-.003567,-.241509,.017299,.913644);const mat3 v=mat3(.613195,.070205,.020619,.339515,.916334,.109567,.047368,.013449,.869606);const mat3 R=mat3(1.70478,-.13026,-.024009,-.621692,1.140829,-.129,-.083245,-.010549,1.153248);const vec3 s=vec3(2.2);const vec3 o=vec3(1./2.2);vec3 w(in vec3 a){return vec3(a.r<=.04045?a.r/12.92:pow((a.r+.055)/1.055,2.4),a.g<=.04045?a.g/12.92:pow((a.g+.055)/1.055,2.4),a.b<=.04045?a.b/12.92:pow((a.b+.055)/1.055,2.4));}vec3 S(in vec3 a){return vec3(a.r<=.003131?a.r*12.92:1.055*pow(a.r,1./2.4)-.055,a.g<=.003131?a.g*12.92:1.055*pow(a.g,1./2.4)-.055,a.b<=.003131?a.b*12.92:1.055*pow(a.b,1./2.4)-.055);}vec3 p(in vec3 b){const vec4 d=vec4(0.,-1./3.,2./3.,-1.);vec4 c=b.g<b.b?vec4(b.bg,d.wz):vec4(b.gb,d.xy);vec4 a=b.r<c.x?vec4(c.xyw,b.r):vec4(b.r,c.yzx);float e=a.x-min(a.w,a.y);return vec3(abs(a.z+(a.w-a.y)/(6.*e+1e-10)),e/(a.x+1e-10),a.x);}vec3 t(in vec3 b){const vec4 a=vec4(1.,2./3.,1./3.,3.);vec3 c=abs(fract(b.xxx+a.xyz)*6.-a.www);return b.z*mix(a.xxx,clamp(c-a.xxx,0.,1.),b.y);}vec3 J(in vec3 a,in vec3 b,in vec3 c,in float d){vec3 e=u*b;vec3 f=u*c;vec3 g=pow(e/f,vec3(d));return P*(u*a*g);}float T(in float a){a*=2.;if(a>=1.){a-=1.;a=log(.5)/log(.5*(1.-a)+.9332*a);}return clamp(a,1e-3,10.);}float x(in vec3 a){return dot(a,vec3(1./3.));}float U(in vec3 a){float b=min(min(a.r,a.g),a.b);float c=max(max(a.r,a.g),a.b);return (c+b)/2.;}float m(in vec3 a){const vec3 b=vec3(.298839,.586811,.11435);return dot(a,b);}float K(in vec3 a){float b=min(min(a.r,a.g),a.b);float c=max(max(a.r,a.g),a.b);return c-b;}vec3 y(in vec3 b,in vec3 c){vec3 a=p(b);vec3 d=p(c);a.x=d.x;return clamp(t(a),0.,1.);}vec3 L(in vec3 a,in float c){float e=abs(c);float b=pow(2.,e+1.)-2.;float d=1.-exp(-b);a*=.99;a=c>0.?(1.-exp(-b*a))/d:log(1.-a*d)/-b;return a/.99;}vec2 M(in vec2 a){float b=sin(dot(a,vec2(12.9898,78.233)))*43758.5453;return fract(vec2(1.3453,1.3647)*b)*2.-1.;}float V(){const vec3 a=vec3(12.9898,78.233,151.7182);return fract(sin(dot(gl_FragCoord.xyz,a))*43758.5453);}void W(inout vec3 c,in float i,in float e){vec2 f=1./textureSize*textureScale;vec2 g=f*e*2.-i*f;vec2 h=M(distortionCoord)*f*e;vec2 d=(0.+h)*g;vec2 a=(1.+h)*g;vec2 b=(2.+h)*g;vec3 j=c;c=.013514*texture2D(texture,coord.xy+vec2(-b.x,-b.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(-b.x,-a.y)).rgb+.040541*texture2D(texture,coord.xy+vec2(-b.x,-d.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(-b.x,+a.y)).rgb+.013514*texture2D(texture,coord.xy+vec2(-b.x,+b.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(-a.x,-b.y)).rgb+.054054*texture2D(texture,coord.xy+vec2(-a.x,-a.y)).rgb+.067568*texture2D(texture,coord.xy+vec2(-a.x,-d.y)).rgb+.054054*texture2D(texture,coord.xy+vec2(-a.x,+a.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(-a.x,+b.y)).rgb+.040541*texture2D(texture,coord.xy+vec2(+d.x,-b.y)).rgb+.067568*texture2D(texture,coord.xy+vec2(+d.x,-a.y)).rgb+.081081*c+.067568*texture2D(texture,coord.xy+vec2(+d.x,+a.y)).rgb+.040541*texture2D(texture,coord.xy+vec2(+d.x,+b.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(+a.x,-b.y)).rgb+.054054*texture2D(texture,coord.xy+vec2(+a.x,-a.y)).rgb+.067568*texture2D(texture,coord.xy+vec2(+a.x,-d.y)).rgb+.054054*texture2D(texture,coord.xy+vec2(+a.x,+a.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(+a.x,+b.y)).rgb+.013514*texture2D(texture,coord.xy+vec2(+b.x,-b.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(+b.x,-a.y)).rgb+.040541*texture2D(texture,coord.xy+vec2(+b.x,-d.y)).rgb+.027027*texture2D(texture,coord.xy+vec2(+b.x,+a.y)).rgb+.013514*texture2D(texture,coord.xy+vec2(+b.x,+b.y)).rgb;c=mix(c,j,(1.+i)*2.*(1.-e));c=clamp(c,0.,1.);c=y(c,j);}void X(inout vec3 a,in float c,in float f){vec3 g=c<0.?O:N;float h=x(a);float d=1.-pow(h,2.);float i=abs(c);vec3 j=r;vec3 e=mix(r,g,i);e.y-=f*d*.2;vec3 b=H*a;b=J(b,e,j,2.*d);a=I*b;a=clamp(a,0.,1.);}void Y(inout vec3 a,in float f,in float d){float e=m(a);float g=K(a);vec3 b=p(a);float h=pow(g,.5);float c=1.-abs(fract(b.x+.93)*2.-1.);c=min(1.,c+.5+a.g*.5);b.y=d>0.?mix(b.y,1.,d*(1.-e)*h*c):mix(b.y,0.,-d*c*.5);a=t(b);a=mix(a,vec3(e),-f);}void Z(inout vec3 a,in float b,in vec4 c){float d=1.-c.a;float e=mix(1.,max(.01,d),b);a=(a-.95)/e+.95;a=clamp(a,0.,1.);}void _(inout vec3 a,in float c,in vec3 d){vec3 e=d/2.+.5;float f=1.-pow(m(a),2.72);vec3 b=mix(vec3(.5),e,c*2.*f);a=sqrt(a)*(2.*b-1.)+2.*a*(1.-b);}void aa(inout vec3 a,in float c,in vec3 f){float g=c>0.?c*8.:c*4.;vec3 b=mix(vec3(.5),f,g);vec3 d=2.*a*b+a*a*(1.-2.*b);vec3 e=sqrt(a)*(2.*b-1.)+2.*a*(1.-b);a.r=b.r<.5?d.r:e.r;a.g=b.g<.5?d.g:e.g;a.b=b.b<.5?d.b:e.b;}void ba(inout vec3 c,in float j,in float k){const float n=-6.994413;const float q=-.188103;const float z=-14.950968;const float A=-34.330249;const float B=-3.418496;const float C=-12.099387;const float D=-2.919341;const float E=-9.767371;const float F=-121.21509;const float G=-108.566087;float a=sqrt(U(c));float b=a;float f=b*b;float g=f*b;float h=g*b;float i=h*b;float l=i*b;float d,e;d=.005337*b+.666424*f+3.023761*g+n*h+3.293987*i;d=min(d,1.-a);e=q*b+2.812945*f+z*g+33.494165*h+A*i+13.143082*l;e=max(e,-a);c=j>=0.?c*(d*j+a)/a:c*(a-e*j*2.)/a;d=.837673*b+B*f+8.078055*g+C*h+9.520316*i+D*l;d=min(d,1.-a);e=a<=.23?-a:.508865+E*b+49.107057*f+F*g+160.620531*h+G*i+29.315822*l;e=max(e,-a);c=k>=0.?c*(d*k*2.+a)/a:c*(a-e*k)/a;c=clamp(c,0.,1.);}void ca(inout vec3 a,in float d,in float e,in vec3 f){a=pow(a,s);float b=m(f);float g=m(a);e*=b*.5;float c=mix(e+d*.1,d*pow(1.-b,2.),1.-b);c=c*3.*pow(g*2.,.1);a=L(a,c);a=pow(a,o);}void da(inout vec3 a,in float b){a=pow(a,s);a=L(a,b*3.);a=pow(a,o);}void ea(inout vec3 a,in float b){a=pow(a,vec3(T(1.-(b+1.)/2.)));}void fa(inout vec3 a,in float b){float c=mix(1.,.01,-b);a=(a-.98)/c+.98;a=clamp(a,0.,1.);}void ga(inout vec3 a,in float b){float f=b<0.?b*.5:b;vec3 e=mix(vec3(.5),a,f);vec3 c=2.*a*e;vec3 d=1.-2.*(1.-a)*(1.-e);a.r=a.r<.5?c.r:d.r;a.g=a.g<.5?c.g:d.g;a.b=a.b<.5?c.b:d.b;}void ha(inout vec3 a){a=pow(a,s);float b=x(a);vec3 e=mix(precomputed_shadows_rgb,precomputed_highlights_rgb,clamp(pow(b,.5)+balance,0.,1.));float f=1.-b;vec3 g=Q*e;vec3 h=r;vec3 i=mix(r,g,f);vec3 c=H*a;c=J(c,i,h,2.);a=I*c;a=clamp(a,0.,1.);float j=b-x(a);vec3 d=p(a);d.z+=j;a=t(d);a=pow(a,o);}void ia(inout vec3 a,in sampler2D c){vec3 e=a;float d=256.-1.;vec3 b=(a*d+.5)/256.;a.r=texture2D(c,vec2(b.r)).a;a.g=texture2D(c,vec2(b.g)).a;a.b=texture2D(c,vec2(b.b)).a;a=y(a,e);b=(a*d+.5)/256.;a.r=texture2D(c,vec2(b.r)).r;a.g=texture2D(c,vec2(b.g)).g;a.b=texture2D(c,vec2(b.b)).b;}void ja(inout vec3 a,in sampler2D f){vec3 c=p(a);float b=c.x;float g=K(a);float i=m(a);vec3 h=texture2D(f,vec2(b)).xyz;vec3 d=(1.-h*2.)*2.;b=b-d.x*40./360.;b=fract(1.+b);float e=d.z*g*.5;a=t(vec3(b,c.y+e,c.z-e));a=mix(a,vec3(m(a)),d.y);}void ka(inout vec3 a,in float b){a=mix(a,1.-a,b);}void la(inout vec3 a,in float j,in float f,in float k,in vec2 g,in sampler2D l){vec2 b=compositeCoord.xy*textureSize/g;b=b+M(b).xy/g/textureScale/3.;vec4 c=texture2D(l,b);vec2 h=vec2(mix(c.r,c.b,f),mix(c.g,c.a,f));float d=mix(h.x,h.y,k);float i=m(a);float n=1.-i*grain_highlights;float q=1.-pow(1.-i,4.);d=mix(.5,d,j*n*q);vec3 e=vec3(d);a=mix(max(a+2.*e-1.,0.),min(a+2.*(e-.5),1.),step(.5,e));}void ma(inout vec3 a,in float l,in float d,in float n,in float q,in float e,in vec2 z){vec3 A=vec3(compositeCoord.xy*2.-1.,1.);vec3 g=distortionMatrix*A;vec4 B=vec4(g.xy/g.z,1.,1.);vec4 C=B*.5*rotationMatrix+.5;vec2 D=(C.xy-vec2(crop.x,1.-crop.w-crop.y))/crop.zw;vec2 E=z;float F=min(1.-d,.99);float h=-l;float G=mix(10.,2.,q);vec2 i=textureSize*crop.zw;vec2 j=vec2(1.);vec2 na=mix(j,max(j,i.xy/i.yx),e);float oa=1.-pow(m(a),2.72)*n;vec2 c=(D-E)*(1.-d/2.);c+=c*(na-1.)*step(0.,e);float f=1./mix(.5,.05,max(0.,-e));float pa=pow(pow(abs(c.x),f)+pow(abs(c.y),f),1./f);float qa=1.+V()/100.*d;float k=smoothstep(1.,F,pa*G*qa);vec3 b=vec3(mix(.5,k/2.,h));vec3 ra=mix(2.*a*b+a*a*(1.-2.*b),sqrt(a)*(2.*b-1.)+2.*a*(1.-b),step(.5,b));a=ra*mix(1.,k,h*oa);}void sa(inout vec3 b,in float i,in float a,in sampler2D f){vec3 c=clamp(b,0.,1.);float d=a-1.;float g=(c.r*d+.5)/a;float h=(c.b*d+.5)/a;float e=c.g*d;float j=(floor(e)+g)/a;float k=(ceil(e)+g)/a;vec3 l=texture2D(f,vec2(j,h)).xyz;vec3 n=texture2D(f,vec2(k,h)).xyz;b=mix(l,n,fract(e));b=mix(c,b,i);}void main(){vec4 c=texture2D(texture,coord.xy);vec4 g=texture2D(originalTexture,coord.xy);vec4 e=texture2D(dehazeTexture,distortionCoord);vec3 a=c.rgb;vec3 b=e.rgb;vec3 d=g.rgb;float f=max(0.,(grain_size-.25)/.75)*pow(grain_amount,.25);if(sharpen!=0.||f!=0.)W(a,sharpen,f);a=v*w(a);b=v*w(b);d=v*w(d);vec3 h=(d+(1.-b))*.5;if(temperature!=0.||tint!=0.)X(a,temperature,tint);a=pow(a,o);b=pow(b,o);if(dehaze!=0.)Z(a,dehaze,e);vec3 i=a;if(clarity!=0.)aa(a,clarity,h);if(diffuse!=0.)_(a,diffuse,b);if(whites!=0.||blacks!=0.)ba(a,whites,blacks);if(shadows!=0.||highlights!=0.)ca(a,shadows,highlights,b);if(exposure!=0.)da(a,exposure);if(gamma!=0.)ea(a,gamma);if(offset!=0.)fa(a,offset);if(contrast!=0.)ga(a,contrast);if(vignette_amount!=0.)ma(a,vignette_amount,vignette_feather,vignette_highlights,vignette_size,vignette_roundness,vignette_center);a=y(a,i);if(render_curves)ia(a,curvesTexture);if(render_hsl)ja(a,hslTexture);if(saturation!=0.||vibrance!=0.)Y(a,saturation,vibrance);if(render_split_tone)ha(a);if(grain_amount!=0.)la(a,grain_amount,grain_size,grain_roughness,grainTextureSize,grainTexture);if(invert!=0.)ka(a,invert);a=clamp(a,0.,1.);a=pow(a,s);a=S(R*a);if(render_lut)sa(a,lookup_intensity,lutSize,lookupTexture);a=mix(c.rgb,a,c.a);gl_FragColor=vec4(a,c.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\n#extension GL_OES_standard_derivatives:enable\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform vec2 position;uniform vec3 color;uniform float colorMix;uniform float texel;uniform sampler2D texture;float f(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}void main(){float b=texel*2.;lowp vec4 c=texture2D(texture,position+.5);c.rgb=mix(c.rgb,color,colorMix);lowp float g=f(c.rgb);vec3 h=g>.5?vec3(0.):vec3(1.);float a=1.-length(coord.xy*2.-1.);float d=fwidth(a);float i=smoothstep(0.,d,a);float j=smoothstep(0.+.25,d+.25,a);float k=smoothstep(0.+b,d+b,a);float l=smoothstep(0.+b+.25,d+b+.25,a);float m=i-l;float e=k-j;float n=m*.5+e*.5;vec3 o=mix(h,c.rgb,e);vec4 p=vec4(o,n);gl_FragColor=p;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nuniform vec4 color;void main(){gl_FragColor=color;}";
        },
        function(t, e, r) {
            "use strict";
            var n = this && this.__importDefault || function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }, o = this && this.__importStar || function(t) {
                if (t && t.__esModule) return t;
                var e = {};
                if (null != t) for(var r in t)Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                return e.default = t, e;
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var i = r(112), a = n(r(553)), c = o(r(70)), u = o(r(578)), s = o(r(582)), l = o(r(592)), f = r(193), h = function() {
                function t(e, r) {
                    this._src = e, this.opts = f({}, r, t.DefaultOpts), this.opts.combinedFilter = l.combineFilters(this.opts.filters);
                }
                return t.from = function(t) {
                    return new a.default(t);
                }, t.prototype._process = function(t, e) {
                    var r = e.quantizer, n = e.generator;
                    return t.scaleDown(e), t.applyFilter(e.combinedFilter).then(function(t) {
                        return r(t.data, e);
                    }).then(function(t) {
                        return i.Swatch.applyFilter(t, e.combinedFilter);
                    }).then(function(t) {
                        return Promise.resolve(n(t));
                    });
                }, t.prototype.palette = function() {
                    return this.swatches();
                }, t.prototype.swatches = function() {
                    return this._palette;
                }, t.prototype.getPalette = function(t) {
                    var e = this, r = new this.opts.ImageClass, n = r.load(this._src).then(function(t) {
                        return e._process(t, e.opts);
                    }).then(function(t) {
                        return e._palette = t, r.remove(), t;
                    }, function(t) {
                        throw r.remove(), t;
                    });
                    return t && n.then(function(e) {
                        return t(null, e);
                    }, function(e) {
                        return t(e);
                    }), n;
                }, t.Builder = a.default, t.Quantizer = u, t.Generator = s, t.Filter = l, t.Util = c, t.Swatch = i.Swatch, t.DefaultOpts = {
                    colorCount: 64,
                    quality: 5,
                    generator: s.Default,
                    ImageClass: null,
                    quantizer: u.MMCQ,
                    filters: [
                        l.Default
                    ]
                }, t;
            }();
            e.default = h;
        },
        function(t, e) {
            t.exports = function(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length, o = 0, i = []; ++r < n;){
                    var a = t[r];
                    e(a, r, t) && (i[o++] = a);
                }
                return i;
            };
        },
        function(t, e, r) {
            var n = r(486), o = r(171), i = r(25), a = r(113), c = r(114), u = r(173), s = Object.prototype.hasOwnProperty;
            t.exports = function(t, e) {
                var r = i(t), l = !r && o(t), f = !r && !l && a(t), h = !r && !l && !f && u(t), d = r || l || f || h, p = d ? n(t.length, String) : [], v = p.length;
                for(var m in t)!e && !s.call(t, m) || d && ("length" == m || f && ("offset" == m || "parent" == m) || h && ("buffer" == m || "byteLength" == m || "byteOffset" == m) || c(m, v)) || p.push(m);
                return p;
            };
        },
        function(t, e, r) {
            var n = r(487), o = r(41), i = Object.prototype, a = i.hasOwnProperty, c = i.propertyIsEnumerable, u = n(function() {
                return arguments;
            }()) ? n : function(t) {
                return o(t) && a.call(t, "callee") && !c.call(t, "callee");
            };
            t.exports = u;
        },
        function(t, e, r) {
            (function(e) {
                var r = "object" == typeof e && e && e.Object === Object && e;
                t.exports = r;
            }).call(this, r(81));
        },
        function(t, e, r) {
            var n = r(491), o = r(116), i = r(117), a = i && i.isTypedArray, c = a ? o(a) : n;
            t.exports = c;
        },
        function(t, e) {
            t.exports = function(t, e) {
                return function(r) {
                    return t(e(r));
                };
            };
        },
        function(t, e, r) {
            var n = r(55), o = r(42);
            t.exports = function(t) {
                if (!o(t)) return !1;
                var e = n(t);
                return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
            };
        },
        function(t, e) {
            var r = Function.prototype.toString;
            t.exports = function(t) {
                if (null != t) {
                    try {
                        return r.call(t);
                    } catch (t) {}
                    try {
                        return t + "";
                    } catch (t) {}
                }
                return "";
            };
        },
        function(t, e, r) {
            var n = r(524), o = r(41);
            t.exports = function t(e, r, i, a, c) {
                return e === r || (null == e || null == r || !o(e) && !o(r) ? e != e && r != r : n(e, r, i, a, t, c));
            };
        },
        function(t, e, r) {
            var n = r(525), o = r(528), i = r(529);
            t.exports = function(t, e, r, a, c, u) {
                var s = 1 & r, l = t.length, f = e.length;
                if (l != f && !(s && f > l)) return !1;
                var h = u.get(t);
                if (h && u.get(e)) return h == e;
                var d = -1, p = !0, v = 2 & r ? new n : void 0;
                for(u.set(t, e), u.set(e, t); ++d < l;){
                    var m = t[d], g = e[d];
                    if (a) var b = s ? a(g, m, d, e, t, u) : a(m, g, d, t, e, u);
                    if (void 0 !== b) {
                        if (b) continue;
                        p = !1;
                        break;
                    }
                    if (v) {
                        if (!o(e, function(t, e) {
                            if (!i(v, e) && (m === t || c(m, t, r, a, u))) return v.push(e);
                        })) {
                            p = !1;
                            break;
                        }
                    } else if (m !== g && !c(m, g, r, a, u)) {
                        p = !1;
                        break;
                    }
                }
                return u.delete(t), u.delete(e), p;
            };
        },
        function(t, e, r) {
            var n = r(24).Uint8Array;
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(181), o = r(122), i = r(54);
            t.exports = function(t) {
                return n(t, i, o);
            };
        },
        function(t, e, r) {
            var n = r(182), o = r(25);
            t.exports = function(t, e, r) {
                var i = e(t);
                return o(t) ? i : n(i, r(t));
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                for(var r = -1, n = e.length, o = t.length; ++r < n;)t[o + r] = e[r];
                return t;
            };
        },
        function(t, e) {
            t.exports = function() {
                return [];
            };
        },
        function(t, e, r) {
            var n = r(42);
            t.exports = function(t) {
                return t == t && !n(t);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return function(r) {
                    return null != r && r[t] === e && (void 0 !== e || t in Object(r));
                };
            };
        },
        function(t, e, r) {
            var n = r(187), o = r(78);
            t.exports = function(t, e) {
                for(var r = 0, i = (e = n(e, t)).length; null != t && r < i;)t = t[o(e[r++])];
                return r && r == i ? t : void 0;
            };
        },
        function(t, e, r) {
            var n = r(25), o = r(123), i = r(541), a = r(544);
            t.exports = function(t, e) {
                return n(t) ? t : o(t, e) ? [
                    t
                ] : i(a(t));
            };
        },
        function(t, e, r) {
            var n = r(189), o = r(57), i = Object.prototype.hasOwnProperty;
            t.exports = function(t, e, r) {
                var a = t[e];
                i.call(t, e) && o(a, r) && (void 0 !== r || e in t) || n(t, e, r);
            };
        },
        function(t, e, r) {
            var n = r(190);
            t.exports = function(t, e, r) {
                "__proto__" == e && n ? n(t, e, {
                    configurable: !0,
                    enumerable: !0,
                    value: r,
                    writable: !0
                }) : t[e] = r;
            };
        },
        function(t, e, r) {
            var n = r(43), o = function() {
                try {
                    var t = n(Object, "defineProperty");
                    return t({}, "", {}), t;
                } catch (t) {}
            }();
            t.exports = o;
        },
        function(t, e, r) {
            var n = r(182), o = r(192), i = r(122), a = r(183), c = Object.getOwnPropertySymbols ? function(t) {
                for(var e = []; t;)n(e, i(t)), t = o(t);
                return e;
            } : a;
            t.exports = c;
        },
        function(t, e, r) {
            var n = r(174)(Object.getPrototypeOf, Object);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(584), o = r(57), i = r(591), a = r(126), c = Object.prototype, u = c.hasOwnProperty, s = n(function(t, e) {
                t = Object(t);
                var r = -1, n = e.length, s = n > 2 ? e[2] : void 0;
                for(s && i(e[0], e[1], s) && (n = 1); ++r < n;)for(var l = e[r], f = a(l), h = -1, d = f.length; ++h < d;){
                    var p = f[h], v = t[p];
                    (void 0 === v || o(v, c[p]) && !u.call(t, p)) && (t[p] = l[p]);
                }
                return t;
            });
            t.exports = s;
        },
        function(t, e, r) {
            var n = {
                "./basic.frag": 608,
                "./basic.vert": 609,
                "./box_blur.frag": 610,
                "./box_blur_ab.frag": 611,
                "./combine_mask.frag": 612
            };
            function o(t) {
                var e = i(t);
                return r(e);
            }
            function i(t) {
                if (!r.o(n, t)) {
                    var e = new Error("Cannot find module '" + t + "'");
                    throw e.code = "MODULE_NOT_FOUND", e;
                }
                return n[t];
            }
            o.keys = function() {
                return Object.keys(n);
            }, o.resolve = i, t.exports = o, o.id = 194;
        },
        function(t, e, r) {
            "use strict";
            t.exports = {
                2: "need dictionary",
                1: "stream end",
                0: "",
                "-1": "file error",
                "-2": "stream error",
                "-3": "data error",
                "-4": "insufficient memory",
                "-5": "buffer error",
                "-6": "incompatible version"
            };
        },
        function(t, e, r) {
            var n = r(606), o = r(607);
            t.exports = function(t, e, r) {
                var i = e && r || 0;
                "string" == typeof t && (e = "binary" === t ? new Array(16) : null, t = null);
                var a = (t = t || {}).random || (t.rng || n)();
                if (a[6] = 15 & a[6] | 64, a[8] = 63 & a[8] | 128, e) for(var c = 0; c < 16; ++c)e[i + c] = a[c];
                return e || o(a);
            };
        },
        function(t, e, r) {
            "use strict";
            const n = [
                776,
                2359,
                2359,
                2367,
                2367,
                2984,
                3007,
                3021,
                3633,
                3635,
                3648,
                3657,
                4352,
                4449,
                4520
            ];
            function o(t) {
                if ("string" != typeof t) throw new Error("string cannot be undefined or null");
                const e = [];
                let r = 0, n = 0;
                for(; r < t.length;)n += i(r + n, t), s(t[r + n]) && n++, c(t[r + n]) && n++, u(t[r + n]) && n++, l(t[r + n]) ? n++ : (e.push(t.substring(r, r + n)), r += n, n = 0);
                return e;
            }
            function i(t, e) {
                const r = e[t];
                if (!function(t) {
                    return t && h(t[0].charCodeAt(0), 55296, 56319);
                }(r) || t === e.length - 1) return 1;
                const n = r + e[t + 1];
                let o = e.substring(t + 2, t + 5);
                return a(n) && a(o) || function(t) {
                    return h(f(t), 127995, 127999);
                }(o) ? 4 : 2;
            }
            function a(t) {
                return h(f(t), 127462, 127487);
            }
            function c(t) {
                return "string" == typeof t && h(t.charCodeAt(0), 65024, 65039);
            }
            function u(t) {
                return "string" == typeof t && h(t.charCodeAt(0), 8400, 8447);
            }
            function s(t) {
                return "string" == typeof t && -1 !== n.indexOf(t.charCodeAt(0));
            }
            function l(t) {
                return "string" == typeof t && 8205 === t.charCodeAt(0);
            }
            function f(t) {
                return (t.charCodeAt(0) - 55296 << 10) + (t.charCodeAt(1) - 56320) + 65536;
            }
            function h(t, e, r) {
                return t >= e && t <= r;
            }
            t.exports = o, t.exports.substr = function(t, e, r) {
                const n = o(t);
                if (void 0 === e) return t;
                if (e >= n.length) return "";
                const i = n.length - e;
                let a = e + (void 0 === r ? i : r);
                return a > e + i && (a = void 0), n.slice(e, a).join("");
            };
        },
        function(t, e) {
            !function() {
                var e, r, n, o, i, a = {
                    setBuffer: function(t) {
                        o = t, i = 0, n = new DataView(o);
                    },
                    getBuffer: function() {
                        return o;
                    },
                    putByte: function(t) {
                        n.setUint8(i, t), i += 1;
                    },
                    putShort: function(t) {
                        n.setUint16(i, t), i += 2;
                    }
                };
                function c() {
                    var t, r = Math.max(4 * e.width * 2, 1024), n = new Uint8Array(r), o = new DataView(n.buffer), i = 0, a = 0, c = 0, u = 0;
                    function s() {
                        t = n, r > i && (t = n.subarray(0, i));
                        try {
                            e.data.set(t, u);
                        } catch (t) {
                            console.error("jpeg data exceeds raw image data byte length");
                        }
                        u += i, i = 0;
                    }
                    function l() {
                        do {
                            i >= r && s();
                            var t = c >> 24 & 255;
                            255 != t ? (o.setUint8(i++, t), c <<= 8, a -= 8) : (c &= 16777215, o.setUint8(i++, 255));
                        }while (a >= 8);
                    }
                    function f(t, e) {
                        a > 16 && l(), function(t, e) {
                            c |= (t & (1 << e) - 1) << 32 - a - e, a += e;
                        }(t, e);
                    }
                    var h = function() {
                        d(), a >= 8 && l();
                    }, d = function() {
                        f(255, 32 - a & 7);
                    };
                    this.putbits = f, this.putshort = function(t) {
                        h(), o.setUint16(i++, t), i++;
                    }, this.putbyte = function(t) {
                        h(), o.setUint8(i++, t);
                    }, this.align = function() {
                        d();
                    }, this.end = function() {
                        s(), n = null, o = null;
                    }, this.getWrittenBytes = function() {
                        return u;
                    };
                }
                var u = new Uint32Array([
                    0,
                    0,
                    1,
                    5,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]), s = new Uint32Array([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ]), l = new Uint32Array([
                    0,
                    0,
                    2,
                    1,
                    3,
                    3,
                    2,
                    4,
                    3,
                    5,
                    5,
                    4,
                    4,
                    0,
                    0,
                    1,
                    125
                ]), f = new Uint32Array([
                    1,
                    2,
                    3,
                    0,
                    4,
                    17,
                    5,
                    18,
                    33,
                    49,
                    65,
                    6,
                    19,
                    81,
                    97,
                    7,
                    34,
                    113,
                    20,
                    50,
                    129,
                    145,
                    161,
                    8,
                    35,
                    66,
                    177,
                    193,
                    21,
                    82,
                    209,
                    240,
                    36,
                    51,
                    98,
                    114,
                    130,
                    9,
                    10,
                    22,
                    23,
                    24,
                    25,
                    26,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    131,
                    132,
                    133,
                    134,
                    135,
                    136,
                    137,
                    138,
                    146,
                    147,
                    148,
                    149,
                    150,
                    151,
                    152,
                    153,
                    154,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250
                ]), h = new Uint32Array([
                    0,
                    0,
                    3,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0
                ]), d = new Uint32Array([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ]), p = new Uint32Array([
                    0,
                    0,
                    2,
                    1,
                    2,
                    4,
                    4,
                    3,
                    4,
                    7,
                    5,
                    4,
                    4,
                    0,
                    1,
                    2,
                    119
                ]), v = new Uint32Array([
                    0,
                    1,
                    2,
                    3,
                    17,
                    4,
                    5,
                    33,
                    49,
                    6,
                    18,
                    65,
                    81,
                    7,
                    97,
                    113,
                    19,
                    34,
                    50,
                    129,
                    8,
                    20,
                    66,
                    145,
                    161,
                    177,
                    193,
                    9,
                    35,
                    51,
                    82,
                    240,
                    21,
                    98,
                    114,
                    209,
                    10,
                    22,
                    36,
                    52,
                    225,
                    37,
                    241,
                    23,
                    24,
                    25,
                    26,
                    38,
                    39,
                    40,
                    41,
                    42,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    67,
                    68,
                    69,
                    70,
                    71,
                    72,
                    73,
                    74,
                    83,
                    84,
                    85,
                    86,
                    87,
                    88,
                    89,
                    90,
                    99,
                    100,
                    101,
                    102,
                    103,
                    104,
                    105,
                    106,
                    115,
                    116,
                    117,
                    118,
                    119,
                    120,
                    121,
                    122,
                    130,
                    131,
                    132,
                    133,
                    134,
                    135,
                    136,
                    137,
                    138,
                    146,
                    147,
                    148,
                    149,
                    150,
                    151,
                    152,
                    153,
                    154,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250
                ]), m = new Uint32Array([
                    0,
                    1,
                    8,
                    16,
                    9,
                    2,
                    3,
                    10,
                    17,
                    24,
                    32,
                    25,
                    18,
                    11,
                    4,
                    5,
                    12,
                    19,
                    26,
                    33,
                    40,
                    48,
                    41,
                    34,
                    27,
                    20,
                    13,
                    6,
                    7,
                    14,
                    21,
                    28,
                    35,
                    42,
                    49,
                    56,
                    57,
                    50,
                    43,
                    36,
                    29,
                    22,
                    15,
                    23,
                    30,
                    37,
                    44,
                    51,
                    58,
                    59,
                    52,
                    45,
                    38,
                    31,
                    39,
                    46,
                    53,
                    60,
                    61,
                    54,
                    47,
                    55,
                    62,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63,
                    63
                ]), g = new Uint32Array([
                    0,
                    1,
                    5,
                    6,
                    14,
                    15,
                    27,
                    28,
                    2,
                    4,
                    7,
                    13,
                    16,
                    26,
                    29,
                    42,
                    3,
                    8,
                    12,
                    17,
                    25,
                    30,
                    41,
                    43,
                    9,
                    11,
                    18,
                    24,
                    31,
                    40,
                    44,
                    53,
                    10,
                    19,
                    23,
                    32,
                    39,
                    45,
                    52,
                    54,
                    20,
                    22,
                    33,
                    38,
                    46,
                    51,
                    55,
                    60,
                    21,
                    34,
                    37,
                    47,
                    50,
                    56,
                    59,
                    61,
                    35,
                    36,
                    48,
                    49,
                    57,
                    58,
                    62,
                    63
                ]), b = new Float64Array([
                    1,
                    1.387039845,
                    1.306562965,
                    1.175875602,
                    1,
                    .785694958,
                    .5411961,
                    .275899379
                ]), x = new Uint32Array([
                    16,
                    11,
                    10,
                    16,
                    24,
                    40,
                    51,
                    61,
                    12,
                    12,
                    14,
                    19,
                    26,
                    58,
                    60,
                    55,
                    14,
                    13,
                    16,
                    24,
                    40,
                    57,
                    69,
                    56,
                    14,
                    17,
                    22,
                    29,
                    51,
                    87,
                    80,
                    62,
                    18,
                    22,
                    37,
                    56,
                    68,
                    109,
                    103,
                    77,
                    24,
                    35,
                    55,
                    64,
                    81,
                    104,
                    113,
                    92,
                    49,
                    64,
                    78,
                    87,
                    103,
                    121,
                    120,
                    101,
                    72,
                    92,
                    95,
                    98,
                    112,
                    100,
                    103,
                    99
                ]), y = new Uint32Array([
                    17,
                    18,
                    24,
                    47,
                    99,
                    99,
                    99,
                    99,
                    18,
                    21,
                    26,
                    66,
                    99,
                    99,
                    99,
                    99,
                    24,
                    26,
                    56,
                    99,
                    99,
                    99,
                    99,
                    99,
                    47,
                    66,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99
                ]);
                var _ = new function() {
                    var t, n = new Float64Array(64), o = new Float64Array(64), i = new Float64Array(64), _ = new Float64Array(64), w = new Float64Array(64), S = new Int32Array(64), M = new Int32Array(64), T = new Int32Array(64), I = new Array(256), D = new Array(256), E = new Array(256), A = new Array(256), C = function(t) {
                        var e, r, i;
                        for(e = 0; e < 64; ++e){
                            var a = .01 * (x[e] * t + 50) | 0;
                            a < 1 ? a = 1 : a > 255 && (a = 255), S[g[e]] = a;
                        }
                        for(e = 0; e < 64; e++){
                            var c = .01 * (y[e] * t + 50) | 0;
                            c < 1 ? c = 1 : c > 255 && (c = 255), M[g[e]] = c;
                        }
                        for(e = 0, r = 0; r < 8; ++r)for(i = 0; i < 8; ++i)n[e] = 1 / (S[g[e]] * b[r] * b[i] * 8), o[e] = 1 / (M[g[e]] * b[r] * b[i] * 8), e++;
                    }, z = function(t, e, r) {
                        var n, o, i = 0, a = 0;
                        for(n = 0; n < 256; n++)r[n] = [
                            0,
                            0
                        ];
                        for(n = 1; n <= 16; ++n){
                            for(o = 1; o <= t[n]; ++o)r[e[a]] = [
                                i,
                                n
                            ], a++, i++;
                            i <<= 1;
                        }
                    };
                    function O(t, e, n) {
                        let o;
                        o = "Exif" === n || "META" === n ? n.length + 6 : n.length + 5, a.setBuffer(new ArrayBuffer(o)), a.putShort(t), a.putShort(o - 2 + e.byteLength);
                        for(let t = 0; t < n.length; t++)a.putByte(n.charCodeAt(t));
                        r.push(a.getBuffer()), r.push(e);
                    }
                    function F(t, e = "Exif") {
                        O(65505, t, e);
                    }
                    function R(t, e) {
                        return t < 0 ? t + (1 << e) - 1 : t;
                    }
                    function P(t, e) {
                        for(e = 0; 0 != t;)t >>= 1, e++;
                        return e;
                    }
                    function L(t) {
                        return t > 0 ? t : -t;
                    }
                    function k(e, r, n, o, i) {
                        var a, c, u = function(t, e) {
                            var r, n, o, i, a, c, u, s, l, f, h, d, p, v, m, g, b, x, y, _, w, S, M, I, D, E, A, C, z, O = 0;
                            for(f = 0; f < 8; ++f)n = t[O], o = t[O + 1], i = t[O + 2], a = t[O + 3], c = t[O + 4], u = t[O + 5], s = t[O + 6], x = n - (l = t[O + 7]), b = o - s, g = i - u, m = a - c, y = (h = n + l) + (v = a + c), S = h - v, _ = (d = o + s) + (p = i + u), w = d - p, t[O] = y + _, t[O + 4] = y - _, M = .707106781 * (w + S), t[O + 2] = S + M, t[O + 6] = S - M, I = .5411961 * (y = m + g) + (A = .382683433 * (y - (w = b + x))), E = 1.306562965 * w + A, C = x + (D = .707106781 * (_ = g + b)), z = x - D, t[O + 5] = z + I, t[O + 3] = z - I, t[O + 1] = C + E, t[O + 7] = C - E, O += 8;
                            for(O = 0, f = 0; f < 8; ++f)n = t[O], o = t[O + 8], i = t[O + 16], a = t[O + 24], c = t[O + 32], u = t[O + 40], s = t[O + 48], x = n - (l = t[O + 56]), b = o - s, g = i - u, m = a - c, y = (h = n + l) + (v = a + c), S = h - v, _ = (d = o + s) + (p = i + u), w = d - p, t[O] = y + _, t[O + 32] = y - _, M = .707106781 * (w + S), t[O + 16] = S + M, t[O + 48] = S - M, I = .5411961 * (y = m + g) + (A = .382683433 * (y - (w = b + x))), E = 1.306562965 * w + A, C = x + (D = .707106781 * (_ = g + b)), z = x - D, t[O + 40] = z + I, t[O + 24] = z - I, t[O + 8] = C + E, t[O + 56] = C - E, O++;
                            for(f = 0; f < 64; ++f)r = t[f] * e[f], T[f] = r > 0 ? r + .5 | 0 : r - .5 | 0;
                            return T;
                        }(e, r);
                        a = u[0] - n | 0, c = u[0];
                        var s, l, f = 0;
                        f = P(L(a), f), t.putbits(o[f][0], o[f][1]), f && (a = R(a, f), t.putbits(a, f));
                        for(var h = 0, d = 0;;){
                            for(d++, s = 0; 0 == (l = u[m[d]]) && d < 64; d++, s++);
                            if (d >= 64) break;
                            for(; s >= 16;)t.putbits(i[240][0], i[240][1]), s -= 16;
                            var p = 0, v = s << 4 | (p = P(L(l), p));
                            t.putbits(i[v][0], i[v][1]), p && (l = R(l, p), t.putbits(l, p)), h = d;
                        }
                        return 63 != h && t.putbits(i[0][0], i[0][1]), c;
                    }
                    function j(t, r, n) {
                        var o, a, c, u, s, l, f = r * e.width * n + t * n, h = e.width * n, d = t + 8 > e.width ? e.width - t : 8, p = r + 8 > e.height ? e.height - r : 8, v = e.data, m = 0;
                        if (8 == d && 8 == p) for(a = 0; a < 8; a++)for(o = 0; o < 8; o++)u = v[c = f + a * h + o * n], s = v[c + 1], l = v[c + 2], i[m] = .299 * u + .587 * s + .114 * l - 128, _[m] = -0.16874 * u + -0.33126 * s + .5 * l, w[m++] = .5 * u + -0.41869 * s + -0.08131 * l;
                        else for(a = 0; a < 8; a++)for(o = 0; o < 8; o++){
                            var g = o, b = a;
                            o >= d && (g = d - 1), a >= p && (b = p - 1), u = v[c = f + b * h + g * n], s = v[c + 1], l = v[c + 2], i[m] = .299 * u + .587 * s + .114 * l - 128, _[m] = -0.16874 * u + -0.33126 * s + .5 * l, w[m++] = .5 * u + -0.41869 * s + -0.08131 * l;
                        }
                    }
                    this.encode = function(m, g = {}) {
                        e || console.log("input image not provided. aborting encode"), function(t) {
                            t <= 0 && (t = 1), t > 95 && (t = 95), C(t < 50 ? 5e3 / t | 0 : 200 - (t << 1) | 0);
                        }(m), t = new c(e), a.setBuffer(new ArrayBuffer(2)), a.putShort(65496), r.push(a.getBuffer()), g.exif ? F(g.exif, "Exif") : (a.setBuffer(new ArrayBuffer(18)), a.putShort(65504), a.putShort(16), a.putByte(74), a.putByte(70), a.putByte(73), a.putByte(70), a.putByte(0), a.putByte(1), a.putByte(1), a.putByte(0), a.putShort(1), a.putShort(1), a.putByte(0), a.putByte(0), r.push(a.getBuffer())), g.xmp && F(g.xmp, "http://ns.adobe.com/xap/1.0/"), g.iptc && function(t, e = "Photoshop 3.0") {
                            O(65517, t, e);
                        }(g.iptc, "Photoshop 3.0"), function() {
                            var t;
                            for(a.setBuffer(new ArrayBuffer(134)), a.putShort(65499), a.putShort(132), a.putByte(0), t = 0; t < 64; ++t)a.putByte(S[t]);
                            for(a.putByte(1), t = 0; t < 64; ++t)a.putByte(M[t]);
                            r.push(a.getBuffer());
                        }(), function(t, e) {
                            a.setBuffer(new ArrayBuffer(19)), a.putShort(65472), a.putShort(17), a.putByte(8), a.putShort(e), a.putShort(t), a.putByte(3), a.putByte(1), a.putByte(17), a.putByte(0), a.putByte(2), a.putByte(17), a.putByte(1), a.putByte(3), a.putByte(17), a.putByte(1), r.push(a.getBuffer());
                        }(e.width, e.height), function() {
                            var t;
                            for(a.setBuffer(new ArrayBuffer(420)), a.putShort(65476), a.putShort(418), a.putByte(0), t = 0; t < 16; ++t)a.putByte(u[t + 1]);
                            for(t = 0; t <= 11; ++t)a.putByte(s[t]);
                            for(a.putByte(16), t = 0; t < 16; ++t)a.putByte(l[t + 1]);
                            for(t = 0; t <= 161; ++t)a.putByte(f[t]);
                            for(a.putByte(1), t = 0; t < 16; ++t)a.putByte(h[t + 1]);
                            for(t = 0; t <= 11; ++t)a.putByte(d[t]);
                            for(a.putByte(17), t = 0; t < 16; ++t)a.putByte(p[t + 1]);
                            for(t = 0; t <= 161; ++t)a.putByte(v[t]);
                            r.push(a.getBuffer());
                        }(), a.setBuffer(new ArrayBuffer(14)), a.putShort(65498), a.putShort(12), a.putByte(3), a.putByte(1), a.putByte(0), a.putByte(2), a.putByte(17), a.putByte(3), a.putByte(17), a.putByte(0), a.putByte(63), a.putByte(0), r.push(a.getBuffer());
                        var b, x, y = 0, T = 0, z = 0, R = e.width, P = e.height, L = 4;
                        for(e.data.length < R * P * 4 && (L = 3), b = 0; b < P; b += 8)for(x = 0; x < R; x += 8)j(x, b, L), T = k(i, n, T, I, E), y = k(_, o, y, D, A), z = k(w, o, z, D, A);
                        t.align(), t.putshort(65497), t.end();
                        var U = t.getWrittenBytes();
                        return r.push(e.data.buffer.slice(0, U)), r;
                    }, z(u, s, I), z(h, d, D), z(l, f, E), z(p, v, A);
                };
                t.exports = function(t, n, o) {
                    n = n || 80, e = t, r = [];
                    var i = _.encode(n, o);
                    return e = null, r = null, i;
                };
            }();
        },
        function(t, e, r) {
            var n = r(614), o = function() {
                for(var t = new Uint32Array(256), e = 0; e < 256; e++){
                    for(var r = e, n = 0; n < 8; n++)r = !0 & r ? 3988292384 ^ r >>> 1 : r >>> 1;
                    t[e] = r;
                }
                return function(e) {
                    for(var r = 1; r < arguments.length; r++)for(var n = 0; n < arguments[r].length; n++)e = t[255 & (e ^ arguments[r][n])] ^ e >>> 8;
                    return ~e;
                };
            }();
            t.exports = function(t, e, r) {
                logTime("encode PNG");
                let i = !0, a = 4;
                t.length < e * r * 4 && (a = 3, i = !1);
                for(var c = 0, u = new Uint8Array(e * r * a + r), s = 0, l = 0; l < r; l++){
                    u[s++] = 0;
                    for(var f = 0; f < e; f++)u[s++] = t[c], u[s++] = t[c + 1], u[s++] = t[c + 2], i && (u[s++] = t[c + 3]), c += a;
                }
                var h = [];
                function d(t, e) {
                    var r = new Uint8Array(4);
                    p(r, 0, e.length);
                    var n = new Uint8Array(4);
                    n[0] = t.charCodeAt(0), n[1] = t.charCodeAt(1), n[2] = t.charCodeAt(2), n[3] = t.charCodeAt(3);
                    var i = new Uint8Array(4);
                    p(i, 0, o(4294967295, n, e)), h.push(r.buffer), h.push(n.buffer), h.push(e.buffer), h.push(i.buffer);
                }
                function p(t, e, r) {
                    t[e] = r >>> 24, t[e + 1] = r >>> 16, t[e + 2] = r >>> 8, t[e + 3] = r;
                }
                h.push(new Uint8Array([
                    137,
                    80,
                    78,
                    71,
                    13,
                    10,
                    26,
                    10
                ]).buffer);
                var v = new Uint8Array(13);
                return p(v, 0, e), p(v, 4, r), v[8] = 8, v[9] = i ? 6 : 2, v[10] = 0, v[11] = 0, v[12] = 0, d("IHDR", v), d("IDAT", n.deflate(u, {
                    level: 4
                })), d("IEND", new Uint8Array(0)), logTimeEnd("encode PNG"), h;
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function(t, e, r, n) {
                var o, i = (o = new ArrayBuffer(2), new DataView(o).setInt16(0, 256, !0), 256 === new Int16Array(o)[0]), a = !i, c = function(t, e, r, n, o) {
                    switch(t.setUint16(e, r, a), e += 2, t.setUint16(e, n, a), e += 2, t.setUint32(e, 1, a), e += 4, n){
                        case 1:
                        case 2:
                            t.setUint8(e, o);
                            break;
                        case 3:
                            t.setUint16(e, o, a);
                            break;
                        case 4:
                            t.setUint32(e, o, a);
                    }
                    return e += 4;
                };
                if (!n) {
                    n = new ArrayBuffer(198);
                    var u, s = new DataView(n);
                    s.setUint16(0, i ? 19789 : 18761, a), s.setUint16(2, 42, a), s.setUint32(4, 8, a), s.setUint16(8, 14, a), u = c(s, 10, 254, 4, 0), u = c(s, u, 256, 3, e), u = c(s, u, 257, 3, r), s.setUint16(u, 258, a), s.setUint16(u + 2, 3, a), s.setUint32(u + 4, 3, a), s.setUint32(u + 8, 192, a), u = c(s, u += 12, 259, 3, 1), u = c(s, u, 262, 3, 2), u = c(s, u, 273, 4, n.byteLength), u = c(s, u, 274, 3, 1), u = c(s, u, 277, 3, 3), u = c(s, u, 278, 3, r), u = c(s, u, 279, 4, e * r * 3), u = c(s, u, 282, 4, 72), u = c(s, u, 283, 4, 72), u = c(s, u, 284, 3, 1), u = c(s, u, 296, 3, 2), s.setUint16(u, 0, a), s.setUint16(u + 2, 8, a), s.setUint16(u + 4, 8, a), s.setUint16(u + 6, 8, a);
                }
                for(var l, f, h, d = new Uint8Array(e * r * 3), p = 0; p < r; p++)for(var v = 0; v < e; v++)h = 4 * (l = v + p * e), d[f = 3 * l] = t[h], d[f + 1] = t[h + 1], d[f + 2] = t[h + 2];
                return [
                    n,
                    d.buffer
                ];
            };
        },
        ,
        ,
        ,
        ,
        ,
        function(t, e, r) {
            r(207), r(208), t.exports = r(621);
        },
        function(t, e, r) {
            (function(t) {
                ("undefined" != typeof window ? window : void 0 !== t ? t : "undefined" != typeof self ? self : {}).SENTRY_RELEASE = {
                    id: "ca51a2dc746993da277eec3c20ed50bf0b2ff184"
                };
            }).call(this, r(81));
        },
        function(t, e, r) {
            "use strict";
            r(209);
            var n, o = (n = r(381)) && n.__esModule ? n : {
                default: n
            };
            o.default._babelPolyfill && "undefined" != typeof console && console.warn && console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning."), o.default._babelPolyfill = !0;
        },
        function(t, e, r) {
            "use strict";
            r(210), r(353), r(355), r(358), r(360), r(362), r(364), r(366), r(368), r(370), r(372), r(374), r(376), r(380);
        },
        function(t, e, r) {
            r(211), r(214), r(215), r(216), r(217), r(218), r(219), r(220), r(221), r(222), r(223), r(224), r(225), r(226), r(227), r(228), r(229), r(230), r(231), r(232), r(233), r(234), r(235), r(236), r(237), r(238), r(239), r(240), r(241), r(242), r(243), r(244), r(245), r(246), r(247), r(248), r(249), r(250), r(251), r(252), r(253), r(254), r(255), r(257), r(258), r(259), r(260), r(261), r(262), r(263), r(264), r(265), r(266), r(267), r(268), r(269), r(270), r(271), r(272), r(273), r(274), r(275), r(276), r(277), r(278), r(279), r(280), r(281), r(282), r(283), r(284), r(285), r(286), r(287), r(288), r(289), r(290), r(292), r(293), r(295), r(296), r(297), r(298), r(299), r(300), r(301), r(303), r(304), r(305), r(306), r(307), r(308), r(309), r(310), r(311), r(312), r(313), r(314), r(315), r(102), r(316), r(149), r(317), r(150), r(318), r(319), r(320), r(321), r(151), r(324), r(325), r(326), r(327), r(328), r(329), r(330), r(331), r(332), r(333), r(334), r(335), r(336), r(337), r(338), r(339), r(340), r(341), r(342), r(343), r(344), r(345), r(346), r(347), r(348), r(349), r(350), r(351), r(352), t.exports = r(8);
        },
        function(t, e, r) {
            "use strict";
            var n = r(2), o = r(14), i = r(9), a = r(0), c = r(12), u = r(30).KEY, s = r(3), l = r(58), f = r(44), h = r(32), d = r(6), p = r(83), v = r(130), m = r(213), g = r(61), b = r(4), x = r(5), y = r(11), _ = r(16), w = r(29), S = r(31), M = r(36), T = r(133), I = r(21), D = r(60), E = r(10), A = r(34), C = I.f, z = E.f, O = T.f, F = n.Symbol, R = n.JSON, P = R && R.stringify, L = d("_hidden"), k = d("toPrimitive"), j = {}.propertyIsEnumerable, U = l("symbol-registry"), B = l("symbols"), N = l("op-symbols"), G = Object.prototype, V = "function" == typeof F && !!D.f, q = n.QObject, Y = !q || !q.prototype || !q.prototype.findChild, H = i && s(function() {
                return 7 != M(z({}, "a", {
                    get: function() {
                        return z(this, "a", {
                            value: 7
                        }).a;
                    }
                })).a;
            }) ? function(t, e, r) {
                var n = C(G, e);
                n && delete G[e], z(t, e, r), n && t !== G && z(G, e, n);
            } : z, W = function(t) {
                var e = B[t] = M(F.prototype);
                return e._k = t, e;
            }, X = V && "symbol" == typeof F.iterator ? function(t) {
                return "symbol" == typeof t;
            } : function(t) {
                return t instanceof F;
            }, K = function(t, e, r) {
                return t === G && K(N, e, r), b(t), e = w(e, !0), b(r), o(B, e) ? (r.enumerable ? (o(t, L) && t[L][e] && (t[L][e] = !1), r = M(r, {
                    enumerable: S(0, !1)
                })) : (o(t, L) || z(t, L, S(1, {})), t[L][e] = !0), H(t, e, r)) : z(t, e, r);
            }, Z = function(t, e) {
                b(t);
                for(var r, n = m(e = _(e)), o = 0, i = n.length; i > o;)K(t, r = n[o++], e[r]);
                return t;
            }, J = function(t) {
                var e = j.call(this, t = w(t, !0));
                return !(this === G && o(B, t) && !o(N, t)) && (!(e || !o(this, t) || !o(B, t) || o(this, L) && this[L][t]) || e);
            }, $ = function(t, e) {
                if (t = _(t), e = w(e, !0), t !== G || !o(B, e) || o(N, e)) {
                    var r = C(t, e);
                    return !r || !o(B, e) || o(t, L) && t[L][e] || (r.enumerable = !0), r;
                }
            }, Q = function(t) {
                for(var e, r = O(_(t)), n = [], i = 0; r.length > i;)o(B, e = r[i++]) || e == L || e == u || n.push(e);
                return n;
            }, tt = function(t) {
                for(var e, r = t === G, n = O(r ? N : _(t)), i = [], a = 0; n.length > a;)!o(B, e = n[a++]) || r && !o(G, e) || i.push(B[e]);
                return i;
            };
            V || (c((F = function() {
                if (this instanceof F) throw TypeError("Symbol is not a constructor!");
                var t = h(arguments.length > 0 ? arguments[0] : void 0), e = function(r) {
                    this === G && e.call(N, r), o(this, L) && o(this[L], t) && (this[L][t] = !1), H(this, t, S(1, r));
                };
                return i && Y && H(G, t, {
                    configurable: !0,
                    set: e
                }), W(t);
            }).prototype, "toString", function() {
                return this._k;
            }), I.f = $, E.f = K, r(37).f = T.f = Q, r(51).f = J, D.f = tt, i && !r(33) && c(G, "propertyIsEnumerable", J, !0), p.f = function(t) {
                return W(d(t));
            }), a(a.G + a.W + a.F * !V, {
                Symbol: F
            });
            for(var et = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), rt = 0; et.length > rt;)d(et[rt++]);
            for(var nt = A(d.store), ot = 0; nt.length > ot;)v(nt[ot++]);
            a(a.S + a.F * !V, "Symbol", {
                for: function(t) {
                    return o(U, t += "") ? U[t] : U[t] = F(t);
                },
                keyFor: function(t) {
                    if (!X(t)) throw TypeError(t + " is not a symbol!");
                    for(var e in U)if (U[e] === t) return e;
                },
                useSetter: function() {
                    Y = !0;
                },
                useSimple: function() {
                    Y = !1;
                }
            }), a(a.S + a.F * !V, "Object", {
                create: function(t, e) {
                    return void 0 === e ? M(t) : Z(M(t), e);
                },
                defineProperty: K,
                defineProperties: Z,
                getOwnPropertyDescriptor: $,
                getOwnPropertyNames: Q,
                getOwnPropertySymbols: tt
            });
            var it = s(function() {
                D.f(1);
            });
            a(a.S + a.F * it, "Object", {
                getOwnPropertySymbols: function(t) {
                    return D.f(y(t));
                }
            }), R && a(a.S + a.F * (!V || s(function() {
                var t = F();
                return "[null]" != P([
                    t
                ]) || "{}" != P({
                    a: t
                }) || "{}" != P(Object(t));
            })), "JSON", {
                stringify: function(t) {
                    for(var e, r, n = [
                        t
                    ], o = 1; arguments.length > o;)n.push(arguments[o++]);
                    if (r = e = n[1], (x(e) || void 0 !== t) && !X(t)) return g(e) || (e = function(t, e) {
                        if ("function" == typeof r && (e = r.call(this, t, e)), !X(e)) return e;
                    }), n[1] = e, P.apply(R, n);
                }
            }), F.prototype[k] || r(15)(F.prototype, k, F.prototype.valueOf), f(F, "Symbol"), f(Math, "Math", !0), f(n.JSON, "JSON", !0);
        },
        function(t, e, r) {
            t.exports = r(58)("native-function-to-string", Function.toString);
        },
        function(t, e, r) {
            var n = r(34), o = r(60), i = r(51);
            t.exports = function(t) {
                var e = n(t), r = o.f;
                if (r) for(var a, c = r(t), u = i.f, s = 0; c.length > s;)u.call(t, a = c[s++]) && e.push(a);
                return e;
            };
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Object", {
                create: r(36)
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S + n.F * !r(9), "Object", {
                defineProperty: r(10).f
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S + n.F * !r(9), "Object", {
                defineProperties: r(132)
            });
        },
        function(t, e, r) {
            var n = r(16), o = r(21).f;
            r(22)("getOwnPropertyDescriptor", function() {
                return function(t, e) {
                    return o(n(t), e);
                };
            });
        },
        function(t, e, r) {
            var n = r(11), o = r(38);
            r(22)("getPrototypeOf", function() {
                return function(t) {
                    return o(n(t));
                };
            });
        },
        function(t, e, r) {
            var n = r(11), o = r(34);
            r(22)("keys", function() {
                return function(t) {
                    return o(n(t));
                };
            });
        },
        function(t, e, r) {
            r(22)("getOwnPropertyNames", function() {
                return r(133).f;
            });
        },
        function(t, e, r) {
            var n = r(5), o = r(30).onFreeze;
            r(22)("freeze", function(t) {
                return function(e) {
                    return t && n(e) ? t(o(e)) : e;
                };
            });
        },
        function(t, e, r) {
            var n = r(5), o = r(30).onFreeze;
            r(22)("seal", function(t) {
                return function(e) {
                    return t && n(e) ? t(o(e)) : e;
                };
            });
        },
        function(t, e, r) {
            var n = r(5), o = r(30).onFreeze;
            r(22)("preventExtensions", function(t) {
                return function(e) {
                    return t && n(e) ? t(o(e)) : e;
                };
            });
        },
        function(t, e, r) {
            var n = r(5);
            r(22)("isFrozen", function(t) {
                return function(e) {
                    return !n(e) || !!t && t(e);
                };
            });
        },
        function(t, e, r) {
            var n = r(5);
            r(22)("isSealed", function(t) {
                return function(e) {
                    return !n(e) || !!t && t(e);
                };
            });
        },
        function(t, e, r) {
            var n = r(5);
            r(22)("isExtensible", function(t) {
                return function(e) {
                    return !!n(e) && (!t || t(e));
                };
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S + n.F, "Object", {
                assign: r(134)
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Object", {
                is: r(135)
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Object", {
                setPrototypeOf: r(87).set
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(52), o = {};
            o[r(6)("toStringTag")] = "z", o + "" != "[object z]" && r(12)(Object.prototype, "toString", function() {
                return "[object " + n(this) + "]";
            }, !0);
        },
        function(t, e, r) {
            var n = r(0);
            n(n.P, "Function", {
                bind: r(136)
            });
        },
        function(t, e, r) {
            var n = r(10).f, o = Function.prototype, i = /^\s*function ([^ (]*)/;
            "name" in o || r(9) && n(o, "name", {
                configurable: !0,
                get: function() {
                    try {
                        return ("" + this).match(i)[1];
                    } catch (t) {
                        return "";
                    }
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(5), o = r(38), i = r(6)("hasInstance"), a = Function.prototype;
            i in a || r(10).f(a, i, {
                value: function(t) {
                    if ("function" != typeof this || !n(t)) return !1;
                    if (!n(this.prototype)) return t instanceof this;
                    for(; t = o(t);)if (this.prototype === t) return !0;
                    return !1;
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(138);
            n(n.G + n.F * (parseInt != o), {
                parseInt: o
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(139);
            n(n.G + n.F * (parseFloat != o), {
                parseFloat: o
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(2), o = r(14), i = r(26), a = r(89), c = r(29), u = r(3), s = r(37).f, l = r(21).f, f = r(10).f, h = r(45).trim, d = n.Number, p = d, v = d.prototype, m = "Number" == i(r(36)(v)), g = "trim" in String.prototype, b = function(t) {
                var e = c(t, !1);
                if ("string" == typeof e && e.length > 2) {
                    var r, n, o, i = (e = g ? e.trim() : h(e, 3)).charCodeAt(0);
                    if (43 === i || 45 === i) {
                        if (88 === (r = e.charCodeAt(2)) || 120 === r) return NaN;
                    } else if (48 === i) {
                        switch(e.charCodeAt(1)){
                            case 66:
                            case 98:
                                n = 2, o = 49;
                                break;
                            case 79:
                            case 111:
                                n = 8, o = 55;
                                break;
                            default:
                                return +e;
                        }
                        for(var a, u = e.slice(2), s = 0, l = u.length; s < l; s++)if ((a = u.charCodeAt(s)) < 48 || a > o) return NaN;
                        return parseInt(u, n);
                    }
                }
                return +e;
            };
            if (!d(" 0o1") || !d("0b1") || d("+0x1")) {
                d = function(t) {
                    var e = arguments.length < 1 ? 0 : t, r = this;
                    return r instanceof d && (m ? u(function() {
                        v.valueOf.call(r);
                    }) : "Number" != i(r)) ? a(new p(b(e)), r, d) : b(e);
                };
                for(var x, y = r(9) ? s(p) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), _ = 0; y.length > _; _++)o(p, x = y[_]) && !o(d, x) && f(d, x, l(p, x));
                d.prototype = v, v.constructor = d, r(12)(n, "Number", d);
            }
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(20), i = r(140), a = r(90), c = 1..toFixed, u = Math.floor, s = [
                0,
                0,
                0,
                0,
                0,
                0
            ], l = "Number.toFixed: incorrect invocation!", f = function(t, e) {
                for(var r = -1, n = e; ++r < 6;)n += t * s[r], s[r] = n % 1e7, n = u(n / 1e7);
            }, h = function(t) {
                for(var e = 6, r = 0; --e >= 0;)r += s[e], s[e] = u(r / t), r = r % t * 1e7;
            }, d = function() {
                for(var t = 6, e = ""; --t >= 0;)if ("" !== e || 0 === t || 0 !== s[t]) {
                    var r = String(s[t]);
                    e = "" === e ? r : e + a.call("0", 7 - r.length) + r;
                }
                return e;
            }, p = function(t, e, r) {
                return 0 === e ? r : e % 2 == 1 ? p(t, e - 1, r * t) : p(t * t, e / 2, r);
            };
            n(n.P + n.F * (!!c && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !r(3)(function() {
                c.call({});
            })), "Number", {
                toFixed: function(t) {
                    var e, r, n, c, u = i(this, l), s = o(t), v = "", m = "0";
                    if (s < 0 || s > 20) throw RangeError(l);
                    if (u != u) return "NaN";
                    if (u <= -1000000000000000000000 || u >= 1e21) return String(u);
                    if (u < 0 && (v = "-", u = -u), u > 1e-21) {
                        if (r = (e = function(t) {
                            for(var e = 0, r = t; r >= 4096;)e += 12, r /= 4096;
                            for(; r >= 2;)e += 1, r /= 2;
                            return e;
                        }(u * p(2, 69, 1)) - 69) < 0 ? u * p(2, -e, 1) : u / p(2, e, 1), r *= 4503599627370496, (e = 52 - e) > 0) {
                            for(f(0, r), n = s; n >= 7;)f(1e7, 0), n -= 7;
                            for(f(p(10, n, 1), 0), n = e - 1; n >= 23;)h(8388608), n -= 23;
                            h(1 << n), f(1, 1), h(2), m = d();
                        } else f(0, r), f(1 << -e, 0), m = d() + a.call("0", s);
                    }
                    return m = s > 0 ? v + ((c = m.length) <= s ? "0." + a.call("0", s - c) + m : m.slice(0, c - s) + "." + m.slice(c - s)) : v + m;
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(3), i = r(140), a = 1..toPrecision;
            n(n.P + n.F * (o(function() {
                return "1" !== a.call(1, void 0);
            }) || !o(function() {
                a.call({});
            })), "Number", {
                toPrecision: function(t) {
                    var e = i(this, "Number#toPrecision: incorrect invocation!");
                    return void 0 === t ? a.call(e) : a.call(e, t);
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Number", {
                EPSILON: Math.pow(2, -52)
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(2).isFinite;
            n(n.S, "Number", {
                isFinite: function(t) {
                    return "number" == typeof t && o(t);
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Number", {
                isInteger: r(141)
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Number", {
                isNaN: function(t) {
                    return t != t;
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(141), i = Math.abs;
            n(n.S, "Number", {
                isSafeInteger: function(t) {
                    return o(t) && i(t) <= 9007199254740991;
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Number", {
                MAX_SAFE_INTEGER: 9007199254740991
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Number", {
                MIN_SAFE_INTEGER: -9007199254740991
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(139);
            n(n.S + n.F * (Number.parseFloat != o), "Number", {
                parseFloat: o
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(138);
            n(n.S + n.F * (Number.parseInt != o), "Number", {
                parseInt: o
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(142), i = Math.sqrt, a = Math.acosh;
            n(n.S + n.F * !(a && 710 == Math.floor(a(Number.MAX_VALUE)) && a(1 / 0) == 1 / 0), "Math", {
                acosh: function(t) {
                    return (t = +t) < 1 ? NaN : t > 94906265.62425156 ? Math.log(t) + Math.LN2 : o(t - 1 + i(t - 1) * i(t + 1));
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = Math.asinh;
            n(n.S + n.F * !(o && 1 / o(0) > 0), "Math", {
                asinh: function t(e) {
                    return isFinite(e = +e) && 0 != e ? e < 0 ? -t(-e) : Math.log(e + Math.sqrt(e * e + 1)) : e;
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = Math.atanh;
            n(n.S + n.F * !(o && 1 / o(-0) < 0), "Math", {
                atanh: function(t) {
                    return 0 == (t = +t) ? t : Math.log((1 + t) / (1 - t)) / 2;
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(91);
            n(n.S, "Math", {
                cbrt: function(t) {
                    return o(t = +t) * Math.pow(Math.abs(t), 1 / 3);
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Math", {
                clz32: function(t) {
                    return (t >>>= 0) ? 31 - Math.floor(Math.log(t + .5) * Math.LOG2E) : 32;
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = Math.exp;
            n(n.S, "Math", {
                cosh: function(t) {
                    return (o(t = +t) + o(-t)) / 2;
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(92);
            n(n.S + n.F * (o != Math.expm1), "Math", {
                expm1: o
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Math", {
                fround: r(256)
            });
        },
        function(t, e, r) {
            var n = r(91), o = Math.pow, i = o(2, -52), a = o(2, -23), c = o(2, 127) * (2 - a), u = o(2, -126);
            t.exports = Math.fround || function(t) {
                var e, r, o = Math.abs(t), s = n(t);
                return o < u ? s * (o / u / a + 1 / i - 1 / i) * u * a : (r = (e = (1 + a / i) * o) - (e - o)) > c || r != r ? s * (1 / 0) : s * r;
            };
        },
        function(t, e, r) {
            var n = r(0), o = Math.abs;
            n(n.S, "Math", {
                hypot: function(t, e) {
                    for(var r, n, i = 0, a = 0, c = arguments.length, u = 0; a < c;)u < (r = o(arguments[a++])) ? (i = i * (n = u / r) * n + 1, u = r) : i += r > 0 ? (n = r / u) * n : r;
                    return u === 1 / 0 ? 1 / 0 : u * Math.sqrt(i);
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = Math.imul;
            n(n.S + n.F * r(3)(function() {
                return -5 != o(4294967295, 5) || 2 != o.length;
            }), "Math", {
                imul: function(t, e) {
                    var r = +t, n = +e, o = 65535 & r, i = 65535 & n;
                    return 0 | o * i + ((65535 & r >>> 16) * i + o * (65535 & n >>> 16) << 16 >>> 0);
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Math", {
                log10: function(t) {
                    return Math.log(t) * Math.LOG10E;
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Math", {
                log1p: r(142)
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Math", {
                log2: function(t) {
                    return Math.log(t) / Math.LN2;
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Math", {
                sign: r(91)
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(92), i = Math.exp;
            n(n.S + n.F * r(3)(function() {
                return -0.00000000000000002 != !Math.sinh(-0.00000000000000002);
            }), "Math", {
                sinh: function(t) {
                    return Math.abs(t = +t) < 1 ? (o(t) - o(-t)) / 2 : (i(t - 1) - i(-t - 1)) * (Math.E / 2);
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(92), i = Math.exp;
            n(n.S, "Math", {
                tanh: function(t) {
                    var e = o(t = +t), r = o(-t);
                    return e == 1 / 0 ? 1 : r == 1 / 0 ? -1 : (e - r) / (i(t) + i(-t));
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Math", {
                trunc: function(t) {
                    return (t > 0 ? Math.floor : Math.ceil)(t);
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(35), i = String.fromCharCode, a = String.fromCodePoint;
            n(n.S + n.F * (!!a && 1 != a.length), "String", {
                fromCodePoint: function(t) {
                    for(var e, r = [], n = arguments.length, a = 0; n > a;){
                        if (e = +arguments[a++], o(e, 1114111) !== e) throw RangeError(e + " is not a valid code point");
                        r.push(e < 65536 ? i(e) : i(55296 + ((e -= 65536) >> 10), e % 1024 + 56320));
                    }
                    return r.join("");
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(16), i = r(7);
            n(n.S, "String", {
                raw: function(t) {
                    for(var e = o(t.raw), r = i(e.length), n = arguments.length, a = [], c = 0; r > c;)a.push(String(e[c++])), c < n && a.push(String(arguments[c]));
                    return a.join("");
                }
            });
        },
        function(t, e, r) {
            "use strict";
            r(45)("trim", function(t) {
                return function() {
                    return t(this, 3);
                };
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(93)(!0);
            r(94)(String, "String", function(t) {
                this._t = String(t), this._i = 0;
            }, function() {
                var t, e = this._t, r = this._i;
                return r >= e.length ? {
                    value: void 0,
                    done: !0
                } : (t = n(e, r), this._i += t.length, {
                    value: t,
                    done: !1
                });
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(93)(!1);
            n(n.P, "String", {
                codePointAt: function(t) {
                    return o(this, t);
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(7), i = r(95), a = "".endsWith;
            n(n.P + n.F * r(97)("endsWith"), "String", {
                endsWith: function(t) {
                    var e = i(this, t, "endsWith"), r = arguments.length > 1 ? arguments[1] : void 0, n = o(e.length), c = void 0 === r ? n : Math.min(o(r), n), u = String(t);
                    return a ? a.call(e, u, c) : e.slice(c - u.length, c) === u;
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(95);
            n(n.P + n.F * r(97)("includes"), "String", {
                includes: function(t) {
                    return !!~o(this, t, "includes").indexOf(t, arguments.length > 1 ? arguments[1] : void 0);
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.P, "String", {
                repeat: r(90)
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(7), i = r(95), a = "".startsWith;
            n(n.P + n.F * r(97)("startsWith"), "String", {
                startsWith: function(t) {
                    var e = i(this, t, "startsWith"), r = o(Math.min(arguments.length > 1 ? arguments[1] : void 0, e.length)), n = String(t);
                    return a ? a.call(e, n, r) : e.slice(r, r + n.length) === n;
                }
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("anchor", function(t) {
                return function(e) {
                    return t(this, "a", "name", e);
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("big", function(t) {
                return function() {
                    return t(this, "big", "", "");
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("blink", function(t) {
                return function() {
                    return t(this, "blink", "", "");
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("bold", function(t) {
                return function() {
                    return t(this, "b", "", "");
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("fixed", function(t) {
                return function() {
                    return t(this, "tt", "", "");
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("fontcolor", function(t) {
                return function(e) {
                    return t(this, "font", "color", e);
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("fontsize", function(t) {
                return function(e) {
                    return t(this, "font", "size", e);
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("italics", function(t) {
                return function() {
                    return t(this, "i", "", "");
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("link", function(t) {
                return function(e) {
                    return t(this, "a", "href", e);
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("small", function(t) {
                return function() {
                    return t(this, "small", "", "");
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("strike", function(t) {
                return function() {
                    return t(this, "strike", "", "");
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("sub", function(t) {
                return function() {
                    return t(this, "sub", "", "");
                };
            });
        },
        function(t, e, r) {
            "use strict";
            r(13)("sup", function(t) {
                return function() {
                    return t(this, "sup", "", "");
                };
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Date", {
                now: function() {
                    return (new Date).getTime();
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(11), i = r(29);
            n(n.P + n.F * r(3)(function() {
                return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
                    toISOString: function() {
                        return 1;
                    }
                });
            }), "Date", {
                toJSON: function(t) {
                    var e = o(this), r = i(e);
                    return "number" != typeof r || isFinite(r) ? e.toISOString() : null;
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(291);
            n(n.P + n.F * (Date.prototype.toISOString !== o), "Date", {
                toISOString: o
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(3), o = Date.prototype.getTime, i = Date.prototype.toISOString, a = function(t) {
                return t > 9 ? t : "0" + t;
            };
            t.exports = n(function() {
                return "0385-07-25T07:06:39.999Z" != i.call(new Date(-50000000000001));
            }) || !n(function() {
                i.call(new Date(NaN));
            }) ? function() {
                if (!isFinite(o.call(this))) throw RangeError("Invalid time value");
                var t = this, e = t.getUTCFullYear(), r = t.getUTCMilliseconds(), n = e < 0 ? "-" : e > 9999 ? "+" : "";
                return n + ("00000" + Math.abs(e)).slice(n ? -6 : -4) + "-" + a(t.getUTCMonth() + 1) + "-" + a(t.getUTCDate()) + "T" + a(t.getUTCHours()) + ":" + a(t.getUTCMinutes()) + ":" + a(t.getUTCSeconds()) + "." + (r > 99 ? r : "0" + a(r)) + "Z";
            } : i;
        },
        function(t, e, r) {
            var n = Date.prototype, o = n.toString, i = n.getTime;
            new Date(NaN) + "" != "Invalid Date" && r(12)(n, "toString", function() {
                var t = i.call(this);
                return t == t ? o.call(this) : "Invalid Date";
            });
        },
        function(t, e, r) {
            var n = r(6)("toPrimitive"), o = Date.prototype;
            n in o || r(15)(o, n, r(294));
        },
        function(t, e, r) {
            "use strict";
            var n = r(4), o = r(29);
            t.exports = function(t) {
                if ("string" !== t && "number" !== t && "default" !== t) throw TypeError("Incorrect hint");
                return o(n(this), "number" != t);
            };
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Array", {
                isArray: r(61)
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(18), o = r(0), i = r(11), a = r(144), c = r(98), u = r(7), s = r(99), l = r(100);
            o(o.S + o.F * !r(62)(function(t) {
                Array.from(t);
            }), "Array", {
                from: function(t) {
                    var e, r, o, f, h = i(t), d = "function" == typeof this ? this : Array, p = arguments.length, v = p > 1 ? arguments[1] : void 0, m = void 0 !== v, g = 0, b = l(h);
                    if (m && (v = n(v, p > 2 ? arguments[2] : void 0, 2)), null == b || d == Array && c(b)) for(r = new d(e = u(h.length)); e > g; g++)s(r, g, m ? v(h[g], g) : h[g]);
                    else for(f = b.call(h), r = new d; !(o = f.next()).done; g++)s(r, g, m ? a(f, v, [
                        o.value,
                        g
                    ], !0) : o.value);
                    return r.length = g, r;
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(99);
            n(n.S + n.F * r(3)(function() {
                function t() {}
                return !(Array.of.call(t) instanceof t);
            }), "Array", {
                of: function() {
                    for(var t = 0, e = arguments.length, r = new ("function" == typeof this ? this : Array)(e); e > t;)o(r, t, arguments[t++]);
                    return r.length = e, r;
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(16), i = [].join;
            n(n.P + n.F * (r(50) != Object || !r(17)(i)), "Array", {
                join: function(t) {
                    return i.call(o(this), void 0 === t ? "," : t);
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(86), i = r(26), a = r(35), c = r(7), u = [].slice;
            n(n.P + n.F * r(3)(function() {
                o && u.call(o);
            }), "Array", {
                slice: function(t, e) {
                    var r = c(this.length), n = i(this);
                    if (e = void 0 === e ? r : e, "Array" == n) return u.call(this, t, e);
                    for(var o = a(t, r), s = a(e, r), l = c(s - o), f = new Array(l), h = 0; h < l; h++)f[h] = "String" == n ? this.charAt(o + h) : this[o + h];
                    return f;
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(19), i = r(11), a = r(3), c = [].sort, u = [
                1,
                2,
                3
            ];
            n(n.P + n.F * (a(function() {
                u.sort(void 0);
            }) || !a(function() {
                u.sort(null);
            }) || !r(17)(c)), "Array", {
                sort: function(t) {
                    return void 0 === t ? c.call(i(this)) : c.call(i(this), o(t));
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(23)(0), i = r(17)([].forEach, !0);
            n(n.P + n.F * !i, "Array", {
                forEach: function(t) {
                    return o(this, t, arguments[1]);
                }
            });
        },
        function(t, e, r) {
            var n = r(5), o = r(61), i = r(6)("species");
            t.exports = function(t) {
                var e;
                return o(t) && ("function" != typeof (e = t.constructor) || e !== Array && !o(e.prototype) || (e = void 0), n(e) && null === (e = e[i]) && (e = void 0)), void 0 === e ? Array : e;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(23)(1);
            n(n.P + n.F * !r(17)([].map, !0), "Array", {
                map: function(t) {
                    return o(this, t, arguments[1]);
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(23)(2);
            n(n.P + n.F * !r(17)([].filter, !0), "Array", {
                filter: function(t) {
                    return o(this, t, arguments[1]);
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(23)(3);
            n(n.P + n.F * !r(17)([].some, !0), "Array", {
                some: function(t) {
                    return o(this, t, arguments[1]);
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(23)(4);
            n(n.P + n.F * !r(17)([].every, !0), "Array", {
                every: function(t) {
                    return o(this, t, arguments[1]);
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(146);
            n(n.P + n.F * !r(17)([].reduce, !0), "Array", {
                reduce: function(t) {
                    return o(this, t, arguments.length, arguments[1], !1);
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(146);
            n(n.P + n.F * !r(17)([].reduceRight, !0), "Array", {
                reduceRight: function(t) {
                    return o(this, t, arguments.length, arguments[1], !0);
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(59)(!1), i = [].indexOf, a = !!i && 1 / [
                1
            ].indexOf(1, -0) < 0;
            n(n.P + n.F * (a || !r(17)(i)), "Array", {
                indexOf: function(t) {
                    return a ? i.apply(this, arguments) || 0 : o(this, t, arguments[1]);
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(16), i = r(20), a = r(7), c = [].lastIndexOf, u = !!c && 1 / [
                1
            ].lastIndexOf(1, -0) < 0;
            n(n.P + n.F * (u || !r(17)(c)), "Array", {
                lastIndexOf: function(t) {
                    if (u) return c.apply(this, arguments) || 0;
                    var e = o(this), r = a(e.length), n = r - 1;
                    for(arguments.length > 1 && (n = Math.min(n, i(arguments[1]))), n < 0 && (n = r + n); n >= 0; n--)if (n in e && e[n] === t) return n || 0;
                    return -1;
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.P, "Array", {
                copyWithin: r(147)
            }), r(39)("copyWithin");
        },
        function(t, e, r) {
            var n = r(0);
            n(n.P, "Array", {
                fill: r(101)
            }), r(39)("fill");
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(23)(5), i = !0;
            "find" in [] && Array(1).find(function() {
                i = !1;
            }), n(n.P + n.F * i, "Array", {
                find: function(t) {
                    return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
                }
            }), r(39)("find");
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(23)(6), i = "findIndex", a = !0;
            i in [] && Array(1)[i](function() {
                a = !1;
            }), n(n.P + n.F * a, "Array", {
                findIndex: function(t) {
                    return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
                }
            }), r(39)(i);
        },
        function(t, e, r) {
            r(47)("Array");
        },
        function(t, e, r) {
            var n = r(2), o = r(89), i = r(10).f, a = r(37).f, c = r(96), u = r(63), s = n.RegExp, l = s, f = s.prototype, h = /a/g, d = /a/g, p = new s(h) !== h;
            if (r(9) && (!p || r(3)(function() {
                return d[r(6)("match")] = !1, s(h) != h || s(d) == d || "/a/i" != s(h, "i");
            }))) {
                s = function(t, e) {
                    var r = this instanceof s, n = c(t), i = void 0 === e;
                    return !r && n && t.constructor === s && i ? t : o(p ? new l(n && !i ? t.source : t, e) : l((n = t instanceof s) ? t.source : t, n && i ? u.call(t) : e), r ? this : f, s);
                };
                for(var v = function(t) {
                    t in s || i(s, t, {
                        configurable: !0,
                        get: function() {
                            return l[t];
                        },
                        set: function(e) {
                            l[t] = e;
                        }
                    });
                }, m = a(l), g = 0; m.length > g;)v(m[g++]);
                f.constructor = s, s.prototype = f, r(12)(n, "RegExp", s);
            }
            r(47)("RegExp");
        },
        function(t, e, r) {
            "use strict";
            r(150);
            var n = r(4), o = r(63), i = r(9), a = /./.toString, c = function(t) {
                r(12)(RegExp.prototype, "toString", t, !0);
            };
            r(3)(function() {
                return "/a/b" != a.call({
                    source: "a",
                    flags: "b"
                });
            }) ? c(function() {
                var t = n(this);
                return "/".concat(t.source, "/", "flags" in t ? t.flags : !i && t instanceof RegExp ? o.call(t) : void 0);
            }) : "toString" != a.name && c(function() {
                return a.call(this);
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(4), o = r(7), i = r(104), a = r(64);
            r(65)("match", 1, function(t, e, r, c) {
                return [
                    function(r) {
                        var n = t(this), o = null == r ? void 0 : r[e];
                        return void 0 !== o ? o.call(r, n) : new RegExp(r)[e](String(n));
                    },
                    function(t) {
                        var e = c(r, t, this);
                        if (e.done) return e.value;
                        var u = n(t), s = String(this);
                        if (!u.global) return a(u, s);
                        var l = u.unicode;
                        u.lastIndex = 0;
                        for(var f, h = [], d = 0; null !== (f = a(u, s));){
                            var p = String(f[0]);
                            h[d] = p, "" === p && (u.lastIndex = i(s, o(u.lastIndex), l)), d++;
                        }
                        return 0 === d ? null : h;
                    }
                ];
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(4), o = r(11), i = r(7), a = r(20), c = r(104), u = r(64), s = Math.max, l = Math.min, f = Math.floor, h = /\$([$&`']|\d\d?|<[^>]*>)/g, d = /\$([$&`']|\d\d?)/g;
            r(65)("replace", 2, function(t, e, r, p) {
                return [
                    function(n, o) {
                        var i = t(this), a = null == n ? void 0 : n[e];
                        return void 0 !== a ? a.call(n, i, o) : r.call(String(i), n, o);
                    },
                    function(t, e) {
                        var o = p(r, t, this, e);
                        if (o.done) return o.value;
                        var f = n(t), h = String(this), d = "function" == typeof e;
                        d || (e = String(e));
                        var m = f.global;
                        if (m) {
                            var g = f.unicode;
                            f.lastIndex = 0;
                        }
                        for(var b = [];;){
                            var x = u(f, h);
                            if (null === x) break;
                            if (b.push(x), !m) break;
                            "" === String(x[0]) && (f.lastIndex = c(h, i(f.lastIndex), g));
                        }
                        for(var y, _ = "", w = 0, S = 0; S < b.length; S++){
                            x = b[S];
                            for(var M = String(x[0]), T = s(l(a(x.index), h.length), 0), I = [], D = 1; D < x.length; D++)I.push(void 0 === (y = x[D]) ? y : String(y));
                            var E = x.groups;
                            if (d) {
                                var A = [
                                    M
                                ].concat(I, T, h);
                                void 0 !== E && A.push(E);
                                var C = String(e.apply(void 0, A));
                            } else C = v(M, h, T, I, E, e);
                            T >= w && (_ += h.slice(w, T) + C, w = T + M.length);
                        }
                        return _ + h.slice(w);
                    }
                ];
                function v(t, e, n, i, a, c) {
                    var u = n + t.length, s = i.length, l = d;
                    return void 0 !== a && (a = o(a), l = h), r.call(c, l, function(r, o) {
                        var c;
                        switch(o.charAt(0)){
                            case "$":
                                return "$";
                            case "&":
                                return t;
                            case "`":
                                return e.slice(0, n);
                            case "'":
                                return e.slice(u);
                            case "<":
                                c = a[o.slice(1, -1)];
                                break;
                            default:
                                var l = +o;
                                if (0 === l) return r;
                                if (l > s) {
                                    var h = f(l / 10);
                                    return 0 === h ? r : h <= s ? void 0 === i[h - 1] ? o.charAt(1) : i[h - 1] + o.charAt(1) : r;
                                }
                                c = i[l - 1];
                        }
                        return void 0 === c ? "" : c;
                    });
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(4), o = r(135), i = r(64);
            r(65)("search", 1, function(t, e, r, a) {
                return [
                    function(r) {
                        var n = t(this), o = null == r ? void 0 : r[e];
                        return void 0 !== o ? o.call(r, n) : new RegExp(r)[e](String(n));
                    },
                    function(t) {
                        var e = a(r, t, this);
                        if (e.done) return e.value;
                        var c = n(t), u = String(this), s = c.lastIndex;
                        o(s, 0) || (c.lastIndex = 0);
                        var l = i(c, u);
                        return o(c.lastIndex, s) || (c.lastIndex = s), null === l ? -1 : l.index;
                    }
                ];
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(96), o = r(4), i = r(53), a = r(104), c = r(7), u = r(64), s = r(103), l = r(3), f = Math.min, h = [].push, d = "length", p = !l(function() {
                RegExp(4294967295, "y");
            });
            r(65)("split", 2, function(t, e, r, l) {
                var v;
                return v = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1)[d] || 2 != "ab".split(/(?:ab)*/)[d] || 4 != ".".split(/(.?)(.?)/)[d] || ".".split(/()()/)[d] > 1 || "".split(/.?/)[d] ? function(t, e) {
                    var o = String(this);
                    if (void 0 === t && 0 === e) return [];
                    if (!n(t)) return r.call(o, t, e);
                    for(var i, a, c, u = [], l = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), f = 0, p = void 0 === e ? 4294967295 : e >>> 0, v = new RegExp(t.source, l + "g"); (i = s.call(v, o)) && !((a = v.lastIndex) > f && (u.push(o.slice(f, i.index)), i[d] > 1 && i.index < o[d] && h.apply(u, i.slice(1)), c = i[0][d], f = a, u[d] >= p));)v.lastIndex === i.index && v.lastIndex++;
                    return f === o[d] ? !c && v.test("") || u.push("") : u.push(o.slice(f)), u[d] > p ? u.slice(0, p) : u;
                } : "0".split(void 0, 0)[d] ? function(t, e) {
                    return void 0 === t && 0 === e ? [] : r.call(this, t, e);
                } : r, [
                    function(r, n) {
                        var o = t(this), i = null == r ? void 0 : r[e];
                        return void 0 !== i ? i.call(r, o, n) : v.call(String(o), r, n);
                    },
                    function(t, e) {
                        var n = l(v, t, this, e, v !== r);
                        if (n.done) return n.value;
                        var s = o(t), h = String(this), d = i(s, RegExp), m = s.unicode, g = (s.ignoreCase ? "i" : "") + (s.multiline ? "m" : "") + (s.unicode ? "u" : "") + (p ? "y" : "g"), b = new d(p ? s : "^(?:" + s.source + ")", g), x = void 0 === e ? 4294967295 : e >>> 0;
                        if (0 === x) return [];
                        if (0 === h.length) return null === u(b, h) ? [
                            h
                        ] : [];
                        for(var y = 0, _ = 0, w = []; _ < h.length;){
                            b.lastIndex = p ? _ : 0;
                            var S, M = u(b, p ? h : h.slice(_));
                            if (null === M || (S = f(c(b.lastIndex + (p ? 0 : _)), h.length)) === y) _ = a(h, _, m);
                            else {
                                if (w.push(h.slice(y, _)), w.length === x) return w;
                                for(var T = 1; T <= M.length - 1; T++)if (w.push(M[T]), w.length === x) return w;
                                _ = y = S;
                            }
                        }
                        return w.push(h.slice(y)), w;
                    }
                ];
            });
        },
        function(t, e, r) {
            var n = r(2), o = r(105).set, i = n.MutationObserver || n.WebKitMutationObserver, a = n.process, c = n.Promise, u = "process" == r(26)(a);
            t.exports = function() {
                var t, e, r, s = function() {
                    var n, o;
                    for(u && (n = a.domain) && n.exit(); t;){
                        o = t.fn, t = t.next;
                        try {
                            o();
                        } catch (n) {
                            throw t ? r() : e = void 0, n;
                        }
                    }
                    e = void 0, n && n.enter();
                };
                if (u) r = function() {
                    a.nextTick(s);
                };
                else if (!i || n.navigator && n.navigator.standalone) {
                    if (c && c.resolve) {
                        var l = c.resolve(void 0);
                        r = function() {
                            l.then(s);
                        };
                    } else r = function() {
                        o.call(n, s);
                    };
                } else {
                    var f = !0, h = document.createTextNode("");
                    new i(s).observe(h, {
                        characterData: !0
                    }), r = function() {
                        h.data = f = !f;
                    };
                }
                return function(n) {
                    var o = {
                        fn: n,
                        next: void 0
                    };
                    e && (e.next = o), t || (t = o, r()), e = o;
                };
            };
        },
        function(t, e) {
            t.exports = function(t) {
                try {
                    return {
                        e: !1,
                        v: t()
                    };
                } catch (t) {
                    return {
                        e: !0,
                        v: t
                    };
                }
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(154), o = r(40);
            t.exports = r(68)("Map", function(t) {
                return function() {
                    return t(this, arguments.length > 0 ? arguments[0] : void 0);
                };
            }, {
                get: function(t) {
                    var e = n.getEntry(o(this, "Map"), t);
                    return e && e.v;
                },
                set: function(t, e) {
                    return n.def(o(this, "Map"), 0 === t ? 0 : t, e);
                }
            }, n, !0);
        },
        function(t, e, r) {
            "use strict";
            var n = r(154), o = r(40);
            t.exports = r(68)("Set", function(t) {
                return function() {
                    return t(this, arguments.length > 0 ? arguments[0] : void 0);
                };
            }, {
                add: function(t) {
                    return n.def(o(this, "Set"), t = 0 === t ? 0 : t, t);
                }
            }, n);
        },
        function(t, e, r) {
            "use strict";
            var n, o = r(2), i = r(23)(0), a = r(12), c = r(30), u = r(134), s = r(155), l = r(5), f = r(40), h = r(40), d = !o.ActiveXObject && "ActiveXObject" in o, p = c.getWeak, v = Object.isExtensible, m = s.ufstore, g = function(t) {
                return function() {
                    return t(this, arguments.length > 0 ? arguments[0] : void 0);
                };
            }, b = {
                get: function(t) {
                    if (l(t)) {
                        var e = p(t);
                        return !0 === e ? m(f(this, "WeakMap")).get(t) : e ? e[this._i] : void 0;
                    }
                },
                set: function(t, e) {
                    return s.def(f(this, "WeakMap"), t, e);
                }
            }, x = t.exports = r(68)("WeakMap", g, b, s, !0, !0);
            h && d && (u((n = s.getConstructor(g, "WeakMap")).prototype, b), c.NEED = !0, i([
                "delete",
                "has",
                "get",
                "set"
            ], function(t) {
                var e = x.prototype, r = e[t];
                a(e, t, function(e, o) {
                    if (l(e) && !v(e)) {
                        this._f || (this._f = new n);
                        var i = this._f[t](e, o);
                        return "set" == t ? this : i;
                    }
                    return r.call(this, e, o);
                });
            }));
        },
        function(t, e, r) {
            "use strict";
            var n = r(155), o = r(40);
            r(68)("WeakSet", function(t) {
                return function() {
                    return t(this, arguments.length > 0 ? arguments[0] : void 0);
                };
            }, {
                add: function(t) {
                    return n.def(o(this, "WeakSet"), t, !0);
                }
            }, n, !1, !0);
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(69), i = r(106), a = r(4), c = r(35), u = r(7), s = r(5), l = r(2).ArrayBuffer, f = r(53), h = i.ArrayBuffer, d = i.DataView, p = o.ABV && l.isView, v = h.prototype.slice, m = o.VIEW;
            n(n.G + n.W + n.F * (l !== h), {
                ArrayBuffer: h
            }), n(n.S + n.F * !o.CONSTR, "ArrayBuffer", {
                isView: function(t) {
                    return p && p(t) || s(t) && m in t;
                }
            }), n(n.P + n.U + n.F * r(3)(function() {
                return !new h(2).slice(1, void 0).byteLength;
            }), "ArrayBuffer", {
                slice: function(t, e) {
                    if (void 0 !== v && void 0 === e) return v.call(a(this), t);
                    for(var r = a(this).byteLength, n = c(t, r), o = c(void 0 === e ? r : e, r), i = new (f(this, h))(u(o - n)), s = new d(this), l = new d(i), p = 0; n < o;)l.setUint8(p++, s.getUint8(n++));
                    return i;
                }
            }), r(47)("ArrayBuffer");
        },
        function(t, e, r) {
            var n = r(0);
            n(n.G + n.W + n.F * !r(69).ABV, {
                DataView: r(106).DataView
            });
        },
        function(t, e, r) {
            r(28)("Int8", 1, function(t) {
                return function(e, r, n) {
                    return t(this, e, r, n);
                };
            });
        },
        function(t, e, r) {
            r(28)("Uint8", 1, function(t) {
                return function(e, r, n) {
                    return t(this, e, r, n);
                };
            });
        },
        function(t, e, r) {
            r(28)("Uint8", 1, function(t) {
                return function(e, r, n) {
                    return t(this, e, r, n);
                };
            }, !0);
        },
        function(t, e, r) {
            r(28)("Int16", 2, function(t) {
                return function(e, r, n) {
                    return t(this, e, r, n);
                };
            });
        },
        function(t, e, r) {
            r(28)("Uint16", 2, function(t) {
                return function(e, r, n) {
                    return t(this, e, r, n);
                };
            });
        },
        function(t, e, r) {
            r(28)("Int32", 4, function(t) {
                return function(e, r, n) {
                    return t(this, e, r, n);
                };
            });
        },
        function(t, e, r) {
            r(28)("Uint32", 4, function(t) {
                return function(e, r, n) {
                    return t(this, e, r, n);
                };
            });
        },
        function(t, e, r) {
            r(28)("Float32", 4, function(t) {
                return function(e, r, n) {
                    return t(this, e, r, n);
                };
            });
        },
        function(t, e, r) {
            r(28)("Float64", 8, function(t) {
                return function(e, r, n) {
                    return t(this, e, r, n);
                };
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(19), i = r(4), a = (r(2).Reflect || {}).apply, c = Function.apply;
            n(n.S + n.F * !r(3)(function() {
                a(function() {});
            }), "Reflect", {
                apply: function(t, e, r) {
                    var n = o(t), u = i(r);
                    return a ? a(n, e, u) : c.call(n, e, u);
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(36), i = r(19), a = r(4), c = r(5), u = r(3), s = r(136), l = (r(2).Reflect || {}).construct, f = u(function() {
                function t() {}
                return !(l(function() {}, [], t) instanceof t);
            }), h = !u(function() {
                l(function() {});
            });
            n(n.S + n.F * (f || h), "Reflect", {
                construct: function(t, e) {
                    i(t), a(e);
                    var r = arguments.length < 3 ? t : i(arguments[2]);
                    if (h && !f) return l(t, e, r);
                    if (t == r) {
                        switch(e.length){
                            case 0:
                                return new t;
                            case 1:
                                return new t(e[0]);
                            case 2:
                                return new t(e[0], e[1]);
                            case 3:
                                return new t(e[0], e[1], e[2]);
                            case 4:
                                return new t(e[0], e[1], e[2], e[3]);
                        }
                        var n = [
                            null
                        ];
                        return n.push.apply(n, e), new (s.apply(t, n));
                    }
                    var u = r.prototype, d = o(c(u) ? u : Object.prototype), p = Function.apply.call(t, d, e);
                    return c(p) ? p : d;
                }
            });
        },
        function(t, e, r) {
            var n = r(10), o = r(0), i = r(4), a = r(29);
            o(o.S + o.F * r(3)(function() {
                Reflect.defineProperty(n.f({}, 1, {
                    value: 1
                }), 1, {
                    value: 2
                });
            }), "Reflect", {
                defineProperty: function(t, e, r) {
                    i(t), e = a(e, !0), i(r);
                    try {
                        return n.f(t, e, r), !0;
                    } catch (t) {
                        return !1;
                    }
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(21).f, i = r(4);
            n(n.S, "Reflect", {
                deleteProperty: function(t, e) {
                    var r = o(i(t), e);
                    return !(r && !r.configurable) && delete t[e];
                }
            });
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(4), i = function(t) {
                this._t = o(t), this._i = 0;
                var e, r = this._k = [];
                for(e in t)r.push(e);
            };
            r(143)(i, "Object", function() {
                var t, e = this._k;
                do {
                    if (this._i >= e.length) return {
                        value: void 0,
                        done: !0
                    };
                }while (!((t = e[this._i++]) in this._t));
                return {
                    value: t,
                    done: !1
                };
            }), n(n.S, "Reflect", {
                enumerate: function(t) {
                    return new i(t);
                }
            });
        },
        function(t, e, r) {
            var n = r(21), o = r(38), i = r(14), a = r(0), c = r(5), u = r(4);
            a(a.S, "Reflect", {
                get: function t(e, r) {
                    var a, s, l = arguments.length < 3 ? e : arguments[2];
                    return u(e) === l ? e[r] : (a = n.f(e, r)) ? i(a, "value") ? a.value : void 0 !== a.get ? a.get.call(l) : void 0 : c(s = o(e)) ? t(s, r, l) : void 0;
                }
            });
        },
        function(t, e, r) {
            var n = r(21), o = r(0), i = r(4);
            o(o.S, "Reflect", {
                getOwnPropertyDescriptor: function(t, e) {
                    return n.f(i(t), e);
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(38), i = r(4);
            n(n.S, "Reflect", {
                getPrototypeOf: function(t) {
                    return o(i(t));
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Reflect", {
                has: function(t, e) {
                    return e in t;
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(4), i = Object.isExtensible;
            n(n.S, "Reflect", {
                isExtensible: function(t) {
                    return o(t), !i || i(t);
                }
            });
        },
        function(t, e, r) {
            var n = r(0);
            n(n.S, "Reflect", {
                ownKeys: r(157)
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(4), i = Object.preventExtensions;
            n(n.S, "Reflect", {
                preventExtensions: function(t) {
                    o(t);
                    try {
                        return i && i(t), !0;
                    } catch (t) {
                        return !1;
                    }
                }
            });
        },
        function(t, e, r) {
            var n = r(10), o = r(21), i = r(38), a = r(14), c = r(0), u = r(31), s = r(4), l = r(5);
            c(c.S, "Reflect", {
                set: function t(e, r, c) {
                    var f, h, d = arguments.length < 4 ? e : arguments[3], p = o.f(s(e), r);
                    if (!p) {
                        if (l(h = i(e))) return t(h, r, c, d);
                        p = u(0);
                    }
                    if (a(p, "value")) {
                        if (!1 === p.writable || !l(d)) return !1;
                        if (f = o.f(d, r)) {
                            if (f.get || f.set || !1 === f.writable) return !1;
                            f.value = c, n.f(d, r, f);
                        } else n.f(d, r, u(0, c));
                        return !0;
                    }
                    return void 0 !== p.set && (p.set.call(d, c), !0);
                }
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(87);
            o && n(n.S, "Reflect", {
                setPrototypeOf: function(t, e) {
                    o.check(t, e);
                    try {
                        return o.set(t, e), !0;
                    } catch (t) {
                        return !1;
                    }
                }
            });
        },
        function(t, e, r) {
            r(354), t.exports = r(8).Array.includes;
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(59)(!0);
            n(n.P, "Array", {
                includes: function(t) {
                    return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
                }
            }), r(39)("includes");
        },
        function(t, e, r) {
            r(356), t.exports = r(8).Array.flatMap;
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(357), i = r(11), a = r(7), c = r(19), u = r(145);
            n(n.P, "Array", {
                flatMap: function(t) {
                    var e, r, n = i(this);
                    return c(t), e = a(n.length), r = u(n, 0), o(r, n, n, e, 0, 1, t, arguments[1]), r;
                }
            }), r(39)("flatMap");
        },
        function(t, e, r) {
            "use strict";
            var n = r(61), o = r(5), i = r(7), a = r(18), c = r(6)("isConcatSpreadable");
            t.exports = function t(e, r, u, s, l, f, h, d) {
                for(var p, v, m = l, g = 0, b = !!h && a(h, d, 3); g < s;){
                    if (g in u) {
                        if (p = b ? b(u[g], g, r) : u[g], v = !1, o(p) && (v = void 0 !== (v = p[c]) ? !!v : n(p)), v && f > 0) m = t(e, r, p, i(p.length), m, f - 1) - 1;
                        else {
                            if (m >= 9007199254740991) throw TypeError();
                            e[m] = p;
                        }
                        m++;
                    }
                    g++;
                }
                return m;
            };
        },
        function(t, e, r) {
            r(359), t.exports = r(8).String.padStart;
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(158), i = r(67), a = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(i);
            n(n.P + n.F * a, "String", {
                padStart: function(t) {
                    return o(this, t, arguments.length > 1 ? arguments[1] : void 0, !0);
                }
            });
        },
        function(t, e, r) {
            r(361), t.exports = r(8).String.padEnd;
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(158), i = r(67), a = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(i);
            n(n.P + n.F * a, "String", {
                padEnd: function(t) {
                    return o(this, t, arguments.length > 1 ? arguments[1] : void 0, !1);
                }
            });
        },
        function(t, e, r) {
            r(363), t.exports = r(8).String.trimLeft;
        },
        function(t, e, r) {
            "use strict";
            r(45)("trimLeft", function(t) {
                return function() {
                    return t(this, 1);
                };
            }, "trimStart");
        },
        function(t, e, r) {
            r(365), t.exports = r(8).String.trimRight;
        },
        function(t, e, r) {
            "use strict";
            r(45)("trimRight", function(t) {
                return function() {
                    return t(this, 2);
                };
            }, "trimEnd");
        },
        function(t, e, r) {
            r(367), t.exports = r(83).f("asyncIterator");
        },
        function(t, e, r) {
            r(130)("asyncIterator");
        },
        function(t, e, r) {
            r(369), t.exports = r(8).Object.getOwnPropertyDescriptors;
        },
        function(t, e, r) {
            var n = r(0), o = r(157), i = r(16), a = r(21), c = r(99);
            n(n.S, "Object", {
                getOwnPropertyDescriptors: function(t) {
                    for(var e, r, n = i(t), u = a.f, s = o(n), l = {}, f = 0; s.length > f;)void 0 !== (r = u(n, e = s[f++])) && c(l, e, r);
                    return l;
                }
            });
        },
        function(t, e, r) {
            r(371), t.exports = r(8).Object.values;
        },
        function(t, e, r) {
            var n = r(0), o = r(159)(!1);
            n(n.S, "Object", {
                values: function(t) {
                    return o(t);
                }
            });
        },
        function(t, e, r) {
            r(373), t.exports = r(8).Object.entries;
        },
        function(t, e, r) {
            var n = r(0), o = r(159)(!0);
            n(n.S, "Object", {
                entries: function(t) {
                    return o(t);
                }
            });
        },
        function(t, e, r) {
            "use strict";
            r(151), r(375), t.exports = r(8).Promise.finally;
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(8), i = r(2), a = r(53), c = r(153);
            n(n.P + n.R, "Promise", {
                finally: function(t) {
                    var e = a(this, o.Promise || i.Promise), r = "function" == typeof t;
                    return this.then(r ? function(r) {
                        return c(e, t()).then(function() {
                            return r;
                        });
                    } : t, r ? function(r) {
                        return c(e, t()).then(function() {
                            throw r;
                        });
                    } : t);
                }
            });
        },
        function(t, e, r) {
            r(377), r(378), r(379), t.exports = r(8);
        },
        function(t, e, r) {
            var n = r(2), o = r(0), i = r(67), a = [].slice, c = /MSIE .\./.test(i), u = function(t) {
                return function(e, r) {
                    var n = arguments.length > 2, o = !!n && a.call(arguments, 2);
                    return t(n ? function() {
                        ("function" == typeof e ? e : Function(e)).apply(this, o);
                    } : e, r);
                };
            };
            o(o.G + o.B + o.F * c, {
                setTimeout: u(n.setTimeout),
                setInterval: u(n.setInterval)
            });
        },
        function(t, e, r) {
            var n = r(0), o = r(105);
            n(n.G + n.B, {
                setImmediate: o.set,
                clearImmediate: o.clear
            });
        },
        function(t, e, r) {
            for(var n = r(102), o = r(34), i = r(12), a = r(2), c = r(15), u = r(46), s = r(6), l = s("iterator"), f = s("toStringTag"), h = u.Array, d = {
                CSSRuleList: !0,
                CSSStyleDeclaration: !1,
                CSSValueList: !1,
                ClientRectList: !1,
                DOMRectList: !1,
                DOMStringList: !1,
                DOMTokenList: !0,
                DataTransferItemList: !1,
                FileList: !1,
                HTMLAllCollection: !1,
                HTMLCollection: !1,
                HTMLFormElement: !1,
                HTMLSelectElement: !1,
                MediaList: !0,
                MimeTypeArray: !1,
                NamedNodeMap: !1,
                NodeList: !0,
                PaintRequestList: !1,
                Plugin: !1,
                PluginArray: !1,
                SVGLengthList: !1,
                SVGNumberList: !1,
                SVGPathSegList: !1,
                SVGPointList: !1,
                SVGStringList: !1,
                SVGTransformList: !1,
                SourceBufferList: !1,
                StyleSheetList: !0,
                TextTrackCueList: !1,
                TextTrackList: !1,
                TouchList: !1
            }, p = o(d), v = 0; v < p.length; v++){
                var m, g = p[v], b = d[g], x = a[g], y = x && x.prototype;
                if (y && (y[l] || c(y, l, h), y[f] || c(y, f, g), u[g] = h, b)) for(m in n)y[m] || i(y, m, n[m], !0);
            }
        },
        function(t, e, r) {
            var n = function(t) {
                "use strict";
                var e = Object.prototype, r = e.hasOwnProperty, n = "function" == typeof Symbol ? Symbol : {}, o = n.iterator || "@@iterator", i = n.asyncIterator || "@@asyncIterator", a = n.toStringTag || "@@toStringTag";
                function c(t, e, r, n) {
                    var o = e && e.prototype instanceof l ? e : l, i = Object.create(o.prototype), a = new w(n || []);
                    return i._invoke = function(t, e, r) {
                        var n = "suspendedStart";
                        return function(o, i) {
                            if ("executing" === n) throw new Error("Generator is already running");
                            if ("completed" === n) {
                                if ("throw" === o) throw i;
                                return M();
                            }
                            for(r.method = o, r.arg = i;;){
                                var a = r.delegate;
                                if (a) {
                                    var c = x(a, r);
                                    if (c) {
                                        if (c === s) continue;
                                        return c;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if ("suspendedStart" === n) throw n = "completed", r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                n = "executing";
                                var l = u(t, e, r);
                                if ("normal" === l.type) {
                                    if (n = r.done ? "completed" : "suspendedYield", l.arg === s) continue;
                                    return {
                                        value: l.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
                            }
                        };
                    }(t, r, a), i;
                }
                function u(t, e, r) {
                    try {
                        return {
                            type: "normal",
                            arg: t.call(e, r)
                        };
                    } catch (t) {
                        return {
                            type: "throw",
                            arg: t
                        };
                    }
                }
                t.wrap = c;
                var s = {};
                function l() {}
                function f() {}
                function h() {}
                var d = {};
                d[o] = function() {
                    return this;
                };
                var p = Object.getPrototypeOf, v = p && p(p(S([])));
                v && v !== e && r.call(v, o) && (d = v);
                var m = h.prototype = l.prototype = Object.create(d);
                function g(t) {
                    [
                        "next",
                        "throw",
                        "return"
                    ].forEach(function(e) {
                        t[e] = function(t) {
                            return this._invoke(e, t);
                        };
                    });
                }
                function b(t, e) {
                    var n;
                    this._invoke = function(o, i) {
                        function a() {
                            return new e(function(n, a) {
                                !function n(o, i, a, c) {
                                    var s = u(t[o], t, i);
                                    if ("throw" !== s.type) {
                                        var l = s.arg, f = l.value;
                                        return f && "object" == typeof f && r.call(f, "__await") ? e.resolve(f.__await).then(function(t) {
                                            n("next", t, a, c);
                                        }, function(t) {
                                            n("throw", t, a, c);
                                        }) : e.resolve(f).then(function(t) {
                                            l.value = t, a(l);
                                        }, function(t) {
                                            return n("throw", t, a, c);
                                        });
                                    }
                                    c(s.arg);
                                }(o, i, n, a);
                            });
                        }
                        return n = n ? n.then(a, a) : a();
                    };
                }
                function x(t, e) {
                    var r = t.iterator[e.method];
                    if (void 0 === r) {
                        if (e.delegate = null, "throw" === e.method) {
                            if (t.iterator.return && (e.method = "return", e.arg = void 0, x(t, e), "throw" === e.method)) return s;
                            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
                        }
                        return s;
                    }
                    var n = u(r, t.iterator, e.arg);
                    if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, s;
                    var o = n.arg;
                    return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, s) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, s);
                }
                function y(t) {
                    var e = {
                        tryLoc: t[0]
                    };
                    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
                }
                function _(t) {
                    var e = t.completion || {};
                    e.type = "normal", delete e.arg, t.completion = e;
                }
                function w(t) {
                    this.tryEntries = [
                        {
                            tryLoc: "root"
                        }
                    ], t.forEach(y, this), this.reset(!0);
                }
                function S(t) {
                    if (t) {
                        var e = t[o];
                        if (e) return e.call(t);
                        if ("function" == typeof t.next) return t;
                        if (!isNaN(t.length)) {
                            var n = -1, i = function e() {
                                for(; ++n < t.length;)if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
                                return e.value = void 0, e.done = !0, e;
                            };
                            return i.next = i;
                        }
                    }
                    return {
                        next: M
                    };
                }
                function M() {
                    return {
                        value: void 0,
                        done: !0
                    };
                }
                return f.prototype = m.constructor = h, h.constructor = f, h[a] = f.displayName = "GeneratorFunction", t.isGeneratorFunction = function(t) {
                    var e = "function" == typeof t && t.constructor;
                    return !!e && (e === f || "GeneratorFunction" === (e.displayName || e.name));
                }, t.mark = function(t) {
                    return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : (t.__proto__ = h, a in t || (t[a] = "GeneratorFunction")), t.prototype = Object.create(m), t;
                }, t.awrap = function(t) {
                    return {
                        __await: t
                    };
                }, g(b.prototype), b.prototype[i] = function() {
                    return this;
                }, t.AsyncIterator = b, t.async = function(e, r, n, o, i) {
                    void 0 === i && (i = Promise);
                    var a = new b(c(e, r, n, o), i);
                    return t.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                        return t.done ? t.value : a.next();
                    });
                }, g(m), m[a] = "Generator", m[o] = function() {
                    return this;
                }, m.toString = function() {
                    return "[object Generator]";
                }, t.keys = function(t) {
                    var e = [];
                    for(var r in t)e.push(r);
                    return e.reverse(), function r() {
                        for(; e.length;){
                            var n = e.pop();
                            if (n in t) return r.value = n, r.done = !1, r;
                        }
                        return r.done = !0, r;
                    };
                }, t.values = S, w.prototype = {
                    constructor: w,
                    reset: function(t) {
                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(_), !t) for(var e in this)"t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
                    },
                    stop: function() {
                        this.done = !0;
                        var t = this.tryEntries[0].completion;
                        if ("throw" === t.type) throw t.arg;
                        return this.rval;
                    },
                    dispatchException: function(t) {
                        if (this.done) throw t;
                        var e = this;
                        function n(r, n) {
                            return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
                        }
                        for(var o = this.tryEntries.length - 1; o >= 0; --o){
                            var i = this.tryEntries[o], a = i.completion;
                            if ("root" === i.tryLoc) return n("end");
                            if (i.tryLoc <= this.prev) {
                                var c = r.call(i, "catchLoc"), u = r.call(i, "finallyLoc");
                                if (c && u) {
                                    if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                                    if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                                } else if (c) {
                                    if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                                } else {
                                    if (!u) throw new Error("try statement without catch or finally");
                                    if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                                }
                            }
                        }
                    },
                    abrupt: function(t, e) {
                        for(var n = this.tryEntries.length - 1; n >= 0; --n){
                            var o = this.tryEntries[n];
                            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                var i = o;
                                break;
                            }
                        }
                        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                        var a = i ? i.completion : {};
                        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, s) : this.complete(a);
                    },
                    complete: function(t, e) {
                        if ("throw" === t.type) throw t.arg;
                        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), s;
                    },
                    finish: function(t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e){
                            var r = this.tryEntries[e];
                            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), _(r), s;
                        }
                    },
                    catch: function(t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e){
                            var r = this.tryEntries[e];
                            if (r.tryLoc === t) {
                                var n = r.completion;
                                if ("throw" === n.type) {
                                    var o = n.arg;
                                    _(r);
                                }
                                return o;
                            }
                        }
                        throw new Error("illegal catch attempt");
                    },
                    delegateYield: function(t, e, r) {
                        return this.delegate = {
                            iterator: S(t),
                            resultName: e,
                            nextLoc: r
                        }, "next" === this.method && (this.arg = void 0), s;
                    }
                }, t;
            }(t.exports);
            try {
                regeneratorRuntime = n;
            } catch (t) {
                Function("r", "regeneratorRuntime = r")(n);
            }
        },
        function(t, e, r) {
            r(382), t.exports = r(160).global;
        },
        function(t, e, r) {
            var n = r(383);
            n(n.G, {
                global: r(107)
            });
        },
        function(t, e, r) {
            var n = r(107), o = r(160), i = r(384), a = r(386), c = r(393), u = function(t, e, r) {
                var s, l, f, h = t & u.F, d = t & u.G, p = t & u.S, v = t & u.P, m = t & u.B, g = t & u.W, b = d ? o : o[e] || (o[e] = {}), x = b.prototype, y = d ? n : p ? n[e] : (n[e] || {}).prototype;
                for(s in d && (r = e), r)(l = !h && y && void 0 !== y[s]) && c(b, s) || (f = l ? y[s] : r[s], b[s] = d && "function" != typeof y[s] ? r[s] : m && l ? i(f, n) : g && y[s] == f ? function(t) {
                    var e = function(e, r, n) {
                        if (this instanceof t) {
                            switch(arguments.length){
                                case 0:
                                    return new t;
                                case 1:
                                    return new t(e);
                                case 2:
                                    return new t(e, r);
                            }
                            return new t(e, r, n);
                        }
                        return t.apply(this, arguments);
                    };
                    return e.prototype = t.prototype, e;
                }(f) : v && "function" == typeof f ? i(Function.call, f) : f, v && ((b.virtual || (b.virtual = {}))[s] = f, t & u.R && x && !x[s] && a(x, s, f)));
            };
            u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, t.exports = u;
        },
        function(t, e, r) {
            var n = r(385);
            t.exports = function(t, e, r) {
                if (n(t), void 0 === e) return t;
                switch(r){
                    case 1:
                        return function(r) {
                            return t.call(e, r);
                        };
                    case 2:
                        return function(r, n) {
                            return t.call(e, r, n);
                        };
                    case 3:
                        return function(r, n, o) {
                            return t.call(e, r, n, o);
                        };
                }
                return function() {
                    return t.apply(e, arguments);
                };
            };
        },
        function(t, e) {
            t.exports = function(t) {
                if ("function" != typeof t) throw TypeError(t + " is not a function!");
                return t;
            };
        },
        function(t, e, r) {
            var n = r(387), o = r(392);
            t.exports = r(109) ? function(t, e, r) {
                return n.f(t, e, o(1, r));
            } : function(t, e, r) {
                return t[e] = r, t;
            };
        },
        function(t, e, r) {
            var n = r(388), o = r(389), i = r(391), a = Object.defineProperty;
            e.f = r(109) ? Object.defineProperty : function(t, e, r) {
                if (n(t), e = i(e, !0), n(r), o) try {
                    return a(t, e, r);
                } catch (t) {}
                if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
                return "value" in r && (t[e] = r.value), t;
            };
        },
        function(t, e, r) {
            var n = r(108);
            t.exports = function(t) {
                if (!n(t)) throw TypeError(t + " is not an object!");
                return t;
            };
        },
        function(t, e, r) {
            t.exports = !r(109) && !r(161)(function() {
                return 7 != Object.defineProperty(r(390)("div"), "a", {
                    get: function() {
                        return 7;
                    }
                }).a;
            });
        },
        function(t, e, r) {
            var n = r(108), o = r(107).document, i = n(o) && n(o.createElement);
            t.exports = function(t) {
                return i ? o.createElement(t) : {};
            };
        },
        function(t, e, r) {
            var n = r(108);
            t.exports = function(t, e) {
                if (!n(t)) return t;
                var r, o;
                if (e && "function" == typeof (r = t.toString) && !n(o = r.call(t))) return o;
                if ("function" == typeof (r = t.valueOf) && !n(o = r.call(t))) return o;
                if (!e && "function" == typeof (r = t.toString) && !n(o = r.call(t))) return o;
                throw TypeError("Can't convert object to primitive value");
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return {
                    enumerable: !(1 & t),
                    configurable: !(2 & t),
                    writable: !(4 & t),
                    value: e
                };
            };
        },
        function(t, e) {
            var r = {}.hasOwnProperty;
            t.exports = function(t, e) {
                return r.call(t, e);
            };
        },
        function(t, e, r) {
            var n = {
                "./basic.vert": 110,
                "./border.vert": 395,
                "./composite.vert": 396,
                "./distortion.vert": 111,
                "./fringing.vert": 397,
                "./layer.vert": 398,
                "./legacy/paint.vert": 399,
                "./legacy/sharpen.vert": 400,
                "./line.vert": 162,
                "./screen.vert": 401,
                "./spot_heal.vert": 402
            };
            function o(t) {
                var e = i(t);
                return r(e);
            }
            function i(t) {
                if (!r.o(n, t)) {
                    var e = new Error("Cannot find module '" + t + "'");
                    throw e.code = "MODULE_NOT_FOUND", e;
                }
                return n[t];
            }
            o.keys = function() {
                return Object.keys(n);
            }, o.resolve = i, t.exports = o, o.id = 394;
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nuniform mat4 u_ModelViewProjectionMatrix;attribute vec4 a_Vertex;attribute vec4 a_TexCoord;varying vec4 coord;varying vec4 compositeCoord;uniform mat4 matrix;void main(){coord=a_TexCoord;compositeCoord=matrix*a_Vertex*.5+.5;gl_Position=u_ModelViewProjectionMatrix*a_Vertex;}";
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nattribute vec4 a_Vertex;attribute vec4 a_TexCoord;varying vec4 coord;varying vec4 compositeCoord;uniform mat4 viewMatrix;void main(){compositeCoord=a_TexCoord;coord=viewMatrix*a_Vertex*.5+.5;gl_Position=viewMatrix*a_Vertex;}";
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nuniform mat4 u_ModelViewProjectionMatrix;uniform mat3 distortionMatrix;attribute vec4 a_TexCoord;attribute vec4 a_Distortion;attribute vec4 a_Delta;varying vec4 coord;varying vec2 distortionCoord[3];varying vec2 fringingCoord[3];uniform float distortion_amount;uniform float distortion_horizontal;uniform float distortion_vertical;uniform float fringing;uniform vec2 fringing_center;uniform float fringing_radius;uniform vec2 textureSize;const vec2 d=vec2(.5,.5);void main(){vec2 g=vec2(0.,.5);vec4 k=a_Distortion+vec4(a_Delta.xy,0.,0.);vec3 o=distortionMatrix*vec3(k.xy,1.);k.xy=o.xy/o.z;coord=a_TexCoord;float p=length(textureSize);vec2 q=.4/p*textureSize;vec2 t=vec2(distortion_horizontal,distortion_vertical);vec2 r=1.-step(0.,t);vec2 h,b;float c,e;float l=1.;float m=1.;vec2 a=abs(r-coord.xy);if(distortion_horizontal!=0.){b=a-g.xy;h=1.-abs(distortion_horizontal)*q;b=mix(b,b*h,vec2(1.,b.x));a=b+g.xy;}if(distortion_vertical!=0.){b=a-g.yx;h=1.-abs(distortion_vertical)*q;b=mix(b,b*h,vec2(b.y,1.));a=b+g.yx;}a=abs(r-a)-d;if(distortion_amount<0.){e=p/(distortion_amount*-4.);c=max(length(a*textureSize)/e,1e-4);l=atan(c)/c;c=max(-.5*textureSize.x,-.5*textureSize.y)/e;m=atan(c)/c;}if(distortion_amount>0.){c=dot(a,a)*.5625;e=distortion_amount*2.;l=1.+c*e;m=1.+.5*.5625*e;}a/=m;float i=0.;float s=distance(coord.xy,fringing_center);if(s<fringing_radius){i=mix(0.,fringing,s/fringing_radius);}else{i=fringing;}vec3 f=vec3(1.+i*.05,1.,1.-i*.05);vec2 j=fringing_center-.5;vec2 n=a*l-j;distortionCoord[0]=f.r*a+d;distortionCoord[1]=f.g*a+d;distortionCoord[2]=f.b*a+d;fringingCoord[0]=f.r*n+j+d;fringingCoord[1]=f.g*n+j+d;fringingCoord[2]=f.b*n+j+d;gl_Position=u_ModelViewProjectionMatrix*k;}";
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nuniform mat4 u_ModelViewProjectionMatrix;attribute vec4 a_Vertex;attribute vec4 a_TexCoord;varying vec4 coord;varying vec4 backgroundCoords;uniform mat4 backgroundMatrix;void main(){coord=a_TexCoord;backgroundCoords=backgroundMatrix*a_Vertex*.5+.5;gl_Position=u_ModelViewProjectionMatrix*a_Vertex;}";
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nattribute vec4 coordinates;varying vec3 color;varying float pressure;varying float angle;uniform float brushSize;uniform sampler2D image;void main(){color=texture2D(image,coordinates.xy).rgb;vec2 a=(coordinates.xy-.5)*2.;pressure=coordinates[2]*2.;angle=coordinates[3];gl_Position=vec4(a,1.,1.);gl_PointSize=brushSize*pressure;}";
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nuniform mat4 u_ModelViewProjectionMatrix;\nattribute vec4 a_Vertex;\nattribute vec4 a_TexCoord;\nattribute vec4 a_Distortion;\nattribute vec4 a_Delta;\n\nvarying vec4 coord;\nvarying vec2 offsetCoord[4];\n\nuniform vec2 step;\nuniform float zoom;\n\nvoid main() {\n  coord = a_TexCoord;\n\n\toffsetCoord[0] = coord.xy + vec2(0.0, -step.y);\n\toffsetCoord[1] = coord.xy + vec2(-step.x, 0.0);\n\toffsetCoord[2] = coord.xy + vec2(step.x, 0.0);\n\toffsetCoord[3] = coord.xy + vec2(0.0, step.y);\n\n  gl_Position = u_ModelViewProjectionMatrix * a_Vertex;\n}\n";
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nuniform mat4 u_ModelViewProjectionMatrix;attribute vec4 a_Vertex;attribute vec4 a_TexCoord;varying vec4 coord;varying vec4 compositeCoord;uniform mat4 cropMatrix;uniform mat4 viewMatrix;void main(){coord=a_TexCoord;compositeCoord=viewMatrix*cropMatrix*a_Vertex*.5+.5;gl_Position=u_ModelViewProjectionMatrix*a_Vertex;}";
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nattribute vec4 a_TexCoord;attribute vec4 a_Distortion;varying vec4 coord;varying vec4 compositeCoord;varying vec2 distortionCoord;uniform mat4 viewMatrix;uniform float distortion_amount;uniform float distortion_horizontal;uniform float distortion_vertical;uniform vec2 textureSize;uniform vec2 position;uniform vec2 sourcePosition;vec2 m(in vec2 n){const vec2 i=vec2(.5);const vec2 e=vec2(0.,.5);float j=length(textureSize);vec2 k=.4/j*textureSize;vec2 o=vec2(distortion_horizontal,distortion_vertical);vec2 l=1.-step(0.,o);vec2 f,a;float c,d;float g=1.;float h=1.;vec2 b=abs(l-n);if(distortion_horizontal!=0.){a=b-e.xy;f=1.-abs(distortion_horizontal)*k;a=mix(a,a*f,vec2(1.,a.x));b=a+e.xy;}if(distortion_vertical!=0.){a=b-e.yx;f=1.-abs(distortion_vertical)*k;a=mix(a,a*f,vec2(a.y,1.));b=a+e.yx;}b=abs(l-b)-i;if(distortion_amount<0.){d=j/(distortion_amount*-4.);c=max(length(b*textureSize)/d,1e-4);g=atan(c)/c;c=max(-.5*textureSize.x,-.5*textureSize.y)/d;h=atan(c)/c;}if(distortion_amount>0.){c=dot(b,b)*.5625;d=distortion_amount*2.;g=1.+c*d;h=1.+.5*.5625*d;}return g*b/h+i;}void main(){coord=viewMatrix*a_Distortion*.5+.5;compositeCoord=a_TexCoord;distortionCoord=m(compositeCoord.xy+(sourcePosition-position));gl_Position=viewMatrix*a_Distortion;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;void main(){gl_FragColor=texture2D(texture,coord.xy);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec2 delta;float g(vec3 b,float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}void main(){float h=g(vec3(12.9898,78.233,151.7182),0.);vec4 i=texture2D(texture,coord.xy);float a,b,e=0.;vec4 c,f=vec4(0.);for(float d=-20.;d<=20.;d++){a=(d+h-.5)/20.;c=texture2D(texture,coord.xy+delta*i.a*a);b=(1.-abs(a))*max(c.a,1e-3);f+=c*b;e+=b;}gl_FragColor=vec4(f/e);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;uniform sampler2D texture;uniform sampler2D blurTexture;void main(){lowp vec4 a=texture2D(blurTexture,compositeCoord.xy);lowp vec4 b=texture2D(texture,coord.xy);lowp float c=min(a.a/.05,1.);lowp vec3 d=mix(b.rgb,a.rgb,c);gl_FragColor=vec4(d,b.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec2 delta;uniform vec2 blur;uniform vec2 spread;uniform vec2 scale;float h(vec3 b,float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}void main(){vec2 e=(coord.xy-.5)/scale+.5;float i=h(vec3(12.9898,78.233,151.7182),0.)-.5;vec2 j=delta*blur.x;vec2 k=delta*blur.y;vec3 l=vec3(1.-spread.x);float m=1.-spread.y;float b,c,f=0.;lowp vec4 a,g=vec4(0.);for(float d=-12.;d<=12.;d++){b=(d+i)/12.;a=vec4(texture2D(texture,e+j*b).rgb,texture2D(texture,e+k*b).a);a.rgb=pow(a.rgb,l);a.a=pow(a.a,m);c=1.-abs(b);g+=a*c;f+=c;}gl_FragColor=vec4(g/f);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;precision lowp sampler2D;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;uniform vec4 border_color;uniform sampler2D texture;void main(){if(compositeCoord.x>1.||compositeCoord.x<0.||compositeCoord.y>1.||compositeCoord.y<0.){gl_FragColor=border_color;}else{gl_FragColor=texture2D(texture,coord.xy);}}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec4 delta;float d(in vec3 a){return fract(sin(dot(gl_FragCoord.xyz,a))*43758.5453);}void main(){const vec3 e=vec3(12.9898,78.233,151.7182);float f=d(e)-.5;vec2 g=delta.xy;vec2 h=delta.zw;float a;lowp vec4 b=vec4(0.);const float i=8.*2.+1.;for(float c=-8.;c<=8.;c++){a=(c+f)/8.;b.rgb+=texture2D(texture,coord.xy+g*a).rgb;b.a+=texture2D(texture,coord.xy+h*a).a;}gl_FragColor=vec4(b/i);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D a;uniform sampler2D b;uniform sampler2D I;void main(){vec4 b=texture2D(b,coord.xy);vec4 c=texture2D(a,coord.xy);vec4 a=texture2D(I,coord.xy);a.a=min(min(a.r,a.g),a.b);gl_FragColor=c*a+b;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D mean_I;uniform sampler2D mean_II;uniform sampler2D mean_p;void main(){vec4 c=texture2D(mean_I,coord.xy);vec4 d=texture2D(mean_II,coord.xy);vec4 a=texture2D(mean_p,coord.xy);vec4 b=vec4(c.rgb,a.b);vec4 e=vec4(d.rgb,a.a);vec4 f=vec4(c.rgb,a.r);vec4 g=vec4(d.rgb,a.g);vec4 h=g-b*f;vec4 i=e-b*b;gl_FragColor=h/(i+.01);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D mean_I;uniform sampler2D mean_p;uniform sampler2D a;void main(){vec4 c=texture2D(a,coord.xy);vec4 a=texture2D(mean_I,coord.xy);vec4 b=texture2D(mean_p,coord.xy);vec4 d=vec4(a.rgb,b.b);vec4 e=vec4(a.rgb,b.r);gl_FragColor=e-c*d;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec2 delta;void main(){float e;lowp vec4 a;lowp float b=1.;lowp vec4 c=texture2D(texture,coord.xy);lowp float f=min(min(min(1.,c.r),c.g),c.b);for(float d=-8.;d<=8.;d++){e=d/8.;a=texture2D(texture,coord.xy+delta*e);b=min(min(min(b,a.r),a.g),a.b);}gl_FragColor=vec4(b,0.,0.,f);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec2 delta;void main(){float e;lowp vec4 f;lowp float c=1.;lowp vec4 g=texture2D(texture,coord.xy);lowp float a=g.a;for(float d=-8.;d<=8.;d++){e=d/8.;f=texture2D(texture,coord.xy+delta*e);c=min(c,f.r);}float b=clamp(1.-.95*(c/.95),0.,1.);b=1.-b;gl_FragColor=vec4(b,b*a,a,a*a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D dehazeTexture;uniform sampler2D denoiseTexture;uniform float luminance_denoise;uniform float color_denoise;float d(in vec3 a){const vec3 b=vec3(.298839,.586811,.11435);return dot(a,b);}vec3 e(in vec3 a,in float b){float c=b-d(a);return a+c;}void main(){vec3 c=texture2D(dehazeTexture,distortionCoord).rgb;vec4 f=texture2D(denoiseTexture,distortionCoord);vec3 b=f.rgb;vec4 g=texture2D(texture,coord.xy);vec3 a=g.rgb;float h=exp(-3.*d(b));float i=max(luminance_denoise-pow(f.a,.5),0.);float j=color_denoise;vec3 k=mix(b,c,luminance_denoise*h);vec3 l=mix(b,c,color_denoise*h);a=mix(a,e(l,d(a)),j);a=mix(a,e(a,d(k)),i);gl_FragColor=vec4(a,g.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float delta;uniform float kernel[15];const float i=float(7*2+1);const float f=1./.04;const float j=.5*f*f;float g(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}void main(){mediump float b=0.;mediump vec3 h=vec3(0.);lowp vec3 k=texture2D(texture,coord.xy).rgb;lowp float l=g(k);mediump float c;mediump float d;lowp vec3 e;for(int a=-7;a<=7;a++){e=texture2D(texture,coord.xy+vec2(float(a)*delta,0.)).rgb;c=g(e)-l;d=kernel[7+a]*exp(-(c*c*j));h+=e*d;b+=d;}gl_FragColor=vec4(h/b,b/i);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float delta;uniform float kernel[15];const float f=float(7*2+1);const float g=1./.04;const float j=.5*g*g;float h(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}void main(){mediump float c=0.;mediump vec3 i=vec3(0.);lowp vec3 k=texture2D(texture,coord.xy).rgb;lowp float l=h(k);mediump float d;mediump float e;lowp vec4 a;for(int b=-7;b<=7;b++){a=texture2D(texture,coord.xy+vec2(0.,float(b)*delta));d=h(a.rgb)-l;e=kernel[7+b]*exp(-(d*d*j));i+=a.rgb*(e*a.a*f);c+=e*a.a*f;}gl_FragColor=vec4(i/c,1./c*2.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\n\nvarying vec4 coord;\n\nuniform sampler2D texture;\nuniform float colorProfile;\nuniform int pixelFormat;\nuniform float scale;\nuniform vec2 resolution;\n\nconst float PROFILE_sRGB_1604150559 = 0.0;\nconst float PROFILE_P3_1604150559 = 1.0;\nconst float PROFILE_YUV_OUT_1604150559 = 2.0;\n\nvec3 invCompand(in vec3 companded) {\n  return vec3(\n    (companded.r <= 0.04045) ? (companded.r / 12.92) : pow((companded.r + 0.055) / 1.055, 2.4),\n    (companded.g <= 0.04045) ? (companded.g / 12.92) : pow((companded.g + 0.055) / 1.055, 2.4),\n    (companded.b <= 0.04045) ? (companded.b / 12.92) : pow((companded.b + 0.055) / 1.055, 2.4)\n  );\n}\n\nvec3 compand(in vec3 linear) {\n  return vec3(\n    (linear.r <= 0.0031308) ? (linear.r * 12.92) : (1.055 * pow(linear.r, 1.0 / 2.4) - 0.055),\n    (linear.g <= 0.0031308) ? (linear.g * 12.92) : (1.055 * pow(linear.g, 1.0 / 2.4) - 0.055),\n    (linear.b <= 0.0031308) ? (linear.b * 12.92) : (1.055 * pow(linear.b, 1.0 / 2.4) - 0.055)\n  );\n}\n\n// sRGB\nconst mat3 matXYZtoRGB = mat3(\n\t3.2404541621141045, -0.9692660305051868, 0.055643430959114726,\n\t-1.5371385127977166, 1.8760108454466942, -0.2040259135167538,\n\t-0.498531409556016, 0.041556017530349834, 1.0572251882231791\n);\n\n// Adobe (Display P3)\n//const mat3 matP3toXYZ = mat3(\n//  0.5339322536875603, 0.25544127334904565, 0,\n//  0.2585025746446025, 0.6815250049351109, 0.061920384159055916,\n//  0.15802117166783758, 0.0630337217158436, 1.0271376158409444\n//);\n\n// Apple (Display P3)\nconst mat3 matP3toXYZ = mat3(\n  0.44437725301940956, 0.2076931069675821, -0.0005863356219285645,\n  0.29654436740749496, 0.7028080668178333, 0.042616530663972446,\n  0.20954837957309558, 0.08949882621458483, 1.046799804957956\n);\n\nconst vec3 offset_yuv_1604150559 = vec3(0.0625, 0.5, 0.5);\n\nmat3 matRGBtoYUV = mat3(\n  0.257, 0.504, 0.098,\n  -0.148, -0.291, 0.439,\n  0.439, -0.368, -0.071\n);\n\nvec3 RGBtoYUV(in vec3 rgb) {\n  return rgb * matRGBtoYUV + offset_yuv_1604150559;\n}\n\nvec3 convertProfile(in vec3 color, in float profile) {\n  if (profile == PROFILE_P3_1604150559) {\n    return compand(matXYZtoRGB * matP3toXYZ * invCompand(color));\n\n  } else if (profile == PROFILE_YUV_OUT_1604150559) {\n    return RGBtoYUV(color);\n\n  } else {\n    return color;\n  }\n}\n\n#define RGBA 0\n#define ABGR 1\n#define ARGB 2\n#define BGRA 3\n\nvec4 formatPixel(in vec4 color, in int pixelFormat) {\n  if (pixelFormat == ABGR) {\n    return color.abgr;\n  } else if (pixelFormat == ARGB) {\n    return color.argb;\n  } else if (pixelFormat == BGRA) {\n    return color.bgra;\n  } else {\n    return color;\n  }\n}\n\nvec4 resample (in sampler2D texture_0, in vec2 coords) {\n  vec2 factor = 1.0 / resolution * min((1.0 - scale) * 2.0, 1.0);\n  const float w = 0.25;\n  vec2 offset = factor * w;\n\n  return (\n    texture2D(texture_0, coords + vec2(-offset.x, -offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture_0, coords + vec2(-offset.x, offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture_0, coords + vec2(offset.x, -offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture_0, coords + vec2(offset.x, offset.y)) * vec4(w,w,w,w)\n  );\n}\n\nvoid main() {\n  vec4 color = resample(texture, coord.xy);\n\n  color = formatPixel(color, pixelFormat);\n\n  color.rgb = convertProfile(color.rgb, colorProfile);\n\n  gl_FragColor = color;\n}\n";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\n\nvarying vec4 coord;\n\nuniform sampler2D textures[4];\nuniform float colorProfile;\nuniform int pixelFormat;\nuniform float scale;\nuniform float scaleX;\nuniform vec2 resolution;\n\nconst float PROFILE_sRGB_1540259130 = 0.0;\nconst float PROFILE_P3_1540259130 = 1.0;\nconst float PROFILE_YUV_OUT_1540259130 = 2.0;\n\nvec3 invCompand(in vec3 companded) {\n  return vec3(\n    (companded.r <= 0.04045) ? (companded.r / 12.92) : pow((companded.r + 0.055) / 1.055, 2.4),\n    (companded.g <= 0.04045) ? (companded.g / 12.92) : pow((companded.g + 0.055) / 1.055, 2.4),\n    (companded.b <= 0.04045) ? (companded.b / 12.92) : pow((companded.b + 0.055) / 1.055, 2.4)\n  );\n}\n\nvec3 compand(in vec3 linear) {\n  return vec3(\n    (linear.r <= 0.0031308) ? (linear.r * 12.92) : (1.055 * pow(linear.r, 1.0 / 2.4) - 0.055),\n    (linear.g <= 0.0031308) ? (linear.g * 12.92) : (1.055 * pow(linear.g, 1.0 / 2.4) - 0.055),\n    (linear.b <= 0.0031308) ? (linear.b * 12.92) : (1.055 * pow(linear.b, 1.0 / 2.4) - 0.055)\n  );\n}\n\n// sRGB\nconst mat3 matXYZtoRGB = mat3(\n\t3.2404541621141045, -0.9692660305051868, 0.055643430959114726,\n\t-1.5371385127977166, 1.8760108454466942, -0.2040259135167538,\n\t-0.498531409556016, 0.041556017530349834, 1.0572251882231791\n);\n\n// Adobe (Display P3)\n//const mat3 matP3toXYZ = mat3(\n//  0.5339322536875603, 0.25544127334904565, 0,\n//  0.2585025746446025, 0.6815250049351109, 0.061920384159055916,\n//  0.15802117166783758, 0.0630337217158436, 1.0271376158409444\n//);\n\n// Apple (Display P3)\nconst mat3 matP3toXYZ = mat3(\n  0.44437725301940956, 0.2076931069675821, -0.0005863356219285645,\n  0.29654436740749496, 0.7028080668178333, 0.042616530663972446,\n  0.20954837957309558, 0.08949882621458483, 1.046799804957956\n);\n\nconst vec3 offset_yuv_1540259130 = vec3(0.0625, 0.5, 0.5);\n\nmat3 matRGBtoYUV = mat3(\n  0.257, 0.504, 0.098,\n  -0.148, -0.291, 0.439,\n  0.439, -0.368, -0.071\n);\n\nvec3 RGBtoYUV(in vec3 rgb) {\n  return rgb * matRGBtoYUV + offset_yuv_1540259130;\n}\n\nvec3 convertProfile(in vec3 color, in float profile) {\n  if (profile == PROFILE_P3_1540259130) {\n    return compand(matXYZtoRGB * matP3toXYZ * invCompand(color));\n\n  } else if (profile == PROFILE_YUV_OUT_1540259130) {\n    return RGBtoYUV(color);\n\n  } else {\n    return color;\n  }\n}\n\n#define RGBA 0\n#define ABGR 1\n#define ARGB 2\n#define BGRA 3\n\nvec4 formatPixel(in vec4 color, in int pixelFormat) {\n  if (pixelFormat == ABGR) {\n    return color.abgr;\n  } else if (pixelFormat == ARGB) {\n    return color.argb;\n  } else if (pixelFormat == BGRA) {\n    return color.bgra;\n  } else {\n    return color;\n  }\n}\n\nvec4 resample (in sampler2D texture, in vec2 coords_0) {\n  vec2 factor = 1.0 / resolution * min((1.0 - scale) * 2.0, 1.0);\n  const float w = 0.25;\n  vec2 offset = factor * w;\n\n  return (\n    texture2D(texture, coords_0 + vec2(-offset.x, -offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture, coords_0 + vec2(-offset.x, offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture, coords_0 + vec2(offset.x, -offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture, coords_0 + vec2(offset.x, offset.y)) * vec4(w,w,w,w)\n  );\n}\n\nvec4 lookupTexture(vec2 coords) {\n  vec2 c = coords * 2.0;\n  vec2 f = floor(c);\n  int i = int(f.x + f.y * 2.0);\n  vec2 uv = vec2(c.x - f.x, c.y - f.y);\n  vec4 col;\n\n  uv.x *= scaleX;\n\n  if (i == 0) {\n    col = resample(textures[0], uv);\n  } else if (i == 1) {\n    col = resample(textures[1], uv);\n  } else if (i == 2) {\n    col = resample(textures[2], uv);\n  } else /* if (i == 3) */ {\n    col = resample(textures[3], uv);\n  }\n\n  return col;\n}\n\nvoid main(){\n  vec4 color = lookupTexture(coord.xy);\n\n  color = formatPixel(color, pixelFormat);\n\n  color.rgb = convertProfile(color.rgb, colorProfile);\n\n  gl_FragColor = color;\n}\n";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\n\nvarying vec4 coord;\nvarying vec2 fringingCoord[3];\n\nuniform sampler2D texture;\nuniform float colorProfile;\nuniform int pixelFormat;\nuniform float scale;\nuniform vec2 resolution;\nuniform vec2 fringing_center;\nuniform float fringing_radius;\nuniform float fringing_hue;\n\nconst float PROFILE_sRGB_1540259130 = 0.0;\nconst float PROFILE_P3_1540259130 = 1.0;\nconst float PROFILE_YUV_OUT_1540259130 = 2.0;\n\nvec3 invCompand(in vec3 companded) {\n  return vec3(\n    (companded.r <= 0.04045) ? (companded.r / 12.92) : pow((companded.r + 0.055) / 1.055, 2.4),\n    (companded.g <= 0.04045) ? (companded.g / 12.92) : pow((companded.g + 0.055) / 1.055, 2.4),\n    (companded.b <= 0.04045) ? (companded.b / 12.92) : pow((companded.b + 0.055) / 1.055, 2.4)\n  );\n}\n\nvec3 compand(in vec3 linear) {\n  return vec3(\n    (linear.r <= 0.0031308) ? (linear.r * 12.92) : (1.055 * pow(linear.r, 1.0 / 2.4) - 0.055),\n    (linear.g <= 0.0031308) ? (linear.g * 12.92) : (1.055 * pow(linear.g, 1.0 / 2.4) - 0.055),\n    (linear.b <= 0.0031308) ? (linear.b * 12.92) : (1.055 * pow(linear.b, 1.0 / 2.4) - 0.055)\n  );\n}\n\n// sRGB\nconst mat3 matXYZtoRGB = mat3(\n\t3.2404541621141045, -0.9692660305051868, 0.055643430959114726,\n\t-1.5371385127977166, 1.8760108454466942, -0.2040259135167538,\n\t-0.498531409556016, 0.041556017530349834, 1.0572251882231791\n);\n\n// Adobe (Display P3)\n//const mat3 matP3toXYZ = mat3(\n//  0.5339322536875603, 0.25544127334904565, 0,\n//  0.2585025746446025, 0.6815250049351109, 0.061920384159055916,\n//  0.15802117166783758, 0.0630337217158436, 1.0271376158409444\n//);\n\n// Apple (Display P3)\nconst mat3 matP3toXYZ = mat3(\n  0.44437725301940956, 0.2076931069675821, -0.0005863356219285645,\n  0.29654436740749496, 0.7028080668178333, 0.042616530663972446,\n  0.20954837957309558, 0.08949882621458483, 1.046799804957956\n);\n\nconst vec3 offset_yuv_1540259130 = vec3(0.0625, 0.5, 0.5);\n\nmat3 matRGBtoYUV_0 = mat3(\n  0.257, 0.504, 0.098,\n  -0.148, -0.291, 0.439,\n  0.439, -0.368, -0.071\n);\n\nvec3 RGBtoYUV_0(in vec3 rgb) {\n  return rgb * matRGBtoYUV_0 + offset_yuv_1540259130;\n}\n\nvec3 convertProfile(in vec3 color, in float profile) {\n  if (profile == PROFILE_P3_1540259130) {\n    return compand(matXYZtoRGB * matP3toXYZ * invCompand(color));\n\n  } else if (profile == PROFILE_YUV_OUT_1540259130) {\n    return RGBtoYUV_0(color);\n\n  } else {\n    return color;\n  }\n}\n\n#define RGBA 0\n#define ABGR 1\n#define ARGB 2\n#define BGRA 3\n\nvec4 formatPixel(in vec4 color, in int pixelFormat) {\n  if (pixelFormat == ABGR) {\n    return color.abgr;\n  } else if (pixelFormat == ARGB) {\n    return color.argb;\n  } else if (pixelFormat == BGRA) {\n    return color.bgra;\n  } else {\n    return color;\n  }\n}\n\nvec4 resample (in sampler2D texture_0, in vec2 coords) {\n  vec2 factor = 1.0 / resolution * min((1.0 - scale) * 2.0, 1.0);\n  const float w = 0.25;\n  vec2 offset = factor * w;\n\n  return (\n    texture2D(texture_0, coords + vec2(-offset.x, -offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture_0, coords + vec2(-offset.x, offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture_0, coords + vec2(offset.x, -offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture_0, coords + vec2(offset.x, offset.y)) * vec4(w,w,w,w)\n  );\n}\n\nmat3 matYUVtoRGB = mat3(\n  1, 0.956, 0.621,\n  1, -0.272, -0.647,\n  1, -1.107, 1.705\n);\n\nmat3 matRGBtoYUV = mat3(\n  0.299, 0.587, 0.114,\n  0.596, -0.274, -0.321,\n  0.211, -0.523, 0.311\n);\n\nvec3 RGBtoYUV(in vec3 rgb) {\n  return rgb * matRGBtoYUV;\n}\n\nvec3 YUVtoRGB(in vec3 yuv) {\n  return yuv * matYUVtoRGB;\n}\n\nmat3 rotateHue(float r) {\n  return mat3(1, 0, 0,\n      0, cos(r), -sin(r),\n      0, sin(r), cos(r));\n}\n\nvec3 rotateColor(in vec3 col, mat3 rotation) {\n  return YUVtoRGB(rotation * RGBtoYUV(col));\n}\n\nfloat random() {\n  const vec3 scale = vec3(12.9898, 78.233, 151.7182);\n  return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n}\n\nvoid main() {\n  vec3 color;\n  vec4 colors[3];\n\n  colors[0] = resample(texture, fringingCoord[0]);\n  colors[1] = resample(texture, fringingCoord[1]);\n  colors[2] = resample(texture, fringingCoord[2]);\n\n  colors[0] = formatPixel(colors[0], pixelFormat);\n  colors[1] = formatPixel(colors[1], pixelFormat);\n  colors[2] = formatPixel(colors[2], pixelFormat);\n\n  mat3 hue = rotateHue(fringing_hue);\n  mat3 hueInv = rotateHue(-fringing_hue);\n\n  vec3 channels = vec3(\n    rotateColor(colors[0].rgb, hue).r,\n    rotateColor(colors[1].rgb, hue).g,\n    rotateColor(colors[2].rgb, hue).b\n  );\n\n  color = rotateColor(channels, hueInv);\n\n  float alpha = (colors[0].a + colors[1].a + colors[2].a) / 3.0;\n\n  color.rgb = convertProfile(color.rgb, colorProfile);\n\n  gl_FragColor = vec4(color.rgb, alpha);\n}\n";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec2 distortionCoord;uniform sampler2D texture;uniform bool useTexture;uniform bool horizontal;float f(float a,float b){a=floor(a)+.5;return floor(a/exp2(b));}float g(float a,float b){return floor(a*exp2(b)+.5);}float h(float a,float b){return mod(a,g(1.,b));}float d(float c,float a,float b){a=floor(a+.5);b=floor(b+.5);return h(f(c,a),b-a);}vec4 i(float a){if(a==0.)return vec4(0,0,0,0);float j=a>0.?0.:1.;a=abs(a);float c=floor(log2(a));float k=c+127.;float b=(a/exp2(c)-1.)*8388608.;float e=k/2.;float l=fract(e)*2.;float m=floor(e);float n=d(b,0.,8.)/255.;float o=d(b,8.,16.)/255.;float p=(l*128.+d(b,16.,23.))/255.;float q=(j*128.+m)/255.;return vec4(n,o,p,q);}void main(){vec4 a;if(useTexture){a=texture2D(texture,distortionCoord);}else{highp float b=horizontal?distortionCoord.x:distortionCoord.y;a=i(b);}gl_FragColor=a;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\n\nvarying vec4 coord;\nvarying vec2 fringingCoord[3];\n\nuniform sampler2D textures[4];\nuniform float colorProfile;\nuniform int pixelFormat;\nuniform float scale;\nuniform float scaleX;\nuniform vec2 resolution;\nuniform vec2 fringing_center;\nuniform float fringing_radius;\nuniform float fringing_hue;\n\nconst float PROFILE_sRGB_1117569599 = 0.0;\nconst float PROFILE_P3_1117569599 = 1.0;\nconst float PROFILE_YUV_OUT_1117569599 = 2.0;\n\nvec3 invCompand(in vec3 companded) {\n  return vec3(\n    (companded.r <= 0.04045) ? (companded.r / 12.92) : pow((companded.r + 0.055) / 1.055, 2.4),\n    (companded.g <= 0.04045) ? (companded.g / 12.92) : pow((companded.g + 0.055) / 1.055, 2.4),\n    (companded.b <= 0.04045) ? (companded.b / 12.92) : pow((companded.b + 0.055) / 1.055, 2.4)\n  );\n}\n\nvec3 compand(in vec3 linear) {\n  return vec3(\n    (linear.r <= 0.0031308) ? (linear.r * 12.92) : (1.055 * pow(linear.r, 1.0 / 2.4) - 0.055),\n    (linear.g <= 0.0031308) ? (linear.g * 12.92) : (1.055 * pow(linear.g, 1.0 / 2.4) - 0.055),\n    (linear.b <= 0.0031308) ? (linear.b * 12.92) : (1.055 * pow(linear.b, 1.0 / 2.4) - 0.055)\n  );\n}\n\n// sRGB\nconst mat3 matXYZtoRGB = mat3(\n\t3.2404541621141045, -0.9692660305051868, 0.055643430959114726,\n\t-1.5371385127977166, 1.8760108454466942, -0.2040259135167538,\n\t-0.498531409556016, 0.041556017530349834, 1.0572251882231791\n);\n\n// Adobe (Display P3)\n//const mat3 matP3toXYZ = mat3(\n//  0.5339322536875603, 0.25544127334904565, 0,\n//  0.2585025746446025, 0.6815250049351109, 0.061920384159055916,\n//  0.15802117166783758, 0.0630337217158436, 1.0271376158409444\n//);\n\n// Apple (Display P3)\nconst mat3 matP3toXYZ = mat3(\n  0.44437725301940956, 0.2076931069675821, -0.0005863356219285645,\n  0.29654436740749496, 0.7028080668178333, 0.042616530663972446,\n  0.20954837957309558, 0.08949882621458483, 1.046799804957956\n);\n\nconst vec3 offset_yuv_1117569599 = vec3(0.0625, 0.5, 0.5);\n\nmat3 matRGBtoYUV_0 = mat3(\n  0.257, 0.504, 0.098,\n  -0.148, -0.291, 0.439,\n  0.439, -0.368, -0.071\n);\n\nvec3 RGBtoYUV_0(in vec3 rgb) {\n  return rgb * matRGBtoYUV_0 + offset_yuv_1117569599;\n}\n\nvec3 convertProfile(in vec3 color, in float profile) {\n  if (profile == PROFILE_P3_1117569599) {\n    return compand(matXYZtoRGB * matP3toXYZ * invCompand(color));\n\n  } else if (profile == PROFILE_YUV_OUT_1117569599) {\n    return RGBtoYUV_0(color);\n\n  } else {\n    return color;\n  }\n}\n\n#define RGBA 0\n#define ABGR 1\n#define ARGB 2\n#define BGRA 3\n\nvec4 formatPixel(in vec4 color, in int pixelFormat) {\n  if (pixelFormat == ABGR) {\n    return color.abgr;\n  } else if (pixelFormat == ARGB) {\n    return color.argb;\n  } else if (pixelFormat == BGRA) {\n    return color.bgra;\n  } else {\n    return color;\n  }\n}\n\nvec4 resample (in sampler2D texture, in vec2 coords_0) {\n  vec2 factor = 1.0 / resolution * min((1.0 - scale) * 2.0, 1.0);\n  const float w = 0.25;\n  vec2 offset = factor * w;\n\n  return (\n    texture2D(texture, coords_0 + vec2(-offset.x, -offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture, coords_0 + vec2(-offset.x, offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture, coords_0 + vec2(offset.x, -offset.y)) * vec4(w,w,w,w) +\n    texture2D(texture, coords_0 + vec2(offset.x, offset.y)) * vec4(w,w,w,w)\n  );\n}\n\nmat3 matYUVtoRGB = mat3(\n  1, 0.956, 0.621,\n  1, -0.272, -0.647,\n  1, -1.107, 1.705\n);\n\nmat3 matRGBtoYUV = mat3(\n  0.299, 0.587, 0.114,\n  0.596, -0.274, -0.321,\n  0.211, -0.523, 0.311\n);\n\nvec3 RGBtoYUV(in vec3 rgb) {\n  return rgb * matRGBtoYUV;\n}\n\nvec3 YUVtoRGB(in vec3 yuv) {\n  return yuv * matYUVtoRGB;\n}\n\nmat3 rotateHue(float r) {\n  return mat3(1, 0, 0,\n      0, cos(r), -sin(r),\n      0, sin(r), cos(r));\n}\n\nvec3 rotateColor(in vec3 col, mat3 rotation) {\n  return YUVtoRGB(rotation * RGBtoYUV(col));\n}\n\nfloat random() {\n  const vec3 scale = vec3(12.9898, 78.233, 151.7182);\n  return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n}\n\nvec4 lookupTextureResample(in vec2 coords) {\n  vec2 c = coords * 2.0;\n  vec2 f = floor(c);\n  int i = int(f.x + f.y * 2.0);\n  vec2 uv = c - f;\n  lowp vec4 col;\n\n  uv.x *= scaleX;\n\n  if (i == 0) {\n    col = resample(textures[0], uv);\n  } else if (i == 1) {\n    col = resample(textures[1], uv);\n  } else if (i == 2) {\n    col = resample(textures[2], uv);\n  } else /* if (i == 3) */ {\n    col = resample(textures[3], uv);\n  }\n\n  return col;\n}\n\nvoid main() {\n  vec3 color;\n  vec4 colors[3];\n\n  colors[0] = lookupTextureResample(fringingCoord[0]);\n  colors[1] = lookupTextureResample(fringingCoord[1]);\n  colors[2] = lookupTextureResample(fringingCoord[2]);\n\n  colors[0] = formatPixel(colors[0], pixelFormat);\n  colors[1] = formatPixel(colors[1], pixelFormat);\n  colors[2] = formatPixel(colors[2], pixelFormat);\n\n  mat3 hue = rotateHue(fringing_hue);\n  mat3 hueInv = rotateHue(-fringing_hue);\n\n  vec3 channels = vec3(\n    rotateColor(colors[0].rgb, hue).r,\n    rotateColor(colors[1].rgb, hue).g,\n    rotateColor(colors[2].rgb, hue).b\n  );\n\n  color = rotateColor(channels, hueInv);\n\n  float alpha = (colors[0].a + colors[1].a + colors[2].a) / 3.0;\n\n  color.rgb = convertProfile(color.rgb, colorProfile);\n\n  gl_FragColor = vec4(color.rgb, alpha);\n}\n";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;precision lowp sampler2D;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D originalTexture;uniform sampler2D smoothMap;uniform sampler2D faceMask;uniform float skin_smoothness;uniform float skin_tone;uniform float skin_shadows;uniform float skin_highlights;uniform float skin_hue;uniform float skin_saturation;uniform float teeth_brightness;uniform float teeth_whitening;uniform float eyes_brightness;uniform float eyes_contrast;uniform float eyes_clarity;uniform float lips_brightness;uniform float lips_saturation;const mat3 m=mat3(.412456,.212673,.019334,.357576,.715152,.119192,.180437,.072175,.950304);const mat3 n=mat3(3.240454,-.969266,.055643,-1.537139,1.876011,-.204026,-.498531,.041556,1.057225);const mat3 o=mat3(.987224,-.007598,.003073,-.006113,1.00186,-.005096,.015953,.00533,1.08168);const mat3 p=mat3(1.013035,.007698,-.002841,.006105,.998165,.004685,-.014971,-.005032,.924507);const mat3 q=mat3(.662454,.272229,-.005575,.134004,.674082,.004061,.156188,.05369,1.010339);const mat3 r=mat3(1.641023,-.663663,.011722,-.324803,1.615332,-.008284,-.236425,.016756,.988395);const mat3 s=o*q;const mat3 t=r*p;const mat3 f=t*m;const mat3 u=n*s;vec3 g(in vec3 a){return vec3(a.r<=.04045?a.r/12.92:pow((a.r+.055)/1.055,2.4),a.g<=.04045?a.g/12.92:pow((a.g+.055)/1.055,2.4),a.b<=.04045?a.b/12.92:pow((a.b+.055)/1.055,2.4));}vec3 v(in vec3 a){return vec3(a.r<=.003131?a.r*12.92:1.055*pow(a.r,1./2.4)-.055,a.g<=.003131?a.g*12.92:1.055*pow(a.g,1./2.4)-.055,a.b<=.003131?a.b*12.92:1.055*pow(a.b,1./2.4)-.055);}float w(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}vec3 x(in vec3 b){const vec4 d=vec4(0.,-1./3.,2./3.,-1.);vec4 c=mix(vec4(b.bg,d.wz),vec4(b.gb,d.xy),step(b.b,b.g));vec4 a=mix(vec4(c.xyw,b.r),vec4(b.r,c.yzx),step(c.x,b.r));float e=a.x-min(a.w,a.y);return vec3(abs(a.z+(a.w-a.y)/(6.*e+1e-10)),e/(a.x+1e-10),a.x);}vec3 y(in vec3 b){const vec4 a=vec4(1.,2./3.,1./3.,3.);vec3 c=abs(fract(b.xxx+a.xyz)*6.-a.www);return b.z*mix(a.xxx,clamp(c-a.xxx,0.,1.),b.y);}float k(in float a){return exp(-3.141593*2.*a*a);}vec3 z(in vec3 a,in float c){float e=abs(c);float b=pow(2.,e+1.)-2.;float d=1.-exp(-b);a*=.99;a=c>0.?(1.-exp(-b*a))/d:log(1.-a*d)/-b;return a/.99;}void A(inout vec3 b,in float c,in vec3 d){float e=c>0.?c*8.:c*4.;vec3 a=mix(vec3(.5),d,e);a=clamp(a,0.,1.);b=mix(2.*b*a+b*b*(1.-2.*a),sqrt(b)*(2.*a-1.)+2.*b*(1.-a),step(.5,a));}void B(inout vec3 a,in float b){float d=b<0.?b*.5:b;vec3 c=mix(vec3(.5),a,d);a=mix(2.*a*c,1.-2.*(1.-a)*(1.-c),step(.5,a));}void main(){lowp vec4 h=texture2D(texture,coord.xy);lowp vec3 i=texture2D(originalTexture,coord.xy).rgb;lowp vec3 d=texture2D(smoothMap,distortionCoord).rgb;lowp vec4 b=texture2D(faceMask,distortionCoord);vec3 a=h.rgb;a=f*g(a);d=f*g(d);i=f*g(i);vec3 C=(i+(1.-d))*.5;float j=w(d);float e=1.-clamp(b.r*.5+b.g+b.b,0.,1.);float D=-skin_smoothness*e*sqrt(sqrt(j))+eyes_clarity*2.*b.b;A(a,D,C);B(a,eyes_contrast*b.b);float E=mix(skin_highlights+skin_shadows*.1,skin_shadows*pow(1.-j,2.),1.-j);float l=eyes_brightness*b.b+skin_tone*.3+E*e+lips_brightness*b.r*.3+teeth_brightness*b.g;if(l!=0.)a=z(a,l);vec3 c=x(a);float F=(c.x-.084)/.3;float G=k(F)*min(1.,c.y*2.);c.x+=skin_hue*.05*G*e;c.y*=1.+skin_saturation*.5*e;float H=(c.x-.166)/.3;c.y*=1.-teeth_whitening*b.g*k(H);c.y=c.y*(1.+lips_saturation*.5*b.r);a=y(c);a=clamp(a,0.,1.);a=v(u*a);a=mix(h.rgb,a,b.a);gl_FragColor=vec4(a,h.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform vec4 fill_color;uniform float fill_blend;uniform sampler2D texture;vec3 f(in vec3 a,in vec3 b,in float c){return abs(a-b*c);}float g(in float b,in float a){return a==1.?a:min(b/(1.-a),1.);}float h(in float b,in float a){return a==0.?a:max(1.-(1.-b)/a,0.);}float d(in float b,in float a){return a<.5?h(b,2.*a):g(b,2.*(a-.5));}vec3 i(in vec3 b,in vec3 a,in float c){a=mix(vec3(.5),a,c);return vec3(d(b.r,a.r),d(b.g,a.g),d(b.b,a.b));}void main(){lowp vec4 a=texture2D(texture,coord.xy);lowp vec3 b=mix(a.rgb,fill_color.rgb,fill_color.a*a.a);lowp vec3 c;float e=min(1.,(1.-abs(fill_blend))*1.333);float j=min(1.,abs(fill_blend)*4.);c=fill_blend>0.?i(a.rgb,b,e):f(a.rgb,b,e);b=mix(b,c,j);gl_FragColor=vec4(b,a.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 backgroundCoords;uniform sampler2D texture;uniform sampler2D layerTexture;uniform vec4 colorOverlay;uniform float opacity;uniform float blendMode;float o(in vec3 a){float b=min(min(a.r,a.g),a.b);float c=max(max(a.r,a.g),a.b);return c-b;}vec3 p(in vec3 a,in float d){float c=min(min(a.r,a.g),a.b);float e=max(max(a.r,a.g),a.b);vec3 b=vec3(0.);if(e>c){if(a.r==c&&a.b==e){b.r=0.;b.g=(a.g-c)*d/(e-c);b.b=d;}else if(a.r==c&&a.g==e){b.r=0.;b.b=(a.b-c)*d/(e-c);b.g=d;}else if(a.g==c&&a.b==e){b.g=0.;b.r=(a.r-c)*d/(e-c);b.b=d;}else if(a.g==c&&a.r==e){b.g=0.;b.b=(a.b-c)*d/(e-c);b.r=d;}else if(a.b==c&&a.r==e){b.b=0.;b.g=(a.g-c)*d/(e-c);b.r=d;}else{b.b=0.;b.r=(a.r-c)*d/(e-c);b.g=d;}}return b;}float f(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}vec3 s(in vec3 a){float b=f(a);float c=min(min(a.r,a.g),a.b);float d=max(max(a.r,a.g),a.b);if(c<0.)a=(a-b)*b/(b-c)+b;if(d>1.)a=(a-b)*(1.-b)/(d-b)+b;return a;}vec3 g(in vec3 a,in float c){float b=c-f(a);a.r=a.r+b;a.g=a.g+b;a.b=a.b+b;return s(a);}vec3 t(in vec3 a,in vec3 b){return max(b,a);}vec3 u(in vec3 a,in vec3 b){return min(b,a);}vec3 v(in vec3 a,in vec3 b){return a*b;}vec3 w(in vec3 a,in vec3 b){return a/b;}vec3 x(in vec3 a,in vec3 b){return min(a+b,vec3(1.));}vec3 q(in vec3 a,in vec3 b){return max(a+b-vec3(1.),vec3(0.));}vec3 y(in vec3 a,in vec3 b){return abs(a-b);}vec3 z(in vec3 a,in vec3 b){return a+b-2.*a*b;}float j(in float a,in float b){return 1.-(1.-a)*(1.-b);}vec3 A(in vec3 a,in vec3 b){return vec3(j(a.r,b.r),j(a.g,b.g),j(a.b,b.b));}float k(in float a,in float b){return a<.5?2.*a*b:1.-2.*(1.-a)*(1.-b);}vec3 r(in vec3 a,in vec3 b){return vec3(k(a.r,b.r),k(a.g,b.g),k(a.b,b.b));}float l(in float a,in float b){return b<.5?2.*a*b+a*a*(1.-2.*b):sqrt(a)*(2.*b-1.)+2.*a*(1.-b);}vec3 B(in vec3 a,in vec3 b){return vec3(l(a.r,b.r),l(a.g,b.g),l(a.b,b.b));}vec3 C(in vec3 a,in vec3 b){return r(b,a);}float h(in float b,in float a){return a==1.?a:min(b/(1.-a),1.);}vec3 D(in vec3 a,in vec3 b){return vec3(h(a.r,b.r),h(a.g,b.g),h(a.b,b.b));}float i(in float b,in float a){return a==0.?a:max(1.-(1.-b)/a,0.);}vec3 E(in vec3 a,in vec3 b){return vec3(i(a.r,b.r),i(a.g,b.g),i(a.b,b.b));}float m(in float b,in float a){return a<.5?max(b+2.*a-1.,0.):min(b+2.*(a-.5),1.);}vec3 F(in vec3 a,in vec3 b){return vec3(m(a.r,b.r),m(a.g,b.g),m(a.b,b.b));}float n(in float b,in float a){return a<.5?i(b,2.*a):h(b,2.*(a-.5));}vec3 G(in vec3 a,in vec3 b){return vec3(n(a.r,b.r),n(a.g,b.g),n(a.b,b.b));}vec3 H(in vec3 a,in vec3 b){return g(p(b,o(a)),f(a));}vec3 I(in vec3 a,in vec3 b){return g(p(a,o(b)),f(a));}vec3 J(in vec3 a,in vec3 b){return g(b,f(a));}vec3 K(in vec3 a,in vec3 b){return g(a,f(b));}void main(){lowp vec3 b=texture2D(texture,backgroundCoords.xy).rgb;lowp vec4 c=texture2D(layerTexture,coord.xy);lowp vec3 a=mix(c.rgb,colorOverlay.rgb,colorOverlay.a);if(blendMode==1.)a=u(b,a);else if(blendMode==2.)a=v(b,a);else if(blendMode==3.)a=E(b,a);else if(blendMode==4.)a=q(b,a);else if(blendMode==5.)a=t(b,a);else if(blendMode==6.)a=A(b,a);else if(blendMode==7.)a=D(b,a);else if(blendMode==8.)a=x(b,a);else if(blendMode==9.)a=r(b,a);else if(blendMode==10.)a=B(b,a);else if(blendMode==11.)a=C(b,a);else if(blendMode==12.)a=G(b,a);else if(blendMode==13.)a=F(b,a);else if(blendMode==14.)a=y(b,a);else if(blendMode==15.)a=z(b,a);else if(blendMode==16.)a=q(b,a);else if(blendMode==17.)a=w(b,a);else if(blendMode==18.)a=H(b,a);else if(blendMode==19.)a=I(b,a);else if(blendMode==20.)a=J(b,a);else if(blendMode==21.)a=K(b,a);else if(blendMode==22.)a=b;gl_FragColor=vec4(a,c.a*opacity);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\n\nvarying vec4 coord;\nvarying vec4 backgroundCoords;\n\nuniform sampler2D texture;\nuniform sampler2D layerTexture;\nuniform float opacity;\nuniform float fill;\nuniform int blendMode;\nuniform int gradient;\nuniform bool reverse;\nuniform bool repeat;\nuniform bool reflect;\n\nfloat sat(in vec3 c){\n    float n = min(min(c.r, c.g), c.b);\n    float x = max(max(c.r, c.g), c.b);\n\n    return x - n;\n}\n\nvec3 setSat(in vec3 c, in float s){\n    float cmin = min(min(c.r, c.g), c.b);\n    float cmax = max(max(c.r, c.g), c.b);\n\n    vec3 res = vec3(0.0);\n\n    if (cmax > cmin) {\n\n        if (c.r == cmin && c.b == cmax) { // R min G mid B max\n            res.r = 0.0;\n            res.g = ((c.g-cmin)*s) / (cmax-cmin);\n            res.b = s;\n        }\n        else if (c.r == cmin && c.g == cmax) { // R min B mid G max\n            res.r = 0.0;\n            res.b = ((c.b-cmin)*s) / (cmax-cmin);\n            res.g = s;\n        }\n        else if (c.g == cmin && c.b == cmax) { // G min R mid B max\n            res.g = 0.0;\n            res.r = ((c.r-cmin)*s) / (cmax-cmin);\n            res.b = s;\n        }\n        else if (c.g == cmin && c.r == cmax) { // G min B mid R max\n            res.g = 0.0;\n            res.b = ((c.b-cmin)*s) / (cmax-cmin);\n            res.r = s;\n        }\n        else if (c.b == cmin && c.r == cmax) { // B min G mid R max\n            res.b = 0.0;\n            res.g = ((c.g-cmin)*s) / (cmax-cmin);\n            res.r = s;\n        }\n        else { // B min R mid G max\n            res.b = 0.0;\n            res.r = ((c.r-cmin)*s) / (cmax-cmin);\n            res.g = s;\n        }\n\n    }\n\n    return res;\n}\n\nfloat luma(in vec3 color){\n    return dot(color, vec3(0.298839, 0.586811, 0.11435));\n}\n\nvec3 clipColor(in vec3 c) {\n    float l = luma(c);\n    float n = min(min(c.r, c.g), c.b);\n    float x = max(max(c.r, c.g), c.b);\n\n    if (n < 0.0) c = (c-l)*l / (l-n) + l;\n    if (x > 1.0) c = (c-l) * (1.0-l) / (x-l) + l;\n\n    return c;\n}\n\nvec3 setLuma(in vec3 c, in float l) {\n    float d = l - luma(c);\n\n    c.r = c.r + d;\n    c.g = c.g + d;\n    c.b = c.b + d;\n\n    return clipColor(c);\n}\n\nvec3 blendLighten(in vec3 base, in vec3 blend, in float fill) {\n    blend *= fill;\n    return max(blend, base);\n}\n\nvec3 blendDarken(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(vec3(1.0), blend, fill);\n    return min(blend, base);\n}\n\nvec3 blendMultiply(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(vec3(1.0), blend, fill);\n    return base * blend;\n}\n\nvec3 blendDivide(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(vec3(1.0), blend, fill);\n    return base / blend;\n}\n\nvec3 blendAdd(in vec3 base, in vec3 blend, in float fill) {\n    blend *= fill;\n    return min(base + blend, vec3(1.0));\n}\n\nvec3 blendSubtract(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(vec3(1.0), blend, fill);\n    return max(base + blend - vec3(1.0), vec3(0.0));\n}\n\nvec3 blendDifference(in vec3 base, in vec3 blend, in float fill) {\n    blend *= fill;\n    return abs(base - blend);\n}\n\nvec3 blendExclusion(in vec3 base, in vec3 blend, in float fill) {\n    blend *= fill;\n    return (base + blend - 2.0 * base * blend);\n}\n\nfloat blendScreen(in float base, in float blend) {\n    return 1.0-((1.0-base)*(1.0-blend));\n}\n\nvec3 blendScreen(in vec3 base, in vec3 blend, in float fill) {\n    blend *= fill;\n    return vec3(blendScreen(base.r, blend.r), blendScreen(base.g, blend.g), blendScreen(base.b, blend.b));\n}\n\nfloat blendOverlay(in float base, in float blend) {\n    return base<0.5?(2.0*base*blend):(1.0-2.0*(1.0-base)*(1.0-blend));\n}\n\nvec3 blendOverlay(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(vec3(0.5), blend, fill);\n    return vec3(blendOverlay(base.r, blend.r), blendOverlay(base.g, blend.g), blendOverlay(base.b, blend.b));\n}\n\nfloat blendSoftLight(in float base, in float blend) {\n    return (blend<0.5)?(2.0*base*blend+base*base*(1.0-2.0*blend)):(sqrt(base)*(2.0*blend-1.0)+2.0*base*(1.0-blend));\n}\n\nvec3 blendSoftLight(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(vec3(0.5), blend, fill);\n    return vec3(blendSoftLight(base.r, blend.r), blendSoftLight(base.g, blend.g), blendSoftLight(base.b, blend.b));\n}\n\nvec3 blendHardLight(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(vec3(0.5), blend, fill);\n    return blendOverlay(blend, base, 1.0);\n}\n\nfloat blendColorDodge(in float base, in float blend) {\n    return (blend==1.0)?blend:min(base/(1.0-blend), 1.0);\n}\n\nvec3 blendColorDodge(in vec3 base, in vec3 blend, in float fill) {\n    blend *= fill;\n    return vec3(blendColorDodge(base.r, blend.r), blendColorDodge(base.g, blend.g), blendColorDodge(base.b, blend.b));\n}\n\nfloat blendColorBurn(in float base, in float blend) {\n    return (blend==0.0)?blend:max((1.0-((1.0-base)/blend)), 0.0);\n}\n\nvec3 blendColorBurn(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(vec3(1.0), blend, fill);\n    return vec3(blendColorBurn(base.r, blend.r), blendColorBurn(base.g, blend.g), blendColorBurn(base.b, blend.b));\n}\n\nfloat blendLinearLight(in float base, in float blend) {\n    return blend<0.5?max(base+(2.0*blend)-1.0, 0.0):min(base+(2.0*(blend-0.5)), 1.0);\n}\n\nvec3 blendLinearLight(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(vec3(0.5), blend, fill);\n    return vec3(blendLinearLight(base.r, blend.r), blendLinearLight(base.g, blend.g), blendLinearLight(base.b, blend.b));\n}\n\nfloat blendVividLight(in float base, in float blend) {\n    return (blend<0.5)?blendColorBurn(base, (2.0*blend)):blendColorDodge(base, (2.0*(blend-0.5)));\n}\n\nvec3 blendVividLight(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(vec3(0.5), blend, fill);\n    return vec3(blendVividLight(base.r, blend.r), blendVividLight(base.g, blend.g), blendVividLight(base.b, blend.b));\n}\n\nvec3 blendHue(in vec3 base, in vec3 blend, in float fill) {\n    return mix(\n    base,\n    setLuma(setSat(blend, sat(base)), luma(base)),\n    fill\n    );\n}\n\nvec3 blendSaturation(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(base, blend, fill);\n    return setLuma(setSat(base, sat(blend)), luma(base));\n}\n\nvec3 blendColor(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(base, blend, fill);\n    return setLuma(blend, luma(base));\n}\n\nvec3 blendLuminosity(in vec3 base, in vec3 blend, in float fill) {\n    blend = mix(base, blend, fill);\n    return setLuma(base, luma(blend));\n}\n\nconst vec3 randomScale = vec3(12.9898, 78.233, 151.7182);\nfloat random() {\n    return fract(sin(dot(gl_FragCoord.xyz, randomScale)) * 43758.5453);\n}\n\nvoid main() {\n    lowp vec4 color = texture2D(texture, coord.xy);\n\n    vec2 layerCoords = backgroundCoords.xy;\n    float layerMask = 1.0;\n    float dither = 0.0;\n\n    // linear gradient\n    if (gradient == 1) {\n        dither = (random() - 0.5) * 0.01;\n\n        // radial gradient\n    } else if (gradient == 2) {\n        dither = (random() - 0.5) * 0.01;\n        float dist = length(layerCoords * 2.0 - 1.0);\n        layerCoords = vec2(dist, 0.5);\n\n        // gradient map (luminance)\n    } else if (gradient == 3) {\n        layerCoords = vec2(luma(color.rgb), 0.5);\n\n        // no gradient (image)\n    } else {\n        layerMask = float(!(layerCoords.x > 1.0 || layerCoords.x < 0.0 || layerCoords.y > 1.0 || layerCoords.y < 0.0));\n    }\n\n    if (repeat) layerCoords.x = mod(layerCoords.x, 1.0);\n    if (reflect) layerCoords.x = abs(1.0 - layerCoords.x * 2.0);\n    if (reverse) layerCoords.x = 1.0 - layerCoords.x;\n\n    layerCoords.x += dither;\n\n    lowp vec4 layer = texture2D(layerTexture, layerCoords);\n\n    lowp vec3 base = color.rgb;\n    lowp vec3 blend = layer.rgb;\n\n    if (blendMode ==  0) blend = mix(base, blend, fill);\n    else if (blendMode ==  1) blend = blendDarken(base, blend, fill);\n    else if (blendMode ==  2) blend = blendMultiply(base, blend, fill);\n    else if (blendMode ==  3) blend = blendColorBurn(base, blend, fill);\n    else if (blendMode ==  4) blend = blendSubtract(base, blend, fill);// linear burn\n    else if (blendMode ==  5) blend = blendLighten(base, blend, fill);\n    else if (blendMode ==  6) blend = blendScreen(base, blend, fill);\n    else if (blendMode ==  7) blend = blendColorDodge(base, blend, fill);\n    else if (blendMode ==  8) blend = blendAdd(base, blend, fill);// linear dodge\n    else if (blendMode ==  9) blend = blendOverlay(base, blend, fill);\n    else if (blendMode == 10) blend = blendSoftLight(base, blend, fill);\n    else if (blendMode == 11) blend = blendHardLight(base, blend, fill);\n    else if (blendMode == 12) blend = blendVividLight(base, blend, fill);\n    else if (blendMode == 13) blend = blendLinearLight(base, blend, fill);\n    else if (blendMode == 14) blend = blendDifference(base, blend, fill);\n    else if (blendMode == 15) blend = blendExclusion(base, blend, fill);\n    else if (blendMode == 16) blend = blendSubtract(base, blend, fill);\n    else if (blendMode == 17) blend = blendDivide(base, blend, fill);\n    else if (blendMode == 18) blend = blendHue(base, blend, fill);\n    else if (blendMode == 19) blend = blendSaturation(base, blend, fill);\n    else if (blendMode == 20) blend = blendColor(base, blend, fill);\n    else if (blendMode == 21) blend = blendLuminosity(base, blend, fill);\n    else if (blendMode == 22) blend = base;// passthrough\n\n    color.rgb = mix(base, blend, opacity * color.a * layer.a * layerMask);\n\n    gl_FragColor = color;\n}\n";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec2 delta;float j(in vec3 b,in float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}float d(vec3 a){return .299*a.r+.587*a.g+.114*a.b;}void main(){vec3 e=texture2D(texture,coord.xy).rgb;vec3 f=e;float a=1.;float k=d(e);float l=j(vec3(12.9898,78.233,151.7182),0.);for(float b=-20.;b<=20.;b++){float g=(b+l-.5)/20.;float c=1.-abs(g);vec3 h=texture2D(texture,coord.xy+delta*g).rgb;float i=d(h)-k;c*=exp(-min(i*i*25.,10.));f+=h*c;a+=c;}vec4 m=vec4(f/a,a/20.);gl_FragColor=clamp(m,0.,1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec2 delta;float k(in vec3 b,in float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}float d(vec3 a){return .299*a.r+.587*a.g+.114*a.b;}void main(){vec3 c=texture2D(texture,coord.xy).rgb;vec3 e=c;float f=1.;float l=d(c);float m=k(vec3(12.9898,78.233,151.7182),0.);for(float a=-20.;a<=20.;a++){float g=(a+m-.5)/20.;float b=1.-abs(g);vec4 h=texture2D(texture,coord.xy+delta*g);vec3 i=h.rgb;float j=d(i)-l;float n=h.a;b*=n/20.*exp(-min(j*j*25.,10.));e+=i*b;f+=b;}vec4 o=vec4(e/f,1.);gl_FragColor=clamp(o,0.,1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D smoothMap;uniform float clarity;const mat3 h=mat3(.529346,.330073,.140581,.098374,.873461,.028165,.016883,.117672,.865444);const mat3 i=mat3(2.034076,-.727334,-.306742,-.228813,1.23173,-.002917,-.00857,-.153287,1.161856);float f(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}vec3 g(in vec3 b){vec4 d=vec4(0.,-1./3.,2./3.,-1.);vec4 c=mix(vec4(b.bg,d.wz),vec4(b.gb,d.xy),step(b.b,b.g));vec4 a=mix(vec4(c.xyw,b.r),vec4(b.r,c.yzx),step(c.x,b.r));float e=a.x-min(a.w,a.y);return vec3(abs(a.z+(a.w-a.y)/(6.*e+1e-10)),e/(a.x+1e-10),a.x);}vec3 j(in vec3 b){vec4 a=vec4(1.,2./3.,1./3.,3.);vec3 c=abs(fract(b.xxx+a.xyz)*6.-a.www);return b.z*mix(a.xxx,clamp(c-a.xxx,0.,1.),b.y);}vec3 k(in vec3 b,in vec3 c){vec3 d=g(c);vec3 a=g(b);return j(vec3(d.x,a.y,a.z));}vec3 l(in vec3 a,in vec3 b){return mix(2.*a*b,1.-2.*(1.-a)*(1.-b),step(.5,a));}void main(){lowp vec4 b=texture2D(texture,coord.xy);lowp vec3 d=texture2D(smoothMap,distortionCoord).rgb;float e=clarity>0.?clarity*3.:clarity*2.;float m=(f(b.rgb)+(1.-f(d)))*.5;vec3 c=b.rgb*h;vec3 n=vec3(clamp(mix(.5,m,e*b.a),0.,1.));vec3 a=l(c,n);a=k(a,c);a=a*i;gl_FragColor=vec4(a,b.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float contrast;const mat3 e=mat3(.529346,.330073,.140581,.098374,.873461,.028165,.016883,.117672,.865444);const mat3 f=mat3(2.034076,-.727334,-.306742,-.228813,1.23173,-.002917,-.00857,-.153287,1.161856);void main(){lowp vec4 b=texture2D(texture,coord.xy);float g=contrast<0.?contrast/2.:contrast;vec3 a=b.rgb*e;vec3 d=mix(vec3(.5),a,g*b.a);vec3 c=mix(2.*a*d,1.-2.*(1.-a)*(1.-d),step(.5,a));c=c*f;gl_FragColor=vec4(c,b.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform sampler2D map;void main(){lowp vec4 a=texture2D(texture,coord.xy);a.r=texture2D(map,vec2(texture2D(map,vec2(a.r)).r)).a;a.g=texture2D(map,vec2(texture2D(map,vec2(a.g)).g)).a;a.b=texture2D(map,vec2(texture2D(map,vec2(a.b)).b)).a;gl_FragColor=a;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D dehazeMap;uniform float dehaze;void main(){lowp vec4 a=texture2D(texture,coord.xy);lowp float b=texture2D(dehazeMap,distortionCoord).a;b=1.-b;float c=mix(1.,max(.01,b),dehaze*a.a);vec3 d=(a.rgb-.95)/c+.95;gl_FragColor=vec4(d,a.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;float j(in vec3 b,in float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}const float k=.5*5.*5.;const float e=.05/float(5*2);const float l=.5*e*e/.02/.02;void main(){vec2 h;vec3 f;float c;vec4 d=vec4(0.);float i=0.;float m=j(vec3(151.7182,12.9898,78.233),0.);lowp vec3 n=texture2D(texture,coord.xy).rgb;lowp vec4 g;for(int a=-5;a<=5;a++){for(int b=-5;b<=5;b++){h=coord.xy+(vec2(float(a),float(b))+m-.5)*e;g=texture2D(texture,h);f=g.rgb-n;c=exp(-min(float(a*a+b*b)*l,10.));c*=exp(-min(dot(f,f)*k,10.));d+=g*c;i+=c;}}d=d/i;gl_FragColor=vec4(d);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;float e(in vec3 b,in float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}const float f=.01/5./2.;const vec2 g=vec2(.9,-.1);void main(){vec2 d;float h=e(vec3(12.9898,78.233,151.7182),0.);lowp vec3 i=texture2D(texture,coord.xy).rgb;lowp float b=1.;lowp vec4 a;for(int c=-5;c<=5;c++){d=coord.xy+(vec2(float(c))*g+h-.5)*f;a=texture2D(texture,d);b=min(min(min(b,a.r),a.g),a.b);}gl_FragColor=vec4(i,b);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;float e(in vec3 b,in float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}const float f=.01/5./2.;const vec2 g=vec2(.1,.9);void main(){vec2 d;float h=e(vec3(12.9898,78.233,151.7182),0.);lowp vec3 i=texture2D(texture,coord.xy).rgb;lowp float b=1.;lowp vec4 a;for(int c=-5;c<=5;c++){d=coord.xy+(vec2(float(c))*g+h-.5)*f;a=texture2D(texture,d);b=min(min(min(min(b,a.r),a.g),a.b),a.a);}lowp float j=clamp(1.-.95*b,1e-3,1.-1e-3);gl_FragColor=vec4(i,j);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D denoiseMap;uniform sampler2D dehazeMap;uniform float color_denoise;uniform float luminance_denoise;float d(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}vec3 g(in vec3 a){float b=d(a);float c=min(min(a.r,a.g),a.b);float e=max(max(a.r,a.g),a.b);if(c<0.)a=(a-b)*b/(b-c)+b;if(e>1.)a=(a-b)*(1.-b)/(e-b)+b;return a;}vec3 f(in vec3 a,in float b){float c=b-d(a);return g(a+c);}void main(){lowp vec3 a=texture2D(texture,coord.xy).rgb;lowp vec4 b=texture2D(denoiseMap,distortionCoord);lowp vec4 c=texture2D(dehazeMap,distortionCoord);float e=exp(-3.*d(b.rgb));float h=max(luminance_denoise-pow(b.a,.5),0.);vec4 i=mix(b,c,luminance_denoise*e);vec4 j=mix(b,c,color_denoise*e);a=mix(a,f(j.rgb,d(a)),color_denoise);a=mix(a,f(a,d(i.rgb)),h);gl_FragColor=vec4(a,1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec2 textureResolution;const float f=1./.15;const float m=.5*f*f;const float g=7.*2.+1.;const float h=.5*g*g;float i(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}void main(){vec2 c=1./textureResolution;float d=0.;vec3 j=vec3(0.);vec3 n=texture2D(texture,coord.xy).rgb;float o=i(n);float p=h*h*c.x*c.y;for(float a=-7.;a<=7.;a++){for(float b=-7.;b<=7.;b++){vec2 q=coord.xy+vec2(a,b)*c;vec3 k=texture2D(texture,q).rgb;float l=i(k)-o;float e=exp(-min((a*a+b*b)*p,10.));e*=exp(-min(l*l*m,10.));j+=k*e;d+=e;}}gl_FragColor=vec4(j/d,1./d*2.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D smoothMap;uniform float diffuse;float d(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}void main(){lowp vec3 a=texture2D(texture,coord.xy).rgb;lowp vec3 c=texture2D(smoothMap,distortionCoord).rgb;vec3 e=c/2.+.5;float f=1.-pow(d(a),2.72);vec3 b=mix(vec3(.5),e,diffuse*2.*f);vec3 g=sqrt(a)*(2.*b-1.)+2.*a*(1.-b);gl_FragColor=vec4(g,1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float exposure;uniform float gamma;const float h=1.-1e-6;const mat3 i=mat3(.529346,.330073,.140581,.098374,.873461,.028165,.016883,.117672,.865444);const mat3 j=mat3(2.034076,-.727334,-.306742,-.228813,1.23173,-.002917,-.00857,-.153287,1.161856);float k(in float a){a*=2.;if(a>=1.){a-=1.;a=log(.5)/log(.5*(1.-a)+.9332*a);}return clamp(a,1e-3,10.);}vec3 f(in vec3 b){vec4 d=vec4(0.,-1./3.,2./3.,-1.);vec4 c=mix(vec4(b.bg,d.wz),vec4(b.gb,d.xy),step(b.b,b.g));vec4 a=mix(vec4(c.xyw,b.r),vec4(b.r,c.yzx),step(c.x,b.r));float e=a.x-min(a.w,a.y);return vec3(abs(a.z+(a.w-a.y)/(6.*e+1e-10)),e/(a.x+1e-10),a.x);}vec3 l(in vec3 b){vec4 a=vec4(1.,2./3.,1./3.,3.);vec3 c=abs(fract(b.xxx+a.xyz)*6.-a.www);return b.z*mix(a.xxx,clamp(c-a.xxx,0.,1.),b.y);}vec3 m(in vec3 b,in vec3 c){vec3 d=f(c);vec3 a=f(b);return l(vec3(d.x,a.y,a.z));}void main(){lowp vec4 b=texture2D(texture,coord.xy);vec3 c=b.rgb*i;float e=abs(exposure)*b.a+1e-6;float d=pow(2.,e*2.+1.)-2.;float g=h-exp(-d);vec3 a=exposure>0.?(1.-exp(-d*c))/g:log(1.-c*g)/-d;a=mix(c,a,min(e*100.,1.));a=m(a,c);a=pow(a,vec3(k(1.-(gamma*b.a+1.)/2.)));a=a*j;gl_FragColor=vec4(a,b.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;uniform sampler2D texture;uniform sampler2D grain_texture;uniform vec2 textureSize;uniform vec2 grain_texture_size;uniform float scale;uniform float grain_highlights;uniform float grain_amount;uniform float grain_size;uniform float grain_roughness;vec2 h(in vec2 a){float b=sin(dot(a,vec2(12.9898,78.233)))*43758.5453;return fract(vec2(1.3453,1.3647)*b)*2.-1.;}float i(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}void main(){vec4 b=texture2D(texture,coord.xy);float j=i(b.rgb);float k=grain_amount*grain_highlights;float f=mix(grain_amount,k,j);if(grain_size>.25){vec2 a=(grain_size-.25)*f*2./textureSize*scale;b=(1.*texture2D(texture,coord.xy+vec2(-2.,-2.)*a)+2.*texture2D(texture,coord.xy+vec2(-2.,-1.)*a)+3.*texture2D(texture,coord.xy+vec2(-2.,-0.)*a)+2.*texture2D(texture,coord.xy+vec2(-2.,+1.)*a)+1.*texture2D(texture,coord.xy+vec2(-2.,+2.)*a)+2.*texture2D(texture,coord.xy+vec2(-1.,-2.)*a)+4.*texture2D(texture,coord.xy+vec2(-1.,-1.)*a)+6.*texture2D(texture,coord.xy+vec2(-1.,-0.)*a)+4.*texture2D(texture,coord.xy+vec2(-1.,+1.)*a)+2.*texture2D(texture,coord.xy+vec2(-1.,+2.)*a)+3.*texture2D(texture,coord.xy+vec2(+0.,-2.)*a)+6.*texture2D(texture,coord.xy+vec2(+0.,-1.)*a)+9.*texture2D(texture,coord.xy+vec2(+0.,-0.)*a)+6.*texture2D(texture,coord.xy+vec2(+0.,+1.)*a)+3.*texture2D(texture,coord.xy+vec2(+0.,+2.)*a)+2.*texture2D(texture,coord.xy+vec2(+1.,-2.)*a)+4.*texture2D(texture,coord.xy+vec2(+1.,-1.)*a)+6.*texture2D(texture,coord.xy+vec2(+1.,-0.)*a)+4.*texture2D(texture,coord.xy+vec2(+1.,+1.)*a)+2.*texture2D(texture,coord.xy+vec2(+1.,+2.)*a)+1.*texture2D(texture,coord.xy+vec2(+2.,-2.)*a)+2.*texture2D(texture,coord.xy+vec2(+2.,-1.)*a)+3.*texture2D(texture,coord.xy+vec2(+2.,-0.)*a)+2.*texture2D(texture,coord.xy+vec2(+2.,+1.)*a)+1.*texture2D(texture,coord.xy+vec2(+2.,+2.)*a))/81.;}vec2 c=compositeCoord.xy*textureSize/grain_texture_size;c=c+h(c).xy/grain_texture_size/scale/3.;vec4 d=texture2D(grain_texture,c);vec2 g=vec2(mix(d.r,d.b,grain_size),mix(d.g,d.a,grain_size));float l=mix(g.x,g.y,grain_roughness);vec3 e=b.rgb*l*2.;e=mix(b.rgb,e,f);gl_FragColor.rgb=e;gl_FragColor.a=b.a;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform sampler2D map;vec3 k(vec3 b){vec3 a;float e=min(min(b.r,b.g),b.b);float c=max(max(b.r,b.g),b.b);float d=c-e;a.z=(c+e)/2.;if(d==0.){a.x=0.;a.y=0.;}else{if(a.z<.5)a.y=d/(c+e);else a.y=d/(2.-c-e);float h=((c-b.r)/6.+d/2.)/d;float i=((c-b.g)/6.+d/2.)/d;float j=((c-b.b)/6.+d/2.)/d;if(b.r==c)a.x=j-i;else if(b.g==c)a.x=1./3.+h-j;else if(b.b==c)a.x=2./3.+i-h;if(a.x<0.)a.x+=1.;else if(a.x>1.)a.x-=1.;}return clamp(a,0.,1.);}float f(float b,float d,float a){if(a<0.)a+=1.;else if(a>1.)a-=1.;float c;if(6.*a<1.)c=b+(d-b)*6.*a;else if(2.*a<1.)c=d;else if(3.*a<2.)c=b+(d-b)*(2./3.-a)*6.;else c=b;return c;}vec3 l(vec3 a){vec3 c;if(a.y==0.)c=vec3(a.z);else{float b;if(a.z<.5)b=a.z*(1.+a.y);else b=a.z+a.y-a.y*a.z;float d=2.*a.z-b;c.r=f(d,b,a.x+1./3.);c.g=f(d,b,a.x);c.b=f(d,b,a.x-1./3.);}return c;}float g(vec3 a){return .299*a.r+.587*a.g+.114*a.b;}vec3 m(vec3 a){float b=g(a);float c=min(min(a.r,a.g),a.b);float d=max(max(a.r,a.g),a.b);if(c<0.)a=(a-b)*b/(b-c)+b;if(d>1.)a=(a-b)*(1.-b)/(d-b)+b;return a;}vec3 n(vec3 a,float c){float b=c-g(a);a.r=a.r+b;a.g=a.g+b;a.b=a.b+b;return m(a);}void main(){lowp vec3 e=texture2D(texture,coord.xy).rgb;vec3 a=k(e);lowp vec3 c=texture2D(map,vec2(a.x)).xyz;vec3 d=l(vec3(a.x-(1.-c.x*2.)*60./360.,a.y*(c.y*2.),a.z));float b=g(e);d=n(d,b+(c.z-.5)*(a.y*(1.-b)*4.)*b*b);gl_FragColor=vec4(d,1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float invert;void main(){lowp vec4 a=texture2D(texture,coord.xy);gl_FragColor=mix(a,vec4(1.)-a,invert);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float radius;float i(vec3 b,float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}void main(){vec4 d=texture2D(texture,coord.xy);vec3 e=vec3(0.);float f=0.;float a=radius*d.a;float j=i(vec3(12.9898,78.233,151.7182),0.)/30.*a;for(float b=-15.;b<=15.;b++){for(float c=-15.;c<=15.;c++){vec2 g=coord.xy+vec2(b,c)/15.*a;float h=1.-floor(distance(g,coord.xy)/a);e+=texture2D(texture,g+j).rgb*h;f+=h;}}gl_FragColor=vec4(e/f,d.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;uniform sampler2D texture;uniform sampler2D blurTexture;uniform sampler2D patternTexture;uniform float mosaic_size;uniform vec2 textureSize;uniform vec2 patternSize;void main(){vec2 f=patternSize*mosaic_size;vec2 a=textureSize/f;vec2 b=(compositeCoord.xy-.5)*a;vec3 e=texture2D(patternTexture,fract(b)).rgb;vec2 g=(floor(b)+e.rg)/a+.5;vec2 h=(floor(b)+.5)/a+.5;vec3 c=texture2D(blurTexture,g).rgb;vec3 i=texture2D(blurTexture,h).rgb;c=mix(c,i,e.b);vec4 d=texture2D(texture,coord.xy);gl_FragColor=vec4(mix(d.rgb,c,d.a),d.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D textures[4];float f(vec2 g){vec2 d=g*2.;vec2 b=floor(d);int e=int(b.x+b.y*2.);vec2 c=vec2(d.x-b.x,d.y-b.y);lowp float a;if(e==0){a=texture2D(textures[0],c).a;}else if(e==1){a=texture2D(textures[1],c).a;}else if(e==2){a=texture2D(textures[2],c).a;}else{a=texture2D(textures[3],c).a;}return a;}void main(){lowp vec3 a=texture2D(texture,coord.xy).rgb;lowp float b=f(distortionCoord);gl_FragColor=vec4(a,b);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying float angle;varying vec3 color;uniform float flow;uniform sampler2D brushMap;void main(){float b=sin(angle);float c=cos(angle);vec2 a=gl_PointCoord.xy-.5;a=vec2(a.x*c-a.y*b,a.x*b+a.y*c)+.5;float d=texture2D(brushMap,a).r*flow;gl_FragColor=vec4(color,d);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float saturation;uniform float vibrance;void main(){lowp vec4 b=texture2D(texture,coord.xy);vec3 a=b.rgb;float e=a.r*.299+a.g*.587+a.b*.114;float f=min(min(a.r,a.g),a.b);float c=max(max(a.r,a.g),a.b);float g=(1.-(c-f))*(1.-c)*e*5.;vec3 d=vec3((f+c)/2.);a=mix(a,mix(a,d,-vibrance),g);a=mix(a,d,(1.-d)*(1.-vibrance)/2.*abs(vibrance));a=mix(a,vec3(e),-saturation);gl_FragColor=vec4(mix(b.rgb,a,b.a),b.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D smoothMap;uniform float shadows;uniform float highlights;const float j=1.-1e-6;const mat3 f=mat3(.529346,.330073,.140581,.098374,.873461,.028165,.016883,.117672,.865444);const mat3 k=mat3(2.034076,-.727334,-.306742,-.228813,1.23173,-.002917,-.00857,-.153287,1.161856);float l(in vec3 a){return dot(a,vec3(.242655,.755158,.002187));}float m(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}vec3 g(in vec3 b){vec4 d=vec4(0.,-1./3.,2./3.,-1.);vec4 c=mix(vec4(b.bg,d.wz),vec4(b.gb,d.xy),step(b.b,b.g));vec4 a=mix(vec4(c.xyw,b.r),vec4(b.r,c.yzx),step(c.x,b.r));float e=a.x-min(a.w,a.y);return vec3(abs(a.z+(a.w-a.y)/(6.*e+1e-10)),e/(a.x+1e-10),a.x);}vec3 n(in vec3 b){vec4 a=vec4(1.,2./3.,1./3.,3.);vec3 c=abs(fract(b.xxx+a.xyz)*6.-a.www);return b.z*mix(a.xxx,clamp(c-a.xxx,0.,1.),b.y);}vec3 o(in vec3 b,in vec3 c){vec3 d=g(c);vec3 a=g(b);return n(vec3(d.x,a.y,a.z));}void main(){lowp vec4 b=texture2D(texture,coord.xy);lowp vec3 p=texture2D(smoothMap,distortionCoord).rgb;vec3 c=b.rgb*f;float r=m(b.rgb);float q=l(p*f);float e=mix(highlights,shadows,1.-q)*b.a;float h=abs(e)*b.a+1e-6;float d=pow(2.,h+1.)-2.;float i=j-exp(-d);vec3 a=e>0.?(1.-exp(-d*c))/i:log(1.-c*i)/-d;a=mix(c,a,min(h*100.,1.));a=o(a,c);a=a*k;gl_FragColor=vec4(a,b.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 offsetCoord[4];uniform sampler2D texture;uniform float sharpen;void main(){lowp vec4 b=texture2D(texture,coord.xy);lowp vec4 a=b*5.;a-=texture2D(texture,offsetCoord[0]);a-=texture2D(texture,offsetCoord[1]);a-=texture2D(texture,offsetCoord[2]);a-=texture2D(texture,offsetCoord[3]);gl_FragColor=mix(b,a,sharpen);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float highlights_hue;uniform float highlights_saturation;uniform float shadows_hue;uniform float shadows_saturation;uniform float balance;const float i=216./24389.;const float g=24389./27.;const vec3 j=vec3(.96422,1.,.82521);const vec3 n=vec3(.95047,1.,1.08883);const mat3 t=mat3(.529346,.330073,.140581,.098374,.873461,.028165,.016883,.117672,.865444);const mat3 H=mat3(2.034076,-.727334,-.306742,-.228813,1.23173,-.002917,-.00857,-.153287,1.161856);const mat3 I=mat3(.797675,.135192,.031353,.28804,.711874,8.57e-5,0.,0.,.82521);const mat3 J=mat3(1.345943,-.255607,-.051112,-.544599,1.508167,.020535,0.,0.,1.211813);const mat3 u=mat3(.412456,.357576,.180437,.212673,.715152,.072175,.019334,.119192,.950304);const mat3 v=mat3(3.240454,-1.537139,-.498531,-.969266,1.876011,.041556,.055643,-.204026,1.057225);const mat3 e=mat3(.8951,.2664,-.1614,-.7502,1.7135,.0367,.0389,-.0685,1.0296);const mat3 o=mat3(.986993,-.147054,.159963,.432305,.51836,.049291,-.008529,.040043,.968487);vec3 p(in vec3 b){vec4 a=vec4(1.,2./3.,1./3.,3.);vec3 c=abs(fract(b.xxx+a.xyz)*6.-a.www);return b.z*mix(a.xxx,clamp(c-a.xxx,0.,1.),b.y);}vec3 k(in vec3 b,in vec3 c,in vec3 d){vec3 a;a=b*u;a=a*e*(c/d)*o;return a;}vec3 w(in vec3 a,in vec3 c,in vec3 d){vec3 b;a=a*e*(d/c)*o;b=a*v;return b;}vec3 q(in vec3 c,in vec3 d){vec3 a=c/d;vec3 b=vec3(a.x>i?pow(a.x,1./3.):(g*a.x+16.)/116.,a.y>i?pow(a.y,1./3.):(g*a.y+16.)/116.,a.z>i?pow(a.z,1./3.):(g*a.z+16.)/116.);return vec3(116.*b.y-16.,500.*(b.x-b.y),200.*(b.y-b.z));}vec3 x(in vec3 a,in vec3 l){float d=(a.x+16.)/116.;float b=2e-3*a.y+d;float c=d-5e-3*a.z;float f=b*b*b;float h=c*c*c;vec3 m=vec3(f>i?f:(116.*b-16.)/g,a.x>8.?pow((a.x+16.)/116.,3.):a.x/g,h>i?h:(116.*c-16.)/g);return m*l;}float y(in vec3 a){return dot(a,vec3(.242655,.755158,.002187));}vec3 z(in vec3 a){return vec3(a.r<=.04045?a.r/12.92:pow((a.r+.055)/1.055,2.4),a.g<=.04045?a.g/12.92:pow((a.g+.055)/1.055,2.4),a.b<=.04045?a.b/12.92:pow((a.b+.055)/1.055,2.4));}vec3 A(in vec3 a){return vec3(a.r<=.003131?a.r*12.92:1.055*pow(a.r,1./2.4)-.055,a.g<=.003131?a.g*12.92:1.055*pow(a.g,1./2.4)-.055,a.b<=.003131?a.b*12.92:1.055*pow(a.b,1./2.4)-.055);}void main(){lowp vec4 h=texture2D(texture,coord.xy);vec3 a=h.rgb;float l=y(a*t);float B=h.a;a=z(a);vec3 C=p(vec3(highlights_hue,highlights_saturation*2.,1.));vec3 D=p(vec3(shadows_hue,shadows_saturation*2.,1.));vec3 b=j;vec3 f=n;vec3 c=b*e;vec3 d=f*e;vec3 E=q(k(a,c,d),b);vec3 m=mix(D,C,clamp(l+balance,0.,1.));vec3 F=k(m,c,d);float r=1.-(1.-l)*B;b=j;f=j;c=b*e;d=f*e;vec3 G=k(m,c,d);b=mix(F,j,r);f=n;c=b*e;d=f*e;a=k(a,c,d);b=j;f=mix(G,n,r);c=b*e;d=f*e;vec3 s=q(a,b);s.x=E.x;a=x(s,b);a=w(a,c,d);a=clamp(a,0.,1.);a=A(a);gl_FragColor=vec4(a,h.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float temperature;uniform float tint;const mat3 m=mat3(.412456,.212673,.019334,.357576,.715152,.119192,.180437,.072175,.950304);const mat3 n=mat3(3.240454,-.969266,.055643,-1.537139,1.876011,-.204026,-.498531,.041556,1.057225);const mat3 f=mat3(.8951,-.7502,.0389,.2664,1.7135,-.0685,-.1614,.0367,1.0296);const mat3 k=mat3(.986993,.432305,-.008529,-.147054,.51836,.040043,.159963,.049291,.968487);vec3 o(vec3 c,vec3 d,vec3 e){vec3 a,b;a=m*c;b=f*a;b*=d/e;a=k*b;return a;}vec3 p(vec3 a,vec3 d,vec3 e){vec3 b,c;c=f*a;b*=e/d;a=k*c;b=n*a;return b;}float q(vec3 a){return .299*a.r+.587*a.g+.114*a.b;}const vec3 x=vec3(.981443,1.,.863177);const vec3 l=vec3(.968774,1.,1.121774);const vec3 y=vec3(1.274335,1.,.145233);const vec3 r=vec3(1.009802,1.,.644496);const vec3 s=vec3(.995451,1.,1.886109);void main(){lowp vec4 b=texture2D(texture,coord.xy);vec3 c,a;vec3 e,g;vec3 d,h;if(temperature<0.){c=s;a=l;}else{c=r;a=l;}vec3 i=b.rgb;float t=q(i);float j=abs(temperature)*(1.-pow(t,2.72));h=a;d=vec3(mix(a.x,c.x,j),mix(1.,.9,tint),mix(a.z,c.z,j));d=mix(h,d,b.a);e=f*d;g=f*h;vec3 u=o(i,e,g);vec3 v=p(u,e,g);vec3 w=v*(1.+(j+tint)/10.);gl_FragColor=vec4(mix(i,w,b.a),b.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;uniform sampler2D texture;uniform float vignette_feather;uniform float vignette_amount;uniform float vignette_highlights;uniform float vignette_exposure;uniform float vignette_roundness;uniform float vignette_size;uniform vec2 textureSize;uniform vec4 crop;uniform mat4 rotationMatrix;float n(vec3 a){return .299*a.r+.587*a.g+.114*a.b;}float f(float a,float b){return b<.5?2.*a*b+a*a*(1.-2.*b):sqrt(a)*(2.*b-1.)+2.*a*(1.-b);}vec3 i(vec3 a,vec3 b){return vec3(f(a.r,b.r),f(a.g,b.g),f(a.b,b.b));}float o(vec3 b,float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}void main(){const vec2 p=vec2(1.,1.);const vec2 q=vec2(0.,0.);float r=min(1.-vignette_feather,.99);float j=-vignette_amount;float k=-vignette_exposure*.5;vec3 g=texture2D(texture,coord.xy).rgb;vec4 s=(compositeCoord-.5)*rotationMatrix+.5;vec2 t=(s.xy-vec2(crop.x,1.-crop.w-crop.y))/crop.zw;float u=mix(10.,2.,vignette_size);float h=1./mix(.5,.05,max(0.,-vignette_roundness));vec2 a=textureSize*crop.zw;float v=mix(1.,max(1.,a.x/a.y),vignette_roundness);float w=mix(1.,max(1.,a.y/a.x),vignette_roundness);vec2 x=vec2(v,w);vec3 l=vec3(1.-pow(n(g),2.72)*vignette_highlights);vec2 y=(t-.5)/p*(1.-vignette_feather/2.);vec2 b=y-q;b+=b*(x-1.)*float(vignette_roundness>=0.);float z=pow(pow(abs(b.x),h)+pow(abs(b.y),h),1./h);float A=1.+o(vec3(12.9898,78.233,151.7182),0.)/100.*vignette_feather;float c=smoothstep(1.,r,z*u*A);vec3 d=vec3(c);vec3 B=i(g,mix(vec3(.5),d/2.,j));d=B*mix(vec3(1.),d,j*l);float m=1.-c;vec3 e=vec3(m);vec3 C=i(g,mix(vec3(.5),e/2.,k));e=C*mix(vec3(1.),e,k*l);float D=float(c/(c+m));gl_FragColor=vec4(mix(d,e,D),1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec2 white_balance;const float i=216./24389.;const float g=24389./27.;const vec3 j=vec3(.96422,1.,.82521);const vec3 k=vec3(.95047,1.,1.08883);const mat3 q=mat3(.529346,.330073,.140581,.098374,.873461,.028165,.016883,.117672,.865444);const mat3 B=mat3(2.034076,-.727334,-.306742,-.228813,1.23173,-.002917,-.00857,-.153287,1.161856);const mat3 C=mat3(.797675,.135192,.031353,.28804,.711874,8.57e-5,0.,0.,.82521);const mat3 D=mat3(1.345943,-.255607,-.051112,-.544599,1.508167,.020535,0.,0.,1.211813);const mat3 r=mat3(.412456,.357576,.180437,.212673,.715152,.072175,.019334,.119192,.950304);const mat3 s=mat3(3.240454,-1.537139,-.498531,-.969266,1.876011,.041556,.055643,-.204026,1.057225);const mat3 h=mat3(.8951,.2664,-.1614,-.7502,1.7135,.0367,.0389,-.0685,1.0296);const mat3 m=mat3(.986993,-.147054,.159963,.432305,.51836,.049291,-.008529,.040043,.968487);vec3 t(in vec3 b){vec4 a=vec4(1.,2./3.,1./3.,3.);vec3 c=abs(fract(b.xxx+a.xyz)*6.-a.www);return b.z*mix(a.xxx,clamp(c-a.xxx,0.,1.),b.y);}vec3 n(in vec3 b,in vec3 c,in vec3 d){vec3 e=c*h;vec3 f=d*h;vec3 a;a=b*r;a=a*h*(f/e)*m;return a;}vec3 u(in vec3 a,in vec3 c,in vec3 d){vec3 e=c*h;vec3 f=d*h;vec3 b;a=a*h*(e/f)*m;b=a*s;return b;}vec3 o(in vec3 c,in vec3 d){vec3 a=c/d;vec3 b=vec3(a.x>i?pow(a.x,1./3.):(g*a.x+16.)/116.,a.y>i?pow(a.y,1./3.):(g*a.y+16.)/116.,a.z>i?pow(a.z,1./3.):(g*a.z+16.)/116.);return vec3(116.*b.y-16.,500.*(b.x-b.y),200.*(b.y-b.z));}vec3 v(in vec3 a,in vec3 l){float d=(a.x+16.)/116.;float b=2e-3*a.y+d;float c=d-5e-3*a.z;float e=b*b*b;float f=c*c*c;vec3 p=vec3(e>i?e:(116.*b-16.)/g,a.x>8.?pow((a.x+16.)/116.,3.):a.x/g,f>i?f:(116.*c-16.)/g);return p*l;}vec3 w(in vec3 a){return vec3(a.r<=.04045?a.r/12.92:pow((a.r+.055)/1.055,2.4),a.g<=.04045?a.g/12.92:pow((a.g+.055)/1.055,2.4),a.b<=.04045?a.b/12.92:pow((a.b+.055)/1.055,2.4));}float x(in float a){return a<=.04045?a/12.92:pow((a+.055)/1.055,2.4);}vec3 y(in vec3 a){return vec3(a.r<=.003131?a.r*12.92:1.055*pow(a.r,1./2.4)-.055,a.g<=.003131?a.g*12.92:1.055*pow(a.g,1./2.4)-.055,a.b<=.003131?a.b*12.92:1.055*pow(a.b,1./2.4)-.055);}float z(vec3 a){return dot(a,vec3(.242655,.755158,.002187));}const vec3 E=vec3(1.274335,1.,.145233);const vec3 F=vec3(1.009802,1.,.644496);const vec3 A=vec3(.995451,1.,1.886109);void main(){lowp vec4 e=texture2D(texture,coord.xy);vec3 a=e.rgb;a=w(a);float p=z(a*q);vec3 c=n(a,k,j);vec3 b=o(c,j);float f=sqrt(b.y*b.y+b.z*b.z)/100.;float G=x(b.x/100.*(1.-f));vec3 l=t(vec3(white_balance.x,white_balance.y,1.));vec3 d=n(l,k,j);d.y=1.;a=o(c,mix(d,A,1.));a=u(v(a,j),k,j);a=clamp(a,0.,1.);a=y(a);gl_FragColor=vec4(a,1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float whites;uniform float blacks;float i(vec3 a){return .299*a.r+.587*a.g+.114*a.b;}vec3 j(vec3 a){float b=i(a);float c=min(min(a.r,a.g),a.b);float d=max(max(a.r,a.g),a.b);if(c<0.)a=max((a-b)*b/(b-c)+b,0.);if(d>1.)a=min((a-b)*(1.-b)/(d-b)+b,1.);return a;}vec3 k(vec3 a,float b){a+=b-i(a);return j(a);}const float l=-6.994413;const float m=-.188103;const float n=-14.950968;const float o=-34.330249;const float p=-3.418496;const float q=-12.099387;const float r=-2.919341;const float s=-9.767371;const float t=-121.21509;const float u=-108.566087;void main(){lowp vec3 d=texture2D(texture,coord.xy).rgb;float v=max(d.r,max(d.g,d.b));float w=min(d.r,min(d.g,d.b));float b=(v+w)/2.;float h=b;float a=h*h;float c=a*h;float f,g;vec3 e;f=.005337*h+.666424*a+3.023761*c+l*a*a+3.293987*a*c;f=min(f,1.-b);g=m*h+2.812945*a+n*c+33.494165*a*a+o*a*c+13.143082*c*c;g=max(g,-b);e=whites>=0.?d*(f*whites+b)/b:d*(b-g*whites)/b;e=clamp(e,0.,1.);f=.837673*h+p*a+8.078055*c+q*a*a+9.520316*a*c+r*c*c;f=min(f,1.-b);g=b<=.23?-b:.508865+s*h+49.107057*a+t*c+160.620531*a*a+u*a*c+29.315822*c*c;g=max(g,-b);e=blacks>=0.?e*(f*blacks+b)/b:e*(b-g*blacks)/b;e=clamp(e,0.,1.);gl_FragColor=vec4(k(d,i(e)),1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform vec2 img_size;uniform float lut_color_space;const vec3 d=vec3(.0625,.5,.5);mat3 e=mat3(1.164,1.596,0.,1.164,-.813,-.391,1.164,0.,2.018);vec3 f(in vec3 a){return clamp((a.xzy-d)*e,0.,1.);}void main(){float b=img_size.y;float g=b+1.;vec2 c=floor(coord.xy*b);vec3 a=vec3(floor((coord.x*b-c.x)*b),c)*g/img_size.x;a=min(a,1.);if(lut_color_space==2.){a=f(a);}gl_FragColor.rgb=a;gl_FragColor.a=1.;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D image_texture;uniform sampler2D lookup_texture;uniform float lookup_intensity;uniform float lut_size;vec3 f(in vec3 a){float b=lut_size-1.;float d=(a.r*b+.5)/lut_size;float e=(a.b*b+.5)/lut_size;float c=a.g*b;float g=(floor(c)+d)/lut_size;float h=(ceil(c)+d)/lut_size;vec3 i=texture2D(lookup_texture,vec2(g,e)).xyz;vec3 j=texture2D(lookup_texture,vec2(h,e)).xyz;return mix(i,j,fract(c));}void main(){vec4 a=texture2D(image_texture,coord.xy);a.rgb=mix(a.rgb,f(a.rgb),lookup_intensity);gl_FragColor=a;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\n\n#define UNION 0\n#define SUBTRACT 1\n#define INTERSECT 2\n#define DIFFERENCE 3\n#define COMBINE 4\n\nvarying vec4 coord;\nvarying vec4 compositeCoord;\nvarying vec2 distortionCoord;\n\nuniform float opacity;\nuniform float alpha;\nuniform int mode;\nuniform bool invert;\nuniform sampler2D texture;\nuniform sampler2D brushTexture;\n\nvoid main() {\n    vec4 col = texture2D(texture, coord.xy);\n    vec4 brush = texture2D(brushTexture, compositeCoord.xy);\n    float mask = brush.r;\n\n    if (invert) mask = 1.0 - mask;\n\n    float a;\n\n    // TODO: implement other modes as needed\n    if (mode == COMBINE) {\n        mask = mask * 2.0 - 1.0;\n        a = col.a + mask * opacity;\n    } else {\n        a = col.a * alpha + mask * opacity;\n    }\n\n    a = clamp(a, 0.0, 1.0);\n\n    gl_FragColor = vec4(col.rgb, a);\n}\n";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;varying vec2 distortionCoord;uniform float threshold;uniform float feather;uniform bool invert;uniform bool useRadius;uniform float angle;uniform vec2 position;uniform vec2 size;uniform float opacity;uniform float alpha;uniform vec2 textureSize;uniform vec3 selectedColor;uniform bool useSelectedColor;uniform sampler2D texture;uniform sampler2D colorMap;const float e=216./24389.;const float f=24389./27.;const vec3 s=vec3(.96422,1.,.82521);const vec3 t=vec3(.95047,1.,1.08883);const mat3 u=mat3(.412456,.357576,.180437,.212673,.715152,.072175,.019334,.119192,.950304);const mat3 G=mat3(3.240454,-1.537139,-.498531,-.969266,1.876011,.041556,.055643,-.204026,1.057225);const mat3 g=mat3(.8951,.2664,-.1614,-.7502,1.7135,.0367,.0389,-.0685,1.0296);const mat3 v=mat3(.986993,-.147054,.159963,.432305,.51836,.049291,-.008529,.040043,.968487);vec3 h(in vec3 b,in vec3 c,in vec3 d){vec3 a;a=b*u;a=a*g*(c/d)*v;return a;}vec3 i(in vec3 c,in vec3 d){vec3 a=c/d;vec3 b=vec3(a.x>e?pow(a.x,1./3.):(f*a.x+16.)/116.,a.y>e?pow(a.y,1./3.):(f*a.y+16.)/116.,a.z>e?pow(a.z,1./3.):(f*a.z+16.)/116.);return vec3(116.*b.y-16.,500.*(b.x-b.y),200.*(b.y-b.z));}float w(vec3 b,float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}void main(){vec4 j=texture2D(texture,coord.xy);vec3 x=texture2D(colorMap,distortionCoord).rgb;vec3 y=useSelectedColor?selectedColor:texture2D(colorMap,position+.5).rgb;float k=min(1.-feather,.99);float l=radians(angle);float m=sin(l);float n=cos(l);vec2 a=(compositeCoord.xy-.5-position)*textureSize;a=(vec2(a.x*n-a.y*m,a.x*m+a.y*n)/textureSize+position)/size;vec2 o=1.+(1.-vec2(feather));float p=distance(a*o,position/size*o);p+=w(vec3(12.9898,78.233,151.7182),1.)/50.*(1.-k);float b=useRadius?smoothstep(1.,k,p):1.;vec3 c=s;vec3 z=t;vec3 q=c*g;vec3 r=z*g;vec3 A=i(h(x,q,r),c);vec3 B=i(h(y,q,r),c);vec3 C=abs(A-B)/vec3(100.,127.,127.);float D=threshold*threshold*.98+.01;vec3 d=clamp(1.-C/D,0.,1.);float E=d.x*d.y*d.z;b*=E;if(invert)b=1.-b;float F=clamp(j.a*alpha+b*opacity,0.,1.);gl_FragColor=vec4(j.rgb,F);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D depthTexture;uniform bool invert;uniform float opacity;uniform float alpha;uniform float target;uniform float range;void main(){lowp vec4 b=texture2D(texture,coord.xy);lowp vec4 c=texture2D(depthTexture,distortionCoord.xy);lowp float a=c.r;float d=range*.98+.01;a=clamp(1.-abs(a-target)/d,0.,1.);if(invert)a=1.-a;float e=clamp(b.a*alpha+a*opacity,0.,1.);gl_FragColor=vec4(b.rgb,e);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\n\nvarying vec4 coord;\nvarying vec4 compositeCoord;\n\nuniform vec2 startPoint;\nuniform vec2 endPoint;\nuniform vec2 textureSize;\nuniform float opacity;\nuniform float alpha;\nuniform bool invert;\nuniform bool reflect;\n\nuniform sampler2D texture;\n\nvoid main() {\n  vec4 col = texture2D(texture, coord.xy);\n\n  vec2 compositeCoords = compositeCoord.xy - 0.5;\n\tvec2 coords = vec2(compositeCoords.x, 1.0 - compositeCoords.y) * textureSize;\n\n  vec2 start = vec2(startPoint.x, startPoint.y + 1.0) * textureSize;\n  vec2 end = vec2(endPoint.x, endPoint.y + 1.0) * textureSize;\n\n  vec2 direction = end - start;\n  direction /= length(direction);\n  float scale = dot(direction, end - start);\n  float value = dot(direction, coords - start) / scale;\n  float mask = reflect ? abs(1.0-value*2.0) : clamp(1.0-value, 0.0, 1.0);\n\n  if (invert) mask = 1.0 - mask;\n\n  float a = clamp(col.a * alpha + mask * opacity, 0.0, 1.0);\n\n\tgl_FragColor = vec4(col.rgb, a);\n}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D smoothTexture;uniform bool invert;uniform float opacity;uniform float alpha;uniform float target;uniform float range;uniform float smoothness;float d(in vec3 a){return dot(a,vec3(.298839,.586811,.11435));}void main(){lowp vec4 b=texture2D(texture,coord.xy);lowp vec3 c=texture2D(smoothTexture,distortionCoord).rgb;lowp vec3 e=mix(b.rgb,c,smoothness);float a=d(e);float f=range*.98+.01;a=clamp(1.-abs(a-target)/f,0.,1.);if(invert)a=1.-a;float g=clamp(b.a*alpha+a*opacity,0.,1.);gl_FragColor=vec4(b.rgb,g);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec2 distortionCoord;uniform sampler2D texture;uniform sampler2D originalTexture;uniform sampler2D objectMask;uniform bool invert;uniform bool useRefine;uniform float opacity;uniform float alpha;float f(in vec3 b,in vec4 a,in bool c){float d=dot(b,vec3(.298839,.586811,.11435));float e=a.x;float g=a.y;return c?e*d+g:a.w;}void main(){lowp vec4 b=texture2D(texture,coord.xy);lowp vec4 c=texture2D(originalTexture,coord.xy);vec4 d=texture2D(objectMask,distortionCoord);float a=f(c.rgb,d,useRefine);if(invert)a=1.-a;float e=clamp(b.a*alpha+a*opacity,0.,1.);gl_FragColor=vec4(b.rgb,e);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;uniform float feather;uniform bool invert;uniform float angle;uniform vec2 position;uniform vec2 size;uniform float opacity;uniform float alpha;uniform sampler2D texture;uniform vec2 textureSize;float j(vec3 b,float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}void main(){vec4 c=texture2D(texture,coord.xy);float d=min(1.-feather,.99);float e=radians(angle);float f=sin(e);float g=cos(e);vec2 a=(compositeCoord.xy-.5-position)*textureSize;a=(vec2(a.x*g-a.y*f,a.x*f+a.y*g)/textureSize+position)/size;vec2 h=1.+(1.-vec2(feather));float i=distance(a*h,position/size*h);i+=j(vec3(12.9898,78.233,151.7182),1.)/50.*(1.-d);float b=smoothstep(1.,d,i);if(invert)b=1.-b;float k=clamp(c.a*alpha+b*opacity,0.,1.);gl_FragColor=vec4(c.rgb,k);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;void main(){vec3 a=texture2D(texture,coord.xy).rgb;gl_FragColor=vec4(a*a,1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform sampler2D original;void main(){lowp vec3 a=texture2D(texture,coord.xy).rgb;lowp float b=texture2D(original,coord.xy).a;gl_FragColor=vec4(a,b);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec4 overlayMask;uniform float opacity;uniform float gray;uniform mat4 viewMatrix;void main(){vec4 c=viewMatrix*(coord*2.-1.)*.5+.5;vec2 b=ceil(fract(clamp(c.xy,0.,1.)));const vec4 d=vec4(1.);lowp vec4 e=texture2D(texture,coord.xy);lowp float f=dot(e*overlayMask,d);vec4 a=vec4(1.,0.,0.,f*opacity*b.x*b.y);a=mix(a,vec4(vec3(.5),1.-a.a),gray);gl_FragColor=a;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform lowp sampler2D texture;uniform lowp sampler2D extraTexture;uniform vec4 extraTextureChannel;uniform vec4 channel;uniform vec4 offset;uniform vec4 scale;void main(){vec4 a=texture2D(texture,coord.xy);vec4 b=texture2D(extraTexture,coord.xy);float c=dot(b*extraTextureChannel,vec4(1.));a=a+c;a+=offset;a*=scale;float d=dot(a*channel,vec4(1.));gl_FragColor=vec4(d);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float scale;uniform vec2 resolution;vec4 d(in sampler2D b,in vec2 c){vec2 e=1./resolution;vec2 a=e/scale*.5*.5;return texture2D(b,c+vec2(-a.x,-a.y))*.25+texture2D(b,c+vec2(-a.x,a.y))*.25+texture2D(b,c+vec2(a.x,-a.y))*.25+texture2D(b,c+vec2(a.x,a.y))*.25;}void main(){gl_FragColor=d(texture,coord.xy);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec2 blur_center;uniform float blur_radius;uniform float rotation_blur_strength;float g(){const vec3 a=vec3(12.9898,78.233,151.7182);return fract(sin(dot(gl_FragCoord.xyz,a))*43758.5453);}vec2 h(in vec2 a,in float f,in vec2 b){float c=radians(f);float d=sin(c);float e=cos(c);a=a-b;a=vec2(a.x*e-a.y*d,a.x*d+a.y*e)+b;return a;}void main(){vec3 a;a=vec3(0.);float i=g()-.5;float j=distance(coord.xy,blur_center);float k=min(1.,j/blur_radius);float l=k*rotation_blur_strength;float b,c,e=0.;vec3 f;for(float d=-20.;d<=20.;d++){b=(d+i)/20.;vec2 m=h(coord.xy,l*b,blur_center);f=texture2D(texture,m).rgb;c=1.-abs(b);a+=f*c;e+=c;}a=a/e;gl_FragColor=vec4(a,1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;uniform sampler2D texture;uniform sampler2D cacheTexture;uniform lowp float showTexture;uniform vec2 img_size;uniform vec2 grid_size;uniform float zoom;void main(){vec2 f=img_size*zoom;vec2 a=1./(f*.5/grid_size);vec2 c=1.-a;lowp vec2 d=ceil(fract(clamp(compositeCoord.xy,0.,1.)));lowp vec4 g=texture2D(cacheTexture,coord.xy);lowp vec4 h=texture2D(texture,compositeCoord.xy);lowp vec4 b=mix(g,h,d.x*d.y*showTexture);vec2 i=(coord.xy-.5)*(1.-a*.5)+.5;vec2 e=fract(i*grid_size-a*.5);if(e.x>c.x||e.y>c.y){b=mix(b,vec4(1.),.5);}gl_FragColor=b;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;varying vec2 distortionCoord;uniform float feather;uniform float angle;uniform vec2 position;uniform vec2 sourcePosition;uniform vec2 size;uniform float opacity;uniform float mode;uniform sampler2D texture;uniform sampler2D smoothTexture;uniform sampler2D originalTexture;uniform sampler2D retouchTexture;uniform vec2 textureSize;float g(in float b,in float a){return a<.5?max(b+2.*a-1.,0.):min(b+2.*(a-.5),1.);}vec3 k(in vec3 a,in vec3 b){return vec3(g(a.r,b.r),g(a.g,b.g),g(a.b,b.b));}float l(vec3 b,float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}vec2 h(in vec2 a,in float f,in vec2 b){float c=radians(f);float d=sin(c);float e=cos(c);a=(a-b)*textureSize;a=vec2(a.x*e-a.y*d,a.x*d+a.y*e)/textureSize+b;return a;}void main(){vec2 c=h(distortionCoord.xy-.5,angle,sourcePosition)+.5;lowp vec4 b=texture2D(texture,coord.xy);lowp vec4 d=texture2D(retouchTexture,compositeCoord.xy);lowp vec4 m=texture2D(smoothTexture,c);lowp vec4 e=texture2D(originalTexture,c);float f=min(1.-feather,.99);vec2 n=h(compositeCoord.xy-.5,angle,position)/size;float i=distance(n*2.,position/size*2.);i+=l(vec3(12.9898,78.233,151.7182),1.)/50.*(1.-f);float j=smoothstep(1.,f,i)*opacity;lowp vec3 a;if(mode==1.){a=mix(b.rgb,d.rgb,min(d.a/.05,1.));vec3 o=(e.rgb+(1.-m.rgb))*.5;a=k(a,o.rgb);a=mix(b.rgb,a,j);}else{a=mix(b.rgb,e.rgb,j);}gl_FragColor=vec4(a,b.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;uniform float feather;uniform vec2 position;uniform vec2 size;uniform float opacity;uniform float alpha;uniform sampler2D texture;float d(vec3 b,float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}void main(){lowp vec4 a=texture2D(texture,coord.xy);float b=min(1.-feather,.99);vec2 e=(compositeCoord.xy-.5)/size;float c=distance(e*2.,position/size*2.);c+=d(vec3(12.9898,78.233,151.7182),1.)/50.*(1.-b);float f=smoothstep(1.,b,c);float g=clamp(a.a*alpha+f*opacity,0.,1.);gl_FragColor=vec4(a.rgb,g);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 compositeCoord;varying vec2 distortionCoord;uniform float feather;uniform float angle;uniform vec2 position;uniform vec2 sourcePosition;uniform vec2 size;uniform float opacity;uniform float mode;uniform sampler2D texture;uniform sampler2D smoothTexture;uniform sampler2D retouchTexture;uniform vec2 textureSize;uniform sampler2D textures[4];vec4 k(in vec2 f){vec2 e=f*2.;vec2 c=floor(e);int d=int(c.x+c.y*2.);vec2 b=e-c;lowp vec4 a;if(d==0){a=texture2D(textures[0],b);}else if(d==1){a=texture2D(textures[1],b);}else if(d==2){a=texture2D(textures[2],b);}else{a=texture2D(textures[3],b);}return a;}float g(in float b,in float a){return a<.5?max(b+2.*a-1.,0.):min(b+2.*(a-.5),1.);}vec3 l(in vec3 a,in vec3 b){return vec3(g(a.r,b.r),g(a.g,b.g),g(a.b,b.b));}float m(vec3 b,float a){return fract(sin(dot(gl_FragCoord.xyz+a,b))*43758.5453+a);}vec2 h(in vec2 a,in float f,in vec2 b){float c=radians(f);float d=sin(c);float e=cos(c);a=(a-b)*textureSize;a=vec2(a.x*e-a.y*d,a.x*d+a.y*e)/textureSize+b;return a;}void main(){vec2 c=h(distortionCoord.xy-.5,angle,sourcePosition)+.5;lowp vec4 b=texture2D(texture,coord.xy);lowp vec4 d=texture2D(retouchTexture,compositeCoord.xy);lowp vec4 n=texture2D(smoothTexture,c);lowp vec4 e=k(c);float f=min(1.-feather,.99);vec2 o=h(compositeCoord.xy-.5,angle,position)/size;float i=distance(o*2.,position/size*2.);i+=m(vec3(12.9898,78.233,151.7182),1.)/50.*(1.-f);float j=smoothstep(1.,f,i)*opacity;lowp vec3 a;if(mode==1.){a=mix(b.rgb,d.rgb,min(d.a/.05,1.));vec3 p=(e.rgb+(1.-n.rgb))*.5;a=l(a,p.rgb);a=mix(b.rgb,a,j);}else{a=mix(b.rgb,e.rgb,j);}gl_FragColor=vec4(a,b.a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;void main(){lowp vec3 a=texture2D(texture,coord.xy).rgb;gl_FragColor=vec4(a,1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;varying vec4 backgroundCoords;uniform sampler2D texture;uniform sampler2D layerTexture;uniform sampler2D shadowTexture;uniform vec2 shadowScale;uniform vec2 shadowOffset;uniform vec4 shadowColor;uniform bool enableShadow;uniform float opacity;uniform float blendMix;uniform bool passthrough;uniform bool renderMask;uniform mat3 distortionMatrix;vec3 m(in vec3 a,in vec3 b,in float c){return abs(a-b*c);}float r(in float b,in float a){return a==1.?a:min(b/(1.-a),1.);}float s(in float b,in float a){return a==0.?a:max(1.-(1.-b)/a,0.);}float i(in float b,in float a){return a<.5?s(b,2.*a):r(b,2.*(a-.5));}vec3 n(in vec3 b,in vec3 a,in float c){a=mix(vec3(.5),a,c);return vec3(i(b.r,a.r),i(b.g,a.g),i(b.b,a.b));}void main(){vec4 j=vec4(backgroundCoords.xy*2.-1.,0.,0.);vec3 o=distortionMatrix*vec3(j.xy,1.);j.xy=o.xy/o.z;vec2 c=j.xy*.5+.5;vec2 p=shadowScale.xy;vec2 d=(c.xy-.5)*p+.5+shadowOffset*p;lowp vec4 k=texture2D(texture,coord.xy);lowp vec4 e=texture2D(layerTexture,c);lowp vec4 t=texture2D(shadowTexture,d);lowp vec3 b=k.rgb;lowp vec3 a=b;float l=0.;float h=min(1.,(1.-abs(blendMix))*1.333);float q=min(1.,abs(blendMix)*4.);if(enableShadow&&!(d.x>1.||d.x<0.||d.y>1.||d.y<0.)){vec3 f=shadowColor.rgb;vec3 u=blendMix>0.?n(b,f,h):m(b,f,h);f=mix(f,u,q);a=mix(a,f,shadowColor.a*t.a*opacity);}if(!(c.x>1.||c.x<0.||c.y>1.||c.y<0.)){l=e.a;vec3 g=min(e.rgb/e.a,vec3(1.));vec3 v=blendMix>0.?n(b,g,h):m(b,g,h);g=mix(g,v,q);a=renderMask?mix(a,b,e.a):mix(a,g,e.a*opacity);}a=mix(b,a,k.a);if(renderMask){gl_FragColor=vec4(a,l*k.a*opacity);}else if(passthrough){gl_FragColor=vec4(b,l);}else{gl_FragColor=vec4(a,1.);}}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform float opacity;void main(){lowp vec4 a=texture2D(texture,coord.xy);a*=opacity;gl_FragColor=a;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;uniform vec2 blur_center;uniform float blur_radius;uniform float zoom_blur_strength;float i(){const vec3 a=vec3(12.9898,78.233,151.7182);return fract(sin(dot(gl_FragCoord.xyz,a))*43758.5453);}void main(){vec3 a;a=vec3(0.);float j=zoom_blur_strength*.03;float k=i()-.5;float e=distance(coord.xy,blur_center);float l=min(1.,e/blur_radius);vec2 m=normalize(blur_center-coord.xy)*e*j*l;float b,c,f=0.;vec3 g;vec2 h;for(float d=-20.;d<=20.;d++){b=(d+k)/20.;h=m*b;g=texture2D(texture,coord.xy+h).rgb;c=1.-abs(b);a+=g*c;f+=c;}a=a/f;gl_FragColor=vec4(a,1.);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform bool multitexture;uniform sampler2D textures[4];uniform vec2 reflection_center;uniform vec2 reflection_center_2;uniform int type;uniform float width;uniform float height;uniform float angle;uniform bool reflect_x;uniform bool reflect_y;uniform bool flip_x;uniform bool flip_y;mat2 i=mat2(cos(angle),sin(angle),-sin(angle),cos(angle));mat2 j=mat2(cos(-angle),sin(-angle),-sin(-angle),cos(-angle));vec2 g(in vec2 b,in mat2 c){vec2 a=vec2(width,height);return (b-.5)*a*c/a+.5;}vec4 k(vec2 h){if(!multitexture){return texture2D(textures[0],h);}vec2 d=h*2.;vec2 b=floor(d);int f=int(b.x+b.y*2.);vec2 c=vec2(d.x-b.x,d.y-b.y);vec4 a;if(f==0){a=texture2D(textures[0],c);}else if(f==1){a=texture2D(textures[1],c);}else if(f==2){a=texture2D(textures[2],c);}else{a=texture2D(textures[3],c);}return a;}float e(in vec2 a){a=a.x<.5?1.-a:a;return min(a.y,a.x*2.-a.y);}void main(){vec2 a=coord.xy;a=g(a,i);vec2 b=reflection_center;if(reflect_x)a.x=e(vec2(b.x,a.x));if(reflect_y)a.y=e(vec2(b.y,a.y));if(type==12||type==13){vec2 c=reflection_center_2;if(reflect_x)a.x=e(vec2(1.-c.x,a.x));if(reflect_y)a.y=e(vec2(1.-c.y,a.y));}a=g(a,j);if(flip_x)a.x=1.-a.x;if(flip_y)a.y=1.-a.y;vec2 d=fract(a*.5)*2.;a=1.-abs(d-1.);gl_FragColor=k(a);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform bool multitexture;uniform sampler2D textures[4];uniform sampler2D patternTexture;uniform float pixelate;uniform vec2 textureSize;uniform vec2 patternSize;vec4 g(vec2 f){if(!multitexture){return texture2D(textures[0],f);}vec2 d=f*2.;vec2 b=floor(d);int e=int(b.x+b.y*2.);vec2 c=vec2(d.x-b.x,d.y-b.y);vec4 a;if(e==0){a=texture2D(textures[0],c);}else if(e==1){a=texture2D(textures[1],c);}else if(e==2){a=texture2D(textures[2],c);}else{a=texture2D(textures[3],c);}return a;}void main(){vec2 e=patternSize*pixelate;vec2 a=textureSize/e;vec2 b=(coord.xy-.5)*a;vec3 d=texture2D(patternTexture,fract(b)).rgb;vec2 f=(floor(b)+d.rg)/a+.5;vec2 h=(floor(b)+.5)/a+.5;vec4 c=g(f);vec4 i=g(h);c=mix(c,i,d.b);gl_FragColor=c;}";
        },
        function(t, e, r) {
            "use strict";
            var n = this && this.__importDefault || function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }, o = n(r(168)), i = n(r(594));
            o.default.DefaultOpts.ImageClass = i.default, t.exports = o.default;
        },
        function(t, e, r) {
            var n = r(169), o = r(481), i = r(495), a = r(25);
            t.exports = function(t, e) {
                return (a(t) ? n : o)(t, i(e, 3));
            };
        },
        function(t, e, r) {
            var n = r(482);
            t.exports = function(t, e) {
                var r = [];
                return n(t, function(t, n, o) {
                    e(t, n, o) && r.push(t);
                }), r;
            };
        },
        function(t, e, r) {
            var n = r(483), o = r(494)(n);
            t.exports = o;
        },
        function(t, e, r) {
            var n = r(484), o = r(54);
            t.exports = function(t, e) {
                return t && n(t, e, o);
            };
        },
        function(t, e, r) {
            var n = r(485)();
            t.exports = n;
        },
        function(t, e) {
            t.exports = function(t) {
                return function(e, r, n) {
                    for(var o = -1, i = Object(e), a = n(e), c = a.length; c--;){
                        var u = a[t ? c : ++o];
                        if (!1 === r(i[u], u, i)) break;
                    }
                    return e;
                };
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                for(var r = -1, n = Array(t); ++r < t;)n[r] = e(r);
                return n;
            };
        },
        function(t, e, r) {
            var n = r(55), o = r(41);
            t.exports = function(t) {
                return o(t) && "[object Arguments]" == n(t);
            };
        },
        function(t, e, r) {
            var n = r(56), o = Object.prototype, i = o.hasOwnProperty, a = o.toString, c = n ? n.toStringTag : void 0;
            t.exports = function(t) {
                var e = i.call(t, c), r = t[c];
                try {
                    t[c] = void 0;
                    var n = !0;
                } catch (t) {}
                var o = a.call(t);
                return n && (e ? t[c] = r : delete t[c]), o;
            };
        },
        function(t, e) {
            var r = Object.prototype.toString;
            t.exports = function(t) {
                return r.call(t);
            };
        },
        function(t, e) {
            t.exports = function() {
                return !1;
            };
        },
        function(t, e, r) {
            var n = r(55), o = r(115), i = r(41), a = {};
            a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, t.exports = function(t) {
                return i(t) && o(t.length) && !!a[n(t)];
            };
        },
        function(t, e, r) {
            var n = r(118), o = r(493), i = Object.prototype.hasOwnProperty;
            t.exports = function(t) {
                if (!n(t)) return o(t);
                var e = [];
                for(var r in Object(t))i.call(t, r) && "constructor" != r && e.push(r);
                return e;
            };
        },
        function(t, e, r) {
            var n = r(174)(Object.keys, Object);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(72);
            t.exports = function(t, e) {
                return function(r, o) {
                    if (null == r) return r;
                    if (!n(r)) return t(r, o);
                    for(var i = r.length, a = e ? i : -1, c = Object(r); (e ? a-- : ++a < i) && !1 !== o(c[a], a, c););
                    return r;
                };
            };
        },
        function(t, e, r) {
            var n = r(496), o = r(539), i = r(125), a = r(25), c = r(550);
            t.exports = function(t) {
                return "function" == typeof t ? t : null == t ? i : "object" == typeof t ? a(t) ? o(t[0], t[1]) : n(t) : c(t);
            };
        },
        function(t, e, r) {
            var n = r(497), o = r(538), i = r(185);
            t.exports = function(t) {
                var e = o(t);
                return 1 == e.length && e[0][2] ? i(e[0][0], e[0][1]) : function(r) {
                    return r === t || n(r, t, e);
                };
            };
        },
        function(t, e, r) {
            var n = r(119), o = r(177);
            t.exports = function(t, e, r, i) {
                var a = r.length, c = a, u = !i;
                if (null == t) return !c;
                for(t = Object(t); a--;){
                    var s = r[a];
                    if (u && s[2] ? s[1] !== t[s[0]] : !(s[0] in t)) return !1;
                }
                for(; ++a < c;){
                    var l = (s = r[a])[0], f = t[l], h = s[1];
                    if (u && s[2]) {
                        if (void 0 === f && !(l in t)) return !1;
                    } else {
                        var d = new n;
                        if (i) var p = i(f, h, l, t, e, d);
                        if (!(void 0 === p ? o(h, f, 3, i, d) : p)) return !1;
                    }
                }
                return !0;
            };
        },
        function(t, e) {
            t.exports = function() {
                this.__data__ = [], this.size = 0;
            };
        },
        function(t, e, r) {
            var n = r(74), o = Array.prototype.splice;
            t.exports = function(t) {
                var e = this.__data__, r = n(e, t);
                return !(r < 0) && (r == e.length - 1 ? e.pop() : o.call(e, r, 1), --this.size, !0);
            };
        },
        function(t, e, r) {
            var n = r(74);
            t.exports = function(t) {
                var e = this.__data__, r = n(e, t);
                return r < 0 ? void 0 : e[r][1];
            };
        },
        function(t, e, r) {
            var n = r(74);
            t.exports = function(t) {
                return n(this.__data__, t) > -1;
            };
        },
        function(t, e, r) {
            var n = r(74);
            t.exports = function(t, e) {
                var r = this.__data__, o = n(r, t);
                return o < 0 ? (++this.size, r.push([
                    t,
                    e
                ])) : r[o][1] = e, this;
            };
        },
        function(t, e, r) {
            var n = r(73);
            t.exports = function() {
                this.__data__ = new n, this.size = 0;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = this.__data__, r = e.delete(t);
                return this.size = e.size, r;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return this.__data__.get(t);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return this.__data__.has(t);
            };
        },
        function(t, e, r) {
            var n = r(73), o = r(120), i = r(121);
            t.exports = function(t, e) {
                var r = this.__data__;
                if (r instanceof n) {
                    var a = r.__data__;
                    if (!o || a.length < 199) return a.push([
                        t,
                        e
                    ]), this.size = ++r.size, this;
                    r = this.__data__ = new i(a);
                }
                return r.set(t, e), this.size = r.size, this;
            };
        },
        function(t, e, r) {
            var n = r(175), o = r(509), i = r(42), a = r(176), c = /^\[object .+?Constructor\]$/, u = Function.prototype, s = Object.prototype, l = u.toString, f = s.hasOwnProperty, h = RegExp("^" + l.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
            t.exports = function(t) {
                return !(!i(t) || o(t)) && (n(t) ? h : c).test(a(t));
            };
        },
        function(t, e, r) {
            var n, o = r(510), i = (n = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "";
            t.exports = function(t) {
                return !!i && i in t;
            };
        },
        function(t, e, r) {
            var n = r(24)["__core-js_shared__"];
            t.exports = n;
        },
        function(t, e) {
            t.exports = function(t, e) {
                return null == t ? void 0 : t[e];
            };
        },
        function(t, e, r) {
            var n = r(513), o = r(73), i = r(120);
            t.exports = function() {
                this.size = 0, this.__data__ = {
                    hash: new n,
                    map: new (i || o),
                    string: new n
                };
            };
        },
        function(t, e, r) {
            var n = r(514), o = r(515), i = r(516), a = r(517), c = r(518);
            function u(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            u.prototype.clear = n, u.prototype.delete = o, u.prototype.get = i, u.prototype.has = a, u.prototype.set = c, t.exports = u;
        },
        function(t, e, r) {
            var n = r(75);
            t.exports = function() {
                this.__data__ = n ? n(null) : {}, this.size = 0;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = this.has(t) && delete this.__data__[t];
                return this.size -= e ? 1 : 0, e;
            };
        },
        function(t, e, r) {
            var n = r(75), o = Object.prototype.hasOwnProperty;
            t.exports = function(t) {
                var e = this.__data__;
                if (n) {
                    var r = e[t];
                    return "__lodash_hash_undefined__" === r ? void 0 : r;
                }
                return o.call(e, t) ? e[t] : void 0;
            };
        },
        function(t, e, r) {
            var n = r(75), o = Object.prototype.hasOwnProperty;
            t.exports = function(t) {
                var e = this.__data__;
                return n ? void 0 !== e[t] : o.call(e, t);
            };
        },
        function(t, e, r) {
            var n = r(75);
            t.exports = function(t, e) {
                var r = this.__data__;
                return this.size += this.has(t) ? 0 : 1, r[t] = n && void 0 === e ? "__lodash_hash_undefined__" : e, this;
            };
        },
        function(t, e, r) {
            var n = r(76);
            t.exports = function(t) {
                var e = n(this, t).delete(t);
                return this.size -= e ? 1 : 0, e;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = typeof t;
                return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
            };
        },
        function(t, e, r) {
            var n = r(76);
            t.exports = function(t) {
                return n(this, t).get(t);
            };
        },
        function(t, e, r) {
            var n = r(76);
            t.exports = function(t) {
                return n(this, t).has(t);
            };
        },
        function(t, e, r) {
            var n = r(76);
            t.exports = function(t, e) {
                var r = n(this, t), o = r.size;
                return r.set(t, e), this.size += r.size == o ? 0 : 1, this;
            };
        },
        function(t, e, r) {
            var n = r(119), o = r(178), i = r(530), a = r(533), c = r(77), u = r(25), s = r(113), l = r(173), f = "[object Object]", h = Object.prototype.hasOwnProperty;
            t.exports = function(t, e, r, d, p, v) {
                var m = u(t), g = u(e), b = m ? "[object Array]" : c(t), x = g ? "[object Array]" : c(e), y = (b = "[object Arguments]" == b ? f : b) == f, _ = (x = "[object Arguments]" == x ? f : x) == f, w = b == x;
                if (w && s(t)) {
                    if (!s(e)) return !1;
                    m = !0, y = !1;
                }
                if (w && !y) return v || (v = new n), m || l(t) ? o(t, e, r, d, p, v) : i(t, e, b, r, d, p, v);
                if (!(1 & r)) {
                    var S = y && h.call(t, "__wrapped__"), M = _ && h.call(e, "__wrapped__");
                    if (S || M) {
                        var T = S ? t.value() : t, I = M ? e.value() : e;
                        return v || (v = new n), p(T, I, r, d, v);
                    }
                }
                return !!w && (v || (v = new n), a(t, e, r, d, p, v));
            };
        },
        function(t, e, r) {
            var n = r(121), o = r(526), i = r(527);
            function a(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.__data__ = new n; ++e < r;)this.add(t[e]);
            }
            a.prototype.add = a.prototype.push = o, a.prototype.has = i, t.exports = a;
        },
        function(t, e) {
            t.exports = function(t) {
                return this.__data__.set(t, "__lodash_hash_undefined__"), this;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return this.__data__.has(t);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length; ++r < n;)if (e(t[r], r, t)) return !0;
                return !1;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.has(e);
            };
        },
        function(t, e, r) {
            var n = r(56), o = r(179), i = r(57), a = r(178), c = r(531), u = r(532), s = n ? n.prototype : void 0, l = s ? s.valueOf : void 0;
            t.exports = function(t, e, r, n, s, f, h) {
                switch(r){
                    case "[object DataView]":
                        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                        t = t.buffer, e = e.buffer;
                    case "[object ArrayBuffer]":
                        return !(t.byteLength != e.byteLength || !f(new o(t), new o(e)));
                    case "[object Boolean]":
                    case "[object Date]":
                    case "[object Number]":
                        return i(+t, +e);
                    case "[object Error]":
                        return t.name == e.name && t.message == e.message;
                    case "[object RegExp]":
                    case "[object String]":
                        return t == e + "";
                    case "[object Map]":
                        var d = c;
                    case "[object Set]":
                        var p = 1 & n;
                        if (d || (d = u), t.size != e.size && !p) return !1;
                        var v = h.get(t);
                        if (v) return v == e;
                        n |= 2, h.set(t, e);
                        var m = a(d(t), d(e), n, s, f, h);
                        return h.delete(t), m;
                    case "[object Symbol]":
                        if (l) return l.call(t) == l.call(e);
                }
                return !1;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = -1, r = Array(t.size);
                return t.forEach(function(t, n) {
                    r[++e] = [
                        n,
                        t
                    ];
                }), r;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = -1, r = Array(t.size);
                return t.forEach(function(t) {
                    r[++e] = t;
                }), r;
            };
        },
        function(t, e, r) {
            var n = r(180), o = Object.prototype.hasOwnProperty;
            t.exports = function(t, e, r, i, a, c) {
                var u = 1 & r, s = n(t), l = s.length;
                if (l != n(e).length && !u) return !1;
                for(var f = l; f--;){
                    var h = s[f];
                    if (!(u ? h in e : o.call(e, h))) return !1;
                }
                var d = c.get(t);
                if (d && c.get(e)) return d == e;
                var p = !0;
                c.set(t, e), c.set(e, t);
                for(var v = u; ++f < l;){
                    var m = t[h = s[f]], g = e[h];
                    if (i) var b = u ? i(g, m, h, e, t, c) : i(m, g, h, t, e, c);
                    if (!(void 0 === b ? m === g || a(m, g, r, i, c) : b)) {
                        p = !1;
                        break;
                    }
                    v || (v = "constructor" == h);
                }
                if (p && !v) {
                    var x = t.constructor, y = e.constructor;
                    x == y || !("constructor" in t) || !("constructor" in e) || "function" == typeof x && x instanceof x && "function" == typeof y && y instanceof y || (p = !1);
                }
                return c.delete(t), c.delete(e), p;
            };
        },
        function(t, e, r) {
            var n = r(43)(r(24), "DataView");
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(43)(r(24), "Promise");
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(43)(r(24), "Set");
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(43)(r(24), "WeakMap");
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(184), o = r(54);
            t.exports = function(t) {
                for(var e = o(t), r = e.length; r--;){
                    var i = e[r], a = t[i];
                    e[r] = [
                        i,
                        a,
                        n(a)
                    ];
                }
                return e;
            };
        },
        function(t, e, r) {
            var n = r(177), o = r(540), i = r(547), a = r(123), c = r(184), u = r(185), s = r(78);
            t.exports = function(t, e) {
                return a(t) && c(e) ? u(s(t), e) : function(r) {
                    var a = o(r, t);
                    return void 0 === a && a === e ? i(r, t) : n(e, a, 3);
                };
            };
        },
        function(t, e, r) {
            var n = r(186);
            t.exports = function(t, e, r) {
                var o = null == t ? void 0 : n(t, e);
                return void 0 === o ? r : o;
            };
        },
        function(t, e, r) {
            var n = r(542), o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, i = /\\(\\)?/g, a = n(function(t) {
                var e = [];
                return 46 === t.charCodeAt(0) && e.push(""), t.replace(o, function(t, r, n, o) {
                    e.push(n ? o.replace(i, "$1") : r || t);
                }), e;
            });
            t.exports = a;
        },
        function(t, e, r) {
            var n = r(543);
            t.exports = function(t) {
                var e = n(t, function(t) {
                    return 500 === r.size && r.clear(), t;
                }), r = e.cache;
                return e;
            };
        },
        function(t, e, r) {
            var n = r(121);
            function o(t, e) {
                if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");
                var r = function() {
                    var n = arguments, o = e ? e.apply(this, n) : n[0], i = r.cache;
                    if (i.has(o)) return i.get(o);
                    var a = t.apply(this, n);
                    return r.cache = i.set(o, a) || i, a;
                };
                return r.cache = new (o.Cache || n), r;
            }
            o.Cache = n, t.exports = o;
        },
        function(t, e, r) {
            var n = r(545);
            t.exports = function(t) {
                return null == t ? "" : n(t);
            };
        },
        function(t, e, r) {
            var n = r(56), o = r(546), i = r(25), a = r(124), c = n ? n.prototype : void 0, u = c ? c.toString : void 0;
            t.exports = function t(e) {
                if ("string" == typeof e) return e;
                if (i(e)) return o(e, t) + "";
                if (a(e)) return u ? u.call(e) : "";
                var r = e + "";
                return "0" == r && 1 / e == -1 / 0 ? "-0" : r;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;)o[r] = e(t[r], r, t);
                return o;
            };
        },
        function(t, e, r) {
            var n = r(548), o = r(549);
            t.exports = function(t, e) {
                return null != t && o(t, e, n);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return null != t && e in Object(t);
            };
        },
        function(t, e, r) {
            var n = r(187), o = r(171), i = r(25), a = r(114), c = r(115), u = r(78);
            t.exports = function(t, e, r) {
                for(var s = -1, l = (e = n(e, t)).length, f = !1; ++s < l;){
                    var h = u(e[s]);
                    if (!(f = null != t && r(t, h))) break;
                    t = t[h];
                }
                return f || ++s != l ? f : !!(l = null == t ? 0 : t.length) && c(l) && a(h, l) && (i(t) || o(t));
            };
        },
        function(t, e, r) {
            var n = r(551), o = r(552), i = r(123), a = r(78);
            t.exports = function(t) {
                return i(t) ? n(a(t)) : o(t);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return function(e) {
                    return null == e ? void 0 : e[t];
                };
            };
        },
        function(t, e, r) {
            var n = r(186);
            t.exports = function(t) {
                return function(e) {
                    return n(e, t);
                };
            };
        },
        function(t, e, r) {
            "use strict";
            var n = this && this.__importDefault || function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var o = n(r(168)), i = r(554), a = function() {
                function t(t, e) {
                    void 0 === e && (e = {}), this._src = t, this._opts = e, this._opts.filters = i(o.default.DefaultOpts.filters);
                }
                return t.prototype.maxColorCount = function(t) {
                    return this._opts.colorCount = t, this;
                }, t.prototype.maxDimension = function(t) {
                    return this._opts.maxDimension = t, this;
                }, t.prototype.addFilter = function(t) {
                    return this._opts.filters.push(t), this;
                }, t.prototype.removeFilter = function(t) {
                    var e = this._opts.filters.indexOf(t);
                    return e > 0 && this._opts.filters.splice(e), this;
                }, t.prototype.clearFilters = function() {
                    return this._opts.filters = [], this;
                }, t.prototype.quality = function(t) {
                    return this._opts.quality = t, this;
                }, t.prototype.useImageClass = function(t) {
                    return this._opts.ImageClass = t, this;
                }, t.prototype.useGenerator = function(t) {
                    return this._opts.generator = t, this;
                }, t.prototype.useQuantizer = function(t) {
                    return this._opts.quantizer = t, this;
                }, t.prototype.build = function() {
                    return new o.default(this._src, this._opts);
                }, t.prototype.getPalette = function(t) {
                    return this.build().getPalette(t);
                }, t.prototype.getSwatches = function(t) {
                    return this.build().getPalette(t);
                }, t;
            }();
            e.default = a;
        },
        function(t, e, r) {
            var n = r(555);
            t.exports = function(t) {
                return n(t, 4);
            };
        },
        function(t, e, r) {
            var n = r(119), o = r(556), i = r(188), a = r(557), c = r(558), u = r(561), s = r(562), l = r(563), f = r(564), h = r(180), d = r(565), p = r(77), v = r(566), m = r(567), g = r(572), b = r(25), x = r(113), y = r(574), _ = r(42), w = r(576), S = r(54), M = {};
            M["[object Arguments]"] = M["[object Array]"] = M["[object ArrayBuffer]"] = M["[object DataView]"] = M["[object Boolean]"] = M["[object Date]"] = M["[object Float32Array]"] = M["[object Float64Array]"] = M["[object Int8Array]"] = M["[object Int16Array]"] = M["[object Int32Array]"] = M["[object Map]"] = M["[object Number]"] = M["[object Object]"] = M["[object RegExp]"] = M["[object Set]"] = M["[object String]"] = M["[object Symbol]"] = M["[object Uint8Array]"] = M["[object Uint8ClampedArray]"] = M["[object Uint16Array]"] = M["[object Uint32Array]"] = !0, M["[object Error]"] = M["[object Function]"] = M["[object WeakMap]"] = !1, t.exports = function t(e, r, T, I, D, E) {
                var A, C = 1 & r, z = 2 & r, O = 4 & r;
                if (T && (A = D ? T(e, I, D, E) : T(e)), void 0 !== A) return A;
                if (!_(e)) return e;
                var F = b(e);
                if (F) {
                    if (A = v(e), !C) return s(e, A);
                } else {
                    var R = p(e), P = "[object Function]" == R || "[object GeneratorFunction]" == R;
                    if (x(e)) return u(e, C);
                    if ("[object Object]" == R || "[object Arguments]" == R || P && !D) {
                        if (A = z || P ? {} : g(e), !C) return z ? f(e, c(A, e)) : l(e, a(A, e));
                    } else {
                        if (!M[R]) return D ? e : {};
                        A = m(e, R, C);
                    }
                }
                E || (E = new n);
                var L = E.get(e);
                if (L) return L;
                E.set(e, A), w(e) ? e.forEach(function(n) {
                    A.add(t(n, r, T, n, e, E));
                }) : y(e) && e.forEach(function(n, o) {
                    A.set(o, t(n, r, T, o, e, E));
                });
                var k = O ? z ? d : h : z ? keysIn : S, j = F ? void 0 : k(e);
                return o(j || e, function(n, o) {
                    j && (n = e[o = n]), i(A, o, t(n, r, T, o, e, E));
                }), A;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length; ++r < n && !1 !== e(t[r], r, t););
                return t;
            };
        },
        function(t, e, r) {
            var n = r(79), o = r(54);
            t.exports = function(t, e) {
                return t && n(e, o(e), t);
            };
        },
        function(t, e, r) {
            var n = r(79), o = r(126);
            t.exports = function(t, e) {
                return t && n(e, o(e), t);
            };
        },
        function(t, e, r) {
            var n = r(42), o = r(118), i = r(560), a = Object.prototype.hasOwnProperty;
            t.exports = function(t) {
                if (!n(t)) return i(t);
                var e = o(t), r = [];
                for(var c in t)("constructor" != c || !e && a.call(t, c)) && r.push(c);
                return r;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = [];
                if (null != t) for(var r in Object(t))e.push(r);
                return e;
            };
        },
        function(t, e, r) {
            (function(t) {
                var n = r(24), o = e && !e.nodeType && e, i = o && "object" == typeof t && t && !t.nodeType && t, a = i && i.exports === o ? n.Buffer : void 0, c = a ? a.allocUnsafe : void 0;
                t.exports = function(t, e) {
                    if (e) return t.slice();
                    var r = t.length, n = c ? c(r) : new t.constructor(r);
                    return t.copy(n), n;
                };
            }).call(this, r(71)(t));
        },
        function(t, e) {
            t.exports = function(t, e) {
                var r = -1, n = t.length;
                for(e || (e = Array(n)); ++r < n;)e[r] = t[r];
                return e;
            };
        },
        function(t, e, r) {
            var n = r(79), o = r(122);
            t.exports = function(t, e) {
                return n(t, o(t), e);
            };
        },
        function(t, e, r) {
            var n = r(79), o = r(191);
            t.exports = function(t, e) {
                return n(t, o(t), e);
            };
        },
        function(t, e, r) {
            var n = r(181), o = r(191), i = r(126);
            t.exports = function(t) {
                return n(t, i, o);
            };
        },
        function(t, e) {
            var r = Object.prototype.hasOwnProperty;
            t.exports = function(t) {
                var e = t.length, n = new t.constructor(e);
                return e && "string" == typeof t[0] && r.call(t, "index") && (n.index = t.index, n.input = t.input), n;
            };
        },
        function(t, e, r) {
            var n = r(127), o = r(568), i = r(569), a = r(570), c = r(571);
            t.exports = function(t, e, r) {
                var u = t.constructor;
                switch(e){
                    case "[object ArrayBuffer]":
                        return n(t);
                    case "[object Boolean]":
                    case "[object Date]":
                        return new u(+t);
                    case "[object DataView]":
                        return o(t, r);
                    case "[object Float32Array]":
                    case "[object Float64Array]":
                    case "[object Int8Array]":
                    case "[object Int16Array]":
                    case "[object Int32Array]":
                    case "[object Uint8Array]":
                    case "[object Uint8ClampedArray]":
                    case "[object Uint16Array]":
                    case "[object Uint32Array]":
                        return c(t, r);
                    case "[object Map]":
                        return new u;
                    case "[object Number]":
                    case "[object String]":
                        return new u(t);
                    case "[object RegExp]":
                        return i(t);
                    case "[object Set]":
                        return new u;
                    case "[object Symbol]":
                        return a(t);
                }
            };
        },
        function(t, e, r) {
            var n = r(127);
            t.exports = function(t, e) {
                var r = e ? n(t.buffer) : t.buffer;
                return new t.constructor(r, t.byteOffset, t.byteLength);
            };
        },
        function(t, e) {
            var r = /\w*$/;
            t.exports = function(t) {
                var e = new t.constructor(t.source, r.exec(t));
                return e.lastIndex = t.lastIndex, e;
            };
        },
        function(t, e, r) {
            var n = r(56), o = n ? n.prototype : void 0, i = o ? o.valueOf : void 0;
            t.exports = function(t) {
                return i ? Object(i.call(t)) : {};
            };
        },
        function(t, e, r) {
            var n = r(127);
            t.exports = function(t, e) {
                var r = e ? n(t.buffer) : t.buffer;
                return new t.constructor(r, t.byteOffset, t.length);
            };
        },
        function(t, e, r) {
            var n = r(573), o = r(192), i = r(118);
            t.exports = function(t) {
                return "function" != typeof t.constructor || i(t) ? {} : n(o(t));
            };
        },
        function(t, e, r) {
            var n = r(42), o = Object.create, i = function() {
                function t() {}
                return function(e) {
                    if (!n(e)) return {};
                    if (o) return o(e);
                    t.prototype = e;
                    var r = new t;
                    return t.prototype = void 0, r;
                };
            }();
            t.exports = i;
        },
        function(t, e, r) {
            var n = r(575), o = r(116), i = r(117), a = i && i.isMap, c = a ? o(a) : n;
            t.exports = c;
        },
        function(t, e, r) {
            var n = r(77), o = r(41);
            t.exports = function(t) {
                return o(t) && "[object Map]" == n(t);
            };
        },
        function(t, e, r) {
            var n = r(577), o = r(116), i = r(117), a = i && i.isSet, c = a ? o(a) : n;
            t.exports = c;
        },
        function(t, e, r) {
            var n = r(77), o = r(41);
            t.exports = function(t) {
                return o(t) && "[object Set]" == n(t);
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = r(579);
            e.MMCQ = n.default, e.WebWorker = null;
        },
        function(t, e, r) {
            "use strict";
            var n = this && this.__importDefault || function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var o = r(112), i = n(r(580)), a = n(r(581));
            function c(t, e) {
                for(var r = t.size(); t.size() < e;){
                    var n = t.pop();
                    if (!(n && n.count() > 0)) break;
                    var o = n.split(), i = o[0], a = o[1];
                    if (t.push(i), a && a.count() > 0 && t.push(a), t.size() === r) break;
                    r = t.size();
                }
            }
            e.default = function(t, e) {
                if (0 === t.length || e.colorCount < 2 || e.colorCount > 256) throw new Error("Wrong MMCQ parameters");
                var r = i.default.build(t), n = r.hist, u = (Object.keys(n).length, new a.default(function(t, e) {
                    return t.count() - e.count();
                }));
                u.push(r), c(u, .75 * e.colorCount);
                var s = new a.default(function(t, e) {
                    return t.count() * t.volume() - e.count() * e.volume();
                });
                return s.contents = u.contents, c(s, e.colorCount - s.size()), function(t) {
                    var e = [];
                    for(; t.size();){
                        var r = t.pop(), n = r.avg();
                        n[0], n[1], n[2];
                        e.push(new o.Swatch(n, r.count()));
                    }
                    return e;
                }(s);
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = r(70), o = function() {
                function t(t, e, r, n, o, i, a) {
                    this._volume = -1, this._count = -1, this.dimension = {
                        r1: t,
                        r2: e,
                        g1: r,
                        g2: n,
                        b1: o,
                        b2: i
                    }, this.hist = a;
                }
                return t.build = function(e, r) {
                    var o, i, a, c, u, s, l, f, h, d = 1 << 3 * n.SIGBITS, p = new Uint32Array(d);
                    o = a = u = 0, i = c = s = Number.MAX_VALUE;
                    for(var v = e.length / 4, m = 0; m < v;){
                        var g = 4 * m;
                        if (m++, l = e[g + 0], f = e[g + 1], h = e[g + 2], 0 !== e[g + 3]) l >>= n.RSHIFT, f >>= n.RSHIFT, h >>= n.RSHIFT, p[n.getColorIndex(l, f, h)] += 1, l > o && (o = l), l < i && (i = l), f > a && (a = f), f < c && (c = f), h > u && (u = h), h < s && (s = h);
                    }
                    return new t(i, o, c, a, s, u, p);
                }, t.prototype.invalidate = function() {
                    this._volume = this._count = -1, this._avg = null;
                }, t.prototype.volume = function() {
                    if (this._volume < 0) {
                        var t = this.dimension, e = t.r1, r = t.r2, n = t.g1, o = t.g2, i = t.b1, a = t.b2;
                        this._volume = (r - e + 1) * (o - n + 1) * (a - i + 1);
                    }
                    return this._volume;
                }, t.prototype.count = function() {
                    if (this._count < 0) {
                        for(var t = this.hist, e = this.dimension, r = e.r1, o = e.r2, i = e.g1, a = e.g2, c = e.b1, u = e.b2, s = 0, l = r; l <= o; l++)for(var f = i; f <= a; f++)for(var h = c; h <= u; h++)s += t[n.getColorIndex(l, f, h)];
                        this._count = s;
                    }
                    return this._count;
                }, t.prototype.clone = function() {
                    var e = this.hist, r = this.dimension;
                    return new t(r.r1, r.r2, r.g1, r.g2, r.b1, r.b2, e);
                }, t.prototype.avg = function() {
                    if (!this._avg) {
                        var t = this.hist, e = this.dimension, r = e.r1, o = e.r2, i = e.g1, a = e.g2, c = e.b1, u = e.b2, s = 0, l = 1 << 8 - n.SIGBITS, f = void 0, h = void 0, d = void 0;
                        f = h = d = 0;
                        for(var p = r; p <= o; p++)for(var v = i; v <= a; v++)for(var m = c; m <= u; m++){
                            var g = t[n.getColorIndex(p, v, m)];
                            s += g, f += g * (p + .5) * l, h += g * (v + .5) * l, d += g * (m + .5) * l;
                        }
                        this._avg = s ? [
                            ~~(f / s),
                            ~~(h / s),
                            ~~(d / s)
                        ] : [
                            ~~(l * (r + o + 1) / 2),
                            ~~(l * (i + a + 1) / 2),
                            ~~(l * (c + u + 1) / 2)
                        ];
                    }
                    return this._avg;
                }, t.prototype.contains = function(t) {
                    var e = t[0], r = t[1], o = t[2], i = this.dimension, a = i.r1, c = i.r2, u = i.g1, s = i.g2, l = i.b1, f = i.b2;
                    return e >>= n.RSHIFT, r >>= n.RSHIFT, o >>= n.RSHIFT, e >= a && e <= c && r >= u && r <= s && o >= l && o <= f;
                }, t.prototype.split = function() {
                    var t = this.hist, e = this.dimension, r = e.r1, o = e.r2, i = e.g1, a = e.g2, c = e.b1, u = e.b2, s = this.count();
                    if (!s) return [];
                    if (1 === s) return [
                        this.clone()
                    ];
                    var l, f, h = o - r + 1, d = a - i + 1, p = u - c + 1, v = Math.max(h, d, p), m = null;
                    l = f = 0;
                    var g = null;
                    if (v === h) {
                        g = "r", m = new Uint32Array(o + 1);
                        for(var b = r; b <= o; b++){
                            l = 0;
                            for(var x = i; x <= a; x++)for(var y = c; y <= u; y++)l += t[n.getColorIndex(b, x, y)];
                            f += l, m[b] = f;
                        }
                    } else if (v === d) {
                        g = "g", m = new Uint32Array(a + 1);
                        for(x = i; x <= a; x++){
                            l = 0;
                            for(b = r; b <= o; b++)for(y = c; y <= u; y++)l += t[n.getColorIndex(b, x, y)];
                            f += l, m[x] = f;
                        }
                    } else {
                        g = "b", m = new Uint32Array(u + 1);
                        for(y = c; y <= u; y++){
                            l = 0;
                            for(b = r; b <= o; b++)for(x = i; x <= a; x++)l += t[n.getColorIndex(b, x, y)];
                            f += l, m[y] = f;
                        }
                    }
                    for(var _ = -1, w = new Uint32Array(m.length), S = 0; S < m.length; S++){
                        var M = m[S];
                        _ < 0 && M > f / 2 && (_ = S), w[S] = f - M;
                    }
                    var T = this;
                    return function(t) {
                        var e = t + "1", r = t + "2", n = T.dimension[e], o = T.dimension[r], i = T.clone(), a = T.clone(), c = _ - n, u = o - _;
                        for(c <= u ? (o = Math.min(o - 1, ~~(_ + u / 2)), o = Math.max(0, o)) : (o = Math.max(n, ~~(_ - 1 - c / 2)), o = Math.min(T.dimension[r], o)); !m[o];)o++;
                        for(var s = w[o]; !s && m[o - 1];)s = w[--o];
                        return i.dimension[r] = o, a.dimension[e] = o + 1, [
                            i,
                            a
                        ];
                    }(g);
                }, t;
            }();
            e.default = o;
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = function() {
                function t(t) {
                    this._comparator = t, this.contents = [], this._sorted = !1;
                }
                return t.prototype._sort = function() {
                    this._sorted || (this.contents.sort(this._comparator), this._sorted = !0);
                }, t.prototype.push = function(t) {
                    this.contents.push(t), this._sorted = !1;
                }, t.prototype.peek = function(t) {
                    return this._sort(), t = "number" == typeof t ? t : this.contents.length - 1, this.contents[t];
                }, t.prototype.pop = function() {
                    return this._sort(), this.contents.pop();
                }, t.prototype.size = function() {
                    return this.contents.length;
                }, t.prototype.map = function(t) {
                    return this._sort(), this.contents.map(t);
                }, t;
            }();
            e.default = n;
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = r(583);
            e.Default = n.default;
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = r(112), o = r(70), i = r(193), a = {
                targetDarkLuma: .26,
                maxDarkLuma: .45,
                minLightLuma: .55,
                targetLightLuma: .74,
                minNormalLuma: .3,
                targetNormalLuma: .5,
                maxNormalLuma: .7,
                targetMutesSaturation: .3,
                maxMutesSaturation: .4,
                targetVibrantSaturation: 1,
                minVibrantSaturation: .35,
                weightSaturation: 3,
                weightLuma: 6.5,
                weightPopulation: .5
            };
            function c(t, e, r, n, o, i, a, c, u, s) {
                var l = null, f = 0;
                return e.forEach(function(e) {
                    var h = e.getHsl(), d = h[1], p = h[2];
                    if (d >= c && d <= u && p >= o && p <= i && !function(t, e) {
                        return t.Vibrant === e || t.DarkVibrant === e || t.LightVibrant === e || t.Muted === e || t.DarkMuted === e || t.LightMuted === e;
                    }(t, e)) {
                        var v = function(t, e, r, n, o, i, a) {
                            function c(t, e) {
                                return 1 - Math.abs(t - e);
                            }
                            return function() {
                                for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
                                for(var r = 0, n = 0, o = 0; o < t.length; o += 2){
                                    var i = t[o], a = t[o + 1];
                                    r += i * a, n += a;
                                }
                                return r / n;
                            }(c(t, e), a.weightSaturation, c(r, n), a.weightLuma, o / i, a.weightPopulation);
                        }(d, a, p, n, e.getPopulation(), r, s);
                        (null === l || v > f) && (l = e, f = v);
                    }
                }), l;
            }
            e.default = function(t, e) {
                e = i({}, e, a);
                var r = function(t) {
                    var e = 0;
                    return t.forEach(function(t) {
                        e = Math.max(e, t.getPopulation());
                    }), e;
                }(t), u = function(t, e, r) {
                    var n = {};
                    return n.Vibrant = c(n, t, e, r.targetNormalLuma, r.minNormalLuma, r.maxNormalLuma, r.targetVibrantSaturation, r.minVibrantSaturation, 1, r), n.LightVibrant = c(n, t, e, r.targetLightLuma, r.minLightLuma, 1, r.targetVibrantSaturation, r.minVibrantSaturation, 1, r), n.DarkVibrant = c(n, t, e, r.targetDarkLuma, 0, r.maxDarkLuma, r.targetVibrantSaturation, r.minVibrantSaturation, 1, r), n.Muted = c(n, t, e, r.targetNormalLuma, r.minNormalLuma, r.maxNormalLuma, r.targetMutesSaturation, 0, r.maxMutesSaturation, r), n.LightMuted = c(n, t, e, r.targetLightLuma, r.minLightLuma, 1, r.targetMutesSaturation, 0, r.maxMutesSaturation, r), n.DarkMuted = c(n, t, e, r.targetDarkLuma, 0, r.maxDarkLuma, r.targetMutesSaturation, 0, r.maxMutesSaturation, r), n;
                }(t, r, e);
                return function(t, e, r) {
                    if (null === t.Vibrant && null === t.DarkVibrant && null === t.LightVibrant) {
                        if (null === t.DarkVibrant && null !== t.DarkMuted) {
                            var i = t.DarkMuted.getHsl(), a = i[0], c = i[1], u = i[2];
                            u = r.targetDarkLuma, t.DarkVibrant = new n.Swatch(o.hslToRgb(a, c, u), 0);
                        }
                        if (null === t.LightVibrant && null !== t.LightMuted) {
                            var s = t.LightMuted.getHsl();
                            a = s[0], c = s[1], u = s[2];
                            u = r.targetDarkLuma, t.DarkVibrant = new n.Swatch(o.hslToRgb(a, c, u), 0);
                        }
                    }
                    if (null === t.Vibrant && null !== t.DarkVibrant) {
                        var l = t.DarkVibrant.getHsl();
                        a = l[0], c = l[1], u = l[2];
                        u = r.targetNormalLuma, t.Vibrant = new n.Swatch(o.hslToRgb(a, c, u), 0);
                    } else if (null === t.Vibrant && null !== t.LightVibrant) {
                        var f = t.LightVibrant.getHsl();
                        a = f[0], c = f[1], u = f[2];
                        u = r.targetNormalLuma, t.Vibrant = new n.Swatch(o.hslToRgb(a, c, u), 0);
                    }
                    if (null === t.DarkVibrant && null !== t.Vibrant) {
                        var h = t.Vibrant.getHsl();
                        a = h[0], c = h[1], u = h[2];
                        u = r.targetDarkLuma, t.DarkVibrant = new n.Swatch(o.hslToRgb(a, c, u), 0);
                    }
                    if (null === t.LightVibrant && null !== t.Vibrant) {
                        var d = t.Vibrant.getHsl();
                        a = d[0], c = d[1], u = d[2];
                        u = r.targetLightLuma, t.LightVibrant = new n.Swatch(o.hslToRgb(a, c, u), 0);
                    }
                    if (null === t.Muted && null !== t.Vibrant) {
                        var p = t.Vibrant.getHsl();
                        a = p[0], c = p[1], u = p[2];
                        u = r.targetMutesSaturation, t.Muted = new n.Swatch(o.hslToRgb(a, c, u), 0);
                    }
                    if (null === t.DarkMuted && null !== t.DarkVibrant) {
                        var v = t.DarkVibrant.getHsl();
                        a = v[0], c = v[1], u = v[2];
                        u = r.targetMutesSaturation, t.DarkMuted = new n.Swatch(o.hslToRgb(a, c, u), 0);
                    }
                    if (null === t.LightMuted && null !== t.LightVibrant) {
                        var m = t.LightVibrant.getHsl();
                        a = m[0], c = m[1], u = m[2];
                        u = r.targetMutesSaturation, t.LightMuted = new n.Swatch(o.hslToRgb(a, c, u), 0);
                    }
                }(u, 0, e), u;
            };
        },
        function(t, e, r) {
            var n = r(125), o = r(585), i = r(587);
            t.exports = function(t, e) {
                return i(o(t, e, n), t + "");
            };
        },
        function(t, e, r) {
            var n = r(586), o = Math.max;
            t.exports = function(t, e, r) {
                return e = o(void 0 === e ? t.length - 1 : e, 0), function() {
                    for(var i = arguments, a = -1, c = o(i.length - e, 0), u = Array(c); ++a < c;)u[a] = i[e + a];
                    a = -1;
                    for(var s = Array(e + 1); ++a < e;)s[a] = i[a];
                    return s[e] = r(u), n(t, this, s);
                };
            };
        },
        function(t, e) {
            t.exports = function(t, e, r) {
                switch(r.length){
                    case 0:
                        return t.call(e);
                    case 1:
                        return t.call(e, r[0]);
                    case 2:
                        return t.call(e, r[0], r[1]);
                    case 3:
                        return t.call(e, r[0], r[1], r[2]);
                }
                return t.apply(e, r);
            };
        },
        function(t, e, r) {
            var n = r(588), o = r(590)(n);
            t.exports = o;
        },
        function(t, e, r) {
            var n = r(589), o = r(190), i = r(125), a = o ? function(t, e) {
                return o(t, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: n(e),
                    writable: !0
                });
            } : i;
            t.exports = a;
        },
        function(t, e) {
            t.exports = function(t) {
                return function() {
                    return t;
                };
            };
        },
        function(t, e) {
            var r = Date.now;
            t.exports = function(t) {
                var e = 0, n = 0;
                return function() {
                    var o = r(), i = 16 - (o - n);
                    if (n = o, i > 0) {
                        if (++e >= 800) return arguments[0];
                    } else e = 0;
                    return t.apply(void 0, arguments);
                };
            };
        },
        function(t, e, r) {
            var n = r(57), o = r(72), i = r(114), a = r(42);
            t.exports = function(t, e, r) {
                if (!a(r)) return !1;
                var c = typeof e;
                return !!("number" == c ? o(r) && i(e, r.length) : "string" == c && e in r) && n(r[e], t);
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = r(593);
            e.Default = n.default, e.combineFilters = function(t) {
                return Array.isArray(t) && 0 !== t.length ? function(e, r, n, o) {
                    if (0 === o) return !1;
                    for(var i = 0; i < t.length; i++)if (!t[i](e, r, n, o)) return !1;
                    return !0;
                } : null;
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = function(t, e, r, n) {
                return n >= 125 && !(t > 250 && e > 250 && r > 250);
            };
        },
        function(t, e, r) {
            "use strict";
            var n, o = this && this.__extends || (n = function(t, e) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
                })(t, e);
            }, function(t, e) {
                function r() {
                    this.constructor = t;
                }
                n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
            }), i = this && this.__importStar || function(t) {
                if (t && t.__esModule) return t;
                var e = {};
                if (null != t) for(var r in t)Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                return e.default = t, e;
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var a = r(595), c = i(r(596));
            var u = function(t) {
                function e() {
                    return null !== t && t.apply(this, arguments) || this;
                }
                return o(e, t), e.prototype._initCanvas = function() {
                    var t = this.image, e = this._canvas = document.createElement("canvas"), r = this._context = e.getContext("2d");
                    e.className = "vibrant-canvas", e.style.display = "none", this._width = e.width = t.width, this._height = e.height = t.height, r.drawImage(t, 0, 0), document.body.appendChild(e);
                }, e.prototype.load = function(t) {
                    var e, r, n, o, i, a, u = this, s = null, l = null;
                    if ("string" == typeof t) s = document.createElement("img"), i = t, null === (a = c.parse(i)).protocol && null === a.host && null === a.port || (e = window.location.href, r = t, n = c.parse(e), o = c.parse(r), n.protocol === o.protocol && n.hostname === o.hostname && n.port === o.port) || (s.crossOrigin = "anonymous"), l = s.src = t;
                    else {
                        if (!(t instanceof HTMLImageElement)) return Promise.reject(new Error("Cannot load buffer as an image in browser"));
                        s = t, l = t.src;
                    }
                    return this.image = s, new Promise(function(t, e) {
                        var r = function() {
                            u._initCanvas(), t(u);
                        };
                        s.complete ? r() : (s.onload = r, s.onerror = function(t) {
                            return e(new Error("Fail to load image: " + l));
                        });
                    });
                }, e.prototype.clear = function() {
                    this._context.clearRect(0, 0, this._width, this._height);
                }, e.prototype.update = function(t) {
                    this._context.putImageData(t, 0, 0);
                }, e.prototype.getWidth = function() {
                    return this._width;
                }, e.prototype.getHeight = function() {
                    return this._height;
                }, e.prototype.resize = function(t, e, r) {
                    var n = this._canvas, o = this._context, i = this.image;
                    this._width = n.width = t, this._height = n.height = e, o.scale(r, r), o.drawImage(i, 0, 0);
                }, e.prototype.getPixelCount = function() {
                    return this._width * this._height;
                }, e.prototype.getImageData = function() {
                    return this._context.getImageData(0, 0, this._width, this._height);
                }, e.prototype.remove = function() {
                    this._canvas && this._canvas.parentNode && this._canvas.parentNode.removeChild(this._canvas);
                }, e;
            }(a.ImageBase);
            e.default = u;
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = function() {
                function t() {}
                return t.prototype.scaleDown = function(t) {
                    var e = this.getWidth(), r = this.getHeight(), n = 1;
                    if (t.maxDimension > 0) {
                        var o = Math.max(e, r);
                        o > t.maxDimension && (n = t.maxDimension / o);
                    } else n = 1 / t.quality;
                    n < 1 && this.resize(e * n, r * n, n);
                }, t.prototype.applyFilter = function(t) {
                    var e = this.getImageData();
                    if ("function" == typeof t) for(var r = e.data, n = r.length / 4, o = void 0, i = 0; i < n; i++)t(r[(o = 4 * i) + 0], r[o + 1], r[o + 2], r[o + 3]) || (r[o + 3] = 0);
                    return Promise.resolve(e);
                }, t;
            }();
            e.ImageBase = n;
        },
        function(t, e, r) {
            "use strict";
            var n = r(597), o = r(598);
            function i() {
                this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
            }
            e.parse = x, e.resolve = function(t, e) {
                return x(t, !1, !0).resolve(e);
            }, e.resolveObject = function(t, e) {
                return t ? x(t, !1, !0).resolveObject(e) : e;
            }, e.format = function(t) {
                o.isString(t) && (t = x(t));
                return t instanceof i ? t.format() : i.prototype.format.call(t);
            }, e.Url = i;
            var a = /^([a-z0-9.+-]+:)/i, c = /:[0-9]*$/, u = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, s = [
                "{",
                "}",
                "|",
                "\\",
                "^",
                "`"
            ].concat([
                "<",
                ">",
                '"',
                "`",
                " ",
                "\r",
                "\n",
                "\t"
            ]), l = [
                "'"
            ].concat(s), f = [
                "%",
                "/",
                "?",
                ";",
                "#"
            ].concat(l), h = [
                "/",
                "?",
                "#"
            ], d = /^[+a-z0-9A-Z_-]{0,63}$/, p = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, v = {
                javascript: !0,
                "javascript:": !0
            }, m = {
                javascript: !0,
                "javascript:": !0
            }, g = {
                http: !0,
                https: !0,
                ftp: !0,
                gopher: !0,
                file: !0,
                "http:": !0,
                "https:": !0,
                "ftp:": !0,
                "gopher:": !0,
                "file:": !0
            }, b = r(599);
            function x(t, e, r) {
                if (t && o.isObject(t) && t instanceof i) return t;
                var n = new i;
                return n.parse(t, e, r), n;
            }
            i.prototype.parse = function(t, e, r) {
                if (!o.isString(t)) throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
                var i = t.indexOf("?"), c = -1 !== i && i < t.indexOf("#") ? "?" : "#", s = t.split(c);
                s[0] = s[0].replace(/\\/g, "/");
                var x = t = s.join(c);
                if (x = x.trim(), !r && 1 === t.split("#").length) {
                    var y = u.exec(x);
                    if (y) return this.path = x, this.href = x, this.pathname = y[1], y[2] ? (this.search = y[2], this.query = e ? b.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
                }
                var _ = a.exec(x);
                if (_) {
                    var w = (_ = _[0]).toLowerCase();
                    this.protocol = w, x = x.substr(_.length);
                }
                if (r || _ || x.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                    var S = "//" === x.substr(0, 2);
                    !S || _ && m[_] || (x = x.substr(2), this.slashes = !0);
                }
                if (!m[_] && (S || _ && !g[_])) {
                    for(var M, T, I = -1, D = 0; D < h.length; D++)-1 !== (E = x.indexOf(h[D])) && (-1 === I || E < I) && (I = E);
                    -1 !== (T = -1 === I ? x.lastIndexOf("@") : x.lastIndexOf("@", I)) && (M = x.slice(0, T), x = x.slice(T + 1), this.auth = decodeURIComponent(M)), I = -1;
                    for(D = 0; D < f.length; D++){
                        var E;
                        -1 !== (E = x.indexOf(f[D])) && (-1 === I || E < I) && (I = E);
                    }
                    -1 === I && (I = x.length), this.host = x.slice(0, I), x = x.slice(I), this.parseHost(), this.hostname = this.hostname || "";
                    var A = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
                    if (!A) for(var C = this.hostname.split(/\./), z = (D = 0, C.length); D < z; D++){
                        var O = C[D];
                        if (O && !O.match(d)) {
                            for(var F = "", R = 0, P = O.length; R < P; R++)O.charCodeAt(R) > 127 ? F += "x" : F += O[R];
                            if (!F.match(d)) {
                                var L = C.slice(0, D), k = C.slice(D + 1), j = O.match(p);
                                j && (L.push(j[1]), k.unshift(j[2])), k.length && (x = "/" + k.join(".") + x), this.hostname = L.join(".");
                                break;
                            }
                        }
                    }
                    this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), A || (this.hostname = n.toASCII(this.hostname));
                    var U = this.port ? ":" + this.port : "", B = this.hostname || "";
                    this.host = B + U, this.href += this.host, A && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== x[0] && (x = "/" + x));
                }
                if (!v[w]) for(D = 0, z = l.length; D < z; D++){
                    var N = l[D];
                    if (-1 !== x.indexOf(N)) {
                        var G = encodeURIComponent(N);
                        G === N && (G = escape(N)), x = x.split(N).join(G);
                    }
                }
                var V = x.indexOf("#");
                -1 !== V && (this.hash = x.substr(V), x = x.slice(0, V));
                var q = x.indexOf("?");
                if (-1 !== q ? (this.search = x.substr(q), this.query = x.substr(q + 1), e && (this.query = b.parse(this.query)), x = x.slice(0, q)) : e && (this.search = "", this.query = {}), x && (this.pathname = x), g[w] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
                    U = this.pathname || "";
                    var Y = this.search || "";
                    this.path = U + Y;
                }
                return this.href = this.format(), this;
            }, i.prototype.format = function() {
                var t = this.auth || "";
                t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
                var e = this.protocol || "", r = this.pathname || "", n = this.hash || "", i = !1, a = "";
                this.host ? i = t + this.host : this.hostname && (i = t + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (i += ":" + this.port)), this.query && o.isObject(this.query) && Object.keys(this.query).length && (a = b.stringify(this.query));
                var c = this.search || a && "?" + a || "";
                return e && ":" !== e.substr(-1) && (e += ":"), this.slashes || (!e || g[e]) && !1 !== i ? (i = "//" + (i || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : i || (i = ""), n && "#" !== n.charAt(0) && (n = "#" + n), c && "?" !== c.charAt(0) && (c = "?" + c), e + i + (r = r.replace(/[?#]/g, function(t) {
                    return encodeURIComponent(t);
                })) + (c = c.replace("#", "%23")) + n;
            }, i.prototype.resolve = function(t) {
                return this.resolveObject(x(t, !1, !0)).format();
            }, i.prototype.resolveObject = function(t) {
                if (o.isString(t)) {
                    var e = new i;
                    e.parse(t, !1, !0), t = e;
                }
                for(var r = new i, n = Object.keys(this), a = 0; a < n.length; a++){
                    var c = n[a];
                    r[c] = this[c];
                }
                if (r.hash = t.hash, "" === t.href) return r.href = r.format(), r;
                if (t.slashes && !t.protocol) {
                    for(var u = Object.keys(t), s = 0; s < u.length; s++){
                        var l = u[s];
                        "protocol" !== l && (r[l] = t[l]);
                    }
                    return g[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
                }
                if (t.protocol && t.protocol !== r.protocol) {
                    if (!g[t.protocol]) {
                        for(var f = Object.keys(t), h = 0; h < f.length; h++){
                            var d = f[h];
                            r[d] = t[d];
                        }
                        return r.href = r.format(), r;
                    }
                    if (r.protocol = t.protocol, t.host || m[t.protocol]) r.pathname = t.pathname;
                    else {
                        for(var p = (t.pathname || "").split("/"); p.length && !(t.host = p.shift()););
                        t.host || (t.host = ""), t.hostname || (t.hostname = ""), "" !== p[0] && p.unshift(""), p.length < 2 && p.unshift(""), r.pathname = p.join("/");
                    }
                    if (r.search = t.search, r.query = t.query, r.host = t.host || "", r.auth = t.auth, r.hostname = t.hostname || t.host, r.port = t.port, r.pathname || r.search) {
                        var v = r.pathname || "", b = r.search || "";
                        r.path = v + b;
                    }
                    return r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
                }
                var x = r.pathname && "/" === r.pathname.charAt(0), y = t.host || t.pathname && "/" === t.pathname.charAt(0), _ = y || x || r.host && t.pathname, w = _, S = r.pathname && r.pathname.split("/") || [], M = (p = t.pathname && t.pathname.split("/") || [], r.protocol && !g[r.protocol]);
                if (M && (r.hostname = "", r.port = null, r.host && ("" === S[0] ? S[0] = r.host : S.unshift(r.host)), r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && ("" === p[0] ? p[0] = t.host : p.unshift(t.host)), t.host = null), _ = _ && ("" === p[0] || "" === S[0])), y) r.host = t.host || "" === t.host ? t.host : r.host, r.hostname = t.hostname || "" === t.hostname ? t.hostname : r.hostname, r.search = t.search, r.query = t.query, S = p;
                else if (p.length) S || (S = []), S.pop(), S = S.concat(p), r.search = t.search, r.query = t.query;
                else if (!o.isNullOrUndefined(t.search)) {
                    if (M) r.hostname = r.host = S.shift(), (A = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = A.shift(), r.host = r.hostname = A.shift());
                    return r.search = t.search, r.query = t.query, o.isNull(r.pathname) && o.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
                }
                if (!S.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;
                for(var T = S.slice(-1)[0], I = (r.host || t.host || S.length > 1) && ("." === T || ".." === T) || "" === T, D = 0, E = S.length; E >= 0; E--)"." === (T = S[E]) ? S.splice(E, 1) : ".." === T ? (S.splice(E, 1), D++) : D && (S.splice(E, 1), D--);
                if (!_ && !w) for(; D--; D)S.unshift("..");
                !_ || "" === S[0] || S[0] && "/" === S[0].charAt(0) || S.unshift(""), I && "/" !== S.join("/").substr(-1) && S.push("");
                var A, C = "" === S[0] || S[0] && "/" === S[0].charAt(0);
                M && (r.hostname = r.host = C ? "" : S.length ? S.shift() : "", (A = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = A.shift(), r.host = r.hostname = A.shift()));
                return (_ = _ || r.host && S.length) && !C && S.unshift(""), S.length ? r.pathname = S.join("/") : (r.pathname = null, r.path = null), o.isNull(r.pathname) && o.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = t.auth || r.auth, r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
            }, i.prototype.parseHost = function() {
                var t = this.host, e = c.exec(t);
                e && (":" !== (e = e[0]) && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
            };
        },
        function(t, e, r) {
            (function(t, n) {
                var o;
                !function(i) {
                    e && e.nodeType, t && t.nodeType;
                    var a = "object" == typeof n && n;
                    a.global !== a && a.window !== a && a.self;
                    var c, u = 2147483647, s = /^xn--/, l = /[^\x20-\x7E]/, f = /[\x2E\u3002\uFF0E\uFF61]/g, h = {
                        overflow: "Overflow: input needs wider integers to process",
                        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                        "invalid-input": "Invalid input"
                    }, d = Math.floor, p = String.fromCharCode;
                    function v(t) {
                        throw new RangeError(h[t]);
                    }
                    function m(t, e) {
                        for(var r = t.length, n = []; r--;)n[r] = e(t[r]);
                        return n;
                    }
                    function g(t, e) {
                        var r = t.split("@"), n = "";
                        return r.length > 1 && (n = r[0] + "@", t = r[1]), n + m((t = t.replace(f, ".")).split("."), e).join(".");
                    }
                    function b(t) {
                        for(var e, r, n = [], o = 0, i = t.length; o < i;)(e = t.charCodeAt(o++)) >= 55296 && e <= 56319 && o < i ? 56320 == (64512 & (r = t.charCodeAt(o++))) ? n.push(((1023 & e) << 10) + (1023 & r) + 65536) : (n.push(e), o--) : n.push(e);
                        return n;
                    }
                    function x(t) {
                        return m(t, function(t) {
                            var e = "";
                            return t > 65535 && (e += p((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += p(t);
                        }).join("");
                    }
                    function y(t, e) {
                        return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
                    }
                    function _(t, e, r) {
                        var n = 0;
                        for(t = r ? d(t / 700) : t >> 1, t += d(t / e); t > 455; n += 36)t = d(t / 35);
                        return d(n + 36 * t / (t + 38));
                    }
                    function w(t) {
                        var e, r, n, o, i, a, c, s, l, f, h, p = [], m = t.length, g = 0, b = 128, y = 72;
                        for((r = t.lastIndexOf("-")) < 0 && (r = 0), n = 0; n < r; ++n)t.charCodeAt(n) >= 128 && v("not-basic"), p.push(t.charCodeAt(n));
                        for(o = r > 0 ? r + 1 : 0; o < m;){
                            for(i = g, a = 1, c = 36; o >= m && v("invalid-input"), ((s = (h = t.charCodeAt(o++)) - 48 < 10 ? h - 22 : h - 65 < 26 ? h - 65 : h - 97 < 26 ? h - 97 : 36) >= 36 || s > d((u - g) / a)) && v("overflow"), g += s * a, !(s < (l = c <= y ? 1 : c >= y + 26 ? 26 : c - y)); c += 36)a > d(u / (f = 36 - l)) && v("overflow"), a *= f;
                            y = _(g - i, e = p.length + 1, 0 == i), d(g / e) > u - b && v("overflow"), b += d(g / e), g %= e, p.splice(g++, 0, b);
                        }
                        return x(p);
                    }
                    function S(t) {
                        var e, r, n, o, i, a, c, s, l, f, h, m, g, x, w, S = [];
                        for(m = (t = b(t)).length, e = 128, r = 0, i = 72, a = 0; a < m; ++a)(h = t[a]) < 128 && S.push(p(h));
                        for(n = o = S.length, o && S.push("-"); n < m;){
                            for(c = u, a = 0; a < m; ++a)(h = t[a]) >= e && h < c && (c = h);
                            for(c - e > d((u - r) / (g = n + 1)) && v("overflow"), r += (c - e) * g, e = c, a = 0; a < m; ++a)if ((h = t[a]) < e && ++r > u && v("overflow"), h == e) {
                                for(s = r, l = 36; !(s < (f = l <= i ? 1 : l >= i + 26 ? 26 : l - i)); l += 36)w = s - f, x = 36 - f, S.push(p(y(f + w % x, 0))), s = d(w / x);
                                S.push(p(y(s, 0))), i = _(r, g, n == o), r = 0, ++n;
                            }
                            ++r, ++e;
                        }
                        return S.join("");
                    }
                    c = {
                        version: "1.4.1",
                        ucs2: {
                            decode: b,
                            encode: x
                        },
                        decode: w,
                        encode: S,
                        toASCII: function(t) {
                            return g(t, function(t) {
                                return l.test(t) ? "xn--" + S(t) : t;
                            });
                        },
                        toUnicode: function(t) {
                            return g(t, function(t) {
                                return s.test(t) ? w(t.slice(4).toLowerCase()) : t;
                            });
                        }
                    }, void 0 === (o = (function() {
                        return c;
                    }).call(e, r, e, t)) || (t.exports = o);
                }();
            }).call(this, r(71)(t), r(81));
        },
        function(t, e, r) {
            "use strict";
            t.exports = {
                isString: function(t) {
                    return "string" == typeof t;
                },
                isObject: function(t) {
                    return "object" == typeof t && null !== t;
                },
                isNull: function(t) {
                    return null === t;
                },
                isNullOrUndefined: function(t) {
                    return null == t;
                }
            };
        },
        function(t, e, r) {
            "use strict";
            e.decode = e.parse = r(600), e.encode = e.stringify = r(601);
        },
        function(t, e, r) {
            "use strict";
            function n(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
            }
            t.exports = function(t, e, r, i) {
                e = e || "&", r = r || "=";
                var a = {};
                if ("string" != typeof t || 0 === t.length) return a;
                var c = /\+/g;
                t = t.split(e);
                var u = 1e3;
                i && "number" == typeof i.maxKeys && (u = i.maxKeys);
                var s = t.length;
                u > 0 && s > u && (s = u);
                for(var l = 0; l < s; ++l){
                    var f, h, d, p, v = t[l].replace(c, "%20"), m = v.indexOf(r);
                    m >= 0 ? (f = v.substr(0, m), h = v.substr(m + 1)) : (f = v, h = ""), d = decodeURIComponent(f), p = decodeURIComponent(h), n(a, d) ? o(a[d]) ? a[d].push(p) : a[d] = [
                        a[d],
                        p
                    ] : a[d] = p;
                }
                return a;
            };
            var o = Array.isArray || function(t) {
                return "[object Array]" === Object.prototype.toString.call(t);
            };
        },
        function(t, e, r) {
            "use strict";
            var n = function(t) {
                switch(typeof t){
                    case "string":
                        return t;
                    case "boolean":
                        return t ? "true" : "false";
                    case "number":
                        return isFinite(t) ? t : "";
                    default:
                        return "";
                }
            };
            t.exports = function(t, e, r, c) {
                return e = e || "&", r = r || "=", null === t && (t = void 0), "object" == typeof t ? i(a(t), function(a) {
                    var c = encodeURIComponent(n(a)) + r;
                    return o(t[a]) ? i(t[a], function(t) {
                        return c + encodeURIComponent(n(t));
                    }).join(e) : c + encodeURIComponent(n(t[a]));
                }).join(e) : c ? encodeURIComponent(n(c)) + r + encodeURIComponent(n(t)) : "";
            };
            var o = Array.isArray || function(t) {
                return "[object Array]" === Object.prototype.toString.call(t);
            };
            function i(t, e) {
                if (t.map) return t.map(e);
                for(var r = [], n = 0; n < t.length; n++)r.push(e(t[n], n));
                return r;
            }
            var a = Object.keys || function(t) {
                var e = [];
                for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && e.push(r);
                return e;
            };
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nattribute vec3 coordinates;varying float pressure;varying vec2 position;varying vec3 color;uniform sampler2D smoothTexture;uniform float brushSize;vec3 b(in vec3 a){return a*mat3(.299,.587,.114,-.14713,-.28886,.436,.615,-.51499,-.10001);}void main(){vec2 a=coordinates.xy*2.-1.;position=coordinates.xy;pressure=coordinates[2]*2.;color=b(texture2D(smoothTexture,coordinates.xy).rgb);gl_Position=vec4(a,1.,1.);gl_PointSize=brushSize;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying float pressure;varying vec2 position;varying vec3 color;uniform sampler2D smoothTexture;uniform vec2 texel;uniform float brushSize;uniform float flow;uniform float hardness;uniform float masking;uniform bool erase;vec3 d(in vec3 a){return a*mat3(.299,.587,.114,-.14713,-.28886,.436,.615,-.51499,-.10001);}void main(){vec2 c=texel*brushSize*vec2(1.,-1.);vec2 e=(gl_PointCoord-.5)*c+position;vec3 a=texture2D(smoothTexture,e).rgb;a=d(a);vec3 f=abs(color-a);float b=length(f);b=1.-min(b/masking,1.);float g=1.-length(gl_PointCoord-vec2(.5))*2.;float h=smoothstep(0.,1.,g*hardness*pressure)*flow*pressure;vec3 i=erase?vec3(0.):vec3(1.);gl_FragColor=vec4(i,h*b);}";
        },
        function(t, e) {
            t.exports = "#define GLSLIFY 1\n/*! Copyright (c) 2015-present, Polarr, Inc. */\nuniform mat4 u_ModelViewProjectionMatrix;attribute vec4 a_Vertex;attribute vec4 a_TexCoord;varying vec4 coord;void main(){coord=a_TexCoord;gl_Position=u_ModelViewProjectionMatrix*a_Vertex;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\n#extension GL_OES_standard_derivatives:enable\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform float pressure;uniform float flow;uniform float hardness;uniform sampler2D cacheTexture;uniform sampler2D texture;uniform sampler2D overlay;uniform sampler2D borderTexture;uniform float overlayOpacity;uniform float highlightOpacity;uniform float brushScale;uniform mat4 backgroundMatrix;uniform mat4 overlayMatrix;uniform mat4 cropMatrix;uniform mat4 viewMatrix;uniform bool renderWindow;void main(){float c=1.-length(coord.xy-vec2(.5))*2.*brushScale;float a=fwidth(c);float h=a*2.;float j=h*2.;float r=smoothstep(0.,a,c);float k=smoothstep(h-a,h+a,c);float s=smoothstep(j-a,j+a,c);float e=r-k*.7-s;float l=smoothstep(0.,1.,c*hardness*pressure)*flow*pressure;vec4 m=vec4(vec3(1.-k),e);vec4 f=vec4(1.,0.,0.,l);float z=min(l+e,1.);f.a*=highlightOpacity;if(renderWindow){vec4 n=mix(f,m,step(1e-5,e));vec4 t=overlayMatrix*(coord*2.-1.)*.5+.5;vec4 b=backgroundMatrix*(coord*2.-1.)*.5+.5;vec4 o=viewMatrix*cropMatrix*(b*2.-1.)*.5+.5;vec2 p=ceil(fract(clamp(o.xy,0.,1.)));lowp vec4 i=texture2D(borderTexture,coord.xy);lowp vec4 u=texture2D(cacheTexture,b.xy);lowp vec4 v=texture2D(texture,o.xy);lowp vec4 g=mix(u,v,p.x*p.y);lowp vec4 w=texture2D(overlay,t.xy).rrrr;g.rgb=mix(g.rgb,f.rgb,w.a*overlayOpacity);g*=float(!(b.x>1.||b.x<0.||b.y>1.||b.y<0.));float x=i.b;float q=i.g;float y=i.r;lowp vec3 d=mix(g,n,n.a).rgb;d=mix(vec3(1.),d,x);d=mix(vec3(0.),d,q);gl_FragColor=vec4(d,y*.3+q);}else{gl_FragColor=mix(f,m,step(1e-5,e));}}";
        },
        function(t, e) {
            var r = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
            if (r) {
                var n = new Uint8Array(16);
                t.exports = function() {
                    return r(n), n;
                };
            } else {
                var o = new Array(16);
                t.exports = function() {
                    for(var t, e = 0; e < 16; e++)0 == (3 & e) && (t = 4294967296 * Math.random()), o[e] = t >>> ((3 & e) << 3) & 255;
                    return o;
                };
            }
        },
        function(t, e) {
            for(var r = [], n = 0; n < 256; ++n)r[n] = (n + 256).toString(16).substr(1);
            t.exports = function(t, e) {
                var n = e || 0, o = r;
                return [
                    o[t[n++]],
                    o[t[n++]],
                    o[t[n++]],
                    o[t[n++]],
                    "-",
                    o[t[n++]],
                    o[t[n++]],
                    "-",
                    o[t[n++]],
                    o[t[n++]],
                    "-",
                    o[t[n++]],
                    o[t[n++]],
                    "-",
                    o[t[n++]],
                    o[t[n++]],
                    o[t[n++]],
                    o[t[n++]],
                    o[t[n++]],
                    o[t[n++]]
                ].join("");
            };
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform sampler2D texture;void main(){gl_FragColor=texture2D(texture,coord.xy);}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nuniform mat4 u_ModelViewProjectionMatrix;attribute vec4 a_Vertex;attribute vec4 a_TexCoord;varying vec4 coord;void main(){coord=a_TexCoord;gl_Position=u_ModelViewProjectionMatrix*a_Vertex;}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\n\nvarying vec4 coord;\n\nuniform sampler2D texture;\nuniform vec2 delta[4];\n\n#define RADIUS 4\n#define TOTAL 8.5 // RADIUS * 2 + 0.5\n\nvoid main() {\n  vec4 color = texture2D(texture, coord.xy) * 0.5;\n\n  for (int i = 0; i < RADIUS; i++) {\n    color += texture2D(texture, coord.xy - delta[i]);\n    color += texture2D(texture, coord.xy + delta[i]);\n  }\n\n  gl_FragColor = color / TOTAL;\n\n}";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\n\nvarying vec4 coord;\n\nuniform sampler2D texture;\nuniform vec2 delta[4];\nuniform float eps;\n\n#define RADIUS 4\n#define TOTAL 8.5 // RADIUS * 2 + 0.5\n\nvoid main() {\n  vec4 color = texture2D(texture, coord.xy) * 0.5;\n\n  for (int i = 0; i < RADIUS; i++) {\n    color += texture2D(texture, coord.xy - delta[i]);\n    color += texture2D(texture, coord.xy + delta[i]);\n  }\n\n  vec4 mean = color / TOTAL;\n\n  float mean_I = mean.r;\n  float mean_p = mean.g;\n  float mean_II = mean.b;\n  float mean_Ip = mean.a;\n\n  float cov_Ip = mean_Ip - mean_I * mean_p;\n  float var_I = mean_II - mean_I * mean_I;\n  float a = cov_Ip / max(var_I + eps, 0.00001);\n  float b = mean_p - a * mean_I;\n\n  gl_FragColor = vec4(a, b, mean_I, mean_p);\n}\n";
        },
        function(t, e) {
            t.exports = "/*! Copyright (c) 2015-present, Polarr, Inc. */\nprecision highp float;\n#define GLSLIFY 1\nvarying vec4 coord;uniform bool multitexture;uniform sampler2D textures[4];uniform sampler2D maskTexture;uniform mat4 maskTransform;vec4 g(vec2 f){if(!multitexture){return texture2D(textures[0],f);}vec2 d=f*2.;vec2 b=floor(d);int e=int(b.x+b.y*2.);vec2 c=vec2(d.x-b.x,d.y-b.y);vec4 a;if(e==0){a=texture2D(textures[0],c);}else if(e==1){a=texture2D(textures[1],c);}else if(e==2){a=texture2D(textures[2],c);}else{a=texture2D(textures[3],c);}return a;}void main(){vec4 c=(coord-.5)*maskTransform+.5;vec4 d=g(coord.xy);vec4 e=texture2D(maskTexture,c.xy);float a=dot(d.rgb,vec3(.298839,.586811,.11435));float b=e.r;gl_FragColor=vec4(a,b,a*a,a*b);}";
        },
        function(t, e, r) {
            !function(t) {
                var e, r, n, o = String.fromCharCode;
                function i(t) {
                    for(var e, r, n = [], o = 0, i = t.length; o < i;)(e = t.charCodeAt(o++)) >= 55296 && e <= 56319 && o < i ? 56320 == (64512 & (r = t.charCodeAt(o++))) ? n.push(((1023 & e) << 10) + (1023 & r) + 65536) : (n.push(e), o--) : n.push(e);
                    return n;
                }
                function a(t) {
                    if (t >= 55296 && t <= 57343) throw Error("Lone surrogate U+" + t.toString(16).toUpperCase() + " is not a scalar value");
                }
                function c(t, e) {
                    return o(t >> e & 63 | 128);
                }
                function u(t) {
                    if (0 == (4294967168 & t)) return o(t);
                    var e = "";
                    return 0 == (4294965248 & t) ? e = o(t >> 6 & 31 | 192) : 0 == (4294901760 & t) ? (a(t), e = o(t >> 12 & 15 | 224), e += c(t, 6)) : 0 == (4292870144 & t) && (e = o(t >> 18 & 7 | 240), e += c(t, 12), e += c(t, 6)), e += o(63 & t | 128);
                }
                function s() {
                    if (n >= r) throw Error("Invalid byte index");
                    var t = 255 & e[n];
                    if (n++, 128 == (192 & t)) return 63 & t;
                    throw Error("Invalid continuation byte");
                }
                function l() {
                    var t, o;
                    if (n > r) throw Error("Invalid byte index");
                    if (n == r) return !1;
                    if (t = 255 & e[n], n++, 0 == (128 & t)) return t;
                    if (192 == (224 & t)) {
                        if ((o = (31 & t) << 6 | s()) >= 128) return o;
                        throw Error("Invalid continuation byte");
                    }
                    if (224 == (240 & t)) {
                        if ((o = (15 & t) << 12 | s() << 6 | s()) >= 2048) return a(o), o;
                        throw Error("Invalid continuation byte");
                    }
                    if (240 == (248 & t) && (o = (7 & t) << 18 | s() << 12 | s() << 6 | s()) >= 65536 && o <= 1114111) return o;
                    throw Error("Invalid UTF-8 detected");
                }
                t.version = "3.0.0", t.encode = function(t) {
                    for(var e = i(t), r = e.length, n = -1, o = ""; ++n < r;)o += u(e[n]);
                    return o;
                }, t.decode = function(t) {
                    e = i(t), r = e.length, n = 0;
                    for(var a, c = []; !1 !== (a = l());)c.push(a);
                    return function(t) {
                        for(var e, r = t.length, n = -1, i = ""; ++n < r;)(e = t[n]) > 65535 && (i += o((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), i += o(e);
                        return i;
                    }(c);
                };
            }(e);
        },
        function(t, e, r) {
            "use strict";
            var n = r(615), o = r(80), i = r(619), a = r(195), c = r(620), u = Object.prototype.toString;
            function s(t) {
                if (!(this instanceof s)) return new s(t);
                this.options = o.assign({
                    level: -1,
                    method: 8,
                    chunkSize: 16384,
                    windowBits: 15,
                    memLevel: 8,
                    strategy: 0,
                    to: ""
                }, t || {});
                var e = this.options;
                e.raw && e.windowBits > 0 ? e.windowBits = -e.windowBits : e.gzip && e.windowBits > 0 && e.windowBits < 16 && (e.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new c, this.strm.avail_out = 0;
                var r = n.deflateInit2(this.strm, e.level, e.method, e.windowBits, e.memLevel, e.strategy);
                if (0 !== r) throw new Error(a[r]);
                if (e.header && n.deflateSetHeader(this.strm, e.header), e.dictionary) {
                    var l;
                    if (l = "string" == typeof e.dictionary ? i.string2buf(e.dictionary) : "[object ArrayBuffer]" === u.call(e.dictionary) ? new Uint8Array(e.dictionary) : e.dictionary, 0 !== (r = n.deflateSetDictionary(this.strm, l))) throw new Error(a[r]);
                    this._dict_set = !0;
                }
            }
            function l(t, e) {
                var r = new s(e);
                if (r.push(t, !0), r.err) throw r.msg || a[r.err];
                return r.result;
            }
            s.prototype.push = function(t, e) {
                var r, a, c = this.strm, s = this.options.chunkSize;
                if (this.ended) return !1;
                a = e === ~~e ? e : !0 === e ? 4 : 0, "string" == typeof t ? c.input = i.string2buf(t) : "[object ArrayBuffer]" === u.call(t) ? c.input = new Uint8Array(t) : c.input = t, c.next_in = 0, c.avail_in = c.input.length;
                do {
                    if (0 === c.avail_out && (c.output = new o.Buf8(s), c.next_out = 0, c.avail_out = s), 1 !== (r = n.deflate(c, a)) && 0 !== r) return this.onEnd(r), this.ended = !0, !1;
                    0 !== c.avail_out && (0 !== c.avail_in || 4 !== a && 2 !== a) || ("string" === this.options.to ? this.onData(i.buf2binstring(o.shrinkBuf(c.output, c.next_out))) : this.onData(o.shrinkBuf(c.output, c.next_out)));
                }while ((c.avail_in > 0 || 0 === c.avail_out) && 1 !== r);
                return 4 === a ? (r = n.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, 0 === r) : 2 !== a || (this.onEnd(0), c.avail_out = 0, !0);
            }, s.prototype.onData = function(t) {
                this.chunks.push(t);
            }, s.prototype.onEnd = function(t) {
                0 === t && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
            }, e.Deflate = s, e.deflate = l, e.deflateRaw = function(t, e) {
                return (e = e || {}).raw = !0, l(t, e);
            }, e.gzip = function(t, e) {
                return (e = e || {}).gzip = !0, l(t, e);
            };
        },
        function(t, e, r) {
            "use strict";
            var n, o = r(80), i = r(616), a = r(617), c = r(618), u = r(195);
            function s(t, e) {
                return t.msg = u[e], e;
            }
            function l(t) {
                return (t << 1) - (t > 4 ? 9 : 0);
            }
            function f(t) {
                for(var e = t.length; --e >= 0;)t[e] = 0;
            }
            function h(t) {
                var e = t.state, r = e.pending;
                r > t.avail_out && (r = t.avail_out), 0 !== r && (o.arraySet(t.output, e.pending_buf, e.pending_out, r, t.next_out), t.next_out += r, e.pending_out += r, t.total_out += r, t.avail_out -= r, e.pending -= r, 0 === e.pending && (e.pending_out = 0));
            }
            function d(t, e) {
                i._tr_flush_block(t, t.block_start >= 0 ? t.block_start : -1, t.strstart - t.block_start, e), t.block_start = t.strstart, h(t.strm);
            }
            function p(t, e) {
                t.pending_buf[t.pending++] = e;
            }
            function v(t, e) {
                t.pending_buf[t.pending++] = e >>> 8 & 255, t.pending_buf[t.pending++] = 255 & e;
            }
            function m(t, e) {
                var r, n, o = t.max_chain_length, i = t.strstart, a = t.prev_length, c = t.nice_match, u = t.strstart > t.w_size - 262 ? t.strstart - (t.w_size - 262) : 0, s = t.window, l = t.w_mask, f = t.prev, h = t.strstart + 258, d = s[i + a - 1], p = s[i + a];
                t.prev_length >= t.good_match && (o >>= 2), c > t.lookahead && (c = t.lookahead);
                do if (s[(r = e) + a] === p && s[r + a - 1] === d && s[r] === s[i] && s[++r] === s[i + 1]) {
                    i += 2, r++;
                    do ;
                    while (s[++i] === s[++r] && s[++i] === s[++r] && s[++i] === s[++r] && s[++i] === s[++r] && s[++i] === s[++r] && s[++i] === s[++r] && s[++i] === s[++r] && s[++i] === s[++r] && i < h);
                    if (n = 258 - (h - i), i = h - 258, n > a) {
                        if (t.match_start = e, a = n, n >= c) break;
                        d = s[i + a - 1], p = s[i + a];
                    }
                }
                while ((e = f[e & l]) > u && 0 != --o);
                return a <= t.lookahead ? a : t.lookahead;
            }
            function g(t) {
                var e, r, n, i, u, s, l, f, h, d, p = t.w_size;
                do {
                    if (i = t.window_size - t.lookahead - t.strstart, t.strstart >= p + (p - 262)) {
                        o.arraySet(t.window, t.window, p, p, 0), t.match_start -= p, t.strstart -= p, t.block_start -= p, e = r = t.hash_size;
                        do n = t.head[--e], t.head[e] = n >= p ? n - p : 0;
                        while (--r);
                        e = r = p;
                        do n = t.prev[--e], t.prev[e] = n >= p ? n - p : 0;
                        while (--r);
                        i += p;
                    }
                    if (0 === t.strm.avail_in) break;
                    if (s = t.strm, l = t.window, f = t.strstart + t.lookahead, h = i, d = void 0, (d = s.avail_in) > h && (d = h), r = 0 === d ? 0 : (s.avail_in -= d, o.arraySet(l, s.input, s.next_in, d, f), 1 === s.state.wrap ? s.adler = a(s.adler, l, d, f) : 2 === s.state.wrap && (s.adler = c(s.adler, l, d, f)), s.next_in += d, s.total_in += d, d), t.lookahead += r, t.lookahead + t.insert >= 3) for(u = t.strstart - t.insert, t.ins_h = t.window[u], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[u + 1]) & t.hash_mask; t.insert && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[u + 3 - 1]) & t.hash_mask, t.prev[u & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = u, u++, t.insert--, !(t.lookahead + t.insert < 3)););
                }while (t.lookahead < 262 && 0 !== t.strm.avail_in);
            }
            function b(t, e) {
                for(var r, n;;){
                    if (t.lookahead < 262) {
                        if (g(t), t.lookahead < 262 && 0 === e) return 1;
                        if (0 === t.lookahead) break;
                    }
                    if (r = 0, t.lookahead >= 3 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), 0 !== r && t.strstart - r <= t.w_size - 262 && (t.match_length = m(t, r)), t.match_length >= 3) {
                        if (n = i._tr_tally(t, t.strstart - t.match_start, t.match_length - 3), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= 3) {
                            t.match_length--;
                            do t.strstart++, t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart;
                            while (0 != --t.match_length);
                            t.strstart++;
                        } else t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 1]) & t.hash_mask;
                    } else n = i._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
                    if (n && (d(t, !1), 0 === t.strm.avail_out)) return 1;
                }
                return t.insert = t.strstart < 2 ? t.strstart : 2, 4 === e ? (d(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (d(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
            }
            function x(t, e) {
                for(var r, n, o;;){
                    if (t.lookahead < 262) {
                        if (g(t), t.lookahead < 262 && 0 === e) return 1;
                        if (0 === t.lookahead) break;
                    }
                    if (r = 0, t.lookahead >= 3 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = 2, 0 !== r && t.prev_length < t.max_lazy_match && t.strstart - r <= t.w_size - 262 && (t.match_length = m(t, r), t.match_length <= 5 && (1 === t.strategy || 3 === t.match_length && t.strstart - t.match_start > 4096) && (t.match_length = 2)), t.prev_length >= 3 && t.match_length <= t.prev_length) {
                        o = t.strstart + t.lookahead - 3, n = i._tr_tally(t, t.strstart - 1 - t.prev_match, t.prev_length - 3), t.lookahead -= t.prev_length - 1, t.prev_length -= 2;
                        do ++t.strstart <= o && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart);
                        while (0 != --t.prev_length);
                        if (t.match_available = 0, t.match_length = 2, t.strstart++, n && (d(t, !1), 0 === t.strm.avail_out)) return 1;
                    } else if (t.match_available) {
                        if ((n = i._tr_tally(t, 0, t.window[t.strstart - 1])) && d(t, !1), t.strstart++, t.lookahead--, 0 === t.strm.avail_out) return 1;
                    } else t.match_available = 1, t.strstart++, t.lookahead--;
                }
                return t.match_available && (n = i._tr_tally(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < 2 ? t.strstart : 2, 4 === e ? (d(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (d(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
            }
            function y(t, e, r, n, o) {
                this.good_length = t, this.max_lazy = e, this.nice_length = r, this.max_chain = n, this.func = o;
            }
            function _() {
                this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new o.Buf16(1146), this.dyn_dtree = new o.Buf16(122), this.bl_tree = new o.Buf16(78), f(this.dyn_ltree), f(this.dyn_dtree), f(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new o.Buf16(16), this.heap = new o.Buf16(573), f(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new o.Buf16(573), f(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
            }
            function w(t) {
                var e;
                return t && t.state ? (t.total_in = t.total_out = 0, t.data_type = 2, (e = t.state).pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? 42 : 113, t.adler = 2 === e.wrap ? 0 : 1, e.last_flush = 0, i._tr_init(e), 0) : s(t, -2);
            }
            function S(t) {
                var e, r = w(t);
                return 0 === r && ((e = t.state).window_size = 2 * e.w_size, f(e.head), e.max_lazy_match = n[e.level].max_lazy, e.good_match = n[e.level].good_length, e.nice_match = n[e.level].nice_length, e.max_chain_length = n[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = 2, e.match_available = 0, e.ins_h = 0), r;
            }
            function M(t, e, r, n, i, a) {
                if (!t) return -2;
                var c = 1;
                if (-1 === e && (e = 6), n < 0 ? (c = 0, n = -n) : n > 15 && (c = 2, n -= 16), i < 1 || i > 9 || 8 !== r || n < 8 || n > 15 || e < 0 || e > 9 || a < 0 || a > 4) return s(t, -2);
                8 === n && (n = 9);
                var u = new _;
                return t.state = u, u.strm = t, u.wrap = c, u.gzhead = null, u.w_bits = n, u.w_size = 1 << u.w_bits, u.w_mask = u.w_size - 1, u.hash_bits = i + 7, u.hash_size = 1 << u.hash_bits, u.hash_mask = u.hash_size - 1, u.hash_shift = ~~((u.hash_bits + 3 - 1) / 3), u.window = new o.Buf8(2 * u.w_size), u.head = new o.Buf16(u.hash_size), u.prev = new o.Buf16(u.w_size), u.lit_bufsize = 1 << i + 6, u.pending_buf_size = 4 * u.lit_bufsize, u.pending_buf = new o.Buf8(u.pending_buf_size), u.d_buf = 1 * u.lit_bufsize, u.l_buf = 3 * u.lit_bufsize, u.level = e, u.strategy = a, u.method = r, S(t);
            }
            n = [
                new y(0, 0, 0, 0, function(t, e) {
                    var r = 65535;
                    for(r > t.pending_buf_size - 5 && (r = t.pending_buf_size - 5);;){
                        if (t.lookahead <= 1) {
                            if (g(t), 0 === t.lookahead && 0 === e) return 1;
                            if (0 === t.lookahead) break;
                        }
                        t.strstart += t.lookahead, t.lookahead = 0;
                        var n = t.block_start + r;
                        if ((0 === t.strstart || t.strstart >= n) && (t.lookahead = t.strstart - n, t.strstart = n, d(t, !1), 0 === t.strm.avail_out)) return 1;
                        if (t.strstart - t.block_start >= t.w_size - 262 && (d(t, !1), 0 === t.strm.avail_out)) return 1;
                    }
                    return t.insert = 0, 4 === e ? (d(t, !0), 0 === t.strm.avail_out ? 3 : 4) : (t.strstart > t.block_start && (d(t, !1), t.strm.avail_out), 1);
                }),
                new y(4, 4, 8, 4, b),
                new y(4, 5, 16, 8, b),
                new y(4, 6, 32, 32, b),
                new y(4, 4, 16, 16, x),
                new y(8, 16, 32, 32, x),
                new y(8, 16, 128, 128, x),
                new y(8, 32, 128, 256, x),
                new y(32, 128, 258, 1024, x),
                new y(32, 258, 258, 4096, x)
            ], e.deflateInit = function(t, e) {
                return M(t, e, 8, 15, 8, 0);
            }, e.deflateInit2 = M, e.deflateReset = S, e.deflateResetKeep = w, e.deflateSetHeader = function(t, e) {
                return t && t.state ? 2 !== t.state.wrap ? -2 : (t.state.gzhead = e, 0) : -2;
            }, e.deflate = function(t, e) {
                var r, o, a, u;
                if (!t || !t.state || e > 5 || e < 0) return t ? s(t, -2) : -2;
                if (o = t.state, !t.output || !t.input && 0 !== t.avail_in || 666 === o.status && 4 !== e) return s(t, 0 === t.avail_out ? -5 : -2);
                if (o.strm = t, r = o.last_flush, o.last_flush = e, 42 === o.status) {
                    if (2 === o.wrap) t.adler = 0, p(o, 31), p(o, 139), p(o, 8), o.gzhead ? (p(o, (o.gzhead.text ? 1 : 0) + (o.gzhead.hcrc ? 2 : 0) + (o.gzhead.extra ? 4 : 0) + (o.gzhead.name ? 8 : 0) + (o.gzhead.comment ? 16 : 0)), p(o, 255 & o.gzhead.time), p(o, o.gzhead.time >> 8 & 255), p(o, o.gzhead.time >> 16 & 255), p(o, o.gzhead.time >> 24 & 255), p(o, 9 === o.level ? 2 : o.strategy >= 2 || o.level < 2 ? 4 : 0), p(o, 255 & o.gzhead.os), o.gzhead.extra && o.gzhead.extra.length && (p(o, 255 & o.gzhead.extra.length), p(o, o.gzhead.extra.length >> 8 & 255)), o.gzhead.hcrc && (t.adler = c(t.adler, o.pending_buf, o.pending, 0)), o.gzindex = 0, o.status = 69) : (p(o, 0), p(o, 0), p(o, 0), p(o, 0), p(o, 0), p(o, 9 === o.level ? 2 : o.strategy >= 2 || o.level < 2 ? 4 : 0), p(o, 3), o.status = 113);
                    else {
                        var m = 8 + (o.w_bits - 8 << 4) << 8;
                        m |= (o.strategy >= 2 || o.level < 2 ? 0 : o.level < 6 ? 1 : 6 === o.level ? 2 : 3) << 6, 0 !== o.strstart && (m |= 32), m += 31 - m % 31, o.status = 113, v(o, m), 0 !== o.strstart && (v(o, t.adler >>> 16), v(o, 65535 & t.adler)), t.adler = 1;
                    }
                }
                if (69 === o.status) {
                    if (o.gzhead.extra) {
                        for(a = o.pending; o.gzindex < (65535 & o.gzhead.extra.length) && (o.pending !== o.pending_buf_size || (o.gzhead.hcrc && o.pending > a && (t.adler = c(t.adler, o.pending_buf, o.pending - a, a)), h(t), a = o.pending, o.pending !== o.pending_buf_size));)p(o, 255 & o.gzhead.extra[o.gzindex]), o.gzindex++;
                        o.gzhead.hcrc && o.pending > a && (t.adler = c(t.adler, o.pending_buf, o.pending - a, a)), o.gzindex === o.gzhead.extra.length && (o.gzindex = 0, o.status = 73);
                    } else o.status = 73;
                }
                if (73 === o.status) {
                    if (o.gzhead.name) {
                        a = o.pending;
                        do {
                            if (o.pending === o.pending_buf_size && (o.gzhead.hcrc && o.pending > a && (t.adler = c(t.adler, o.pending_buf, o.pending - a, a)), h(t), a = o.pending, o.pending === o.pending_buf_size)) {
                                u = 1;
                                break;
                            }
                            u = o.gzindex < o.gzhead.name.length ? 255 & o.gzhead.name.charCodeAt(o.gzindex++) : 0, p(o, u);
                        }while (0 !== u);
                        o.gzhead.hcrc && o.pending > a && (t.adler = c(t.adler, o.pending_buf, o.pending - a, a)), 0 === u && (o.gzindex = 0, o.status = 91);
                    } else o.status = 91;
                }
                if (91 === o.status) {
                    if (o.gzhead.comment) {
                        a = o.pending;
                        do {
                            if (o.pending === o.pending_buf_size && (o.gzhead.hcrc && o.pending > a && (t.adler = c(t.adler, o.pending_buf, o.pending - a, a)), h(t), a = o.pending, o.pending === o.pending_buf_size)) {
                                u = 1;
                                break;
                            }
                            u = o.gzindex < o.gzhead.comment.length ? 255 & o.gzhead.comment.charCodeAt(o.gzindex++) : 0, p(o, u);
                        }while (0 !== u);
                        o.gzhead.hcrc && o.pending > a && (t.adler = c(t.adler, o.pending_buf, o.pending - a, a)), 0 === u && (o.status = 103);
                    } else o.status = 103;
                }
                if (103 === o.status && (o.gzhead.hcrc ? (o.pending + 2 > o.pending_buf_size && h(t), o.pending + 2 <= o.pending_buf_size && (p(o, 255 & t.adler), p(o, t.adler >> 8 & 255), t.adler = 0, o.status = 113)) : o.status = 113), 0 !== o.pending) {
                    if (h(t), 0 === t.avail_out) return o.last_flush = -1, 0;
                } else if (0 === t.avail_in && l(e) <= l(r) && 4 !== e) return s(t, -5);
                if (666 === o.status && 0 !== t.avail_in) return s(t, -5);
                if (0 !== t.avail_in || 0 !== o.lookahead || 0 !== e && 666 !== o.status) {
                    var b = 2 === o.strategy ? function(t, e) {
                        for(var r;;){
                            if (0 === t.lookahead && (g(t), 0 === t.lookahead)) {
                                if (0 === e) return 1;
                                break;
                            }
                            if (t.match_length = 0, r = i._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++, r && (d(t, !1), 0 === t.strm.avail_out)) return 1;
                        }
                        return t.insert = 0, 4 === e ? (d(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (d(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
                    }(o, e) : 3 === o.strategy ? function(t, e) {
                        for(var r, n, o, a, c = t.window;;){
                            if (t.lookahead <= 258) {
                                if (g(t), t.lookahead <= 258 && 0 === e) return 1;
                                if (0 === t.lookahead) break;
                            }
                            if (t.match_length = 0, t.lookahead >= 3 && t.strstart > 0 && (n = c[o = t.strstart - 1]) === c[++o] && n === c[++o] && n === c[++o]) {
                                a = t.strstart + 258;
                                do ;
                                while (n === c[++o] && n === c[++o] && n === c[++o] && n === c[++o] && n === c[++o] && n === c[++o] && n === c[++o] && n === c[++o] && o < a);
                                t.match_length = 258 - (a - o), t.match_length > t.lookahead && (t.match_length = t.lookahead);
                            }
                            if (t.match_length >= 3 ? (r = i._tr_tally(t, 1, t.match_length - 3), t.lookahead -= t.match_length, t.strstart += t.match_length, t.match_length = 0) : (r = i._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++), r && (d(t, !1), 0 === t.strm.avail_out)) return 1;
                        }
                        return t.insert = 0, 4 === e ? (d(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (d(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
                    }(o, e) : n[o.level].func(o, e);
                    if (3 !== b && 4 !== b || (o.status = 666), 1 === b || 3 === b) return 0 === t.avail_out && (o.last_flush = -1), 0;
                    if (2 === b && (1 === e ? i._tr_align(o) : 5 !== e && (i._tr_stored_block(o, 0, 0, !1), 3 === e && (f(o.head), 0 === o.lookahead && (o.strstart = 0, o.block_start = 0, o.insert = 0))), h(t), 0 === t.avail_out)) return o.last_flush = -1, 0;
                }
                return 4 !== e ? 0 : o.wrap <= 0 ? 1 : (2 === o.wrap ? (p(o, 255 & t.adler), p(o, t.adler >> 8 & 255), p(o, t.adler >> 16 & 255), p(o, t.adler >> 24 & 255), p(o, 255 & t.total_in), p(o, t.total_in >> 8 & 255), p(o, t.total_in >> 16 & 255), p(o, t.total_in >> 24 & 255)) : (v(o, t.adler >>> 16), v(o, 65535 & t.adler)), h(t), o.wrap > 0 && (o.wrap = -o.wrap), 0 !== o.pending ? 0 : 1);
            }, e.deflateEnd = function(t) {
                var e;
                return t && t.state ? 42 !== (e = t.state.status) && 69 !== e && 73 !== e && 91 !== e && 103 !== e && 113 !== e && 666 !== e ? s(t, -2) : (t.state = null, 113 === e ? s(t, -3) : 0) : -2;
            }, e.deflateSetDictionary = function(t, e) {
                var r, n, i, c, u, s, l, h, d = e.length;
                if (!t || !t.state) return -2;
                if (2 === (c = (r = t.state).wrap) || 1 === c && 42 !== r.status || r.lookahead) return -2;
                for(1 === c && (t.adler = a(t.adler, e, d, 0)), r.wrap = 0, d >= r.w_size && (0 === c && (f(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), h = new o.Buf8(r.w_size), o.arraySet(h, e, d - r.w_size, r.w_size, 0), e = h, d = r.w_size), u = t.avail_in, s = t.next_in, l = t.input, t.avail_in = d, t.next_in = 0, t.input = e, g(r); r.lookahead >= 3;){
                    n = r.strstart, i = r.lookahead - 2;
                    do r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + 3 - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++;
                    while (--i);
                    r.strstart = n, r.lookahead = 2, g(r);
                }
                return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, t.next_in = s, t.input = l, t.avail_in = u, r.wrap = c, 0;
            }, e.deflateInfo = "pako deflate (from Nodeca project)";
        },
        function(t, e, r) {
            "use strict";
            var n = r(80);
            function o(t) {
                for(var e = t.length; --e >= 0;)t[e] = 0;
            }
            var i = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0
            ], a = [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13
            ], c = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                2,
                3,
                7
            ], u = [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ], s = new Array(576);
            o(s);
            var l = new Array(60);
            o(l);
            var f = new Array(512);
            o(f);
            var h = new Array(256);
            o(h);
            var d = new Array(29);
            o(d);
            var p, v, m, g = new Array(30);
            function b(t, e, r, n, o) {
                this.static_tree = t, this.extra_bits = e, this.extra_base = r, this.elems = n, this.max_length = o, this.has_stree = t && t.length;
            }
            function x(t, e) {
                this.dyn_tree = t, this.max_code = 0, this.stat_desc = e;
            }
            function y(t) {
                return t < 256 ? f[t] : f[256 + (t >>> 7)];
            }
            function _(t, e) {
                t.pending_buf[t.pending++] = 255 & e, t.pending_buf[t.pending++] = e >>> 8 & 255;
            }
            function w(t, e, r) {
                t.bi_valid > 16 - r ? (t.bi_buf |= e << t.bi_valid & 65535, _(t, t.bi_buf), t.bi_buf = e >> 16 - t.bi_valid, t.bi_valid += r - 16) : (t.bi_buf |= e << t.bi_valid & 65535, t.bi_valid += r);
            }
            function S(t, e, r) {
                w(t, r[2 * e], r[2 * e + 1]);
            }
            function M(t, e) {
                var r = 0;
                do r |= 1 & t, t >>>= 1, r <<= 1;
                while (--e > 0);
                return r >>> 1;
            }
            function T(t, e, r) {
                var n, o, i = new Array(16), a = 0;
                for(n = 1; n <= 15; n++)i[n] = a = a + r[n - 1] << 1;
                for(o = 0; o <= e; o++){
                    var c = t[2 * o + 1];
                    0 !== c && (t[2 * o] = M(i[c]++, c));
                }
            }
            function I(t) {
                var e;
                for(e = 0; e < 286; e++)t.dyn_ltree[2 * e] = 0;
                for(e = 0; e < 30; e++)t.dyn_dtree[2 * e] = 0;
                for(e = 0; e < 19; e++)t.bl_tree[2 * e] = 0;
                t.dyn_ltree[512] = 1, t.opt_len = t.static_len = 0, t.last_lit = t.matches = 0;
            }
            function D(t) {
                t.bi_valid > 8 ? _(t, t.bi_buf) : t.bi_valid > 0 && (t.pending_buf[t.pending++] = t.bi_buf), t.bi_buf = 0, t.bi_valid = 0;
            }
            function E(t, e, r, n) {
                var o = 2 * e, i = 2 * r;
                return t[o] < t[i] || t[o] === t[i] && n[e] <= n[r];
            }
            function A(t, e, r) {
                for(var n = t.heap[r], o = r << 1; o <= t.heap_len && (o < t.heap_len && E(e, t.heap[o + 1], t.heap[o], t.depth) && o++, !E(e, n, t.heap[o], t.depth));)t.heap[r] = t.heap[o], r = o, o <<= 1;
                t.heap[r] = n;
            }
            function C(t, e, r) {
                var n, o, c, u, s = 0;
                if (0 !== t.last_lit) do n = t.pending_buf[t.d_buf + 2 * s] << 8 | t.pending_buf[t.d_buf + 2 * s + 1], o = t.pending_buf[t.l_buf + s], s++, 0 === n ? S(t, o, e) : (S(t, (c = h[o]) + 256 + 1, e), 0 !== (u = i[c]) && w(t, o -= d[c], u), S(t, c = y(--n), r), 0 !== (u = a[c]) && w(t, n -= g[c], u));
                while (s < t.last_lit);
                S(t, 256, e);
            }
            function z(t, e) {
                var r, n, o, i = e.dyn_tree, a = e.stat_desc.static_tree, c = e.stat_desc.has_stree, u = e.stat_desc.elems, s = -1;
                for(t.heap_len = 0, t.heap_max = 573, r = 0; r < u; r++)0 !== i[2 * r] ? (t.heap[++t.heap_len] = s = r, t.depth[r] = 0) : i[2 * r + 1] = 0;
                for(; t.heap_len < 2;)i[2 * (o = t.heap[++t.heap_len] = s < 2 ? ++s : 0)] = 1, t.depth[o] = 0, t.opt_len--, c && (t.static_len -= a[2 * o + 1]);
                for(e.max_code = s, r = t.heap_len >> 1; r >= 1; r--)A(t, i, r);
                o = u;
                do r = t.heap[1], t.heap[1] = t.heap[t.heap_len--], A(t, i, 1), n = t.heap[1], t.heap[--t.heap_max] = r, t.heap[--t.heap_max] = n, i[2 * o] = i[2 * r] + i[2 * n], t.depth[o] = (t.depth[r] >= t.depth[n] ? t.depth[r] : t.depth[n]) + 1, i[2 * r + 1] = i[2 * n + 1] = o, t.heap[1] = o++, A(t, i, 1);
                while (t.heap_len >= 2);
                t.heap[--t.heap_max] = t.heap[1], function(t, e) {
                    var r, n, o, i, a, c, u = e.dyn_tree, s = e.max_code, l = e.stat_desc.static_tree, f = e.stat_desc.has_stree, h = e.stat_desc.extra_bits, d = e.stat_desc.extra_base, p = e.stat_desc.max_length, v = 0;
                    for(i = 0; i <= 15; i++)t.bl_count[i] = 0;
                    for(u[2 * t.heap[t.heap_max] + 1] = 0, r = t.heap_max + 1; r < 573; r++)(i = u[2 * u[2 * (n = t.heap[r]) + 1] + 1] + 1) > p && (i = p, v++), u[2 * n + 1] = i, n > s || (t.bl_count[i]++, a = 0, n >= d && (a = h[n - d]), c = u[2 * n], t.opt_len += c * (i + a), f && (t.static_len += c * (l[2 * n + 1] + a)));
                    if (0 !== v) {
                        do {
                            for(i = p - 1; 0 === t.bl_count[i];)i--;
                            t.bl_count[i]--, t.bl_count[i + 1] += 2, t.bl_count[p]--, v -= 2;
                        }while (v > 0);
                        for(i = p; 0 !== i; i--)for(n = t.bl_count[i]; 0 !== n;)(o = t.heap[--r]) > s || (u[2 * o + 1] !== i && (t.opt_len += (i - u[2 * o + 1]) * u[2 * o], u[2 * o + 1] = i), n--);
                    }
                }(t, e), T(i, s, t.bl_count);
            }
            function O(t, e, r) {
                var n, o, i = -1, a = e[1], c = 0, u = 7, s = 4;
                for(0 === a && (u = 138, s = 3), e[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)o = a, a = e[2 * (n + 1) + 1], ++c < u && o === a || (c < s ? t.bl_tree[2 * o] += c : 0 !== o ? (o !== i && t.bl_tree[2 * o]++, t.bl_tree[32]++) : c <= 10 ? t.bl_tree[34]++ : t.bl_tree[36]++, c = 0, i = o, 0 === a ? (u = 138, s = 3) : o === a ? (u = 6, s = 3) : (u = 7, s = 4));
            }
            function F(t, e, r) {
                var n, o, i = -1, a = e[1], c = 0, u = 7, s = 4;
                for(0 === a && (u = 138, s = 3), n = 0; n <= r; n++)if (o = a, a = e[2 * (n + 1) + 1], !(++c < u && o === a)) {
                    if (c < s) do S(t, o, t.bl_tree);
                    while (0 != --c);
                    else 0 !== o ? (o !== i && (S(t, o, t.bl_tree), c--), S(t, 16, t.bl_tree), w(t, c - 3, 2)) : c <= 10 ? (S(t, 17, t.bl_tree), w(t, c - 3, 3)) : (S(t, 18, t.bl_tree), w(t, c - 11, 7));
                    c = 0, i = o, 0 === a ? (u = 138, s = 3) : o === a ? (u = 6, s = 3) : (u = 7, s = 4);
                }
            }
            o(g);
            var R = !1;
            function P(t, e, r, o) {
                w(t, 0 + (o ? 1 : 0), 3), function(t, e, r, o) {
                    D(t), o && (_(t, r), _(t, ~r)), n.arraySet(t.pending_buf, t.window, e, r, t.pending), t.pending += r;
                }(t, e, r, !0);
            }
            e._tr_init = function(t) {
                R || (!function() {
                    var t, e, r, n, o, u = new Array(16);
                    for(r = 0, n = 0; n < 28; n++)for(d[n] = r, t = 0; t < 1 << i[n]; t++)h[r++] = n;
                    for(h[r - 1] = n, o = 0, n = 0; n < 16; n++)for(g[n] = o, t = 0; t < 1 << a[n]; t++)f[o++] = n;
                    for(o >>= 7; n < 30; n++)for(g[n] = o << 7, t = 0; t < 1 << a[n] - 7; t++)f[256 + o++] = n;
                    for(e = 0; e <= 15; e++)u[e] = 0;
                    for(t = 0; t <= 143;)s[2 * t + 1] = 8, t++, u[8]++;
                    for(; t <= 255;)s[2 * t + 1] = 9, t++, u[9]++;
                    for(; t <= 279;)s[2 * t + 1] = 7, t++, u[7]++;
                    for(; t <= 287;)s[2 * t + 1] = 8, t++, u[8]++;
                    for(T(s, 287, u), t = 0; t < 30; t++)l[2 * t + 1] = 5, l[2 * t] = M(t, 5);
                    p = new b(s, i, 257, 286, 15), v = new b(l, a, 0, 30, 15), m = new b(new Array(0), c, 0, 19, 7);
                }(), R = !0), t.l_desc = new x(t.dyn_ltree, p), t.d_desc = new x(t.dyn_dtree, v), t.bl_desc = new x(t.bl_tree, m), t.bi_buf = 0, t.bi_valid = 0, I(t);
            }, e._tr_stored_block = P, e._tr_flush_block = function(t, e, r, n) {
                var o, i, a = 0;
                t.level > 0 ? (2 === t.strm.data_type && (t.strm.data_type = function(t) {
                    var e, r = 4093624447;
                    for(e = 0; e <= 31; e++, r >>>= 1)if (1 & r && 0 !== t.dyn_ltree[2 * e]) return 0;
                    if (0 !== t.dyn_ltree[18] || 0 !== t.dyn_ltree[20] || 0 !== t.dyn_ltree[26]) return 1;
                    for(e = 32; e < 256; e++)if (0 !== t.dyn_ltree[2 * e]) return 1;
                    return 0;
                }(t)), z(t, t.l_desc), z(t, t.d_desc), a = function(t) {
                    var e;
                    for(O(t, t.dyn_ltree, t.l_desc.max_code), O(t, t.dyn_dtree, t.d_desc.max_code), z(t, t.bl_desc), e = 18; e >= 3 && 0 === t.bl_tree[2 * u[e] + 1]; e--);
                    return t.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
                }(t), o = t.opt_len + 3 + 7 >>> 3, (i = t.static_len + 3 + 7 >>> 3) <= o && (o = i)) : o = i = r + 5, r + 4 <= o && -1 !== e ? P(t, e, r, n) : 4 === t.strategy || i === o ? (w(t, 2 + (n ? 1 : 0), 3), C(t, s, l)) : (w(t, 4 + (n ? 1 : 0), 3), function(t, e, r, n) {
                    var o;
                    for(w(t, e - 257, 5), w(t, r - 1, 5), w(t, n - 4, 4), o = 0; o < n; o++)w(t, t.bl_tree[2 * u[o] + 1], 3);
                    F(t, t.dyn_ltree, e - 1), F(t, t.dyn_dtree, r - 1);
                }(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, a + 1), C(t, t.dyn_ltree, t.dyn_dtree)), I(t), n && D(t);
            }, e._tr_tally = function(t, e, r) {
                return t.pending_buf[t.d_buf + 2 * t.last_lit] = e >>> 8 & 255, t.pending_buf[t.d_buf + 2 * t.last_lit + 1] = 255 & e, t.pending_buf[t.l_buf + t.last_lit] = 255 & r, t.last_lit++, 0 === e ? t.dyn_ltree[2 * r]++ : (t.matches++, e--, t.dyn_ltree[2 * (h[r] + 256 + 1)]++, t.dyn_dtree[2 * y(e)]++), t.last_lit === t.lit_bufsize - 1;
            }, e._tr_align = function(t) {
                w(t, 2, 3), S(t, 256, s), function(t) {
                    16 === t.bi_valid ? (_(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : t.bi_valid >= 8 && (t.pending_buf[t.pending++] = 255 & t.bi_buf, t.bi_buf >>= 8, t.bi_valid -= 8);
                }(t);
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function(t, e, r, n) {
                for(var o = 65535 & t | 0, i = t >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                    r -= a = r > 2e3 ? 2e3 : r;
                    do i = i + (o = o + e[n++] | 0) | 0;
                    while (--a);
                    o %= 65521, i %= 65521;
                }
                return o | i << 16 | 0;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = function() {
                for(var t, e = [], r = 0; r < 256; r++){
                    t = r;
                    for(var n = 0; n < 8; n++)t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
                    e[r] = t;
                }
                return e;
            }();
            t.exports = function(t, e, r, o) {
                var i = n, a = o + r;
                t ^= -1;
                for(var c = o; c < a; c++)t = t >>> 8 ^ i[255 & (t ^ e[c])];
                return -1 ^ t;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(80), o = !0, i = !0;
            try {
                String.fromCharCode.apply(null, [
                    0
                ]);
            } catch (t) {
                o = !1;
            }
            try {
                String.fromCharCode.apply(null, new Uint8Array(1));
            } catch (t) {
                i = !1;
            }
            for(var a = new n.Buf8(256), c = 0; c < 256; c++)a[c] = c >= 252 ? 6 : c >= 248 ? 5 : c >= 240 ? 4 : c >= 224 ? 3 : c >= 192 ? 2 : 1;
            function u(t, e) {
                if (e < 65534 && (t.subarray && i || !t.subarray && o)) return String.fromCharCode.apply(null, n.shrinkBuf(t, e));
                for(var r = "", a = 0; a < e; a++)r += String.fromCharCode(t[a]);
                return r;
            }
            a[254] = a[254] = 1, e.string2buf = function(t) {
                var e, r, o, i, a, c = t.length, u = 0;
                for(i = 0; i < c; i++)55296 == (64512 & (r = t.charCodeAt(i))) && i + 1 < c && 56320 == (64512 & (o = t.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (o - 56320), i++), u += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                for(e = new n.Buf8(u), a = 0, i = 0; a < u; i++)55296 == (64512 & (r = t.charCodeAt(i))) && i + 1 < c && 56320 == (64512 & (o = t.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (o - 56320), i++), r < 128 ? e[a++] = r : r < 2048 ? (e[a++] = 192 | r >>> 6, e[a++] = 128 | 63 & r) : r < 65536 ? (e[a++] = 224 | r >>> 12, e[a++] = 128 | r >>> 6 & 63, e[a++] = 128 | 63 & r) : (e[a++] = 240 | r >>> 18, e[a++] = 128 | r >>> 12 & 63, e[a++] = 128 | r >>> 6 & 63, e[a++] = 128 | 63 & r);
                return e;
            }, e.buf2binstring = function(t) {
                return u(t, t.length);
            }, e.binstring2buf = function(t) {
                for(var e = new n.Buf8(t.length), r = 0, o = e.length; r < o; r++)e[r] = t.charCodeAt(r);
                return e;
            }, e.buf2string = function(t, e) {
                var r, n, o, i, c = e || t.length, s = new Array(2 * c);
                for(n = 0, r = 0; r < c;)if ((o = t[r++]) < 128) s[n++] = o;
                else if ((i = a[o]) > 4) s[n++] = 65533, r += i - 1;
                else {
                    for(o &= 2 === i ? 31 : 3 === i ? 15 : 7; i > 1 && r < c;)o = o << 6 | 63 & t[r++], i--;
                    i > 1 ? s[n++] = 65533 : o < 65536 ? s[n++] = o : (o -= 65536, s[n++] = 55296 | o >> 10 & 1023, s[n++] = 56320 | 1023 & o);
                }
                return u(s, n);
            }, e.utf8border = function(t, e) {
                var r;
                for((e = e || t.length) > t.length && (e = t.length), r = e - 1; r >= 0 && 128 == (192 & t[r]);)r--;
                return r < 0 || 0 === r ? e : r + a[t[r]] > e ? r : e;
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = function() {
                this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
            };
        },
        function(t, e, r) {
            "use strict";
            r.r(e), r.d(e, "HistoryAction", function() {
                return Pn;
            }), r.d(e, "MaskMode", function() {
                return Ln;
            }), r.d(e, "PixelFormat", function() {
                return kn;
            });
            var n = {};
            r.r(n), r.d(n, "create", function() {
                return v;
            }), r.d(n, "fromMat4", function() {
                return m;
            }), r.d(n, "clone", function() {
                return g;
            }), r.d(n, "copy", function() {
                return b;
            }), r.d(n, "fromValues", function() {
                return x;
            }), r.d(n, "set", function() {
                return y;
            }), r.d(n, "identity", function() {
                return _;
            }), r.d(n, "transpose", function() {
                return w;
            }), r.d(n, "invert", function() {
                return S;
            }), r.d(n, "adjoint", function() {
                return M;
            }), r.d(n, "determinant", function() {
                return T;
            }), r.d(n, "multiply", function() {
                return I;
            }), r.d(n, "translate", function() {
                return D;
            }), r.d(n, "rotate", function() {
                return E;
            }), r.d(n, "scale", function() {
                return A;
            }), r.d(n, "fromTranslation", function() {
                return C;
            }), r.d(n, "fromRotation", function() {
                return z;
            }), r.d(n, "fromScaling", function() {
                return O;
            }), r.d(n, "fromMat2d", function() {
                return F;
            }), r.d(n, "fromQuat", function() {
                return R;
            }), r.d(n, "normalFromMat4", function() {
                return P;
            }), r.d(n, "projection", function() {
                return L;
            }), r.d(n, "str", function() {
                return k;
            }), r.d(n, "frob", function() {
                return j;
            }), r.d(n, "add", function() {
                return U;
            }), r.d(n, "subtract", function() {
                return B;
            }), r.d(n, "multiplyScalar", function() {
                return N;
            }), r.d(n, "multiplyScalarAndAdd", function() {
                return G;
            }), r.d(n, "exactEquals", function() {
                return V;
            }), r.d(n, "equals", function() {
                return q;
            }), r.d(n, "mul", function() {
                return Y;
            }), r.d(n, "sub", function() {
                return H;
            });
            var o = {};
            r.r(o), r.d(o, "create", function() {
                return W;
            }), r.d(o, "clone", function() {
                return X;
            }), r.d(o, "copy", function() {
                return K;
            }), r.d(o, "fromValues", function() {
                return Z;
            }), r.d(o, "set", function() {
                return J;
            }), r.d(o, "identity", function() {
                return $;
            }), r.d(o, "transpose", function() {
                return Q;
            }), r.d(o, "invert", function() {
                return tt;
            }), r.d(o, "adjoint", function() {
                return et;
            }), r.d(o, "determinant", function() {
                return rt;
            }), r.d(o, "multiply", function() {
                return nt;
            }), r.d(o, "translate", function() {
                return ot;
            }), r.d(o, "scale", function() {
                return it;
            }), r.d(o, "rotate", function() {
                return at;
            }), r.d(o, "rotateX", function() {
                return ct;
            }), r.d(o, "rotateY", function() {
                return ut;
            }), r.d(o, "rotateZ", function() {
                return st;
            }), r.d(o, "fromTranslation", function() {
                return lt;
            }), r.d(o, "fromScaling", function() {
                return ft;
            }), r.d(o, "fromRotation", function() {
                return ht;
            }), r.d(o, "fromXRotation", function() {
                return dt;
            }), r.d(o, "fromYRotation", function() {
                return pt;
            }), r.d(o, "fromZRotation", function() {
                return vt;
            }), r.d(o, "fromRotationTranslation", function() {
                return mt;
            }), r.d(o, "fromQuat2", function() {
                return gt;
            }), r.d(o, "getTranslation", function() {
                return bt;
            }), r.d(o, "getScaling", function() {
                return xt;
            }), r.d(o, "getRotation", function() {
                return yt;
            }), r.d(o, "fromRotationTranslationScale", function() {
                return _t;
            }), r.d(o, "fromRotationTranslationScaleOrigin", function() {
                return wt;
            }), r.d(o, "fromQuat", function() {
                return St;
            }), r.d(o, "frustum", function() {
                return Mt;
            }), r.d(o, "perspective", function() {
                return Tt;
            }), r.d(o, "perspectiveFromFieldOfView", function() {
                return It;
            }), r.d(o, "ortho", function() {
                return Dt;
            }), r.d(o, "lookAt", function() {
                return Et;
            }), r.d(o, "targetTo", function() {
                return At;
            }), r.d(o, "str", function() {
                return Ct;
            }), r.d(o, "frob", function() {
                return zt;
            }), r.d(o, "add", function() {
                return Ot;
            }), r.d(o, "subtract", function() {
                return Ft;
            }), r.d(o, "multiplyScalar", function() {
                return Rt;
            }), r.d(o, "multiplyScalarAndAdd", function() {
                return Pt;
            }), r.d(o, "exactEquals", function() {
                return Lt;
            }), r.d(o, "equals", function() {
                return kt;
            }), r.d(o, "mul", function() {
                return jt;
            }), r.d(o, "sub", function() {
                return Ut;
            });
            var i = {};
            r.r(i), r.d(i, "create", function() {
                return Bt;
            }), r.d(i, "clone", function() {
                return Nt;
            }), r.d(i, "fromValues", function() {
                return Gt;
            }), r.d(i, "copy", function() {
                return Vt;
            }), r.d(i, "set", function() {
                return qt;
            }), r.d(i, "add", function() {
                return Yt;
            }), r.d(i, "subtract", function() {
                return Ht;
            }), r.d(i, "multiply", function() {
                return Wt;
            }), r.d(i, "divide", function() {
                return Xt;
            }), r.d(i, "ceil", function() {
                return Kt;
            }), r.d(i, "floor", function() {
                return Zt;
            }), r.d(i, "min", function() {
                return Jt;
            }), r.d(i, "max", function() {
                return $t;
            }), r.d(i, "round", function() {
                return Qt;
            }), r.d(i, "scale", function() {
                return te;
            }), r.d(i, "scaleAndAdd", function() {
                return ee;
            }), r.d(i, "distance", function() {
                return re;
            }), r.d(i, "squaredDistance", function() {
                return ne;
            }), r.d(i, "length", function() {
                return oe;
            }), r.d(i, "squaredLength", function() {
                return ie;
            }), r.d(i, "negate", function() {
                return ae;
            }), r.d(i, "inverse", function() {
                return ce;
            }), r.d(i, "normalize", function() {
                return ue;
            }), r.d(i, "dot", function() {
                return se;
            }), r.d(i, "cross", function() {
                return le;
            }), r.d(i, "lerp", function() {
                return fe;
            }), r.d(i, "random", function() {
                return he;
            }), r.d(i, "transformMat2", function() {
                return de;
            }), r.d(i, "transformMat2d", function() {
                return pe;
            }), r.d(i, "transformMat3", function() {
                return ve;
            }), r.d(i, "transformMat4", function() {
                return me;
            }), r.d(i, "rotate", function() {
                return ge;
            }), r.d(i, "angle", function() {
                return be;
            }), r.d(i, "str", function() {
                return xe;
            }), r.d(i, "exactEquals", function() {
                return ye;
            }), r.d(i, "equals", function() {
                return _e;
            }), r.d(i, "len", function() {
                return Se;
            }), r.d(i, "sub", function() {
                return Me;
            }), r.d(i, "mul", function() {
                return Te;
            }), r.d(i, "div", function() {
                return Ie;
            }), r.d(i, "dist", function() {
                return De;
            }), r.d(i, "sqrDist", function() {
                return Ee;
            }), r.d(i, "sqrLen", function() {
                return Ae;
            }), r.d(i, "forEach", function() {
                return Ce;
            });
            var a = {};
            r.r(a), r.d(a, "create", function() {
                return ze;
            }), r.d(a, "clone", function() {
                return Oe;
            }), r.d(a, "length", function() {
                return Fe;
            }), r.d(a, "fromValues", function() {
                return Re;
            }), r.d(a, "copy", function() {
                return Pe;
            }), r.d(a, "set", function() {
                return Le;
            }), r.d(a, "add", function() {
                return ke;
            }), r.d(a, "subtract", function() {
                return je;
            }), r.d(a, "multiply", function() {
                return Ue;
            }), r.d(a, "divide", function() {
                return Be;
            }), r.d(a, "ceil", function() {
                return Ne;
            }), r.d(a, "floor", function() {
                return Ge;
            }), r.d(a, "min", function() {
                return Ve;
            }), r.d(a, "max", function() {
                return qe;
            }), r.d(a, "round", function() {
                return Ye;
            }), r.d(a, "scale", function() {
                return He;
            }), r.d(a, "scaleAndAdd", function() {
                return We;
            }), r.d(a, "distance", function() {
                return Xe;
            }), r.d(a, "squaredDistance", function() {
                return Ke;
            }), r.d(a, "squaredLength", function() {
                return Ze;
            }), r.d(a, "negate", function() {
                return Je;
            }), r.d(a, "inverse", function() {
                return $e;
            }), r.d(a, "normalize", function() {
                return Qe;
            }), r.d(a, "dot", function() {
                return tr;
            }), r.d(a, "cross", function() {
                return er;
            }), r.d(a, "lerp", function() {
                return rr;
            }), r.d(a, "hermite", function() {
                return nr;
            }), r.d(a, "bezier", function() {
                return or;
            }), r.d(a, "random", function() {
                return ir;
            }), r.d(a, "transformMat4", function() {
                return ar;
            }), r.d(a, "transformMat3", function() {
                return cr;
            }), r.d(a, "transformQuat", function() {
                return ur;
            }), r.d(a, "rotateX", function() {
                return sr;
            }), r.d(a, "rotateY", function() {
                return lr;
            }), r.d(a, "rotateZ", function() {
                return fr;
            }), r.d(a, "angle", function() {
                return hr;
            }), r.d(a, "str", function() {
                return dr;
            }), r.d(a, "exactEquals", function() {
                return pr;
            }), r.d(a, "equals", function() {
                return vr;
            }), r.d(a, "sub", function() {
                return mr;
            }), r.d(a, "mul", function() {
                return gr;
            }), r.d(a, "div", function() {
                return br;
            }), r.d(a, "dist", function() {
                return xr;
            }), r.d(a, "sqrDist", function() {
                return yr;
            }), r.d(a, "len", function() {
                return _r;
            }), r.d(a, "sqrLen", function() {
                return wr;
            }), r.d(a, "forEach", function() {
                return Sr;
            });
            var c = {};
            r.r(c), r.d(c, "HALF_PI", function() {
                return Hr;
            }), r.d(c, "TAU", function() {
                return Wr;
            }), r.d(c, "getSquareToQuad", function() {
                return Xr;
            }), r.d(c, "intersectLines", function() {
                return Kr;
            }), r.d(c, "intersectsPathLine", function() {
                return Zr;
            }), r.d(c, "intersectsPath", function() {
                return Jr;
            }), r.d(c, "distanceToLine", function() {
                return $r;
            }), r.d(c, "distanceToPath", function() {
                return Qr;
            }), r.d(c, "getCentroid", function() {
                return tn;
            }), r.d(c, "getCenter", function() {
                return en;
            }), r.d(c, "resize", function() {
                return rn;
            }), r.d(c, "rotateBounds", function() {
                return nn;
            }), r.d(c, "rotatePoint", function() {
                return on;
            }), r.d(c, "rotateVector", function() {
                return an;
            }), r.d(c, "rotateVectorRads", function() {
                return cn;
            }), r.d(c, "clamp", function() {
                return un;
            }), r.d(c, "lerp", function() {
                return sn;
            }), r.d(c, "lerpColor", function() {
                return ln;
            }), r.d(c, "toLinear", function() {
                return fn;
            }), r.d(c, "fromLinear", function() {
                return hn;
            }), r.d(c, "rgbToHsv", function() {
                return dn;
            }), r.d(c, "hsvToRgb", function() {
                return pn;
            }), r.d(c, "distance", function() {
                return vn;
            }), r.d(c, "gaussian", function() {
                return mn;
            }), r.d(c, "degrees", function() {
                return gn;
            }), r.d(c, "radians", function() {
                return bn;
            }), r.d(c, "theta", function() {
                return xn;
            }), r.d(c, "now", function() {
                return yn;
            }), r.d(c, "throttleAnimation", function() {
                return _n;
            }), r.d(c, "throttle", function() {
                return wn;
            }), r.d(c, "debounce", function() {
                return Sn;
            }), r.d(c, "shallowClone", function() {
                return Mn;
            }), r.d(c, "clone", function() {
                return Tn;
            }), r.d(c, "diff", function() {
                return In;
            }), r.d(c, "shallowEqual", function() {
                return Dn;
            }), r.d(c, "deepEqual", function() {
                return En;
            }), r.d(c, "getOrientationSettings", function() {
                return An;
            }), r.d(c, "animate", function() {
                return Cn;
            }), r.d(c, "mapValues", function() {
                return zn;
            }), r.d(c, "noop", function() {
                return On;
            }), r.d(c, "extractFileType", function() {
                return Fn;
            }), r.d(c, "get", function() {
                return Rn;
            });
            var u = {};
            r.r(u), r.d(u, "presets", function() {
                return Zc;
            }), r.d(u, "startPaint", function() {
                return Jc;
            }), r.d(u, "paint", function() {
                return $c;
            }), r.d(u, "endPaint", function() {
                return Qc;
            }), r.d(u, "setCursor", function() {
                return tu;
            }), r.d(u, "showCursor", function() {
                return eu;
            }), r.d(u, "hideCursor", function() {
                return ru;
            }), r.d(u, "showMask", function() {
                return nu;
            }), r.d(u, "hideMask", function() {
                return ou;
            });
            var s = {};
            r.r(s), r.d(s, "showGrid", function() {
                return fu;
            }), r.d(s, "hideGrid", function() {
                return hu;
            }), r.d(s, "distortionPoints", function() {
                return pu;
            }), r.d(s, "distortionQuad", function() {
                return vu;
            }), r.d(s, "distortionQuadInv", function() {
                return mu;
            }), r.d(s, "limitPoints", function() {
                return yu;
            }), r.d(s, "lookupPerspective", function() {
                return _u;
            }), r.d(s, "lookupDistortion", function() {
                return wu;
            }), r.d(s, "startDistortMesh", function() {
                return Au;
            }), r.d(s, "distortMesh", function() {
                return Cu;
            }), r.d(s, "endDistortMesh", function() {
                return zu;
            });
            var l = {};
            r.r(l), r.d(l, "monotonic", function() {
                return Fs;
            }), r.d(l, "cubic", function() {
                return Os;
            });
            var f = {};
            r.r(f), r.d(f, "setCursor", function() {
                return cl;
            }), r.d(f, "showCursor", function() {
                return ul;
            }), r.d(f, "hideCursor", function() {
                return sl;
            });
            var h = 1e-6, d = "undefined" != typeof Float32Array ? Float32Array : Array, p = Math.random;
            Math.PI;
            function v() {
                var t = new d(9);
                return d != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[5] = 0, t[6] = 0, t[7] = 0), t[0] = 1, t[4] = 1, t[8] = 1, t;
            }
            function m(t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[4], t[4] = e[5], t[5] = e[6], t[6] = e[8], t[7] = e[9], t[8] = e[10], t;
            }
            function g(t) {
                var e = new d(9);
                return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e;
            }
            function b(t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t;
            }
            function x(t, e, r, n, o, i, a, c, u) {
                var s = new d(9);
                return s[0] = t, s[1] = e, s[2] = r, s[3] = n, s[4] = o, s[5] = i, s[6] = a, s[7] = c, s[8] = u, s;
            }
            function y(t, e, r, n, o, i, a, c, u, s) {
                return t[0] = e, t[1] = r, t[2] = n, t[3] = o, t[4] = i, t[5] = a, t[6] = c, t[7] = u, t[8] = s, t;
            }
            function _(t) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 1, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
            }
            function w(t, e) {
                if (t === e) {
                    var r = e[1], n = e[2], o = e[5];
                    t[1] = e[3], t[2] = e[6], t[3] = r, t[5] = e[7], t[6] = n, t[7] = o;
                } else t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8];
                return t;
            }
            function S(t, e) {
                var r = e[0], n = e[1], o = e[2], i = e[3], a = e[4], c = e[5], u = e[6], s = e[7], l = e[8], f = l * a - c * s, h = -l * i + c * u, d = s * i - a * u, p = r * f + n * h + o * d;
                return p ? (p = 1 / p, t[0] = f * p, t[1] = (-l * n + o * s) * p, t[2] = (c * n - o * a) * p, t[3] = h * p, t[4] = (l * r - o * u) * p, t[5] = (-c * r + o * i) * p, t[6] = d * p, t[7] = (-s * r + n * u) * p, t[8] = (a * r - n * i) * p, t) : null;
            }
            function M(t, e) {
                var r = e[0], n = e[1], o = e[2], i = e[3], a = e[4], c = e[5], u = e[6], s = e[7], l = e[8];
                return t[0] = a * l - c * s, t[1] = o * s - n * l, t[2] = n * c - o * a, t[3] = c * u - i * l, t[4] = r * l - o * u, t[5] = o * i - r * c, t[6] = i * s - a * u, t[7] = n * u - r * s, t[8] = r * a - n * i, t;
            }
            function T(t) {
                var e = t[0], r = t[1], n = t[2], o = t[3], i = t[4], a = t[5], c = t[6], u = t[7], s = t[8];
                return e * (s * i - a * u) + r * (-s * o + a * c) + n * (u * o - i * c);
            }
            function I(t, e, r) {
                var n = e[0], o = e[1], i = e[2], a = e[3], c = e[4], u = e[5], s = e[6], l = e[7], f = e[8], h = r[0], d = r[1], p = r[2], v = r[3], m = r[4], g = r[5], b = r[6], x = r[7], y = r[8];
                return t[0] = h * n + d * a + p * s, t[1] = h * o + d * c + p * l, t[2] = h * i + d * u + p * f, t[3] = v * n + m * a + g * s, t[4] = v * o + m * c + g * l, t[5] = v * i + m * u + g * f, t[6] = b * n + x * a + y * s, t[7] = b * o + x * c + y * l, t[8] = b * i + x * u + y * f, t;
            }
            function D(t, e, r) {
                var n = e[0], o = e[1], i = e[2], a = e[3], c = e[4], u = e[5], s = e[6], l = e[7], f = e[8], h = r[0], d = r[1];
                return t[0] = n, t[1] = o, t[2] = i, t[3] = a, t[4] = c, t[5] = u, t[6] = h * n + d * a + s, t[7] = h * o + d * c + l, t[8] = h * i + d * u + f, t;
            }
            function E(t, e, r) {
                var n = e[0], o = e[1], i = e[2], a = e[3], c = e[4], u = e[5], s = e[6], l = e[7], f = e[8], h = Math.sin(r), d = Math.cos(r);
                return t[0] = d * n + h * a, t[1] = d * o + h * c, t[2] = d * i + h * u, t[3] = d * a - h * n, t[4] = d * c - h * o, t[5] = d * u - h * i, t[6] = s, t[7] = l, t[8] = f, t;
            }
            function A(t, e, r) {
                var n = r[0], o = r[1];
                return t[0] = n * e[0], t[1] = n * e[1], t[2] = n * e[2], t[3] = o * e[3], t[4] = o * e[4], t[5] = o * e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t;
            }
            function C(t, e) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 1, t[5] = 0, t[6] = e[0], t[7] = e[1], t[8] = 1, t;
            }
            function z(t, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t[0] = n, t[1] = r, t[2] = 0, t[3] = -r, t[4] = n, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
            }
            function O(t, e) {
                return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = e[1], t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
            }
            function F(t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = 0, t[3] = e[2], t[4] = e[3], t[5] = 0, t[6] = e[4], t[7] = e[5], t[8] = 1, t;
            }
            function R(t, e) {
                var r = e[0], n = e[1], o = e[2], i = e[3], a = r + r, c = n + n, u = o + o, s = r * a, l = n * a, f = n * c, h = o * a, d = o * c, p = o * u, v = i * a, m = i * c, g = i * u;
                return t[0] = 1 - f - p, t[3] = l - g, t[6] = h + m, t[1] = l + g, t[4] = 1 - s - p, t[7] = d - v, t[2] = h - m, t[5] = d + v, t[8] = 1 - s - f, t;
            }
            function P(t, e) {
                var r = e[0], n = e[1], o = e[2], i = e[3], a = e[4], c = e[5], u = e[6], s = e[7], l = e[8], f = e[9], h = e[10], d = e[11], p = e[12], v = e[13], m = e[14], g = e[15], b = r * c - n * a, x = r * u - o * a, y = r * s - i * a, _ = n * u - o * c, w = n * s - i * c, S = o * s - i * u, M = l * v - f * p, T = l * m - h * p, I = l * g - d * p, D = f * m - h * v, E = f * g - d * v, A = h * g - d * m, C = b * A - x * E + y * D + _ * I - w * T + S * M;
                return C ? (C = 1 / C, t[0] = (c * A - u * E + s * D) * C, t[1] = (u * I - a * A - s * T) * C, t[2] = (a * E - c * I + s * M) * C, t[3] = (o * E - n * A - i * D) * C, t[4] = (r * A - o * I + i * T) * C, t[5] = (n * I - r * E - i * M) * C, t[6] = (v * S - m * w + g * _) * C, t[7] = (m * y - p * S - g * x) * C, t[8] = (p * w - v * y + g * b) * C, t) : null;
            }
            function L(t, e, r) {
                return t[0] = 2 / e, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = -2 / r, t[5] = 0, t[6] = -1, t[7] = 1, t[8] = 1, t;
            }
            function k(t) {
                return "mat3(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ", " + t[4] + ", " + t[5] + ", " + t[6] + ", " + t[7] + ", " + t[8] + ")";
            }
            function j(t) {
                return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2) + Math.pow(t[2], 2) + Math.pow(t[3], 2) + Math.pow(t[4], 2) + Math.pow(t[5], 2) + Math.pow(t[6], 2) + Math.pow(t[7], 2) + Math.pow(t[8], 2));
            }
            function U(t, e, r) {
                return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t[3] = e[3] + r[3], t[4] = e[4] + r[4], t[5] = e[5] + r[5], t[6] = e[6] + r[6], t[7] = e[7] + r[7], t[8] = e[8] + r[8], t;
            }
            function B(t, e, r) {
                return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t[3] = e[3] - r[3], t[4] = e[4] - r[4], t[5] = e[5] - r[5], t[6] = e[6] - r[6], t[7] = e[7] - r[7], t[8] = e[8] - r[8], t;
            }
            function N(t, e, r) {
                return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t[4] = e[4] * r, t[5] = e[5] * r, t[6] = e[6] * r, t[7] = e[7] * r, t[8] = e[8] * r, t;
            }
            function G(t, e, r, n) {
                return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t[3] = e[3] + r[3] * n, t[4] = e[4] + r[4] * n, t[5] = e[5] + r[5] * n, t[6] = e[6] + r[6] * n, t[7] = e[7] + r[7] * n, t[8] = e[8] + r[8] * n, t;
            }
            function V(t, e) {
                return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5] && t[6] === e[6] && t[7] === e[7] && t[8] === e[8];
            }
            function q(t, e) {
                var r = t[0], n = t[1], o = t[2], i = t[3], a = t[4], c = t[5], u = t[6], s = t[7], l = t[8], f = e[0], d = e[1], p = e[2], v = e[3], m = e[4], g = e[5], b = e[6], x = e[7], y = e[8];
                return Math.abs(r - f) <= h * Math.max(1, Math.abs(r), Math.abs(f)) && Math.abs(n - d) <= h * Math.max(1, Math.abs(n), Math.abs(d)) && Math.abs(o - p) <= h * Math.max(1, Math.abs(o), Math.abs(p)) && Math.abs(i - v) <= h * Math.max(1, Math.abs(i), Math.abs(v)) && Math.abs(a - m) <= h * Math.max(1, Math.abs(a), Math.abs(m)) && Math.abs(c - g) <= h * Math.max(1, Math.abs(c), Math.abs(g)) && Math.abs(u - b) <= h * Math.max(1, Math.abs(u), Math.abs(b)) && Math.abs(s - x) <= h * Math.max(1, Math.abs(s), Math.abs(x)) && Math.abs(l - y) <= h * Math.max(1, Math.abs(l), Math.abs(y));
            }
            var Y = I, H = B;
            function W() {
                var t = new d(16);
                return d != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0), t[0] = 1, t[5] = 1, t[10] = 1, t[15] = 1, t;
            }
            function X(t) {
                var e = new d(16);
                return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
            }
            function K(t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
            }
            function Z(t, e, r, n, o, i, a, c, u, s, l, f, h, p, v, m) {
                var g = new d(16);
                return g[0] = t, g[1] = e, g[2] = r, g[3] = n, g[4] = o, g[5] = i, g[6] = a, g[7] = c, g[8] = u, g[9] = s, g[10] = l, g[11] = f, g[12] = h, g[13] = p, g[14] = v, g[15] = m, g;
            }
            function J(t, e, r, n, o, i, a, c, u, s, l, f, h, d, p, v, m) {
                return t[0] = e, t[1] = r, t[2] = n, t[3] = o, t[4] = i, t[5] = a, t[6] = c, t[7] = u, t[8] = s, t[9] = l, t[10] = f, t[11] = h, t[12] = d, t[13] = p, t[14] = v, t[15] = m, t;
            }
            function $(t) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
            }
            function Q(t, e) {
                if (t === e) {
                    var r = e[1], n = e[2], o = e[3], i = e[6], a = e[7], c = e[11];
                    t[1] = e[4], t[2] = e[8], t[3] = e[12], t[4] = r, t[6] = e[9], t[7] = e[13], t[8] = n, t[9] = i, t[11] = e[14], t[12] = o, t[13] = a, t[14] = c;
                } else t[0] = e[0], t[1] = e[4], t[2] = e[8], t[3] = e[12], t[4] = e[1], t[5] = e[5], t[6] = e[9], t[7] = e[13], t[8] = e[2], t[9] = e[6], t[10] = e[10], t[11] = e[14], t[12] = e[3], t[13] = e[7], t[14] = e[11], t[15] = e[15];
                return t;
            }
            function tt(t, e) {
                var r = e[0], n = e[1], o = e[2], i = e[3], a = e[4], c = e[5], u = e[6], s = e[7], l = e[8], f = e[9], h = e[10], d = e[11], p = e[12], v = e[13], m = e[14], g = e[15], b = r * c - n * a, x = r * u - o * a, y = r * s - i * a, _ = n * u - o * c, w = n * s - i * c, S = o * s - i * u, M = l * v - f * p, T = l * m - h * p, I = l * g - d * p, D = f * m - h * v, E = f * g - d * v, A = h * g - d * m, C = b * A - x * E + y * D + _ * I - w * T + S * M;
                return C ? (C = 1 / C, t[0] = (c * A - u * E + s * D) * C, t[1] = (o * E - n * A - i * D) * C, t[2] = (v * S - m * w + g * _) * C, t[3] = (h * w - f * S - d * _) * C, t[4] = (u * I - a * A - s * T) * C, t[5] = (r * A - o * I + i * T) * C, t[6] = (m * y - p * S - g * x) * C, t[7] = (l * S - h * y + d * x) * C, t[8] = (a * E - c * I + s * M) * C, t[9] = (n * I - r * E - i * M) * C, t[10] = (p * w - v * y + g * b) * C, t[11] = (f * y - l * w - d * b) * C, t[12] = (c * T - a * D - u * M) * C, t[13] = (r * D - n * T + o * M) * C, t[14] = (v * x - p * _ - m * b) * C, t[15] = (l * _ - f * x + h * b) * C, t) : null;
            }
            function et(t, e) {
                var r = e[0], n = e[1], o = e[2], i = e[3], a = e[4], c = e[5], u = e[6], s = e[7], l = e[8], f = e[9], h = e[10], d = e[11], p = e[12], v = e[13], m = e[14], g = e[15];
                return t[0] = c * (h * g - d * m) - f * (u * g - s * m) + v * (u * d - s * h), t[1] = -(n * (h * g - d * m) - f * (o * g - i * m) + v * (o * d - i * h)), t[2] = n * (u * g - s * m) - c * (o * g - i * m) + v * (o * s - i * u), t[3] = -(n * (u * d - s * h) - c * (o * d - i * h) + f * (o * s - i * u)), t[4] = -(a * (h * g - d * m) - l * (u * g - s * m) + p * (u * d - s * h)), t[5] = r * (h * g - d * m) - l * (o * g - i * m) + p * (o * d - i * h), t[6] = -(r * (u * g - s * m) - a * (o * g - i * m) + p * (o * s - i * u)), t[7] = r * (u * d - s * h) - a * (o * d - i * h) + l * (o * s - i * u), t[8] = a * (f * g - d * v) - l * (c * g - s * v) + p * (c * d - s * f), t[9] = -(r * (f * g - d * v) - l * (n * g - i * v) + p * (n * d - i * f)), t[10] = r * (c * g - s * v) - a * (n * g - i * v) + p * (n * s - i * c), t[11] = -(r * (c * d - s * f) - a * (n * d - i * f) + l * (n * s - i * c)), t[12] = -(a * (f * m - h * v) - l * (c * m - u * v) + p * (c * h - u * f)), t[13] = r * (f * m - h * v) - l * (n * m - o * v) + p * (n * h - o * f), t[14] = -(r * (c * m - u * v) - a * (n * m - o * v) + p * (n * u - o * c)), t[15] = r * (c * h - u * f) - a * (n * h - o * f) + l * (n * u - o * c), t;
            }
            function rt(t) {
                var e = t[0], r = t[1], n = t[2], o = t[3], i = t[4], a = t[5], c = t[6], u = t[7], s = t[8], l = t[9], f = t[10], h = t[11], d = t[12], p = t[13], v = t[14], m = t[15];
                return (e * a - r * i) * (f * m - h * v) - (e * c - n * i) * (l * m - h * p) + (e * u - o * i) * (l * v - f * p) + (r * c - n * a) * (s * m - h * d) - (r * u - o * a) * (s * v - f * d) + (n * u - o * c) * (s * p - l * d);
            }
            function nt(t, e, r) {
                var n = e[0], o = e[1], i = e[2], a = e[3], c = e[4], u = e[5], s = e[6], l = e[7], f = e[8], h = e[9], d = e[10], p = e[11], v = e[12], m = e[13], g = e[14], b = e[15], x = r[0], y = r[1], _ = r[2], w = r[3];
                return t[0] = x * n + y * c + _ * f + w * v, t[1] = x * o + y * u + _ * h + w * m, t[2] = x * i + y * s + _ * d + w * g, t[3] = x * a + y * l + _ * p + w * b, x = r[4], y = r[5], _ = r[6], w = r[7], t[4] = x * n + y * c + _ * f + w * v, t[5] = x * o + y * u + _ * h + w * m, t[6] = x * i + y * s + _ * d + w * g, t[7] = x * a + y * l + _ * p + w * b, x = r[8], y = r[9], _ = r[10], w = r[11], t[8] = x * n + y * c + _ * f + w * v, t[9] = x * o + y * u + _ * h + w * m, t[10] = x * i + y * s + _ * d + w * g, t[11] = x * a + y * l + _ * p + w * b, x = r[12], y = r[13], _ = r[14], w = r[15], t[12] = x * n + y * c + _ * f + w * v, t[13] = x * o + y * u + _ * h + w * m, t[14] = x * i + y * s + _ * d + w * g, t[15] = x * a + y * l + _ * p + w * b, t;
            }
            function ot(t, e, r) {
                var n = r[0], o = r[1], i = r[2], a = void 0, c = void 0, u = void 0, s = void 0, l = void 0, f = void 0, h = void 0, d = void 0, p = void 0, v = void 0, m = void 0, g = void 0;
                return e === t ? (t[12] = e[0] * n + e[4] * o + e[8] * i + e[12], t[13] = e[1] * n + e[5] * o + e[9] * i + e[13], t[14] = e[2] * n + e[6] * o + e[10] * i + e[14], t[15] = e[3] * n + e[7] * o + e[11] * i + e[15]) : (a = e[0], c = e[1], u = e[2], s = e[3], l = e[4], f = e[5], h = e[6], d = e[7], p = e[8], v = e[9], m = e[10], g = e[11], t[0] = a, t[1] = c, t[2] = u, t[3] = s, t[4] = l, t[5] = f, t[6] = h, t[7] = d, t[8] = p, t[9] = v, t[10] = m, t[11] = g, t[12] = a * n + l * o + p * i + e[12], t[13] = c * n + f * o + v * i + e[13], t[14] = u * n + h * o + m * i + e[14], t[15] = s * n + d * o + g * i + e[15]), t;
            }
            function it(t, e, r) {
                var n = r[0], o = r[1], i = r[2];
                return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t[3] = e[3] * n, t[4] = e[4] * o, t[5] = e[5] * o, t[6] = e[6] * o, t[7] = e[7] * o, t[8] = e[8] * i, t[9] = e[9] * i, t[10] = e[10] * i, t[11] = e[11] * i, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
            }
            function at(t, e, r, n) {
                var o, i, a, c, u, s, l, f, d, p, v, m, g, b, x, y, _, w, S, M, T, I, D, E, A = n[0], C = n[1], z = n[2], O = Math.sqrt(A * A + C * C + z * z);
                return O < h ? null : (A *= O = 1 / O, C *= O, z *= O, o = Math.sin(r), a = 1 - (i = Math.cos(r)), c = e[0], u = e[1], s = e[2], l = e[3], f = e[4], d = e[5], p = e[6], v = e[7], m = e[8], g = e[9], b = e[10], x = e[11], y = A * A * a + i, _ = C * A * a + z * o, w = z * A * a - C * o, S = A * C * a - z * o, M = C * C * a + i, T = z * C * a + A * o, I = A * z * a + C * o, D = C * z * a - A * o, E = z * z * a + i, t[0] = c * y + f * _ + m * w, t[1] = u * y + d * _ + g * w, t[2] = s * y + p * _ + b * w, t[3] = l * y + v * _ + x * w, t[4] = c * S + f * M + m * T, t[5] = u * S + d * M + g * T, t[6] = s * S + p * M + b * T, t[7] = l * S + v * M + x * T, t[8] = c * I + f * D + m * E, t[9] = u * I + d * D + g * E, t[10] = s * I + p * D + b * E, t[11] = l * I + v * D + x * E, e !== t && (t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t);
            }
            function ct(t, e, r) {
                var n = Math.sin(r), o = Math.cos(r), i = e[4], a = e[5], c = e[6], u = e[7], s = e[8], l = e[9], f = e[10], h = e[11];
                return e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[4] = i * o + s * n, t[5] = a * o + l * n, t[6] = c * o + f * n, t[7] = u * o + h * n, t[8] = s * o - i * n, t[9] = l * o - a * n, t[10] = f * o - c * n, t[11] = h * o - u * n, t;
            }
            function ut(t, e, r) {
                var n = Math.sin(r), o = Math.cos(r), i = e[0], a = e[1], c = e[2], u = e[3], s = e[8], l = e[9], f = e[10], h = e[11];
                return e !== t && (t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = i * o - s * n, t[1] = a * o - l * n, t[2] = c * o - f * n, t[3] = u * o - h * n, t[8] = i * n + s * o, t[9] = a * n + l * o, t[10] = c * n + f * o, t[11] = u * n + h * o, t;
            }
            function st(t, e, r) {
                var n = Math.sin(r), o = Math.cos(r), i = e[0], a = e[1], c = e[2], u = e[3], s = e[4], l = e[5], f = e[6], h = e[7];
                return e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = i * o + s * n, t[1] = a * o + l * n, t[2] = c * o + f * n, t[3] = u * o + h * n, t[4] = s * o - i * n, t[5] = l * o - a * n, t[6] = f * o - c * n, t[7] = h * o - u * n, t;
            }
            function lt(t, e) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = e[0], t[13] = e[1], t[14] = e[2], t[15] = 1, t;
            }
            function ft(t, e) {
                return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
            }
            function ht(t, e, r) {
                var n, o, i, a = r[0], c = r[1], u = r[2], s = Math.sqrt(a * a + c * c + u * u);
                return s < h ? null : (a *= s = 1 / s, c *= s, u *= s, n = Math.sin(e), i = 1 - (o = Math.cos(e)), t[0] = a * a * i + o, t[1] = c * a * i + u * n, t[2] = u * a * i - c * n, t[3] = 0, t[4] = a * c * i - u * n, t[5] = c * c * i + o, t[6] = u * c * i + a * n, t[7] = 0, t[8] = a * u * i + c * n, t[9] = c * u * i - a * n, t[10] = u * u * i + o, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t);
            }
            function dt(t, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = n, t[6] = r, t[7] = 0, t[8] = 0, t[9] = -r, t[10] = n, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
            }
            function pt(t, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t[0] = n, t[1] = 0, t[2] = -r, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = r, t[9] = 0, t[10] = n, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
            }
            function vt(t, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t[0] = n, t[1] = r, t[2] = 0, t[3] = 0, t[4] = -r, t[5] = n, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
            }
            function mt(t, e, r) {
                var n = e[0], o = e[1], i = e[2], a = e[3], c = n + n, u = o + o, s = i + i, l = n * c, f = n * u, h = n * s, d = o * u, p = o * s, v = i * s, m = a * c, g = a * u, b = a * s;
                return t[0] = 1 - (d + v), t[1] = f + b, t[2] = h - g, t[3] = 0, t[4] = f - b, t[5] = 1 - (l + v), t[6] = p + m, t[7] = 0, t[8] = h + g, t[9] = p - m, t[10] = 1 - (l + d), t[11] = 0, t[12] = r[0], t[13] = r[1], t[14] = r[2], t[15] = 1, t;
            }
            function gt(t, e) {
                var r = new d(3), n = -e[0], o = -e[1], i = -e[2], a = e[3], c = e[4], u = e[5], s = e[6], l = e[7], f = n * n + o * o + i * i + a * a;
                return f > 0 ? (r[0] = 2 * (c * a + l * n + u * i - s * o) / f, r[1] = 2 * (u * a + l * o + s * n - c * i) / f, r[2] = 2 * (s * a + l * i + c * o - u * n) / f) : (r[0] = 2 * (c * a + l * n + u * i - s * o), r[1] = 2 * (u * a + l * o + s * n - c * i), r[2] = 2 * (s * a + l * i + c * o - u * n)), mt(t, e, r), t;
            }
            function bt(t, e) {
                return t[0] = e[12], t[1] = e[13], t[2] = e[14], t;
            }
            function xt(t, e) {
                var r = e[0], n = e[1], o = e[2], i = e[4], a = e[5], c = e[6], u = e[8], s = e[9], l = e[10];
                return t[0] = Math.sqrt(r * r + n * n + o * o), t[1] = Math.sqrt(i * i + a * a + c * c), t[2] = Math.sqrt(u * u + s * s + l * l), t;
            }
            function yt(t, e) {
                var r = e[0] + e[5] + e[10], n = 0;
                return r > 0 ? (n = 2 * Math.sqrt(r + 1), t[3] = .25 * n, t[0] = (e[6] - e[9]) / n, t[1] = (e[8] - e[2]) / n, t[2] = (e[1] - e[4]) / n) : e[0] > e[5] && e[0] > e[10] ? (n = 2 * Math.sqrt(1 + e[0] - e[5] - e[10]), t[3] = (e[6] - e[9]) / n, t[0] = .25 * n, t[1] = (e[1] + e[4]) / n, t[2] = (e[8] + e[2]) / n) : e[5] > e[10] ? (n = 2 * Math.sqrt(1 + e[5] - e[0] - e[10]), t[3] = (e[8] - e[2]) / n, t[0] = (e[1] + e[4]) / n, t[1] = .25 * n, t[2] = (e[6] + e[9]) / n) : (n = 2 * Math.sqrt(1 + e[10] - e[0] - e[5]), t[3] = (e[1] - e[4]) / n, t[0] = (e[8] + e[2]) / n, t[1] = (e[6] + e[9]) / n, t[2] = .25 * n), t;
            }
            function _t(t, e, r, n) {
                var o = e[0], i = e[1], a = e[2], c = e[3], u = o + o, s = i + i, l = a + a, f = o * u, h = o * s, d = o * l, p = i * s, v = i * l, m = a * l, g = c * u, b = c * s, x = c * l, y = n[0], _ = n[1], w = n[2];
                return t[0] = (1 - (p + m)) * y, t[1] = (h + x) * y, t[2] = (d - b) * y, t[3] = 0, t[4] = (h - x) * _, t[5] = (1 - (f + m)) * _, t[6] = (v + g) * _, t[7] = 0, t[8] = (d + b) * w, t[9] = (v - g) * w, t[10] = (1 - (f + p)) * w, t[11] = 0, t[12] = r[0], t[13] = r[1], t[14] = r[2], t[15] = 1, t;
            }
            function wt(t, e, r, n, o) {
                var i = e[0], a = e[1], c = e[2], u = e[3], s = i + i, l = a + a, f = c + c, h = i * s, d = i * l, p = i * f, v = a * l, m = a * f, g = c * f, b = u * s, x = u * l, y = u * f, _ = n[0], w = n[1], S = n[2], M = o[0], T = o[1], I = o[2], D = (1 - (v + g)) * _, E = (d + y) * _, A = (p - x) * _, C = (d - y) * w, z = (1 - (h + g)) * w, O = (m + b) * w, F = (p + x) * S, R = (m - b) * S, P = (1 - (h + v)) * S;
                return t[0] = D, t[1] = E, t[2] = A, t[3] = 0, t[4] = C, t[5] = z, t[6] = O, t[7] = 0, t[8] = F, t[9] = R, t[10] = P, t[11] = 0, t[12] = r[0] + M - (D * M + C * T + F * I), t[13] = r[1] + T - (E * M + z * T + R * I), t[14] = r[2] + I - (A * M + O * T + P * I), t[15] = 1, t;
            }
            function St(t, e) {
                var r = e[0], n = e[1], o = e[2], i = e[3], a = r + r, c = n + n, u = o + o, s = r * a, l = n * a, f = n * c, h = o * a, d = o * c, p = o * u, v = i * a, m = i * c, g = i * u;
                return t[0] = 1 - f - p, t[1] = l + g, t[2] = h - m, t[3] = 0, t[4] = l - g, t[5] = 1 - s - p, t[6] = d + v, t[7] = 0, t[8] = h + m, t[9] = d - v, t[10] = 1 - s - f, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
            }
            function Mt(t, e, r, n, o, i, a) {
                var c = 1 / (r - e), u = 1 / (o - n), s = 1 / (i - a);
                return t[0] = 2 * i * c, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 2 * i * u, t[6] = 0, t[7] = 0, t[8] = (r + e) * c, t[9] = (o + n) * u, t[10] = (a + i) * s, t[11] = -1, t[12] = 0, t[13] = 0, t[14] = a * i * 2 * s, t[15] = 0, t;
            }
            function Tt(t, e, r, n, o) {
                var i = 1 / Math.tan(e / 2), a = void 0;
                return t[0] = i / r, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = i, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != o && o !== 1 / 0 ? (a = 1 / (n - o), t[10] = (o + n) * a, t[14] = 2 * o * n * a) : (t[10] = -1, t[14] = -2 * n), t;
            }
            function It(t, e, r, n) {
                var o = Math.tan(e.upDegrees * Math.PI / 180), i = Math.tan(e.downDegrees * Math.PI / 180), a = Math.tan(e.leftDegrees * Math.PI / 180), c = Math.tan(e.rightDegrees * Math.PI / 180), u = 2 / (a + c), s = 2 / (o + i);
                return t[0] = u, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = s, t[6] = 0, t[7] = 0, t[8] = -(a - c) * u * .5, t[9] = (o - i) * s * .5, t[10] = n / (r - n), t[11] = -1, t[12] = 0, t[13] = 0, t[14] = n * r / (r - n), t[15] = 0, t;
            }
            function Dt(t, e, r, n, o, i, a) {
                var c = 1 / (e - r), u = 1 / (n - o), s = 1 / (i - a);
                return t[0] = -2 * c, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * u, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * s, t[11] = 0, t[12] = (e + r) * c, t[13] = (o + n) * u, t[14] = (a + i) * s, t[15] = 1, t;
            }
            function Et(t, e, r, n) {
                var o = void 0, i = void 0, a = void 0, c = void 0, u = void 0, s = void 0, l = void 0, f = void 0, d = void 0, p = void 0, v = e[0], m = e[1], g = e[2], b = n[0], x = n[1], y = n[2], _ = r[0], w = r[1], S = r[2];
                return Math.abs(v - _) < h && Math.abs(m - w) < h && Math.abs(g - S) < h ? $(t) : (l = v - _, f = m - w, d = g - S, o = x * (d *= p = 1 / Math.sqrt(l * l + f * f + d * d)) - y * (f *= p), i = y * (l *= p) - b * d, a = b * f - x * l, (p = Math.sqrt(o * o + i * i + a * a)) ? (o *= p = 1 / p, i *= p, a *= p) : (o = 0, i = 0, a = 0), c = f * a - d * i, u = d * o - l * a, s = l * i - f * o, (p = Math.sqrt(c * c + u * u + s * s)) ? (c *= p = 1 / p, u *= p, s *= p) : (c = 0, u = 0, s = 0), t[0] = o, t[1] = c, t[2] = l, t[3] = 0, t[4] = i, t[5] = u, t[6] = f, t[7] = 0, t[8] = a, t[9] = s, t[10] = d, t[11] = 0, t[12] = -(o * v + i * m + a * g), t[13] = -(c * v + u * m + s * g), t[14] = -(l * v + f * m + d * g), t[15] = 1, t);
            }
            function At(t, e, r, n) {
                var o = e[0], i = e[1], a = e[2], c = n[0], u = n[1], s = n[2], l = o - r[0], f = i - r[1], h = a - r[2], d = l * l + f * f + h * h;
                d > 0 && (l *= d = 1 / Math.sqrt(d), f *= d, h *= d);
                var p = u * h - s * f, v = s * l - c * h, m = c * f - u * l;
                return (d = p * p + v * v + m * m) > 0 && (p *= d = 1 / Math.sqrt(d), v *= d, m *= d), t[0] = p, t[1] = v, t[2] = m, t[3] = 0, t[4] = f * m - h * v, t[5] = h * p - l * m, t[6] = l * v - f * p, t[7] = 0, t[8] = l, t[9] = f, t[10] = h, t[11] = 0, t[12] = o, t[13] = i, t[14] = a, t[15] = 1, t;
            }
            function Ct(t) {
                return "mat4(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ", " + t[4] + ", " + t[5] + ", " + t[6] + ", " + t[7] + ", " + t[8] + ", " + t[9] + ", " + t[10] + ", " + t[11] + ", " + t[12] + ", " + t[13] + ", " + t[14] + ", " + t[15] + ")";
            }
            function zt(t) {
                return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2) + Math.pow(t[2], 2) + Math.pow(t[3], 2) + Math.pow(t[4], 2) + Math.pow(t[5], 2) + Math.pow(t[6], 2) + Math.pow(t[7], 2) + Math.pow(t[8], 2) + Math.pow(t[9], 2) + Math.pow(t[10], 2) + Math.pow(t[11], 2) + Math.pow(t[12], 2) + Math.pow(t[13], 2) + Math.pow(t[14], 2) + Math.pow(t[15], 2));
            }
            function Ot(t, e, r) {
                return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t[3] = e[3] + r[3], t[4] = e[4] + r[4], t[5] = e[5] + r[5], t[6] = e[6] + r[6], t[7] = e[7] + r[7], t[8] = e[8] + r[8], t[9] = e[9] + r[9], t[10] = e[10] + r[10], t[11] = e[11] + r[11], t[12] = e[12] + r[12], t[13] = e[13] + r[13], t[14] = e[14] + r[14], t[15] = e[15] + r[15], t;
            }
            function Ft(t, e, r) {
                return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t[3] = e[3] - r[3], t[4] = e[4] - r[4], t[5] = e[5] - r[5], t[6] = e[6] - r[6], t[7] = e[7] - r[7], t[8] = e[8] - r[8], t[9] = e[9] - r[9], t[10] = e[10] - r[10], t[11] = e[11] - r[11], t[12] = e[12] - r[12], t[13] = e[13] - r[13], t[14] = e[14] - r[14], t[15] = e[15] - r[15], t;
            }
            function Rt(t, e, r) {
                return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t[4] = e[4] * r, t[5] = e[5] * r, t[6] = e[6] * r, t[7] = e[7] * r, t[8] = e[8] * r, t[9] = e[9] * r, t[10] = e[10] * r, t[11] = e[11] * r, t[12] = e[12] * r, t[13] = e[13] * r, t[14] = e[14] * r, t[15] = e[15] * r, t;
            }
            function Pt(t, e, r, n) {
                return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t[3] = e[3] + r[3] * n, t[4] = e[4] + r[4] * n, t[5] = e[5] + r[5] * n, t[6] = e[6] + r[6] * n, t[7] = e[7] + r[7] * n, t[8] = e[8] + r[8] * n, t[9] = e[9] + r[9] * n, t[10] = e[10] + r[10] * n, t[11] = e[11] + r[11] * n, t[12] = e[12] + r[12] * n, t[13] = e[13] + r[13] * n, t[14] = e[14] + r[14] * n, t[15] = e[15] + r[15] * n, t;
            }
            function Lt(t, e) {
                return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5] && t[6] === e[6] && t[7] === e[7] && t[8] === e[8] && t[9] === e[9] && t[10] === e[10] && t[11] === e[11] && t[12] === e[12] && t[13] === e[13] && t[14] === e[14] && t[15] === e[15];
            }
            function kt(t, e) {
                var r = t[0], n = t[1], o = t[2], i = t[3], a = t[4], c = t[5], u = t[6], s = t[7], l = t[8], f = t[9], d = t[10], p = t[11], v = t[12], m = t[13], g = t[14], b = t[15], x = e[0], y = e[1], _ = e[2], w = e[3], S = e[4], M = e[5], T = e[6], I = e[7], D = e[8], E = e[9], A = e[10], C = e[11], z = e[12], O = e[13], F = e[14], R = e[15];
                return Math.abs(r - x) <= h * Math.max(1, Math.abs(r), Math.abs(x)) && Math.abs(n - y) <= h * Math.max(1, Math.abs(n), Math.abs(y)) && Math.abs(o - _) <= h * Math.max(1, Math.abs(o), Math.abs(_)) && Math.abs(i - w) <= h * Math.max(1, Math.abs(i), Math.abs(w)) && Math.abs(a - S) <= h * Math.max(1, Math.abs(a), Math.abs(S)) && Math.abs(c - M) <= h * Math.max(1, Math.abs(c), Math.abs(M)) && Math.abs(u - T) <= h * Math.max(1, Math.abs(u), Math.abs(T)) && Math.abs(s - I) <= h * Math.max(1, Math.abs(s), Math.abs(I)) && Math.abs(l - D) <= h * Math.max(1, Math.abs(l), Math.abs(D)) && Math.abs(f - E) <= h * Math.max(1, Math.abs(f), Math.abs(E)) && Math.abs(d - A) <= h * Math.max(1, Math.abs(d), Math.abs(A)) && Math.abs(p - C) <= h * Math.max(1, Math.abs(p), Math.abs(C)) && Math.abs(v - z) <= h * Math.max(1, Math.abs(v), Math.abs(z)) && Math.abs(m - O) <= h * Math.max(1, Math.abs(m), Math.abs(O)) && Math.abs(g - F) <= h * Math.max(1, Math.abs(g), Math.abs(F)) && Math.abs(b - R) <= h * Math.max(1, Math.abs(b), Math.abs(R));
            }
            var jt = nt, Ut = Ft;
            function Bt() {
                var t = new d(2);
                return d != Float32Array && (t[0] = 0, t[1] = 0), t;
            }
            function Nt(t) {
                var e = new d(2);
                return e[0] = t[0], e[1] = t[1], e;
            }
            function Gt(t, e) {
                var r = new d(2);
                return r[0] = t, r[1] = e, r;
            }
            function Vt(t, e) {
                return t[0] = e[0], t[1] = e[1], t;
            }
            function qt(t, e, r) {
                return t[0] = e, t[1] = r, t;
            }
            function Yt(t, e, r) {
                return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t;
            }
            function Ht(t, e, r) {
                return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t;
            }
            function Wt(t, e, r) {
                return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t;
            }
            function Xt(t, e, r) {
                return t[0] = e[0] / r[0], t[1] = e[1] / r[1], t;
            }
            function Kt(t, e) {
                return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t;
            }
            function Zt(t, e) {
                return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t;
            }
            function Jt(t, e, r) {
                return t[0] = Math.min(e[0], r[0]), t[1] = Math.min(e[1], r[1]), t;
            }
            function $t(t, e, r) {
                return t[0] = Math.max(e[0], r[0]), t[1] = Math.max(e[1], r[1]), t;
            }
            function Qt(t, e) {
                return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t;
            }
            function te(t, e, r) {
                return t[0] = e[0] * r, t[1] = e[1] * r, t;
            }
            function ee(t, e, r, n) {
                return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t;
            }
            function re(t, e) {
                var r = e[0] - t[0], n = e[1] - t[1];
                return Math.sqrt(r * r + n * n);
            }
            function ne(t, e) {
                var r = e[0] - t[0], n = e[1] - t[1];
                return r * r + n * n;
            }
            function oe(t) {
                var e = t[0], r = t[1];
                return Math.sqrt(e * e + r * r);
            }
            function ie(t) {
                var e = t[0], r = t[1];
                return e * e + r * r;
            }
            function ae(t, e) {
                return t[0] = -e[0], t[1] = -e[1], t;
            }
            function ce(t, e) {
                return t[0] = 1 / e[0], t[1] = 1 / e[1], t;
            }
            function ue(t, e) {
                var r = e[0], n = e[1], o = r * r + n * n;
                return o > 0 && (o = 1 / Math.sqrt(o), t[0] = e[0] * o, t[1] = e[1] * o), t;
            }
            function se(t, e) {
                return t[0] * e[0] + t[1] * e[1];
            }
            function le(t, e, r) {
                var n = e[0] * r[1] - e[1] * r[0];
                return t[0] = t[1] = 0, t[2] = n, t;
            }
            function fe(t, e, r, n) {
                var o = e[0], i = e[1];
                return t[0] = o + n * (r[0] - o), t[1] = i + n * (r[1] - i), t;
            }
            function he(t, e) {
                e = e || 1;
                var r = 2 * p() * Math.PI;
                return t[0] = Math.cos(r) * e, t[1] = Math.sin(r) * e, t;
            }
            function de(t, e, r) {
                var n = e[0], o = e[1];
                return t[0] = r[0] * n + r[2] * o, t[1] = r[1] * n + r[3] * o, t;
            }
            function pe(t, e, r) {
                var n = e[0], o = e[1];
                return t[0] = r[0] * n + r[2] * o + r[4], t[1] = r[1] * n + r[3] * o + r[5], t;
            }
            function ve(t, e, r) {
                var n = e[0], o = e[1];
                return t[0] = r[0] * n + r[3] * o + r[6], t[1] = r[1] * n + r[4] * o + r[7], t;
            }
            function me(t, e, r) {
                var n = e[0], o = e[1];
                return t[0] = r[0] * n + r[4] * o + r[12], t[1] = r[1] * n + r[5] * o + r[13], t;
            }
            function ge(t, e, r, n) {
                var o = e[0] - r[0], i = e[1] - r[1], a = Math.sin(n), c = Math.cos(n);
                return t[0] = o * c - i * a + r[0], t[1] = o * a + i * c + r[1], t;
            }
            function be(t, e) {
                var r = t[0], n = t[1], o = e[0], i = e[1], a = r * r + n * n;
                a > 0 && (a = 1 / Math.sqrt(a));
                var c = o * o + i * i;
                c > 0 && (c = 1 / Math.sqrt(c));
                var u = (r * o + n * i) * a * c;
                return u > 1 ? 0 : u < -1 ? Math.PI : Math.acos(u);
            }
            function xe(t) {
                return "vec2(" + t[0] + ", " + t[1] + ")";
            }
            function ye(t, e) {
                return t[0] === e[0] && t[1] === e[1];
            }
            function _e(t, e) {
                var r = t[0], n = t[1], o = e[0], i = e[1];
                return Math.abs(r - o) <= h * Math.max(1, Math.abs(r), Math.abs(o)) && Math.abs(n - i) <= h * Math.max(1, Math.abs(n), Math.abs(i));
            }
            var we, Se = oe, Me = Ht, Te = Wt, Ie = Xt, De = re, Ee = ne, Ae = ie, Ce = (we = Bt(), function(t, e, r, n, o, i) {
                var a = void 0, c = void 0;
                for(e || (e = 2), r || (r = 0), c = n ? Math.min(n * e + r, t.length) : t.length, a = r; a < c; a += e)we[0] = t[a], we[1] = t[a + 1], o(we, we, i), t[a] = we[0], t[a + 1] = we[1];
                return t;
            });
            function ze() {
                var t = new d(3);
                return d != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t;
            }
            function Oe(t) {
                var e = new d(3);
                return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
            }
            function Fe(t) {
                var e = t[0], r = t[1], n = t[2];
                return Math.sqrt(e * e + r * r + n * n);
            }
            function Re(t, e, r) {
                var n = new d(3);
                return n[0] = t, n[1] = e, n[2] = r, n;
            }
            function Pe(t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
            }
            function Le(t, e, r, n) {
                return t[0] = e, t[1] = r, t[2] = n, t;
            }
            function ke(t, e, r) {
                return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t;
            }
            function je(t, e, r) {
                return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t;
            }
            function Ue(t, e, r) {
                return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t[2] = e[2] * r[2], t;
            }
            function Be(t, e, r) {
                return t[0] = e[0] / r[0], t[1] = e[1] / r[1], t[2] = e[2] / r[2], t;
            }
            function Ne(t, e) {
                return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t[2] = Math.ceil(e[2]), t;
            }
            function Ge(t, e) {
                return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t[2] = Math.floor(e[2]), t;
            }
            function Ve(t, e, r) {
                return t[0] = Math.min(e[0], r[0]), t[1] = Math.min(e[1], r[1]), t[2] = Math.min(e[2], r[2]), t;
            }
            function qe(t, e, r) {
                return t[0] = Math.max(e[0], r[0]), t[1] = Math.max(e[1], r[1]), t[2] = Math.max(e[2], r[2]), t;
            }
            function Ye(t, e) {
                return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t[2] = Math.round(e[2]), t;
            }
            function He(t, e, r) {
                return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t;
            }
            function We(t, e, r, n) {
                return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t;
            }
            function Xe(t, e) {
                var r = e[0] - t[0], n = e[1] - t[1], o = e[2] - t[2];
                return Math.sqrt(r * r + n * n + o * o);
            }
            function Ke(t, e) {
                var r = e[0] - t[0], n = e[1] - t[1], o = e[2] - t[2];
                return r * r + n * n + o * o;
            }
            function Ze(t) {
                var e = t[0], r = t[1], n = t[2];
                return e * e + r * r + n * n;
            }
            function Je(t, e) {
                return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t;
            }
            function $e(t, e) {
                return t[0] = 1 / e[0], t[1] = 1 / e[1], t[2] = 1 / e[2], t;
            }
            function Qe(t, e) {
                var r = e[0], n = e[1], o = e[2], i = r * r + n * n + o * o;
                return i > 0 && (i = 1 / Math.sqrt(i), t[0] = e[0] * i, t[1] = e[1] * i, t[2] = e[2] * i), t;
            }
            function tr(t, e) {
                return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
            }
            function er(t, e, r) {
                var n = e[0], o = e[1], i = e[2], a = r[0], c = r[1], u = r[2];
                return t[0] = o * u - i * c, t[1] = i * a - n * u, t[2] = n * c - o * a, t;
            }
            function rr(t, e, r, n) {
                var o = e[0], i = e[1], a = e[2];
                return t[0] = o + n * (r[0] - o), t[1] = i + n * (r[1] - i), t[2] = a + n * (r[2] - a), t;
            }
            function nr(t, e, r, n, o, i) {
                var a = i * i, c = a * (2 * i - 3) + 1, u = a * (i - 2) + i, s = a * (i - 1), l = a * (3 - 2 * i);
                return t[0] = e[0] * c + r[0] * u + n[0] * s + o[0] * l, t[1] = e[1] * c + r[1] * u + n[1] * s + o[1] * l, t[2] = e[2] * c + r[2] * u + n[2] * s + o[2] * l, t;
            }
            function or(t, e, r, n, o, i) {
                var a = 1 - i, c = a * a, u = i * i, s = c * a, l = 3 * i * c, f = 3 * u * a, h = u * i;
                return t[0] = e[0] * s + r[0] * l + n[0] * f + o[0] * h, t[1] = e[1] * s + r[1] * l + n[1] * f + o[1] * h, t[2] = e[2] * s + r[2] * l + n[2] * f + o[2] * h, t;
            }
            function ir(t, e) {
                e = e || 1;
                var r = 2 * p() * Math.PI, n = 2 * p() - 1, o = Math.sqrt(1 - n * n) * e;
                return t[0] = Math.cos(r) * o, t[1] = Math.sin(r) * o, t[2] = n * e, t;
            }
            function ar(t, e, r) {
                var n = e[0], o = e[1], i = e[2], a = r[3] * n + r[7] * o + r[11] * i + r[15];
                return a = a || 1, t[0] = (r[0] * n + r[4] * o + r[8] * i + r[12]) / a, t[1] = (r[1] * n + r[5] * o + r[9] * i + r[13]) / a, t[2] = (r[2] * n + r[6] * o + r[10] * i + r[14]) / a, t;
            }
            function cr(t, e, r) {
                var n = e[0], o = e[1], i = e[2];
                return t[0] = n * r[0] + o * r[3] + i * r[6], t[1] = n * r[1] + o * r[4] + i * r[7], t[2] = n * r[2] + o * r[5] + i * r[8], t;
            }
            function ur(t, e, r) {
                var n = r[0], o = r[1], i = r[2], a = r[3], c = e[0], u = e[1], s = e[2], l = o * s - i * u, f = i * c - n * s, h = n * u - o * c, d = o * h - i * f, p = i * l - n * h, v = n * f - o * l, m = 2 * a;
                return l *= m, f *= m, h *= m, d *= 2, p *= 2, v *= 2, t[0] = c + l + d, t[1] = u + f + p, t[2] = s + h + v, t;
            }
            function sr(t, e, r, n) {
                var o = [], i = [];
                return o[0] = e[0] - r[0], o[1] = e[1] - r[1], o[2] = e[2] - r[2], i[0] = o[0], i[1] = o[1] * Math.cos(n) - o[2] * Math.sin(n), i[2] = o[1] * Math.sin(n) + o[2] * Math.cos(n), t[0] = i[0] + r[0], t[1] = i[1] + r[1], t[2] = i[2] + r[2], t;
            }
            function lr(t, e, r, n) {
                var o = [], i = [];
                return o[0] = e[0] - r[0], o[1] = e[1] - r[1], o[2] = e[2] - r[2], i[0] = o[2] * Math.sin(n) + o[0] * Math.cos(n), i[1] = o[1], i[2] = o[2] * Math.cos(n) - o[0] * Math.sin(n), t[0] = i[0] + r[0], t[1] = i[1] + r[1], t[2] = i[2] + r[2], t;
            }
            function fr(t, e, r, n) {
                var o = [], i = [];
                return o[0] = e[0] - r[0], o[1] = e[1] - r[1], o[2] = e[2] - r[2], i[0] = o[0] * Math.cos(n) - o[1] * Math.sin(n), i[1] = o[0] * Math.sin(n) + o[1] * Math.cos(n), i[2] = o[2], t[0] = i[0] + r[0], t[1] = i[1] + r[1], t[2] = i[2] + r[2], t;
            }
            function hr(t, e) {
                var r = Re(t[0], t[1], t[2]), n = Re(e[0], e[1], e[2]);
                Qe(r, r), Qe(n, n);
                var o = tr(r, n);
                return o > 1 ? 0 : o < -1 ? Math.PI : Math.acos(o);
            }
            function dr(t) {
                return "vec3(" + t[0] + ", " + t[1] + ", " + t[2] + ")";
            }
            function pr(t, e) {
                return t[0] === e[0] && t[1] === e[1] && t[2] === e[2];
            }
            function vr(t, e) {
                var r = t[0], n = t[1], o = t[2], i = e[0], a = e[1], c = e[2];
                return Math.abs(r - i) <= h * Math.max(1, Math.abs(r), Math.abs(i)) && Math.abs(n - a) <= h * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(o - c) <= h * Math.max(1, Math.abs(o), Math.abs(c));
            }
            var mr = je, gr = Ue, br = Be, xr = Xe, yr = Ke, _r = Fe, wr = Ze, Sr = function() {
                var t = ze();
                return function(e, r, n, o, i, a) {
                    var c = void 0, u = void 0;
                    for(r || (r = 3), n || (n = 0), u = o ? Math.min(o * r + n, e.length) : e.length, c = n; c < u; c += r)t[0] = e[c], t[1] = e[c + 1], t[2] = e[c + 2], i(t, t, a), e[c] = t[0], e[c + 1] = t[1], e[c + 2] = t[2];
                    return e;
                };
            }();
            function Mr(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            class Tr {
                constructor(t, e, r){
                    Mr(this, "gl", void 0), Mr(this, "target", void 0), Mr(this, "type", void 0), Mr(this, "buffer", void 0), Mr(this, "spacing", void 0), Mr(this, "data", void 0), this.gl = t, this.target = e, this.type = r, this.data = Float32Array.from([]);
                }
                compile(t) {
                    if (t = t || this.gl.STATIC_DRAW, !this.data) throw new Error("!this.data");
                    if (!this.spacing) throw new Error("!this.spacing");
                    const e = this.createBuffer(this.gl, this.data.length, this.spacing);
                    this.buffer = this.buffer || e, this.gl.bindBuffer(this.target, this.buffer), this.gl.bufferData(this.target, this.data, t);
                }
                createBuffer(t, e, r) {
                    const n = t.createBuffer();
                    return Object.assign(n, {
                        length: e,
                        spacing: r
                    });
                }
            }
            function Ir(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            class Dr {
                constructor(t, e, r){
                    Ir(this, "gl", void 0), Ir(this, "Buffer", void 0), Ir(this, "vertexBuffers", void 0), Ir(this, "indexBuffers", void 0), Ir(this, "buffers", void 0), Ir(this, "vertices", []), Ir(this, "coords", void 0), Ir(this, "distortion", void 0), Ir(this, "delta", void 0), Ir(this, "lines", void 0), Ir(this, "triangles", []), this.gl = t, this.Buffer = e, this.vertexBuffers = {}, this.indexBuffers = {}, this.buffers = {}, this.addVertexBuffer("vertices", "a_Vertex", {
                        spacing: 2
                    }), r.coords && this.addVertexBuffer("coords", "a_TexCoord", {
                        spacing: 2
                    }), r.distortion && this.addVertexBuffer("distortion", "a_Distortion", {
                        spacing: 2
                    }), r.delta && this.addVertexBuffer("delta", "a_Delta", {
                        spacing: 2
                    }), r.lines && this.addIndexBuffer("lines", {
                        spacing: 2
                    }), "triangles" in r && !r.triangles || this.addIndexBuffer("triangles", {
                        spacing: 3
                    });
                }
                addVertexBuffer(t, e, r) {
                    const { spacing: n } = r, o = Vr.Buffer.create(this.gl.ARRAY_BUFFER, Float32Array);
                    o.spacing = n, this[t] = [], this.buffers[t] = o, this.vertexBuffers[e] = o;
                }
                addIndexBuffer(t, e) {
                    const { spacing: r } = e, n = Vr.Buffer.create(this.gl.ELEMENT_ARRAY_BUFFER, Uint16Array);
                    n.spacing = r, this[t] = [], this.buffers[t] = n, this.indexBuffers[t] = n;
                }
                compile() {
                    for(const t in this.buffers)this.compileBuffer(t);
                }
                compileBuffer(t) {
                    const e = this.buffers[t];
                    this[t].buffer || (this[t] = new e.type(this[t])), e.data = this[t], e.compile();
                }
            }
            function Er(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            function Ar(t, e) {
                return function(r) {
                    t.uniform1i(e, r);
                };
            }
            function Cr(t, e) {
                return function(r) {
                    t.uniform1iv(e, r);
                };
            }
            function zr(t, e) {
                return function(r) {
                    t.uniform2iv(e, r);
                };
            }
            function Or(t, e) {
                return function(r) {
                    t.uniform3iv(e, r);
                };
            }
            function Fr(t, e) {
                return function(r) {
                    t.uniform4iv(e, r);
                };
            }
            function Rr(t, e) {
                return function(r) {
                    t.uniform1i(e, r);
                };
            }
            function Pr(t, e) {
                return function(r) {
                    t.uniform1iv(e, r);
                };
            }
            function Lr(t, e) {
                return {
                    setter: t,
                    arraySetter: e
                };
            }
            const kr = {
                5126: Lr(function(t, e) {
                    return function(r) {
                        t.uniform1f(e, r);
                    };
                }, function(t, e) {
                    return function(r) {
                        t.uniform1fv(e, r);
                    };
                }),
                35664: Lr(function(t, e) {
                    return function(r) {
                        t.uniform2fv(e, r);
                    };
                }),
                35665: Lr(function(t, e) {
                    return function(r) {
                        t.uniform3fv(e, r);
                    };
                }),
                35666: Lr(function(t, e) {
                    return function(r) {
                        t.uniform4fv(e, r);
                    };
                }),
                5124: Lr(Ar, Cr),
                35667: Lr(zr),
                35668: Lr(Or),
                35669: Lr(Fr),
                5125: Lr(function(t, e) {
                    return function(r) {
                        t.uniform1ui(e, r);
                    };
                }, function(t, e) {
                    return function(r) {
                        t.uniform1uiv(e, r);
                    };
                }),
                36294: Lr(function(t, e) {
                    return function(r) {
                        t.uniform2uiv(e, r);
                    };
                }),
                36295: Lr(function(t, e) {
                    return function(r) {
                        t.uniform3uiv(e, r);
                    };
                }),
                36296: Lr(function(t, e) {
                    return function(r) {
                        t.uniform4uiv(e, r);
                    };
                }),
                35670: Lr(Ar, Cr),
                35671: Lr(zr),
                35672: Lr(Or),
                35673: Lr(Fr),
                35674: Lr(function(t, e) {
                    return function(r) {
                        t.uniformMatrix2fv(e, !1, r);
                    };
                }),
                35675: Lr(function(t, e) {
                    return function(r) {
                        t.uniformMatrix3fv(e, !1, r);
                    };
                }),
                35676: Lr(function(t, e) {
                    return (r)=>{
                        t.uniformMatrix4fv(e, !1, r);
                    };
                }),
                35685: Lr(function(t, e) {
                    return function(r) {
                        t.uniformMatrix2x3fv(e, !1, r);
                    };
                }),
                35686: Lr(function(t, e) {
                    return function(r) {
                        t.uniformMatrix2x4fv(e, !1, r);
                    };
                }),
                35687: Lr(function(t, e) {
                    return function(r) {
                        t.uniformMatrix3x2fv(e, !1, r);
                    };
                }),
                35688: Lr(function(t, e) {
                    return function(r) {
                        t.uniformMatrix3x4fv(e, !1, r);
                    };
                }),
                35689: Lr(function(t, e) {
                    return function(r) {
                        t.uniformMatrix4x2fv(e, !1, r);
                    };
                }),
                35690: Lr(function(t, e) {
                    return function(r) {
                        t.uniformMatrix4x3fv(e, !1, r);
                    };
                }),
                35678: Lr(Rr, Pr),
                35680: Lr(Rr, Pr),
                35679: Lr(Rr, Pr),
                35682: Lr(Rr, Pr),
                36289: Lr(Rr, Pr),
                36292: Lr(Rr, Pr),
                36293: Lr(Rr, Pr),
                36298: Lr(Rr, Pr),
                36299: Lr(Rr, Pr),
                36300: Lr(Rr, Pr),
                36303: Lr(Rr, Pr),
                36306: Lr(Rr, Pr),
                36307: Lr(Rr, Pr),
                36308: Lr(Rr, Pr),
                36311: Lr(Rr, Pr)
            };
            class jr {
                constructor(t, e, r){
                    Er(this, "program", void 0), Er(this, "gl", void 0), Er(this, "attributes", void 0), Er(this, "uniformSetters", void 0), this.gl = t;
                    const n = t.createProgram();
                    if (!n) throw new Error("!this.program");
                    this.program = n;
                    if (t.attachShader(this.program, this.compileSource(t.VERTEX_SHADER, e)), t.attachShader(this.program, this.compileSource(t.FRAGMENT_SHADER, r)), t.linkProgram(this.program), !t.getProgramParameter(this.program, t.LINK_STATUS)) throw console.log(e, r), new Error("link error: " + t.getProgramInfoLog(this.program));
                    this.attributes = {}, this.uniformSetters = {};
                    const o = t.getProgramParameter(this.program, t.ACTIVE_UNIFORMS);
                    for(let e = 0; e < o; ++e){
                        const r = t.getActiveUniform(this.program, e);
                        if (!r) throw new Error("!uniformInfo");
                        if (r.name.startsWith("gl_")) continue;
                        const n = t.getUniformLocation(this.program, r.name), o = r.size > 1 && "[0]" === r.name.substr(-3), i = r.type, a = kr[i];
                        if (!a) throw "unknown type: 0x" + i.toString(16);
                        let c;
                        c = o && a.arraySetter ? a.arraySetter(t, n) : a.setter(t, n), c.location = n;
                        let u = r.name;
                        "[0]" === u.substr(-3) && (u = u.substr(0, u.length - 3)), this.uniformSetters[u] = c;
                    }
                }
                compileSource(t, e) {
                    const r = this.gl.createShader(t);
                    return this.gl.shaderSource(r, e), this.gl.compileShader(r), r;
                }
                setUniform(t, e) {
                    const r = this.uniformSetters[t];
                    r && r(e);
                }
                uniforms(t) {
                    this.gl.useProgram(this.program);
                    for(const e in t)this.setUniform(e, t[e]);
                    return this;
                }
                draw(t) {
                    this.drawBuffers(t.vertexBuffers, t.indexBuffers.triangles, this.gl.TRIANGLES);
                }
                getAttributeLocation(t) {
                    return this.attributes[t] || this.gl.getAttribLocation(this.program, t);
                }
                drawBuffers(t, e, r) {
                    let n;
                    this.setUniform("u_ModelViewProjectionMatrix", this.gl.modelviewMatrix);
                    for(const e in t){
                        n = t[e];
                        const r = this.getAttributeLocation(e);
                        -1 != r && n.buffer && (this.attributes[e] = r, this.gl.bindBuffer(this.gl.ARRAY_BUFFER, n.buffer), this.gl.enableVertexAttribArray(r), this.gl.vertexAttribPointer(r, n.buffer.spacing, this.gl.FLOAT, !1, 0, 0));
                    }
                    return e ? (this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, e.buffer), this.gl.drawElements(r, e.buffer.length, this.gl.UNSIGNED_SHORT, 0)) : this.gl.drawArrays(r, 0, n.buffer.length / n.buffer.spacing), this;
                }
            }
            function Ur(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            class Br {
                constructor(t, e, r, n, o = {}){
                    Ur(this, "gl", void 0), Ur(this, "viewport", void 0), Ur(this, "framebuffer", void 0), Ur(this, "id", void 0), Ur(this, "poolId", void 0), Ur(this, "width", void 0), Ur(this, "height", void 0), Ur(this, "format", void 0), Ur(this, "type", void 0), this.gl = t, this.viewport = e, this.id = t.createTexture(), this.width = r, this.height = n, this.format = o.format || t.RGBA, this.type = o.type || t.UNSIGNED_BYTE;
                    const i = o.data || null, a = o.premultiplyAlpha || !1, c = o.ignoreColorspace ? t.NONE : t.BROWSER_DEFAULT_WEBGL, u = o.alignment || 4, s = o.filter || o.magFilter || t.LINEAR, l = o.filter || o.minFilter || t.LINEAR, f = null == o.flipY || o.flipY;
                    if (this.type === t.FLOAT) {
                        if (!this.canUseFloatingPointTextures()) throw new Error("OES_texture_float is required but not supported");
                        if ((l !== t.NEAREST || s !== t.NEAREST) && !this.canUseFloatingPointLinearFiltering()) throw new Error("OES_texture_float_linear is required but not supported");
                    } else if (this.type === (t.getExtension("OES_texture_half_float") && t.getExtension("OES_texture_half_float").HALF_FLOAT_OES)) {
                        if (!this.canUseHalfFloatingPointTextures()) throw new Error("OES_texture_half_float is required but not supported");
                        if ((l !== t.NEAREST || s !== t.NEAREST) && !this.canUseHalfFloatingPointLinearFiltering()) throw new Error("OES_texture_half_float_linear is required but not supported");
                    }
                    t.bindTexture(t.TEXTURE_2D, this.id), t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, f), t.pixelStorei(t.UNPACK_ALIGNMENT, u), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, a), t.pixelStorei(t.UNPACK_COLORSPACE_CONVERSION_WEBGL, c), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, s), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, l), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, o.wrap || o.wrapS || t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, o.wrap || o.wrapT || t.CLAMP_TO_EDGE), t.texImage2D(t.TEXTURE_2D, 0, this.format, r, n, 0, this.format, this.type, i);
                    do this.poolId = Math.ceil(Number.MAX_SAFE_INTEGER * Math.random());
                    while (this.poolId in Br.texturePool);
                    Br.texturePool[this.poolId] = this;
                }
                getFramebuffer() {
                    return this.framebuffer = this.framebuffer || this.gl.createFramebuffer(), this.framebuffer;
                }
                bind(t) {
                    this.gl.activeTexture(this.gl.TEXTURE0 + (t || 0)), this.gl.bindTexture(this.gl.TEXTURE_2D, this.id);
                }
                unbind(t) {
                    this.gl.activeTexture(this.gl.TEXTURE0 + (t || 0)), this.gl.bindTexture(this.gl.TEXTURE_2D, null);
                }
                canDrawTo() {
                    this.framebuffer = this.framebuffer || this.gl.createFramebuffer(), this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.framebuffer), this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, this.id, 0);
                    const t = this.gl.checkFramebufferStatus(this.gl.FRAMEBUFFER) == this.gl.FRAMEBUFFER_COMPLETE;
                    return this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null), t;
                }
                drawTo(t) {
                    this.framebuffer = this.framebuffer || this.gl.createFramebuffer(), this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.framebuffer), this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, this.id, 0), this.gl.viewport(0, 0, this.width, this.height), t(), this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null), this.gl.viewport(this.viewport[0], this.viewport[1], this.viewport[2], this.viewport[3]);
                }
                swapWith(t) {
                    let e;
                    e = t.id, t.id = this.id, this.id = e, e = t.width, t.width = this.width, this.width = e, e = t.height, t.height = this.height, this.height = e;
                }
                canUseFloatingPointTextures() {
                    return !!this.gl.getExtension("OES_texture_float");
                }
                canUseFloatingPointLinearFiltering() {
                    return !!this.gl.getExtension("OES_texture_float_linear");
                }
                canUseHalfFloatingPointTextures() {
                    return !!this.gl.getExtension("OES_texture_half_float");
                }
                canUseHalfFloatingPointLinearFiltering() {
                    return !!this.gl.getExtension("OES_texture_half_float_linear");
                }
            }
            function Nr(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            Ur(Br, "texturePool", {});
            class Gr {
                constructor(){
                    Nr(this, "context", void 0), Nr(this, "Shader", void 0), Nr(this, "Buffer", void 0), Nr(this, "Mesh", void 0), Nr(this, "Texture", void 0), Nr(this, "viewport", [
                        0,
                        0,
                        1,
                        1
                    ]);
                }
                create(t = {}, e) {
                    e || ((e = document.createElement("canvas")).width = 1, e.height = 1);
                    try {
                        this.context = e.getContext("webgl", t) || e.getContext("experimental-webgl", t), this.context.HALF_FLOAT_OES = 36193, (r = this.context).modelviewMatrix = o.create(), r.loadIdentity = ()=>{
                            r.modelviewMatrix = o.create();
                        }, r.loadMatrix = (t)=>{
                            r.modelviewMatrix = t;
                        }, this.Shader = function(t) {
                            return {
                                create: (e, r)=>new jr(t, e, r)
                            };
                        }(this.context), this.Buffer = function(t) {
                            return {
                                create: (e, r)=>new Tr(t, e, r)
                            };
                        }(this.context), this.Mesh = function(t, e) {
                            return {
                                create: (r = {})=>new Dr(t, e, r),
                                plane: (r = {})=>{
                                    const n = new Dr(t, e, r), o = r.detailX || r.detail || 1, i = r.detailY || r.detail || 1;
                                    for(let t = 0; t <= i; t++){
                                        const e = t / i;
                                        for(let r = 0; r <= o; r++){
                                            const a = r / o, c = 2 * a - 1, u = 2 * e - 1;
                                            if (n.vertices.push(c, u), n.distortion && n.distortion.push(c, u), n.delta && n.delta.push(0, 0), n.coords && n.coords.push(a, e), r < o && t < i) {
                                                const e = r + t * (o + 1);
                                                n.triangles.push(e, e + 1, e + o + 1), n.triangles.push(e + o + 1, e + 1, e + o + 2);
                                            }
                                        }
                                    }
                                    return n.compile(), n;
                                }
                            };
                        }(this.context, this.Buffer), this.Texture = function(t, e) {
                            const r = {
                                create: (r, n, o)=>new Br(t, e, r, n, o),
                                fromImage (r, n = {}) {
                                    const o = new Br(t, e, r.width, r.height, n);
                                    try {
                                        t.texImage2D(t.TEXTURE_2D, 0, o.format, o.format, o.type, r);
                                    } catch (t) {
                                        throw "file:" == location.protocol ? new Error('image not loaded for security reasons (serve this page over "http://" instead)') : new Error("image not loaded for security reasons (image must originate from the same domain as this page or use Cross-Origin Resource Sharing)");
                                    }
                                    return n.minFilter && n.minFilter != t.NEAREST && n.minFilter != t.LINEAR && t.generateMipmap(t.TEXTURE_2D), o;
                                },
                                fromData (r, n, o, i = {}) {
                                    const a = new Br(t, e, n, o, i);
                                    return a.format !== t.RGBA && t.pixelStorei(t.UNPACK_ALIGNMENT, 1), t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, i.flipY || 0), t.texImage2D(t.TEXTURE_2D, 0, a.format, n, o, 0, a.format, a.type, r), i.minFilter && i.minFilter != t.NEAREST && i.minFilter != t.LINEAR && t.generateMipmap(t.TEXTURE_2D), a;
                                },
                                fromURL: (n, o = {})=>{
                                    const i = new Br(t, e, 1, 1, o), a = new Image;
                                    return a.crossOrigin = "anonymous", a.onload = ()=>{
                                        let t = r.fromImage(a, o);
                                        t.swapWith(i), r.delete(t), "function" == typeof o.onload && o.onload(i);
                                    }, a.src = n, i;
                                },
                                setSize (e, r, n, o) {
                                    (o || e.width !== r || e.height !== n) && (e.width = (r || 1) >> 0, e.height = (n || 1) >> 0, t.bindTexture(t.TEXTURE_2D, e.id), t.texImage2D(t.TEXTURE_2D, 0, e.format, e.width, e.height, 0, e.format, e.type, null));
                                },
                                update (e, r, n, o) {
                                    e.width = (r || 1) >> 0, e.height = (n || 1) >> 0, t.bindTexture(t.TEXTURE_2D, e.id), t.texImage2D(t.TEXTURE_2D, 0, e.format, e.width, e.height, 0, e.format, e.type, o);
                                },
                                read (e, r) {
                                    const { width: n, height: o } = e, i = e.format === t.RGB ? 3 : 4;
                                    return r instanceof Uint8Array || (r = new Uint8Array(n * o * i)), t.bindFramebuffer(t.FRAMEBUFFER, e.getFramebuffer()), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e.id, 0), t.readPixels(0, 0, n, o, e.format, t.UNSIGNED_BYTE, r), t.bindFramebuffer(t.FRAMEBUFFER, null), r;
                                },
                                delete (e) {
                                    e && e.id && (t.bindTexture(t.TEXTURE_2D, e.id), t.deleteTexture(e.id), delete e.id, delete Br.texturePool[e.poolId]);
                                },
                                canUseFloatingPointTextures: ()=>!!t.getExtension("OES_texture_float"),
                                canUseFloatingPointLinearFiltering: ()=>!!t.getExtension("OES_texture_float_linear"),
                                canUseHalfFloatingPointTextures: ()=>!!t.getExtension("OES_texture_half_float"),
                                canUseHalfFloatingPointLinearFiltering: ()=>!!t.getExtension("OES_texture_half_float_linear"),
                                canRenderToFloatingPointTextures () {
                                    const e = t.getExtension("OES_texture_half_float"), r = t.getExtension("OES_texture_float"), n = e && e.HALF_FLOAT_OES, o = {
                                        halfFloat: !1,
                                        float: !1
                                    }, i = t.createFramebuffer();
                                    if (t.bindFramebuffer(t.FRAMEBUFFER, i), n) {
                                        const e = t.createTexture();
                                        t.bindTexture(t.TEXTURE_2D, e), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, 1, 1, 0, t.RGBA, n, null), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e, 0), o.halfFloat = t.checkFramebufferStatus(t.FRAMEBUFFER) == t.FRAMEBUFFER_COMPLETE, t.deleteTexture(e);
                                    }
                                    if (r) {
                                        const e = t.createTexture();
                                        t.bindTexture(t.TEXTURE_2D, e), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, 1, 1, 0, t.RGBA, t.FLOAT, null), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e, 0), o.float = t.checkFramebufferStatus(t.FRAMEBUFFER) == t.FRAMEBUFFER_COMPLETE, t.deleteTexture(e);
                                    }
                                    return t.bindFramebuffer(t.FRAMEBUFFER, null), t.deleteFramebuffer(i), o;
                                }
                            };
                            return r;
                        }(this.context, this.viewport);
                    } catch (t) {
                        throw new Error("WebGL not supported");
                    }
                    var r;
                    return this.context;
                }
                readPixels(t, e, r, n, o) {
                    const i = new Uint8Array(r * n * 4);
                    if (!this.context) throw new Error("!this.context");
                    if (o) {
                        const a = o.getFramebuffer();
                        this.context.bindFramebuffer(this.context.FRAMEBUFFER, a), this.context.framebufferTexture2D(this.context.FRAMEBUFFER, this.context.COLOR_ATTACHMENT0, this.context.TEXTURE_2D, o.id, 0), this.context.readPixels(t, e, r, n, this.context.RGBA, this.context.UNSIGNED_BYTE, i), this.context.bindFramebuffer(this.context.FRAMEBUFFER, null);
                    } else this.context.readPixels(t, e, r, n, this.context.RGBA, this.context.UNSIGNED_BYTE, i);
                    return i;
                }
                setViewport(t, e, r, n) {
                    if (!this.context) throw new Error("!this.context");
                    this.viewport[0] === t && this.viewport[1] === e && this.viewport[2] === r && this.viewport[3] === n || (this.viewport[0] = t, this.viewport[1] = e, this.viewport[2] = r, this.viewport[3] = n, this.context.viewport(t, e, r, n));
                }
            }
            const Vr = new Gr, qr = 180 / Math.PI, Yr = Math.PI / 180, Hr = Math.PI / 2, Wr = 2 * Math.PI, Xr = ([t, e, r, n, o, i, a, c])=>{
                const u = r - o, s = n - i, l = a - o, f = c - i, h = t - r + o - a, d = e - n + i - c, p = u * f - l * s, v = (h * f - l * d) / p, m = (u * d - h * s) / p;
                return [
                    r - t + v * r,
                    n - e + v * n,
                    v,
                    a - t + m * a,
                    c - e + m * c,
                    m,
                    t,
                    e,
                    1
                ];
            };
            function Kr(t, e, r, n, o, i, a, c) {
                if (t === r && e === n || o === a && i === c) return !1;
                const u = (c - i) * (r - t) - (a - o) * (n - e);
                if (0 === u) return !1;
                const s = ((a - o) * (e - i) - (c - i) * (t - o)) / u, l = ((r - t) * (e - i) - (n - e) * (t - o)) / u;
                if (s < 0 || s > 1 || l < 0 || l > 1) return !1;
                return [
                    t + s * (r - t),
                    e + s * (n - e)
                ];
            }
            const Zr = (t, e, r)=>{
                r = r.concat([
                    r[0]
                ]);
                const [n, o] = t, [i, a] = e;
                let c, u, s, l, f = !1;
                for(let t = 0; t < r.length - 1 && (c = r[t][0], u = r[t][1], s = r[t + 1][0], l = r[t + 1][1], f = Kr(n, o, i, a, c, u, s, l), !f); t++);
                return f;
            }, Jr = (t, e)=>{
                e = e.concat([
                    e[0]
                ]);
                const r = t[0], n = t[1];
                let o = !1;
                for(let t = 0, i = e.length - 1; t < e.length; i = t++){
                    const a = e[t][0], c = e[t][1], u = e[i][0], s = e[i][1];
                    c > n != s > n && r < (u - a) * (n - c) / (s - c) + a && (o = !o);
                }
                return o;
            }, $r = (t, e, r)=>{
                const n = i.sqrDist(e, r);
                if (0 == n) return i.sqrDist(t, e);
                let o = ((t[0] - e[0]) * (r[0] - e[0]) + (t[1] - e[1]) * (r[1] - e[1])) / n;
                return o = Math.max(0, Math.min(1, o)), i.dist(t, [
                    e[0] + o * (r[0] - e[0]),
                    e[1] + o * (r[1] - e[1])
                ]);
            }, Qr = (t, e)=>{
                if (Jr(t, e)) return 0;
                const r = e.length;
                let n, o = 1;
                for(let i = 0, a = r - 1; i < r; a = i++)n = $r(t, e[i], e[a]), o = Math.min(o, $r(t, e[i], e[a]));
                return o;
            }, tn = (t)=>{
                const e = (t = t.concat([
                    t[0]
                ])).length;
                let r, n, o, i = 0, a = 0, c = 0;
                for(let u = 0, s = e - 1; u < e; s = u++)r = t[u], n = t[s], o = r[0] * n[1] - n[0] * r[1], i += o, a += (r[0] + n[0]) * o, c += (r[1] + n[1]) * o;
                return o = 3 * i, [
                    a / o,
                    c / o
                ];
            }, en = (t)=>{
                const e = t.length;
                let r, n, o = 1, i = 1, a = -1, c = -1;
                for(let u = 0; u < e; u++)r = t[u][0], n = t[u][1], o = Math.min(o, r), a = Math.max(a, r), i = Math.min(i, n), c = Math.max(c, n);
                return r = .5 * o + .5 * a, n = .5 * i + .5 * c, [
                    r,
                    n
                ];
            }, rn = (t, e, r = "stretch")=>{
                let n, o;
                if ("fit" === r) {
                    const r = Math.min(e[0] / t[0], e[1] / t[1]);
                    n = t[0] * r >> 0, o = t[1] * r >> 0;
                } else if ("fill" === r) {
                    const r = Math.max(e[0] / t[0], e[1] / t[1]);
                    n = t[0] * r >> 0, o = t[1] * r >> 0;
                } else [n, o] = e;
                return [
                    n,
                    o
                ];
            }, nn = (t, e, r, n)=>{
                let o = t[0], i = t[1], a = o + t[2], c = i + t[3];
                r && (o = 1 - o, a = 1 - a), n && (i = 1 - i, c = 1 - c), o -= .5, i -= .5, a -= .5, c -= .5;
                const u = an([
                    o,
                    i
                ], e), s = an([
                    a,
                    i
                ], e), l = an([
                    a,
                    c
                ], e), f = an([
                    o,
                    c
                ], e);
                return o = Math.min(u[0], s[0], l[0], f[0]) + .5, i = Math.min(u[1], s[1], l[1], f[1]) + .5, a = Math.max(u[0], s[0], l[0], f[0]) + .5, c = Math.max(u[1], s[1], l[1], f[1]) + .5, [
                    o,
                    i,
                    a - o,
                    c - i
                ];
            }, on = (t, e, r, n)=>{
                let [o, i] = t;
                return r && (o = 1 - o), n && (i = 1 - i), o -= .5, i -= .5, [o, i] = an([
                    o,
                    i
                ], e), [
                    o + .5,
                    i + .5
                ];
            }, an = (t, e)=>{
                const r = e * (Math.PI / 180), n = Math.cos(r), o = Math.sin(r);
                return [
                    t[0] * n - t[1] * o,
                    t[0] * o + t[1] * n
                ];
            }, cn = (t, e)=>{
                const r = Math.cos(e), n = Math.sin(e);
                return [
                    t[0] * r - t[1] * n,
                    t[0] * n + t[1] * r
                ];
            }, un = (t, e, r)=>t <= e ? e : t >= r ? r : t, sn = (t, e, r)=>e * (1 - t) + r * t, ln = (t, e, r)=>a.lerp(a.create(), e, r, t), fn = (t)=>t <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4), hn = (t)=>t <= .0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055, dn = (t, e, r)=>{
                const n = Math.max(t, e, r), o = Math.min(t, e, r);
                let i, a, c = n;
                const u = n - o;
                if (a = 0 == n ? 0 : u / n, n == o) i = 0;
                else switch(n){
                    case t:
                        i = (e - r) / u + (e < r ? 6 : 0);
                        break;
                    case e:
                        i = (r - t) / u + 2;
                        break;
                    case r:
                        i = (t - e) / u + 4;
                        break;
                    default:
                        i = 0;
                }
                return i /= 6, [
                    i,
                    a,
                    c
                ];
            }, pn = (t, e, r)=>{
                let n = 0, o = 0, i = 0;
                const a = Math.floor(6 * t), c = 6 * t - a, u = r * (1 - e), s = r * (1 - c * e), l = r * (1 - (1 - c) * e);
                switch(a % 6){
                    case 0:
                        n = r, o = l, i = u;
                        break;
                    case 1:
                        n = s, o = r, i = u;
                        break;
                    case 2:
                        n = u, o = r, i = l;
                        break;
                    case 3:
                        n = u, o = s, i = r;
                        break;
                    case 4:
                        n = l, o = u, i = r;
                        break;
                    case 5:
                        n = r, o = u, i = s;
                }
                return [
                    n,
                    o,
                    i
                ];
            }, vn = (t, e)=>i.dist(t, e), mn = (t)=>Math.exp(2 * -Math.PI * t * t), gn = (t)=>t * qr, bn = (t)=>t * Yr, xn = (t, e)=>Math.atan2(t[0] - e[0], t[1] - e[1]), yn = (()=>{
                const t = window.performance || Date;
                return ()=>t.now.apply(t);
            })(), _n = (t)=>{
                let e, r, n = !1;
                const o = ()=>(t.apply(e, r), n = !1);
                return function() {
                    if (e = this, r = arguments, !n) return n = !0, requestAnimationFrame(o);
                };
            }, wn = (t, e)=>{
                let r, n = 0, o = 0, i = 0;
                return function() {
                    const a = this;
                    r = arguments, i = yn(), o && i < o + e ? (window.clearTimeout(n), n = window.setTimeout(function() {
                        t.apply(a, r);
                    }, e)) : (o = i, t.apply(a, r));
                };
            }, Sn = (t, e = 1)=>{
                let r, n = 0;
                return function() {
                    const o = this;
                    r = arguments, window.clearTimeout(n), n = window.setTimeout(function() {
                        t.apply(o, r);
                    }, e);
                };
            }, Mn = (t)=>{
                const e = {};
                for(const r in t){
                    let n = t[r];
                    n instanceof Array && (n = n.slice(0)), e[r] = n;
                }
                return e;
            }, Tn = (t)=>{
                let e = t;
                if (t && "object" == typeof t && !(t instanceof ArrayBuffer) && !(t.buffer instanceof ArrayBuffer)) {
                    e = t instanceof Array ? [] : {};
                    for(const r in t)e[r] = Tn(t[r]);
                }
                return e;
            }, In = (t, e)=>{
                const r = {};
                for(const n in t){
                    const o = t[n];
                    o instanceof Array || e[n] !== o && (r[n] = e[n]);
                }
                return r;
            }, Dn = (t, e)=>{
                if (t === e) return !0;
                if ("object" != typeof t || null === t || "object" != typeof e || null === e) return !1;
                const r = Object.keys(t), n = Object.keys(e);
                if (r.length !== n.length) return !1;
                for (const n of r)if (!window.hasOwnProperty.call(e, n) || t[n] !== e[n]) return !1;
                return !0;
            }, En = (t, e, r, n)=>{
                let o = !0;
                if (t instanceof Array) {
                    if (o = e && t.length === e.length, !o) return o;
                    if (r) {
                        for(let i = 0; i < t.length; i++)if (o = En(t[i], e[i], r, n), !o) return o;
                    }
                } else if (t instanceof ArrayBuffer) o = t === e;
                else if (null !== t && "object" == typeof t) {
                    for(const i in t)if ((!n || n.hasOwnProperty(i)) && (o = e && En(t[i], e[i], r, n), !o)) return o;
                } else o = t === e;
                return o;
            }, An = function(t = 0) {
                (t > 8 || t < 0) && (t = 1);
                return [
                    {
                        rotate90: 0,
                        flip_x: !1,
                        flip_y: !1
                    },
                    {
                        rotate90: 0,
                        flip_x: !1,
                        flip_y: !1
                    },
                    {
                        rotate90: 0,
                        flip_x: !0,
                        flip_y: !1
                    },
                    {
                        rotate90: 2,
                        flip_x: !1,
                        flip_y: !1
                    },
                    {
                        rotate90: 0,
                        flip_x: !1,
                        flip_y: !0
                    },
                    {
                        rotate90: 1,
                        flip_x: !0,
                        flip_y: !1
                    },
                    {
                        rotate90: 1,
                        flip_x: !1,
                        flip_y: !1
                    },
                    {
                        rotate90: -1,
                        flip_x: !0,
                        flip_y: !1
                    },
                    {
                        rotate90: -1,
                        flip_x: !1,
                        flip_y: !1
                    }
                ][t];
            }, Cn = function(t, e, r, n, o) {
                let i = 0;
                const a = Date.now(), c = a + 1e3 * r, u = "number" == typeof t ? [
                    t
                ] : t, s = "number" == typeof e ? [
                    e
                ] : e, l = u.slice(0), f = c - a;
                let h = 0, d = null, p = function() {
                    i = Date.now();
                    let t = 1 - (i - a) / f;
                    t < 0 && (t = 0), h = -(t * t * t - 1);
                    for(let t = 0; t < u.length; t++){
                        const e = u[t];
                        l[t] = (s[t] - e) * h + e;
                    }
                    n(l), i <= c ? d = requestAnimationFrame(p) : (n(s), "function" == typeof o && o());
                };
                return p(), function() {
                    null !== d && cancelAnimationFrame(d), p = n = o = function() {};
                };
            }, zn = function(t, e) {
                const r = {};
                for(const n in t)t.hasOwnProperty(n) && (r[n] = e(t[n]));
                return r;
            }, On = Function.prototype;
            function Fn(t = "") {
                return t.toLowerCase().split(".").pop() || "";
            }
            function Rn(t, e) {
                return e.reduce((t, e)=>t && "object" == typeof t ? t[e] : void 0, t);
            }
            let Pn, Ln, kn;
            var jn, Un, Bn, Nn, Gn;
            function Vn(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            !function(t) {
                t[t.RASTERIZE = 0] = "RASTERIZE", t[t.REVERT = 1] = "REVERT", t[t.FLATTEN_STATE = 2] = "FLATTEN_STATE";
            }(Pn || (Pn = {})), function(t) {
                t[t.UNION = 0] = "UNION", t[t.SUBTRACT = 1] = "SUBTRACT", t[t.INTERSECT = 2] = "INTERSECT", t[t.DIFFERENCE = 3] = "DIFFERENCE", t[t.COMBINE = 4] = "COMBINE";
            }(Ln || (Ln = {})), function(t) {
                t.ABGR = "ABGR", t.ARGB = "ARGB", t.BGRA = "BGRA", t.RGBA = "RGBA";
            }(kn || (kn = {}));
            const qn = document.createElement("canvas");
            qn.width = 1, qn.height = 1, qn.addEventListener("webglcontextlost", (t)=>{
                throw setTimeout(()=>{
                    window.location.reload();
                }, 1e3), new Error("WebGL context lost with status: ".concat(t.statusMessage));
            });
            const Yn = Vr.create({
                alpha: !1,
                antialias: !1,
                depth: !1,
                stencil: !1,
                failIfMajorPerformanceCaveat: !1,
                powerPreference: "high-performance",
                preferLowPowerToHighPerformance: !1,
                preserveDrawingBuffer: !0
            }, qn), Hn = {
                V1: 0,
                V2: 1
            }, Wn = Hn.V2;
            let Xn, Kn;
            var Zn;
            !function(t) {
                t[t.NORMAL = 0] = "NORMAL", t[t.DARKEN = 1] = "DARKEN", t[t.MULTIPLY = 2] = "MULTIPLY", t[t.COLOR_BURN = 3] = "COLOR_BURN", t[t.LINEAR_BURN = 4] = "LINEAR_BURN", t[t.LIGHTEN = 5] = "LIGHTEN", t[t.SCREEN = 6] = "SCREEN", t[t.COLOR_DODGE = 7] = "COLOR_DODGE", t[t.LINEAR_DODGE = 8] = "LINEAR_DODGE", t[t.ADD = 8] = "ADD", t[t.OVERLAY = 9] = "OVERLAY", t[t.SOFT_LIGHT = 10] = "SOFT_LIGHT", t[t.HARD_LIGHT = 11] = "HARD_LIGHT", t[t.VIVID_LIGHT = 12] = "VIVID_LIGHT", t[t.LINEAR_LIGHT = 13] = "LINEAR_LIGHT", t[t.DIFFERENCE = 14] = "DIFFERENCE", t[t.EXCLUSION = 15] = "EXCLUSION", t[t.SUBTRACT = 16] = "SUBTRACT", t[t.DIVIDE = 17] = "DIVIDE", t[t.HUE = 18] = "HUE", t[t.SATURATION = 19] = "SATURATION", t[t.COLOR = 20] = "COLOR", t[t.LUMINOSITY = 21] = "LUMINOSITY", t[t.PASSTHROUGH = 22] = "PASSTHROUGH";
            }(Xn || (Xn = {})), function(t) {
                t[t.none = 0] = "none", t[t.linear = 1] = "linear", t[t.radial = 2] = "radial", t[t.luminance = 3] = "luminance";
            }(Kn || (Kn = {})), function(t) {
                t[t.sRGB = 0] = "sRGB", t[t["Display P3"] = 1] = "Display P3", t[t.YUV = 2] = "YUV";
            }(Zn || (Zn = {}));
            const Jn = window.devicePixelRatio, $n = Yn.getParameter(Yn.MAX_TEXTURE_SIZE), Qn = Yn.getParameter(Yn.MAX_RENDERBUFFER_SIZE), to = Math.min(Qn, $n), eo = (null === (jn = Vr.Texture) || void 0 === jn ? void 0 : jn.canUseFloatingPointTextures()) && (null === (Un = Vr.Texture) || void 0 === Un ? void 0 : Un.canUseFloatingPointLinearFiltering()), ro = (null === (Bn = Vr.Texture) || void 0 === Bn ? void 0 : Bn.canUseHalfFloatingPointTextures()) && (null === (Nn = Vr.Texture) || void 0 === Nn ? void 0 : Nn.canUseHalfFloatingPointLinearFiltering()), no = null === (Gn = Vr.Texture) || void 0 === Gn ? void 0 : Gn.canRenderToFloatingPointTextures(), oo = {
                canUseFloatTexture: eo,
                canUseHalfFloatTexture: ro,
                canRenderToFloatTexture: eo && (null == no ? void 0 : no.float),
                canRenderToHalfFloatTexture: ro && (null == no ? void 0 : no.halfFloat)
            };
            class io {
                get storage() {
                    return io.storage;
                }
                set storage(t) {
                    io.storage = t;
                }
                static getPixelFormat(t) {
                    switch(t){
                        case kn.ABGR:
                            return 1;
                        case kn.ARGB:
                            return 2;
                        case kn.BGRA:
                            return 3;
                        default:
                            return 0;
                    }
                }
                setPixelFormat(t) {
                    this.pixelFormat = io.getPixelFormat(t);
                }
                constructor(){
                    Vn(this, "capabilities", oo), Vn(this, "pixelFormat", io.getPixelFormat(kn.RGBA)), Vn(this, "scaleX", 1), Vn(this, "originalSource", void 0), Vn(this, "originalSourceOptions", {}), Vn(this, "reloadSource", On), Vn(this, "rasterize", On), Vn(this, "getAssetsDir", io.getAssetsDir), Vn(this, "deleteTexture", io.deleteTexture), Vn(this, "swapTextures", io.swapTextures), Vn(this, "setStorage", io.setStorage), Vn(this, "maxTextureSize", to), Vn(this, "gl", Yn), Vn(this, "canvas", Yn.canvas), Vn(this, "pixelRatio", Jn), Vn(this, "currentProcess", Wn), Vn(this, "processVersions", Hn), Vn(this, "blendModes", Xn), Vn(this, "gradientTypes", Kn), Vn(this, "colorProfileName", "sRGB"), Vn(this, "colorProfile", 0), Vn(this, "colorProfiles", Zn), Vn(this, "mesh", void 0), Vn(this, "overlayMesh", void 0), Vn(this, "distortionVertices", void 0), Vn(this, "deltaVertices", void 0), Vn(this, "originalTexture", null), Vn(this, "texture", {
                        width: 0,
                        height: 0,
                        bind: (t)=>{}
                    }), Vn(this, "textures", []), Vn(this, "dehazeTexture", Vr.Texture.create(1, 1)), Vn(this, "cacheTexture", Vr.Texture.create(1, 1)), Vn(this, "intermediateTexture", Vr.Texture.create(1, 1)), Vn(this, "readableTexture", Vr.Texture.create(1, 1)), Vn(this, "writableTexture", Vr.Texture.create(1, 1)), Vn(this, "lensBlurTexture", Vr.Texture.create(1, 1)), Vn(this, "retouchTexture", Vr.Texture.create(1, 1)), Vn(this, "brushTexture", Vr.Texture.create(1, 1)), Vn(this, "pixelTexture", Vr.Texture.create(1, 1)), Vn(this, "faceMasks", []), Vn(this, "textLayers", []), Vn(this, "layers", []), Vn(this, "brushTextures", {}), Vn(this, "objectMasks", {}), Vn(this, "curvesTexture", Vr.Texture.create(0, 0)), Vn(this, "hslTexture", Vr.Texture.create(0, 0)), Vn(this, "lutTexture", Vr.Texture.create(0, 0)), Vn(this, "denoiseTexture", Vr.Texture.create(0, 0)), Vn(this, "depthTexture", void 0), Vn(this, "inTexture", void 0), Vn(this, "screenTexture", void 0), Vn(this, "patterns", {}), Vn(this, "brushes", {}), Vn(this, "grainTexture", Vr.Texture.fromURL(io.getAssetsDir() + "film_grain_small.png", {
                        magFilter: Yn.LINEAR,
                        minFilter: Yn.LINEAR_MIPMAP_LINEAR,
                        wrapS: Yn.REPEAT,
                        wrapT: Yn.REPEAT
                    })), Vn(this, "brushWindowBorder", Vr.Texture.fromURL(io.getAssetsDir() + "border-01.png")), Vn(this, "matrix", o.create()), Vn(this, "matrixInv", o.create()), Vn(this, "viewMatrix", o.create()), Vn(this, "perspectiveMatrix", o.create()), Vn(this, "projectionMatrix", o.create()), Vn(this, "projectionMatrixInv", o.create()), Vn(this, "translationMatrix", o.create()), Vn(this, "rotationMatrix", o.create()), Vn(this, "rotation90Matrix", o.create()), Vn(this, "rotation90MatrixInv", o.create()), Vn(this, "scaleMatrix", o.create()), Vn(this, "cropMatrix", o.create()), Vn(this, "borderMatrix", o.create()), Vn(this, "screenMatrix", o.create()), Vn(this, "overlayMatrix", o.create()), Vn(this, "tmpMatrix", o.create()), Vn(this, "distortionMatrix", n.create()), Vn(this, "cacheTextureMatrix", o.create()), Vn(this, "zoom", 0), Vn(this, "flipY", !1), Vn(this, "flipX", !1), Vn(this, "rotate90", 0), Vn(this, "rotation", 0), Vn(this, "offset", [
                        0,
                        0
                    ]), Vn(this, "crop", [
                        0,
                        0,
                        0,
                        0
                    ]), Vn(this, "borderCrop", [
                        0,
                        0,
                        1,
                        1
                    ]), Vn(this, "cropScale", 1), Vn(this, "cropMode", !1), Vn(this, "downsampleResolution", [
                        0,
                        0
                    ]), Vn(this, "compositeResolution", [
                        0,
                        0
                    ]), Vn(this, "compositeCoords", [
                        0,
                        0,
                        0,
                        0
                    ]), Vn(this, "downsampleFactor", 1), Vn(this, "margins", [
                        0,
                        0,
                        0,
                        0
                    ]), Vn(this, "backgroundColor", [
                        30 / 255,
                        30 / 255,
                        30 / 255
                    ]), Vn(this, "thresholdAverage", [
                        1,
                        1,
                        1
                    ]), Vn(this, "overlayMask", [
                        0,
                        0,
                        0,
                        0
                    ]), Vn(this, "overlay", {
                        flipX: 1,
                        flipY: 1,
                        tx: 0,
                        ty: 0,
                        rotation: 0,
                        width: 0,
                        height: 0,
                        imageWidth: 0,
                        imageHeight: 0
                    }), Vn(this, "screen", {
                        center: [
                            0,
                            0
                        ],
                        offset: [
                            0,
                            0
                        ],
                        rotation: [
                            0,
                            0,
                            0
                        ],
                        zoom: 0
                    }), Vn(this, "watermark", Vr.Texture.create(1, 1)), Vn(this, "watermarkOptions", {
                        enabled: !1,
                        opacity: 1,
                        position: [
                            .95,
                            .95
                        ],
                        rotation: 0,
                        scale: .2
                    }), Vn(this, "palette", {}), Vn(this, "needsUpdate", !0), Vn(this, "previewIntermediate", !1), Vn(this, "photoLoaded", !1), Vn(this, "state", {}), Vn(this, "prevState", {}), Vn(this, "defaultState", {}), Vn(this, "stateMap", {}), Vn(this, "currentEffect", null), Vn(this, "thumbnail", void 0), Vn(this, "textureFormat", void 0), this.mesh = Vr.Mesh.plane({
                        coords: !0,
                        delta: !0,
                        detail: 64,
                        distortion: !0
                    }), this.overlayMesh = Vr.Mesh.plane({
                        coords: !0
                    }), this.distortionVertices = this.mesh.distortion, this.deltaVertices = this.mesh.delta;
                }
            }
            Vn(io, "storage", {
                get: ()=>Promise.resolve(),
                set: ()=>Promise.resolve(),
                isFontLoaded: ()=>!1
            }), Vn(io, "getAssetsDir", ()=>`${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/img/sample_images/assets/`), Vn(io, "deleteTexture", (t)=>{
                Yn.bindTexture(Yn.TEXTURE_2D, t), Yn.deleteTexture(t);
            }), Vn(io, "swapTextures", ()=>{
                const t = ao.readableTexture;
                ao.readableTexture = ao.writableTexture, ao.writableTexture = t, ao.inTexture = null;
            }), Vn(io, "setStorage", (t)=>{
                io.storage = t;
            });
            const ao = new io;
            var co = ao;
            function uo(t, e, r) {
                ao.state[t] = e, ao.defaultState[t] = e, ao.stateMap[t] = r || Function.prototype;
            }
            function so(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            const { gl: lo } = co;
            lo.getExtension("OES_standard_derivatives");
            const fo = {}, ho = (t, e = co.writableTexture)=>{
                fo[t].render(co.inTexture || co.readableTexture, e), co.swapTextures();
            };
            class po {
                constructor(t){
                    if (so(this, "name", void 0), so(this, "fragment", "basic"), so(this, "vertex", "basic"), so(this, "uniforms", {}), so(this, "mesh", co.mesh), so(this, "readableTexture", null), so(this, "fragmentSource", void 0), so(this, "vertexSource", void 0), so(this, "_shader", void 0), so(this, "draw", ()=>{
                        this.readableTexture && this.readableTexture.bind && this.readableTexture.bind(0), this.onRender(this.readableTexture), this.shader.draw(this.mesh);
                    }), ((t, e)=>{
                        if (fo[t]) throw "Filter '".concat(t, "' already exists");
                        if (!(e instanceof po)) throw "filter is not an instance of Filter";
                        fo[t] = e;
                    })(t.name, this), this.name = t.name, this.fragment = t.fragment || t.name, t.vertex && (this.vertex = t.vertex), t.mesh && (this.mesh = t.mesh), t.fragmentShader && (this.fragmentSource = t.fragmentShader), t.vertexShader && (this.vertexSource = t.vertexShader), t.uniforms) {
                        this.uniforms = t.uniforms;
                        for(const e in t.uniforms)uo(e, t.uniforms[e], this.setUniform.bind(this, e));
                    }
                    t.shouldRender && (this.shouldRender = t.shouldRender.bind(this)), t.onRender && (this.onRender = t.onRender.bind(this));
                }
                get shader() {
                    return this._shader || (this.vertexSource || (this.vertexSource = r(394)("./".concat(this.vertex || "basic", ".vert"))), this.fragmentSource || (this.fragmentSource = r(163)("./".concat(this.fragment, ".frag"))), this._shader = Vr.Shader.create(this.vertexSource, this.fragmentSource)), this._shader;
                }
                set shader(t) {
                    this._shader = t;
                }
                setUniform(t, e) {
                    lo.useProgram(this.shader.program), this.shader.setUniform(t, e);
                }
                set(t) {
                    this.shader.uniforms(t);
                }
                render(t, e) {
                    this.readableTexture = t, e ? e.drawTo(this.draw) : this.draw();
                }
                onRender(t) {}
                shouldRender() {
                    return !0;
                }
            }
            new po({
                name: "fill",
                uniforms: {
                    fill_color: [
                        1,
                        0,
                        0,
                        0
                    ],
                    fill_blend: 0
                },
                onRender () {
                    this.set({
                        texture: 0
                    });
                }
            }), new po({
                name: "layer",
                vertex: "layer",
                onRender () {
                    this.set({
                        texture: 0
                    });
                }
            }), new po({
                name: "text_layer",
                vertex: "layer",
                onRender () {
                    this.set({
                        texture: 0
                    });
                }
            }), new po({
                name: "distortion_multitexture",
                vertex: "fringing",
                onRender () {
                    co.textures[0].bind(0), co.textures[1].bind(1), co.textures[2].bind(2), co.textures[3].bind(3), this.set({
                        textures: [
                            2,
                            3,
                            0,
                            1
                        ],
                        fringing: co.state.fringing,
                        fringing_center: co.state.fringing_center,
                        fringing_channel: co.state.fringing_channel,
                        fringing_radius: co.state.fringing_radius,
                        fringing_hue: co.state.fringing_hue,
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical,
                        scale: co.zoom,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ],
                        resolution: co.downsampleResolution,
                        colorProfile: co.colorProfile,
                        pixelFormat: co.pixelFormat,
                        distortionMatrix: co.distortionMatrix,
                        scaleX: co.scaleX
                    });
                }
            }), new po({
                name: "distortion",
                vertex: "fringing",
                onRender () {
                    this.set({
                        texture: 0,
                        fringing: co.state.fringing,
                        fringing_center: co.state.fringing_center,
                        fringing_channel: co.state.fringing_channel,
                        fringing_radius: co.state.fringing_radius,
                        fringing_hue: co.state.fringing_hue,
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical,
                        scale: co.zoom,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ],
                        resolution: co.downsampleResolution,
                        colorProfile: co.colorProfile,
                        pixelFormat: co.pixelFormat,
                        distortionMatrix: co.distortionMatrix
                    });
                }
            }), new po({
                name: "display",
                onRender () {
                    this.set({
                        texture: 0,
                        colorProfile: co.colorProfile,
                        pixelFormat: co.pixelFormat,
                        resolution: co.downsampleResolution,
                        scale: co.zoom
                    });
                }
            }), new po({
                name: "display_multitexture",
                onRender () {
                    co.textures[0].bind(0), co.textures[1].bind(1), co.textures[2].bind(2), co.textures[3].bind(3), this.set({
                        textures: [
                            2,
                            3,
                            0,
                            1
                        ],
                        colorProfile: co.colorProfile,
                        pixelFormat: co.pixelFormat,
                        resolution: co.downsampleResolution,
                        scale: co.zoom,
                        scaleX: co.scaleX
                    });
                }
            }), new po({
                name: "out",
                onRender () {
                    co.intermediateTexture.bind(1), this.set({
                        original: 1,
                        texture: 0
                    });
                }
            }), new po({
                name: "distortion_map",
                vertex: "distortion",
                onRender () {
                    this.set({
                        texture: 0,
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            }), new po({
                name: "denoise_nlm1",
                onRender () {
                    this.set({
                        texture: 0,
                        textureResolution: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            }), new po({
                name: "denoise_nlm2",
                onRender () {
                    this.set({
                        texture: 0,
                        textureResolution: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            }), new po({
                name: "mask_object",
                vertex: "distortion",
                onRender () {
                    co.intermediateTexture.bind(1), this.set({
                        texture: 0,
                        originalTexture: 1,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ],
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical
                    });
                }
            }), new po({
                name: "mask_luminance",
                vertex: "distortion",
                onRender () {
                    co.dehazeTexture.bind(1), this.set({
                        texture: 0,
                        smoothTexture: 1,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ],
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical
                    });
                }
            }), new po({
                name: "mask_depth",
                vertex: "distortion",
                onRender () {
                    co.depthTexture && co.depthTexture.bind(1), this.set({
                        texture: 0,
                        depthTexture: 1,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ],
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical
                    });
                }
            }), new po({
                name: "mask_brush",
                vertex: "composite",
                onRender () {
                    this.set({
                        texture: 0,
                        viewMatrix: co.matrix,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            }), new po({
                name: "mask_color",
                vertex: "distortion",
                onRender () {
                    co.dehazeTexture.bind(1), this.set({
                        texture: 0,
                        colorMap: 1,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ],
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical
                    });
                }
            }), new po({
                name: "mask_radial",
                vertex: "composite",
                onRender () {
                    this.set({
                        texture: 0,
                        viewMatrix: co.matrix,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            }), new po({
                name: "mask_gradient",
                vertex: "composite",
                onRender () {
                    this.set({
                        texture: 0,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            }), new po({
                name: "spot_heal_mask",
                vertex: "composite",
                onRender () {
                    this.set({
                        texture: 0,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            }), new po({
                name: "spot_heal",
                vertex: "spot_heal",
                onRender () {
                    co.dehazeTexture.bind(1), co.texture.bind(2), co.retouchTexture.bind(3), this.set({
                        texture: 0,
                        smoothTexture: 1,
                        originalTexture: 2,
                        retouchTexture: 3,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            }), new po({
                name: "spot_heal_multitexture",
                vertex: "spot_heal",
                onRender () {
                    co.textures[0].bind(3), co.textures[1].bind(4), co.textures[2].bind(5), co.textures[3].bind(6), co.dehazeTexture.bind(1), co.retouchTexture.bind(2), this.set({
                        texture: 0,
                        textures: [
                            5,
                            6,
                            3,
                            4
                        ],
                        smoothTexture: 1,
                        retouchTexture: 2,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            }), new po({
                name: "basic",
                onRender () {
                    this.set({
                        texture: 0
                    });
                }
            }), new po({
                name: "render_channel",
                onRender () {
                    this.set({
                        texture: 0
                    });
                }
            }), new po({
                name: "overlay",
                onRender () {
                    this.set({
                        texture: 0,
                        overlayMask: co.overlayMask
                    });
                }
            }), new po({
                name: "strip_alpha",
                onRender () {
                    this.set({
                        texture: 0
                    });
                }
            }), new po({
                name: "screen",
                vertex: "screen",
                uniforms: {
                    grid_size: [
                        0,
                        0
                    ]
                },
                onRender (t) {
                    co.cacheTexture.bind(1), this.set({
                        texture: 0,
                        cacheTexture: 1,
                        showTexture: !!t,
                        cropMatrix: co.cropMatrix,
                        viewMatrix: co.viewMatrix,
                        img_size: [
                            co.crop[2],
                            co.crop[3]
                        ],
                        zoom: co.zoom
                    });
                }
            }), new po({
                name: "blur",
                onRender () {
                    this.set({
                        texture: 0
                    });
                }
            }), new po({
                name: "blur_mask",
                onRender () {
                    this.set({
                        texture: 0
                    });
                }
            }), new po({
                name: "border",
                vertex: "border",
                uniforms: {
                    border_color: [
                        1,
                        1,
                        1,
                        1
                    ]
                },
                shouldRender: ()=>!co.cropMode && !(!co.state.border_inset && !co.state.border_ratio),
                onRender () {
                    this.set({
                        texture: 0,
                        matrix: co.borderMatrix
                    });
                }
            }), new po({
                name: "blur_composite",
                vertex: "composite",
                onRender () {
                    co.lensBlurTexture.bind(1), this.set({
                        texture: 0,
                        blurTexture: 1,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix
                    });
                }
            }), new po({
                name: "zoom_blur",
                onRender () {
                    this.set({
                        texture: 0,
                        blur_center: co.state.blur_center,
                        blur_radius: co.state.blur_radius,
                        zoom_blur_strength: co.state.zoom_blur_strength
                    });
                }
            }), new po({
                name: "rotation_blur",
                onRender () {
                    this.set({
                        texture: 0,
                        blur_center: co.state.blur_center,
                        blur_radius: co.state.blur_radius,
                        rotation_blur_strength: co.state.rotation_blur_strength
                    });
                }
            }), new po({
                name: "face",
                vertex: "distortion",
                onRender () {
                    co.dehazeTexture.bind(1), co.intermediateTexture.bind(3), this.set({
                        texture: 0,
                        smoothMap: 1,
                        faceMask: 2,
                        originalTexture: 3,
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            });
            const vo = ()=>{
                co.previewIntermediate = !0;
            };
            uo("fringing", 0, vo), uo("fringing_center", [
                .5,
                .5
            ], vo), uo("fringing_radius", .3, vo), uo("blur_center", [
                .5,
                .5
            ], vo), uo("blur_radius", .3, vo), uo("fringing_hue", 0, vo), uo("distortion_amount", 0, vo), uo("distortion_horizontal", 0, vo), uo("distortion_vertical", 0, vo);
            var mo = r(128), go = r.n(mo), bo = r(1), xo = r.n(bo);
            function yo(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function _o(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            uo("effect", {});
            const wo = {};
            function So(t) {
                const { name: e } = t;
                wo[e] = t;
            }
            function Mo(t) {
                const e = t ? wo[t] : null;
                co.currentEffect = e, co.defaultState.effect = e ? function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var r = null != arguments[e] ? arguments[e] : {};
                        e % 2 ? yo(Object(r), !0).forEach(function(e) {
                            _o(t, e, r[e]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : yo(Object(r)).forEach(function(e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                        });
                    }
                    return t;
                }({}, e.state) : {};
            }
            So({
                name: "reflections",
                state: {
                    type: 0,
                    reflection_center: [
                        .5,
                        .5
                    ],
                    reflection_center_2: [
                        .5,
                        .5
                    ],
                    angle: 0,
                    reflect_x: !0,
                    reflect_y: !1,
                    flip_x: !1,
                    flip_y: !1
                }
            }), new po({
                name: "reflections",
                fragmentShader: r(477),
                onRender () {
                    const t = !!co.textures.length;
                    let e = [
                        0,
                        0,
                        0,
                        0
                    ];
                    t && (co.textures[0].bind(0), co.textures[1].bind(1), co.textures[2].bind(2), co.textures[3].bind(3), e = [
                        2,
                        3,
                        0,
                        1
                    ]), this.set({
                        multitexture: t,
                        textures: e,
                        width: co.texture.width,
                        height: co.texture.height
                    });
                }
            });
            const To = {
                square: Vr.Texture.fromURL(co.getAssetsDir() + "mosaic_pattern_00.png"),
                hexagon: Vr.Texture.fromURL(co.getAssetsDir() + "mosaic_pattern_01.png"),
                dot: Vr.Texture.fromURL(co.getAssetsDir() + "mosaic_pattern_02.png"),
                triangle: Vr.Texture.fromURL(co.getAssetsDir() + "mosaic_pattern_03.png"),
                diamond: Vr.Texture.fromURL(co.getAssetsDir() + "mosaic_pattern_04.png")
            };
            So({
                name: "pixelate",
                state: {
                    pixelate: .1,
                    pattern: "square"
                }
            }), new po({
                name: "pixelate",
                fragmentShader: r(478),
                onRender () {
                    const t = !!co.textures.length;
                    let e = [
                        0,
                        0,
                        0,
                        0
                    ];
                    t && (co.textures[0].bind(0), co.textures[1].bind(1), co.textures[2].bind(2), co.textures[3].bind(3), e = [
                        2,
                        3,
                        0,
                        1
                    ]);
                    const r = co.state.effect.pattern, n = To[r] || To.square;
                    n.bind(4), this.set({
                        multitexture: t,
                        textures: e,
                        patternTexture: 4,
                        patternSize: [
                            n.width,
                            n.height
                        ],
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ]
                    });
                }
            });
            const Io = {
                thumbnail: [],
                history: [],
                screen: []
            };
            function Do(t, e, r, n) {
                if (Io[t]) for(let o, i = 0; i < Io[t].length; i++)o = Io[t][i], o.call(o, e, r, n);
                return t;
            }
            const Eo = (t, e)=>{
                if (!Io[t]) return;
                const r = Io[t].indexOf(e);
                return r >= 0 ? Io[t].splice(r, 1) : void 0;
            };
            const Ao = Object(bo.Record)({
                op: "=",
                val: null
            }), Co = Object(bo.Record)({
                op: "!=",
                val: null,
                newVal: null
            });
            function zo(t, e) {
                return function t(e, r, n, o, i) {
                    if (0 === o && 0 === i) return [];
                    if (o > 0 && i > 0 && Object(bo.is)(r.get(o - 1), n.get(i - 1))) return t(e, r, n, o - 1, i - 1).concat(new Ao({
                        op: "=",
                        val: r.get(o - 1)
                    }));
                    if (o > 0 && i > 0 && o === i && !Object(bo.is)(r.get(o - 1), n.get(i - 1))) return t(e, r, n, o - 1, i - 1).concat(new Co({
                        newVal: n.get(o - 1),
                        val: r.get(o - 1)
                    }));
                    if (i > 0 && (0 === o || e[o][i - 1] >= e[o - 1][i])) return t(e, r, n, o, i - 1).concat(new Ao({
                        op: "+",
                        val: n.get(i - 1)
                    }));
                    if (o > 0 && (0 === i || e[o][i - 1] < e[o - 1][i])) return t(e, r, n, o - 1, i).concat(new Ao({
                        op: "-",
                        val: r.get(o - 1)
                    }));
                    throw new Error("Invalid arguments to printDiff, " + JSON.stringify({
                        i: o,
                        j: i
                    }));
                }(Oo(t, e), t, e, t.size || 0, e.size || 0);
            }
            function Oo(t, e) {
                const r = t.size || 0, n = e.size || 0, o = function(t, e, r) {
                    const n = [];
                    for(let o = 0; o < t; o++){
                        n[o] = new Array(e);
                        for(let t = 0; t < e; t++)n[o][t] = r;
                    }
                    return n;
                }(r + 1, n + 1, 0);
                for(let i = 0; i < r; i++)for(let r = 0; r < n; r++)Object(bo.is)(t.get(i), e.get(r)) ? o[i + 1][r + 1] = o[i][r] + 1 : o[i + 1][r + 1] = Math.max(o[i + 1][r], o[i][r + 1]);
                return o;
            }
            const { isMap: Fo } = bo.Map, { isIndexed: Ro } = bo.Iterable;
            function Po(t) {
                return null != t && t.toJS ? t.toJS() : t;
            }
            function Lo(t, e, r) {
                return "remove" === t ? {
                    op: t,
                    path: e
                } : {
                    op: t,
                    path: e,
                    value: r
                };
            }
            function ko(t, e, r = []) {
                var n = [];
                if (Object(bo.is)(t, e)) return n;
                var o = Ro(t) && Ro(e), i = null, a = null;
                return t.forEach && t.forEach((t, c)=>{
                    if (e.has(c)) {
                        if (Fo(t) && Fo(e.get(c))) n = n.concat(ko(t, e.get(c), r.concat(c)));
                        else if (Ro(e.get(c)) && Ro(t)) n = n.concat(jo(t, e.get(c), r.concat(c)));
                        else {
                            var u = e.get ? e.get(c) : e;
                            t !== u && n.push(Lo("replace", r.concat(c), Po(u)));
                        }
                    } else o ? (a = null != i && i + 1 === c ? a : c, n.push(Lo("remove", r.concat(a))), i = c) : n.push(Lo("remove", r.concat(c)));
                }), e.forEach((e, o)=>{
                    t.has && !t.has(o) && n.push(Lo("add", r.concat(o), Po(e)));
                }), n;
            }
            function jo(t, e, r = []) {
                var n = [];
                if (Object(bo.is)(t, e)) return n;
                if (e.count() > 1e3 || t.count() > 1e3) return n.push(Lo("replace", r, Po(e))), n;
                if (e.count() > 100) return ko(t, e, r);
                var o = zo(t, e), i = 0;
                return o.forEach((t)=>{
                    if ("=" === t.op) i++;
                    else if ("!=" === t.op) {
                        if (Fo(t.val) && Fo(t.newVal)) {
                            var e = ko(t.val, t.newVal, r.concat(i));
                            n = n.concat(e);
                        } else n.push(Lo("replace", r.concat(i), Po(t.newVal)));
                        i++;
                    } else "+" === t.op ? (n.push(Lo("add", r.concat(i), Po(t.val))), i++) : "-" === t.op && n.push(Lo("remove", r.concat(i)));
                }), n;
            }
            function Uo(t, e, r) {
                return Ro(t) && Ro(e) ? jo(t, e) : Fo(t) && Fo(e) ? ko(t, e) : function(t, e, r = []) {
                    return t === e ? [] : [
                        Lo("replace", r, Po(e))
                    ];
                }(t, e, r);
            }
            const Bo = xo.a.List.isList;
            var No = (t, e, r = !0)=>t.withMutations((t)=>{
                    e.forEach((e)=>{
                        const n = ((t)=>("string" == typeof t && (t = t.split("/")), xo.a.fromJS(t)))(e.path), o = ((t)=>xo.a.fromJS(t))(e.value);
                        if ("remove" === e.op) return t.deleteIn(n);
                        if ("add" === e.op && r) {
                            let e, r;
                            if (n.size > 1 && (r = n.pop(), e = t.getIn(r)), Bo(e)) {
                                const i = e.insert(n.last(), o);
                                t.setIn(r, i);
                            } else t.setIn(n, o);
                        } else t.setIn(n, o);
                    });
                });
            function Go(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function Vo(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? Go(Object(r), !0).forEach(function(e) {
                        qo(t, e, r[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Go(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }
            function qo(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            const Yo = bo.Map.isMap, Ho = bo.List.isList;
            let Wo = !1, Xo = null, Ko = {};
            const Zo = {
                history: bo.List(),
                historyIndex: 0,
                prevIndex: 0,
                rasterizeIndex: 0,
                minIndex: 0
            }, Jo = {
                skin_smoothness: 0,
                skin_tone: 0,
                skin_hue: 0,
                skin_saturation: 0,
                skin_shadows: 0,
                skin_highlights: 0,
                teeth_whitening: 0,
                teeth_brightness: 0,
                eyes_brightness: 0,
                eyes_contrast: 0,
                eyes_clarity: 0,
                lips_brightness: 0,
                lips_saturation: 0
            }, $o = {
                eye_size: [
                    0,
                    0
                ],
                eye_height: [
                    0,
                    0
                ],
                eye_width: [
                    0,
                    0
                ],
                eye_tilt: [
                    0,
                    0
                ],
                eye_position: [
                    [
                        0,
                        0
                    ],
                    [
                        0,
                        0
                    ]
                ],
                face_width: 0,
                jaw_width: 0,
                forehead_height: 0,
                chin_height: 0,
                nose_width: 0,
                nose_height: 0,
                mouth_width: 0,
                mouth_height: 0,
                upper_lip: 0,
                lower_lip: 0,
                smile: 0
            }, Qo = {
                blur: 0,
                sharpen: 0,
                color_denoise: 0,
                luminance_denoise: 0,
                diffuse: 0,
                clarity: 0,
                dehaze: 0,
                whites: 0,
                blacks: 0,
                highlights: 0,
                shadows: 0,
                exposure: 0,
                gamma: 0,
                temperature: 0,
                tint: 0,
                contrast: 0,
                saturation: 0,
                vibrance: 0,
                highlights_hue: 0,
                highlights_saturation: 0,
                shadows_hue: 0,
                shadows_saturation: 0,
                balance: 0,
                invert: 0,
                grain_highlights: .25,
                grain_amount: 0,
                grain_size: .25,
                grain_roughness: .5,
                vignette_amount: 0,
                vignette_feather: .5,
                vignette_highlights: .5,
                vignette_roundness: 0,
                vignette_size: 1,
                lookup_intensity: 0
            }, ti = {
                sharpen: 0,
                diffuse: 0,
                clarity: 0,
                dehaze: 0,
                whites: 0,
                blacks: 0,
                highlights: 0,
                shadows: 0,
                exposure: 0,
                gamma: 0,
                temperature: 0,
                tint: 0,
                contrast: 0,
                saturation: 0,
                vibrance: 0,
                highlights_hue: 0,
                highlights_saturation: 0,
                shadows_hue: 0,
                shadows_saturation: 0,
                balance: 0,
                invert: 0,
                grain_highlights: .25,
                grain_amount: 0,
                grain_size: .25,
                grain_roughness: .5,
                vignette_amount: 0,
                vignette_feather: .5,
                vignette_center: [
                    .5,
                    .5
                ],
                vignette_highlights: .5,
                vignette_roundness: 0,
                vignette_size: 1,
                lookup_intensity: 0
            }, ei = (t, e, r)=>{
                uo(t, e, r);
            }, ri = (t, e)=>{
                co.state[t] = e;
            }, ni = (t, e)=>{
                const r = t[0], n = co.state[r];
                if (!co.defaultState.hasOwnProperty(r)) return;
                let o = co.state, i = "";
                if (t.forEach((t)=>{
                    o = null != o ? o[t] : null, i += "/" + t;
                }), null != o) {
                    Ko.toUpdate = Ko.toUpdate || {}, Ko.toUpdate[i] = Ko.toUpdate[i] || {
                        path: t,
                        value: {}
                    };
                    for(const t in e)Ko.toUpdate[i].value[t] = e[t], o[t] = e[t];
                    co.stateMap[r](n), fi(), Wo = !1;
                }
            }, oi = (t)=>{
                for(const e in t){
                    const r = t[e];
                    co.defaultState.hasOwnProperty(e) && (Wo && (Ko.toMerge = Ko.toMerge || {}, Ko.toMerge[e] = r), co.state[e] = r, co.stateMap[e](r));
                }
                fi(), Wo = !1;
            }, ii = (t)=>{
                Wo = t;
            }, ai = (t, e)=>{
                const r = Tn(e);
                for(const n in t){
                    const o = t[n];
                    e.hasOwnProperty(n) && (r[n] = o);
                }
                return r;
            }, ci = (t)=>{
                const e = ai(t, co.defaultState);
                return e.local_adjustments.forEach((t)=>{
                    t.adjustments = ai(t.adjustments, Qo);
                }), e.faces && e.faces.length && (e.face_features || (e.face_features = []), e.faces.forEach((t, r)=>{
                    t.adjustments = t.adjustments || xi(!0), e.face_features[r] = e.face_features[r] || yi(!0);
                })), e;
            }, ui = (t = li(), e = Zo.history)=>{
                let r = co.defaultState;
                return e.size && (r = e.getIn([
                    t,
                    "state"
                ]).toJS()), ci(r);
            }, si = async (t)=>{
                t = Number(t), Zo.historyIndex = un(t, Zo.minIndex, Zo.history.size - 1);
                let e = [];
                if (Zo.historyIndex < Zo.rasterizeIndex && (e.push({
                    index: 0,
                    action: Pn.REVERT
                }), Zo.prevIndex = 0), Zo.historyIndex > Zo.prevIndex) for(let t = Zo.prevIndex + 1; t <= Zo.historyIndex; t++){
                    const r = Zo.history.getIn([
                        t,
                        "action"
                    ]), n = Zo.history.getIn([
                        t,
                        "actionOptions"
                    ]);
                    switch(r){
                        case Pn.REVERT:
                            e = Zo.rasterizeIndex > 0 ? [
                                {
                                    index: t,
                                    action: r
                                }
                            ] : [];
                            break;
                        case Pn.RASTERIZE:
                        case Pn.FLATTEN_STATE:
                            e.push({
                                index: t,
                                action: r,
                                actionOptions: n
                            });
                    }
                }
                if (e.length) {
                    Do("begin_rasterize");
                    for(let t = 0; t < e.length; t++){
                        const { index: r, action: n, actionOptions: o } = e[t];
                        switch(n){
                            case Pn.REVERT:
                                await co.reloadSource();
                                break;
                            case Pn.RASTERIZE:
                                if (oi(ui(r - 1)), await co.rasterize(), o) {
                                    const { effect: t, state: e } = o;
                                    t && (oi(ui(r)), Mo(t), oi({
                                        effect: e
                                    }), await co.rasterize(), Mo(null));
                                }
                                break;
                            case Pn.FLATTEN_STATE:
                                if (o) {
                                    const { state: t } = o;
                                    oi(ci(t));
                                }
                                await co.rasterize();
                        }
                        Zo.rasterizeIndex = r;
                    }
                    Do("end_rasterize");
                }
                0 === Zo.rasterizeIndex && (Vr.Texture.delete(co.originalTexture), co.originalTexture = null), Zo.prevIndex = Zo.historyIndex, oi(ui()), Ko = {};
            }, li = ()=>Zo.historyIndex, fi = ()=>{
                Xo && (((t)=>{
                    const e = Zo.history.getIn([
                        li(),
                        "state"
                    ]).withMutations((t)=>{
                        if (Ko.toUpdate) {
                            let e, r;
                            for(const n in Ko.toUpdate){
                                if (e = Ko.toUpdate[n], void 0 === t.getIn(e.path)) {
                                    const r = e.path[0];
                                    t.set(r, bo.fromJS(co.state[r]));
                                }
                                t.updateIn(e.path, (t)=>(r = bo.fromJS(e.value), Yo(t) ? t.merge(r) : r));
                            }
                        }
                        Ko.toMerge && t.merge(bo.fromJS(Ko.toMerge));
                    });
                    Zo.history.size - 1 > li() && (Zo.history = Zo.history.setSize(li() + 1));
                    const r = bo.Map(Vo({
                        state: e
                    }, t));
                    Zo.history = Zo.history.push(r), Zo.historyIndex = Zo.history.size - 1, Ko = {};
                })({
                    message: Xo.message,
                    changed: Xo.changed
                }), Xo.complete(), Xo = null);
            };
            function hi(t, e) {
                Zo.history.size - 1 > li() && (Zo.history = Zo.history.setSize(li() + 1));
                const r = bo.Map({
                    state: bo.fromJS(gi()),
                    action: Pn.RASTERIZE,
                    actionOptions: e,
                    message: t
                });
                return Zo.history = Zo.history.push(r), si(Zo.history.size - 1);
            }
            const di = (t, e)=>(Zo.history = Ho(t) ? t : bo.fromJS(t), e = null != e ? e : Zo.history.size - 1, si(e)), pi = (t)=>{
                console.time("loadSavedHistory"), Zo.history = bo.List().withMutations((e)=>{
                    let r;
                    t.forEach((t)=>{
                        if (null != t) {
                            if (t.patch) {
                                const e = r.get("state"), n = No(e, t.patch), o = {
                                    message: t.message,
                                    state: n
                                };
                                null != t.changed && Object.assign(o, {
                                    changed: t.changed
                                }), null != t.action && Object.assign(o, {
                                    action: t.action,
                                    actionOptions: t.actionOptions
                                }), r = bo.Map(o);
                            } else r = bo.fromJS(t);
                            e.push(r);
                        }
                    });
                }), console.timeEnd("loadSavedHistory");
                const e = t[0] && t[0].index, r = Zo.history.size - 1, n = null != e ? Math.min(e, r) : r;
                return si(n);
            }, vi = ()=>Zo.history, mi = (t = !1)=>t ? Tn(co.state) : co.state, gi = (t)=>t ? Tn(co.defaultState) : co.defaultState, bi = (t)=>t ? Tn(Qo) : Qo, xi = (t)=>t ? Tn(Jo) : Jo, yi = (t)=>t ? Tn($o) : $o;
            ei("rotation", 0, zi), ei("rotate90", 0, Oi), ei("flip_y", 0, function(t) {
                _i = !0, co.flipY = !!t, co.screen.rotation[0] = 180 * co.flipY, Ui(-co.rotation);
            }), ei("flip_x", 0, function(t) {
                _i = !0, co.flipX = !!t, co.screen.rotation[1] = 180 * co.flipX, Ui(-co.rotation);
            }), ei("crop", [
                0,
                0,
                1,
                1
            ], Di), ei("crop_ratio", 0), ei("border_ratio", 0, Ii), ei("border_inset", 0, Ii);
            let _i = !0;
            const wi = co.pixelRatio, Si = bn(180), Mi = o.create();
            o.rotateX(Mi, Mi, Si);
            const Ti = o.create();
            function Ii() {
                Di(co.state.crop);
            }
            function Di(t) {
                const e = Ei(), r = co.state.border_ratio, n = i.length([
                    e[0] * t[2],
                    e[1] * t[3]
                ]) * co.state.border_inset * .25;
                if (t[0] = un(t[0], 0, 1), t[1] = un(t[1], 0, 1), t[2] = un(t[2], 0, 1 - t[0]), t[3] = un(t[3], 0, 1 - t[1]), co.crop = [
                    e[0] * t[0],
                    e[1] * t[1],
                    e[0] * t[2],
                    e[1] * t[3]
                ], co.crop[0] -= n, co.crop[1] -= n, co.crop[2] += 2 * n, co.crop[3] += 2 * n, r) {
                    let t = co.crop[2], e = co.crop[3];
                    const n = t, o = t * r, i = Math.max(t / n, e / o);
                    t = n * i, e = o * i;
                    const a = t - co.crop[2], c = e - co.crop[3];
                    co.crop[0] -= a / 2, co.crop[1] -= c / 2, co.crop[2] = t, co.crop[3] = e;
                }
                co.crop = co.crop.map(Math.round), co.borderCrop = [
                    co.crop[0] / e[0],
                    co.crop[1] / e[1],
                    co.crop[2] / e[0],
                    co.crop[3] / e[1]
                ], _i = !0;
            }
            o.rotateY(Ti, Ti, Si);
            const Ei = ()=>co.rotate90 % 2 ? [
                    co.texture.height,
                    co.texture.width
                ] : [
                    co.texture.width,
                    co.texture.height
                ], Ai = function() {
                return [
                    co.canvas.width,
                    co.canvas.height
                ];
            }, Ci = function() {
                return co.rotate90 % 2 ? [
                    co.flipY,
                    co.flipX
                ] : [
                    co.flipX,
                    co.flipY
                ];
            };
            function zi(t) {
                _i = !0, co.rotation = t;
                const e = Ei(), r = e[0] / 2, n = e[1] / 2, o = r, i = n, a = co.rotation * (Math.PI / 180), c = Math.abs(Math.cos(a)), u = Math.abs(Math.sin(a));
                co.cropScale = Math.min(1, r / (o * c + i * u), n / (o * u + i * c)), Ui(-co.rotation);
            }
            function Oi(t) {
                co.rotate90 = t % 4;
                const e = Ei();
                Bi(-co.rotate90), Li(e[0], e[1]), Ui(-co.rotation);
            }
            const Fi = function(t, e) {
                _i = !0, co.offset[0] = t, co.offset[1] = e;
            }, Ri = function(t = {}) {
                const e = t.margins || co.margins, r = t.size || Ei(), n = Ai(), o = co.cropMode || t.useImageSize ? r[0] : co.crop[2], i = co.cropMode || t.useImageSize ? r[1] : co.crop[3], a = n[0] - (e[0] + e[2]) * wi, c = n[1] - (e[1] + e[3]) * wi;
                return Math.min(1, a / o, c / i);
            }, Pi = function() {
                const { margins: t } = co;
                return [
                    (t[0] - t[2]) * wi / 2,
                    (t[1] - t[3]) * wi / 2
                ];
            }, Li = function(t, e) {
                return _i = !0, o.ortho(co.projectionMatrix, t / -2, t / 2, e / -2, e / 2, -9999, 9999), o.invert(co.projectionMatrixInv, co.projectionMatrix);
            }, ki = function(t, e) {
                const r = Ei(), n = r[0] / 2 / t, i = r[1] / 2 / e;
                o.identity(co.scaleMatrix), o.scale(co.scaleMatrix, co.scaleMatrix, [
                    n,
                    i,
                    1
                ]);
            }, ji = function(t, e) {
                const r = Ei();
                o.identity(co.translationMatrix);
                return o.translate(co.translationMatrix, co.translationMatrix, [
                    t / r[0] * 2,
                    e / r[1] * 2,
                    0
                ]);
            }, Ui = function(t) {
                const e = Ci();
                if (o.identity(co.rotationMatrix), o.rotateZ(co.rotationMatrix, co.rotationMatrix, bn(t)), e[0] && o.multiply(co.rotationMatrix, co.rotationMatrix, Ti), e[1]) return o.multiply(co.rotationMatrix, co.rotationMatrix, Mi);
            }, Bi = function(t) {
                return o.identity(co.rotation90Matrix), o.rotateZ(co.rotation90Matrix, co.rotation90Matrix, bn(90 * t)), o.invert(co.rotation90MatrixInv, co.rotation90Matrix);
            }, Ni = function() {
                return o.identity(co.matrix), o.multiply(co.matrix, co.matrix, co.projectionMatrix), o.multiply(co.matrix, co.matrix, co.scaleMatrix), o.multiply(co.matrix, co.matrix, co.translationMatrix), co.viewMatrix = o.clone(co.matrix), co.cropMode || (o.multiply(co.matrix, co.matrix, co.projectionMatrix), o.multiply(co.matrix, co.matrix, co.rotationMatrix), o.multiply(co.matrix, co.matrix, co.projectionMatrixInv), o.multiply(co.matrix, co.matrix, co.rotation90Matrix)), o.invert(co.matrixInv, co.matrix), co.matrix;
            }, Gi = function(t, e, r, n) {
                o.identity(co.cropMatrix), o.scale(co.cropMatrix, co.cropMatrix, [
                    r,
                    n,
                    1
                ]), o.translate(co.cropMatrix, co.cropMatrix, [
                    t,
                    e,
                    0
                ]);
            }, Vi = function() {
                const [t, e, r, n] = co.state.crop;
                o.scale(co.borderMatrix, co.viewMatrix, [
                    co.cropScale,
                    co.cropScale,
                    1
                ]), o.translate(co.borderMatrix, co.borderMatrix, [
                    2 * t - 1,
                    2 * -e + 1,
                    0
                ]), o.scale(co.borderMatrix, co.borderMatrix, [
                    r,
                    n,
                    1
                ]), o.translate(co.borderMatrix, co.borderMatrix, [
                    1,
                    -1,
                    0
                ]), o.invert(co.borderMatrix, co.borderMatrix);
            }, qi = function() {
                let t, e, r, n, i, a, c, u;
                const s = co.texture.width * co.screen.zoom / co.cropScale, l = co.texture.height * co.screen.zoom / co.cropScale, f = co.rotation + co.screen.rotation[2] + 90 * co.rotate90, h = co.borderCrop, d = Ei();
                co.cropMode ? (r = Math.round(s / 2), n = Math.round(l / 2), t = co.screen.rotation[0], e = co.screen.rotation[1], c = 0, u = 0) : (r = Math.round(co.crop[2] / 2 * co.screen.zoom), n = Math.round(co.crop[3] / 2 * co.screen.zoom), c = ((1 - h[2]) / 2 - h[0]) * d[0] * co.screen.zoom, u = ((1 - h[3]) / 2 - h[1]) * d[1] * co.screen.zoom), i = -co.screen.offset[0] + co.screen.center[0], a = -co.screen.offset[1] - co.screen.center[1], co.overlay.imageWidth = d[0], co.overlay.imageHeight = d[1], co.overlay.width = s, co.overlay.height = l, co.overlay.rotation = f, co.overlay.flipX = co.flipX ? -1 : 1, co.overlay.flipY = co.flipY ? -1 : 1, co.overlay.tx = i + c, co.overlay.ty = a - u;
                const p = [
                    i,
                    a,
                    co.invFov
                ], v = [
                    r,
                    n,
                    1
                ], m = [
                    co.overlay.tx,
                    co.overlay.ty,
                    co.invFov
                ], g = [
                    s * co.overlay.flipX * .5,
                    l * co.overlay.flipY * .5,
                    1
                ];
                return o.translate(co.overlayMatrix, co.perspectiveMatrix, m), o.translate(co.screenMatrix, co.perspectiveMatrix, p), co.cropMode ? (o.rotateZ(co.screenMatrix, co.screenMatrix, bn(-f)), o.scale(co.screenMatrix, co.screenMatrix, v), o.rotateX(co.screenMatrix, co.screenMatrix, bn(t)), o.rotateY(co.screenMatrix, co.screenMatrix, bn(e))) : o.scale(co.screenMatrix, co.screenMatrix, v), o.rotateZ(co.overlayMatrix, co.overlayMatrix, bn(-f)), o.scale(co.overlayMatrix, co.overlayMatrix, g), co.screenMatrix;
            }, Yi = function() {
                let t, e;
                co.downsampleFactor > 1 ? (e = 32 * Math.floor(co.compositeResolution[0] / co.downsampleFactor / 32), t = 32 * Math.floor(co.compositeResolution[1] / co.downsampleFactor / 32)) : (e = co.compositeResolution[0], t = co.compositeResolution[1]), Vr.Texture.setSize(co.readableTexture, e, t), Vr.Texture.setSize(co.writableTexture, e, t);
            }, Hi = function(t) {
                const e = co.layers[t.textureIndex || 0];
                if (!e) return;
                const r = [
                    co.texture.width,
                    co.texture.height
                ], [n, i] = r, a = t.scale.concat([
                    1
                ]), c = e.matrix ? o.identity(e.matrix) : o.create(), u = o.create(), s = o.create();
                o.ortho(u, n / -2, n / 2, i / -2, i / 2, -1, 1), o.invert(s, u), o.translate(c, c, [
                    t.position[0],
                    t.position[1],
                    0
                ]), o.multiply(c, c, u), o.rotateZ(c, c, bn(-t.angle)), o.multiply(c, c, s), o.scale(c, c, a), e.matrix = c;
            };
            var Wi = {
                getCanvasSize: Ai,
                getCenter: Pi,
                getCrop: function() {
                    return co.crop;
                },
                getCropScale: function() {
                    return co.cropScale;
                },
                getFlip: Ci,
                getImageInfo: function() {
                    if (!co.photoLoaded) return {
                        zoom: 0,
                        megapixels: 0,
                        cropWidth: 0,
                        cropHeight: 0,
                        width: 0,
                        height: 0,
                        ratio: [
                            0,
                            0
                        ]
                    };
                    const t = Ei(), e = new go.a(co.crop[2] / co.crop[3]);
                    return {
                        zoom: Math.round(1e3 * co.zoom) / 10,
                        megapixels: Math.round(co.texture.width * co.texture.height / 1e4) / 100,
                        cropWidth: Math.round(co.crop[2]),
                        cropHeight: Math.round(co.crop[3]),
                        width: t[0],
                        height: t[1],
                        ratio: [
                            e.n,
                            e.d
                        ]
                    };
                },
                getImageSize: Ei,
                getMargins: function() {
                    return co.margins;
                },
                getMinZoom: Ri,
                getOffset: function() {
                    return [
                        co.offset[0],
                        co.offset[1]
                    ];
                },
                getOverlayProps: function() {
                    return co.overlay;
                },
                getScreenProps: function() {
                    return co.screen;
                },
                getTextureSize: function() {
                    return [
                        co.texture.width,
                        co.texture.height
                    ];
                },
                getZoom: function() {
                    return co.screen.zoom;
                },
                hasAlpha: function() {
                    return co.textureFormat === co.gl.RGBA;
                },
                pixelRatio: wi,
                resampleTextures: Yi,
                rotateCrop: function(t, e = co.state.crop) {
                    let r = e[0] - .5, n = e[1] - .5, o = r + e[2], i = n + e[3];
                    const a = an([
                        r,
                        n
                    ], t), c = an([
                        o,
                        n
                    ], t), u = an([
                        o,
                        i
                    ], t), s = an([
                        r,
                        i
                    ], t);
                    return r = Math.min(a[0], c[0], u[0], s[0]) + .5, n = Math.min(a[1], c[1], u[1], s[1]) + .5, o = Math.max(a[0], c[0], u[0], s[0]) + .5, i = Math.max(a[1], c[1], u[1], s[1]) + .5, [
                        r,
                        n,
                        o - r,
                        i - n
                    ];
                },
                setMargins: function(t) {
                    return _i = !0, co.margins = t;
                },
                setOffset: Fi,
                setRotation: zi,
                setRotation90: Oi,
                setSize: Li,
                setZoom: function(t, e) {
                    _i = !0, co.prevZoom = co.zoom, t = t || Ri() || 1, t = un(t, 0, 5);
                    const r = co.zoom / t;
                    if (co.zoom = t, e) {
                        const t = (e[0] + co.offset[0]) / r - e[0], n = (e[1] + co.offset[1]) / r - e[1];
                        return Fi(t, n);
                    }
                },
                update: function(t = !1) {
                    if (!_i && !t) return;
                    const e = Ei(), r = Ai();
                    let { crop: n, cropScale: o } = co;
                    co.cropMode && (n = [
                        0,
                        0,
                        e[0],
                        e[1]
                    ], o = 1);
                    const i = e[0] / 2, a = e[1] / 2;
                    n = [
                        (n[0] - i) * o + i,
                        (n[1] - a) * o + a,
                        n[2] * o,
                        n[3] * o
                    ];
                    const c = co.zoom / o, u = Pi(), s = co.offset[0] - u[0], l = u[1] + co.offset[1], f = n[2] * c, h = n[3] * c, d = r[0] - f >> 1, p = r[1] - h >> 1;
                    let v = d - s, m = p - l;
                    v += r[0] % 2 / 2, m += r[1] % 2 / 2;
                    let g = v + f - r[0], b = m + h - r[1];
                    f < r[0] && (g = Math.min(0, v) + Math.max(0, g)), h < r[1] && (b = Math.min(0, m) + Math.max(0, b)), g /= c, b /= c;
                    const x = Math.min(r[0] / c, n[2]), y = Math.min(r[1] / c, n[3]), _ = n[2] - x >> 1, w = n[3] - y >> 1, S = (e[0] - n[2]) / 2 - n[0], M = -(e[1] - n[3]) / 2 + n[1];
                    let T = _ - un(g, 0, n[2] - x) - S, I = w - un(b, 0, n[3] - y) - M, D = x / e[0], E = y / e[1];
                    co.compositeResolution[0] = Math.min(r[0], Math.round(f)), co.compositeResolution[1] = Math.min(r[1], Math.round(h)), co.compositeCoords[0] = un(s, d, -d) - s, co.compositeCoords[1] = un(l, p, -p) - l, co.compositeCoords[2] = co.compositeCoords[0] + co.compositeResolution[0], co.compositeCoords[3] = co.compositeCoords[1] + co.compositeResolution[1], co.downsampleResolution[0] = Math.round(co.texture.width * co.zoom), co.downsampleResolution[1] = Math.round(co.texture.height * co.zoom), ji(-T, -I), ki(D, E), Ni(), T = -S / n[2] * 2, I = -M / n[3] * 2, D = n[2] / e[0], E = n[3] / e[1], Gi(T, I, D, E), Vi(), qi(), Yi(), co.minZoom = Ri(), co.needsUpdate = !0, _i = !1;
                },
                updateForOutput: (t, e, r = !0, n = !0, o)=>{
                    let i;
                    _i = !0, i = n ? Ei() : [
                        co.texture.width,
                        co.texture.height
                    ];
                    const a = i[0] / 2, c = i[1] / 2;
                    let { crop: u } = co;
                    o && (u = [
                        u[0] + o[0],
                        u[1] + o[1],
                        Math.floor(u[2] * o[2]),
                        Math.floor(u[3] * o[3])
                    ]), u = n ? [
                        (u[0] - a) * co.cropScale + a,
                        (u[1] - c) * co.cropScale + c,
                        u[2] * co.cropScale,
                        u[3] * co.cropScale
                    ] : [
                        0,
                        0,
                        i[0],
                        i[1]
                    ];
                    const s = -(i[0] - u[2]) / 2 + u[0], l = (i[1] - u[3]) / 2 - u[1], f = u[2] / i[0], h = u[3] / i[1], d = s / u[2] * 2, p = l / u[3] * 2, v = r ? -1 : 1;
                    ji(-s, -l), ki(f, h * v), Ni(), Gi(d, p, f, h), Vi(), co.downsampleResolution[0] = Math.round(co.texture.width * u[2] * co.zoom), co.downsampleResolution[1] = Math.round(co.texture.height * u[3] * co.zoom), Vr.Texture.setSize(co.readableTexture, t, e), Vr.Texture.setSize(co.writableTexture, t, e), co.needsUpdate = !0;
                },
                updateScreenMatrix: qi
            };
            const { gl: Xi } = co, Ki = new Float32Array(3);
            ei("local_adjustments", [], (t)=>{
                (t = t || []).forEach((t)=>{
                    t.layer && Hi(t.layer), t.layers && t.layers.forEach((t)=>Hi(t));
                });
            });
            const Zi = (t)=>{
                if (t.disabled) return;
                let e;
                t.mask && (t.mask.disabled || (Ji(t.mask), t.mask.showOverlay && (e = t.mask)));
                const { texture: r, matrix: n } = co.layers[t.textureIndex] || {};
                if (null == r) return;
                r.bind(1);
                const i = co.tmpMatrix;
                o.multiply(i, co.matrix, n), o.invert(i, i);
                const a = co.blendModes[t.blendMode] || 0, c = co.gradientTypes[t.gradientType] || 0;
                return fo.layer.set({
                    layerTexture: 1,
                    opacity: t.opacity,
                    fill: t.fill,
                    blendMode: a,
                    gradient: c,
                    reverse: t.reverse || 0,
                    repeat: t.repeat || 0,
                    reflect: t.reflect || 0,
                    backgroundMatrix: i
                }), ho("layer"), e;
            }, Ji = (t, e = 1, r = 0)=>{
                switch(t.type){
                    case "radial":
                        fo.mask_radial.set({
                            feather: t.feather,
                            size: t.size,
                            position: t.position,
                            angle: t.angle || 0,
                            invert: t.invert,
                            opacity: e,
                            alpha: r
                        }), ho("mask_radial");
                        break;
                    case "gradient":
                        fo.mask_gradient.set({
                            startPoint: t.startPoint,
                            endPoint: t.endPoint,
                            reflect: t.reflect,
                            invert: t.invert,
                            opacity: e,
                            alpha: r
                        }), ho("mask_gradient");
                        break;
                    case "color":
                        fo.mask_color.set({
                            feather: t.feather,
                            threshold: t.threshold,
                            size: t.size,
                            angle: t.angle || 0,
                            position: t.position,
                            useRadius: t.useRadius,
                            selectedColor: t.selectedColor || Ki,
                            useSelectedColor: !!t.selectedColor,
                            invert: t.invert,
                            opacity: e,
                            alpha: r
                        }), ho("mask_color");
                        break;
                    case "brush":
                        co.brushTextures[t.id] ? co.brushTextures[t.id].bind(1) : e = 0, fo.mask_brush.set({
                            brushTexture: 1,
                            invert: t.invert,
                            mode: t.mode,
                            opacity: e,
                            alpha: r
                        }), ho("mask_brush");
                        break;
                    case "depth":
                        fo.mask_depth.set({
                            target: t.target,
                            range: t.range,
                            invert: t.invert,
                            opacity: e,
                            alpha: r
                        }), ho("mask_depth");
                        break;
                    case "luminance":
                        fo.mask_luminance.set({
                            target: t.target,
                            range: t.range,
                            smoothness: t.smoothness,
                            invert: t.invert,
                            opacity: e,
                            alpha: r
                        }), ho("mask_luminance");
                        break;
                    case "object":
                        co.objectMasks[t.index] ? co.objectMasks[t.index].bind(2) : e = 0, fo.mask_object.set({
                            objectMask: 2,
                            invert: t.invert,
                            opacity: e,
                            alpha: r,
                            useRefine: t.feather && (co.capabilities.canRenderToFloatTexture || co.capabilities.canRenderToHalfFloatTexture)
                        }), ho("mask_object");
                }
            }, $i = (t, e, r)=>{
                let n;
                if (t.showOverlay && (n = t), Ji(t, e, r), t.masks && t.masks.length) for(let r, o = 0; o < t.masks.length; o++)r = t.masks[o], r.disabled || (Ji(r, e), r.showOverlay && (n = r));
                return n;
            };
            function Qi(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            const { gl: ta } = co, ea = function() {
                let t = {};
                const e = _n(function(e, r, n, o) {
                    ra(e, r, n, o), t = {};
                });
                return function(r, n, o, i) {
                    for(const e in r){
                        const n = r[e];
                        t[e] = n;
                    }
                    e(t, n, o, i);
                };
            }(), ra = function(t, e, r, n, o) {
                if (!co.photoLoaded) return void (co.readyProps = t);
                t.margins && Wi.setMargins(t.margins), t.position && Wi.setOffset(t.position[0], t.position[1]), null != t.rotation && Wi.setRotation(t.rotation), null != t.zoom && Wi.setZoom(t.zoom, t.origin);
                const i = null != t.rotateX ? t.rotateX : co.screen.rotation[0], a = null != t.rotateY ? t.rotateY : co.screen.rotation[1], c = null != t.rotateZ ? t.rotateZ : co.screen.rotation[2];
                na({
                    center: Wi.getCenter(),
                    offset: co.offset,
                    rotation: [
                        i,
                        a,
                        c
                    ],
                    zoom: co.zoom
                }, e, r, n, o);
            }, na = function() {
                let t = Function.prototype, e = Function.prototype, r = Function.prototype;
                const n = [], o = [], i = function(r) {
                    return co.screen.zoom = r[0], co.screen.center = [
                        r[1],
                        r[2]
                    ], co.screen.offset = [
                        r[3],
                        r[4]
                    ], co.screen.rotation = [
                        r[5],
                        r[6],
                        r[7]
                    ], Wi.updateScreenMatrix(), Do("screenDidUpdate"), e && ua(), "function" == typeof t ? t(r) : void 0;
                };
                return function(a, c, u, s, l = !0) {
                    return t = s, e = l, Do("screenWillUpdate"), n[0] = a.zoom, n[1] = a.center[0], n[2] = a.center[1], n[3] = a.offset[0], n[4] = a.offset[1], n[5] = a.rotation[0], n[6] = a.rotation[1], n[7] = a.rotation[2], c ? (o[0] = co.screen.zoom, o[1] = co.screen.center[0], o[2] = co.screen.center[1], o[3] = co.screen.offset[0], o[4] = co.screen.offset[1], o[5] = co.screen.rotation[0], o[6] = co.screen.rotation[1], o[7] = co.screen.rotation[2], r(), r = Cn(o, n, c, (t)=>i(t), u)) : (i(n), "function" == typeof u ? u() : void 0);
                };
            }(), oa = [];
            class ia {
                constructor(t){
                    Qi(this, "render", Function.prototype), Qi(this, "state", {}), Qi(this, "defaultState", {}), Qi(this, "zIndex", 0), this.render = t.render || Function.prototype, this.state = t.state || {}, this.defaultState = t.defaultState || {}, this.zIndex = t.zIndex || 0;
                }
                setState(t) {
                    Object.assign(this.state, t);
                }
                enable() {
                    this.state.enabled = !0;
                    -1 === oa.indexOf(this) && (oa.push(this), oa.sort((t, e)=>t.zIndex - e.zIndex));
                }
                disable() {
                    this.state.enabled = !1;
                    const t = oa.indexOf(this);
                    -1 !== t && oa.splice(t, 1);
                }
            }
            const aa = function(t) {
                return new ia(t);
            }, ca = ()=>ta.clear(ta.COLOR_BUFFER_BIT), ua = (t = !1, e = co.screenTexture)=>{
                t && (Wi.update(), co.writableTexture.drawTo(ca), co.readableTexture.drawTo(ca), ta.disable(ta.BLEND), ta.loadMatrix(co.matrix), co.originalTexture ? fo.display.render(co.originalTexture, co.readableTexture) : co.textures.length ? fo.display_multitexture.render(null, co.readableTexture) : fo.display.render(co.texture, co.readableTexture), ta.loadIdentity(), fo.border.set({
                    border_color: [
                        0,
                        0,
                        0,
                        0
                    ]
                }), fo.border.render(co.readableTexture, co.writableTexture), fo.border.set({
                    border_color: co.state.border_color
                })), ta.clear(ta.COLOR_BUFFER_BIT), ta.loadMatrix(co.screenMatrix);
                if (co.textureFormat === ta.RGBA && (ta.enable(ta.BLEND), ta.blendEquation(ta.FUNC_ADD), ta.blendFuncSeparate(ta.SRC_ALPHA, ta.ONE_MINUS_SRC_ALPHA, ta.ONE, ta.ONE_MINUS_SRC_ALPHA)), t ? fo.screen.render(co.writableTexture) : fo.screen.render(e), oa.length) {
                    ta.enable(ta.BLEND), ta.blendEquation(ta.FUNC_ADD), ta.blendFunc(ta.SRC_ALPHA, ta.ONE_MINUS_SRC_ALPHA);
                    for(let t = 0; t < oa.length; t++)oa[t].render();
                }
            }, sa = _n(ua), la = function(t, e, r = !1, n = co.overlayMatrix) {
                const i = window.innerWidth, c = window.innerHeight, u = [
                    (t *= co.canvas.width / (window.innerWidth * Wi.pixelRatio)) / i * 2 - 1,
                    2 * (1 - (e *= co.canvas.height / (window.innerHeight * Wi.pixelRatio)) / c) - 1,
                    .91734895682833
                ];
                o.invert(co.tmpMatrix, n);
                const s = a.transformMat4([], u, co.tmpMatrix);
                return r ? [
                    s[0],
                    s[1]
                ] : [
                    .5 * s[0] + .5,
                    .5 * s[1] + .5
                ];
            }, fa = r(479);
            co.palette = {};
            const { gl: ha } = co, da = function(t) {
                ha.bindTexture(ha.TEXTURE_2D, t.id), ha.deleteTexture(t.id);
            }, pa = {}, va = (t)=>{
                pa[t] = Vr.Shader.create(r(110), r(163)("./".concat(t, ".frag")));
            };
            function ma(t, e, r, n) {
                n = n || r;
                const o = 1 / (e = e || t).width * r, i = 1 / e.height * r, a = 1 / e.width * n, c = 1 / e.height * n;
                return co.readableTexture.drawTo(()=>{
                    t.bind(0), pa.box_blur.uniforms({
                        texture: 0,
                        delta: [
                            o,
                            0,
                            a,
                            0
                        ]
                    }), pa.box_blur.draw(co.overlayMesh);
                }), e.drawTo(()=>{
                    co.readableTexture.bind(0), pa.box_blur.uniforms({
                        texture: 0,
                        delta: [
                            0,
                            i,
                            0,
                            c
                        ]
                    }), pa.box_blur.draw(co.overlayMesh);
                }), e;
            }
            function ga(t) {
                const { width: e, height: r } = co.texture, n = 512 / Math.max(e, r), o = e * n >> 0, i = r * n >> 0;
                Vr.Texture.setSize(co.writableTexture, o, i), Vr.Texture.setSize(co.readableTexture, o, i);
                let a, c, u = Vr.Texture.create(o, i), s = Vr.Texture.create(o, i), l = Vr.Texture.create(o, i), f = t;
                !function(t, e) {
                    const r = 1 / (e = e || t).width * 8, n = 1 / e.height * 8;
                    co.readableTexture.drawTo(()=>{
                        t.bind(0), pa.darkchannel_1.uniforms({
                            texture: 0,
                            delta: [
                                r,
                                0
                            ]
                        }), pa.darkchannel_1.draw(co.overlayMesh);
                    }), e.drawTo(()=>{
                        co.readableTexture.bind(0), pa.darkchannel_2.uniforms({
                            texture: 0,
                            delta: [
                                0,
                                n
                            ]
                        }), pa.darkchannel_2.draw(co.overlayMesh);
                    });
                }(f, l), s.drawTo(()=>{
                    f.bind(0), pa.mul.uniforms({
                        texture: 0
                    }), pa.mul.draw(co.overlayMesh);
                }), u = ma(f, u, 8), s = ma(s, s, 8), l = ma(l, l, 48), a = co.writableTexture, c = s, a.drawTo(()=>{
                    u.bind(0), s.bind(1), l.bind(2), pa.compute_a.uniforms({
                        mean_I: 0,
                        mean_II: 1,
                        mean_p: 2
                    }), pa.compute_a.draw(co.overlayMesh);
                }), c.drawTo(()=>{
                    u.bind(0), l.bind(2), a.bind(3), pa.compute_b.uniforms({
                        mean_I: 0,
                        mean_p: 2,
                        a: 3
                    }), pa.compute_b.draw(co.overlayMesh);
                }), a = ma(a, a, 8, 48), c = ma(c, c, 8, 48), co.dehazeTexture.drawTo(()=>{
                    a.bind(0), c.bind(1), f.bind(2), pa.combine.uniforms({
                        a: 0,
                        b: 1,
                        I: 2
                    }), pa.combine.draw(co.overlayMesh);
                }), da(u), da(s), da(l);
            }
            va("box_blur"), va("darkchannel_1"), va("darkchannel_2"), va("compute_a"), va("compute_b"), va("combine"), va("mul");
            const ba = function() {
                const { width: t, height: e } = co.texture, { zoom: r } = co, n = t >> 1, o = e >> 1;
                let i;
                Vr.Texture.setSize(co.intermediateTexture, n, o), Vr.Texture.setSize(co.dehazeTexture, n, o), co.downsampleResolution = [
                    n,
                    o
                ], co.zoom = 1, ha.loadIdentity(), ha.disable(ha.BLEND), co.textures.length ? (fo.display_multitexture.render(null, co.intermediateTexture), i = co.intermediateTexture) : i = co.texture, ga(i), function(t) {
                    Vr.Texture.setSize(co.writableTexture, 300, 300), fo.basic.render(t, co.writableTexture);
                    const e = Vr.Texture.read(co.writableTexture);
                    let r = fa.Quantizer.MMCQ(e, fa.DefaultOpts);
                    co.palette = fa.Generator.Default(r, fa.DefaultOpts);
                }(i), co.zoom = r;
            };
            function xa(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function ya(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? xa(Object(r), !0).forEach(function(e) {
                        _a(t, e, r[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : xa(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }
            function _a(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            const { gl: wa } = co, Sa = {
                _renderers: {},
                add (t, e) {
                    this._renderers[t] = e;
                },
                render (t) {
                    this._renderers[t] && this._renderers[t]();
                }
            }, Ma = {
                _deps: [],
                add (t) {
                    this._deps.push(t);
                },
                render (t = {}) {
                    return this._deps.map((e)=>e(t));
                }
            }, Ta = (t, e)=>{
                t ? (wa.enable(wa.BLEND), e ? wa.blendFunc(wa.ONE, wa.ONE_MINUS_SRC_ALPHA) : wa.blendFuncSeparate(wa.SRC_ALPHA, wa.ONE_MINUS_SRC_ALPHA, wa.ONE, wa.ONE_MINUS_SRC_ALPHA)) : wa.disable(wa.BLEND);
            };
            const Ia = (t = !0, e)=>{
                if (!co.writableTexture.width || !co.writableTexture.height || !co.photoLoaded) return;
                if (Ta(!1), co.currentEffect) return void function(t, e) {
                    Vr.Texture.setSize(co.intermediateTexture, co.writableTexture.width, co.writableTexture.height), wa.loadMatrix(co.matrix);
                    const r = co.currentEffect, n = fo[r.name];
                    n.set(co.state.effect), n.render(co.texture, co.intermediateTexture), co.inTexture = co.intermediateTexture, wa.loadIdentity(), ho("out", e), co.screenTexture = null, t && (co.screenTexture = co.readableTexture, ua());
                }(t, e);
                (co.previewIntermediate || co.needsUpdate && (co.intermediateTexture.width !== co.writableTexture.width || co.intermediateTexture.height !== co.writableTexture.height || !Dn(co.intermediateTexture.matrix, co.matrix)) && (co.intermediateTexture.matrix = co.matrix.slice(0), 1)) && (Vr.Texture.setSize(co.intermediateTexture, co.writableTexture.width, co.writableTexture.height), wa.loadMatrix(co.matrix), co.writableTexture.drawTo(Ea), co.readableTexture.drawTo(Ea), co.intermediateTexture.drawTo(Aa), co.textures.length ? fo.distortion_multitexture.render(null, co.intermediateTexture) : fo.distortion.render(co.texture, co.intermediateTexture), co.needsUpdate = !1, co.previewIntermediate = !1), co.inTexture = co.intermediateTexture, wa.loadIdentity();
                const r = co.state.spots;
                if (r.length) {
                    const t = co.textures.length ? "spot_heal_multitexture" : "spot_heal";
                    for(let e, n = 0; n < r.length; n++)e = r[n], fo[t].set({
                        feather: e.feather,
                        size: e.size,
                        position: e.position,
                        sourcePosition: e.sourcePosition,
                        angle: e.angle,
                        opacity: e.opacity,
                        mode: e.mode
                    }), ho(t);
                }
                if (fo.denoise.shouldRender() && ho("denoise"), co.state.is_lut_render && ho("lookup_export_filter"), fo.adjustments.setFrom(co.state, ti), ho("adjustments"), co.state.is_lut_render && co.state.lut_color_space) {
                    const t = co.colorProfile;
                    return co.colorProfile = co.state.lut_color_space, ho("display", e), void (co.colorProfile = t);
                }
                const n = co.state.faces;
                if (n.length) for(let t = 0; t < n.length; t++){
                    const e = n[t], r = co.faceMasks[t];
                    r && e && e.adjustments && !e.disabled && (r.bind(2), fo.face.set({
                        faceMask: 2
                    }), fo.face.set(e.adjustments), ho("face"));
                }
                let o;
                if (o = ((t)=>{
                    let e, r, n;
                    const o = co.state.local_adjustments;
                    if (o.length) {
                        for(let t, a = 0; a < o.length; a++){
                            var i;
                            if (t = o[a], r = t.layer, n = t.layers, t.disabled) continue;
                            const c = !En(t.adjustments, Qo, !0);
                            if ((r || (null === (i = n) || void 0 === i ? void 0 : i.length) || c || t.showOverlay) && (e = $i(t) || e, c && (fo.adjustments.setFrom(t.adjustments, Qo), ho("adjustments")), r && Zi(r), n && n.length)) for(let t = 0; t < n.length; t++)Zi(n[t]);
                        }
                        0 === co.state.blur_opacity && t.render("blur"), ho("strip_alpha");
                    }
                    return e;
                })(Sa), co.skipAfterLocal) return;
                co.state.blur_opacity && ho("blur_composite");
                const i = co.state.layers || [];
                if (i.length) {
                    let t;
                    for(let e = 0; e < i.length; e++)t = Zi(i[e]), t && (o = t);
                }
                fo.border.shouldRender() && ho("border"), o && ($i(o), Xi.enable(Xi.BLEND), Xi.blendEquation(Xi.FUNC_ADD), Xi.blendFunc(Xi.SRC_ALPHA, Xi.ONE_MINUS_SRC_ALPHA), co.overlayMask = [
                    0,
                    0,
                    0,
                    1
                ], fo.overlay.set({
                    opacity: 1,
                    viewMatrix: co.borderMatrix
                }), ho("overlay"), Xi.disable(Xi.BLEND)), fo.watermark.shouldRender() && (Ta(!0, !0), co.swapTextures(), ho("watermark"), wa.loadIdentity(), Ta(!1)), ho("out", e), co.screenTexture = null, t && (co.screenTexture = co.readableTexture, ua());
            }, Da = async (t, e, r = {})=>{
                if (!co.photoLoaded) return;
                let { settings: n, watermark: i, resize: a = "stretch", renderDependencies: c = !1, pixels: u, resizeQuality: s, rasterize: l } = r;
                const f = !l, { zoom: h, cropMode: d, matrix: p, matrixInv: v } = co, m = co.watermarkOptions.enabled;
                let g, b;
                co.watermarkOptions.enabled = i, co.zoom = Math.max(t, e) / Math.max(co.texture.width, co.texture.height), co.cropMode = !1, co.matrix = o.create(), co.matrixInv = o.create();
                const x = {
                    border_ratio: co.state.border_ratio
                };
                if (n) {
                    Object.assign(x, co.state);
                    const t = ya(ya({}, co.defaultState), n);
                    oi(t), g = t.crop;
                } else g = co.state.crop, Object.assign(x, {
                    crop: g.concat()
                });
                switch(a){
                    case "stretch":
                        t = (t || co.crop[2]) >> 0, e = (e || co.crop[3]) >> 0;
                        break;
                    case "fit":
                        b = Math.min(t / co.crop[2], e / co.crop[3]), t = co.crop[2] * b >> 0, e = co.crop[3] * b >> 0;
                        break;
                    case "fill":
                        oi({
                            border_ratio: 0
                        }), b = Math.max(t / co.crop[2], e / co.crop[3]);
                        const r1 = co.crop[2] * b >> 0, n1 = co.crop[3] * b >> 0, o1 = g[2] * (t / r1), i1 = g[3] * (e / n1);
                        g = [
                            g[0] + (g[2] - o1) / 2,
                            g[1] + (g[3] - i1) / 2,
                            o1,
                            i1
                        ];
                        break;
                    default:
                        t = co.crop[2] >> 0, e = co.crop[3] >> 0;
                }
                if (oi({
                    crop: g
                }), c && await Promise.all(Ma.render({
                    isInitialRender: !0
                })), t > co.maxTextureSize || e > co.maxTextureSize) {
                    const r = t >> 1, n = e >> 1;
                    t = 2 * r, e = 2 * n;
                    const o = co.crop[2] >> 1, i = co.crop[3] >> 1, a = [
                        [
                            0,
                            0
                        ],
                        [
                            r,
                            0
                        ],
                        [
                            0,
                            n
                        ],
                        [
                            r,
                            n
                        ]
                    ], c = [
                        [
                            0,
                            0,
                            .5,
                            .5
                        ],
                        [
                            o,
                            0,
                            .5,
                            .5
                        ],
                        [
                            0,
                            i,
                            .5,
                            .5
                        ],
                        [
                            o,
                            i,
                            .5,
                            .5
                        ]
                    ], s = 3;
                    let h, d = [];
                    l || (h = new Uint8Array(r * n * 4), u = u || new Uint8Array(t * e * 3));
                    for(let o = 0; o < c.length; o++){
                        if (Wi.updateForOutput(r, n, f, !0, c[o]), Ia(!1), l) {
                            const t = co.readableTexture, e = Vr.Texture.create(t.width, t.height, {
                                type: t.type,
                                format: t.format
                            });
                            d[o] = t, co.readableTexture = e;
                            continue;
                        }
                        h = Vr.Texture.read(co.readableTexture, h);
                        let i = a[o][0], p = a[o][1];
                        i > 0 && (i = t - i), p > 0 && (p = e - p);
                        let v = (p * t + i) * s, m = 0;
                        for(let e = 0; e < n; e++){
                            for(let t = 0; t < r; t++)u[v] = h[m], u[v + 1] = h[m + 1], u[v + 2] = h[m + 2], v += s, m += 4;
                            v += (t - r) * s;
                        }
                    }
                    l && (co.textures.forEach(Vr.Texture.delete), co.textures = d, co.texture.width = t, co.texture.height = e);
                } else {
                    const r = 1 - 1 / Math.max(1, s);
                    let n = Math.round(co.crop[2] * r), o = Math.round(co.crop[3] * r);
                    const i = co.maxTextureSize / Math.max(co.maxTextureSize, n, o);
                    if (n = Math.floor(n * i), o = Math.floor(o * i), r > 0 && t < n && e < o) {
                        const i = t, a = e;
                        for(t = Math.max(n, i), e = Math.max(o, a), Wi.updateForOutput(t, e, f), Ia(!1); t > i && e > a;)t = Math.max(Math.round(t * r), i), e = Math.max(Math.round(e * r), a), t != i && e != a || (t = i, e = a), Vr.Texture.setSize(co.writableTexture, t, e), ho("basic");
                    } else Wi.updateForOutput(t, e, f), Ia(!1);
                    if (l) {
                        const t = co.readableTexture, e = Vr.Texture.create(t.width, t.height, {
                            type: t.type,
                            format: t.format
                        });
                        Vr.Texture.delete(co.texture), co.texture = t, co.readableTexture = e;
                    } else u = Vr.Texture.read(co.readableTexture, u);
                }
                return oi(x), co.zoom = h, co.cropMode = d, co.watermarkOptions.enabled = m, co.matrix = p, co.matrixInv = v, {
                    data: u,
                    height: e,
                    width: t
                };
            }, Ea = ()=>{
                wa.clear(wa.COLOR_BUFFER_BIT);
            }, Aa = function() {
                wa.clearColor(0, 0, 0, 1), wa.clear(wa.DEPTH_BUFFER_BIT | wa.COLOR_BUFFER_BIT), wa.clearColor(0, 0, 0, 0);
            };
            co.rasterize = async function() {
                const t = co.crop[2], e = co.crop[3];
                if (!co.originalTexture) {
                    const { zoom: r } = co, [n, o] = rn([
                        t,
                        e
                    ], [
                        co.canvas.width,
                        co.canvas.height
                    ], "fit");
                    co.originalTexture = Vr.Texture.create(n, o), co.zoom = 1, Wi.updateForOutput(n, o, !1), wa.disable(wa.BLEND), wa.loadMatrix(co.matrix), co.textures.length ? fo.display_multitexture.render(null, co.originalTexture) : fo.display.render(co.texture, co.originalTexture), co.zoom = r;
                }
                await Da(t, e, {
                    rasterize: !0,
                    renderDependencies: !0
                }), co.scaleX = 1, co.colorProfileName = "sRGB", co.colorProfile = co.colorProfiles.sRGB || 0, co.setPixelFormat(kn.RGBA), ba();
            };
            var Ca = {
                dependencies: Ma,
                previews: Sa,
                render: Ia,
                clear: Ea,
                renderCacheTexture: ()=>{
                    Ma.render(), logTime("%ccache texture");
                    let t = co.crop[2], e = co.crop[3];
                    co.cropMode && (t = co.texture.width, e = co.texture.height);
                    const r = co.canvas.width, n = co.canvas.height, i = Math.min(r / t, n / e);
                    t = t * i >> 0, e = e * i >> 0, Vr.Texture.setSize(co.cacheTexture, t, e), Wi.updateForOutput(t, e, !1, !co.cropMode), co.cacheTextureMatrix = o.clone(co.matrix), Ia(!1, co.cacheTexture), Wi.update(), logTimeEnd("%ccache texture", "color: green");
                },
                renderOutput: Da
            };
            const za = document.createElement("canvas"), Oa = za.getContext("2d"), Fa = new Uint16Array(256), Ra = new Uint16Array(256), Pa = new Uint16Array(256), La = new Uint16Array(256), ka = new Uint16Array(256), ja = new Uint16Array(256);
            let Ua = 0;
            const Ba = {
                COMBINED: 0,
                SPLIT_HORIZONTAL: 1,
                SPLIT_VERTICAL: 2
            };
            let Na = Ba.COMBINED;
            const Ga = (t, e, r, n)=>{
                Oa.strokeStyle = "hsl(".concat(e, ")"), Oa.fillStyle = "hsla(".concat(e, ", 0.5)"), Oa.beginPath(), Oa.moveTo(r, n + 208);
                for(let e = 0; e < 256; e++){
                    const o = Math.min(t[e] / Ua, 1);
                    Oa.lineTo(r + 2 * e, n + 208 - 208 * o);
                }
                Oa.closePath(), Oa.stroke(), Oa.fill();
            }, Va = function() {
                let t = 0, e = 0;
                switch(Na){
                    case Ba.SPLIT_HORIZONTAL:
                        t = 512, za.width = 1536, za.height = 208;
                        break;
                    case Ba.SPLIT_VERTICAL:
                        e = 208, za.width = 512, za.height = 624;
                        break;
                    case Ba.COMBINED:
                        za.width = 512, za.height = 208;
                }
                Oa.globalCompositeOperation = "lighter", Oa.lineWidth = 2, Ga(Fa, "360, 100%, 60%", 0, 0), Ga(Ra, "120, 100%, 60%", t, e), Ga(Pa, "230, 100%, 60%", 2 * t, 2 * e);
            };
            var qa = {
                canvas: za,
                setDisplay: function(t) {
                    switch(t){
                        case Ba.COMBINED:
                        case Ba.SPLIT_HORIZONTAL:
                        case Ba.SPLIT_VERTICAL:
                            Na = t, Va();
                    }
                },
                displayTypes: Ba,
                update: function(t) {
                    Ua = 0;
                    for(let t = 0; t < 255; t++)Fa[t] = 0, Ra[t] = 0, Pa[t] = 0;
                    for(let e = 0; e < t.length; e += 4){
                        const r = t[e], n = t[e + 1], o = t[e + 2];
                        r > 0 && r < 255 && Fa[r]++, n > 0 && n < 255 && Ra[n]++, o > 0 && o < 255 && Pa[o]++;
                    }
                    for(let t = 1; t < 255; t++)La[t] = Fa[t] || Fa[t - 1] || Fa[t + 1], ka[t] = Ra[t] || Ra[t - 1] || Ra[t + 1], ja[t] = Pa[t] || Pa[t - 1] || Pa[t + 1];
                    for(let t = 1; t < 255; t++)Fa[t] = (La[t - 1] + La[t] + La[t + 1]) / 3, Ra[t] = (ka[t - 1] + ka[t] + ka[t + 1]) / 3, Pa[t] = (ja[t - 1] + ja[t] + ja[t + 1]) / 3, Ua = Math.max(Ua, Fa[t], Ra[t], Pa[t]);
                    Ua = Math.min(Ua, 1200), Va();
                }
            };
            let Ya = 60, Ha = 1, Wa = 1e3 / Ya, Xa = Wa + 200;
            const Ka = function() {
                let t = !1, e = 1e3 / Ya, r = null, n = null;
                const o = function() {
                    cancelAnimationFrame(r), e = Math.min(e, 500), t = !1;
                };
                return document.addEventListener("visibilitychange", o), function() {
                    if (!t) {
                        t = !0;
                        let i = yn();
                        r = requestAnimationFrame(function() {
                            Wi.update(), Ca.render(), e += (yn() - i - e) / 10, Ya = Math.min(1e3 / (2 * e), 60), Wa = 1e3 / Ya, Xa = Wa + 200, t = !1;
                        }), clearTimeout(n), n = setTimeout(o, 1e3);
                    }
                };
            }(), Za = {}, Ja = function(t, e) {
                let r;
                const n = Math.min((t || 500) / co.crop[2], (e || 500) / co.crop[3]), o = co.crop[2] * n >> 0, i = co.crop[3] * n >> 0;
                return o === Za.width && i === Za.height && (r = Za.data), Ca.renderOutput(o, i, {
                    pixels: r,
                    renderDependencies: !1
                }).then((t)=>{
                    t && (Za.width = t.width, Za.height = t.height, Za.data = t.data, co.thumbnail = Za, qa.update(Za.data), Do("thumbnail", Za));
                });
            };
            let $a, Qa, tc;
            function ec() {
                clearTimeout(Qa), Qa = window.setTimeout(Ja, Xa);
            }
            function rc() {
                co.downsampleFactor = 1, Wi.resampleTextures(), Ca.dependencies.render(), Ka();
            }
            function nc(t = !0, e = !0) {
                if (t) co.downsampleFactor = Ha >> 0, Wi.resampleTextures(), clearTimeout(tc), tc = window.setTimeout(rc, Xa), Ka(), ec();
                else {
                    if (e && ua(), clearTimeout($a), co.zoom < co.minZoom) return;
                    $a = window.setTimeout(Ka, Xa);
                }
            }
            const oc = function() {
                let t, e, r, n, o = null, i = null, a = null;
                const c = function() {
                    r ? ni(r, t) : oi(t), n && n(), !1 !== e ? nc() : ec();
                };
                return function(u, s, l, f) {
                    t = u, e = s, r = l, n = f, a = yn(), i && a < i + Wa ? (clearTimeout(o), o = setTimeout(c, Wa)) : (i = a, c());
                };
            }(), ic = function(t, e, r, n) {
                n ? (ni(t, e), !1 !== r ? nc() : ec()) : oc(e, r, t);
            };
            let ac;
            !function(t) {
                t.MASK = "mask", t.PAINT = "paint";
            }(ac || (ac = {}));
            const cc = {
                points: [],
                size: .5,
                spacing: .25,
                randomize: 0,
                interpolate: !0,
                flow: .5,
                hardness: 0,
                masking: 1,
                erase: !1,
                mode: ac.MASK
            };
            let uc, sc, lc, fc, hc, dc, pc, vc, mc, gc, bc, xc, yc = [
                0,
                0,
                0
            ], _c = !1;
            function wc(t) {
                vc = t, vc.bind(5);
            }
            function Sc(t) {
                pc = t, dc = [
                    1 / pc.width,
                    1 / pc.height
                ];
            }
            function Mc() {
                return dc;
            }
            function Tc() {
                if (!_c) {
                    if (!(xc instanceof WebGLRenderingContext)) throw new Error("WebGL Rendering Context is not set");
                    if (!(pc instanceof Br)) throw new Error("brushTexture is not set");
                    if (!(vc instanceof Br)) throw new Error("maskingTexture is not set");
                    mc = Vr.Shader.create(r(602), r(603)), gc = xc.getAttribLocation(mc.program, "coordinates"), bc = xc.createBuffer(), _c = !0;
                }
            }
            function Ic(t) {
                Tc(), xc.enable(xc.BLEND), xc.blendEquation(xc.FUNC_ADD), xc.blendFuncSeparate(xc.SRC_ALPHA, xc.ONE_MINUS_SRC_ALPHA, xc.ONE, xc.ONE_MINUS_SRC_ALPHA);
                const e = cc.mode === ac.PAINT ? 4 : 3;
                xc.bindBuffer(xc.ARRAY_BUFFER, bc), xc.bufferData(xc.ARRAY_BUFFER, new Float32Array(t), xc.STREAM_DRAW), xc.vertexAttribPointer(gc, e, xc.FLOAT, !1, 0, 0), xc.enableVertexAttribArray(gc), xc.useProgram(mc.program), vc.bind(5), pc.drawTo(function() {
                    xc.drawArrays(xc.POINTS, 0, t.length / e);
                });
            }
            function Dc(t) {
                const e = cc.mode === ac.PAINT ? 4 : 3, r = t.length;
                hc = [
                    t[r - e],
                    t[r - e + 1],
                    t[r - e + 2]
                ];
                for(let n = 0; n < r; n += e)cc.randomize && (t[n + 0] += (Math.random() - .5) * cc.randomize * uc, t[n + 1] += (Math.random() - .5) * cc.randomize * uc), t[n + 0] *= dc[0], t[n + 1] *= dc[1];
                Ic(t), cc.points.push.apply(cc.points, t);
            }
            function Ec(t) {
                if (t = [
                    t[0] * pc.width,
                    t[1] * pc.height,
                    t[2]
                ], hc) {
                    cc.mode === ac.PAINT && (yc[3] = Math.atan2(t[1] - hc[1], t[0] - hc[0]));
                    const e = sc * t[2], r = function(t, e) {
                        const r = e[0] - t[0], n = e[1] - t[1];
                        return Math.hypot(r, n);
                    }(t, hc);
                    if (r >= e) {
                        if (cc.interpolate) {
                            const n = [];
                            for(let o = e; o <= r; o += e)Oc(yc, hc, t, o / r), n.push.apply(n, yc);
                            Dc(n);
                        } else yc[0] = t[0], yc[1] = t[1], yc[2] = t[2], Dc(yc);
                    }
                } else !function(t) {
                    hc = [
                        t[0],
                        t[1],
                        t[2]
                    ], cc.mode !== ac.PAINT && (t[0] *= dc[0], t[1] *= dc[1], Ic(t), cc.points.push.apply(cc.points, t));
                }(t);
            }
            function Ac(t = {}) {
                var e;
                Tc(), Object.assign(cc, {
                    points: [],
                    mode: ac.MASK,
                    masking: 0
                }, t), uc = Cc(cc.size), lc = zc(cc.hardness), e = cc.masking, e = Number(e), fc = Math.max(.25, Fc(1 - e) / 10), sc = uc * cc.spacing, hc = null, yc = cc.mode === ac.PAINT ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    0,
                    0,
                    0
                ], mc.uniforms({
                    brushSize: uc,
                    texel: dc,
                    hardness: lc,
                    masking: fc,
                    flow: cc.flow,
                    erase: cc.erase,
                    smoothTexture: 5
                });
            }
            function Cc(t) {
                return Math.max(10, 255 * t);
            }
            function zc(t) {
                return 1 + 9 * (t = Fc(t) / 10);
            }
            function Oc(t, e, r, n) {
                const o = e[0], i = e[1], a = e[2];
                return t[0] = o + n * (r[0] - o), t[1] = i + n * (r[1] - i), t[2] = a + n * (r[2] - a), t;
            }
            function Fc(t) {
                return (t *= 2) >= 1 && (t -= 1, t = Math.log(.5) / Math.log(.5 * (1 - t) + .9332 * t)), function(t, e, r) {
                    return t <= e ? e : t >= r ? r : t;
                }(t, 0, 10);
            }
            const { gl: Rc } = co;
            let Pc, Lc = !1;
            const kc = aa({
                zIndex: 1,
                state: {
                    matrix: o.create(),
                    backgroundMatrix: o.create(),
                    backgroundCropMatrix: o.create(),
                    overlayMatrix: o.create(),
                    point: [
                        0,
                        0,
                        0
                    ],
                    pointer: [
                        0,
                        0
                    ],
                    highlightOpacity: 0,
                    inputType: "mouse",
                    brushSize: 32
                },
                render: function() {
                    Lc || (Pc = Vr.Shader.create(r(604), r(605)), Lc = !0);
                    const t = this.state;
                    "touch" === t.inputType ? function(t) {
                        const { point: e, pointer: r, brushSize: n, matrix: i, overlayMatrix: a, backgroundMatrix: c, highlightOpacity: u, hardness: s, flow: l, margins: f = co.margins } = t, h = Mc(), d = f[1], p = Math.min(1, 2 * e[2]), v = Rc.drawingBufferWidth / co.pixelRatio, m = Rc.drawingBufferHeight / co.pixelRatio, g = [
                            64,
                            64 + d
                        ], b = [
                            -v / 2 + g[0],
                            m / 2 - g[1],
                            0
                        ], x = [
                            64,
                            64,
                            1
                        ];
                        r[0] < co.margins[0] + 128 && r[1] < co.margins[1] + 128 && (g[0] = 64, g[1] = 64 + d, b[0] = v / 2 - g[0]);
                        const { flipX: y, flipY: _ } = co.overlay, w = co.rotation, S = 90 * co.rotate90, M = [
                            2 * e[0] - 1,
                            2 * e[1] - 1,
                            0
                        ], T = [
                            h[0] * n * (1 / .75) * y,
                            h[1] * n * (1 / .75) * _,
                            1
                        ];
                        o.ortho(i, v / -2, v / 2, m / -2, m / 2, -9999, 9999), o.translate(i, i, b), o.scale(i, i, x), o.identity(a), o.translate(a, a, M), o.scale(a, a, T), o.rotateZ(a, a, bn(w + S)), o.identity(c), o.multiply(c, c, co.cacheTextureMatrix), o.multiply(c, c, a), Rc.loadMatrix(i), co.cacheTexture.bind(0), (co.screenTexture || co.readableTexture).bind(1), co.brushWindowBorder.bind(3);
                        let I = 0;
                        jc.state.enabled && (jc.state.texture.bind(2), I = .5), Pc.uniforms({
                            pressure: p,
                            flow: l || 1,
                            hardness: s || 1,
                            cacheTexture: 0,
                            texture: 1,
                            overlay: 2,
                            borderTexture: 3,
                            overlayOpacity: I,
                            brushScale: 1 / .75,
                            highlightOpacity: u,
                            backgroundMatrix: c,
                            overlayMatrix: a,
                            cropMatrix: co.cropMatrix,
                            viewMatrix: co.viewMatrix,
                            renderWindow: !0
                        }), Pc.draw(co.overlayMesh);
                    }(t) : function(t) {
                        const { point: e, brushSize: r, matrix: n, highlightOpacity: i, hardness: a, flow: c } = t, u = Mc(), s = Math.min(1, 2 * e[2]), l = [
                            u[0] * r,
                            u[1] * r,
                            1
                        ], f = [
                            2 * e[0] - 1,
                            2 * e[1] - 1,
                            0
                        ];
                        o.translate(n, co.overlayMatrix, f), o.scale(n, n, l), Rc.loadMatrix(n), Pc.uniforms({
                            pressure: s,
                            flow: c || 0,
                            hardness: a || 1,
                            brushScale: 1,
                            highlightOpacity: i,
                            renderWindow: !1
                        }), Pc.draw(co.overlayMesh);
                    }(t);
                }
            }), jc = aa({
                state: {
                    texture: null,
                    opacity: .5,
                    matrix: co.matrix
                },
                render () {
                    Rc.loadMatrix(co.overlayMatrix), fo.overlay.set({
                        opacity: this.state.opacity,
                        viewMatrix: this.state.matrix
                    }), fo.overlay.render(this.state.texture);
                }
            });
            var Uc = r(196), Bc = r.n(Uc);
            const { gl: Nc } = co, Gc = [
                "huawei"
            ].some((t)=>RegExp(t, "gi").test(navigator.userAgent)) ? Nc.RGB : Nc.LUMINANCE;
            function Vc() {
                let { width: t, height: e } = co.texture;
                const r = 1024 / Math.max(t, e);
                t = Math.floor(t * r), e = Math.floor(e * r), Vr.Texture.setSize(co.brushTexture, t, e), Sc(co.brushTexture);
            }
            function qc() {
                Vc();
                const { width: t, height: e } = co.brushTexture;
                Vr.Texture.setSize(co.writableTexture, t, e), Nc.loadIdentity(), Nc.disable(Nc.BLEND), fo.distortion.render(co.dehazeTexture, co.writableTexture), wc(co.writableTexture);
            }
            function Yc(t) {
                const e = t.id;
                if ("string" != typeof e) return;
                const r = t.brush, { width: n, height: o } = co.brushTexture;
                co.brushTextures[e] = co.brushTextures[e] || Vr.Texture.create(n, o, {
                    format: Gc
                }), Hc(t.mode === Ln.COMBINE ? .5 : 0), r && r.forEach((t)=>(function(t) {
                        Ac(t), Ic(t.points);
                    })(t)), Nc.bindFramebuffer(Nc.FRAMEBUFFER, co.brushTexture.getFramebuffer()), Nc.framebufferTexture2D(Nc.FRAMEBUFFER, Nc.COLOR_ATTACHMENT0, Nc.TEXTURE_2D, co.brushTexture.id, 0), Nc.bindTexture(Nc.TEXTURE_2D, co.brushTextures[e].id), Nc.copyTexImage2D(Nc.TEXTURE_2D, 0, Gc, 0, 0, n, o, 0);
            }
            function Hc(t) {
                co.brushTexture.drawTo(function() {
                    t ? (Nc.clearColor(t, t, t, t), Nc.clear(Nc.COLOR_BUFFER_BIT), Nc.clearColor(0, 0, 0, 0)) : Nc.clear(Nc.COLOR_BUFFER_BIT);
                });
            }
            function Wc(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function Xc(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            Ca.dependencies.add(function() {
                const t = co.state.local_adjustments, e = co.state.layers, r = co.state.text, n = function() {
                    co.prevState.distortion = co.prevState.distortion || [];
                    const t = [
                        co.state.distortion_amount,
                        co.state.distortion_horizontal,
                        co.state.distortion_vertical,
                        co.state.distortion_points,
                        co.state.distortion_mesh
                    ], e = !En(co.prevState.distortion, t, !0);
                    return co.prevState.distortion = t, e;
                }(), o = [], i = [];
                co.prevState.brushes = co.prevState.brushes || {};
                const a = (t)=>{
                    if (t) {
                        if ("brush" === t.type) {
                            const e = function(t, e, r) {
                                const n = t.brush, o = t.id = t.id || Bc()();
                                !r && En(co.prevState.brushes[o], n) || e.push(t);
                                return o;
                            }(t, i, n);
                            o.push(e), co.prevState.brushes[e] = t.brush;
                        }
                        t.masks && t.masks.length && t.masks.forEach(a);
                    }
                };
                t.forEach(a), e.forEach((t)=>a(t.mask)), r.forEach((t)=>a(t.mask)), i.length && (qc(), i.forEach(Yc));
                for(const t in co.brushTextures){
                    const e = co.brushTextures[t];
                    o.includes(t) || (Vr.Texture.delete(e), delete co.prevState.brushes[t], delete co.brushTextures[t]);
                }
            });
            const { gl: Kc } = co;
            xc = Kc, wc(co.writableTexture), Sc(co.brushTexture);
            const Zc = {
                masking: {
                    size: .5,
                    flow: .5,
                    hardness: 0,
                    masking: 1,
                    spacing: .25,
                    randomize: 0,
                    interpolate: !0,
                    mode: "mask"
                },
                painting: {
                    size: .5,
                    flow: .5,
                    spacing: .5,
                    randomize: .25,
                    interpolate: !1,
                    mode: "paint"
                }
            };
            function Jc(t) {
                clearTimeout($a), clearTimeout(Qa), clearTimeout(tc), Wi.update(), Ca.render(), co.photoLoaded = !1, au(), Hc(), qc(), Ac(t);
            }
            function $c(t, e) {
                Ec(t), kc.setState({
                    point: t,
                    pointer: e
                }), sa();
            }
            function Qc() {
                return co.photoLoaded = !0, jc.disable(), function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var r = null != arguments[e] ? arguments[e] : {};
                        e % 2 ? Wc(Object(r), !0).forEach(function(e) {
                            Xc(t, e, r[e]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Wc(Object(r)).forEach(function(e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                        });
                    }
                    return t;
                }({}, cc);
            }
            function tu(t) {
                null != t.brushSize && (t.brushSize = Cc(t.brushSize)), null != t.hardness && (t.hardness = zc(t.hardness)), kc.setState(t);
            }
            function eu(t) {
                Vc(), tu(t), kc.enable(), sa();
            }
            function ru() {
                kc.disable(), sa();
            }
            function nu(t) {
                au(t), sa();
            }
            function ou() {
                jc.disable(), sa();
            }
            function iu(t) {
                if (t) {
                    if ("brush" === t.type && null != t.id) return co.brushTextures[t.id];
                    if ("object" === t.type && null != t.index) return co.objectMasks[t.index];
                }
            }
            function au(t = []) {
                Wi.update();
                const e = o.clone(co.matrix), r = Rn(co.state, t), n = iu(r), i = function(t) {
                    if (t.length > 2) {
                        const e = t.slice(0, -2);
                        return Rn(co.state, e);
                    }
                }(t), a = iu(i);
                if (n) {
                    let t, e = [
                        1,
                        1,
                        1,
                        1
                    ], c = [
                        0,
                        0,
                        0,
                        0
                    ];
                    if (r.mode === Ln.COMBINE && (e = [
                        2,
                        1,
                        1,
                        1
                    ], c = [
                        -0.5,
                        0,
                        0,
                        0
                    ]), Kc.loadIdentity(), o.identity(co.matrix), "object" === (null == i ? void 0 : i.type) && a) {
                        const e = co.intermediateTexture;
                        co.intermediateTexture = co.dehazeTexture, a.bind(2), fo.mask_object.set({
                            objectMask: 2,
                            invert: i.invert,
                            opacity: 1,
                            alpha: 0,
                            useRefine: i.feather && (co.capabilities.canRenderToFloatTexture || co.capabilities.canRenderToHalfFloatTexture)
                        }), fo.mask_object.render(co.readableTexture, co.writableTexture), co.intermediateTexture = e, t = co.writableTexture;
                    }
                    t && t.bind(1), fo.render_channel.set({
                        scale: e,
                        offset: c,
                        extraTexture: 1,
                        extraTextureChannel: [
                            0,
                            0,
                            0,
                            t ? 1 : 0
                        ],
                        channel: [
                            1,
                            0,
                            0,
                            0
                        ]
                    }), fo.render_channel.render(n, co.brushTexture);
                }
                co.overlayMask = [
                    1,
                    0,
                    0,
                    0
                ], jc.setState({
                    texture: co.brushTexture,
                    matrix: e
                }), jc.enable(), co.matrix = e;
            }
            const { gl: cu } = co;
            let uu, su = !1;
            const lu = aa({
                zIndex: 0,
                state: {
                    color: [
                        .5,
                        .5,
                        .5,
                        1
                    ]
                },
                render: function() {
                    su || (uu = Vr.Shader.create(r(162), r(167)), su = !0), cu.loadMatrix(co.overlayMatrix);
                    const t = co.mesh, e = t.vertexBuffers.a_Distortion, n = t.indexBuffers.triangles, o = uu.getAttributeLocation("a_Vertex");
                    cu.bindBuffer(cu.ARRAY_BUFFER, e.buffer), cu.vertexAttribPointer(o, e.buffer.spacing, cu.FLOAT, !1, 0, 0), uu.uniforms({
                        u_ModelViewProjectionMatrix: co.overlayMatrix,
                        color: this.state.color
                    }), cu.lineWidth(1), cu.bindBuffer(cu.ELEMENT_ARRAY_BUFFER, n.buffer), cu.drawElements(cu.LINES, n.buffer.length, cu.UNSIGNED_SHORT, 0);
                }
            });
            function fu() {
                lu.enable(), sa();
            }
            function hu() {
                lu.disable(), sa();
            }
            const { gl: du } = co, pu = [
                -1,
                -1,
                1,
                -1,
                -1,
                1,
                1,
                1
            ], vu = Xr(pu), mu = n.invert([], vu);
            ei("distortion_mesh", null, function(t) {
                co.mesh.distortion = t ? new Float32Array(t) : co.distortionVertices;
                co.previewIntermediate = !0, co.mesh.compileBuffer("distortion");
            }), ei("face_features", null, function(t) {
                if (co.previewIntermediate = !0, null == t || 0 === t.filter((t)=>!t.disabled).length) return co.mesh.delta = co.deltaVertices, void co.mesh.compileBuffer("delta");
                const e = co.distortionVertices, r = e.slice(0);
                let n, o, i, a, c, u, s, l, f, h, d = !1;
                for(a = 0; a < t.length; a++){
                    if (i = t[a], h = co.faceMasks[a], !h || i.disabled) continue;
                    if (n = h.weights, o = h.markers, !n || !o) continue;
                    let e, p, v, m, g, b;
                    d = !0;
                    const x = {
                        eyes: 0,
                        face: 0,
                        forehead: 0,
                        jaw: 0,
                        leftEye: 0,
                        mouth: 0,
                        nose: 0,
                        rightEye: 0
                    }, [y, _] = o.rotation;
                    for(c = 0; c < r.length / 2; c++){
                        if (x.mouth = n.mouth[c] / 255, x.nose = n.nose[c] / 255, x.leftEye = n.leftEye[c] / 255, x.rightEye = n.rightEye[c] / 255, x.jaw = n.jaw[c] / 255, x.forehead = n.forehead[c] / 255, x.face = Math.max(x.jaw, x.forehead), x.eyes = Math.max(x.leftEye, x.rightEye), x.smile = Math.max(x.mouth, .3 * Math.max(0, x.face - x.nose - x.eyes)), u = 2 * c, s = u + 1, l = r[u] * y - r[s] * -_, f = r[u] * -_ + r[s] * y, x.leftEye && (e = o.leftEyeCenter[0], p = o.leftEyeCenter[1], m = 1 + i.eye_size[0] * x.leftEye * .3, l = (l - e) * m + e, f = (f - p) * m + p), x.rightEye && (e = o.rightEyeCenter[0], p = o.rightEyeCenter[1], m = 1 + i.eye_size[1] * x.rightEye * .3, l = (l - e) * m + e, f = (f - p) * m + p), x.face && (e = o.faceCenter[0], p = o.faceCenter[1], m = 1 + i.face_width * x.face * (1 - x.eyes) * .1, l = (l - e) * m + e), x.mouth && (e = o.mouthCenter[0], p = o.mouthCenter[1], v = x.mouth * (1 - x.nose) * .2, g = 1 + i.mouth_width * v, b = 1 + i.mouth_height * v, l = (l - e) * g + e, f = (f - p) * b + p), x.smile) {
                            e = o.mouthCenter[0], p = o.mouthCenter[1];
                            const t = [
                                .8 * (l - e) + e,
                                .8 * (f - p) + p
                            ], r = [
                                vn(t, o.mouthCorners[0]),
                                vn(t, o.mouthCorners[1])
                            ];
                            let n = Math.min(r[0], r[1]);
                            const a = vn([
                                l,
                                f
                            ], o.mouthCenter);
                            n = (1 - Math.min(1, n / .1)) * Math.min(1, a / .1), n = i.smile * x.smile * n, g = 1 + i.smile * x.mouth * .1, l = (l - e) * g + e, f = f - p + .05 * n + p;
                        }
                        x.nose && (e = o.noseCenter[0], p = o.noseCenter[1], g = 1 + i.nose_width * x.nose * .3, b = 1 + i.nose_height * x.nose * (1 - x.mouth) * .1, l = (l - e) * g + e, f = (f - p) * b + p), x.jaw && (e = o.faceCenter[0], p = o.faceCenter[1] + .15, b = 1 + i.chin_height * x.jaw * (1 - x.eyes) * (1 - x.mouth) * (1 - x.nose) * .05, f = (f - p) * b + p), x.forehead && (e = o.faceCenter[0], p = o.faceCenter[1] - .15, b = 1 + i.forehead_height * x.forehead * (1 - x.eyes) * .05, f = (f - p) * b + p), r[u] = l * y - f * _, r[s] = l * _ + f * y;
                    }
                }
                if (!d) return;
                for(c = 0; c < r.length / 2; c++)u = 2 * c, s = u + 1, r[u] = r[u] - e[u], r[s] = r[s] - e[s];
                co.mesh.delta = r, co.mesh.compileBuffer("delta");
            }), ei("distortion_points", pu, function(t) {
                const e = Xr(t);
                n.multiply(co.distortionMatrix, e, mu), co.previewIntermediate = !0;
            });
            const gu = new Uint8Array(4), bu = new Float32Array(gu.buffer);
            function xu(t) {
                return Vr.Texture.read(t, gu), bu[0];
            }
            function yu(t, e, r) {
                const n = t.slice(0, 2), o = t.slice(2, 4), a = t.slice(4, 6), c = t.slice(6, 8);
                let u, s, l, f;
                switch(e){
                    case 0:
                        f = n, u = c, s = a, l = o;
                        break;
                    case 1:
                        f = o, u = a, s = c, l = n;
                        break;
                    case 2:
                        f = a, u = o, s = n, l = c;
                        break;
                    case 3:
                        f = c, u = n, s = o, l = a;
                }
                const h = i.lerp(i.create(), u, s, 1e3), d = i.lerp(i.create(), u, l, 1e3), p = [
                    h[0],
                    d[1]
                ], v = Zr(r, f, [
                    s,
                    h,
                    p,
                    d,
                    l
                ]);
                return v ? (f[0] = v[0], f[1] = v[1], i.lerp(f, f, r, 1e-4), [
                    ...n,
                    ...o,
                    ...a,
                    ...c
                ]) : t;
            }
            function _u([t, e], { toClipSpace: r, flipY: o, noInvert: i } = {}) {
                o && (e = 1 - e), r && (t = 2 * t - 1, e = 2 * e - 1);
                const c = i ? co.distortionMatrix : n.invert(co.tmpMatrix, co.distortionMatrix), u = a.transformMat3(a.create(), [
                    t,
                    e,
                    1
                ], c);
                return u[0] = u[0] / u[2], u[1] = u[1] / u[2], r && (u[0] = .5 * u[0] + .5, u[1] = .5 * u[1] + .5), o && (u[1] = 1 - u[1]), u;
            }
            function wu([t, e]) {
                const { width: r, height: i } = co.texture, a = 1 / r, c = 1 / i, u = 2 * t - 1, s = 2 * e - 1, l = o.create();
                o.scale(l, l, [
                    1 / a,
                    1 / c,
                    1
                ]), o.translate(l, l, [
                    -u,
                    -s,
                    0
                ]), du.loadIdentity(), du.disable(du.BLEND), fo.distortion_map.set({
                    viewMatrix: l,
                    distortionMatrix: n.create(),
                    useTexture: !1,
                    horizontal: !0
                }), fo.distortion_map.render(null, co.pixelTexture);
                const f = xu(co.pixelTexture);
                fo.distortion_map.set({
                    horizontal: !1
                }), fo.distortion_map.render(null, co.pixelTexture);
                return _u([
                    f,
                    xu(co.pixelTexture)
                ], {
                    toClipSpace: !0
                });
            }
            const Su = {
                strength: .3,
                radius: .1,
                rate: .02,
                mode: "warp"
            };
            let Mu = null, Tu = null, Iu = 1, Du = null;
            const Eu = function() {
                Du = requestAnimationFrame(function() {
                    Cu(Mu), Eu();
                });
            }, Au = function(t, e) {
                Object.assign(Su, t), Mu = Mu || e, Wi.update(), "pinch" !== Su.mode && "bulge" !== Su.mode || Eu(), Iu = co.texture.width / co.texture.height;
            }, Cu = function(t, e) {
                if (!t) return;
                Mu = Mu || t, Tu = Tu || e;
                const r = t[0] - Mu[0], n = t[1] - Mu[1], o = [];
                let a, c;
                for(let e = 0; e < co.mesh.distortion.length / 2; e++){
                    a = 2 * e, c = a + 1;
                    const u = [
                        co.mesh.distortion[a],
                        co.mesh.distortion[c]
                    ];
                    if (1 === Math.abs(u[0]) || 1 === Math.abs(u[1])) {
                        o[a] = u[0], o[c] = u[1];
                        continue;
                    }
                    let s = vn([
                        t[0] * Iu,
                        t[1]
                    ], [
                        u[0] * Iu,
                        u[1]
                    ]);
                    if (s <= Su.radius) {
                        s = Math.min(1, s / Su.radius);
                        let e = mn(s) * Su.strength;
                        if ("pinch" === Su.mode) e = 1 - e * Su.rate, o[a] = (u[0] - t[0]) * e + t[0], o[c] = (u[1] - t[1]) * e + t[1];
                        else if ("bulge" === Su.mode) e = 1 + Su.rate * e, o[a] = (u[0] - t[0]) * e + t[0], o[c] = (u[1] - t[1]) * e + t[1];
                        else if ("restore" === Su.mode) {
                            const t = i.create(), r = u, n = [
                                co.distortionVertices[a],
                                co.distortionVertices[c]
                            ];
                            i.lerp(t, r, n, .5 * e), o[a] = t[0], o[c] = t[1];
                        } else o[a] = u[0] + r * e, o[c] = u[1] + n * e;
                    } else o[a] = u[0], o[c] = u[1];
                }
                co.mesh.distortion = o, co.mesh.compileBuffer("distortion"), co.previewIntermediate = !0, Ca.render(), Mu = t, Tu && Tu();
            }, zu = ()=>(Mu = null, Tu = null, cancelAnimationFrame(Du), co.mesh.distortion && co.mesh.distortion.buffer ? co.mesh.distortion.buffer.slice(0) : []), { gl: Ou } = co;
            ei("faces", []);
            const Fu = {
                boundaries: !0,
                markers: !0
            };
            Ca.dependencies.add(function() {
                const { faces: t } = co.state;
                let e = co.prevState.faces || [];
                if (t && t.length && !En(e, t, !0, Fu)) {
                    logTime("generate face mask"), e = t;
                    const { width: r, height: n } = co.texture;
                    Hu(r, n, t), logTimeEnd("generate face mask");
                }
                return co.prevState.faces = e;
            });
            let Ru = {};
            const Pu = document.createElement("canvas"), Lu = Pu.getContext("2d"), ku = function(t, e) {
                Lu.fillStyle = e;
                const r = t[t.length - 1];
                Lu.beginPath(), Lu.moveTo(r[0], r[1]), t.forEach((t)=>Lu.lineTo(t[0], t[1])), Lu.fill();
            }, ju = (t, e, r)=>{
                const n = {
                    size: 0
                };
                if (r.markers) {
                    let o;
                    o = r.markers instanceof Array ? r.markers.map((r)=>[
                            r[0] * t,
                            r[1] * e
                        ]) : zn(r.markers, (r)=>r.map((r)=>[
                                r[0] * t,
                                r[1] * e
                            ])), n.markers = qu(o, null, [
                        1,
                        1
                    ]);
                }
                return r.boundaries && (n.boundaries = [
                    r.boundaries[0] * t,
                    r.boundaries[1] * e,
                    r.boundaries[2] * t,
                    r.boundaries[3] * e
                ], n.size = i.length([
                    r.boundaries[2],
                    r.boundaries[3]
                ])), n;
            }, Uu = function(t, e) {
                return [
                    .5 * t[0] + .5 * e[0],
                    .5 * t[1] + .5 * e[1]
                ];
            }, Bu = function(t) {
                const [e, r] = t.leftPupil, [n, o] = t.rightPupil, i = -Math.atan2(e - n, r - o) - Math.PI / 2;
                return [
                    Math.cos(i),
                    Math.sin(i)
                ];
            }, Nu = function(t, [e, r]) {
                return [
                    t[0] * e - t[1] * -r,
                    t[0] * -r + t[1] * e
                ];
            }, Gu = function(t) {
                return t.map((t)=>[
                        2 * t[0] - 1,
                        2 * -t[1] + 1
                    ]);
            }, Vu = function(t) {
                const [e, r, n, o] = t, i = [
                    e,
                    r
                ], a = [
                    e + n,
                    r
                ], c = [
                    e,
                    r + o
                ], u = [
                    e + n,
                    r + o
                ];
                return [
                    Uu(i, a),
                    Uu(a, u),
                    Uu(c, u),
                    Uu(i, c)
                ];
            }, qu = function(t, e, r = [
                1,
                Pu.height / Pu.width
            ]) {
                if (!(t instanceof Array)) return function(t, e, r) {
                    let n = {
                        jaw: t.faceContour,
                        leftEye: t.leftEye,
                        rightEye: t.rightEye,
                        nose: t.nose,
                        bottomNose: t.noseCrest,
                        lips: t.outerLips,
                        teeth: t.innerLips,
                        leftBrow: t.leftEyebrow,
                        rightBrow: t.rightEyebrow,
                        leftPupil: t.leftPupil,
                        rightPupil: t.rightPupil
                    };
                    n = zn(n, (t)=>e ? Gu(t) : t), n.mouth = n.lips, n.leftPupil = n.leftPupil[0], n.rightPupil = n.rightPupil[0], n.rotation = Bu(n);
                    const o = Uu(n.jaw[0], n.jaw[10]);
                    n.faceCenter = Nu(o, n.rotation), n.leftEyeCenter = Nu(en(n.leftEye), n.rotation), n.rightEyeCenter = Nu(en(n.rightEye), n.rotation), n.mouthCenter = Nu(Uu(n.teeth[5], n.teeth[2]), n.rotation), n.noseCenter = Nu(Uu(n.nose[0], n.nose[8]), n.rotation), n.mouthCorners = [
                        Nu(n.lips[9], n.rotation),
                        Nu(n.lips[5], n.rotation)
                    ];
                    const a = [], c = [
                        0,
                        0
                    ], u = e ? 30 : -30;
                    i.mul(c, o, r);
                    for(let t = 1; t < 6; t++){
                        let e = [
                            0,
                            0
                        ];
                        i.mul(e, n.jaw[10], r), i.sub(e, e, c), e = an(e, u * t), i.add(e, e, c), i.div(e, e, r), a.push(e);
                    }
                    return n.face = n.jaw.concat(a), n.forehead = [
                        n.jaw[10]
                    ].concat(a).concat([
                        n.jaw[0]
                    ]), n;
                }(t, e, r);
                e && (t = Gu(t));
                const n = {
                    jaw: t.slice(0, 17),
                    leftBrow: t.slice(17, 22),
                    rightBrow: t.slice(22, 27),
                    middleNose: t.slice(27, 31),
                    bottomNose: t.slice(31, 36),
                    leftEye: t.slice(36, 42),
                    rightEye: t.slice(42, 48),
                    upperLipTop: t.slice(48, 55),
                    lowerLipBottom: t.slice(55, 60),
                    upperLipBottom: t.slice(60, 65),
                    lowerLipTop: t.slice(65, 68)
                };
                n.nose = n.bottomNose.concat([
                    n.middleNose[1]
                ]), n.teeth = n.upperLipBottom.concat(n.lowerLipTop), n.lips = n.upperLipTop.concat(n.lowerLipBottom), n.mouth = n.lips, n.leftPupil = Uu(n.leftEye[0], n.leftEye[3]), n.rightPupil = Uu(n.rightEye[0], n.rightEye[3]), n.rotation = Bu(n);
                const o = Uu(n.jaw[0], n.jaw[16]);
                n.faceCenter = Nu(o, n.rotation), n.leftEyeCenter = Nu(en(n.leftEye), n.rotation), n.rightEyeCenter = Nu(en(n.rightEye), n.rotation), n.mouthCenter = Nu(Uu(n.teeth[2], n.teeth[6]), n.rotation), n.noseCenter = Nu(n.middleNose[0], n.rotation), n.mouthCorners = [
                    Nu(n.upperLipTop[0], n.rotation),
                    Nu(n.upperLipTop[6], n.rotation)
                ];
                const a = [], c = [
                    0,
                    0
                ], u = e ? 30 : -30;
                i.mul(c, o, r);
                for(let t = 1; t < 6; t++){
                    let e = [
                        0,
                        0
                    ];
                    i.mul(e, n.jaw[16], r), i.sub(e, e, c), e = an(e, u * t), i.add(e, e, c), i.div(e, e, r), a.push(e);
                }
                return n.face = n.jaw.concat(a), n.forehead = [
                    n.jaw[16]
                ].concat(a).concat([
                    n.jaw[0]
                ]), n;
            }, Yu = (t, e, r)=>{
                let n;
                return co.faceMasks[t] ? (n = co.faceMasks[t], Ou.bindTexture(Ou.TEXTURE_2D, n.id), Ou.pixelStorei(Ou.UNPACK_FLIP_Y_WEBGL, !0), Ou.pixelStorei(Ou.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), Ou.texImage2D(Ou.TEXTURE_2D, 0, n.format, n.format, n.type, e)) : n = Vr.Texture.fromImage(e), function(t, e = .024) {
                    Vr.Texture.setSize(co.writableTexture, t.width, t.height), Ou.loadIdentity();
                    const r = e * (t.width / t.height), n = e;
                    fo.blur_mask.set({
                        delta: [
                            0,
                            r
                        ],
                        blur: [
                            .7,
                            2
                        ],
                        spread: [
                            0,
                            .5
                        ],
                        scale: [
                            1,
                            1
                        ]
                    }), fo.blur_mask.render(t, co.writableTexture), fo.blur_mask.set({
                        delta: [
                            n,
                            0
                        ]
                    }), fo.blur_mask.render(co.writableTexture, t);
                }(n, r), co.faceMasks[t] = n, n;
            }, Hu = function(t, e, r) {
                const n = Math.max(512 / t, 512 / e), o = t * n >> 0, i = e * n >> 0;
                let a = !1;
                Ru = ((t, e, r)=>t.map(ju.bind(null, e, r)))(r, o, i), Ru.forEach((t, e)=>{
                    Pu.width = o, Pu.height = i, t.markers ? (ku(t.markers.face, "black"), ku(t.markers.lips, "red"), ku(t.markers.teeth, "green"), ku(t.markers.leftEye, "blue"), ku(t.markers.rightEye, "blue")) : t.boundaries && function(t, e) {
                        Lu.fillStyle = e;
                        const [r, n, o, i] = t, a = o / 2, c = i / 2;
                        Lu.ellipse(r + a, n + c, a, c, 0, 0, 2 * Math.PI), Lu.fill();
                    }(t.boundaries, "black");
                    const n = !co.faceMasks[e] && t.markers, c = Yu(e, Pu, .05 * t.size);
                    if (n) {
                        a = !0;
                        const n = co.distortionVertices, o = 2, i = n.length / o, u = {
                            leftEye: new Uint8Array(i),
                            rightEye: new Uint8Array(i),
                            forehead: new Uint8Array(i),
                            jaw: new Uint8Array(i),
                            nose: new Uint8Array(i),
                            mouth: new Uint8Array(i)
                        }, s = qu(r[e].markers, !0);
                        let l;
                        const f = .3 * t.size;
                        let h, d, p;
                        for(let t = 0; t < i; t++)h = t * o, d = h + 1, p = [
                            n[h],
                            n[d]
                        ], l = Qr(p, s.leftEye), l <= f && (l = 1 - Math.min(1, l / f), u.leftEye[t] = l * l * 255), l = Qr(p, s.rightEye), l <= f && (l = 1 - Math.min(1, l / f), u.rightEye[t] = l * l * 255), l = Qr(p, s.forehead), l <= f && (l = 1 - Math.min(1, l / f), u.forehead[t] = l * l * 255), l = Qr(p, s.jaw), l <= f && (l = 1 - Math.min(1, l / f), u.jaw[t] = l * l * 255), l = Qr(p, s.nose), l <= f && (l = 1 - Math.min(1, l / f), u.nose[t] = l * l * 255), l = Qr(p, s.mouth), l <= f && (l = 1 - Math.min(1, l / f), u.mouth[t] = l * l * 255);
                        c.weights = u, c.markers = s;
                    }
                }), a && oi({
                    face_features: co.state.face_features
                }), Pu.width = 0, Pu.height = 0;
            };
            var Wu = {
                getFaces: ()=>Ru,
                getFeatures: (t)=>qu(t.markers),
                getFaceCenter: function(t) {
                    const { markers: e } = t;
                    return e instanceof Array ? Uu(e[0], e[16]) : Uu(e.faceContour[0], e.faceContour[10]);
                },
                getBoundingBox: Vu,
                mapToScreen: function(t) {
                    const e = Vu(t).map((t)=>_u(t, {
                            toClipSpace: !0,
                            flipY: !0,
                            noInvert: !0
                        })), r = e[3][0], n = e[0][1];
                    return [
                        r,
                        n,
                        e[1][0] - r,
                        e[2][1] - n
                    ];
                }
            }, Xu = r(197), Ku = r.n(Xu);
            const Zu = document.createElement("canvas"), Ju = Zu.getContext("2d"), $u = (t = [
                0,
                0,
                0
            ])=>"string" == typeof t ? t : "rgba(".concat(255 * t[0] >> 0, ", ").concat(255 * t[1] >> 0, ", ").concat(255 * t[2] >> 0, ", ").concat(null != t[3] ? t[3] : 1, ")"), Qu = (t)=>Ju.measureText(t).width, ts = function(t, e, r, n, o, i) {
                const a = Ku()(t);
                for(;;){
                    const c = a.shift();
                    let u;
                    t = a.join(""), null != c && (i.fill && Ju.fillText(c, e, r), i.stroke && Ju.strokeText(c, e, r)), u = "" === t ? 0 : Qu(t);
                    if (e += n - u + o, n = u, "" === t) return e;
                }
            }, es = function(t, e) {
                let { spacing: r, wrapWidth: n } = e;
                if (Ju.font = e.font, !n) return t.split(/[\r\n]/g);
                const o = [], i = Qu(" ") + r;
                n >>= 0;
                const a = t.split(/[\r\n]/g);
                for(let t, e = 0; e < a.length; e++){
                    t = a[e];
                    let c = [], u = 0, s = t.split(" ");
                    for(let t = 0; t < s.length; t++){
                        let e = s[t], a = Qu(e) + r * e.length;
                        u += a, u > n ? t > 0 && (o.push(c.join(" ")), c = [], u = a) : u += i, c.push(e);
                    }
                    o.push(c.join(" "));
                }
                return o;
            }, rs = function(t, e) {
                const { padding: r, spacing: n, lineHeight: o, wrapWidth: i } = e, a = t.text.replace(/ +$/g, ""), c = es(a, e);
                let u = 0;
                const s = [];
                for(let t, e = 0; e < c.length; e++){
                    t = c[e];
                    const r = Qu(t);
                    u = Math.max(u, r + n * t.length), s.push(r);
                }
                const l = o * c.length + r.bottom + r.top;
                return i && (u = Math.max(u, i)), {
                    maxWidth: u,
                    maxHeight: l,
                    lines: c,
                    widths: s
                };
            }, ns = function(t, e) {
                let r, n, o;
                "artwork" === t.type ? (r = t.font_size * e * .3, n = {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                }) : (r = t.font_size * e * .1, n = {
                    top: 0,
                    bottom: Math.max(0, 1.2 - t.line_height) * r,
                    left: .2 * r,
                    right: .2 * r
                }, t.wrap && (o = e * t.wrap, o -= n.left + n.right));
                let i = "white";
                t.color && (i = $u(t.color));
                const a = $u(t.shadow_color), c = t.shadow_blur * r, u = t.shadow_offset[0] * r, s = t.shadow_offset[1] * r, l = r * t.stroke_size, f = $u(t.stroke_color), h = l / 2;
                return n.top += h, n.bottom += h, n.left += h, n.right += h, {
                    strokeWidth: l,
                    strokeColor: f,
                    shadowBlur: c,
                    shadowColor: a,
                    shadowOffsetX: u,
                    shadowOffsetY: s,
                    wrapWidth: o,
                    padding: n,
                    fontSize: r,
                    color: i,
                    font: "".concat(t.font_style, " ").concat(t.font_weight, " ").concat(r, "px ").concat(t.font_family, ', "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'),
                    lineHeight: r * t.line_height,
                    spacing: r * t.letter_spacing,
                    scale: t.scale || [
                        1,
                        1
                    ]
                };
            }, os = async function(t, e, r, n) {
                const o = r.maxSize || Ef.getMaxTextureSize();
                let i, a, c = e[t];
                const u = ns(c, r.width), { padding: s, spacing: l, lineHeight: f, scale: h } = u, { lines: d, widths: p, maxWidth: v, maxHeight: m } = rs(c, u), g = v + s.left + s.right >> 0, b = m >> 0;
                let x = Math.max(g * h[0], b * h[1]), y = Math.min(x, o) / x, _ = [
                    Math.abs(y * h[0]),
                    Math.abs(y * h[1])
                ];
                Zu.width = g * _[0] >> 0, Zu.height = b * _[1] >> 0, Ju.scale(_[0], _[1]);
                var w = s.left;
                let S = w, M = m / 2, T = M - (d.length - 1) * f / 2 - s.bottom / 2 + s.top / 2;
                const I = {
                    fill: !0
                };
                if ("outline" === c.mode ? (Ju.lineWidth = u.strokeWidth, Ju.strokeStyle = u.color, I.fill = !1, I.stroke = !0) : Ju.fillStyle = u.color, c.enable_stroke && u.strokeWidth && (Ju.lineWidth = u.strokeWidth, Ju.strokeStyle = u.strokeColor, I.stroke = !0), Ju.font = u.font, Ju.textBaseline = "middle", Ju.textAlign = "left", "justify" === c.align) for(i = 0; i < d.length; i++)if (a = d[i], x = v - l * a.length, M = T + f * i, p[i] < x) {
                    let t = a.split(/\s/g), e = 0, r = t.map(function(t) {
                        let r = Ju.measureText(t).width;
                        return e += r, r;
                    }), n = (x - e) / (t.length - 1) + l;
                    S = w;
                    for(let e = 0; e < t.length; e++){
                        let o = t[e];
                        S = ts(o, S, M, r[e], l, I) + n;
                    }
                } else ts(a, w, M, p[i], l, I);
                else for(i = 0; i < d.length; i++){
                    a = d[i];
                    let t = p[i];
                    x = v - l * a.length, S = (()=>{
                        switch(c.align){
                            case "right":
                                return w + x - t;
                            case "center":
                                return w + (x - t) / 2;
                            default:
                                return w;
                        }
                    })(), M = T + f * i, ts(a, S, M, t, l, I);
                }
                n({
                    context: Ju,
                    canvas: Zu,
                    compositeWidth: g,
                    compositeHeight: b,
                    text: c,
                    index: t
                });
            }, is = function(t, e, r) {
                for(let n = 0; n < t.length; n++)os(n, t, e, r);
            }, { gl: as } = co;
            function cs(t, e) {
                if (t && (t.distortionMatrix = t.distortionMatrix || n.create(), n.identity(t.distortionMatrix), e.distortion_points)) {
                    const r = Xr(e.distortion_points);
                    n.multiply(t.distortionMatrix, r, mu), n.invert(t.distortionMatrix, t.distortionMatrix);
                }
            }
            ei("text", [], (t)=>t.forEach((t, e)=>{
                    if (3 === t.shadow_color.length && (t.shadow_color[3] = t.shadow_opacity), !t.distortion_points) {
                        const e = co.texture.width / co.texture.height;
                        t.distortion_points = pu.concat(), t.position = [
                            2 * (t.position[0] - .5),
                            2 * -(t.position[1] - .5) * e
                        ];
                    }
                    us(co.textLayers[e], t), cs(co.textLayers[e], t), t.layer && Hi(t.layer);
                })), ei("textInvertedColor", [
                1,
                1,
                1,
                1
            ]), ei("textInverted", !1);
            const us = function(t, e) {
                if (!t) return;
                let r;
                r = e.orientation % 2 ? [
                    co.texture.height,
                    co.texture.width
                ] : [
                    co.texture.width,
                    co.texture.height
                ];
                const [n, i] = r, a = e.scale || [
                    1,
                    1
                ], c = t.matrix || o.create(), u = o.create(), s = o.create();
                o.ortho(u, n / -2, n / 2, i / -2, i / 2, -1, 1), o.invert(s, u), o.identity(c), o.translate(c, c, [
                    e.position[0],
                    e.position[1],
                    0
                ]), o.multiply(c, c, u), o.rotateZ(c, c, bn(-e.angle - e.orientation)), o.multiply(c, c, s), o.scale(c, c, [
                    t.compositeWidth / co.texture.width * a[0],
                    t.compositeHeight / co.texture.height * a[1],
                    1
                ]), t.matrix = c;
            }, ss = function(t) {
                const { canvas: e, text: r, index: n } = t, o = co.textLayers[n] || Vr.Texture.create(1, 1, {
                    format: as.RGBA
                });
                if (o.width = e.width, o.height = e.height, o.compositeWidth = t.compositeWidth, o.compositeHeight = t.compositeHeight, co.textLayers[n] = o, us(o, r), cs(o, r), as.bindTexture(as.TEXTURE_2D, o.id), as.pixelStorei(as.UNPACK_FLIP_Y_WEBGL, 1), as.pixelStorei(as.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), as.texParameteri(as.TEXTURE_2D, as.TEXTURE_MAG_FILTER, as.LINEAR), as.texParameteri(as.TEXTURE_2D, as.TEXTURE_MIN_FILTER, as.LINEAR), as.texImage2D(as.TEXTURE_2D, 0, o.format, o.format, o.type, e), r.enable_shadow) {
                    const t = 1, e = .5 * r.shadow_blur / 2, n = Math.ceil(o.height * e), i = o.width + n, a = o.height + n, c = Math.min(i * t, co.maxTextureSize), u = Math.min(a * t, co.maxTextureSize), s = o.shadow || Vr.Texture.create(c, u, {
                        format: as.ALPHA
                    }), l = co.readableTexture;
                    s.scale = [
                        o.width / i,
                        o.height / a
                    ];
                    const f = co.readableTexture.width, h = co.readableTexture.height;
                    Vr.Texture.setSize(co.readableTexture, c, u), Vr.Texture.setSize(co.writableTexture, c, u), function(t, e, r, n) {
                        const o = r, i = r / (t.width / t.height);
                        as.loadIdentity(), fo.blur_mask.set({
                            delta: [
                                0,
                                o
                            ],
                            blur: [
                                1,
                                1
                            ],
                            spread: [
                                0,
                                0
                            ],
                            scale: n
                        }), fo.blur_mask.render(t, co.writableTexture), fo.blur_mask.set({
                            delta: [
                                i,
                                0
                            ],
                            scale: [
                                1,
                                1
                            ]
                        }), fo.blur_mask.render(co.writableTexture, e);
                    }(o, l, e, s.scale), as.bindFramebuffer(as.FRAMEBUFFER, l.getFramebuffer()), as.framebufferTexture2D(as.FRAMEBUFFER, as.COLOR_ATTACHMENT0, as.TEXTURE_2D, l.id, 0), as.bindTexture(as.TEXTURE_2D, s.id), c === s.width && u === s.height || (s.width = c, s.height = u, as.texImage2D(as.TEXTURE_2D, 0, as.ALPHA, c, u, 0, as.ALPHA, as.UNSIGNED_BYTE, null)), as.copyTexImage2D(as.TEXTURE_2D, 0, as.ALPHA, 0, 0, c, u, 0), Vr.Texture.setSize(co.readableTexture, f, h), Vr.Texture.setSize(co.writableTexture, f, h), o.shadow = s;
                }
            };
            var ls = {
                getStyle: (t)=>ns(t, co.texture.width),
                getSize: (t)=>(function(t, e) {
                        const r = ns(t, e), n = rs(t, r);
                        return {
                            offsetWidth: (n.maxWidth + r.padding.left + r.padding.right) / e,
                            offsetHeight: (n.maxHeight + r.padding.top + r.padding.bottom) / e,
                            width: n.maxWidth / e,
                            height: n.maxHeight / e
                        };
                    })(t, co.texture.width),
                getColorCSS: $u,
                getLines: es,
                getMetrics: rs,
                generateLayers: is,
                forceUpdate: function() {
                    const { text: t } = co.state, e = {
                        width: co.texture.width,
                        height: co.texture.height
                    };
                    return is(t, e, ss), Ca.renderCacheTexture();
                },
                getIndexAtPoint: function(t, e) {
                    let r;
                    const n = o.create();
                    for(let i = 0; i < co.state.text.length; i++){
                        const a = co.textLayers[i];
                        o.multiply(n, co.overlayMatrix, a.matrix);
                        const c = la(t[0], t[1], !1, n), u = c[0] >= 0 && c[0] <= 1 && c[1] >= 0 && c[1] <= 1;
                        if (i === e && u) {
                            r = i;
                            break;
                        }
                        null == r && u && (r = i);
                        const s = c[0] * a.width >> 0, l = c[1] * a.height >> 0;
                        Vr.readPixels(s, l, 1, 1, a)[3] > 0 && (r = i);
                    }
                    return r;
                }
            };
            const { gl: fs } = co;
            class hs {
                constructor(t){
                    var e, r, n;
                    n = void 0, (r = "shader") in (e = this) ? Object.defineProperty(e, r, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[r] = n, this.shader = t;
                }
                uniforms(t) {
                    this.shader.uniforms(t);
                }
                render() {
                    this.shader.draw(co.overlayMesh);
                }
            }
            function ds(t, e = "basic.vert") {
                const n = Vr.Shader.create(r(194)("./".concat(e)), r(194)("./".concat(t)));
                return new hs(n);
            }
            const ps = {
                box_blur: ds("box_blur.frag"),
                box_blur_ab: ds("box_blur_ab.frag"),
                combine_mask: ds("combine_mask.frag")
            };
            let vs, ms, gs;
            function bs(t, e) {
                const r = 2 * t, n = [];
                t = -(t / 2);
                for(let o = 0; o < e; o++)t += r, n.push(t);
                return n;
            }
            function xs(t, e, r) {
                return ms.drawTo(()=>{
                    e.bind(4);
                    let n = [
                        0,
                        0,
                        0,
                        0
                    ];
                    Array.isArray(t) ? (t[0].bind(0), t[1].bind(1), t[2].bind(2), t[3].bind(3), n = [
                        2,
                        3,
                        0,
                        1
                    ]) : t.bind(0), ps.combine_mask.uniforms({
                        multitexture: !1,
                        textures: n,
                        maskTexture: 4,
                        maskTransform: r
                    }), ps.combine_mask.render();
                }), function() {
                    let t = ms;
                    ms = gs, gs = t;
                }(), gs;
            }
            function ys(t, e, { orientation: r = 0, feather: n = .5 }) {
                let { width: i, height: a } = co.texture;
                const c = sn(n, 1024, 256) / Math.max(i, a), u = i * c >> 0, s = a * c >> 0;
                let l = fs.UNSIGNED_BYTE;
                co.capabilities.canRenderToHalfFloatTexture ? l = fs.HALF_FLOAT_OES : co.capabilities.canRenderToFloatTexture && (l = fs.FLOAT), t ? (Vr.Texture.setSize(t, u, s), gs = t) : gs = Vr.Texture.create(u, s, {
                    type: l
                }), ms = Vr.Texture.create(u, s, {
                    type: l
                }), vs = function(t, e, r = 1) {
                    const n = bs(1 / t * r, 4), o = bs(1 / e * r, 4), i = {
                        x: new Float32Array(8),
                        y: new Float32Array(8)
                    };
                    for(let t = 0; t < 4; t++)i.x[2 * t + 0] = n[t], i.y[2 * t + 1] = o[t];
                    return i;
                }(u, s, n + .25);
                const f = o.create();
                if (r) {
                    const t = 90 * r * (Math.PI / 180);
                    o.rotateZ(f, f, t);
                }
                fs.loadIdentity(), fs.disable(fs.BLEND);
                const h = xs(co.textures.length ? co.textures : co.texture, e, f);
                var d;
                const p = function(t) {
                    return ms.drawTo(()=>{
                        t.bind(0), ps.box_blur.uniforms({
                            texture: 0,
                            delta: vs.x
                        }), ps.box_blur.render();
                    }), t.drawTo(()=>{
                        ms.bind(0), ps.box_blur.uniforms({
                            texture: 0,
                            delta: vs.y
                        }), ps.box_blur.render();
                    }), t;
                }((d = h, ms.drawTo(()=>{
                    d.bind(0), ps.box_blur.uniforms({
                        texture: 0,
                        delta: vs.x
                    }), ps.box_blur.render();
                }), d.drawTo(()=>{
                    ms.bind(0), ps.box_blur_ab.uniforms({
                        texture: 0,
                        delta: vs.y,
                        eps: 1e-4
                    }), ps.box_blur_ab.render();
                }), d));
                return Vr.Texture.delete(ms), Vr.Texture.delete(e), p;
            }
            const { gl: _s } = co;
            function ws(t) {
                for(let e in co.objectMasks)t[e] || (Vr.Texture.delete(co.objectMasks[e]), delete co.objectMasks[e], delete co.prevState.objectMasks[e]);
            }
            ei("objects", {}), Ca.dependencies.add(({ isInitialRender: t = !1 })=>{
                const e = co.state.local_adjustments || [], r = {};
                t && (co.prevState.objectMasks = {}, ws(r)), e.forEach((t)=>{
                    if ("object" === t.type) {
                        r[t.index] = !0;
                        const e = {
                            feather: t.feather
                        };
                        !En(co.prevState.objectMasks[t.index], e) && (!function(t, e) {
                            const { objects: r } = co.state;
                            if (r && null != r[t]) {
                                const { data: n, width: o, height: i, orientation: a } = r[t], c = Vr.Texture.fromData(n, o, i, {
                                    format: _s.LUMINANCE,
                                    flipY: !0
                                });
                                co.objectMasks[t] = ys(co.objectMasks[t], c, {
                                    orientation: a,
                                    feather: e
                                });
                            }
                        }(t.index, t.feather), co.prevState.objectMasks[t.index] = e);
                    }
                }), ws(r);
            });
            const { gl: Ss } = co;
            ei("blur_opacity", 1), ei("zoom_blur_strength", 0), ei("rotation_blur_strength", 0);
            const Ms = ()=>{
                Ss.disable(Ss.BLEND);
                const t = co.state.local_adjustments;
                for(let e = 0; e < t.length; e++){
                    const r = t[e], n = r.adjustments.blur * Number(!r.disabled) / 1.5, o = Math.min(1, e);
                    $i(r, n, o);
                }
            }, Ts = (t = co.readableTexture)=>{
                const e = t.width / t.height;
                fo.blur.set({
                    delta: [
                        0,
                        .054 * e
                    ]
                }), fo.blur.render(co.readableTexture, co.writableTexture), fo.blur.set({
                    delta: [
                        .054,
                        0
                    ]
                }), fo.blur.render(co.writableTexture, t);
            }, Is = (t, e = co.readableTexture)=>{
                fo[t].render(co.readableTexture, e);
            }, Ds = o.create();
            function Es() {
                const { width: t, height: e } = co.writableTexture, r = co.texture.width >> 1, n = co.texture.height >> 1;
                Vr.Texture.setSize(co.readableTexture, r, n), Vr.Texture.setSize(co.writableTexture, r, n), Vr.Texture.setSize(co.lensBlurTexture, r, n);
                const { matrix: i } = co;
                return o.identity(Ds), co.matrix = Ds, co.needsUpdate = !0, Ss.loadIdentity(), co.skipAfterLocal = !0, Ca.render(!1), {
                    width: t,
                    height: e,
                    matrix: i
                };
            }
            function As(t, e, r) {
                Vr.Texture.setSize(co.readableTexture, t, e), Vr.Texture.setSize(co.writableTexture, t, e), co.skipAfterLocal = !1, co.matrix = r;
            }
            Ca.dependencies.add(function() {
                const t = co.state.local_adjustments;
                let e = !1;
                const r = [];
                if (co.state.zoom_blur_strength && r.push("zoom_blur"), co.state.rotation_blur_strength && r.push("rotation_blur"), t.length) {
                    for(let r = 0; r < t.length; r++)e = e || !!t[r].adjustments.blur;
                    if (e) {
                        const { width: t, height: e, matrix: n } = Es();
                        Ms(), Ts(co.lensBlurTexture), r.forEach((t)=>{
                            co.lensBlurTexture.swapWith(co.readableTexture), Is(t, co.lensBlurTexture);
                        }), As(t, e, n), window.console.log("render blur texture");
                    }
                }
                if (!e && r.length > 0) {
                    const { width: t, height: e, matrix: n } = Es();
                    r.forEach(function(t, e) {
                        Is(t, co.lensBlurTexture), e < r.length - 1 && co.lensBlurTexture.swapWith(co.readableTexture);
                    }), As(t, e, n);
                }
                e || 0 !== r.length || Vr.Texture.setSize(co.lensBlurTexture, 1, 1);
            }), Ca.previews.add("blur", ()=>{
                Ms(), Ts();
            });
            const { gl: Cs } = co;
            ei("spots", []);
            const zs = {
                position: !0,
                size: !0,
                feather: !0
            };
            var Os, Fs;
            Ca.dependencies.add(function() {
                const t = co.state.spots;
                let e = co.prevState.spots || [];
                t.length && (En(e, t, !0, zs) || (logTime("render retouch map"), e = Tn(t), function() {
                    let { width: t, height: e } = co.texture;
                    const r = 1024 / Math.max(t, e);
                    t = Math.floor(t * r), e = Math.floor(e * r);
                    const n = t / e;
                    Vr.Texture.setSize(co.retouchTexture, t, e), Vr.Texture.setSize(co.readableTexture, t, e), Vr.Texture.setSize(co.writableTexture, t, e);
                    const i = co.matrix;
                    o.identity(co.tmpMatrix), co.matrix = co.tmpMatrix, Cs.loadIdentity(), function() {
                        Cs.disable(Cs.BLEND), co.textures.length ? fo.distortion_multitexture.render(null, co.readableTexture) : fo.distortion.render(co.texture, co.readableTexture);
                        const t = co.state.spots;
                        for(let e = 0; e < t.length; e++){
                            const r = t[e], n = Math.min(1, e);
                            fo.spot_heal_mask.set({
                                feather: r.feather,
                                size: r.size,
                                position: r.position,
                                sourcePosition: r.sourcePosition,
                                opacity: 6 * r.size[0],
                                alpha: n
                            }), fo.spot_heal_mask.render(co.readableTexture, co.writableTexture), co.swapTextures();
                        }
                    }(), fo.blur.set({
                        delta: [
                            0,
                            .036 * n
                        ]
                    }), fo.blur.render(co.readableTexture, co.writableTexture), fo.blur.set({
                        delta: [
                            .036,
                            0
                        ]
                    }), fo.blur.render(co.writableTexture, co.retouchTexture), co.matrix = i;
                }(), logTimeEnd("render retouch map"))), co.prevState.spots = e;
            }), Fs = function() {
                function t(t, e) {
                    var r, n, o, i, a, c, u, s, l, f, h, d, p, v, m, g, b, x, y, _, w;
                    for(o = [], l = [], r = [], n = [], i = [], y = [], a = c = 0, m = (f = t.length) - 1; 0 <= m ? c < m : c > m; a = 0 <= m ? ++c : --c)o[a] = (e[a + 1] - e[a]) / (t[a + 1] - t[a]), a > 0 && (l[a] = (o[a - 1] + o[a]) / 2);
                    for(l[0] = o[0], l[f - 1] = o[f - 2], _ = [], a = h = 0, g = f - 1; 0 <= g ? h < g : h > g; a = 0 <= g ? ++h : --h)0 === o[a] && _.push(a);
                    for(d = 0, u = _.length; d < u; d++)l[a = _[d]] = l[a + 1] = 0;
                    for(a = p = 0, b = f - 1; 0 <= b ? p < b : p > b; a = 0 <= b ? ++p : --p)r[a] = l[a] / o[a], n[a] = l[a + 1] / o[a], i[a] = Math.pow(r[a], 2) + Math.pow(n[a], 2), y[a] = 3 / Math.sqrt(i[a]);
                    for(_ = [], a = v = 0, x = f - 1; 0 <= x ? v < x : v > x; a = 0 <= x ? ++v : --v)i[a] > 9 && _.push(a);
                    for(w = 0, s = _.length; w < s; w++)l[a = _[w]] = y[a] * r[a] * o[a], l[a + 1] = y[a] * n[a] * o[a];
                    this.x = t.slice(0, f), this.y = e.slice(0, f), this.m = l;
                }
                return t.prototype.interpolate = function(t) {
                    var e, r, n, o, i, a, c, u, s, l;
                    for(i = a = c = this.x.length - 2; (c <= 0 ? a <= 0 : a >= 0) && !(this.x[i] <= t); i = c <= 0 ? ++a : --a);
                    return e = this.x[i + 1] - this.x[i], u = (t - this.x[i]) / e, s = Math.pow(u, 2), n = (l = Math.pow(u, 3)) - 2 * s + u, r = -2 * l + 3 * s, o = l - s, (2 * l - 3 * s + 1) * this.y[i] + n * e * this.m[i] + r * this.y[i + 1] + o * e * this.m[i + 1];
                }, t;
            }(), Os = function() {
                function t(t, e, r, n) {
                    var o, i, a, c, u, s, l, f, h, d, p, v, m, g, b, x, y, _, w, S, M;
                    if (null != t && null != e) {
                        for(a = null != r && null != n, u = [], S = [], h = [], w = [], M = [], i = [], o = [], c = [], f = [], _ = [], s = l = 0, g = d = t.length - 1; 0 <= g ? l < g : l > g; s = 0 <= g ? ++l : --l)u[s] = t[s + 1] - t[s], f[s] = e[s + 1] - e[s], _[s] = f[s] / u[s];
                        for(a && (S[0] = 3 * (e[1] - e[0]) / u[0] - 3 * r, S[d] = 3 * n - 3 * (e[d] - e[d - 1]) / u[d - 1]), s = p = 1, b = d; 1 <= b ? p < b : p > b; s = 1 <= b ? ++p : --p)S[s] = 3 / u[s] * (e[s + 1] - e[s]) - 3 / u[s - 1] * (e[s] - e[s - 1]);
                        for(a ? (h[0] = 2 * u[0], w[0] = .5, M[0] = S[0] / h[0]) : (h[0] = 1, w[0] = 0, M[0] = 0), s = v = 1, x = d; 1 <= x ? v < x : v > x; s = 1 <= x ? ++v : --v)h[s] = 2 * (t[s + 1] - t[s - 1]) - u[s - 1] * w[s - 1], w[s] = u[s] / h[s], M[s] = (S[s] - u[s - 1] * M[s - 1]) / h[s];
                        for(a ? (h[d] = u[d - 1] * (2 - w[d - 1]), M[d] = (S[d] - u[d - 1] * M[d - 1]) / h[d], i[d] = M[d]) : (h[d] = 1, M[d] = 0, i[d] = 0), s = m = y = d - 1; y <= 0 ? m <= 0 : m >= 0; s = y <= 0 ? ++m : --m)i[s] = M[s] - w[s] * i[s + 1], o[s] = (e[s + 1] - e[s]) / u[s] - u[s] * (i[s + 1] + 2 * i[s]) / 3, c[s] = (i[s + 1] - i[s]) / (3 * u[s]);
                        this.x = t.slice(0, +d + 1 || 9e9), this.a = e.slice(0, d), this.b = o, this.c = i.slice(0, d), this.d = c;
                    }
                }
                return t.prototype.derivative = function() {
                    var t, e, r, n, o, i, a, c, u, s, l;
                    for((l = new this.constructor).x = this.x.slice(0, this.x.length), l.a = this.b.slice(0, this.b.length), r = 0, n = (c = this.c).length; r < n; r++)t = c[r], l.b = 2 * t;
                    for(i = 0, o = (u = this.d).length; i < o; i++)e = u[i], l.c = 3 * e;
                    for(a = 0, s = this.d.length; 0 <= s ? a < s : a > s; 0 <= s ? ++a : --a)l.d = 0;
                    return l;
                }, t.prototype.interpolate = function(t) {
                    var e, r, n, o;
                    for(r = n = o = this.x.length - 1; (o <= 0 ? n <= 0 : n >= 0) && !(this.x[r] <= t); r = o <= 0 ? ++n : --n);
                    return e = t - this.x[r], this.a[r] + this.b[r] * e + this.c[r] * Math.pow(e, 2) + this.d[r] * Math.pow(e, 3);
                }, t;
            }();
            const { gl: Rs } = co;
            ei("curves_red", [
                [
                    0,
                    0
                ],
                [
                    255,
                    255
                ]
            ], Vs("red")), ei("curves_green", [
                [
                    0,
                    0
                ],
                [
                    255,
                    255
                ]
            ], Vs("green")), ei("curves_blue", [
                [
                    0,
                    0
                ],
                [
                    255,
                    255
                ]
            ], Vs("blue")), ei("curves_all", [
                [
                    0,
                    0
                ],
                [
                    255,
                    255
                ]
            ], Vs("all"));
            const Ps = {
                red: 0,
                green: 1,
                blue: 2,
                all: 3
            }, Ls = {
                red: !1,
                green: !1,
                blue: !1,
                all: !1
            }, ks = co.capabilities.canUseFloatTexture, js = ks ? Float32Array : Uint8Array, Us = ks ? Rs.FLOAT : Rs.UNSIGNED_BYTE, Bs = new js(1024);
            function Ns(t, e, r) {
                const n = un(t.interpolate(e), 0, 255);
                return isNaN(n) ? r : n;
            }
            function Gs(t, e) {
                const r = Ps[t], n = function(t) {
                    const e = [
                        [],
                        []
                    ];
                    for(let r = 0; r < t.length; r++)e[0].push(t[r][0]), e[1].push(t[r][1]);
                    return e;
                }(e), o = new Os(n[0], n[1]);
                let i = n[1][0];
                var a, c;
                Ls[t] = (a = e, c = co.defaultState["curves_" + t], a.length !== c.length || a[0][0] !== c[0][0] || a[0][1] !== c[0][1] || a[1][0] !== c[1][0] || a[1][1] !== c[1][1]), ri("render_curves", Ls.red || Ls.green || Ls.blue || Ls.all);
                for(let t = 0; t < 256; t++)i = Ns(o, t, i), Bs[4 * t + r] = ks ? i / 255 : i;
            }
            function Vs(t) {
                return function(e) {
                    Gs(t, e), Rs.bindTexture(Rs.TEXTURE_2D, co.curvesTexture.id), Rs.pixelStorei(Rs.UNPACK_FLIP_Y_WEBGL, 0), Rs.pixelStorei(Rs.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0), Rs.texImage2D(Rs.TEXTURE_2D, 0, Rs.RGBA, 256, 1, 0, Rs.RGBA, Us, Bs);
                };
            }
            uo("color_denoise", 0), uo("luminance_denoise", 0);
            let qs = new class extends po {
                resetDenoiseTexture() {
                    Vr.Texture.setSize(co.denoiseTexture, 0, 0);
                }
                generateDenoiseTexture() {
                    const { gl: t, denoiseTexture: e, dehazeTexture: r, downsampleResolution: n, zoom: o } = co, { width: i, height: a } = r;
                    let c;
                    Vr.Texture.setSize(e, i, a), co.downsampleResolution = [
                        i,
                        a
                    ], co.zoom = 1, t.loadIdentity(), t.disable(t.BLEND), co.textures.length ? (fo.display_multitexture.render(null, co.readableTexture), c = co.readableTexture) : c = co.texture;
                    const u = [], s = 1 / c.width, l = 1 / c.height;
                    for(let t = 0; t <= 7; t++)u[7 + t] = u[7 - t] = Math.exp(-t * t * (1 / 15));
                    fo.denoise_nlm1.set({
                        delta: s,
                        kernel: u
                    }), fo.denoise_nlm2.set({
                        delta: l,
                        kernel: u
                    }), fo.denoise_nlm1.render(c, co.writableTexture), fo.denoise_nlm2.render(co.writableTexture, e), co.downsampleResolution = n, co.zoom = o;
                }
                shouldRender() {
                    const { state: t, defaultState: e, denoiseTexture: r } = co;
                    return (t.color_denoise != e.color_denoise || t.luminance_denoise != e.luminance_denoise) && (r.width <= 1 && r.height <= 1 && this.generateDenoiseTexture(), !0);
                }
                onRender() {
                    co.dehazeTexture.bind(1), co.denoiseTexture.bind(2), this.set({
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ],
                        texture: 0,
                        dehazeTexture: 1,
                        denoiseTexture: 2,
                        luminance_denoise: co.state.luminance_denoise,
                        color_denoise: co.state.color_denoise
                    });
                }
            }({
                name: "denoise",
                vertex: "distortion"
            });
            Ca.dependencies.add(({ isInitialRender: t = !1 })=>{
                t && qs.resetDenoiseTexture();
            });
            const { gl: Ys } = co, Hs = {
                red: [
                    0,
                    8
                ],
                orange: [
                    1
                ],
                yellow: [
                    2
                ],
                green: [
                    3
                ],
                aqua: [
                    4
                ],
                blue: [
                    5
                ],
                purple: [
                    6
                ],
                magenta: [
                    7
                ]
            }, Ws = {
                hue: 0,
                saturation: 1,
                luminance: 2
            }, Xs = {
                hue: [
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5
                ],
                saturation: [
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5
                ],
                luminance: [
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5,
                    127.5
                ],
                degrees: [
                    0,
                    30,
                    60,
                    90,
                    180,
                    240,
                    270,
                    300,
                    360
                ]
            }, Ks = {
                hue: !1,
                saturation: !1,
                luminance: !1
            };
            ei("hue_red", 0, $s("hue", "red")), ei("hue_orange", 0, $s("hue", "orange")), ei("hue_yellow", 0, $s("hue", "yellow")), ei("hue_green", 0, $s("hue", "green")), ei("hue_aqua", 0, $s("hue", "aqua")), ei("hue_blue", 0, $s("hue", "blue")), ei("hue_purple", 0, $s("hue", "purple")), ei("hue_magenta", 0, $s("hue", "magenta")), ei("saturation_red", 0, $s("saturation", "red")), ei("saturation_orange", 0, $s("saturation", "orange")), ei("saturation_yellow", 0, $s("saturation", "yellow")), ei("saturation_green", 0, $s("saturation", "green")), ei("saturation_aqua", 0, $s("saturation", "aqua")), ei("saturation_blue", 0, $s("saturation", "blue")), ei("saturation_purple", 0, $s("saturation", "purple")), ei("saturation_magenta", 0, $s("saturation", "magenta")), ei("luminance_red", 0, $s("luminance", "red")), ei("luminance_orange", 0, $s("luminance", "orange")), ei("luminance_yellow", 0, $s("luminance", "yellow")), ei("luminance_green", 0, $s("luminance", "green")), ei("luminance_aqua", 0, $s("luminance", "aqua")), ei("luminance_blue", 0, $s("luminance", "blue")), ei("luminance_purple", 0, $s("luminance", "purple")), ei("luminance_magenta", 0, $s("luminance", "magenta"));
            const Zs = new Uint8Array(1080);
            function Js(t, e) {
                Ks[t] = function(t) {
                    const e = Xs[t];
                    for(let t = 0; t < e.length; t++)if (127.5 !== e[t]) return !0;
                    return !1;
                }(t), ri("render_hsl", Ks.hue || Ks.saturation || Ks.luminance);
                const r = new Fs(Xs.degrees, Xs[t]);
                let n = 0;
                for(let t = 0; t < 360; t++)Zs[3 * t + e] = n = un(r.interpolate(t), 0, 255) >> 0 || n;
            }
            function $s(t, e) {
                const r = Ws[t], n = Hs[e];
                return function(e) {
                    !function(t, e, r) {
                        for(let n = 0; n < e.length; n++)Xs[t][e[n]] = 255 * (r / 2 + .5);
                    }(t, n, .5 * e), Js(t, r), Ys.bindTexture(Ys.TEXTURE_2D, co.hslTexture.id), Ys.pixelStorei(Ys.UNPACK_FLIP_Y_WEBGL, 0), Ys.pixelStorei(Ys.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0), Ys.pixelStorei(Ys.UNPACK_ALIGNMENT, 1), Ys.texImage2D(Ys.TEXTURE_2D, 0, Ys.RGB, 360, 1, 0, Ys.RGB, Ys.UNSIGNED_BYTE, Zs);
                };
            }
            function Qs(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function tl(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? Qs(Object(r), !0).forEach(function(e) {
                        el(t, e, r[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Qs(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }
            function el(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            co.hslTexture = Vr.Texture.create(360, 1, {
                format: Ys.RGB
            });
            const { gl: rl } = co;
            new class extends po {
                setMatrix() {
                    const t = co.watermark.width, e = co.watermark.height, r = co.crop[2], n = co.crop[3], i = Wi.getImageSize(), a = t / r, c = e / n, { scale: u, rotation: s } = co.watermarkOptions, l = co.watermarkOptions.position, f = Math.sqrt(a * a + c * c), h = a / f * u, d = c / f * u, p = l[0], v = 1 - (l[1] + 1), m = p - h * p, g = v - d * v, b = i[0] / 2, x = i[1] / 2, y = [
                        (co.crop[0] - b) * co.cropScale + b,
                        (co.crop[1] - x) * co.cropScale + x,
                        co.crop[2] * co.cropScale,
                        co.crop[3] * co.cropScale
                    ], _ = (i[0] - y[2]) / 2 - y[0], w = -(i[1] - y[3]) / 2 + y[1], S = -_ / y[2] * 2, M = -w / y[3] * 2, T = y[2] / i[0], I = y[3] / i[1], D = o.create();
                    o.multiply(D, D, co.viewMatrix), o.scale(D, D, [
                        T,
                        I,
                        1
                    ]), o.translate(D, D, [
                        S,
                        M,
                        0
                    ]), o.translate(D, D, [
                        m,
                        g,
                        0
                    ]), o.scale(D, D, [
                        1 / r,
                        1 / n,
                        1
                    ]), o.rotateZ(D, D, bn(s)), o.scale(D, D, [
                        r,
                        n,
                        1
                    ]), o.scale(D, D, [
                        h,
                        d,
                        1
                    ]), rl.loadMatrix(D);
                }
                onRender() {
                    co.watermark.bind(0), this.setMatrix(), this.set({
                        texture: 0,
                        opacity: co.watermarkOptions.opacity
                    });
                }
                shouldRender() {
                    return !co.cropMode && !!(co.watermarkOptions.enabled && co.watermark && co.watermark.id);
                }
            }({
                name: "watermark"
            });
            const { gl: nl } = co, ol = co.pixelRatio, il = {
                color: Vr.Shader.create(r(110), r(166))
            }, al = {
                color: aa({
                    zIndex: 1,
                    defaultState: {
                        color: new Float32Array(3)
                    },
                    state: {
                        matrix: o.create(),
                        position: [
                            .5,
                            .5
                        ],
                        color: null,
                        size: 64
                    },
                    render () {
                        const t = this.state.size * ol, e = [
                            t / (co.texture.width * co.screen.zoom),
                            t / (co.texture.height * co.screen.zoom),
                            1
                        ], r = [
                            2 * this.state.position[0],
                            2 * this.state.position[1],
                            0
                        ];
                        o.translate(this.state.matrix, co.overlayMatrix, r), o.scale(this.state.matrix, this.state.matrix, e), nl.loadMatrix(this.state.matrix), co.dehazeTexture.bind(0), il.color.uniforms({
                            texture: 0,
                            texel: 1 / this.state.size,
                            position: this.state.position,
                            color: this.state.color || this.defaultState.color,
                            colorMix: this.state.color ? 1 : 0
                        }), il.color.draw(co.overlayMesh);
                    }
                })
            };
            function cl(t, e) {
                al[t].setState(e);
            }
            function ul(t, e) {
                al[t].setState(e), al[t].enable(), sa();
            }
            function sl(t) {
                al[t].disable(), sa();
            }
            const { gl: ll } = co, fl = [
                "highlights_hue",
                "highlights_saturation",
                "shadows_hue",
                "shadows_saturation"
            ], hl = {
                [co.processVersions.V1]: Vr.Shader.create(r(111), r(164)),
                [co.processVersions.V2]: Vr.Shader.create(r(111), r(165))
            };
            const dl = new class extends po {
                constructor(t){
                    super(t), this.setProcess(co.processVersions.V2);
                }
                setProcess(t) {
                    this.shader = hl[t] || hl[co.processVersions.V2];
                }
                setFrom(t, e) {
                    ll.useProgram(this.shader.program);
                    const r = (r)=>null != t[r] ? t[r] : e[r], n = mi().process == co.processVersions.V2;
                    let o;
                    for(o in e)n && o in fl || this.shader.setUniform(o, r(o));
                    if (this.shader.setUniform("render_curves", t.render_curves), this.shader.setUniform("render_hsl", t.render_hsl), this.shader.setUniform("render_lut", t.render_lut), n) {
                        const t = r("highlights_hue"), e = r("highlights_saturation"), n = r("shadows_hue"), o = r("shadows_saturation"), i = 0 != e || 0 != o;
                        this.shader.setUniform("render_split_tone", i), i && (this.shader.setUniform("precomputed_highlights_rgb", pn(t, e, 1)), this.shader.setUniform("precomputed_shadows_rgb", pn(n, o, 1)));
                    }
                }
                onRender() {
                    co.intermediateTexture.bind(1), co.dehazeTexture.bind(2), co.curvesTexture.bind(3), co.hslTexture.bind(4), co.lutTexture.bind(5), co.grainTexture.bind(6), this.set({
                        texture: 0,
                        originalTexture: 1,
                        dehazeTexture: 2,
                        curvesTexture: 3,
                        hslTexture: 4,
                        lookupTexture: 5,
                        grainTexture: 6,
                        grainTextureSize: [
                            co.grainTexture.width,
                            co.grainTexture.height
                        ],
                        lutSize: co.lutTexture.height,
                        distortion_amount: co.state.distortion_amount,
                        distortion_horizontal: co.state.distortion_horizontal,
                        distortion_vertical: co.state.distortion_vertical,
                        textureSize: [
                            co.texture.width,
                            co.texture.height
                        ],
                        textureScale: co.zoom,
                        viewMatrix: co.matrix,
                        distortionMatrix: co.distortionMatrix,
                        rotationMatrix: co.rotation90MatrixInv,
                        crop: co.state.crop
                    });
                }
            }({
                name: "adjustments",
                vertex: "distortion"
            });
            ei("process", co.processVersions.V2, pl);
            for(const t in ti)ei(t, ti[t]);
            function pl(t) {
                dl.setProcess(t);
            }
            function vl(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            let ml;
            !function(t) {
                t["1D"] = "1D", t["3D"] = "3D";
            }(ml || (ml = {}));
            class gl {
                static isSupported(t) {
                    const e = (t = t.toLowerCase()).split(".").pop();
                    return !!e && [
                        "cube",
                        "vf",
                        "3dl"
                    ].includes(e);
                }
                static parseLutFile(t, e) {
                    return "3dl" === e ? this.parse3dl(t) : "cube" === e || "vf" === e ? this.parseCube(t) : null;
                }
                static parseCubeLUT(t) {
                    const e = {
                        data: [],
                        domain: [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                1,
                                1,
                                1
                            ]
                        ],
                        size: 0,
                        title: "Cube LUT",
                        type: ml["3D"]
                    }, r = t.split("\n");
                    for (let t of r){
                        if (t = t.trim(), "#" === t[0] || "" === t) continue;
                        const r = t.split(/\s+/);
                        switch(r[0]){
                            case "TITLE":
                                e.title = t.slice(7, -1);
                                break;
                            case "DOMAIN_MIN":
                                e.domain[0] = r.slice(1).map(Number);
                                break;
                            case "DOMAIN_MAX":
                                e.domain[1] = r.slice(1).map(Number);
                                break;
                            case "LUT_1D_SIZE":
                                e.type = ml["1D"], e.size = Number(r[1]);
                                break;
                            case "LUT_3D_SIZE":
                                e.type = ml["3D"], e.size = Number(r[1]);
                                break;
                            case "LUT_1D_INPUT_RANGE":
                            case "LUT_3D_INPUT_RANGE":
                                break;
                            default:
                                e.data.push(...r.map(Number));
                        }
                    }
                    return e.size || (e.type === ml["1D"] ? e.size = Math.floor(e.data.length / 3) : e.size = Math.floor(Math.cbrt(e.data.length / 3))), e;
                }
                static parseCube(t) {
                    const e = this.parseCubeLUT(t);
                    return this.convert1dCubeTo3d(e), this.downscaleToMaxEdgeLength(e), e;
                }
                static parse3dl(t) {
                    const e = {
                        data: [],
                        domain: [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                1,
                                1,
                                1
                            ]
                        ],
                        size: 0,
                        title: "3D LUT",
                        type: ml["3D"]
                    };
                    let r = 4095;
                    const n = function*(t) {
                        const e = t.split("\n");
                        for (let t of e)t = t.trim(), "#" !== t[0] && t.length && (yield t);
                    }(t);
                    let o;
                    for(o = n.next(); o; o = n.next()){
                        if (o.done) return null;
                        const t = o.value.split(/ +/);
                        if (Number.isFinite(Number(t[0]))) break;
                        if ("MESH" === t[0]) {
                            const e = Number(t[2]);
                            Number.isFinite(e) && (r = Math.pow(2, e) - 1);
                        }
                    }
                    if (o.done) return null;
                    let i = o.value.split(/ +/).map(Number);
                    1 === i.length && (i[1] = i[0]), i = [
                        0,
                        r
                    ];
                    for (const t of n){
                        const r = t.split(/ +/).map(Number).reverse();
                        for(const t in r){
                            const e = r[t];
                            let n = 0;
                            for(let t = 0; t < i.length + 1; t++)if (e >= i[t] && e <= i[t + 1]) {
                                const r = i[t + 1] - i[t];
                                if (r) n = (t + (e - i[t]) / r) / (i.length - 1);
                                else n = i[t];
                            }
                            r[t] = n;
                        }
                        e.data.push(...r.map(Number));
                    }
                    return e.size = Math.cbrt(e.data.length / 3), this.downscaleToMaxEdgeLength(e), e;
                }
                static lutCoord3Dto1D(t, e, r) {
                    let n = 0;
                    for(let t = 0; t < 3; t++)n = n * e + r[t];
                    return n *= 3, t.slice(n, n + 3);
                }
            }
            vl(gl, "MAX_LUT_SIZE", 33), vl(gl, "convert1dCubeTo3d", (t)=>{
                if (t.type === ml["1D"]) {
                    const e = [], r = [
                        0,
                        0,
                        0
                    ], n = [
                        0,
                        0,
                        0
                    ];
                    for(r[0] = 0; r[0] < t.size; r[0]++)for(n[0] = t.data[r[0]], r[1] = 0; r[1] < t.size; r[1]++)for(n[1] = t.data[t.size + r[1]], r[2] = 0; r[2] < t.size; r[2]++)n[2] = t.data[2 * t.size + r[2]], e.push(...n);
                    t.type = ml["3D"];
                }
            }), vl(gl, "downscaleToMaxEdgeLength", (t)=>{
                if (t.size <= gl.MAX_LUT_SIZE) return;
                const e = [], r = [
                    0,
                    0,
                    0
                ];
                for(r[0] = 0; r[0] < gl.MAX_LUT_SIZE; r[0]++)for(r[1] = 0; r[1] < gl.MAX_LUT_SIZE; r[1]++)for(r[2] = 0; r[2] < gl.MAX_LUT_SIZE; r[2]++){
                    const n = r.map((e)=>e * (t.size - 1) / (gl.MAX_LUT_SIZE - 1)), o = [
                        n.map(Math.floor),
                        n.map(Math.ceil)
                    ], i = [
                        0,
                        0,
                        0
                    ], a = [
                        0,
                        0,
                        0
                    ];
                    let c = [
                        0,
                        0,
                        0
                    ], u = 0;
                    for(i[0] = o[0][0]; i[0] <= o[1][0]; i[0]++)for(a[0] = 1 - Math.abs(i[0] - n[0]), i[1] = o[0][1]; i[1] <= o[1][1]; i[1]++)for(a[1] = 1 - Math.abs(i[1] - n[1]), i[2] = o[0][2]; i[2] <= o[1][2]; i[2]++){
                        a[2] = 1 - Math.abs(i[2] - n[2]);
                        const e = a.reduce((t, e)=>t * e, 1), r = gl.lutCoord3Dto1D(t.data, t.size, i);
                        c = c.map((t, n)=>t + e * r[n]), u += e;
                    }
                    e.push(...c);
                }
                t.size = gl.MAX_LUT_SIZE, t.data = e;
            });
            const { gl: bl } = co;
            co.lutTexture = Vr.Texture.create(1, 1, {
                format: bl.RGB
            }), ei("lookup_cube", null, function(t) {
                if (yl === t) return;
                if (yl = t, ri("render_lut", !!t && !co.state.disable_lookup_cube), t) {
                    co.lutTexture.width = t.size * t.size, co.lutTexture.height = t.size;
                    const e = new Uint8Array(co.lutTexture.width * co.lutTexture.height * 3);
                    for(let r = 0; r < t.data.length; r++)e[r] = un(255 * t.data[r], 0, 255);
                    bl.bindTexture(bl.TEXTURE_2D, co.lutTexture.id), bl.pixelStorei(bl.UNPACK_FLIP_Y_WEBGL, 0), bl.pixelStorei(bl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0), bl.pixelStorei(bl.UNPACK_ALIGNMENT, 1), bl.texImage2D(bl.TEXTURE_2D, 0, bl.RGB, co.lutTexture.width, co.lutTexture.height, 0, bl.RGB, bl.UNSIGNED_BYTE, e);
                }
            }), ei("lookup_cube_name", null), ei("disable_lookup_cube", !1, (t)=>{
                ri("render_lut", !t);
            });
            const xl = {
                temperature: !0,
                tint: !0,
                vibrance: !0,
                saturation: !0,
                exposure: !0,
                gamma: !0,
                contrast: !0,
                whites: !0,
                blacks: !0,
                hue_red: !0,
                saturation_red: !0,
                luminance_red: !0,
                hue_orange: !0,
                saturation_orange: !0,
                luminance_orange: !0,
                hue_yellow: !0,
                saturation_yellow: !0,
                luminance_yellow: !0,
                hue_green: !0,
                saturation_green: !0,
                luminance_green: !0,
                hue_aqua: !0,
                saturation_aqua: !0,
                luminance_aqua: !0,
                hue_blue: !0,
                saturation_blue: !0,
                luminance_blue: !0,
                hue_purple: !0,
                saturation_purple: !0,
                luminance_purple: !0,
                hue_magenta: !0,
                saturation_magenta: !0,
                luminance_magenta: !0,
                curves_all: !0,
                curves_red: !0,
                curves_green: !0,
                curves_blue: !0,
                lookup_intensity: !0,
                lookup_cube: !0,
                shadows_hue: !0,
                shadows_saturation: !0,
                highlights_hue: !0,
                highlights_saturation: !0,
                balance: !0
            };
            let yl = null;
            function _l(t, e, r) {
                if (!t || !t.size) return r("Lookup table is empty.");
                const n = encodeURIComponent(t.name), o = Fn(t.name);
                if (!gl.isSupported(o)) return r(".".concat(o, " not supported"));
                const i = new FileReader;
                i.onload = ()=>{
                    const t = i.result, a = gl.parseLutFile(t, o);
                    if (!a || !a.size || !a.data || isNaN(a.data[0])) return void r("Cannot load lookup table.");
                    e({
                        lookup_cube_name: n,
                        lookup_cube: a,
                        lookup_intensity: 1
                    });
                }, i.onerror = function() {
                    r("Cannot load lookup table.");
                }, i.readAsText(t, "UTF-8");
            }
            function wl(t) {
                const e = gi(!0), r = {};
                for(const n in t)r[n] = xl[n] ? t[n] : e[n];
                return r;
            }
            function Sl(t) {
                const e = t.edgeSize || 32;
                let r = t.state || mi(!0);
                r = wl(r), r.is_lut_render = !0, r.lut_color_space = co.colorProfiles.sRGB;
                const n = e * e, o = e;
                "yuv" === t.colorSpace && (r.lut_color_space = co.colorProfiles.YUV);
                const i = Object.assign({}, co.state);
                return oi(r), Wi.updateForOutput(n, o, !1, !1), Ca.render(!1), oi(i), co.readableTexture;
            }
            new class extends po {
                shouldRender() {
                    return co.state.is_lut_render;
                }
                onRender() {
                    this.shader.uniforms({
                        img_size: [
                            this.readableTexture.width,
                            this.readableTexture.height
                        ],
                        texture: 0
                    });
                }
            }({
                name: "lookup_export_filter",
                uniforms: {
                    is_lut_render: !1,
                    lut_color_space: 0
                }
            });
            var Ml, Tl, Il = r(198), Dl = r.n(Il), El = r(128), Al = r(613), Cl = (Tl = new ArrayBuffer(2), new DataView(Tl).setInt16(0, 256, !0), 256 === new Int16Array(Tl)[0]);
            const zl = (t)=>{
                try {
                    return Al.decode(t);
                } catch (e) {
                    return t;
                }
            };
            var Ol = function(t) {
                return t.replace("GPS", "").replace("Ref", "Reference").replace("Dest", "Destination").replace("Img", "Image").replace("SubSec", "Sub-second").match(/(GPS|DOP|ISO|ID|JPEG|YCbCr|[A-Z])([a-z-]?)+/g).join(" ");
            }, Fl = function(t) {
                if (t.length < 4) return t[0] + "." + t[1] + t[2];
                var e = String.fromCharCode(t[0], t[1]) + "." + String.fromCharCode(t[2], t[3]);
                return "0" === e[0] && (e = e.slice(1)), e;
            }, Rl = function(t) {
                return t.join(", ");
            }, Pl = function(t) {
                let e = String.fromCharCode.apply(this, Array.from(t));
                return zl(e);
            }, Ll = function(t) {
                return t >= 1 ? "".concat(t, " sec") : "1/" + Math.round(1e3 / (1e3 * t)) + " sec";
            }, kl = function(t) {
                var e = t.trim().split(" "), r = e[0].replace(/:/g, "-");
                if (e.length > 1) var n = (r = new Date(r + "T" + e[1])).getHours(), o = r.getMinutes(), i = r.getSeconds().toString(), a = n >= 12 ? "pm" : "am", c = (n = (n %= 12) || 12) + ":" + (o = o < 10 ? "0" + o : o) + ":" + (i = i.length < 2 ? "0" + i : i) + " " + a;
                else r = new Date(r);
                var u = [
                    "Sun",
                    "Mon",
                    "Tues",
                    "Wed",
                    "Thur",
                    "Fri",
                    "Sat"
                ][r.getDay()] + " " + [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ][r.getMonth()] + " " + r.getDate() + " " + r.getFullYear();
                return c ? u + " " + c : u;
            }, jl = {
                ExifIFDPointer: {
                    id: 34665,
                    type: "LONG",
                    count: 1
                },
                GPSInfoIFDPointer: {
                    id: 34853,
                    type: "LONG",
                    count: 1
                },
                InteroperabilityIFDPointer: {
                    id: 40965,
                    type: "LONG",
                    count: 1
                },
                SubfileType: {
                    id: 255,
                    type: "SHORT",
                    values: {
                        1: "Full-resolution image",
                        2: "Reduced-resolution image",
                        3: "Single page of multi-page image"
                    }
                },
                NewSubfileType: {
                    id: 254,
                    type: "LONG",
                    values: {
                        0: "Full-resolution Image",
                        1: "Reduced-resolution image",
                        2: "Single page of multi-page image",
                        3: "Single page of multi-page reduced-resolution image",
                        4: "Transparency mask",
                        5: "Transparency mask of reduced-resolution image",
                        6: "Transparency mask of multi-page image",
                        7: "Transparency mask of reduced-resolution multi-page image",
                        65537: "Alternate reduced-resolution image"
                    }
                },
                ImageWidth: {
                    id: 256,
                    type: "LONG",
                    count: 1
                },
                ImageHeight: {
                    id: 257,
                    type: "LONG",
                    count: 1
                },
                BitsPerSample: {
                    label: Ol,
                    id: 258,
                    type: "SHORT",
                    count: 4
                },
                Compression: {
                    label: Ol,
                    id: 259,
                    type: "SHORT",
                    count: 1,
                    values: {
                        1: "Uncompressed",
                        2: "CCITT 1D",
                        3: "T4/Group 3 Fax",
                        4: "T6/Group 4 Fax",
                        5: "LZW",
                        6: "JPEG (old-style)",
                        7: "JPEG",
                        8: "Adobe Deflate",
                        9: "JBIG B&W",
                        10: "JBIG Color",
                        99: "JPEG",
                        262: "Kodak 262",
                        32766: "Next",
                        32767: "Sony ARW Compressed",
                        32769: "Packed RAW",
                        32770: "Samsung SRW Compressed",
                        32771: "CCIRLEW",
                        32772: "Samsung SRW Compressed 2",
                        32773: "PackBits",
                        32809: "Thunderscan",
                        32867: "Kodak KDC Compressed",
                        32895: "IT8CTPAD",
                        32896: "IT8LW",
                        32897: "IT8MP",
                        32898: "IT8BL",
                        32908: "PixarFilm",
                        32909: "PixarLog",
                        32946: "Deflate",
                        32947: "DCS",
                        34661: "JBIG",
                        34676: "SGILog",
                        34677: "SGILog24",
                        34712: "JPEG 2000",
                        34713: "Nikon NEF Compressed",
                        34715: "JBIG2 TIFF FX",
                        34718: "Microsoft Document Imaging (MDI) Binary Level Codec",
                        34719: "Microsoft Document Imaging (MDI) Progressive Transform Codec",
                        34720: "Microsoft Document Imaging (MDI) Vector",
                        34892: "Lossy JPEG",
                        65e3: "Kodak DCR Compressed",
                        65535: "Pentax PEF Compressed"
                    }
                },
                PhotometricInterpretation: {
                    label: Ol,
                    id: 262,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "WhiteIsZero",
                        1: "BlackIsZero",
                        2: "RGB",
                        3: "RGB Palette",
                        4: "Transparency mask",
                        5: "CMYK",
                        6: "YCbCr",
                        7: "CIELab",
                        8: "CIELab",
                        9: "ICCLab",
                        10: "ITULab",
                        32803: "Color Filter Array",
                        32844: "Pixar LogL",
                        32845: "Pixar LogLuv",
                        34892: "Linear Raw"
                    }
                },
                Orientation: {
                    label: Ol,
                    id: 274,
                    type: "SHORT",
                    count: 1,
                    values: {
                        1: "Normal",
                        2: "Flipped horizontally",
                        3: "Rotated 180\xb0",
                        4: "Flipped vertically",
                        5: "Rotated 90\xb0 CCW and flipped horizontally",
                        6: "Rotated 90\xb0 CCW",
                        7: "Rotated 90\xb0 CW and flipped horizontally",
                        8: "Rotated 90\xb0 CW"
                    }
                },
                SamplesPerPixel: {
                    label: Ol,
                    id: 277,
                    type: "SHORT",
                    count: 1
                },
                PlanarConfiguration: {
                    label: Ol,
                    id: 284,
                    type: "SHORT",
                    count: 1,
                    values: {
                        1: "Chunky format",
                        2: "Planar format"
                    }
                },
                YCbCrSubSampling: {
                    label: Ol,
                    id: 530,
                    type: "SHORT",
                    count: 2
                },
                YCbCrPositioning: {
                    label: Ol,
                    id: 531,
                    type: "SHORT",
                    count: 1,
                    values: {
                        1: "Centered",
                        2: "Co-sited"
                    }
                },
                XResolution: {
                    label: Ol,
                    group: "resolution",
                    id: 282,
                    type: "RATIONAL",
                    count: 1
                },
                YResolution: {
                    label: Ol,
                    group: "resolution",
                    id: 283,
                    type: "RATIONAL",
                    count: 1
                },
                ResolutionUnit: {
                    label: Ol,
                    group: "resolution",
                    id: 296,
                    type: "SHORT",
                    count: 1,
                    values: {
                        1: "None",
                        2: "Inches",
                        3: "Centimeters"
                    }
                },
                StripOffsets: {
                    id: 273,
                    type: "LONG",
                    count: 1
                },
                RowsPerStrip: {
                    id: 278,
                    type: "LONG",
                    count: 1
                },
                StripByteCounts: {
                    id: 279,
                    type: "LONG",
                    count: 1
                },
                JPEGInterchangeFormat: {
                    id: 513,
                    type: "LONG",
                    count: 1
                },
                JPEGInterchangeFormatLength: {
                    id: 514,
                    type: "LONG",
                    count: 1
                },
                TransferFunction: {
                    id: 301,
                    type: "SHORT",
                    count: 768
                },
                WhitePoint: {
                    id: 318,
                    type: "RATIONAL",
                    count: 2
                },
                PrimaryChromaticities: {
                    id: 319,
                    type: "RATIONAL",
                    count: 6
                },
                YCbCrCoefficients: {
                    id: 529,
                    type: "RATIONAL",
                    count: 3
                },
                ReferenceBlackWhite: {
                    id: 532,
                    type: "RATIONAL",
                    count: 6
                },
                DateTime: {
                    label: Ol,
                    id: 306,
                    type: "ASCII",
                    count: 20,
                    getValue: kl
                },
                ImageDescription: {
                    label: Ol,
                    group: "z",
                    id: 270,
                    type: "ASCII"
                },
                Make: {
                    label: Ol,
                    id: 271,
                    type: "ASCII"
                },
                Model: {
                    label: Ol,
                    id: 272,
                    type: "ASCII"
                },
                Software: {
                    label: Ol,
                    id: 305,
                    type: "ASCII"
                },
                Artist: {
                    label: Ol,
                    group: "z",
                    id: 315,
                    type: "ASCII"
                },
                Copyright: {
                    label: Ol,
                    group: "z",
                    id: 33432,
                    type: "ASCII"
                }
            }, Ul = {
                ExifVersion: {
                    label: Ol,
                    group: "version",
                    id: 36864,
                    type: "UNDEFINED",
                    count: 4,
                    getValue: Fl
                },
                FlashpixVersion: {
                    label: "FlashPix Version",
                    group: "version",
                    id: 40960,
                    type: "UNDEFINED",
                    count: 4,
                    getValue: Fl
                },
                ColorSpace: {
                    label: Ol,
                    id: 40961,
                    type: "SHORT",
                    count: 1,
                    values: {
                        1: "sRGB",
                        65535: "Uncalibrated"
                    }
                },
                Gamma: {
                    label: Ol,
                    id: 42240,
                    type: "RATIONAL",
                    count: 1
                },
                ComponentsConfiguration: {
                    label: Ol,
                    id: 37121,
                    type: "UNDEFINED",
                    count: 4,
                    values: {
                        0: "",
                        1: "Y",
                        2: "Cb",
                        3: "Cr",
                        4: "R",
                        5: "G",
                        6: "B"
                    },
                    getValue: function(t) {
                        var e = Ul.ComponentsConfiguration.values, r = e[t[0]] + e[t[1]] + e[t[2]] + e[t[3]];
                        return t.join(", ") + " (" + r + ")";
                    }
                },
                CompressedBitsPerPixel: {
                    label: Ol,
                    id: 37122,
                    type: "RATIONAL",
                    count: 1
                },
                PixelXDimension: {
                    label: Ol,
                    id: 40962,
                    type: "LONG",
                    count: 1
                },
                PixelYDimension: {
                    label: Ol,
                    id: 40963,
                    type: "LONG",
                    count: 1
                },
                MakerNote: {
                    id: 37500,
                    type: "UNDEFINED"
                },
                UserComment: {
                    label: Ol,
                    group: "z",
                    id: 37510,
                    type: "UNDEFINED",
                    getValue: function(t) {
                        if ("string" == typeof t) return t;
                        if (t && t.length > 8) {
                            var e = t.slice(8);
                            return Pl(e);
                        }
                        return "";
                    }
                },
                RelatedSoundFile: {
                    id: 40964,
                    type: "ASCII",
                    count: 13
                },
                DateTimeOriginal: {
                    label: Ol,
                    group: "datetime",
                    id: 36867,
                    type: "ASCII",
                    count: 20,
                    getValue: kl
                },
                DateTimeDigitized: {
                    label: Ol,
                    group: "datetime",
                    id: 36868,
                    type: "ASCII",
                    count: 20,
                    getValue: kl
                },
                OffsetTime: {
                    label: Ol,
                    group: "datetime",
                    id: 36880,
                    type: "ASCII",
                    count: 7
                },
                OffsetTimeOriginal: {
                    label: Ol,
                    group: "datetime",
                    id: 36881,
                    type: "ASCII",
                    count: 7
                },
                OffsetTimeDigitized: {
                    label: Ol,
                    group: "datetime",
                    id: 36882,
                    type: "ASCII",
                    count: 7
                },
                SubSecTime: {
                    label: Ol,
                    group: "datetime",
                    id: 37520,
                    type: "ASCII"
                },
                SubSecTimeOriginal: {
                    label: Ol,
                    group: "datetime",
                    id: 37521,
                    type: "ASCII"
                },
                SubSecTimeDigitized: {
                    label: Ol,
                    group: "datetime",
                    id: 37522,
                    type: "ASCII"
                },
                ExposureTime: {
                    label: Ol,
                    group: "exposure-speed",
                    id: 33434,
                    type: "RATIONAL",
                    count: 1,
                    getValue: Ll
                },
                FNumber: {
                    label: Ol,
                    group: "exposure",
                    id: 33437,
                    type: "RATIONAL",
                    count: 1
                },
                ExposureProgram: {
                    label: Ol,
                    group: "exposure",
                    id: 34850,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Not defined",
                        1: "Manual",
                        2: "Normal program",
                        3: "Aperture priority",
                        4: "Shutter priority",
                        5: "Creative program",
                        6: "Action program",
                        7: "Portrait mode",
                        8: "Landscape mode",
                        9: "Bulb"
                    }
                },
                SpectralSensitivity: {
                    label: Ol,
                    group: "exposure",
                    id: 34852,
                    type: "ASCII"
                },
                PhotographicSensitivity: {
                    label: "Photographic Sensitivity (ISO)",
                    group: "exposure-iso",
                    id: 34855,
                    type: "SHORT"
                },
                OECF: {
                    id: 34856,
                    type: "UNDEFINED"
                },
                SensitivityType: {
                    label: Ol,
                    group: "exposure-iso",
                    id: 34864,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Unknown",
                        1: "Standard output sensitivity (SOS)",
                        2: "Recommended exposure index (REI)",
                        3: "ISO speed",
                        4: "Standard output sensitivity (SOS) and recommended exposure index (REI)",
                        5: "Standard output sensitivity (SOS) and ISO speed",
                        6: "Recommended exposure index (REI) and ISO speed",
                        7: "Standard output sensitivity (SOS) and recommended exposure index (REI) and ISO speed"
                    }
                },
                StandardOutputSensitivity: {
                    label: Ol,
                    group: "exposure-iso",
                    id: 34865,
                    type: "LONG",
                    count: 1
                },
                RecommendedExposureIndex: {
                    label: Ol,
                    group: "exposure",
                    id: 34866,
                    type: "LONG",
                    count: 1
                },
                ISOSpeed: {
                    label: Ol,
                    group: "exposure-iso",
                    id: 34867,
                    type: "LONG",
                    count: 1
                },
                ISOSpeedLatitudeyyy: {
                    label: "ISO Speed Latitude yyy",
                    group: "exposure-iso",
                    id: 34868,
                    type: "LONG",
                    count: 1
                },
                ISOSpeedLatitudezzz: {
                    label: "ISO Speed Latitude zzz",
                    group: "exposure-iso",
                    id: 34869,
                    type: "LONG",
                    count: 1
                },
                ShutterSpeedValue: {
                    label: Ol,
                    group: "exposure-speed",
                    id: 37377,
                    type: "SRATIONAL",
                    count: 1,
                    getValue: function(t) {
                        var e = Math.pow(2, -t);
                        return Ll(e);
                    }
                },
                ApertureValue: {
                    label: Ol,
                    group: "exposure",
                    id: 37378,
                    type: "RATIONAL",
                    count: 1
                },
                BrightnessValue: {
                    label: Ol,
                    group: "exposure",
                    id: 37379,
                    type: "SRATIONAL",
                    count: 1
                },
                ExposureBiasValue: {
                    label: Ol,
                    group: "exposure",
                    id: 37380,
                    type: "SRATIONAL",
                    count: 1
                },
                MaxApertureValue: {
                    label: Ol,
                    id: 37381,
                    type: "RATIONAL",
                    count: 1
                },
                SubjectDistance: {
                    label: Ol,
                    group: "exposure",
                    id: 37382,
                    type: "RATIONAL",
                    count: 1
                },
                MeteringMode: {
                    label: Ol,
                    group: "exposure",
                    id: 37383,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Unknown",
                        1: "Average",
                        2: "Center-weighted average",
                        3: "Spot",
                        4: "Multi-spot",
                        5: "Pattern",
                        6: "Partial",
                        255: "Other"
                    }
                },
                LightSource: {
                    label: Ol,
                    group: "exposure",
                    id: 37384,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Unknown",
                        1: "Daylight",
                        2: "Fluorescent",
                        3: "Tungsten",
                        4: "Flash",
                        9: "Fine weather",
                        10: "Cloudy weather",
                        11: "Shade",
                        12: "Daylight fluorescent",
                        13: "Day white fluorescent",
                        14: "Cool white fluorescent",
                        15: "White fluorescent",
                        16: "Warm white fluorescent",
                        17: "Standard light A",
                        18: "Standard light B",
                        19: "Standard light C",
                        20: "D55",
                        21: "D65",
                        22: "D75",
                        23: "D50",
                        24: "ISO studio tungsten",
                        255: "Other"
                    }
                },
                Flash: {
                    label: Ol,
                    group: "exposure",
                    id: 37385,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "No Flash",
                        1: "Fired",
                        5: "Fired, Return not detected",
                        7: "Fired, Return detected",
                        8: "On, Did not fire",
                        9: "On, Fired",
                        13: "On, Return not detected",
                        15: "On, Return detected",
                        16: "Off, Did not fire",
                        20: "Off, Did not fire, Return not detected",
                        24: "Auto, Did not fire",
                        25: "Auto, Fired",
                        29: "Auto, Fired, Return not detected",
                        31: "Auto, Fired, Return detected",
                        32: "No flash function",
                        48: "Off, No flash function",
                        65: "Fired, Red-eye reduction",
                        69: "Fired, Red-eye reduction, Return not detected",
                        71: "Fired, Red-eye reduction, Return detected",
                        73: "On, Red-eye reduction",
                        77: "On, Red-eye reduction, Return not detected",
                        79: "On, Red-eye reduction, Return detected",
                        80: "Off, Red-eye reduction",
                        88: "Auto, Did not fire, Red-eye reduction",
                        89: "Auto, Fired, Red-eye reduction",
                        93: "Auto, Fired, Red-eye reduction, Return not detected",
                        95: "Auto, Fired, Red-eye reduction, Return detected"
                    }
                },
                FocalLength: {
                    label: Ol,
                    group: "exposure",
                    id: 37386,
                    type: "RATIONAL",
                    count: 1
                },
                SubjectArea: {
                    label: Ol,
                    id: 37396,
                    type: "SHORT",
                    count: 4,
                    getValue: Rl
                },
                FlashEnergy: {
                    label: Ol,
                    group: "exposure",
                    id: 41483,
                    type: "RATIONAL",
                    count: 1
                },
                SpatialFrequencyResponse: {
                    label: Ol,
                    id: 41484,
                    type: "UNDEFINED"
                },
                FocalPlaneXResolution: {
                    label: Ol,
                    id: 41486,
                    type: "RATIONAL",
                    count: 1
                },
                FocalPlaneYResolution: {
                    label: Ol,
                    id: 41487,
                    type: "RATIONAL",
                    count: 1
                },
                FocalPlaneResolutionUnit: {
                    label: Ol,
                    id: 41488,
                    type: "SHORT",
                    count: 1,
                    values: {
                        1: "None",
                        2: "Inches",
                        3: "cm",
                        4: "mm",
                        5: "um"
                    }
                },
                SubjectLocation: {
                    label: Ol,
                    id: 41492,
                    type: "SHORT",
                    count: 2,
                    getValue: Rl
                },
                ExposureIndex: {
                    label: Ol,
                    group: "exposure",
                    id: 41493,
                    type: "RATIONAL",
                    count: 1
                },
                SensingMethod: {
                    label: Ol,
                    group: "exposure",
                    id: 41495,
                    type: "SHORT",
                    count: 1,
                    values: {
                        1: "Monochrome area sensor",
                        2: "One-chip color area sensor",
                        3: "Two-chip color area sensor",
                        4: "Three-chip color area sensor",
                        5: "Color sequential area sensor",
                        6: "Monochrome linear sensor",
                        7: "Trilinear sensor",
                        8: "Color sequential linear sensor"
                    }
                },
                FileSource: {
                    label: Ol,
                    id: 41728,
                    type: "UNDEFINED",
                    count: 1,
                    values: {
                        0: "Other",
                        1: "Film scanner",
                        2: "Reflection print scanner",
                        3: "Digital camera"
                    }
                },
                SceneType: {
                    label: Ol,
                    group: "scene",
                    id: 41729,
                    type: "UNDEFINED",
                    count: 1,
                    values: {
                        1: "Directly photographed"
                    }
                },
                CFAPattern: {
                    id: 41730,
                    type: "UNDEFINED"
                },
                CustomRendered: {
                    label: Ol,
                    id: 41985,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Normal process",
                        1: "Custom process"
                    }
                },
                ExposureMode: {
                    label: Ol,
                    group: "exposure",
                    id: 41986,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Auto",
                        1: "Manual",
                        2: "Auto bracket"
                    }
                },
                WhiteBalance: {
                    label: Ol,
                    group: "exposure",
                    id: 41987,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Auto",
                        1: "Manual"
                    }
                },
                DigitalZoomRatio: {
                    label: Ol,
                    id: 41988,
                    type: "RATIONAL",
                    count: 1
                },
                FocalLengthIn35mmFilm: {
                    label: "Focal Length In 35mm Film",
                    id: 41989,
                    type: "SHORT",
                    count: 1
                },
                SceneCaptureType: {
                    label: Ol,
                    group: "scene",
                    id: 41990,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Standard",
                        1: "Landscape",
                        2: "Portrait",
                        3: "Night scene"
                    }
                },
                GainControl: {
                    label: Ol,
                    group: "scene",
                    id: 41991,
                    type: "RATIONAL",
                    count: 1,
                    values: {
                        0: "None",
                        1: "Low gain up",
                        2: "High gain up",
                        3: "Low gain down",
                        4: "High gain down"
                    }
                },
                Contrast: {
                    label: Ol,
                    group: "scene",
                    id: 41992,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Normal",
                        1: "Soft",
                        2: "Hard"
                    }
                },
                Saturation: {
                    label: Ol,
                    group: "scene",
                    id: 41993,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Normal",
                        1: "Low saturation",
                        2: "High saturation"
                    }
                },
                Sharpness: {
                    label: Ol,
                    group: "scene",
                    id: 41994,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Normal",
                        1: "Soft",
                        2: "Hard"
                    }
                },
                DeviceSettingDescription: {
                    id: 41995,
                    type: "UNDEFINED"
                },
                SubjectDistanceRange: {
                    label: Ol,
                    id: 41996,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Unknown",
                        1: "Macro",
                        2: "Close view",
                        3: "Distant view"
                    }
                },
                Temperature: {
                    label: Ol,
                    group: "situation",
                    id: 37888,
                    type: "SRATIONAL"
                },
                Humidity: {
                    label: Ol,
                    group: "situation",
                    id: 37889,
                    type: "RATIONAL"
                },
                Pressure: {
                    label: Ol,
                    group: "situation",
                    id: 37890,
                    type: "RATIONAL"
                },
                WaterDepth: {
                    label: Ol,
                    group: "situation",
                    id: 37891,
                    type: "SRATIONAL"
                },
                Acceleration: {
                    label: Ol,
                    group: "situation",
                    id: 37892,
                    type: "RATIONAL"
                },
                CameraElevationAngle: {
                    label: Ol,
                    group: "situation",
                    id: 37893,
                    type: "SRATIONAL"
                },
                ImageUniqueID: {
                    label: Ol,
                    id: 42016,
                    type: "ASCII",
                    count: 33
                },
                CameraOwnerName: {
                    label: Ol,
                    id: 42032,
                    type: "ASCII"
                },
                BodySerialNumber: {
                    label: Ol,
                    id: 42033,
                    type: "ASCII"
                },
                LensSpecification: {
                    label: Ol,
                    id: 42034,
                    type: "RATIONAL",
                    count: 4,
                    getValue: function(t) {
                        return t.map(function(t) {
                            return Number(t).toFixed(2);
                        }).join(", ");
                    }
                },
                LensMake: {
                    label: Ol,
                    id: 42035,
                    type: "ASCII"
                },
                LensModel: {
                    label: Ol,
                    id: 42036,
                    type: "ASCII"
                },
                LensSerialNumber: {
                    label: Ol,
                    id: 42037,
                    type: "ASCII"
                }
            }, Bl = {
                GPSVersionID: {
                    label: Ol,
                    id: 0,
                    type: "BYTE",
                    count: 4,
                    getValue: function(t) {
                        return "number" == typeof t ? t : t[0] + "." + t[1] + "." + t[2] + "." + t[3];
                    }
                },
                GPSLatitudeRef: {
                    id: 1,
                    type: "ASCII",
                    count: 2
                },
                GPSLatitude: {
                    label: Ol,
                    group: "acoords",
                    id: 2,
                    type: "RATIONAL",
                    count: 3,
                    getValue: function(t, e) {
                        var r = e.GPSLatitudeRef;
                        return "number" == typeof t ? t.toFixed(2) + "\xb0 " + r : t[0] + "\xb0 " + t[1] + "' " + t[2] + '" ' + r;
                    }
                },
                GPSLongitudeRef: {
                    id: 3,
                    type: "ASCII",
                    count: 2
                },
                GPSLongitude: {
                    label: Ol,
                    group: "acoords",
                    id: 4,
                    type: "RATIONAL",
                    count: 3,
                    getValue: function(t, e) {
                        var r = e.GPSLongitudeRef;
                        return "number" == typeof t ? t.toFixed(2) + "\xb0 " + r : t[0] + "\xb0 " + t[1] + "' " + t[2] + '" ' + r;
                    }
                },
                GPSAltitudeRef: {
                    label: Ol,
                    group: "acoords",
                    id: 5,
                    type: "BYTE",
                    count: 1,
                    values: {
                        0: "Above sea level",
                        1: "Below sea level"
                    }
                },
                GPSAltitude: {
                    label: Ol,
                    group: "acoords",
                    id: 6,
                    type: "RATIONAL",
                    count: 1,
                    getValue: function(t) {
                        return t.toFixed(2) + " m (" + (3.28084 * t).toFixed(2) + " ft)";
                    }
                },
                GPSTimeStamp: {
                    label: Ol,
                    group: "datetime",
                    id: 7,
                    type: "RATIONAL",
                    count: 3,
                    getValue: function(t) {
                        return "string" == typeof t ? t : t.map(function(t) {
                            return (t = t.toFixed(0)).length < 2 ? "0" + t : t;
                        }).join(":") + " UTC";
                    }
                },
                GPSSatellites: {
                    label: Ol,
                    id: 8,
                    type: "ASCII"
                },
                GPSStatus: {
                    label: Ol,
                    id: 9,
                    type: "ASCII",
                    count: 2,
                    values: {
                        A: "Measurement in progress",
                        V: "Measurement interrupted"
                    }
                },
                GPSMeasureMode: {
                    label: Ol,
                    id: 10,
                    type: "ASCII",
                    count: 2,
                    values: {
                        2: "2-dimensional",
                        3: "3-dimensional"
                    }
                },
                GPSDOP: {
                    label: Ol,
                    id: 11,
                    type: "RATIONAL",
                    count: 1
                },
                GPSSpeedRef: {
                    label: Ol,
                    id: 12,
                    type: "ASCII",
                    count: 2,
                    values: {
                        K: "Kilometers per hour",
                        M: "Miles per hour",
                        N: "Knots"
                    }
                },
                GPSSpeed: {
                    label: Ol,
                    id: 13,
                    type: "RATIONAL",
                    count: 1
                },
                GPSTrackRef: {
                    label: Ol,
                    id: 14,
                    type: "ASCII",
                    count: 2,
                    values: {
                        T: "True",
                        M: "Magnetic"
                    }
                },
                GPSTrack: {
                    label: Ol,
                    id: 15,
                    type: "RATIONAL",
                    count: 1
                },
                GPSImgDirectionRef: {
                    label: Ol,
                    id: 16,
                    type: "ASCII",
                    count: 2,
                    values: {
                        T: "True",
                        M: "Magnetic"
                    }
                },
                GPSImgDirection: {
                    label: Ol,
                    id: 17,
                    type: "RATIONAL",
                    count: 1
                },
                GPSMapDatum: {
                    label: Ol,
                    id: 18,
                    type: "ASCII"
                },
                GPSDestLatitudeRef: {
                    label: Ol,
                    id: 19,
                    type: "ASCII",
                    count: 2
                },
                GPSDestLatitude: {
                    label: Ol,
                    id: 20,
                    type: "RATIONAL",
                    count: 3
                },
                GPSDestLongitudeRef: {
                    label: Ol,
                    id: 21,
                    type: "ASCII",
                    count: 2
                },
                GPSDestLongitude: {
                    label: Ol,
                    id: 22,
                    type: "RATIONAL",
                    count: 3
                },
                GPSDestBearingRef: {
                    label: Ol,
                    id: 23,
                    type: "ASCII",
                    count: 2,
                    values: {
                        T: "True direction",
                        M: "Magnetic direction"
                    }
                },
                GPSDestBearing: {
                    label: Ol,
                    id: 24,
                    type: "RATIONAL",
                    count: 1
                },
                GPSDestDistanceRef: {
                    label: Ol,
                    id: 25,
                    type: "ASCII",
                    count: 2,
                    values: {
                        K: "Kilometers",
                        M: "Miles",
                        N: "Nautical miles"
                    }
                },
                GPSDestDistance: {
                    label: Ol,
                    id: 26,
                    type: "RATIONAL",
                    count: 1
                },
                GPSProcessingMethod: {
                    label: Ol,
                    id: 27,
                    type: "UNDEFINED",
                    getValue: Pl
                },
                GPSAreaInformation: {
                    label: Ol,
                    id: 28,
                    type: "UNDEFINED",
                    getValue: Pl
                },
                GPSDateStamp: {
                    label: Ol,
                    group: "datetime",
                    id: 29,
                    type: "ASCII",
                    count: 11,
                    getValue: kl
                },
                GPSDifferential: {
                    label: Ol,
                    id: 30,
                    type: "SHORT",
                    count: 1,
                    values: {
                        0: "Measurement without differential correction",
                        1: "Differential correction applied"
                    }
                },
                GPSHPositioningError: {
                    label: Ol,
                    id: 31,
                    type: "RATIONAL",
                    count: 1
                }
            };
            const Nl = {}, Gl = function(t, e, r) {
                for(let n in e)t[e[n].id] = {
                    name: n,
                    type: r
                };
                return t;
            };
            Gl(Nl, jl, "TIFF"), Gl(Nl, Ul, "Exif"), Gl(Nl, Bl, "GPS");
            var Vl = {
                BYTE: 1,
                ASCII: 2,
                SHORT: 3,
                LONG: 4,
                RATIONAL: 5,
                SBYTE: 6,
                UNDEFINED: 7,
                SSHORT: 8,
                SLONG: 9,
                SRATIONAL: 10,
                FLOAT: 11,
                DOUBLE: 12
            }, ql = {
                1: {
                    getValue: function(t) {
                        return Ml.getUint8(t);
                    },
                    setValue: function(t, e) {
                        Ml.setUint8(t, e);
                    },
                    size: 1
                },
                2: {
                    getValue: function(t) {
                        return String.fromCharCode(Ml.getUint8(t));
                    },
                    setValue: function(t, e) {
                        Ml.setUint8(t, String(e).charCodeAt(0));
                    },
                    size: 1
                },
                3: {
                    getValue: function(t, e) {
                        return Ml.getUint16(t, e);
                    },
                    setValue: function(t, e) {
                        Ml.setUint16(t, e);
                    },
                    size: 2
                },
                4: {
                    getValue: function(t, e) {
                        return Ml.getUint32(t, e);
                    },
                    setValue: function(t, e) {
                        Ml.setUint32(t, e);
                    },
                    size: 4
                },
                5: {
                    getValue: function(t, e) {
                        return Ml.getUint32(t, e) / Ml.getUint32(t + 4, e);
                    },
                    setValue: function(t, e) {
                        var r = new El(e || 0);
                        Ml.setUint32(t, r.n), Ml.setUint32(t + 4, r.d);
                    },
                    size: 8
                },
                6: {
                    getValue: function(t) {
                        return Ml.getInt8(t);
                    },
                    setValue: function(t, e) {
                        Ml.setInt8(t, e);
                    },
                    size: 1
                },
                8: {
                    getValue: function(t, e) {
                        return Ml.getInt16(t, e);
                    },
                    setValue: function(t, e) {
                        Ml.setInt16(t, e);
                    },
                    size: 2
                },
                9: {
                    getValue: function(t, e) {
                        return Ml.getInt32(t, e);
                    },
                    setValue: function(t, e) {
                        Ml.setInt32(t, e);
                    },
                    size: 4
                },
                10: {
                    getValue: function(t, e) {
                        return Ml.getInt32(t, e) / Ml.getInt32(t + 4, e);
                    },
                    setValue: function(t, e) {
                        var r = new El(e || 0);
                        Ml.setInt32(t, r.s * r.n), Ml.setInt32(t + 4, r.d);
                    },
                    size: 8
                },
                11: {
                    getValue: function(t, e) {
                        return Ml.getFloat32(t, e);
                    },
                    setValue: function(t, e) {
                        Ml.setFloat32(t, e);
                    },
                    size: 4
                },
                12: {
                    getValue: function(t, e) {
                        return Ml.getFloat64(t, e);
                    },
                    setValue: function(t, e) {
                        Ml.setFloat64(t, e);
                    },
                    size: 8
                }
            };
            ql[7] = ql[1];
            var Yl = function(t) {
                return "number" == typeof t && isNaN(t);
            }, Hl = function(t, e, r, n) {
                var o, i, a, c, u, s, l;
                if (!(o = jl[e] || Ul[e] || Bl[e])) return console.warn("Unknown Exif tag: ", e), 0;
                if (a = o.count || r && r.length || 1, c = Vl[o.type], i = (u = ql[c]).size * a, Yl(r) && (r = 0), "string" == typeof r) {
                    if ("UNDEFINED" === o.type) u = ql[2], s = !0;
                    else if ("ASCII" === o.type) l = r, r = Al.encode(l);
                    else {
                        var f = Number(r);
                        isNaN(f) ? (c = Vl.ASCII, u = ql[2], i = a = r.length, s = !0) : r = f;
                    }
                }
                if (("ASCII" === o.type || r instanceof Array) && (s = !0), "ASCII" === o.type && a > 4 && (i += 1), Ml.setUint16(t, o.id), Ml.setUint16(t + 2, c), Ml.setUint32(t + 4, a), i > 4 ? (Ml.setUint32(t + 8, n), i += 1, t = n) : t += 8, s) for(var h = 0; h < a; h++)void 0 === r[h] || Yl(r[h]) || u.setValue(t + h * u.size, r[h]);
                else u.setValue(t, r);
                return i;
            }, Wl = function(t = {}) {
                var e = {};
                for(let r in t)Object.assign(e, t[r]);
                delete e.ExifIFDPointer, delete e.GPSInfoIFDPointer, delete e.InteroperabilityIFDPointer, delete e.JPEGInterchangeFormat, delete e.JPEGInterchangeFormatLength;
                var r, n, o, i, a, c, u, s, l, f = 0;
                r = Object.keys(e), n = new ArrayBuffer(function(t) {
                    var e, r, n, o, i = 8;
                    for(e in t)r = t[e], (n = jl[e] || Ul[e] || Bl[e]) && (o = ql[Vl[n.type]].size * (n.count || r && r.length || 1), "ASCII" === n.type ? o += 1 : "string" == typeof r && "UNDEFINED" !== n.type && (o = r.length), o > 4 && (i += o + 1), i += 12);
                    return i += 60;
                }(e)), Ml = new DataView(n), u = r.filter(function(t) {
                    return !!jl[t];
                }), s = r.filter(function(t) {
                    return !!Ul[t];
                }), l = r.filter(function(t) {
                    return !!Bl[t];
                });
                var h = function(t) {
                    var r, n, u;
                    for(Ml.setUint16(f, t.length), f = (o = f + 2) + 12 * t.length + 2, u = 0; u < t.length; u++)"ExifIFDPointer" === (n = t[u]) ? a = o : "GPSInfoIFDPointer" === n ? i = o : "StripOffsets" === n && (c = o), void 0 !== e[n] && ((r = Hl(o, n, e[n], f)) > 4 && (f += r), o += 12);
                    f += 2;
                };
                return s.length && (u.push("ExifIFDPointer"), e.ExifIFDPointer = 0), l.length && (u.push("GPSInfoIFDPointer"), e.GPSInfoIFDPointer = 0), Ml.setUint16(0, Cl ? 19789 : 18761), Ml.setUint16(2, 42), Ml.setUint32(4, 8), f = 8, h(u), a && (Hl(a, "ExifIFDPointer", f), h(s)), i && (Hl(i, "GPSInfoIFDPointer", f), h(l)), c && Hl(c, "StripOffsets", f), Ml = null, n.slice(0, f);
            }, Xl = r(199), Kl = r.n(Xl), Zl = r(200), Jl = r.n(Zl);
            const { gl: $l } = co, Ql = document.createElement("canvas");
            function tf() {
                return "undefined" != typeof POIPCManager && POIPCManager.serviceImportURL;
            }
            function ef(t) {
                const e = tf();
                return e && "string" == typeof t ? t.replace(e, "ipc:") : t;
            }
            function rf(t) {
                const e = tf();
                return e && "string" == typeof t ? t.replace(/^ipc:/, e) : t;
            }
            const nf = function(t) {
                window.ImageBitmap && t instanceof ImageBitmap ? t.close() : (t instanceof HTMLImageElement && (t.onerror = null, t.onload = null), Ql.width = 0, Ql.height = 0);
            }, of = function() {
                if (null != co.texture.id && ($l.bindTexture($l.TEXTURE_2D, co.texture.id), $l.deleteTexture(co.texture.id), co.texture.id = null), null != co.textures) for (const t of co.textures)$l.bindTexture($l.TEXTURE_2D, t.id), $l.deleteTexture(t.id);
                if (null != co.faceMasks) for (const t of co.faceMasks)$l.bindTexture($l.TEXTURE_2D, t.id), $l.deleteTexture(t.id);
                co.depthTexture && (Vr.Texture.delete(co.depthTexture), co.depthTexture = null), co.texture = {}, co.textures = [], co.faceMasks = [];
            }, af = function() {
                const t = Wi.getImageSize(), e = Wi.getMinZoom({
                    useImageSize: !0
                });
                Wi.setOffset(0, 0), Wi.setZoom(e), Wi.setSize(t[0], t[1]), Wi.update(), co.screen.zoom = co.zoom, co.screen.center = Wi.getCenter(), co.screen.offset = co.offset.slice(0);
            }, cf = async function(t, e = !0) {
                let r;
                var n;
                ba(), co.screen.rotation = [
                    0,
                    0,
                    0
                ], co.prevState = {}, co.originalTexture && (Vr.Texture.delete(co.originalTexture), co.originalTexture = null), co.photoLoaded || (co.photoLoaded = !0, r = co.readyProps), await (n = t, Zo.prevIndex = 0, Zo.rasterizeIndex = 0, bo.List.isList(n) ? di(n) : n instanceof Array ? pi(n) : oi(n)), e && (af(), function(t = {}) {
                    const e = {
                        props: t,
                        duration: 0,
                        completed: null,
                        step: null,
                        render: !1
                    };
                    ra(e.props, e.duration, e.completed, e.step, e.render);
                }(r)), await Promise.all(Ca.dependencies.render({
                    isInitialRender: !0
                }));
            }, uf = async function(t, e, r, n, o, i = {}) {
                const { ignoreColorspace: a = "sRGB" !== co.colorProfileName, resizeWidth: c = n, resizeHeight: u = o } = i;
                if (window.createImageBitmap) return createImageBitmap(t, e, r, n, o, {
                    colorSpaceConversion: a ? "none" : "default",
                    imageOrientation: "flipY",
                    resizeWidth: c,
                    resizeHeight: u
                }).then((t)=>{
                    const e = Vr.Texture.fromImage(t, {
                        magFilter: $l.LINEAR,
                        format: co.textureFormat,
                        ignoreColorspace: a
                    });
                    return t.close(), e;
                });
                Ql.width = c, Ql.height = u;
                return Ql.getContext("2d").drawImage(t, e, r, n, o, 0, 0, c, u), Vr.Texture.fromImage(Ql, {
                    magFilter: $l.LINEAR,
                    format: co.textureFormat,
                    ignoreColorspace: a
                });
            };
            function sf(t) {
                return t = rf(t), new Promise((e, r)=>{
                    const n = new Image;
                    n.decoding = "async", n.crossOrigin = "anonymous", n.style.imageOrientation = "none", n.onload = ()=>e(n), n.onerror = (t)=>r(t), n.src = t;
                });
            }
            function lf(t) {
                t = t.map(rf);
                return Promise.all(t.map((t)=>new Promise((e)=>{
                        const r = new Image;
                        r.decoding = "async", r.crossOrigin = "anonymous", r.onload = ()=>e(r), r.onerror = ()=>e(null), r.src = t;
                    })));
            }
            async function ff(t) {
                if (Array.isArray(t)) {
                    const e = t[0].width + t[1].width, r = t[0].height + t[2].height;
                    co.scaleX = 1, co.texture = {
                        width: e,
                        height: r
                    };
                    const n = {
                        magFilter: $l.LINEAR,
                        format: co.textureFormat,
                        ignoreColorspace: "sRGB" !== co.colorProfileName
                    };
                    co.textures = [
                        Vr.Texture.fromImage(t[0], n),
                        Vr.Texture.fromImage(t[1], n),
                        Vr.Texture.fromImage(t[2], n),
                        Vr.Texture.fromImage(t[3], n)
                    ], t.forEach(nf);
                } else if (t.width > co.maxTextureSize || t.height > co.maxTextureSize) {
                    const e = t.width >> 1, r = t.height >> 1, n = Math.min(co.maxTextureSize / Math.max(e, r), 1), o = e * n >> 0, i = r * n >> 0, a = o << 1, c = i << 1;
                    co.scaleX = 1, co.texture = {
                        width: a,
                        height: c
                    };
                    const u = {
                        resizeWidth: o,
                        resizeHeight: i,
                        ignoreColorspace: "sRGB" !== co.colorProfileName
                    };
                    co.textures = await Promise.all([
                        uf(t, 0, 0, e, r, u),
                        uf(t, e, 0, e, r, u),
                        uf(t, 0, r, e, r, u),
                        uf(t, e, r, e, r, u)
                    ]), nf(t);
                } else {
                    if ("function" == typeof window.createImageBitmap) try {
                        t = await createImageBitmap(t, {
                            imageOrientation: "flipY"
                        });
                    } catch (t) {}
                    co.texture = Vr.Texture.fromImage(t, {
                        magFilter: $l.LINEAR,
                        format: co.textureFormat,
                        ignoreColorspace: "sRGB" !== co.colorProfileName
                    }), nf(t);
                }
            }
            function hf({ data: t, width: e, height: r, flipY: n }) {
                t.length > e * r * 3 ? co.textureFormat = $l.RGBA : co.textureFormat = $l.RGB;
                let o = $l.UNSIGNED_BYTE;
                return t instanceof Uint16Array && (o = $l.HALF_FLOAT_OES), t instanceof Float32Array && (o = $l.FLOAT), Vr.Texture.fromData(t, e, r, {
                    magFilter: $l.LINEAR,
                    format: co.textureFormat,
                    type: o,
                    flipY: n
                });
            }
            function df({ data: t, width: e, height: r, flipY: n, stride: o }) {
                const i = e, a = r;
                if (o && o !== e ? (co.scaleX = (e - 2) / o, e = o) : co.scaleX = 1, t instanceof Array) {
                    co.texture = {
                        width: i,
                        height: a
                    }, e >>= 1, r >>= 1;
                    const [o, c, u, s] = t;
                    co.textures[0] = hf({
                        data: u,
                        width: e,
                        height: r,
                        flipY: n
                    }), co.textures[1] = hf({
                        data: s,
                        width: e,
                        height: r,
                        flipY: n
                    }), co.textures[2] = hf({
                        data: o,
                        width: e,
                        height: r,
                        flipY: n
                    }), co.textures[3] = hf({
                        data: c,
                        width: e,
                        height: r,
                        flipY: n
                    });
                } else co.texture = hf({
                    data: t,
                    width: e,
                    height: r,
                    flipY: n
                });
            }
            async function pf(t, e) {
                let { settings: r, alpha: n, depth: o, colorProfile: i, done: a, resetViewport: c } = e;
                null == n && (n = !1), null == r && (r = co.state), of(), co.colorProfileName = i, co.colorProfile = co.colorProfiles[i] || 0, co.textureFormat = n ? $l.RGBA : $l.RGB, await ff(t);
                const u = await (s = o, s = rf(s), new Promise((t)=>{
                    if (!s) return void t(null);
                    const e = new Image;
                    e.decoding = "async", e.crossOrigin = "anonymous", e.onload = ()=>t(e), e.onerror = ()=>t(null), e.src = s;
                }));
                var s;
                log("DEPTH URL:", o, !!u), u && (co.depthTexture = Vr.Texture.fromImage(u, {
                    format: $l.LUMINANCE
                }), nf(u)), await cf(r, c), "function" == typeof a && a();
            }
            const vf = async (t, e)=>{
                t = rf(t);
                try {
                    const r = await sf(t);
                    await pf(r, e), nf(r);
                } catch (t) {
                    e.error(t);
                }
            };
            co.reloadSource = async function() {
                const t = co.originalSource, e = co.originalSourceOptions;
                if (co.setPixelFormat(e.pixelFormat), co.colorProfileName = e.colorProfile, co.colorProfile = co.colorProfiles[e.colorProfile] || 0, "string" == typeof t) {
                    const e = await sf(t);
                    await ff(e);
                } else if (t instanceof Array) {
                    const e = await lf(t);
                    await ff(e);
                } else if (t instanceof Image) await ff(t);
                else if (t instanceof File || t instanceof Blob) {
                    const e = window.URL.createObjectURL(t), r = await sf(e);
                    await ff(r);
                } else t && t.data && await df(t);
                ba();
            };
            const mf = async function(t, e, r) {
                let { quality: n, exif: o, xmp: i, iptc: a } = r;
                n = n || 90;
                let c = await Ca.renderOutput(t, e, r);
                o && (Object.assign(o.Exif, {
                    PixelXDimension: c.width,
                    PixelYDimension: c.height
                }), delete o.TIFF.PrimaryChromaticities, delete o.TIFF.WhitePoint, o = Wl(o));
                const u = {
                    exif: o,
                    xmp: i,
                    iptc: a
                };
                let s = null;
                try {
                    s = Dl()(c, n, u);
                } catch (t) {}
                return s && (c = {
                    data: s,
                    width: c.width,
                    height: c.height
                }), c;
            }, gf = async function(t, e = {}) {
                if (!co.photoLoaded) return;
                t = t.toLowerCase();
                const r = Wi.getImageInfo();
                let n, o = e.width || r.cropWidth, i = e.height || r.cropHeight;
                if (o < 10 || i < 10) {
                    const t = o / (i || o);
                    i = 10, o = i * t;
                }
                return "jpeg" === t || "jpg" === t ? n = mf(o, i, e) : "heif" === t ? (e.quality = 100, n = mf(o, i, e)) : "cube" === t ? n = async function(t, e, r) {
                    const n = await Ca.renderOutput(t, e, r);
                    return {
                        width: n.width,
                        height: n.height,
                        data: n.data
                    };
                }(o, i, e) : "png" === t || "webp" === t ? n = async function(t, e, r) {
                    let n = await Ca.renderOutput(t, e, r);
                    const o = Kl()(n.data, n.width, n.height);
                    return n = {
                        width: n.width,
                        height: n.height,
                        data: o
                    }, n;
                }(o, i, e) : "tiff" === t || "tif" === t ? n = async function(t, e, r) {
                    let { exif: n } = r, o = await Ca.renderOutput(t, e, r);
                    n && (Object.assign(n.Exif, {
                        PixelXDimension: o.width,
                        PixelYDimension: o.height
                    }), Object.assign(n.TIFF, {
                        NewSubfileType: 0,
                        ImageWidth: o.width,
                        ImageHeight: o.height,
                        BitsPerSample: [
                            8,
                            8,
                            8,
                            8
                        ],
                        Compression: 1,
                        PhotometricInterpretation: 2,
                        StripOffsets: 0,
                        SamplesPerPixel: 3,
                        RowsPerStrip: o.height,
                        StripByteCounts: o.height * o.width * 3
                    }), delete n.TIFF.PrimaryChromaticities, delete n.TIFF.WhitePoint, n = Wl(n));
                    const i = Jl()(o.data, o.width, o.height, n);
                    return o = {
                        width: o.width,
                        height: o.height,
                        data: i
                    }, o;
                }(o, i, e) : "data" === t ? n = Ca.renderOutput(o, i, e) : "texture" === t && (e.returnTexture = !0, n = Ca.renderOutput(o, i, e)), await n;
            }, bf = function(t, e) {
                return t = t instanceof Array ? t : [
                    t
                ], new Blob(t, {
                    type: "image/".concat(e)
                });
            };
            var xf = {
                getMaxSize: ()=>co.maxTextureSize,
                unloadImage: function() {
                    of(), co.photoLoaded = !1, Ca.clear();
                },
                isPhotoLoaded: function() {
                    return co.photoLoaded;
                },
                loadSource: function(t, e = {}) {
                    return e = Object.assign({
                        colorProfile: "sRGB",
                        pixelFormat: "RGBA"
                    }, e), co.setPixelFormat(e.pixelFormat), co.originalSource = t, co.originalSourceOptions = {
                        colorProfile: e.colorProfile,
                        pixelFormat: e.pixelFormat
                    }, new Promise((r, n)=>{
                        const o = e.done || On, i = e.error || On;
                        if (e.done = ()=>{
                            o(), r();
                        }, e.error = (t)=>{
                            i(t), n(t);
                        }, "string" == typeof t) t = ef(t), co.originalSource = t, vf(t, e);
                        else if (t instanceof Array) t[0] instanceof ArrayBuffer || ArrayBuffer.isView(t[0]) ? (co.originalSource = {
                            data: t,
                            width: e.width,
                            height: e.height,
                            flipY: e.flipY,
                            stride: e.stride
                        }, (async (t, e)=>{
                            let { settings: r, width: n, height: o, done: i, resetViewport: a, flipY: c, stride: u } = e;
                            if (4 === t.length) return null == r && (r = co.state), of(), df({
                                data: t,
                                width: n,
                                height: o,
                                flipY: c,
                                stride: u
                            }), await cf(r, a), "function" == typeof i ? i() : void 0;
                            e.error("There must be 4 image chunks");
                        })(t, e)) : (t = t.map(ef), co.originalSource = t, ((t, e)=>{
                            4 === t.length ? lf(t = t.map(rf)).then((t)=>pf(t, e)) : e.error("There must be 4 image chunks");
                        })(t, e));
                        else if (t instanceof Image) pf(t, e);
                        else if (t instanceof File || t instanceof Blob) {
                            const r = window.URL.createObjectURL(t);
                            vf(r, e);
                        } else if (t instanceof ArrayBuffer || ArrayBuffer.isView(t)) {
                            if (e.width && e.height) co.originalSource = {
                                data: t,
                                width: e.width,
                                height: e.height,
                                flipY: e.flipY,
                                stride: e.stride
                            }, async function(t, e) {
                                let { settings: r, width: n, height: o, done: i, error: a, resetViewport: c, flipY: u, stride: s } = e;
                                n > co.maxTextureSize || o > co.maxTextureSize ? ("function" == typeof a && a(), console.error("width or height is greater than max texture size")) : (null == r && (r = co.state), of(), df({
                                    data: t,
                                    width: n,
                                    height: o,
                                    flipY: u,
                                    stride: s
                                }), await cf(r, c), "function" == typeof i && i());
                            }(t, e);
                            else {
                                const r = new Blob([
                                    t
                                ]);
                                co.originalSource = r;
                                const n = window.URL.createObjectURL(r);
                                vf(n, e);
                            }
                        }
                    });
                },
                loadPreview: function(t) {
                    co.texture = Vr.Texture.fromImage(t, {
                        magFilter: $l.LINEAR
                    });
                    const e = Math.min(co.canvas.width, co.canvas.height) / Math.min(co.texture.width, co.texture.height);
                    co.texture.width *= e, co.texture.height *= e, oi(co.defaultState), af(), Ca.render();
                },
                exportImage: gf,
                estimateSize: async function(t, e = {}) {
                    let r, n, o, { width: i, height: a, quality: c, resize: u } = e;
                    "none" === u && (u = "stretch", i = co.crop[2] >> 0, a = co.crop[3] >> 0), "jpg" === t ? (r = 10, n = 4) : "heif" === t ? (c = 100, r = 5, n = 4) : "webp" === t ? (r = 5, n = 4) : (r = 30, n = 6);
                    const s = await gf(t, {
                        width: i / n,
                        height: a / n,
                        quality: c,
                        resize: u
                    });
                    if (!s) throw new Error("Estimation image export failed");
                    return o = s.data instanceof Array ? s.data.reduce((t, e)=>t + e.byteLength, 0) : s.data.length, Math.round(o * r);
                },
                getBlob: bf,
                getFile: function(t, e, r) {
                    const n = t instanceof Blob ? t : bf(t, e);
                    return new File([
                        n
                    ], r);
                },
                readAsArrayBuffer: function(t, e) {
                    const r = new FileReader;
                    r.onload = function() {
                        e(this.result);
                    }, r.readAsArrayBuffer(t);
                },
                readPixel: function(t, e, r = "original") {
                    let n = function(t) {
                        switch(t){
                            case "original":
                                return co.texture;
                            case "smooth":
                            case "dehaze":
                                return co.dehazeTexture;
                            case "denoise":
                                return co.denoiseTexture;
                            case "blur":
                                return co.lensBlurTexture;
                            case "retouch":
                                return co.retouchTexture;
                            case "depth":
                                return co.depthTexture || co.dehazeTexture;
                            default:
                                return null;
                        }
                    }(r);
                    if (n) {
                        const r = 1 / n.width, i = 1 / n.height, a = 2 * t - 1, c = 2 * e - 1, u = o.create();
                        return o.scale(u, u, [
                            1 / r,
                            1 / i,
                            1
                        ]), o.translate(u, u, [
                            -a,
                            -c,
                            0
                        ]), $l.loadIdentity(), $l.disable($l.BLEND), fo.distortion_map.set({
                            viewMatrix: u,
                            distortionMatrix: co.distortionMatrix,
                            useTexture: !0
                        }), fo.distortion_map.render(n, co.pixelTexture), Vr.readPixels(0, 0, 1, 1, co.pixelTexture);
                    }
                    return n || (n = $l.canvas), t *= n.width, e *= n.height, Vr.readPixels(t, e, 1, 1, n);
                }
            };
            const { gl: yf } = co, _f = {};
            let wf = Promise.resolve([]);
            function Sf(t, e) {
                let r = Promise.resolve();
                return _f[t.src] && !t.forceUpdateTexture || (_f[t.src] = _f[t.src] || Vr.Texture.create(1, 1), r = new Promise((r)=>{
                    Mf(t).then((n)=>{
                        if (!_f[t.src]) return r();
                        const o = Vr.Texture.fromImage(n);
                        o.swapWith(_f[t.src]), Hi(t), e || (Wi.update(), Ca.render(), Ca.renderCacheTexture()), r(), Vr.Texture.delete(o), URL.revokeObjectURL(n.src);
                    }).catch(r);
                }), t.forceUpdateTexture = !1), t.textureIndex = co.layers.length, co.layers.push({
                    texture: _f[t.src],
                    matrix: null
                }), Hi(t), r;
            }
            function Mf(t) {
                const { src: e } = t;
                return new Promise((r, n)=>{
                    if ("gradient" === t.type) {
                        const e = document.createElement("canvas"), n = e.getContext("2d");
                        e.width = 100, e.height = 1;
                        const o = n.createLinearGradient(0, 0, 100, 0);
                        t.stops.forEach(([t, e])=>{
                            e = "rgb(".concat(255 * e[0] >> 0, ", ").concat(255 * e[1] >> 0, ", ").concat(255 * e[2] >> 0, ")"), o.addColorStop(t, e);
                        }), n.fillStyle = o, n.fillRect(0, 0, 100, 1), r(e);
                    } else {
                        const o = new Image;
                        o.decoding = "async", o.crossOrigin = "anonymous", o.onload = function() {
                            r(o);
                        }, o.onerror = n, "file" === t.type ? co.storage.getUrl(e).then((t)=>{
                            o.src = t;
                        }).catch(n) : o.src = co.getAssetsDir() + e;
                    }
                });
            }
            function Tf(t, e, r = {}) {
                const n = t.local_adjustments || [], o = t.layers || [], i = t.text || [], a = [];
                return o.forEach((t)=>{
                    r[t.src] = !0, a.push(Sf(t, e));
                }), n.forEach((t)=>{
                    t.layer && (r[t.layer.src] = !0, a.push(Sf(t.layer, e))), t.layers && t.layers.forEach((t)=>{
                        r[t.src] = !0, a.push(Sf(t, e));
                    });
                }), i.forEach((t)=>{
                    t.layer && (r[t.layer.src] = !0, a.push(Sf(t.layer, e)));
                }), a;
            }
            function If(t) {
                const { width: e, height: r, format: n, type: o } = t;
                let i = 0;
                switch(n){
                    case 6409:
                    case 6406:
                        i = 1;
                        break;
                    case 6410:
                        i = 2;
                        break;
                    case 6407:
                        i = 3;
                        break;
                    case 6408:
                        i = 4;
                        break;
                    default:
                        console.warn("Unknown texture format: ".concat(n));
                }
                let a = 0;
                switch(o){
                    case 5121:
                        a = 1;
                        break;
                    case 36193:
                        a = 2;
                        break;
                    case 5126:
                        a = 4;
                        break;
                    default:
                        console.warn("Unknown texture type: ".concat(o));
                }
                return e * r * i * a;
            }
            ei("layers", [], (t)=>{
                (t = t || []).forEach(Hi);
            }), Ca.dependencies.add(({ isInitialRender: t })=>{
                co.layers = [];
                const e = {}, r = Tf(co.state, t, e);
                for(const t in _f)e[t] || (Vr.Texture.delete(_f[t]), delete _f[t]);
                return wf = Promise.all(r), Promise.all(r);
            });
            const Df = {
                context: co,
                canvas: co.canvas,
                histogram: qa.canvas,
                histogramDisplayTypes: qa.displayTypes,
                setHistogramDisplay: qa.setDisplay,
                pixelRatio: Wi.pixelRatio,
                utils: c,
                spline: l,
                brush: u,
                text: ls,
                distortion: s,
                face: Wu,
                cursor: f,
                filters: fo,
                on: (t, e)=>(Io[t] || (Io[t] = []), Io[t].push(e), ()=>Eo(t, e)),
                off: Eo,
                setStorage: co.setStorage,
                getAssetsDir: co.getAssetsDir,
                readLUT: _l,
                loadLUT (t, e, r) {
                    _l(t, (t)=>{
                        ii(!0), oc(t, !0), e(t);
                    }, r);
                },
                setDefaultProcess: function(t) {
                    t = Number(t), ei("process", t, pl);
                },
                setPerformance: function(t = Ha, e = Ya) {
                    Ha = t, Ya = e, Wa = 1e3 / Ya, Xa = Wa + 200;
                },
                render (t) {
                    t ? ua(!0) : !1 === t ? (co.previewIntermediate = !0, Wi.update(), Ca.render()) : nc();
                },
                forceUpdate: function() {
                    return nc(), Ca.renderCacheTexture(), Do("history", vi(), li(), "forceUpdate"), Ja();
                },
                updateCachedTexture: Ca.renderCacheTexture,
                set (t, e, r, n) {
                    ea(t, e, function() {
                        nc(!1, !1), "function" == typeof r && r();
                    }, n);
                },
                setCropMode (t) {
                    co.cropMode = !!t, Wi.update(!0), ra({
                        zoom: 0,
                        position: [
                            0,
                            0
                        ]
                    }, null, null, null, !1), Ca.renderCacheTexture();
                },
                getCropMode: ()=>co.cropMode,
                resize: (t, e)=>{
                    t = Math.max(100, t), e = Math.max(100, e);
                    const r = 45 * Math.PI / 180;
                    co.fov = Math.tan(r / 2), co.invFov = -1 / co.fov, co.perspectiveMatrix = o.create(), o.perspective(co.perspectiveMatrix, r, 1, .1, 1e3), o.scale(co.perspectiveMatrix, co.perspectiveMatrix, [
                        1 / (t / 2),
                        1 / (e / 2),
                        1
                    ]), co.canvas.width = t, co.canvas.height = e, Vr.setViewport(0, 0, t, e);
                    const n = ta.drawingBufferWidth, i = ta.drawingBufferHeight;
                    (t > n || e > i) && Vr.setViewport(0, 0, n, i);
                },
                setZoom: Wi.setZoom,
                getZoom: Wi.getZoom,
                getMinZoom: Wi.getMinZoom,
                getPosition: Wi.getOffset,
                getCenter: Wi.getCenter,
                getMargins: Wi.getMargins,
                getCropCoords: (t = co.state.crop, e = Wi.getImageSize(), r = co.zoom)=>{
                    const n = co.offset, o = Wi.getCenter(), i = e[0] * r, a = e[1] * r;
                    return [
                        ((co.canvas.width - i) / 2 + i * t[0] + (o[0] - n[0])) / Wi.pixelRatio,
                        ((co.canvas.height - a) / 2 + a * t[1] + (o[1] + n[1])) / Wi.pixelRatio,
                        i * t[2] / Wi.pixelRatio,
                        a * t[3] / Wi.pixelRatio
                    ];
                },
                getCoordinates: (t = co.screenMatrix)=>{
                    const e = co.canvas.width, r = co.canvas.height, n = a.transformMat4(a.create(), [
                        -1,
                        -1,
                        0
                    ], t), o = a.transformMat4(a.create(), [
                        1,
                        1,
                        0
                    ], t), i = .5 * n[0] + .5, c = .5 * -o[1] + .5, u = .5 * o[0] + .5, s = .5 * -n[1] + .5, l = e * i / Wi.pixelRatio, f = r * c / Wi.pixelRatio;
                    return [
                        l,
                        f,
                        e * u / Wi.pixelRatio - l,
                        r * s / Wi.pixelRatio - f
                    ];
                },
                getMouseCoords: la,
                getCanvasSize: Wi.getCanvasSize,
                getOverlayProps: Wi.getOverlayProps,
                getLayerSize: function(t) {
                    return new Promise((e, r)=>{
                        if (_f[t.src]) {
                            const { width: r, height: n } = _f[t.src];
                            e([
                                r,
                                n
                            ]);
                        } else Mf(t).then((t)=>{
                            const { width: r, height: n } = t;
                            e([
                                r,
                                n
                            ]);
                        }).catch(r);
                    });
                },
                getLayerThumbnail: function(t, e) {
                    return new Promise(async (r)=>{
                        await wf;
                        const n = _f[t.src];
                        if (n) {
                            let { width: t, height: i } = n;
                            const a = rn([
                                t,
                                i
                            ], [
                                e,
                                e
                            ], "fill");
                            t = a[0], i = a[1], Vr.Texture.setSize(co.intermediateTexture, t, i);
                            const c = co.tmpMatrix;
                            o.identity(c), o.scale(c, c, [
                                1,
                                -1,
                                1
                            ]), yf.loadMatrix(c), fo.basic.render(n, co.intermediateTexture);
                            r({
                                data: Vr.Texture.read(co.intermediateTexture),
                                width: t,
                                height: i
                            });
                        } else r(null);
                    });
                },
                unloadLayerSrc: function(t) {
                    _f[t] && (Vr.Texture.delete(_f[t]), delete _f[t], Wi.update(), Ca.render(), Ca.renderCacheTexture());
                },
                async useEffect (t) {
                    await async function(t) {
                        const e = wo[t];
                        e && (await hi("effect"), Mo(t), ni([
                            "effect"
                        ], e.state), Zo.minIndex = li());
                    }(t), nc(), Ca.renderCacheTexture();
                },
                async commitEffect (t) {
                    co.currentEffect && (await async function(t) {
                        const e = co.currentEffect;
                        if (!e) return;
                        const r = {
                            effect: e.name,
                            state: mi().effect
                        };
                        Zo.history = Zo.history.setSize(Zo.minIndex), Zo.prevIndex = Zo.minIndex, Zo.rasterizeIndex = Zo.minIndex, await co.rasterize(), await hi(t, r), Mo(null), Zo.minIndex = 0;
                    }(t), Do("history", vi(), li(), "forceUpdate"));
                },
                async cancelEffect () {
                    co.currentEffect && (await async function() {
                        if (co.currentEffect) return Zo.history = Zo.history.setSize(Zo.minIndex), Mo(null), Zo.minIndex = 0, si(Zo.history.size - 1);
                    }(), nc(), Ca.renderCacheTexture(), Do("history", vi(), li(), "forceUpdate"));
                },
                getEffectState: ()=>co.state.effect,
                getEffectDefaultState: ()=>co.defaultState.effect,
                setEffectState (t, e = !0) {
                    ii(!0), ic([
                        "effect"
                    ], t, e);
                },
                setState (t, e = !0, r) {
                    ii(!0), oc(t, e, void 0, r);
                },
                setStateIn (t, e, r = !0, n = !1) {
                    ii(!0), ic(t, e, r, n);
                },
                saveState: (t, e, r = !0)=>new Promise((n)=>{
                        ((t, e, r)=>{
                            Xo = {
                                message: t || "Update",
                                changed: e,
                                complete: r
                            }, Wo || fi();
                        })(t, e, function() {
                            r && Ca.renderCacheTexture(), Do("history", vi(), li(), "saveState"), n();
                        });
                    }),
                getStateAt: ui,
                getState: mi,
                getStateDiff: (t, e, r)=>{
                    r = r || Object.keys(t);
                    const n = {};
                    return t && r.forEach((r)=>{
                        En(t[r], e[r], !0) || (n[r] = t[r]);
                    }), n;
                },
                getOriginalState: ()=>{
                    const t = Zo.rasterizeIndex, e = Zo.history.get(t);
                    return e ? e.toJS().state : gi(!0);
                },
                getLastState: ()=>{
                    const t = li(), e = Zo.history.get(t);
                    return e ? e.toJS().state : gi(!0);
                },
                getDefaultState: gi,
                getDefaultLocalState: bi,
                getDefaultFaceAdjustments: xi,
                getDefaultFaceFeatures: yi,
                stateDidChange: (t)=>{
                    for (const e of t)if (!En(co.defaultState[e], co.state[e], !0)) return !0;
                    return !1;
                },
                makeCompatible: ci,
                prepareAdjustments: (t, e)=>{
                    var r, n;
                    if (null == t.process && (t.process = co.processVersions.V1), t = ci(t), e) {
                        const r = (e = ci(e)).rotate90 - t.rotate90;
                        t.local_adjustments = ((t, e)=>{
                            t = t.concat();
                            const r = 90 * e;
                            let n;
                            for(let o = 0; o < t.length; o++)switch(n = t[o], n.type){
                                case "gradient":
                                    n = t[o] = Tn(n), n.startPoint = an(n.startPoint, -r), n.endPoint = an(n.endPoint, -r);
                                    break;
                                case "radial":
                                    n = t[o] = Tn(n), n.position = an(n.position, r), n.size = e % 2 ? [
                                        n.size[1],
                                        n.size[0]
                                    ] : n.size;
                            }
                            return t;
                        })(t.local_adjustments, r);
                        let n = e.local_adjustments;
                        t.local_adjustments.forEach((t)=>{
                            n = n.filter((e)=>e.type !== t.type);
                        }), t.local_adjustments = t.local_adjustments.concat(n);
                        const o = t.faces && t.faces[0], i = t.face_features && t.face_features[0];
                        o && e.faces.length && (t.faces = e.faces.map((t)=>Vo(Vo({}, t), {}, {
                                adjustments: Vo(Vo({}, t.adjustments), o.adjustments)
                            }))), i && e.face_features && (t.face_features = e.face_features.map((t)=>Vo(Vo({}, t), i)));
                    }
                    return (null === (r = t.faces) || void 0 === r ? void 0 : r.length) || delete t.faces, (null === (n = t.face_features) || void 0 === n ? void 0 : n.length) || delete t.face_features, t.text.length || delete t.text, t.layers.length || delete t.layers, t.local_adjustments.length || delete t.local_adjustments, delete t.crop, delete t.flip_x, delete t.flip_y, delete t.rotation, delete t.rotate90, delete t.distortion_amount, delete t.distortion_horizontal, delete t.distortion_vertical, delete t.distortion_mesh, delete t.distortion_points, delete t.border_inset, delete t.border_ratio, delete t.border_color, delete t.spots, delete t.grid_size, delete t.effect, delete t.objects, delete t.render_curves, delete t.render_hsl, delete t.render_lut, t.lookup_cube || delete t.lookup_intensity, t;
                },
                rotateCrop: Wi.rotateCrop,
                getCrop: Wi.getCrop,
                getCropScale: Wi.getCropScale,
                interpolateAdjustments: function(t, e, r) {
                    const n = gi(), o = bi();
                    for(const a in t){
                        const c = t[a], u = r[a];
                        switch(a){
                            case "curves_all":
                            case "curves_red":
                            case "curves_green":
                            case "curves_blue":
                                for(let t = 0; t < u.length; t++){
                                    const r = c[t], n = u[t];
                                    let o;
                                    o = 0 === t ? [
                                        0,
                                        0
                                    ] : t === u.length - 1 ? [
                                        255,
                                        255
                                    ] : [
                                        r[0],
                                        r[0]
                                    ], i.lerp(n, o, r, e);
                                }
                                break;
                            case "local_adjustments":
                                for(let t = 0; t < u.length; t++){
                                    const r = c[t], n = u[t];
                                    for(const t in r.adjustments)"number" == typeof r.adjustments[t] ? n.adjustments[t] = sn(e, o[t], r.adjustments[t]) : n.adjustments[t] = r.adjustments[t];
                                    if (r.layers) for(let t = 0; t < r.layers.length; t++)n.layers[t].fill = sn(e, 0, r.layers[t].fill);
                                }
                                break;
                            case "layers":
                                for(let t = 0; t < u.length; t++){
                                    const r = c[t];
                                    u[t].fill = sn(e, 0, r.fill);
                                }
                                break;
                            case "shadows_hue":
                            case "highlights_hue":
                            case "process":
                            case "border_inset":
                            case "border_ratio":
                            case "crop":
                                r[a] = t[a];
                                break;
                            default:
                                "number" == typeof c ? null != n[a] && (r[a] = sn(e, n[a], t[a])) : r[a] = t[a];
                        }
                    }
                    return r;
                },
                async undo () {
                    await si(li() - 1), nc(), Ca.renderCacheTexture(), Do("history", vi(), li(), "undo");
                },
                async redo () {
                    await si(li() + 1), nc(), Ca.renderCacheTexture(), Do("history", vi(), li(), "redo");
                },
                async setIndex (t) {
                    const e = co.zoom === Wi.getMinZoom() ? 0 : co.zoom;
                    await si(t), Wi.setZoom(e), nc(), Ca.renderCacheTexture(), Do("history", vi(), li(), "setIndex");
                },
                async setHistory (t, e) {
                    await di(t, e), nc(), Ca.renderCacheTexture(), Do("history", vi(), li(), "setHistory");
                },
                async clearHistory () {
                    await (Zo.history = Zo.history.setSize(1), si(0)), nc(), Ca.renderCacheTexture(), Do("history", vi(), li(), "setHistory");
                },
                async revertToOriginal (t) {
                    await function(t) {
                        let e = Zo.history.first();
                        const r = bo.fromJS({
                            action: Pn.REVERT,
                            message: t
                        });
                        return e = e.merge(r), Zo.history = Zo.history.push(e), si(Zo.history.size - 1);
                    }(t), nc(), Ca.renderCacheTexture(), Do("history", vi(), li(), "setHistory");
                },
                async rasterizeImage (t) {
                    await hi(t), nc(), Ca.renderCacheTexture(), Do("history", vi(), li(), "forceUpdate");
                },
                async flattenState (t, e) {
                    await function(t, e) {
                        Zo.history.size - 1 > li() && (Zo.history = Zo.history.setSize(li() + 1));
                        const r = bo.Map({
                            state: bo.fromJS(gi()),
                            message: t,
                            changed: e,
                            action: Pn.FLATTEN_STATE,
                            actionOptions: {
                                state: mi(!0)
                            }
                        });
                        return Zo.history = Zo.history.push(r), si(Zo.history.size - 1);
                    }(t, e), nc(), Ca.renderCacheTexture(), Do("history", vi(), li(), "forceUpdate");
                },
                getIndex: li,
                getRasterizedIndex: ()=>Zo.rasterizeIndex,
                getHistory: vi,
                getHistorySaveData: (t, e = 0)=>{
                    const r = [];
                    let n, o;
                    o = t.get(Math.max(e - 1, 0));
                    for(let i = e; i < t.size; i++){
                        if (n = t.get(i), 0 === i) r.push(n.toJS());
                        else {
                            const t = o.get("state"), e = n.get("state"), i = {
                                message: n.get("message"),
                                patch: Uo(t, e)
                            };
                            n.has("changed") && Object.assign(i, {
                                changed: n.get("changed")
                            }), n.has("action") && Object.assign(i, {
                                action: n.get("action"),
                                actionOptions: n.get("actionOptions")
                            }), r.push(i);
                        }
                        o = n;
                    }
                    return r;
                },
                getInfo: Wi.getImageInfo,
                getImageSize: Wi.getImageSize,
                getTextureSize: Wi.getTextureSize,
                isPhotoTransparent: Wi.hasAlpha,
                getMaxTextureSize: xf.getMaxSize,
                isPhotoLoaded: xf.isPhotoLoaded,
                readPixel: xf.readPixel,
                loadPreview: xf.loadPreview,
                import: xf.loadSource,
                export: xf.exportImage,
                estimateSize: xf.estimateSize,
                getBlob: xf.getBlob,
                getFile: xf.getFile,
                readAsArrayBuffer: xf.readAsArrayBuffer,
                unload: xf.unloadImage,
                preloadLayers: function(t) {
                    return Promise.all(Tf(t, !0));
                },
                lookupTableWhitelist: xl,
                makeStateLookupTableCompatible: wl,
                renderLookupTable: Sl,
                exportLookupTable: function(t) {
                    const e = Sl(t), r = Vr.Texture.read(e), { width: n, height: o } = e, i = r.subarray(0, n * o * 3);
                    for(let t, e, n = 0; n < r.byteLength; n++)t = 3 * n, e = 4 * n, i[t] = r[e], i[t + 1] = r[e + 1], i[t + 2] = r[e + 2];
                    return {
                        data: i,
                        width: n,
                        height: o
                    };
                },
                createLookupTableFile: function(t, { title: e = "Created by Polarr" } = {}) {
                    const r = t.height;
                    let n = 'TITLE "'.concat(e, '" \n');
                    n += "LUT_3D_SIZE ".concat(r, " \n");
                    for(let e = 0; e < t.data.length; e += 3){
                        for(let r = 0; r < 3; r++)n += (t.data[e + r] / 255).toFixed(8) + " ";
                        n += "\n";
                    }
                    return new Blob([
                        n
                    ], {
                        type: "text/plain"
                    });
                },
                setWatermark: function(t = {}) {
                    t.image && (co.watermark = Vr.Texture.fromImage(t.image, {
                        premultiplyAlpha: !0
                    }), delete t.image);
                    for(const e in t)co.watermarkOptions[e] = t[e];
                    co.watermarkOptions.position = [
                        un(co.watermarkOptions.position[0], -1, 1),
                        un(co.watermarkOptions.position[1], -1, 1)
                    ];
                },
                getWatermark: function() {
                    return tl(tl({}, co.watermarkOptions), {}, {
                        height: co.watermark.height,
                        width: co.watermark.width
                    });
                },
                getPalette: ()=>co.palette,
                totalTextureFootprintInBytes: function() {
                    let t = 0;
                    for (const e of Object.values(Br.texturePool))t += If(e);
                    return t;
                }
            };
            var Ef = e.default = Df;
        }
    ]);
});


const $2059f153a9793ac5$var$input = document.createElement("input");
$2059f153a9793ac5$var$input.type = "file";
$2059f153a9793ac5$var$input.multiple = false;
$2059f153a9793ac5$var$input.accept = "image/jpeg";
let $2059f153a9793ac5$var$openFiles = Function.prototype;
$2059f153a9793ac5$var$input.onchange = (e)=>{
    const files = e.target.files;
    const file = files && files[0];
    $2059f153a9793ac5$var$openFiles(file || null);
    e.target.value = "";
};
function $2059f153a9793ac5$export$c47c8b06a9966d9f() {
    return new Promise((resolve)=>{
        $2059f153a9793ac5$var$openFiles = resolve;
        $2059f153a9793ac5$var$input.click();
    });
}






window.log = Function.prototype;
window.logTime = Function.prototype;
window.logTimeEnd = Function.prototype;
const $edd7624ed4b79326$var$canvas = document.createElement("canvas");
(0, (/*@__PURE__*/$parcel$interopDefault($422cec71ced0541f$exports))).setStorage($01ade0a89313d083$exports);
async function $edd7624ed4b79326$export$f120b603e65ef974() {
    const file = await (0, $2059f153a9793ac5$export$c47c8b06a9966d9f)();
    if (file) {
        (0, $01249a745811b263$export$ca000e230c0caa3e).photoName = file.name;
        const url = URL.createObjectURL(file);
        return $edd7624ed4b79326$export$fc1584d70e8a9f5c(url);
    }
}
async function $edd7624ed4b79326$export$33e85711129c0564() {
    const output = await $edd7624ed4b79326$export$da8e8db2a2454039((0, $01249a745811b263$export$ca000e230c0caa3e).style.content.state);
    const jpeg = await $edd7624ed4b79326$export$e326c965e996cde5(output);
    (0, $577521a7d2a2a15c$exports.saveAs)(jpeg, (0, $01249a745811b263$export$ca000e230c0caa3e).photoName);
}
function $edd7624ed4b79326$export$fc1584d70e8a9f5c(url) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($422cec71ced0541f$exports))).import(url);
}
async function $edd7624ed4b79326$var$drawWatermark() {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const image = await (0, $cc8fedf75257ac26$export$fe58198efe02b173)(`${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/logo.png`);
    const author = (0, $01249a745811b263$export$ca000e230c0caa3e).style.author && (0, $01249a745811b263$export$ca000e230c0caa3e).style.author.username;
    canvas.width = image.width * 2 + 16;
    canvas.height = image.height;
    ctx.drawImage(image, 0, 0);
    if (author) {
        const textHeight = image.height / 4;
        ctx.fillStyle = "#ffffff";
        ctx.strokeStyle = "#000000";
        ctx.font = `600 ${textHeight}px sans-serif`;
        ctx.textBaseline = "middle";
        const byLineText = (0, $8ae837b596d9b32e$export$2e2bcd8739ae039).style_made_by;
        const authorText = `@${author}`;
        const textOffsetX = image.width + 48;
        const textOffsetY = image.height / 3;
        ctx.shadowColor = "black";
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.shadowBlur = 2;
        ctx.fillText(byLineText, textOffsetX, textOffsetY);
        ctx.fillText(authorText, textOffsetX, textOffsetY * 2);
        ctx.fillRect(image.width + 24, 16, 3, image.height - 32);
    }
    return canvas;
}
async function $edd7624ed4b79326$export$9416765e0d9c038a() {
    const watermark = await $edd7624ed4b79326$var$drawWatermark();
    (0, (/*@__PURE__*/$parcel$interopDefault($422cec71ced0541f$exports))).setWatermark({
        enabled: true,
        image: watermark,
        position: [
            -0.9,
            0.95
        ],
        scale: 0.5
    });
}
async function $edd7624ed4b79326$export$7ceb98555b214486() {
    const { clientWidth: clientWidth, clientHeight: clientHeight } = (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#preview");
    const width = clientWidth * devicePixelRatio;
    const height = clientHeight * devicePixelRatio;
    const before = await $edd7624ed4b79326$export$cebdc09f4d9da75c({}, width, height);
    const after = await $edd7624ed4b79326$export$cebdc09f4d9da75c((0, $01249a745811b263$export$ca000e230c0caa3e).style.content.state, width, height);
    return [
        before,
        after
    ];
}
async function $edd7624ed4b79326$export$cebdc09f4d9da75c(state, width, height) {
    const output = await $edd7624ed4b79326$export$da8e8db2a2454039(state, width, height);
    return await $edd7624ed4b79326$export$e326c965e996cde5(output);
}
function $edd7624ed4b79326$export$da8e8db2a2454039(state, width, height) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($422cec71ced0541f$exports))).export("data", {
        height: height,
        renderDependencies: true,
        resize: "fill",
        settings: state,
        watermark: true,
        width: width
    });
}
function $edd7624ed4b79326$export$e326c965e996cde5(output) {
    const ctx = $edd7624ed4b79326$var$canvas.getContext("2d");
    if (!ctx) return;
    $edd7624ed4b79326$var$canvas.width = output.width;
    $edd7624ed4b79326$var$canvas.height = output.height;
    const buffer = new Uint8ClampedArray(output.data);
    const imageData = new ImageData(buffer, output.width, output.height);
    ctx.putImageData(imageData, 0, 0);
    return $edd7624ed4b79326$var$canvasToBlob($edd7624ed4b79326$var$canvas);
}
function $edd7624ed4b79326$var$canvasToBlob(canvas, type = "image/jpeg", quality = 100) {
    return new Promise((resolve)=>{
        if (HTMLCanvasElement.prototype["toBlob"]) canvas.toBlob(resolve, type, quality);
        else if (Object.prototype.hasOwnProperty.call(canvas, "msToBlob")) {
            // IE/Edge only supports png
            type = "image/png";
            resolve(canvas.msToBlob());
        } else {
            const url = canvas.toDataURL(type, quality);
            const blob = $edd7624ed4b79326$var$dataURLtoBlob(url, {
                type: type || "image/png"
            });
            resolve(blob);
        }
    });
}
function $edd7624ed4b79326$var$dataURLtoBlob(dataURL, options) {
    const byteString = atob(dataURL.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for(let i = 0; i < byteString.length; i++)ia[i] = byteString.charCodeAt(i);
    return new Blob([
        ab
    ], options);
}





function $341880d652235cde$export$2e2bcd8739ae039({ i18n: i18n, pveLink: pveLink, ppeLink: ppeLink }) {
    return `
    <div id="logo-header">
      <img src="${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/logo.png" width="85" height="36" alt="Polarr">
    </div>
    <div class="container">
      <section>
        <div id="preview">
          <div class="overlay">
            <div class="spinner"></div>
          </div>
        </div>
      </section>
      <header>
        <div id="style-description">
          <h1 id="style-name"></h1>
          <a id="style-author" rel="author" href="#"></a>
          <a id="next-link" rel="noopener" href="#"></a>
          <div class="flex-spacer"></div>
          <div id="style-count"></div>
        </div>
        <div id="qr-code">
          <canvas width="1" height="1"></canvas>
        </div>
      </header>
      <div class="buttons">
        <a href="${pveLink}" id="open-pve" class="button primary" target="_blank" rel="noopener">
          <img src="${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/icons/video.svg" alt="24FPS">
          ${i18n.use_on_video}
        </a>
        <a href="${ppeLink}" id="open-ppe" class="button primary" target="_blank" rel="noopener">
          <img src="${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/icons/photo.svg" alt="Polarr">
          ${i18n.use_on_photo}
        </a>
      </div>
    </div>
  `;
}



var $7ae327a5bb1e741d$export$185802fd694ee1f5;
var $7ae327a5bb1e741d$export$f87f6982d1fd4f81;
var $7ae327a5bb1e741d$export$723e4939e5a27c8;
// only svg for now.
var $7ae327a5bb1e741d$export$f84e8e69fd4488a5;
var $bffbf122983861ab$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$bffbf122983861ab$exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $a9b1d176d1375439$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $285dea3ebb3918cb$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $285dea3ebb3918cb$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $285dea3ebb3918cb$export$ed1d66da50968976;
var $285dea3ebb3918cb$export$6733b14783f975c2;
var $285dea3ebb3918cb$export$ce5b1274f8597fa0;
var $285dea3ebb3918cb$export$43dd553ecded716d;
let $285dea3ebb3918cb$var$toSJISFunction;
const $285dea3ebb3918cb$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$285dea3ebb3918cb$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$285dea3ebb3918cb$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $285dea3ebb3918cb$var$CODEWORDS_COUNT[version];
};
$285dea3ebb3918cb$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$285dea3ebb3918cb$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $285dea3ebb3918cb$var$toSJISFunction = f;
};
$285dea3ebb3918cb$export$ce5b1274f8597fa0 = function() {
    return typeof $285dea3ebb3918cb$var$toSJISFunction !== 'undefined';
};
$285dea3ebb3918cb$export$43dd553ecded716d = function toSJIS(kanji) {
    return $285dea3ebb3918cb$var$toSJISFunction(kanji);
};


var $036ea9fe79c8d1d9$export$61196ced6d74a310;
var $036ea9fe79c8d1d9$export$3a1a48c8f6ef640e;
var $036ea9fe79c8d1d9$export$3722cfe417b6ed86;
var $036ea9fe79c8d1d9$export$7f8ddf7c7c20b3cd;
var $036ea9fe79c8d1d9$export$1ea939691cdc45b8;
var $036ea9fe79c8d1d9$export$6788812c4e6611e6;
$036ea9fe79c8d1d9$export$61196ced6d74a310 = {
    bit: 1
};
$036ea9fe79c8d1d9$export$3a1a48c8f6ef640e = {
    bit: 0
};
$036ea9fe79c8d1d9$export$3722cfe417b6ed86 = {
    bit: 3
};
$036ea9fe79c8d1d9$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $036ea9fe79c8d1d9$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $036ea9fe79c8d1d9$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $036ea9fe79c8d1d9$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $036ea9fe79c8d1d9$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $036ea9fe79c8d1d9$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$036ea9fe79c8d1d9$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$036ea9fe79c8d1d9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($036ea9fe79c8d1d9$export$1ea939691cdc45b8(value)) return value;
    try {
        return $036ea9fe79c8d1d9$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $641b0affba6c5a0d$exports = {};
function $641b0affba6c5a0d$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$641b0affba6c5a0d$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$641b0affba6c5a0d$exports = $641b0affba6c5a0d$var$BitBuffer;


var $dd72e0d163398f3c$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $dd72e0d163398f3c$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $dd72e0d163398f3c$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $dd72e0d163398f3c$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $dd72e0d163398f3c$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $dd72e0d163398f3c$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$dd72e0d163398f3c$exports = $dd72e0d163398f3c$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $e06be72cf2c578c5$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $e06be72cf2c578c5$export$c39457c570f2b189;

var $e06be72cf2c578c5$require$getSymbolSize = $285dea3ebb3918cb$export$8d4a06d3facd414b;
$e06be72cf2c578c5$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $e06be72cf2c578c5$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$e06be72cf2c578c5$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $e06be72cf2c578c5$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $4be0c23da357c44c$export$c39457c570f2b189;

var $4be0c23da357c44c$require$getSymbolSize = $285dea3ebb3918cb$export$8d4a06d3facd414b;
const $4be0c23da357c44c$var$FINDER_PATTERN_SIZE = 7;
$4be0c23da357c44c$export$c39457c570f2b189 = function getPositions(version) {
    const size = $4be0c23da357c44c$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $4be0c23da357c44c$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $4be0c23da357c44c$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $54017cd262c2270c$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $54017cd262c2270c$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $54017cd262c2270c$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $54017cd262c2270c$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $54017cd262c2270c$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $54017cd262c2270c$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $54017cd262c2270c$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $54017cd262c2270c$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $54017cd262c2270c$export$fe9625aaceb0e563;
$54017cd262c2270c$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $54017cd262c2270c$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$54017cd262c2270c$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$54017cd262c2270c$export$6788812c4e6611e6 = function from(value) {
    return $54017cd262c2270c$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$54017cd262c2270c$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $54017cd262c2270c$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $54017cd262c2270c$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $54017cd262c2270c$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $54017cd262c2270c$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$54017cd262c2270c$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $54017cd262c2270c$var$PenaltyScores.N2;
};
$54017cd262c2270c$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $54017cd262c2270c$var$PenaltyScores.N3;
};
$54017cd262c2270c$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $54017cd262c2270c$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $54017cd262c2270c$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $54017cd262c2270c$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $54017cd262c2270c$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $54017cd262c2270c$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $54017cd262c2270c$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $54017cd262c2270c$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $54017cd262c2270c$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $54017cd262c2270c$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $54017cd262c2270c$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$54017cd262c2270c$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $54017cd262c2270c$var$getMaskAt(pattern, row, col));
    }
};
$54017cd262c2270c$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($54017cd262c2270c$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $54017cd262c2270c$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $54017cd262c2270c$export$a5fd3a02c14d0b3e(data) + $54017cd262c2270c$export$9a9385107a518e46(data) + $54017cd262c2270c$export$ade754353f0dc75e(data) + $54017cd262c2270c$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $54017cd262c2270c$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $f881e1adeaaf041b$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $f881e1adeaaf041b$export$683d1b3e8a1a8438;

const $f881e1adeaaf041b$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $f881e1adeaaf041b$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$f881e1adeaaf041b$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $036ea9fe79c8d1d9$export$61196ced6d74a310:
            return $f881e1adeaaf041b$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $036ea9fe79c8d1d9$export$3a1a48c8f6ef640e:
            return $f881e1adeaaf041b$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $036ea9fe79c8d1d9$export$3722cfe417b6ed86:
            return $f881e1adeaaf041b$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $036ea9fe79c8d1d9$export$7f8ddf7c7c20b3cd:
            return $f881e1adeaaf041b$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$f881e1adeaaf041b$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $036ea9fe79c8d1d9$export$61196ced6d74a310:
            return $f881e1adeaaf041b$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $036ea9fe79c8d1d9$export$3a1a48c8f6ef640e:
            return $f881e1adeaaf041b$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $036ea9fe79c8d1d9$export$3722cfe417b6ed86:
            return $f881e1adeaaf041b$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $036ea9fe79c8d1d9$export$7f8ddf7c7c20b3cd:
            return $f881e1adeaaf041b$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $47f9ee7fa75aca25$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $fd3746b2a4712ac1$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $fd3746b2a4712ac1$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $fd3746b2a4712ac1$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $11c079a44749cbc4$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $11c079a44749cbc4$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $11c079a44749cbc4$export$6e3a27864ab166fe;
const $11c079a44749cbc4$var$EXP_TABLE = new Uint8Array(512);
const $11c079a44749cbc4$var$LOG_TABLE = new Uint8Array(256);
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $11c079a44749cbc4$var$EXP_TABLE[i] = x;
        $11c079a44749cbc4$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$11c079a44749cbc4$var$EXP_TABLE[i] = $11c079a44749cbc4$var$EXP_TABLE[i - 255];
})();
$11c079a44749cbc4$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $11c079a44749cbc4$var$LOG_TABLE[n];
};
$11c079a44749cbc4$export$b310ec824aaee37f = function exp(n) {
    return $11c079a44749cbc4$var$EXP_TABLE[n];
};
$11c079a44749cbc4$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $11c079a44749cbc4$var$EXP_TABLE[$11c079a44749cbc4$var$LOG_TABLE[x] + $11c079a44749cbc4$var$LOG_TABLE[y]];
};


$fd3746b2a4712ac1$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $11c079a44749cbc4$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$fd3746b2a4712ac1$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $11c079a44749cbc4$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$fd3746b2a4712ac1$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $fd3746b2a4712ac1$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $11c079a44749cbc4$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $47f9ee7fa75aca25$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $47f9ee7fa75aca25$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $fd3746b2a4712ac1$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $47f9ee7fa75aca25$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $fd3746b2a4712ac1$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$47f9ee7fa75aca25$exports = $47f9ee7fa75aca25$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $a866a06bfde5289e$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $a866a06bfde5289e$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $a866a06bfde5289e$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $a866a06bfde5289e$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $bea14cbaaf899e1a$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $bea14cbaaf899e1a$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $bea14cbaaf899e1a$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $bea14cbaaf899e1a$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $bea14cbaaf899e1a$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $bea14cbaaf899e1a$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $bea14cbaaf899e1a$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $bea14cbaaf899e1a$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $bea14cbaaf899e1a$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $bea14cbaaf899e1a$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $82e57e0d94603d09$export$1ea939691cdc45b8;
$82e57e0d94603d09$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $612e8e905b5aa9c4$export$a4d452c2363c8e12;
var $612e8e905b5aa9c4$export$9df7c29d562bab83;
var $612e8e905b5aa9c4$export$8f4bf8f7eb581284;
var $612e8e905b5aa9c4$export$4d318981b5a83836;
var $612e8e905b5aa9c4$export$376a9ed239d6c1c8;
var $612e8e905b5aa9c4$export$175f16aef75a4569;
var $612e8e905b5aa9c4$export$50b7f9bf92c74274;
var $612e8e905b5aa9c4$export$4ba5f52893b4ac97;
const $612e8e905b5aa9c4$var$numeric = '[0-9]+';
const $612e8e905b5aa9c4$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $612e8e905b5aa9c4$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$612e8e905b5aa9c4$var$kanji = $612e8e905b5aa9c4$var$kanji.replace(/u/g, '\\u');
const $612e8e905b5aa9c4$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $612e8e905b5aa9c4$var$kanji + ')(?:.|[\r\n]))+';
$612e8e905b5aa9c4$export$a4d452c2363c8e12 = new RegExp($612e8e905b5aa9c4$var$kanji, 'g');
$612e8e905b5aa9c4$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$612e8e905b5aa9c4$export$8f4bf8f7eb581284 = new RegExp($612e8e905b5aa9c4$var$byte, 'g');
$612e8e905b5aa9c4$export$4d318981b5a83836 = new RegExp($612e8e905b5aa9c4$var$numeric, 'g');
$612e8e905b5aa9c4$export$376a9ed239d6c1c8 = new RegExp($612e8e905b5aa9c4$var$alphanumeric, 'g');
const $612e8e905b5aa9c4$var$TEST_KANJI = new RegExp('^' + $612e8e905b5aa9c4$var$kanji + '$');
const $612e8e905b5aa9c4$var$TEST_NUMERIC = new RegExp('^' + $612e8e905b5aa9c4$var$numeric + '$');
const $612e8e905b5aa9c4$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$612e8e905b5aa9c4$export$175f16aef75a4569 = function testKanji(str) {
    return $612e8e905b5aa9c4$var$TEST_KANJI.test(str);
};
$612e8e905b5aa9c4$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $612e8e905b5aa9c4$var$TEST_NUMERIC.test(str);
};
$612e8e905b5aa9c4$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $612e8e905b5aa9c4$var$TEST_ALPHANUMERIC.test(str);
};


$bea14cbaaf899e1a$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$bea14cbaaf899e1a$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$bea14cbaaf899e1a$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$bea14cbaaf899e1a$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$bea14cbaaf899e1a$export$bb410559a65d3418 = {
    bit: -1
};
$bea14cbaaf899e1a$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$82e57e0d94603d09$export$1ea939691cdc45b8(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$bea14cbaaf899e1a$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($612e8e905b5aa9c4$export$50b7f9bf92c74274(dataStr)) return $bea14cbaaf899e1a$export$4d318981b5a83836;
    else if ($612e8e905b5aa9c4$export$4ba5f52893b4ac97(dataStr)) return $bea14cbaaf899e1a$export$376a9ed239d6c1c8;
    else if ($612e8e905b5aa9c4$export$175f16aef75a4569(dataStr)) return $bea14cbaaf899e1a$export$a4d452c2363c8e12;
    else return $bea14cbaaf899e1a$export$8f4bf8f7eb581284;
};
$bea14cbaaf899e1a$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$bea14cbaaf899e1a$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $bea14cbaaf899e1a$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $bea14cbaaf899e1a$export$4d318981b5a83836;
        case 'alphanumeric':
            return $bea14cbaaf899e1a$export$376a9ed239d6c1c8;
        case 'kanji':
            return $bea14cbaaf899e1a$export$a4d452c2363c8e12;
        case 'byte':
            return $bea14cbaaf899e1a$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$bea14cbaaf899e1a$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($bea14cbaaf899e1a$export$1ea939691cdc45b8(value)) return value;
    try {
        return $bea14cbaaf899e1a$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $a866a06bfde5289e$var$G18 = 7973;
const $a866a06bfde5289e$var$G18_BCH = $285dea3ebb3918cb$export$ed1d66da50968976($a866a06bfde5289e$var$G18);
function $a866a06bfde5289e$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $a866a06bfde5289e$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $a866a06bfde5289e$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $bea14cbaaf899e1a$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $a866a06bfde5289e$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $a866a06bfde5289e$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $a866a06bfde5289e$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $a866a06bfde5289e$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $a866a06bfde5289e$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $bea14cbaaf899e1a$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$a866a06bfde5289e$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($82e57e0d94603d09$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$a866a06bfde5289e$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$82e57e0d94603d09$export$1ea939691cdc45b8(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $bea14cbaaf899e1a$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $285dea3ebb3918cb$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $f881e1adeaaf041b$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $bea14cbaaf899e1a$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $a866a06bfde5289e$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $bea14cbaaf899e1a$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $bea14cbaaf899e1a$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $bea14cbaaf899e1a$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $bea14cbaaf899e1a$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$a866a06bfde5289e$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $036ea9fe79c8d1d9$export$6788812c4e6611e6(errorCorrectionLevel, $036ea9fe79c8d1d9$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $a866a06bfde5289e$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $a866a06bfde5289e$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$a866a06bfde5289e$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$82e57e0d94603d09$export$1ea939691cdc45b8(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($285dea3ebb3918cb$export$ed1d66da50968976(d) - $a866a06bfde5289e$var$G18_BCH >= 0)d ^= $a866a06bfde5289e$var$G18 << $285dea3ebb3918cb$export$ed1d66da50968976(d) - $a866a06bfde5289e$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $e5a0cffbf316cd5e$export$eee5438974ef6f0e;

const $e5a0cffbf316cd5e$var$G15 = 1335;
const $e5a0cffbf316cd5e$var$G15_MASK = 21522;
const $e5a0cffbf316cd5e$var$G15_BCH = $285dea3ebb3918cb$export$ed1d66da50968976($e5a0cffbf316cd5e$var$G15);
$e5a0cffbf316cd5e$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($285dea3ebb3918cb$export$ed1d66da50968976(d) - $e5a0cffbf316cd5e$var$G15_BCH >= 0)d ^= $e5a0cffbf316cd5e$var$G15 << $285dea3ebb3918cb$export$ed1d66da50968976(d) - $e5a0cffbf316cd5e$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $e5a0cffbf316cd5e$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $33bd76ac4782e3fb$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $33bd76ac4782e3fb$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $33bd76ac4782e3fb$export$89ab1afb9839589b;

var $eab809feafad1336$exports = {};

function $eab809feafad1336$var$NumericData(data) {
    this.mode = $bea14cbaaf899e1a$export$4d318981b5a83836;
    this.data = data.toString();
}
$eab809feafad1336$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$eab809feafad1336$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$eab809feafad1336$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $eab809feafad1336$var$NumericData.getBitsLength(this.data.length);
};
$eab809feafad1336$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$eab809feafad1336$exports = $eab809feafad1336$var$NumericData;


var $ebd7d385417f6ff8$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $ebd7d385417f6ff8$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $ebd7d385417f6ff8$var$AlphanumericData(data) {
    this.mode = $bea14cbaaf899e1a$export$376a9ed239d6c1c8;
    this.data = data;
}
$ebd7d385417f6ff8$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$ebd7d385417f6ff8$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$ebd7d385417f6ff8$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $ebd7d385417f6ff8$var$AlphanumericData.getBitsLength(this.data.length);
};
$ebd7d385417f6ff8$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $ebd7d385417f6ff8$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $ebd7d385417f6ff8$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($ebd7d385417f6ff8$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$ebd7d385417f6ff8$exports = $ebd7d385417f6ff8$var$AlphanumericData;


var $9ef799927fc633fa$exports = {};

function $9ef799927fc633fa$var$ByteData(data) {
    this.mode = $bea14cbaaf899e1a$export$8f4bf8f7eb581284;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$9ef799927fc633fa$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$9ef799927fc633fa$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$9ef799927fc633fa$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $9ef799927fc633fa$var$ByteData.getBitsLength(this.data.length);
};
$9ef799927fc633fa$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$9ef799927fc633fa$exports = $9ef799927fc633fa$var$ByteData;


var $b70a8dd92679d897$exports = {};


function $b70a8dd92679d897$var$KanjiData(data) {
    this.mode = $bea14cbaaf899e1a$export$a4d452c2363c8e12;
    this.data = data;
}
$b70a8dd92679d897$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$b70a8dd92679d897$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$b70a8dd92679d897$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $b70a8dd92679d897$var$KanjiData.getBitsLength(this.data.length);
};
$b70a8dd92679d897$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $285dea3ebb3918cb$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$b70a8dd92679d897$exports = $b70a8dd92679d897$var$KanjiData;




var $9af99727d5ac99b0$exports = {};
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $9af99727d5ac99b0$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $9af99727d5ac99b0$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $9af99727d5ac99b0$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $9af99727d5ac99b0$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $9af99727d5ac99b0$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$9af99727d5ac99b0$exports = $9af99727d5ac99b0$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $33bd76ac4782e3fb$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $33bd76ac4782e3fb$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $33bd76ac4782e3fb$var$getSegmentsFromString(dataStr) {
    const numSegs = $33bd76ac4782e3fb$var$getSegments($612e8e905b5aa9c4$export$4d318981b5a83836, $bea14cbaaf899e1a$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $33bd76ac4782e3fb$var$getSegments($612e8e905b5aa9c4$export$376a9ed239d6c1c8, $bea14cbaaf899e1a$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($285dea3ebb3918cb$export$ce5b1274f8597fa0()) {
        byteSegs = $33bd76ac4782e3fb$var$getSegments($612e8e905b5aa9c4$export$8f4bf8f7eb581284, $bea14cbaaf899e1a$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $33bd76ac4782e3fb$var$getSegments($612e8e905b5aa9c4$export$a4d452c2363c8e12, $bea14cbaaf899e1a$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $33bd76ac4782e3fb$var$getSegments($612e8e905b5aa9c4$export$9df7c29d562bab83, $bea14cbaaf899e1a$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $33bd76ac4782e3fb$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $bea14cbaaf899e1a$export$4d318981b5a83836:
            return $eab809feafad1336$exports.getBitsLength(length);
        case $bea14cbaaf899e1a$export$376a9ed239d6c1c8:
            return $ebd7d385417f6ff8$exports.getBitsLength(length);
        case $bea14cbaaf899e1a$export$a4d452c2363c8e12:
            return $b70a8dd92679d897$exports.getBitsLength(length);
        case $bea14cbaaf899e1a$export$8f4bf8f7eb581284:
            return $9ef799927fc633fa$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $33bd76ac4782e3fb$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $33bd76ac4782e3fb$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $bea14cbaaf899e1a$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $bea14cbaaf899e1a$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $bea14cbaaf899e1a$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $bea14cbaaf899e1a$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $bea14cbaaf899e1a$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $bea14cbaaf899e1a$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $bea14cbaaf899e1a$export$8f4bf8f7eb581284,
                        length: $33bd76ac4782e3fb$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $bea14cbaaf899e1a$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $bea14cbaaf899e1a$export$8f4bf8f7eb581284,
                        length: $33bd76ac4782e3fb$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $33bd76ac4782e3fb$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $33bd76ac4782e3fb$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $33bd76ac4782e3fb$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $33bd76ac4782e3fb$var$getSegmentBitsLength(node.length, node.mode) + 4 + $bea14cbaaf899e1a$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $33bd76ac4782e3fb$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $bea14cbaaf899e1a$export$1bd4c93ffb42e55e(data);
    mode = $bea14cbaaf899e1a$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $bea14cbaaf899e1a$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $bea14cbaaf899e1a$export$f84e8e69fd4488a5(mode) + '.\n Suggested mode is: ' + $bea14cbaaf899e1a$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $bea14cbaaf899e1a$export$a4d452c2363c8e12 && !$285dea3ebb3918cb$export$ce5b1274f8597fa0()) mode = $bea14cbaaf899e1a$export$8f4bf8f7eb581284;
    switch(mode){
        case $bea14cbaaf899e1a$export$4d318981b5a83836:
            return new $eab809feafad1336$exports(data);
        case $bea14cbaaf899e1a$export$376a9ed239d6c1c8:
            return new $ebd7d385417f6ff8$exports(data);
        case $bea14cbaaf899e1a$export$a4d452c2363c8e12:
            return new $b70a8dd92679d897$exports(data);
        case $bea14cbaaf899e1a$export$8f4bf8f7eb581284:
            return new $9ef799927fc633fa$exports(data);
    }
}
$33bd76ac4782e3fb$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($33bd76ac4782e3fb$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($33bd76ac4782e3fb$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$33bd76ac4782e3fb$export$3004f64547af360e = function fromString(data, version) {
    const segs = $33bd76ac4782e3fb$var$getSegmentsFromString(data, $285dea3ebb3918cb$export$ce5b1274f8597fa0());
    const nodes = $33bd76ac4782e3fb$var$buildNodes(segs);
    const graph = $33bd76ac4782e3fb$var$buildGraph(nodes, version);
    const path = $9af99727d5ac99b0$exports.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $33bd76ac4782e3fb$export$571d59b505e6bb4e($33bd76ac4782e3fb$var$mergeSegments(optimizedSegs));
};
$33bd76ac4782e3fb$export$89ab1afb9839589b = function rawSplit(data) {
    return $33bd76ac4782e3fb$export$571d59b505e6bb4e($33bd76ac4782e3fb$var$getSegmentsFromString(data, $285dea3ebb3918cb$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $a9b1d176d1375439$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $4be0c23da357c44c$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $a9b1d176d1375439$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $a9b1d176d1375439$var$setupAlignmentPattern(matrix, version) {
    const pos = $e06be72cf2c578c5$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $a9b1d176d1375439$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $a866a06bfde5289e$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $a9b1d176d1375439$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $e5a0cffbf316cd5e$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $a9b1d176d1375439$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $a9b1d176d1375439$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $641b0affba6c5a0d$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $bea14cbaaf899e1a$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $285dea3ebb3918cb$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $f881e1adeaaf041b$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $a9b1d176d1375439$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $a9b1d176d1375439$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $285dea3ebb3918cb$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $f881e1adeaaf041b$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $f881e1adeaaf041b$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $47f9ee7fa75aca25$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $a9b1d176d1375439$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $33bd76ac4782e3fb$export$571d59b505e6bb4e(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $33bd76ac4782e3fb$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $a866a06bfde5289e$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $33bd76ac4782e3fb$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $a866a06bfde5289e$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $a9b1d176d1375439$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $285dea3ebb3918cb$export$8d4a06d3facd414b(version);
    const modules = new $dd72e0d163398f3c$exports(moduleCount);
    // Add function modules
    $a9b1d176d1375439$var$setupFinderPattern(modules, version);
    $a9b1d176d1375439$var$setupTimingPattern(modules);
    $a9b1d176d1375439$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $a9b1d176d1375439$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $a9b1d176d1375439$var$setupVersionInfo(modules, version);
    // Add data codewords
    $a9b1d176d1375439$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $54017cd262c2270c$export$fe9625aaceb0e563(modules, $a9b1d176d1375439$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $54017cd262c2270c$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $a9b1d176d1375439$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$a9b1d176d1375439$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $036ea9fe79c8d1d9$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $036ea9fe79c8d1d9$export$6788812c4e6611e6(options.errorCorrectionLevel, $036ea9fe79c8d1d9$export$3a1a48c8f6ef640e);
        version = $a866a06bfde5289e$export$6788812c4e6611e6(options.version);
        mask = $54017cd262c2270c$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $285dea3ebb3918cb$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $a9b1d176d1375439$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $2461bb234a05b499$export$b3890eb0ae9dca99;
var $2461bb234a05b499$export$c3e5526bbaf70a25;
var $b61a95076a6173fa$export$d2312e68e1f5ad00;
var $b61a95076a6173fa$export$5cdac61cf538712e;
var $b61a95076a6173fa$export$c3a1a1f268a8142b;
var $b61a95076a6173fa$export$83136f57c739c5f3;
function $b61a95076a6173fa$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$b61a95076a6173fa$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $b61a95076a6173fa$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $b61a95076a6173fa$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$b61a95076a6173fa$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$b61a95076a6173fa$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $b61a95076a6173fa$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$b61a95076a6173fa$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $b61a95076a6173fa$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $2461bb234a05b499$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $2461bb234a05b499$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$2461bb234a05b499$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $2461bb234a05b499$var$getCanvasElement();
    opts = $b61a95076a6173fa$export$d2312e68e1f5ad00(opts);
    const size = $b61a95076a6173fa$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $b61a95076a6173fa$export$83136f57c739c5f3(image.data, qrData, opts);
    $2461bb234a05b499$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$2461bb234a05b499$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $2461bb234a05b499$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $5b234fe282003ae2$export$b3890eb0ae9dca99;

function $5b234fe282003ae2$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $5b234fe282003ae2$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $5b234fe282003ae2$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $5b234fe282003ae2$var$svgCmd('M', col + margin, 0.5 + row + margin) : $5b234fe282003ae2$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $5b234fe282003ae2$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$5b234fe282003ae2$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $b61a95076a6173fa$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $5b234fe282003ae2$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $5b234fe282003ae2$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $5b234fe282003ae2$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};


function $7ae327a5bb1e741d$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$bffbf122983861ab$exports()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $a9b1d176d1375439$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $a9b1d176d1375439$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$7ae327a5bb1e741d$export$185802fd694ee1f5 = $a9b1d176d1375439$export$185802fd694ee1f5;
$7ae327a5bb1e741d$export$f87f6982d1fd4f81 = $7ae327a5bb1e741d$var$renderCanvas.bind(null, $2461bb234a05b499$export$b3890eb0ae9dca99);
$7ae327a5bb1e741d$export$723e4939e5a27c8 = $7ae327a5bb1e741d$var$renderCanvas.bind(null, $2461bb234a05b499$export$c3e5526bbaf70a25);
$7ae327a5bb1e741d$export$f84e8e69fd4488a5 = $7ae327a5bb1e741d$var$renderCanvas.bind(null, function(data, _, opts) {
    return $5b234fe282003ae2$export$b3890eb0ae9dca99(data, opts);
});


function $52c5a4e0ad94240a$export$c6af9d9900238077(url) {
    return new Promise((resolve, reject)=>{
        $7ae327a5bb1e741d$export$f87f6982d1fd4f81(url, {
            color: {
                dark: "#000000ff",
                light: "#ffffff00"
            },
            margin: 1,
            scale: 1
        }, (err, canvas)=>{
            if (err) reject(err);
            else resolve(canvas);
        });
    });
}







function $95b47a0bb032e762$export$2e2bcd8739ae039({ header: header, content: content, button: button }) {
    return `
    <div class="dialog-content">
      <h2>${header}</h2>
      ${typeof content === "function" ? content() : content}
      
      <div class="buttons">
        <a href="#" id="dismiss" class="button">${button}</a>
      </div>
    </div>
  `;
}




function $6747c438f4d4b31e$export$2e2bcd8739ae039({ beforeSrc: beforeSrc, afterSrc: afterSrc }) {
    return `
    <div id="split-preview">
      <div class="split" id="split-preview-a">
        <img src="${beforeSrc}" alt="before" draggable="false" width="512" height="512">
      </div>
      <div class="split" id="split-preview-b">
        <img src="${afterSrc}" alt="after" draggable="false" width="512" height="512">       
      </div>
      <img style="position: absolute; right: 8px; bottom: 8px;" src="${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/icons/compare.svg" width="24" height="24" alt="Show before">
    </div>
  `;
}



function $35f0b8f5c99256ed$export$2e2bcd8739ae039(url, { https: https = true } = {}) {
    if (typeof url !== 'string') throw new TypeError(`Expected \`url\` to be of type \`string\`, got \`${typeof url}\``);
    url = url.trim();
    if (/^\.*\/|^(?!localhost)\w+?:/.test(url)) return url;
    return url.replace(/^(?!(?:\w+?:)?\/\/)/, https ? 'https://' : 'http://');
}



const $3a274644ab246ce2$var$prepend = (str)=>(0, $35f0b8f5c99256ed$export$2e2bcd8739ae039)(str || "");
function $3a274644ab246ce2$export$2e2bcd8739ae039({ snapchatHandle: snapchatHandle, instagramHandle: instagramHandle, facebookHandle: facebookHandle, weiboHandle: weiboHandle, tiktokHandle: tiktokHandle, twitterHandle: twitterHandle }) {
    return `
   <div class="social-links">
     <a aria-label="instagram" ${!instagramHandle ? 'aria-disabled="true"' : ""} target="_blank" href="${$3a274644ab246ce2$var$prepend(instagramHandle)}"><img src="${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/icons/instagram.svg" alt="Instagram"></a>
     <a aria-label="facebook" ${!facebookHandle ? 'aria-disabled="true"' : ""} target="_blank" href="${$3a274644ab246ce2$var$prepend(facebookHandle)}"><img src="${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/icons/facebook.svg" alt="Facebook"></a>
     <a aria-label="snapchat" ${!snapchatHandle ? 'aria-disabled="true"' : ""} target="_blank" href="${$3a274644ab246ce2$var$prepend(snapchatHandle)}"><img src="${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/icons/snapchat.svg" alt="Snapchat"></a>
     <a aria-label="tiktok" ${!tiktokHandle ? 'aria-disabled="true"' : ""} target="_blank" href="${$3a274644ab246ce2$var$prepend(tiktokHandle)}"><img src="${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/icons/tiktok.svg" alt="TikTok"></a>
     <a aria-label="weibo" ${!weiboHandle ? 'aria-disabled="true"' : ""} target="_blank" href="${$3a274644ab246ce2$var$prepend(weiboHandle)}"><img src="${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/icons/weibo.svg" alt="Weibo"></a>
     <a aria-label="twitter" ${!twitterHandle ? 'aria-disabled="true"' : ""} target="_blank" href="${$3a274644ab246ce2$var$prepend(twitterHandle)}"><img src="${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/icons/twitter.svg" alt="Twitter"></a>
   </div>
 `;
}


function $6df832aadcab96a2$export$dbcdc99baef99607() {
    const { style: style } = (0, $01249a745811b263$export$ca000e230c0caa3e);
    (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#style-name").innerText = (0, $2bb369240502852a$export$ab8272679afc2108)(style);
    (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#style-count").innerText = style.scanCount && style.scanCount >= 1 ? `${(0, $cc8fedf75257ac26$export$f5dd818bff069720)(style.scanCount)} ${Number(style.scanCount) === 1 ? (0, $8ae837b596d9b32e$export$2e2bcd8739ae039).import : (0, $8ae837b596d9b32e$export$2e2bcd8739ae039).imports}` : "";
    (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#style-author").innerText = style.author && style.author.username ? `@${style.author.username}` : "";
    (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#style-author").onclick = (e)=>{
        e.preventDefault();
        $6df832aadcab96a2$export$8ba9d448877b74f8();
    };
    document.title = `${(0, $2bb369240502852a$export$ab8272679afc2108)(style)} - ${(0, $8ae837b596d9b32e$export$2e2bcd8739ae039).page_title}`;
}
function $6df832aadcab96a2$export$ebedeb3dd4b3f077() {
    const { style: style } = (0, $01249a745811b263$export$ca000e230c0caa3e);
    if (!style.seoMetadata) return;
    if (!style.seoMetadata.nextFilterId) return;
    (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#next-link").href = `/${style.seoMetadata.nextFilterId}`;
}
async function $6df832aadcab96a2$export$ea753dcdf9e3b159(url) {
    try {
        const canvas = await (0, $52c5a4e0ad94240a$export$c6af9d9900238077)(url);
        (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#qr-code").innerHTML = "";
        (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#qr-code").appendChild(canvas);
    } catch  {
    // QR rendering is optional; the rest of the preview remains usable.
    }
}
function $6df832aadcab96a2$export$8ba9d448877b74f8() {
    const { author: author } = (0, $01249a745811b263$export$ca000e230c0caa3e).style;
    $6df832aadcab96a2$var$showDialog({
        content: (0, $3a274644ab246ce2$export$2e2bcd8739ae039)(author),
        header: author.username
    });
    (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)(".social-links").addEventListener("click", (e)=>{
        const label = e.target.ariaLabel;
        if (label) (0, $fbbd0ebd61aeb144$export$f69ffa4b7935a2f0)({
            handle_type: label,
            handle_url: (0, $cc8fedf75257ac26$export$18ae0829741a5008)(e)
        });
    });
}
function $6df832aadcab96a2$var$showDialog(options) {
    const { header: header, content: content, button: button = (0, $8ae837b596d9b32e$export$2e2bcd8739ae039).dismiss } = options;
    const dialogContent = (0, $95b47a0bb032e762$export$2e2bcd8739ae039)({
        button: button,
        content: content,
        header: header
    });
    const dialogEl = document.createElement("div");
    document.body.appendChild(dialogEl);
    document.body.style.overflow = "hidden";
    dialogEl.className = "dialog";
    dialogEl.innerHTML = dialogContent;
    dialogEl.offsetHeight; // force redraw
    dialogEl.classList.add("active");
    dialogEl.onclick = (e)=>{
        if (e.target === dialogEl) // clicked on backdrop
        $6df832aadcab96a2$var$hideDialog(dialogEl);
    };
    dialogEl.querySelector("#dismiss").onclick = (e)=>{
        e.preventDefault();
        $6df832aadcab96a2$var$hideDialog(dialogEl);
    };
}
function $6df832aadcab96a2$var$hideDialog(element) {
    element.classList.remove("active");
    setTimeout(()=>{
        if (element.parentElement !== null) {
            element.parentElement.removeChild(element);
            document.body.style.overflow = "";
        }
    }, 300);
}
function $6df832aadcab96a2$export$3879b24e8245693d(message, error) {
    (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#preview").innerHTML = `
    <div class="overlay">
      ${message}
    </div>
  `;
    if (window.Sentry) Sentry.captureException(new Error(message), error);
// console.error(error)
}
function $6df832aadcab96a2$export$99ffcc3d7055b3fd(before, after) {
    const beforeSrc = typeof before === "string" ? before : URL.createObjectURL(before);
    const afterSrc = typeof after === "string" ? after : URL.createObjectURL(after);
    const previewEl = (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#preview");
    previewEl.innerHTML = (0, $6747c438f4d4b31e$export$2e2bcd8739ae039)({
        afterSrc: afterSrc,
        beforeSrc: beforeSrc
    });
    const previewAfterEl = (0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#split-preview-b");
    const showBefore = (e)=>{
        e.preventDefault();
        previewAfterEl.style.visibility = "hidden";
    };
    const showAfter = ()=>{
        previewAfterEl.style.visibility = "initial";
    };
    previewEl.addEventListener("touchstart", showBefore);
    previewEl.addEventListener("mousedown", showBefore);
    previewEl.addEventListener("touchend", showAfter);
    previewEl.addEventListener("touchcancel", showAfter);
    previewEl.addEventListener("mouseup", showAfter);
}


const $ed9662ad34627551$var$STYLE_ID = (0, $2bb369240502852a$export$fb278f46a98b8805)();
const $ed9662ad34627551$var$STYLE_URL = (0, $2bb369240502852a$export$6671c68d89d2abfe)();
const $ed9662ad34627551$var$styleLoaded = new (0, $cc8fedf75257ac26$export$85f6557964517f1a)();
const $ed9662ad34627551$var$styleContentLoaded = new (0, $cc8fedf75257ac26$export$85f6557964517f1a)();
const $ed9662ad34627551$var$pveLink = (0, $cc8fedf75257ac26$export$79337f56fa1c77aa)(`https://24fps.polarr.co/style/${$ed9662ad34627551$var$STYLE_ID}`, "pve");
const $ed9662ad34627551$var$ppeLink = (0, $cc8fedf75257ac26$export$79337f56fa1c77aa)(`https://www.polarr.com/style/${$ed9662ad34627551$var$STYLE_ID}`, "ppe");
// Render page
(0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#main").innerHTML = (0, $341880d652235cde$export$2e2bcd8739ae039)({
    i18n: $8ae837b596d9b32e$export$2e2bcd8739ae039,
    pveLink: $ed9662ad34627551$var$pveLink,
    ppeLink: $ed9662ad34627551$var$ppeLink
});
// Tracking
(0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#open-ppe").addEventListener("click", (e)=>(0, $fbbd0ebd61aeb144$export$363414f65951ac79)({
        target_url: (0, $cc8fedf75257ac26$export$18ae0829741a5008)(e)
    }));
(0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#open-pve").addEventListener("click", (e)=>(0, $fbbd0ebd61aeb144$export$a9d3477d73f7f5cb)({
        target_url: (0, $cc8fedf75257ac26$export$18ae0829741a5008)(e)
    }));
(0, $cc8fedf75257ac26$export$3d8c2f653ac9d0b9)("#style-author").addEventListener("click", ()=>(0, $fbbd0ebd61aeb144$export$70578a22e13c2fde)());
async function $ed9662ad34627551$var$renderStyle() {
    await $ed9662ad34627551$var$styleLoaded.promise;
    const { previewImageUrl: previewImageUrl, previewAfterImageUrl: previewAfterImageUrl } = (0, $01249a745811b263$export$ca000e230c0caa3e).style;
    // If style already has before/after images, render those instead
    if (previewImageUrl && previewAfterImageUrl) {
        (0, $6df832aadcab96a2$export$99ffcc3d7055b3fd)(previewImageUrl, previewAfterImageUrl);
        return;
    }
    // Start deferred loading of style content
    $ed9662ad34627551$var$loadStyleContent();
    // Wait for preview image to load
    try {
        const previewImage = (0, $01249a745811b263$export$ca000e230c0caa3e).style.previewImageUrl || `${(0, $ca0cdf5e422ff079$export$2e2bcd8739ae039).staticRoot}/sample.jpg`;
        await $edd7624ed4b79326$exports.importPhoto(previewImage);
    } catch (e) {
        (0, $6df832aadcab96a2$export$3879b24e8245693d)((0, $8ae837b596d9b32e$export$2e2bcd8739ae039).error_loading_photo, e);
        return;
    }
    await $ed9662ad34627551$var$styleContentLoaded.promise;
    await $ed9662ad34627551$var$renderStylePreview($edd7624ed4b79326$exports);
}
async function $ed9662ad34627551$var$renderStylePreview(renderer) {
    try {
        const [before, after] = await renderer.renderBeforeAfter();
        (0, $6df832aadcab96a2$export$99ffcc3d7055b3fd)(before, after);
    } catch (e) {
        (0, $6df832aadcab96a2$export$3879b24e8245693d)((0, $8ae837b596d9b32e$export$2e2bcd8739ae039).error_rendering_style, e);
    }
}
async function $ed9662ad34627551$var$loadStyle() {
    // The style ID is grabbed from the page url so it's possible this would not be defined
    if (!$ed9662ad34627551$var$STYLE_ID) {
        const error = new Error("Missing style ID");
        (0, $6df832aadcab96a2$export$3879b24e8245693d)((0, $8ae837b596d9b32e$export$2e2bcd8739ae039).error_loading_style, error);
        return;
    }
    // We can render the QR code before the style is loaded
    (0, $6df832aadcab96a2$export$ea753dcdf9e3b159)($ed9662ad34627551$var$STYLE_URL);
    try {
        (0, $01249a745811b263$export$ca000e230c0caa3e).style = window.styleMetadata ? window.styleMetadata : await (0, $2bb369240502852a$export$9e2aed230c1376b4)($ed9662ad34627551$var$STYLE_ID);
        $ed9662ad34627551$var$styleLoaded.resolve();
    } catch (e) {
        (0, $6df832aadcab96a2$export$3879b24e8245693d)((0, $8ae837b596d9b32e$export$2e2bcd8739ae039).error_loading_style, e);
        $ed9662ad34627551$var$styleLoaded.reject();
        $ed9662ad34627551$var$styleContentLoaded.reject();
        return;
    }
    (0, $6df832aadcab96a2$export$dbcdc99baef99607)();
    $ed9662ad34627551$var$renderStyle();
}
async function $ed9662ad34627551$var$loadStyleContent() {
    try {
        (0, $01249a745811b263$export$ca000e230c0caa3e).style.content = await (0, $2bb369240502852a$export$61fbb928fb77e86a)((0, $01249a745811b263$export$ca000e230c0caa3e).style);
        await (0, $2bb369240502852a$export$958998e5e61e85c0)((0, $01249a745811b263$export$ca000e230c0caa3e).style.content.state);
    } catch (e) {
        (0, $6df832aadcab96a2$export$3879b24e8245693d)((0, $8ae837b596d9b32e$export$2e2bcd8739ae039).error_loading_style, e);
        $ed9662ad34627551$var$styleContentLoaded.reject();
        return;
    }
    $ed9662ad34627551$var$styleContentLoaded.resolve();
}
$ed9662ad34627551$var$loadStyle();



(0, $fbbd0ebd61aeb144$export$92ab14d0aa42e41e)();


//# sourceMappingURL=polarr-style-preview.0f35b829.js.map
